'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
var n$1 = require('react-dom');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () { return e[k]; }
        });
      }
    });
  }
  n["default"] = e;
  return Object.freeze(n);
}

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var React__namespace = /*#__PURE__*/_interopNamespace(React);
var n__default = /*#__PURE__*/_interopDefaultLegacy(n$1);

var propTypes = {exports: {}};

var reactIs = {exports: {}};

var reactIs_production_min = {};

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_production_min;

function requireReactIs_production_min () {
	if (hasRequiredReactIs_production_min) return reactIs_production_min;
	hasRequiredReactIs_production_min = 1;
var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
	Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
	function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}reactIs_production_min.AsyncMode=l;reactIs_production_min.ConcurrentMode=m;reactIs_production_min.ContextConsumer=k;reactIs_production_min.ContextProvider=h;reactIs_production_min.Element=c;reactIs_production_min.ForwardRef=n;reactIs_production_min.Fragment=e;reactIs_production_min.Lazy=t;reactIs_production_min.Memo=r;reactIs_production_min.Portal=d;
	reactIs_production_min.Profiler=g;reactIs_production_min.StrictMode=f;reactIs_production_min.Suspense=p;reactIs_production_min.isAsyncMode=function(a){return A(a)||z(a)===l};reactIs_production_min.isConcurrentMode=A;reactIs_production_min.isContextConsumer=function(a){return z(a)===k};reactIs_production_min.isContextProvider=function(a){return z(a)===h};reactIs_production_min.isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c};reactIs_production_min.isForwardRef=function(a){return z(a)===n};reactIs_production_min.isFragment=function(a){return z(a)===e};reactIs_production_min.isLazy=function(a){return z(a)===t};
	reactIs_production_min.isMemo=function(a){return z(a)===r};reactIs_production_min.isPortal=function(a){return z(a)===d};reactIs_production_min.isProfiler=function(a){return z(a)===g};reactIs_production_min.isStrictMode=function(a){return z(a)===f};reactIs_production_min.isSuspense=function(a){return z(a)===p};
	reactIs_production_min.isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};reactIs_production_min.typeOf=z;
	return reactIs_production_min;
}

var reactIs_development = {};

/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredReactIs_development;

function requireReactIs_development () {
	if (hasRequiredReactIs_development) return reactIs_development;
	hasRequiredReactIs_development = 1;



	if (process.env.NODE_ENV !== "production") {
	  (function() {

	// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
	var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
	var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
	var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
	var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
	var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
	var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
	// (unstable) APIs that have been removed. Can we remove the symbols?

	var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
	var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
	var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
	var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
	var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
	var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
	var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
	var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
	var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
	var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
	var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

	function isValidElementType(type) {
	  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
	  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
	}

	function typeOf(object) {
	  if (typeof object === 'object' && object !== null) {
	    var $$typeof = object.$$typeof;

	    switch ($$typeof) {
	      case REACT_ELEMENT_TYPE:
	        var type = object.type;

	        switch (type) {
	          case REACT_ASYNC_MODE_TYPE:
	          case REACT_CONCURRENT_MODE_TYPE:
	          case REACT_FRAGMENT_TYPE:
	          case REACT_PROFILER_TYPE:
	          case REACT_STRICT_MODE_TYPE:
	          case REACT_SUSPENSE_TYPE:
	            return type;

	          default:
	            var $$typeofType = type && type.$$typeof;

	            switch ($$typeofType) {
	              case REACT_CONTEXT_TYPE:
	              case REACT_FORWARD_REF_TYPE:
	              case REACT_LAZY_TYPE:
	              case REACT_MEMO_TYPE:
	              case REACT_PROVIDER_TYPE:
	                return $$typeofType;

	              default:
	                return $$typeof;
	            }

	        }

	      case REACT_PORTAL_TYPE:
	        return $$typeof;
	    }
	  }

	  return undefined;
	} // AsyncMode is deprecated along with isAsyncMode

	var AsyncMode = REACT_ASYNC_MODE_TYPE;
	var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
	var ContextConsumer = REACT_CONTEXT_TYPE;
	var ContextProvider = REACT_PROVIDER_TYPE;
	var Element = REACT_ELEMENT_TYPE;
	var ForwardRef = REACT_FORWARD_REF_TYPE;
	var Fragment = REACT_FRAGMENT_TYPE;
	var Lazy = REACT_LAZY_TYPE;
	var Memo = REACT_MEMO_TYPE;
	var Portal = REACT_PORTAL_TYPE;
	var Profiler = REACT_PROFILER_TYPE;
	var StrictMode = REACT_STRICT_MODE_TYPE;
	var Suspense = REACT_SUSPENSE_TYPE;
	var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

	function isAsyncMode(object) {
	  {
	    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
	      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

	      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
	    }
	  }

	  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
	}
	function isConcurrentMode(object) {
	  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
	}
	function isContextConsumer(object) {
	  return typeOf(object) === REACT_CONTEXT_TYPE;
	}
	function isContextProvider(object) {
	  return typeOf(object) === REACT_PROVIDER_TYPE;
	}
	function isElement(object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	}
	function isForwardRef(object) {
	  return typeOf(object) === REACT_FORWARD_REF_TYPE;
	}
	function isFragment(object) {
	  return typeOf(object) === REACT_FRAGMENT_TYPE;
	}
	function isLazy(object) {
	  return typeOf(object) === REACT_LAZY_TYPE;
	}
	function isMemo(object) {
	  return typeOf(object) === REACT_MEMO_TYPE;
	}
	function isPortal(object) {
	  return typeOf(object) === REACT_PORTAL_TYPE;
	}
	function isProfiler(object) {
	  return typeOf(object) === REACT_PROFILER_TYPE;
	}
	function isStrictMode(object) {
	  return typeOf(object) === REACT_STRICT_MODE_TYPE;
	}
	function isSuspense(object) {
	  return typeOf(object) === REACT_SUSPENSE_TYPE;
	}

	reactIs_development.AsyncMode = AsyncMode;
	reactIs_development.ConcurrentMode = ConcurrentMode;
	reactIs_development.ContextConsumer = ContextConsumer;
	reactIs_development.ContextProvider = ContextProvider;
	reactIs_development.Element = Element;
	reactIs_development.ForwardRef = ForwardRef;
	reactIs_development.Fragment = Fragment;
	reactIs_development.Lazy = Lazy;
	reactIs_development.Memo = Memo;
	reactIs_development.Portal = Portal;
	reactIs_development.Profiler = Profiler;
	reactIs_development.StrictMode = StrictMode;
	reactIs_development.Suspense = Suspense;
	reactIs_development.isAsyncMode = isAsyncMode;
	reactIs_development.isConcurrentMode = isConcurrentMode;
	reactIs_development.isContextConsumer = isContextConsumer;
	reactIs_development.isContextProvider = isContextProvider;
	reactIs_development.isElement = isElement;
	reactIs_development.isForwardRef = isForwardRef;
	reactIs_development.isFragment = isFragment;
	reactIs_development.isLazy = isLazy;
	reactIs_development.isMemo = isMemo;
	reactIs_development.isPortal = isPortal;
	reactIs_development.isProfiler = isProfiler;
	reactIs_development.isStrictMode = isStrictMode;
	reactIs_development.isSuspense = isSuspense;
	reactIs_development.isValidElementType = isValidElementType;
	reactIs_development.typeOf = typeOf;
	  })();
	}
	return reactIs_development;
}

var hasRequiredReactIs;

function requireReactIs () {
	if (hasRequiredReactIs) return reactIs.exports;
	hasRequiredReactIs = 1;
	(function (module) {

		if (process.env.NODE_ENV === 'production') {
		  module.exports = requireReactIs_production_min();
		} else {
		  module.exports = requireReactIs_development();
		}
} (reactIs));
	return reactIs.exports;
}

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/

var objectAssign;
var hasRequiredObjectAssign;

function requireObjectAssign () {
	if (hasRequiredObjectAssign) return objectAssign;
	hasRequiredObjectAssign = 1;
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;

	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}

		return Object(val);
	}

	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}

			// Detect buggy property enumeration order in older V8 versions.

			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}

			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}

			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}

	objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;

		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);

			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}

			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}

		return to;
	};
	return objectAssign;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret_1;
var hasRequiredReactPropTypesSecret;

function requireReactPropTypesSecret () {
	if (hasRequiredReactPropTypesSecret) return ReactPropTypesSecret_1;
	hasRequiredReactPropTypesSecret = 1;

	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

	ReactPropTypesSecret_1 = ReactPropTypesSecret;
	return ReactPropTypesSecret_1;
}

var has$1;
var hasRequiredHas;

function requireHas () {
	if (hasRequiredHas) return has$1;
	hasRequiredHas = 1;
	has$1 = Function.call.bind(Object.prototype.hasOwnProperty);
	return has$1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var checkPropTypes_1;
var hasRequiredCheckPropTypes;

function requireCheckPropTypes () {
	if (hasRequiredCheckPropTypes) return checkPropTypes_1;
	hasRequiredCheckPropTypes = 1;

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  var ReactPropTypesSecret = requireReactPropTypesSecret();
	  var loggedTypeFailures = {};
	  var has = requireHas();

	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) { /**/ }
	  };
	}

	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (process.env.NODE_ENV !== 'production') {
	    for (var typeSpecName in typeSpecs) {
	      if (has(typeSpecs, typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          if (typeof typeSpecs[typeSpecName] !== 'function') {
	            var err = Error(
	              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
	              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
	              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
	            );
	            err.name = 'Invariant Violation';
	            throw err;
	          }
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        if (error && !(error instanceof Error)) {
	          printWarning(
	            (componentName || 'React class') + ': type specification of ' +
	            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
	            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
	            'You may have forgotten to pass an argument to the type checker ' +
	            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
	            'shape all require an argument).'
	          );
	        }
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;

	          var stack = getStack ? getStack() : '';

	          printWarning(
	            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
	          );
	        }
	      }
	    }
	  }
	}

	/**
	 * Resets warning cache when testing.
	 *
	 * @private
	 */
	checkPropTypes.resetWarningCache = function() {
	  if (process.env.NODE_ENV !== 'production') {
	    loggedTypeFailures = {};
	  }
	};

	checkPropTypes_1 = checkPropTypes;
	return checkPropTypes_1;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithTypeCheckers;
var hasRequiredFactoryWithTypeCheckers;

function requireFactoryWithTypeCheckers () {
	if (hasRequiredFactoryWithTypeCheckers) return factoryWithTypeCheckers;
	hasRequiredFactoryWithTypeCheckers = 1;

	var ReactIs = requireReactIs();
	var assign = requireObjectAssign();

	var ReactPropTypesSecret = requireReactPropTypesSecret();
	var has = requireHas();
	var checkPropTypes = requireCheckPropTypes();

	var printWarning = function() {};

	if (process.env.NODE_ENV !== 'production') {
	  printWarning = function(text) {
	    var message = 'Warning: ' + text;
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	}

	function emptyFunctionThatReturnsNull() {
	  return null;
	}

	factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }

	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */

	  var ANONYMOUS = '<<anonymous>>';

	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bigint: createPrimitiveTypeChecker('bigint'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),

	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    elementType: createElementTypeTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };

	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/

	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message, data) {
	    this.message = message;
	    this.data = data && typeof data === 'object' ? data: {};
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;

	  function createChainableTypeChecker(validate) {
	    if (process.env.NODE_ENV !== 'production') {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;

	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          var err = new Error(
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	          err.name = 'Invariant Violation';
	          throw err;
	        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            printWarning(
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }

	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);

	    return chainedCheckType;
	  }

	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);

	        return new PropTypeError(
	          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
	          {expectedType: expectedType}
	        );
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
	  }

	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createElementTypeTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!ReactIs.isValidElementType(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	      if (process.env.NODE_ENV !== 'production') {
	        if (arguments.length > 1) {
	          printWarning(
	            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
	            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
	          );
	        } else {
	          printWarning('Invalid argument supplied to oneOf, expected an array.');
	        }
	      }
	      return emptyFunctionThatReturnsNull;
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }

	      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
	        var type = getPreciseType(value);
	        if (type === 'symbol') {
	          return String(value);
	        }
	        return value;
	      });
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (has(propValue, key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	      process.env.NODE_ENV !== 'production' ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunctionThatReturnsNull;
	    }

	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        printWarning(
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
	        );
	        return emptyFunctionThatReturnsNull;
	      }
	    }

	    function validate(props, propName, componentName, location, propFullName) {
	      var expectedTypes = [];
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
	        if (checkerResult == null) {
	          return null;
	        }
	        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
	          expectedTypes.push(checkerResult.data.expectedType);
	        }
	      }
	      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function invalidValidatorError(componentName, location, propFullName, key, type) {
	    return new PropTypeError(
	      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
	      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
	    );
	  }

	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }

	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (has(shapeTypes, key) && typeof checker !== 'function') {
	          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
	        }
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }

	    return createChainableTypeChecker(validate);
	  }

	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }

	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }

	        return true;
	      default:
	        return false;
	    }
	  }

	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }

	    // falsy value can't be a Symbol
	    if (!propValue) {
	      return false;
	    }

	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }

	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }

	    return false;
	  }

	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }

	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }

	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }

	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }

	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithTypeCheckers;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var factoryWithThrowingShims;
var hasRequiredFactoryWithThrowingShims;

function requireFactoryWithThrowingShims () {
	if (hasRequiredFactoryWithThrowingShims) return factoryWithThrowingShims;
	hasRequiredFactoryWithThrowingShims = 1;

	var ReactPropTypesSecret = requireReactPropTypesSecret();

	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;

	factoryWithThrowingShims = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  }	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  }	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bigint: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,

	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,

	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };

	  ReactPropTypes.PropTypes = ReactPropTypes;

	  return ReactPropTypes;
	};
	return factoryWithThrowingShims;
}

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = requireReactIs();

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  propTypes.exports = requireFactoryWithTypeCheckers()(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  propTypes.exports = requireFactoryWithThrowingShims()();
}

var e=[],t=[];function n(n,r){if(n&&"undefined"!=typeof document){var a,s=!0===r.prepend?"prepend":"append",d=!0===r.singleTag,i="string"==typeof r.container?document.querySelector(r.container):document.getElementsByTagName("head")[0];if(d){var u=e.indexOf(i);-1===u&&(u=e.push(i)-1,t[u]={}),a=t[u]&&t[u][s]?t[u][s]:t[u][s]=c();}else a=c();65279===n.charCodeAt(0)&&(n=n.substring(1)),a.styleSheet?a.styleSheet.cssText+=n:a.appendChild(document.createTextNode(n));}function c(){var e=document.createElement("style");if(e.setAttribute("type","text/css"),r.attributes)for(var t=Object.keys(r.attributes),n=0;n<t.length;n++)e.setAttribute(t[n],r.attributes[t[n]]);var a="prepend"===s?"afterbegin":"beforeend";return i.insertAdjacentElement(a,e),e}}

var injectCss = function injectCss(css) {
  if (typeof document === "undefined") {
    if (global.ssrStyles) global.ssrStyles.push(css);else global.ssrStyles = [];
  }
  n(css, {});
};

var css$13 = ".Typography_module_XXLText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 48px;\n  line-height: 52px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_XLText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 32px;\n  line-height: 42px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_LText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 24px;\n  line-height: 34px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_MText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 18px;\n  line-height: 28px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_BaseText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_SText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  line-height: 24px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_XSText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  line-height: 22px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_XXSText__ea6d1378 {\n  font-family: \"Karla\", sans-serif;\n  font-size: 10px;\n  line-height: 20px;\n  font-weight: 400;\n  color: #444F6B;\n  margin: 0;\n  padding: 0;\n}\n\n.Typography_module_Bold__ea6d1378 {\n  font-weight: 700;\n}\n\n.Typography_module_SerifFont__ea6d1378 {\n  font-family: \"Vollkorn\", serif;\n}\n\n.Typography_module_Underline__ea6d1378 {\n  text-decoration: underline;\n}\n\n.Typography_module_UpperCase__ea6d1378 {\n  text-transform: uppercase;\n}\n\n.Typography_module_LowerCase__ea6d1378 {\n  text-transform: lowercase;\n}\n\n.Typography_module_Italic__ea6d1378 {\n  font-style: italic;\n}\n\n.Typography_module_LineThrough__ea6d1378 {\n  text-decoration: line-through;\n}\n\n.Typography_module_Shadow__ea6d1378 {\n  text-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n}\n\n.Typography_module_CenterText__ea6d1378 {\n  text-align: center;\n}\n\n.Typography_module_Spacing__ea6d1378 {\n  margin: 0 0 14px 0;\n}";
injectCss(css$13);
var modules_e6a5a2d0 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","XXLText":"Typography_module_XXLText__ea6d1378","XLText":"Typography_module_XLText__ea6d1378","LText":"Typography_module_LText__ea6d1378","MText":"Typography_module_MText__ea6d1378","BaseText":"Typography_module_BaseText__ea6d1378","SText":"Typography_module_SText__ea6d1378","XSText":"Typography_module_XSText__ea6d1378","XXSText":"Typography_module_XXSText__ea6d1378","Bold":"Typography_module_Bold__ea6d1378","SerifFont":"Typography_module_SerifFont__ea6d1378","Underline":"Typography_module_Underline__ea6d1378","UpperCase":"Typography_module_UpperCase__ea6d1378","LowerCase":"Typography_module_LowerCase__ea6d1378","Italic":"Typography_module_Italic__ea6d1378","LineThrough":"Typography_module_LineThrough__ea6d1378","Shadow":"Typography_module_Shadow__ea6d1378","CenterText":"Typography_module_CenterText__ea6d1378","Spacing":"Typography_module_Spacing__ea6d1378"};

var getClassNames$b = function getClassNames(LText, props) {
  return [LText, props.serif ? modules_e6a5a2d0.SerifFont : "",
  //Decoration
  props.bold ? modules_e6a5a2d0.Bold : "", props.underline ? modules_e6a5a2d0.Underline : "", props.uppercase ? modules_e6a5a2d0.UpperCase : "", props.lowercase ? modules_e6a5a2d0.LowerCase : "", props.italic ? modules_e6a5a2d0.Italic : "", props.lineThrough ? modules_e6a5a2d0.LineThrough : "", props.shadow ? modules_e6a5a2d0.Shadow : "", props.centerText ? modules_e6a5a2d0.CenterText : "",
  //fontSize
  props.fontSize == "XXL" ? modules_e6a5a2d0.XXLText : props.fontSize == "XL" ? modules_e6a5a2d0.XLText : props.fontSize == "L" ? modules_e6a5a2d0.LText : props.fontSize == "M" ? modules_e6a5a2d0.MText : props.fontSize == "BASE" ? modules_e6a5a2d0.BaseText : props.fontSize == "S" ? modules_e6a5a2d0.SText : props.fontSize == "XS" ? modules_e6a5a2d0.XSText : props.fontSize == "XXS" ? modules_e6a5a2d0.XXSText : "", props.color || "", props.size || "", props.extraClass || "", props.spacing ? modules_e6a5a2d0.Spacing : null].join(" ");
};
var Header1 = function Header1(props) {
  return /*#__PURE__*/React__default["default"].createElement("h1", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.XXLText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Header2 = function Header2(props) {
  return /*#__PURE__*/React__default["default"].createElement("h2", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.XLText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Header3 = function Header3(props) {
  return /*#__PURE__*/React__default["default"].createElement("h3", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.LText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Header4 = function Header4(props) {
  return /*#__PURE__*/React__default["default"].createElement("h4", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.MText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Paragraph = function Paragraph(props) {
  return /*#__PURE__*/React__default["default"].createElement("p", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.BaseText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Span = function Span(props) {
  return /*#__PURE__*/React__default["default"].createElement("span", {
    id: props.id,
    className: getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.BaseText, props),
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var Label = function Label(props) {
  return /*#__PURE__*/React__default["default"].createElement("label", {
    id: props.id,
    className: [getClassNames$b(props.size || props.fontSize || modules_e6a5a2d0.SText, props), modules_e6a5a2d0.UpperCase].join(" "),
    htmlFor: props.htmlFor,
    style: {
      color: props.color
    },
    itemProp: props.itemprop
  }, props.children);
};
var textPropTypes = {
  extraClass: propTypes.exports.string,
  color: propTypes.exports.string,
  serif: propTypes.exports.bool,
  //Decorations
  bold: propTypes.exports.bool,
  italic: propTypes.exports.bool,
  shadow: propTypes.exports.bool,
  centerText: propTypes.exports.bool,
  underline: propTypes.exports.bool,
  lineThrough: propTypes.exports.bool,
  uppercase: propTypes.exports.bool,
  lowercase: propTypes.exports.bool,
  htmlFor: propTypes.exports.string,
  itemprop: propTypes.exports.string,
  fontSize: propTypes.exports.oneOf(["XXL", "XL", "L", "M", "BASE", "S", "XS", "XXS"]),
  spacing: propTypes.exports.bool
};
Header1.propTypes = textPropTypes;
Header2.propTypes = textPropTypes;
Header3.propTypes = textPropTypes;
Header4.propTypes = textPropTypes;
Paragraph.propTypes = textPropTypes;
Span.propTypes = textPropTypes;
Label.propTypes = textPropTypes;

var css$12 = ".Button_module_Button__742630dd {\n  height: auto;\n  display: inline-block;\n  max-width: 320px;\n  position: relative;\n  border: 2px;\n  border-radius: 48px;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 100%;\n}\n.Button_module_Button__742630dd svg {\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.Button_module_Button__742630dd .Button_module_Loader__742630dd {\n  display: inline-block;\n  width: auto;\n  padding: 12px 0 14px 10px;\n  order: 3;\n}\n.Button_module_Button__742630dd .Button_module_Loader__742630dd svg {\n  margin: 0 !important;\n}\n.Button_module_Button__742630dd > span {\n  height: 48px;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n  padding: 0 24px;\n  color: #fff;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  text-transform: uppercase;\n  border: 0;\n  border-radius: 48px;\n  background: #444F6B;\n  cursor: pointer;\n  box-shadow: none;\n  -moz-transition: all 0.4s ease-in-out;\n  -o-transition: all 0.4s ease-in-out;\n  -webkit-transition: all 0.4s ease-in-out;\n  transition: all 0.4s ease-in-out;\n}\n.Button_module_Button__742630dd > span svg {\n  margin-right: 12px;\n  fill: #ffffff;\n}\n.Button_module_Button__742630dd:focus-visible > span {\n  box-shadow: 0 0 0px 3px #0985BE;\n  color: #ffffff;\n}\n@media only screen and (min-width: 1024px) {\n  .Button_module_Button__742630dd:hover > span {\n    background: #292f40;\n  }\n  .Button_module_Button__742630dd:hover > span svg {\n    fill: #ffffff;\n    transform: scale(1.1);\n  }\n}\n.Button_module_Button__742630dd.Button_module_Small__742630dd .Button_module_Loader__742630dd {\n  padding: 6px 0 0 10px;\n}\n.Button_module_Button__742630dd.Button_module_Small__742630dd > span {\n  height: 34px;\n}\n.Button_module_Button__742630dd.Button_module_Small__742630dd > span svg {\n  margin-right: 10px;\n  fill: #ffffff;\n}\n.Button_module_Button__742630dd.Button_module_Square__742630dd {\n  border-radius: 14px;\n}\n.Button_module_Button__742630dd.Button_module_Square__742630dd > span {\n  border-radius: 14px;\n}\n.Button_module_Button__742630dd.Button_module_Red__742630dd:before {\n  background-color: #ce0c1c;\n}\n.Button_module_Button__742630dd.Button_module_Red__742630dd > span {\n  background: #ce0c1c;\n}\n@media only screen and (min-width: 768px) {\n  .Button_module_Button__742630dd.Button_module_Red__742630dd:hover > span {\n    background: #b90b19;\n  }\n}\n.Button_module_Button__742630dd.Button_module_White__742630dd:before {\n  background-color: #ffffff;\n}\n.Button_module_Button__742630dd.Button_module_White__742630dd > span {\n  background: #ffffff;\n  color: #444F6B;\n}\n.Button_module_Button__742630dd.Button_module_White__742630dd > span > svg {\n  fill: #444F6B;\n}\n@media only screen and (min-width: 768px) {\n  .Button_module_Button__742630dd.Button_module_White__742630dd:hover > span {\n    background: #d4d4d8;\n  }\n}\n.Button_module_Button__742630dd.Button_module_NeuPrimary__742630dd {\n  padding: 20px;\n  margin: 0;\n  box-shadow: inset 1px 20px 16px rgba(91, 95, 105, 0.28);\n}\n.Button_module_Button__742630dd.Button_module_Plain__742630dd {\n  padding: 0 8px;\n}\n.Button_module_Button__742630dd.Button_module_Plain__742630dd > span {\n  color: #444F6B;\n  background: transparent;\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_Plain__742630dd > span svg {\n  fill: #444F6B;\n}\n@media only screen and (min-width: 1024px) {\n  .Button_module_Button__742630dd.Button_module_Plain__742630dd:hover > span {\n    text-decoration: underline;\n  }\n  .Button_module_Button__742630dd.Button_module_Plain__742630dd.Button_module_Icon__742630dd:hover > span {\n    background-color: transparent;\n  }\n}\n.Button_module_Button__742630dd.Button_module_Plain__742630dd.Button_module_White__742630dd > span {\n  color: #ffffff;\n  background: transparent;\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_Plain__742630dd.Button_module_White__742630dd > span svg {\n  fill: #ffffff;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd .Button_module_Loader__742630dd {\n  padding: 12px 0;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd .Button_module_Loader__742630dd svg {\n  position: relative;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd > span {\n  width: 100%;\n  height: 48px;\n  width: 48px;\n  position: relative;\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd > span svg {\n  height: 100%;\n  margin: 0;\n  position: relative;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd > span span.Button_module_Label__742630dd {\n  display: block;\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd.Button_module_Small__742630dd span {\n  width: 34px;\n  height: 34px;\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_Icon__742630dd.Button_module_Small__742630dd span svg {\n  width: calc(100% - 14px);\n  height: 100%;\n  margin-right: 0;\n  margin-left: 0;\n  fill: #ffffff;\n}\n@media only screen and (min-width: 1024px) {\n  .Button_module_Button__742630dd.Button_module_Icon__742630dd:hover svg {\n    transform: scale(1.2);\n  }\n}\n.Button_module_Button__742630dd.Button_module_Open__742630dd button {\n  transform: rotate(180deg);\n}\n.Button_module_Button__742630dd.Button_module_Closed__742630dd button {\n  transform: rotate(0deg);\n}\n.Button_module_Button__742630dd button {\n  transition: all 0.5s;\n}\n.Button_module_Button__742630dd.Button_module_IconRight__742630dd span svg {\n  order: 2;\n  margin-right: 0px;\n  margin-left: 8px;\n}\n.Button_module_Button__742630dd.Button_module_IconLeft__742630dd .Button_module_Loader__742630dd {\n  order: -1 !important;\n  padding: 12px 10px 14px 0;\n}\n.Button_module_Button__742630dd.Button_module_IconLeft__742630dd span svg {\n  order: 0;\n  margin-right: 8px;\n  margin-left: 0;\n}\n.Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd {\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd.Button_module_Small__742630dd {\n  padding: 0;\n}\n.Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd > span {\n  color: #444F6B;\n  background: linear-gradient(90deg, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 0) 50%, rgba(25, 25, 25, 0.1) 100%);\n  box-shadow: 6px 6px 14px rgba(91, 95, 105, 0.2), inset 0 0 0 0px transparent;\n  transition: box-shadow 0.1s linear;\n}\n.Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd > span svg {\n  fill: #444F6B;\n}\n@media only screen and (min-width: 768px) {\n  .Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd:hover > span {\n    box-shadow: 6px 6px 14px rgba(91, 95, 105, 0.2), inset 0 0 0 4px #444F6B;\n  }\n}\n.Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd:focus-visible > span, .Button_module_Button__742630dd.Button_module_NeuSecondary__742630dd:active > span {\n  box-shadow: inset 0 0 0 2px #444f6b, 6px 6px 24px rgba(91, 95, 105, 0.5), -6px -6px 16px rgba(255, 255, 255, 0.7);\n}\n.Button_module_Button__742630dd.Button_module_Outlined__742630dd > span {\n  color: #444F6B;\n  background: #ffffff;\n  box-shadow: 0 0 0 4px #444F6B;\n  transition: all 0.3s;\n}\n.Button_module_Button__742630dd.Button_module_Outlined__742630dd > span svg {\n  fill: #444F6B;\n}\n@media only screen and (min-width: 1024px) {\n  .Button_module_Button__742630dd.Button_module_Outlined__742630dd:hover > span {\n    box-shadow: 0 0 0 6px #313E5C;\n    text-decoration: underline;\n  }\n  .Button_module_Button__742630dd.Button_module_Outlined__742630dd.Button_module_Icon__742630dd:hover > span {\n    background-color: transparent;\n  }\n}\n.Button_module_Button__742630dd.Button_module_Outlined__742630dd:focus-visible > span {\n  box-shadow: 0 0 0px 6px #0985BE;\n}\n.Button_module_Button__742630dd:disabled {\n  cursor: not-allowed;\n}\n.Button_module_Button__742630dd:disabled > span {\n  background: #a5a5a8;\n  cursor: not-allowed;\n}";
injectCss(css$12);
var modules_79b43374 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Button":"Button_module_Button__742630dd","Loader":"Button_module_Loader__742630dd","Small":"Button_module_Small__742630dd","Square":"Button_module_Square__742630dd","Red":"Button_module_Red__742630dd","White":"Button_module_White__742630dd","NeuPrimary":"Button_module_NeuPrimary__742630dd","Plain":"Button_module_Plain__742630dd","Icon":"Button_module_Icon__742630dd","Label":"Button_module_Label__742630dd","Open":"Button_module_Open__742630dd","Closed":"Button_module_Closed__742630dd","IconRight":"Button_module_IconRight__742630dd","IconLeft":"Button_module_IconLeft__742630dd","NeuSecondary":"Button_module_NeuSecondary__742630dd","Outlined":"Button_module_Outlined__742630dd"};

var css$11 = ".Icons_module_Icon__cf56484c {\n  fill: #444f6b;\n  pointer-events: none;\n}\n\n.Icons_module_IconShadow__cf56484c {\n  filter: drop-shadow(0px 2px 4px rgba(25, 25, 25, 0.2));\n}";
injectCss(css$11);
var modules_adb0feaa = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Icon":"Icons_module_Icon__cf56484c","IconShadow":"Icons_module_IconShadow__cf56484c"};

var iconList = {
  "mdsIcon-aaa-logo": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "aaa-logo",
    viewBox: "0 0 98 50"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    className: "st0",
    d: "M13.3,30.1L13.3,30.1c3.9,1.3,7.9,1.9,12,1.9c13.3,0,24.2-6.7,24.2-15c-0.1-2.8-1.3-5.5-3.3-7.5 c10.4-4.3,18-5.5,19.5-2.9c1.8,3.1-5.4,11-17.4,19.1L48,25.8l0.3,0.4l0.1-0.1c15.1-9.8,24-19.4,21.8-23.4c-2-3.5-12.3-1.6-26.2,4.8 h-0.1c-4.4-3.3-11.1-5.4-18.7-5.4C11.9,2.1,1.1,8.8,1.1,17c0,4.9,3.8,9.2,9.6,11.9C4.6,34.6,2,39,3.3,41.4C4,42.5,5.6,43.1,8,43.1 c3.3,0,8-1.1,13.9-3.3l0.2-0.1l-0.3-0.4h-0.1c-7.8,2.7-13.2,3.1-14.4,1C6.2,38.4,8.4,34.7,13.3,30.1z M25.3,30.7 c-2.1,0-4.2-0.2-6.3-0.7l2-7.2h6l2.1,7.6C27.8,30.6,26.6,30.7,25.3,30.7L25.3,30.7z M33.6,29.5l-1.4-4.7l0.5-1.9h6l1,3.6 C37.8,27.7,35.8,28.8,33.6,29.5L33.6,29.5z M45.2,17c0,2.1-0.7,4.1-1.9,5.8L38.7,7C42.7,9.4,45.2,13,45.2,17z M38.2,20.9h-5l2.5-9.1 L38.2,20.9z M35.4,5.3L31.1,21l0,0L25.9,3.4C29.2,3.4,32.4,4.1,35.4,5.3z M26.5,21h-5l2.5-9.1L26.5,21z M24.2,3.4L19.4,21l0,0 L14.8,5.4C17.8,4.2,21,3.5,24.2,3.4z M14.7,21h-5l2.5-9.1L14.7,21z M5.3,17c0-3.9,2.3-7.4,6.1-9.8L7.1,22.8 C5.9,21.1,5.3,19.1,5.3,17z M8.7,24.7l0.5-1.9h6l1.8,6.6l0,0C13.9,28.5,11,26.9,8.7,24.7z"
  })),
  "mdsIcon-logo-aaa-fullcolor": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "logo-aaa-fullcolor",
    viewBox: "0 0 24 15"
  }, /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M23.39,1.21C22.72.07,19.17.79,14.76,2.79c.23.18.44.37.64.56,3.38-1.41,6-1.85,6.54-.94.63,1.08-1.85,3.71-5.79,6.33l0,0c4.84-3.11,8-6.31,7.2-7.58",
    style: {
      fill: "#00529b"
    }
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.49,13.49c-.38-.66.42-1.92,2-3.4h0L4.13,10h0l-.37-.16h0C1.81,11.53.84,13,1.3,13.79c.53.92,2.9.64,6.08-.53l0-.06c-2.55.88-4.41,1.05-4.86.29",
    style: {
      fill: "#00529b"
    }
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M.5,5.86C.5,3.16,4.09,1,8.51,1s8,2.19,8,4.89-3.59,4.89-8,4.89S.5,8.56.5,5.86M5,2.05l1.51,5.1h0L8.16,1.4A9,9,0,0,0,5,2.05m3,2.11-.83,3H8.92Zm2.37,3L11.88,2a9.09,9.09,0,0,0-3.14-.62l1.7,5.76ZM5,7.15l-.83-3-.82,3Zm9.5.6a3.32,3.32,0,0,0,.63-1.89A4,4,0,0,0,13,2.56Zm-1.7-.6-.84-3-.82,3Zm.17.6H11l-.17.63.46,1.54a7.37,7.37,0,0,0,2.05-1ZM5.78,9.92l-.6-2.17h-2L3,8.36A6.74,6.74,0,0,0,5.78,9.93ZM9.09,7.75h-2L6.43,10.1a9.4,9.4,0,0,0,2.08.23,8.87,8.87,0,0,0,1.28-.09ZM3.92,2.64a3.94,3.94,0,0,0-2,3.22A3.28,3.28,0,0,0,2.5,7.73Z",
    style: {
      fill: "#ed1c2e"
    }
  }))),
  "mdsIcon-logo-caa-fullcolor": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "logo-caa-fullcolor",
    viewBox: "0 0 24 15"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M1.08,7.43C1.08,3.56,5.53.5,11.78.5s11.15,3.1,11.14,7c0,4.11-4.88,7.13-11.14,7S1.08,11.29,1.08,7.43",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.68,13.63c0-.15-.09-.21-.27-.21h-.29v.76h.11v-.33h.14l.2.33h.13l-.22-.34A.2.2,0,0,0,20.68,13.63Zm-.45.12v-.24h.16c.08,0,.17,0,.17.12s-.09.12-.19.12ZM11.78.5C5.53.5,1.08,3.56,1.08,7.43s4.58,7,10.7,7.07,11.14-2.93,11.14-7C22.93,3.6,18,.5,11.78.5ZM12,12.89c-5.29,0-9.14-2.62-9.14-5.57S6.71,2,12,2s9.42,2.58,9.28,5.42S17.6,12.92,12,12.89Zm8.37.25a.66.66,0,1,0,.67.65A.66.66,0,0,0,20.37,13.14Zm0,1.21a.53.53,0,0,1-.53-.56.52.52,0,0,1,.53-.54.53.53,0,0,1,.54.54A.54.54,0,0,1,20.37,14.35Z",
    style: {
      fill: "#00529b"
    }
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8,10A2.73,2.73,0,0,0,9.3,8H7.64c0,.25-.19,1-.93,1S5.6,8.31,5.6,6.92C5.6,5.35,6.24,5,6.78,5a.9.9,0,0,1,.9.81H9.35A2.39,2.39,0,0,0,6.81,3.75h0C4,3.77,3.87,6.47,3.87,7c0,.33.08,3.25,2.84,3.25A2.76,2.76,0,0,0,7.81,10C7.87,10,7.94,10,8,10Zm5.84.29,0-.09L14.6,8,12.75,2.59H10.89L8.84,7.81h.61v.07a2.87,2.87,0,0,1-1.54,2.29l-.47,1.22,1.71.67L10,9.43h3.27l0,.05.78,2.77,1.82-.47-.52-1.52ZM10.59,8l0-.09,1.13-3.23.06.21L12.87,8ZM17.84,4H16.09L14.76,8l-.08.22L14,10.12h1.66L16,9.06h2l.29,1.1h1.48ZM16.3,7.68l.65-2,.65,2Z",
    style: {
      fill: "#ed1b2d"
    }
  })),
  "mdsIcon-inspected-clean": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "inspected-clean",
    viewBox: "0 0 402 46"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    className: "st0",
    style: {
      fill: "#004876"
    },
    d: "M124.5,29.1c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0.1-0.3,0.2-0.5,0.3 c-0.3,0.3-0.7,0.6-1.1,0.8c-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.8,0.2-1.3,0.3c-0.5,0.1-1,0.1-1.5,0.1c-0.9,0-1.8-0.2-2.7-0.6 c-0.8-0.4-1.6-1-2.2-1.7c-0.7-0.8-1.2-1.8-1.5-2.8c-0.4-1.2-0.6-2.5-0.5-3.8c0-1.3,0.1-2.5,0.5-3.7c0.3-1,0.8-1.9,1.4-2.8 c0.6-0.7,1.3-1.3,2.1-1.7c0.9-0.4,1.8-0.6,2.7-0.6c0.5,0,1.1,0,1.6,0.1c0.4,0.1,0.8,0.2,1.2,0.4c0.3,0.1,0.6,0.3,0.9,0.5l0.7,0.5 c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.3,0,0.5-0.1,0.7-0.2c0.2-0.1,0.3-0.3,0.5-0.5l2-2.9c-0.5-0.5-1.1-1-1.7-1.5 c-0.6-0.5-1.3-0.8-2-1.1c-0.8-0.3-1.6-0.6-2.4-0.8c-0.9-0.2-1.8-0.3-2.8-0.3c-1.8,0-3.6,0.3-5.2,1c-1.5,0.7-2.9,1.7-4.1,2.9 c-1.2,1.3-2.1,2.8-2.6,4.5c-0.6,1.8-1,3.7-0.9,5.7c0,1.9,0.3,3.8,0.9,5.6c0.5,1.6,1.4,3.2,2.5,4.5c1.1,1.3,2.4,2.3,4,3 c1.7,0.7,3.5,1.1,5.3,1.1c1.9,0.1,3.8-0.3,5.6-1.1c1.6-0.7,2.9-1.9,3.9-3.3l-2.4-2.7C124.8,29.3,124.6,29.2,124.5,29.1z M85.8,36.3 h16.7v-5H91.9v-6.6h8.2V20h-8.2v-6.4h10.6v-5H85.8V36.3z M128.8,13.6h7.3v22.5h6V13.6h7.3V8.6h-20.6V13.6z M1,36.2h6.1V8.6H1V36.2z M79.3,11.2c-0.9-0.9-2.1-1.5-3.3-1.9c-1.5-0.5-3.1-0.7-4.7-0.7h-9.2v27.6h6V27h3.1c1.6,0,3.2-0.2,4.7-0.7c1.2-0.4,2.3-1,3.3-1.9 c0.9-0.8,1.5-1.8,1.9-3c0.4-1.2,0.6-2.5,0.6-3.8c0-1.2-0.2-2.4-0.6-3.6C80.8,12.9,80.2,12,79.3,11.2z M74.8,20.9 c-0.9,0.9-2.1,1.3-3.4,1.2l-3.1,0v-8.7h3.1c0.7,0,1.3,0.1,2,0.3c0.5,0.2,1,0.4,1.4,0.8c0.4,0.4,0.6,0.8,0.8,1.3 c0.2,0.6,0.3,1.1,0.3,1.7C75.8,18.8,75.5,20,74.8,20.9z M30.4,23.2c0,0.4,0,0.9,0,1.4c0,0.5,0.1,1,0.1,1.5L18.2,9.6 c-0.1-0.2-0.3-0.3-0.4-0.5c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.7,0H13v27.6h5.3V21.4 c0-0.4,0-0.8,0-1.3c0-0.5-0.1-0.9-0.1-1.4l12.2,16.5c0.2,0.3,0.6,0.6,0.9,0.8c0.4,0.2,0.8,0.3,1.2,0.2h3.1V8.6h-5.3V23.2z M55.9,22.3c-0.5-0.6-1.2-1-1.9-1.4c-0.7-0.4-1.4-0.7-2.1-1c-0.7-0.3-1.4-0.5-2.1-0.7c-0.6-0.2-1.3-0.4-1.9-0.7 c-0.5-0.2-0.9-0.6-1.3-1c-0.3-0.4-0.5-0.9-0.5-1.4c0-0.8,0.3-1.5,0.8-2.1c0.7-0.6,1.6-0.8,2.5-0.8c0.6,0,1.2,0.1,1.7,0.3 c0.5,0.2,0.9,0.4,1.4,0.6l1.1,0.6c0.3,0.2,0.6,0.3,0.9,0.3c0.3,0,0.5-0.1,0.8-0.2c0.2-0.2,0.4-0.4,0.6-0.7l1.5-3 c-0.5-0.5-1-0.9-1.6-1.2c-0.6-0.4-1.2-0.7-1.9-0.9c-0.7-0.3-1.4-0.5-2.1-0.6c-0.8-0.1-1.5-0.2-2.3-0.2c-1.3,0-2.6,0.2-3.8,0.7 c-1,0.4-2,1.1-2.8,1.8c-1.5,1.5-2.3,3.5-2.3,5.7c0,1.1,0.1,2.2,0.5,3.3c0.3,0.8,0.7,1.6,1.3,2.2c0.5,0.6,1.2,1.1,1.8,1.4 c0.7,0.4,1.4,0.7,2.1,0.9c0.7,0.2,1.4,0.5,2.1,0.7c0.6,0.2,1.2,0.4,1.8,0.7c0.5,0.2,1,0.6,1.3,1c0.3,0.4,0.5,1,0.5,1.6 c0.1,0.9-0.2,1.8-0.9,2.5c-0.7,0.6-1.6,0.8-2.5,0.8c-0.7,0-1.5-0.1-2.1-0.3c-0.5-0.2-1.1-0.5-1.6-0.8c-0.4-0.3-0.9-0.6-1.2-0.8 c-0.3-0.2-0.7-0.3-1.1-0.4c-0.3,0-0.5,0.1-0.8,0.2c-0.2,0.1-0.4,0.3-0.6,0.5l-1.8,3c0.5,0.6,1.1,1.1,1.8,1.5 c0.7,0.5,1.5,0.8,2.2,1.2c0.8,0.3,1.6,0.6,2.4,0.7c0.8,0.2,1.6,0.3,2.4,0.3c1.3,0,2.7-0.2,3.9-0.7c1.1-0.4,2.1-1.1,2.9-2 c0.8-0.8,1.4-1.8,1.8-2.9c0.4-1.1,0.6-2.3,0.6-3.6c0-1-0.1-2-0.5-2.9C57,23.6,56.5,22.9,55.9,22.3z M153.4,36.3h16.7v-5h-10.6v-6.6 h8.2V20h-8.2v-6.4h10.6v-5h-16.7V36.3z M375.5,23.2c0,0.4,0,0.9,0,1.4s0.1,1,0.1,1.5L363.3,9.6c-0.1-0.2-0.3-0.3-0.4-0.5 c-0.1-0.1-0.3-0.2-0.4-0.3c-0.2-0.1-0.3-0.1-0.5-0.1c-0.2,0-0.4,0-0.7,0h-3.2v27.6h5.3V21.4c0-0.4,0-0.8,0-1.3 c0-0.5-0.1-0.9-0.1-1.4l12.2,16.5c0.2,0.3,0.6,0.6,0.9,0.8c0.4,0.2,0.8,0.3,1.2,0.2h3.1V8.6h-5.3V23.2z M392.5,14c0,0-0.1,0-0.1,0.1 c-0.1,0.1-0.2,0.2-0.3,0.3c-0.1,0.1-0.2,0.1-0.3,0.2s-0.3,0.1-0.4,0.1c-0.1,0-0.3,0-0.5,0c-0.3,0-0.6-0.1-0.8-0.2 c-0.3-0.1-0.5-0.3-0.7-0.5c-0.2-0.2-0.3-0.5-0.4-0.9c-0.1-0.3-0.2-0.7-0.2-1.2c0-0.4,0.1-0.8,0.2-1.1c0.1-0.3,0.3-0.6,0.4-0.9 c0.2-0.2,0.4-0.4,0.7-0.5c0.3-0.1,0.6-0.2,0.9-0.2c0.3,0,0.5,0,0.7,0.1c0.2,0.1,0.3,0.1,0.4,0.2c0.1,0.1,0.2,0.1,0.3,0.2 c0.1,0.1,0.1,0.1,0.2,0.1c0,0,0.1,0,0.1,0c0,0,0,0,0.1-0.1l0.3-0.4c-0.3-0.3-0.5-0.5-0.9-0.6c-0.3-0.2-0.7-0.2-1.2-0.2 c-0.4,0-0.9,0.1-1.2,0.3c-0.4,0.2-0.7,0.4-0.9,0.7c-0.3,0.3-0.5,0.7-0.6,1.1c-0.1,0.4-0.2,0.9-0.2,1.4c0,0.5,0.1,1,0.2,1.4 c0.1,0.4,0.3,0.8,0.6,1.1c0.3,0.3,0.6,0.6,0.9,0.7c0.4,0.2,0.8,0.3,1.2,0.3c0.5,0,0.9-0.1,1.3-0.3c0.4-0.2,0.7-0.4,0.9-0.8l-0.3-0.4 C392.6,14,392.6,14,392.5,14z M194.6,12.5c-1.2-1.3-2.7-2.2-4.3-2.9c-1.7-0.7-3.6-1.1-5.5-1.1h-10v27.6h10c1.9,0,3.8-0.3,5.5-1 c1.6-0.7,3-1.6,4.2-2.9c1.2-1.3,2.1-2.8,2.7-4.4c0.7-1.8,1-3.6,1-5.5c0-1.9-0.3-3.8-1-5.5C196.7,15.2,195.8,13.7,194.6,12.5z M191.6,26.1c-0.3,1-0.8,2-1.4,2.8c-0.6,0.8-1.4,1.4-2.3,1.8c-1,0.4-2,0.6-3.1,0.6h-4V13.5h4c1.1,0,2.1,0.2,3.1,0.6 c0.9,0.4,1.7,1,2.3,1.8c0.7,0.8,1.1,1.8,1.4,2.8c0.3,1.2,0.5,2.4,0.5,3.7C192.1,23.6,191.9,24.9,191.6,26.1z M339,8.6l-10,27.6h4.7 c0.5,0,0.9-0.1,1.3-0.4c0.3-0.3,0.6-0.6,0.7-1l1.5-4.8h9.8l1.5,4.8c0.2,0.4,0.4,0.7,0.7,1c0.4,0.3,0.8,0.4,1.3,0.4h4.7l-10-27.6H339 z M338.6,25.7l2.4-7.5c0.2-0.5,0.4-1,0.6-1.7c0.2-0.7,0.4-1.4,0.6-2.1c0.2,0.8,0.4,1.5,0.6,2.1s0.4,1.2,0.6,1.7l2.4,7.6L338.6,25.7z M400.4,8.5c-0.1,0-0.1,0-0.2,0c0,0-0.1,0.1-0.1,0.1l-2.1,4.2c0,0.1-0.1,0.2-0.1,0.2c0,0.1-0.1,0.2-0.1,0.3c0-0.1-0.1-0.2-0.1-0.3 c0-0.1-0.1-0.2-0.1-0.2l-2.1-4.3c0-0.1-0.1-0.1-0.1-0.1c0,0-0.1,0-0.2,0h-0.6v6.9h0.7v-5.1c0-0.1,0-0.3,0-0.5l2.1,4.3 c0.1,0.1,0.2,0.2,0.3,0.2h0.1c0.1,0,0.2-0.1,0.3-0.2l2.1-4.3c0,0.1,0,0.2,0,0.2s0,0.1,0,0.2v5.1h0.7V8.5H400.4z M284.7,29.1 c-0.1-0.1-0.3-0.1-0.4-0.1c-0.2,0-0.3,0.1-0.5,0.1c-0.2,0.1-0.3,0.2-0.5,0.3c-0.3,0.3-0.7,0.6-1.1,0.8c-0.3,0.2-0.7,0.4-1.1,0.5 c-0.4,0.1-0.8,0.2-1.3,0.3c-0.5,0.1-1,0.1-1.5,0.1c-1.9,0-3.7-0.8-4.8-2.3c-0.7-0.8-1.2-1.8-1.5-2.8c-0.4-1.2-0.6-2.5-0.5-3.8 c0-1.3,0.1-2.5,0.5-3.7c0.3-1,0.8-1.9,1.4-2.8c0.6-0.7,1.3-1.3,2.1-1.7c0.9-0.4,1.8-0.6,2.7-0.6c0.5,0,1.1,0,1.6,0.1 c0.4,0.1,0.8,0.2,1.2,0.4c0.3,0.1,0.6,0.3,0.9,0.5l0.7,0.5c0.2,0.1,0.4,0.3,0.6,0.4c0.2,0.1,0.4,0.1,0.6,0.1c0.3,0,0.5-0.1,0.7-0.2 c0.2-0.1,0.3-0.3,0.5-0.5l2-2.9c-0.5-0.5-1.1-1-1.7-1.5c-0.6-0.5-1.3-0.9-2.1-1.2c-0.8-0.3-1.6-0.6-2.4-0.8 c-0.9-0.2-1.8-0.3-2.8-0.3c-1.8,0-3.6,0.3-5.2,1c-1.5,0.7-2.9,1.7-4.1,2.9c-1.2,1.3-2.1,2.8-2.6,4.5c-0.6,1.8-1,3.7-0.9,5.7 c0,1.9,0.3,3.8,0.9,5.6c0.5,1.6,1.4,3.2,2.5,4.5c1.1,1.3,2.4,2.3,3.9,3c1.7,0.7,3.5,1.1,5.3,1.1c1.9,0,3.8-0.3,5.6-1.1 c1.6-0.7,2.9-1.9,3.9-3.3l-2.4-2.7C285,29.3,284.8,29.2,284.7,29.1z M310.6,36.3h16.7v-5h-10.6v-6.6h8.2V20h-8.2v-6.4h10.6v-5h-16.7 V36.3z M297.1,8.6h-6v27.6h15.6v-5.1h-9.6V8.6z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    className: "st1",
    style: {
      fill: "#97B5DF"
    },
    d: "M225.2,20.3l-5.2,5.3l10.4,10.6l19.3-19.6l-5.2-5.3l-14.1,14.3L225.2,20.3z M248.8,23.2 c-0.2-0.7-0.4-1.3-0.6-1.9l-3.5,3.5c0.2,0.7,0.3,1.5,0.3,2.2c0,7.5-6,13.6-13.4,13.6c-7.4,0-13.4-6.1-13.4-13.6 c0-0.9,0.2-1.9,0.4-2.8c1-4.2,4.3-8.8,9.8-14c0.5-0.5,1.1-1,1.6-1.5l0.5-0.4h0l1.1-0.9c0.3,0.3,0.7,0.6,1,0.8c0,0,0.1,0,0.1,0.1 c0.5,0.4,0.9,0.8,1.3,1.2l0.7,0.7c1.4,1.3,2.6,2.5,3.7,3.7l3.2-3.2c-1.8-2.1-3.8-4.1-5.8-6l-0.9-0.8c-0.6-0.5-1.1-1.1-1.7-1.6 c0,0-0.1-0.1-0.2-0.1L231.6,1c-0.5,0.4-0.9,0.8-1.4,1.2h-0.1l-0.6,0.6c-0.7,0.7-1.4,1.3-2.1,1.9c-7.3,6.9-11.6,13-13,18.5 c-0.3,1.2-0.5,2.5-0.5,3.7c0,11,8.4,18,17.7,18c9.6,0.2,17.6-7.7,17.7-17.4c0-0.2,0-0.4,0-0.6C249.3,25.7,249.1,24.4,248.8,23.2z"
  })),
  "mdsIcon-diamond-approved": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-approved",
    viewBox: "0 0 140 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Short",
    "data-name": "AAA Diamond Approved Short"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Approved_Short_Wrapper",
    "data-name": "AAA Diamond Approved Short Wrapper",
    width: "140",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Short_Banner",
    "data-name": "AAA Diamond Approved Short Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "140 15.21 41.76 15.21 45.25 20.3 29.1 39.32 140 39.32 140 15.21",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Short_Facets",
    "data-name": "AAA Diamond Approved Short Facets"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#a5c5ed"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Short_Text",
    "data-name": "AAA Diamond Approved Short Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m60.96,32.49h-1.5c-.17,0-.31-.04-.42-.13-.11-.08-.19-.19-.23-.31l-.78-2.13h-4.33l-.78,2.13c-.04.11-.11.21-.23.3-.11.09-.25.14-.42.14h-1.51l4.11-10.46h1.99l4.11,10.46Zm-6.77-3.95h3.33l-1.27-3.48c-.06-.16-.12-.34-.19-.55-.07-.21-.14-.44-.21-.68-.07.25-.13.48-.2.69s-.13.4-.19.56l-1.27,3.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m64.77,28.81v3.68h-1.95v-10.46h3.41c.7,0,1.3.08,1.82.25.51.16.93.39,1.27.69.33.3.58.65.74,1.06.16.41.24.86.24,1.35s-.08.97-.25,1.39-.42.78-.76,1.09c-.34.3-.76.54-1.27.71-.51.17-1.1.25-1.78.25h-1.46Zm0-1.52h1.46c.36,0,.67-.05.93-.13.27-.09.48-.22.66-.38s.3-.37.39-.61c.09-.24.13-.5.13-.8,0-.28-.04-.53-.13-.76-.09-.23-.22-.42-.39-.58-.17-.16-.39-.28-.66-.37s-.58-.13-.93-.13h-1.46v3.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m74.54,28.81v3.68h-1.95v-10.46h3.41c.7,0,1.3.08,1.82.25.51.16.93.39,1.27.69.33.3.58.65.74,1.06.16.41.24.86.24,1.35s-.08.97-.25,1.39-.42.78-.76,1.09c-.34.3-.76.54-1.27.71-.51.17-1.1.25-1.78.25h-1.46Zm0-1.52h1.46c.36,0,.67-.05.93-.13.27-.09.48-.22.66-.38s.3-.37.39-.61c.09-.24.13-.5.13-.8,0-.28-.04-.53-.13-.76-.09-.23-.22-.42-.39-.58-.17-.16-.39-.28-.66-.37s-.58-.13-.93-.13h-1.46v3.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m84.3,28.41v4.09h-1.95v-10.46h3.19c.71,0,1.32.07,1.83.22.51.15.93.35,1.25.62.33.27.56.58.72.95.15.37.23.78.23,1.22,0,.35-.05.68-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.86h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.22-.27-.27s-.24-.08-.44-.08h-.83Zm0-1.4h1.21c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.46.13-.73,0-.53-.17-.94-.52-1.22s-.88-.43-1.6-.43h-1.24v3.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m102.17,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.62,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.17-.4c-.65-.27-1.21-.64-1.68-1.12s-.83-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.48.38-2.13c.26-.65.62-1.22,1.08-1.7s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.17-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.26.65.38,1.36.38,2.13Zm-2,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.05.73s-.51.7-.66,1.16c-.15.46-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.05.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m103,22.04h1.57c.17,0,.31.04.41.12s.19.19.24.32l2.46,6.38c.08.21.16.43.23.68.07.25.15.51.21.78.11-.56.25-1.04.41-1.47l2.45-6.38c.04-.11.12-.21.23-.3.11-.09.25-.14.41-.14h1.57l-4.22,10.46h-1.76l-4.22-10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m121.61,22.04v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m133.31,27.26c0,.77-.13,1.47-.38,2.11-.26.64-.61,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.46h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-three": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-three",
    viewBox: "0 0 107 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short",
    "data-name": "AAA Diamond Three Short"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Three_Short_Wrapper",
    "data-name": "AAA Diamond Three Short Wrapper",
    width: "107",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Banner",
    "data-name": "AAA Diamond Three Short Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "107 15.27 41.76 15.27 45.25 20.36 29.1 39.38 107 39.38 107 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "34.56 9.64 7.22 9.64 0 20.23 20.89 45 41.79 20.23 34.56 9.64 34.56 9.64",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Ticks",
    "data-name": "AAA Diamond Three Short Ticks"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m37.08,6.84c-.16,0-.33-.04-.47-.14-.42-.26-.54-.82-.28-1.23l1.39-2.22c.26-.42.82-.54,1.23-.28.2.13.34.33.4.56.05.23.01.47-.12.67l-1.39,2.22c-.17.27-.46.42-.76.42Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m42.18,10.97h-.02l-2.62-.05c-.24,0-.46-.1-.63-.27s-.26-.4-.25-.64.1-.46.27-.63c.17-.17.39-.25.64-.25l2.62.05c.24,0,.46.1.63.27s.26.4.25.64c0,.24-.1.46-.27.63-.17.16-.39.25-.62.25Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m30.29,2.88c.07-.23.23-.41.44-.52.21-.11.46-.13.68-.05s.41.23.52.44l1.19,2.33c.11.23.13.46.05.68-.07.23-.23.41-.44.52s-.46.13-.68.05-.41-.23-.52-.44l-1.19-2.33v-.02c-.11-.21-.13-.45-.05-.67Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Facets",
    "data-name": "AAA Diamond Three Short Facets"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Facets_White",
    "data-name": "AAA Diamond Three Short Facets White"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.41 22.78 12.41 27.68 18.59 31.9 12.41",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.41 19.01 12.41 14.11 18.59 9.89 12.41",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.94 15.94 19.18 20.89 19.19 25.84 19.18 20.89 12.94",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Facets_Blue",
    "data-name": "AAA Diamond Three Short Facets Blue"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.27 37.54 21.04 28.38 21.04 23.01 38.27",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.27 4.24 21.04 13.41 21.04 18.77 38.27",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.18 33.62 13.08 29.45 19.18 37.78 19.18",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.18 8.17 13.08 12.33 19.18 4 19.18",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 21.04 15.28 21.04 20.89 39.93 26.51 21.04 20.89 21.04",
    fill: "#a5c5ed"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Text",
    "data-name": "AAA Diamond Three Short Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m57.8,22.1v1.6h-3.15v8.86h-1.95v-8.86h-3.16v-1.6h8.25Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m68.58,32.56h-1.96v-4.57h-4.9v4.57h-1.96v-10.46h1.96v4.5h4.9v-4.5h1.96v10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m73.43,28.47v4.09h-1.95v-10.46h3.19c.71,0,1.32.07,1.83.22.51.15.93.35,1.25.62.33.27.56.58.72.95.15.37.23.78.23,1.22,0,.35-.05.68-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.86h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.22-.27-.27s-.24-.08-.44-.08h-.83Zm0-1.4h1.21c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.46.13-.73,0-.53-.17-.94-.52-1.22s-.88-.43-1.6-.43h-1.24v3.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m88.21,22.1v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m97.21,22.1v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-four": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-four",
    viewBox: "0 0 107 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short",
    "data-name": "AAA Diamond Four Short"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "107",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Banner",
    "data-name": "AAA Diamond Four Short Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "107 15.27 41.76 15.27 45.25 20.36 29.1 39.38 107 39.38 107 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Ticks",
    "data-name": "AAA Diamond Four Ticks"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.9,4.57c-.09,0-.18-.01-.27-.04-.23-.07-.41-.23-.52-.44h0s-1.19-2.31-1.19-2.31c-.22-.43-.05-.97.38-1.2.43-.23.97-.05,1.2.38l1.19,2.31c.11.21.13.45.06.68-.07.23-.23.41-.44.52-.13.07-.27.1-.4.1Zm.02-.9h0Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m25.84,4.51c-.15,0-.31-.04-.44-.12-.2-.12-.35-.31-.41-.54-.06-.23-.03-.47.09-.67l1.3-2.25c.12-.21.31-.35.54-.41.23-.06.47-.03.67.09.2.12.35.31.41.54.06.23.03.47-.09.67l-1.3,2.25c-.12.21-.31.35-.54.41-.08.02-.15.03-.23.03Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m6.18,7.25c-.2,0-.4-.07-.57-.21l-1.99-1.67c-.38-.31-.42-.87-.11-1.25.31-.38.87-.42,1.25-.11l1.99,1.67c.38.31.42.87.11,1.25-.18.21-.43.32-.68.32Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m35.6,7.25c-.25,0-.51-.11-.68-.32-.31-.38-.27-.94.11-1.25l1.99-1.67c.18-.15.41-.23.65-.2.24.02.45.13.6.31.31.38.27.94-.11,1.25l-1.99,1.67c-.17.14-.37.21-.57.21Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Facets",
    "data-name": "AAA Diamond Four Short Facets"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Facets_White",
    "data-name": "AAA Diamond Four Short Facets White"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Facets_Blue",
    "data-name": "AAA Diamond Four Short Facets Blue"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#a5c5ed"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Text",
    "data-name": "AAA Diamond Four Short Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m60.77,22.04v1.55h-4.64v3.1h3.91v1.56h-3.91v4.26h-1.96v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m73.05,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.62,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.17-.4c-.65-.27-1.21-.64-1.68-1.12s-.83-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.48.38-2.13c.26-.65.62-1.22,1.08-1.7s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.17-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.26.65.38,1.36.38,2.13Zm-2,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.05.73s-.51.7-.66,1.16c-.15.46-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.05.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m79.51,30.92c.38,0,.71-.06,1.01-.19s.55-.3.75-.53.36-.5.47-.82c.11-.32.16-.69.16-1.09v-6.26h1.95v6.26c0,.62-.1,1.2-.3,1.72-.2.53-.49.98-.86,1.37-.38.38-.83.68-1.37.9-.54.21-1.14.32-1.81.32s-1.27-.11-1.81-.32c-.54-.22-.99-.51-1.36-.9-.37-.38-.66-.84-.86-1.37-.2-.53-.3-1.1-.3-1.72v-6.26h1.95v6.26c0,.4.05.76.16,1.08.11.32.26.6.47.83s.45.4.75.53c.3.13.63.19,1.01.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m88.57,28.41v4.09h-1.95v-10.46h3.19c.71,0,1.32.07,1.83.22.51.15.93.35,1.25.62.33.27.56.58.72.95.15.37.23.78.23,1.22,0,.35-.05.68-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.86h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.22-.27-.27s-.24-.08-.44-.08h-.83Zm0-1.4h1.21c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.46.13-.73,0-.53-.17-.94-.52-1.22s-.88-.43-1.6-.43h-1.24v3.47Z",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-five": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-five",
    viewBox: "0 0 107 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Short",
    "data-name": "AAA Diamond Five Short"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Five_Short_Wrapper",
    "data-name": "AAA Diamond Five Short Wrapper",
    width: "107",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Short_Banner",
    "data-name": "AAA Diamond Five Short Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "107 15.27 41.76 15.27 45.25 20.36 29.1 39.38 107 39.38 107 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m20.89,4.67c-.51,0-.92-.42-.92-.92V.92c0-.51.42-.92.93-.92s.92.41.92.92v2.82c0,.51-.42.92-.93.92Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m4.95,7.98c-.22,0-.42-.08-.59-.22l-2.16-1.81c-.19-.16-.31-.38-.33-.63-.02-.25.06-.49.22-.67.16-.19.38-.3.63-.33.24-.02.48.05.67.21l2.16,1.81c.39.33.44.91.11,1.3-.16.19-.38.31-.63.33-.03,0-.06,0-.08,0Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m36.84,7.98c-.26,0-.53-.11-.71-.33-.33-.39-.28-.98.11-1.3l2.16-1.81c.19-.16.42-.23.68-.21.25.02.47.14.63.33.33.39.28.97-.11,1.3l-2.16,1.81c-.17.14-.38.22-.59.22Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m12.39,5.42c-.1,0-.19-.01-.28-.04-.23-.08-.43-.24-.54-.46l-1.29-2.51c-.11-.22-.13-.47-.06-.7.08-.24.24-.43.46-.54.45-.23,1.01-.05,1.24.4l1.29,2.51c.11.22.13.47.06.7-.08.24-.24.43-.46.54-.13.07-.28.1-.42.1Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m29.28,5.39c-.16,0-.32-.04-.46-.12h0c-.21-.12-.37-.32-.43-.56-.06-.24-.03-.49.09-.7l1.41-2.44c.25-.44.82-.59,1.26-.34.21.12.37.32.43.56s.03.49-.09.7l-1.41,2.44c-.12.21-.32.37-.56.43-.08.02-.16.03-.24.03Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Short_Copy",
    "data-name": "AAA Diamond Five Short Copy"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m64.96,22.04v1.55h-4.64v3.1h3.91v1.56h-3.91v4.26h-1.96v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m69.4,32.49h-1.95v-10.46h1.95v10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m71.45,22.04h1.57c.17,0,.31.04.41.12s.19.19.24.32l2.46,6.38c.08.21.16.43.23.68.07.25.15.51.21.78.11-.56.25-1.04.41-1.47l2.45-6.38c.04-.11.12-.21.23-.3.11-.09.25-.14.41-.14h1.57l-4.22,10.46h-1.76l-4.22-10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m90.07,22.04v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Short_Facets",
    "data-name": "AAA Diamond Five Short Facets"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-approved-long": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-approved-long",
    viewBox: "0 0 197 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Long",
    "data-name": "AAA Diamond Approved Long"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Approved_Long_Wrapper",
    "data-name": "AAA Diamond Approved Long Wrapper",
    width: "197",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Long_Banner",
    "data-name": "AAA Diamond Approved Long Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "197 15.21 41.76 15.21 45.25 20.3 29.1 39.32 197 39.32 197 15.21",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Long_Text",
    "data-name": "AAA Diamond Approved Long Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m87.98,32.49h-1.5c-.17,0-.31-.04-.42-.13-.11-.08-.19-.19-.23-.31l-.78-2.13h-4.33l-.78,2.13c-.04.11-.11.21-.23.3-.11.09-.25.14-.42.14h-1.51l4.11-10.46h1.99l4.11,10.46Zm-6.77-3.95h3.33l-1.27-3.48c-.06-.16-.12-.34-.19-.55-.07-.21-.14-.44-.21-.68-.07.25-.13.48-.2.69s-.13.4-.19.56l-1.27,3.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m91.8,28.81v3.68h-1.95v-10.46h3.41c.7,0,1.3.08,1.82.25.51.16.93.39,1.27.69.33.3.58.65.74,1.06.16.41.24.86.24,1.35s-.08.97-.25,1.39-.42.78-.76,1.09c-.34.3-.76.54-1.27.71-.51.17-1.1.25-1.78.25h-1.46Zm0-1.52h1.46c.36,0,.67-.05.93-.13.27-.09.48-.22.66-.38s.3-.37.39-.61c.09-.24.13-.5.13-.8,0-.28-.04-.53-.13-.76-.09-.23-.22-.42-.39-.58-.17-.16-.39-.28-.66-.37s-.58-.13-.93-.13h-1.46v3.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m101.56,28.81v3.68h-1.95v-10.46h3.41c.7,0,1.3.08,1.82.25.51.16.93.39,1.27.69.33.3.58.65.74,1.06.16.41.24.86.24,1.35s-.08.97-.25,1.39-.42.78-.76,1.09c-.34.3-.76.54-1.27.71-.51.17-1.1.25-1.78.25h-1.46Zm0-1.52h1.46c.36,0,.67-.05.93-.13.27-.09.48-.22.66-.38s.3-.37.39-.61c.09-.24.13-.5.13-.8,0-.28-.04-.53-.13-.76-.09-.23-.22-.42-.39-.58-.17-.16-.39-.28-.66-.37s-.58-.13-.93-.13h-1.46v3.75Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m111.32,28.41v4.09h-1.95v-10.46h3.19c.71,0,1.32.07,1.83.22.51.15.93.35,1.25.62.33.27.56.58.72.95.15.37.23.78.23,1.22,0,.35-.05.68-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.86h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.22-.27-.27s-.24-.08-.44-.08h-.83Zm0-1.4h1.21c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.46.13-.73,0-.53-.17-.94-.52-1.22s-.88-.43-1.6-.43h-1.24v3.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m129.19,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.62,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.17-.4c-.65-.27-1.21-.64-1.68-1.12s-.83-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.48.38-2.13c.26-.65.62-1.22,1.08-1.7s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.17-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.26.65.38,1.36.38,2.13Zm-2,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.05.73s-.51.7-.66,1.16c-.15.46-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.05.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m130.02,22.04h1.57c.17,0,.31.04.41.12s.19.19.24.32l2.46,6.38c.08.21.16.43.23.68.07.25.15.51.21.78.11-.56.25-1.04.41-1.47l2.45-6.38c.04-.11.12-.21.23-.3.11-.09.25-.14.41-.14h1.57l-4.22,10.46h-1.76l-4.22-10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m148.63,22.04v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m160.33,27.26c0,.77-.13,1.47-.38,2.11-.26.64-.61,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.46h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Approved_Long_Facets",
    "data-name": "AAA Diamond Approved Long Facets"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#a5c5ed"
  })))),
  "mdsIcon-diamond-three-long": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-three-long",
    viewBox: "0 0 197 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Long",
    "data-name": "AAA Diamond Three Long"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Three_Long_Wrapper",
    "data-name": "AAA Diamond Three Long Wrapper",
    width: "197",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Long_Banner",
    "data-name": "AAA Diamond Three Long Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "AAA_Diamond_Three_Long_BannerBG",
    "data-name": "AAA Diamond Three Long BannerBG",
    points: "197 15.27 41.76 15.27 45.25 20.36 29.1 39.38 197 39.38 197 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "AAA_Diamond_Three_Long_DiamondBG",
    "data-name": "AAA Diamond Three Long DiamondBG",
    points: "34.56 9.64 7.22 9.64 0 20.23 20.89 45 41.79 20.23 34.56 9.64 34.56 9.64",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Ticks",
    "data-name": "AAA Diamond Three Short Ticks"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m37.08,6.84c-.16,0-.33-.04-.47-.14-.42-.26-.54-.82-.28-1.23l1.39-2.22c.26-.42.82-.54,1.23-.28.2.13.34.33.4.56.05.23.01.47-.12.67l-1.39,2.22c-.17.27-.46.42-.76.42Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m42.18,10.97h-.02l-2.62-.05c-.24,0-.46-.1-.63-.27s-.26-.4-.25-.64.1-.46.27-.63c.17-.17.39-.25.64-.25l2.62.05c.24,0,.46.1.63.27s.26.4.25.64c0,.24-.1.46-.27.63-.17.16-.39.25-.62.25Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m30.29,2.88c.07-.23.23-.41.44-.52.21-.11.46-.13.68-.05s.41.23.52.44l1.19,2.33c.11.23.13.46.05.68-.07.23-.23.41-.44.52s-.46.13-.68.05-.41-.23-.52-.44l-1.19-2.33v-.02c-.11-.21-.13-.45-.05-.67Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Long_Facets",
    "data-name": "AAA Diamond Three Long Facets"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Facets_White",
    "data-name": "AAA Diamond Three Short Facets White"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.41 22.78 12.41 27.68 18.59 31.9 12.41",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.41 19.01 12.41 14.11 18.59 9.89 12.41",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.94 15.94 19.18 20.89 19.19 25.84 19.18 20.89 12.94",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Short_Facets_Blue",
    "data-name": "AAA Diamond Three Short Facets Blue"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.27 37.54 21.04 28.38 21.04 23.01 38.27",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.27 4.24 21.04 13.41 21.04 18.77 38.27",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.18 33.62 13.08 29.45 19.18 37.78 19.18",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.18 8.17 13.08 12.33 19.18 4 19.18",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 21.04 15.28 21.04 20.89 39.93 26.51 21.04 20.89 21.04",
    fill: "#a5c5ed"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Three_Long_Text",
    "data-name": "AAA Diamond Three Long Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m62.86,22.1v1.6h-3.15v8.87h-1.95v-8.87h-3.17v-1.6h8.26Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m73.66,32.57h-1.96v-4.58h-4.91v4.58h-1.96v-10.47h1.96v4.5h4.91v-4.5h1.96v10.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m78.51,28.48v4.09h-1.95v-10.47h3.19c.71,0,1.33.07,1.84.22.51.15.93.35,1.25.62.33.27.57.58.72.95.15.37.23.78.23,1.22,0,.35-.05.69-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.87h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.22-.27-.27s-.25-.08-.44-.08h-.83Zm0-1.4h1.22c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.47.13-.73,0-.53-.18-.94-.52-1.22s-.88-.43-1.6-.43h-1.25v3.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m93.32,22.1v1.55h-4.64v2.9h3.66v1.5h-3.66v2.96h4.64v1.56h-6.61v-10.47h6.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m102.34,22.1v1.55h-4.64v2.9h3.66v1.5h-3.66v2.96h4.64v1.56h-6.61v-10.47h6.61Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m117.57,27.33c0,.77-.13,1.47-.38,2.12-.26.64-.62,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.17.38h-4v-10.47h4c.79,0,1.51.13,2.17.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.66c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.55-.15-.46-.37-.84-.66-1.16-.29-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.04v7.37h2.04c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m122.01,32.57h-1.96v-10.47h1.96v10.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m134.3,32.57h-1.51c-.17,0-.31-.04-.42-.13-.11-.08-.19-.19-.23-.31l-.78-2.14h-4.34l-.78,2.14c-.04.11-.11.21-.23.3-.11.09-.25.14-.42.14h-1.51l4.11-10.47h1.99l4.11,10.47Zm-6.78-3.95h3.34l-1.27-3.48c-.06-.16-.12-.34-.19-.55-.07-.21-.14-.44-.21-.69-.07.25-.13.48-.2.69s-.13.4-.19.56l-1.27,3.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m141.59,28.71c.07.17.14.33.21.5.07-.17.14-.35.21-.51.07-.17.15-.33.23-.49l3.1-5.8c.04-.07.08-.13.12-.17.04-.04.09-.07.14-.09.05-.02.11-.03.17-.04.06,0,.14,0,.22,0h1.47v10.47h-1.72v-6.77c0-.13,0-.26.01-.41,0-.15.02-.3.03-.46l-3.16,5.94c-.07.14-.17.24-.28.31-.12.08-.25.11-.41.11h-.27c-.15,0-.29-.04-.41-.11-.12-.07-.21-.18-.28-.31l-3.21-5.96c.02.16.03.32.04.47,0,.15.01.29.01.42v6.77h-1.72v-10.47h1.47c.09,0,.16,0,.22,0,.06,0,.12.02.17.04.05.02.1.05.14.09.04.04.08.1.12.17l3.13,5.82c.08.16.16.32.23.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m160.34,27.33c0,.77-.13,1.48-.38,2.13-.26.66-.62,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.17.4s-1.52-.14-2.17-.4c-.65-.27-1.21-.64-1.68-1.12s-.83-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.48.38-2.13c.26-.65.62-1.22,1.08-1.7s1.03-.85,1.68-1.12c.65-.27,1.38-.4,2.17-.4s1.51.14,2.17.41c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.26.66.38,1.37.38,2.13Zm-2,0c0-.57-.08-1.09-.23-1.55-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.05.73s-.51.71-.66,1.16c-.15.46-.23.97-.23,1.55s.08,1.09.23,1.55c.15.46.37.84.66,1.16.29.32.64.56,1.05.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.29-.32.5-.7.66-1.16.15-.46.23-.97.23-1.55Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m163.84,22.11c.06,0,.11.02.16.04.05.02.09.05.13.09s.09.1.14.16l5.5,7c-.02-.17-.03-.33-.04-.5,0-.16-.01-.31-.01-.45v-6.37h1.72v10.47h-1.01c-.15,0-.28-.02-.38-.07s-.2-.14-.3-.26l-5.48-6.97c.01.15.03.31.03.46s.01.29.01.42v6.43h-1.72v-10.47h1.02c.09,0,.16,0,.22.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m183.58,27.33c0,.77-.13,1.47-.38,2.12-.26.64-.62,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.17.38h-4v-10.47h4c.79,0,1.51.13,2.17.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.66c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.55-.15-.46-.37-.84-.66-1.16-.29-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.04v7.37h2.04c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.55Z",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-four-long": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-four-long",
    viewBox: "0 0 197 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Long",
    "data-name": "AAA Diamond Four Long"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Four_Long_Wwapper",
    "data-name": "AAA Diamond Four Long Wwapper",
    width: "197",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Long_Banner",
    "data-name": "AAA Diamond Four Long Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "AAA_Diamond_Four_Long_BannerBG",
    "data-name": "AAA Diamond Four Long BannerBG",
    points: "197 15.27 41.76 15.27 45.25 20.36 29.1 39.38 197 39.38 197 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "AAA_Diamond_Four_Long_DiamondBG",
    "data-name": "AAA Diamond Four Long DiamondBG",
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Ticks",
    "data-name": "AAA Diamond Four Ticks"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.9,4.57c-.09,0-.18-.01-.27-.04-.23-.07-.41-.23-.52-.44h0s-1.19-2.31-1.19-2.31c-.22-.43-.05-.97.38-1.2.43-.23.97-.05,1.2.38l1.19,2.31c.11.21.13.45.06.68-.07.23-.23.41-.44.52-.13.07-.27.1-.4.1Zm.02-.9h0Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m25.84,4.51c-.15,0-.31-.04-.44-.12-.2-.12-.35-.31-.41-.54-.06-.23-.03-.47.09-.67l1.3-2.25c.12-.21.31-.35.54-.41.23-.06.47-.03.67.09.2.12.35.31.41.54.06.23.03.47-.09.67l-1.3,2.25c-.12.21-.31.35-.54.41-.08.02-.15.03-.23.03Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m6.18,7.25c-.2,0-.4-.07-.57-.21l-1.99-1.67c-.38-.31-.42-.87-.11-1.25.31-.38.87-.42,1.25-.11l1.99,1.67c.38.31.42.87.11,1.25-.18.21-.43.32-.68.32Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m35.6,7.25c-.25,0-.51-.11-.68-.32-.31-.38-.27-.94.11-1.25l1.99-1.67c.18-.15.41-.23.65-.2.24.02.45.13.6.31.31.38.27.94-.11,1.25l-1.99,1.67c-.17.14-.37.21-.57.21Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Long_Facets",
    "data-name": "AAA Diamond Four Long Facets"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Facets_White",
    "data-name": "AAA Diamond Four Short Facets White"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Short_Facets_Blue",
    "data-name": "AAA Diamond Four Short Facets Blue"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#a5c5ed"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#a5c5ed"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Four_Long_Text",
    "data-name": "AAA Diamond Four Long Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m65.1,22.04v1.55h-4.63v3.09h3.91v1.55h-3.91v4.26h-1.96v-10.45h6.59Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m77.37,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.61,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.16-.4c-.65-.27-1.21-.64-1.68-1.12s-.82-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.47.38-2.13c.26-.65.62-1.22,1.08-1.69s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.16-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.25.65.38,1.36.38,2.13Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.04.73s-.51.7-.66,1.16c-.15.45-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.04.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.45.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m83.83,30.92c.38,0,.71-.06,1.01-.19s.55-.3.75-.53.36-.5.47-.82c.11-.32.16-.69.16-1.09v-6.26h1.94v6.26c0,.62-.1,1.2-.3,1.72-.2.53-.49.98-.86,1.37-.38.38-.83.68-1.37.9-.53.21-1.14.32-1.81.32s-1.27-.11-1.81-.32c-.53-.21-.99-.51-1.36-.9-.37-.38-.66-.84-.86-1.37-.2-.53-.3-1.1-.3-1.72v-6.26h1.94v6.25c0,.4.05.76.16,1.08.11.32.26.6.47.83s.45.4.75.53c.3.13.63.19,1.01.19Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m92.88,28.4v4.08h-1.94v-10.45h3.19c.71,0,1.32.07,1.83.22.51.15.93.35,1.25.62.33.27.56.58.72.95.15.37.23.77.23,1.22,0,.35-.05.68-.16,1-.1.31-.25.6-.45.85-.2.26-.44.48-.72.67-.29.19-.61.35-.98.46.25.14.46.34.64.6l2.62,3.86h-1.75c-.17,0-.31-.03-.43-.1-.12-.07-.22-.16-.3-.29l-2.2-3.35c-.08-.13-.17-.21-.27-.27s-.24-.08-.44-.08h-.83Zm0-1.39h1.21c.37,0,.69-.05.96-.14.27-.09.5-.22.67-.38s.31-.35.39-.58c.09-.22.13-.46.13-.73,0-.53-.17-.94-.52-1.22s-.88-.43-1.6-.43h-1.24v3.47Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m113.85,27.26c0,.77-.13,1.47-.38,2.11-.25.64-.61,1.19-1.08,1.65s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.45h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.34.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.45.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m118.28,32.49h-1.95v-10.45h1.95v10.45Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m130.54,32.49h-1.5c-.17,0-.31-.04-.42-.13-.11-.08-.19-.19-.23-.31l-.78-2.13h-4.33l-.78,2.13c-.04.11-.11.21-.23.3-.11.09-.25.14-.42.14h-1.51l4.11-10.45h1.99l4.11,10.45Zm-6.76-3.95h3.33l-1.27-3.48c-.06-.16-.12-.34-.19-.55-.07-.21-.14-.44-.21-.68-.07.25-.13.48-.2.69s-.13.4-.19.56l-1.27,3.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m137.81,28.63c.07.17.14.33.21.5.07-.17.14-.35.21-.51.07-.17.15-.33.23-.48l3.09-5.79c.04-.07.08-.13.12-.17.04-.04.09-.07.14-.09.05-.02.11-.03.17-.04.06,0,.14,0,.22,0h1.47v10.45h-1.71v-6.75c0-.13,0-.26.01-.41,0-.15.02-.3.03-.45l-3.16,5.93c-.07.13-.17.24-.28.31-.12.08-.25.11-.41.11h-.27c-.15,0-.29-.04-.4-.11-.12-.07-.21-.18-.28-.31l-3.2-5.95c.02.16.03.32.04.47,0,.15.01.29.01.42v6.75h-1.71v-10.45h1.47c.09,0,.16,0,.22,0,.06,0,.12.02.17.04.05.02.1.05.14.09.04.04.08.1.12.17l3.12,5.8c.08.16.16.32.23.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m156.53,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.61,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.16-.4c-.65-.27-1.21-.64-1.68-1.12s-.82-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.47.38-2.13c.26-.65.62-1.22,1.08-1.69s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.16-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.25.65.38,1.36.38,2.13Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.04.73s-.51.7-.66,1.16c-.15.45-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.04.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.45.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m160.02,22.05c.06,0,.11.02.16.04.05.02.09.05.13.09s.09.1.14.16l5.49,6.99c-.02-.17-.03-.33-.04-.5,0-.16-.01-.31-.01-.45v-6.35h1.71v10.45h-1c-.15,0-.28-.02-.38-.07s-.2-.13-.3-.26l-5.46-6.96c.01.15.03.31.03.46s.01.29.01.42v6.42h-1.71v-10.45h1.02c.09,0,.16,0,.22.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m179.71,27.26c0,.77-.13,1.47-.38,2.11-.25.64-.61,1.19-1.08,1.65s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.45h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.34.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.45.23-.97.23-1.54Z",
    fill: "#fff"
  })))),
  "mdsIcon-diamond-five-long": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "diamond-five-long",
    viewBox: "0 0 197 45"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Long",
    "data-name": "AAA Diamond Five Long"
  }, /*#__PURE__*/React__default["default"].createElement("rect", {
    id: "AAA_Diamond_Five_Long_Wrapper",
    "data-name": "AAA Diamond Five Long Wrapper",
    width: "197",
    height: "45",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Long_Banner",
    "data-name": "AAA Diamond Five Long Banner"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "197 15.27 41.76 15.27 45.25 20.36 29.1 39.38 197 39.38 197 15.27",
    fill: "#004876"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    id: "AAA_Diamond_Five_Long_DiamondBG",
    "data-name": "AAA Diamond Five Long DiamondBG",
    points: "34.56 9.58 7.22 9.58 0 20.17 20.89 44.94 41.79 20.17 34.56 9.58 34.56 9.58",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Long_BannerTicks",
    "data-name": "AAA Diamond Five Long BannerTicks"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m20.89,4.67c-.51,0-.92-.42-.92-.92V.92c0-.51.42-.92.93-.92s.92.41.92.92v2.82c0,.51-.42.92-.93.92Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m4.95,7.98c-.22,0-.42-.08-.59-.22l-2.16-1.81c-.19-.16-.31-.38-.33-.63-.02-.25.06-.49.22-.67.16-.19.38-.3.63-.33.24-.02.48.05.67.21l2.16,1.81c.39.33.44.91.11,1.3-.16.19-.38.31-.63.33-.03,0-.06,0-.08,0Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m36.84,7.98c-.26,0-.53-.11-.71-.33-.33-.39-.28-.98.11-1.3l2.16-1.81c.19-.16.42-.23.68-.21.25.02.47.14.63.33.33.39.28.97-.11,1.3l-2.16,1.81c-.17.14-.38.22-.59.22Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m12.39,5.42c-.1,0-.19-.01-.28-.04-.23-.08-.43-.24-.54-.46l-1.29-2.51c-.11-.22-.13-.47-.06-.7.08-.24.24-.43.46-.54.45-.23,1.01-.05,1.24.4l1.29,2.51c.11.22.13.47.06.7-.08.24-.24.43-.46.54-.13.07-.28.1-.42.1Z",
    fill: "#074a76"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m29.28,5.39c-.16,0-.32-.04-.46-.12h0c-.21-.12-.37-.32-.43-.56-.06-.24-.03-.49.09-.7l1.41-2.44c.25-.44.82-.59,1.26-.34.21.12.37.32.43.56s.03.49-.09.7l-1.41,2.44c-.12.21-.32.37-.56.43-.08.02-.16.03-.24.03Z",
    fill: "#074a76"
  }))), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Long_Text",
    "data-name": "AAA Diamond Five Long Text"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m69.24,22.04v1.55h-4.64v3.1h3.91v1.56h-3.91v4.26h-1.96v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m73.68,32.49h-1.95v-10.46h1.95v10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m75.73,22.04h1.57c.17,0,.31.04.41.12s.19.19.24.32l2.46,6.38c.08.21.16.43.23.68.07.25.15.51.21.78.11-.56.25-1.04.41-1.47l2.45-6.38c.04-.11.12-.21.23-.3.11-.09.25-.14.41-.14h1.57l-4.22,10.46h-1.76l-4.22-10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m94.34,22.04v1.55h-4.64v2.9h3.65v1.5h-3.65v2.96h4.64v1.56h-6.6v-10.46h6.6Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m109.55,27.26c0,.77-.13,1.47-.38,2.11-.26.64-.61,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.46h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m113.99,32.49h-1.95v-10.46h1.95v10.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m126.26,32.49h-1.5c-.17,0-.31-.04-.42-.13-.11-.08-.19-.19-.23-.31l-.78-2.13h-4.33l-.78,2.13c-.04.11-.11.21-.23.3-.11.09-.25.14-.42.14h-1.51l4.11-10.46h1.99l4.11,10.46Zm-6.77-3.95h3.33l-1.27-3.48c-.06-.16-.12-.34-.19-.55-.07-.21-.14-.44-.21-.68-.07.25-.13.48-.2.69s-.13.4-.19.56l-1.27,3.46Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m133.54,28.64c.07.17.14.33.21.5.07-.17.14-.35.21-.51.07-.17.15-.33.23-.48l3.1-5.79c.04-.07.08-.13.12-.17.04-.04.09-.07.14-.09.05-.02.11-.03.17-.04.06,0,.14,0,.22,0h1.47v10.46h-1.71v-6.76c0-.13,0-.26.01-.41,0-.15.02-.3.03-.46l-3.16,5.93c-.07.13-.17.24-.28.31-.12.08-.25.11-.41.11h-.27c-.15,0-.29-.04-.4-.11-.12-.07-.21-.18-.28-.31l-3.2-5.95c.02.16.03.32.04.47,0,.15.01.29.01.42v6.76h-1.71v-10.46h1.47c.09,0,.16,0,.22,0,.06,0,.12.02.17.04.05.02.1.05.14.09.04.04.08.1.12.17l3.12,5.81c.08.16.16.32.23.48Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m152.26,27.26c0,.77-.13,1.48-.38,2.13-.26.65-.62,1.22-1.08,1.7-.46.48-1.02.85-1.67,1.12-.65.27-1.37.4-2.16.4s-1.51-.13-2.17-.4c-.65-.27-1.21-.64-1.68-1.12s-.83-1.04-1.08-1.7c-.26-.65-.38-1.36-.38-2.13s.13-1.48.38-2.13c.26-.65.62-1.22,1.08-1.7s1.02-.85,1.68-1.12c.65-.27,1.37-.4,2.17-.4s1.51.13,2.16.4c.65.27,1.21.64,1.67,1.12.46.48.82,1.04,1.08,1.69.26.65.38,1.36.38,2.13Zm-2,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.65-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25s-.97.08-1.38.25c-.41.17-.76.41-1.05.73s-.51.7-.66,1.16c-.15.46-.23.97-.23,1.54s.08,1.09.23,1.54c.15.46.37.84.66,1.16.29.32.63.56,1.05.73.41.17.87.25,1.38.25s.97-.08,1.38-.25c.41-.17.75-.41,1.04-.73.28-.32.5-.7.65-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m155.76,22.05c.06,0,.11.02.16.04.05.02.09.05.13.09s.09.1.14.16l5.49,6.99c-.02-.17-.03-.33-.04-.5,0-.16-.01-.31-.01-.45v-6.36h1.71v10.46h-1.01c-.15,0-.28-.02-.38-.07s-.2-.13-.3-.26l-5.47-6.96c.01.15.03.31.03.46s.01.29.01.42v6.42h-1.71v-10.46h1.02c.09,0,.16,0,.22.01Z",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m175.46,27.26c0,.77-.13,1.47-.38,2.11-.26.64-.61,1.19-1.08,1.66s-1.02.82-1.67,1.08c-.65.26-1.37.38-2.16.38h-3.99v-10.46h3.99c.79,0,1.51.13,2.16.39.65.26,1.21.62,1.67,1.08s.82,1.01,1.08,1.65c.26.64.38,1.35.38,2.11Zm-1.99,0c0-.57-.08-1.09-.23-1.54-.15-.46-.37-.84-.66-1.16-.28-.32-.63-.56-1.04-.73-.41-.17-.87-.25-1.38-.25h-2.03v7.36h2.03c.51,0,.97-.08,1.38-.25.41-.17.75-.41,1.04-.73.28-.32.5-.7.66-1.16.15-.46.23-.97.23-1.54Z",
    fill: "#fff"
  })), /*#__PURE__*/React__default["default"].createElement("g", {
    id: "AAA_Diamond_Five_Long_Facets",
    "data-name": "AAA Diamond Five Long Facets"
  }, /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "23.01 38.2 37.54 20.98 28.38 20.98 23.01 38.2",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "18.77 38.2 4.24 20.98 13.41 20.98 18.77 38.2",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "31.9 12.35 22.78 12.35 27.68 18.53 31.9 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "9.89 12.35 19.01 12.35 14.11 18.53 9.89 12.35",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "37.78 19.12 33.62 13.02 29.45 19.12 37.78 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "4 19.12 8.17 13.02 12.33 19.12 4 19.12",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 12.87 15.94 19.12 20.89 19.12 25.84 19.12 20.89 12.87",
    fill: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement("polygon", {
    points: "20.89 20.98 15.28 20.98 20.89 39.87 26.51 20.98 20.89 20.98",
    fill: "#fff"
  })))),
  "mdsIcon-tc-shopping-cart": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "tc-shopping-cart",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("g", {
    id: "my-cart"
  }, /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("rect", {
    width: "24",
    height: "24",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m16.68,15.73c.12-.1.21-.2.32-.3-.12.1-.24.21-.35.32,0,0,.02,0,.03-.02h0Z",
    fill: "#f8d010"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.19,15.73s.06.03.08.05c-.32-.28-.64-.57-.96-.86.29.27.57.54.88.81Z",
    fill: "#0a6eb5"
  }), /*#__PURE__*/React__default["default"].createElement("g", null, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m14.77,11.88h0c.34-.43.69-.84,1.03-1.24h0c-.34.4-.68.81-1.03,1.24Z",
    fill: "none"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m8.64,5.25h.01s.05-.05.08-.07c-.03.02-.06.04-.09.07Z",
    fill: "#d7182a"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.94,10.45c-.05.06-.1.12-.15.18h0c.05-.06.1-.12.15-.18,0,0,0,0,0,0Z",
    fill: "#d7182a"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m23.16,5.18h0s-.01,0-.02-.01c0,0,.01.01.02.02h0Z",
    fill: "#d7182a"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.27,15.78c-.32-.27-.64-.56-.96-.86-.16-.15-.32-.29-.47-.44-.33-.35-.37-.88-.09-1.27.34-.47.68-.91,1.02-1.34h0c-.34.42-.68.86-1.02,1.34-.28.39-.23.92.09,1.27-2.39-2.26-4.16-4.38-5.3-6.35l.54,3.1.53,3.04c.15.84.7,1.55,1.55,1.55h4.77,0s-.6,0-.6,0c-.02-.02-.04-.03-.06-.04Z",
    fill: "#1967b2"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m18.09,14.43s0,0,0,0c-.35.33-.7.66-1.08,1h0c-.12.1-.24.21-.35.31-.03.02-.06.05-.09.07h-.39s4.56,0,4.56,0c.05,0,.1,0,.15,0,.02,0,.03,0,.05,0,.03,0,.06,0,.1-.02.02,0,.04,0,.05-.01.03,0,.06-.01.08-.02.02,0,.04-.01.05-.02l.08-.03s.04-.02.05-.02c.02-.01.05-.02.07-.04.02,0,.03-.02.05-.03.02-.01.05-.03.07-.04.02,0,.03-.02.04-.03.02-.02.04-.04.07-.05.01-.01.03-.02.04-.03.03-.02.05-.05.08-.08,0,0,.01-.01.02-.02.03-.03.06-.07.09-.11,0,0,.02-.02.02-.03.02-.03.04-.05.06-.08,0-.02.02-.03.03-.04.02-.03.03-.05.05-.08,0-.02.02-.04.03-.05.01-.03.03-.05.04-.08,0-.02.02-.04.03-.06.01-.03.02-.05.03-.08,0-.02.02-.04.02-.06,0-.03.02-.05.03-.08,0-.02.01-.04.02-.06,0,0,0-.02,0-.02,0,0,0-.02,0-.03.02-.08.04-.16.05-.24l1.07-6.18h0s0,.02,0,.02c-1.13,1.96-2.89,4.07-5.27,6.32Z",
    fill: "#fbd603"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m8.76,5.15s-.02.02-.03.03c.01,0,.02-.02.03-.02,0,0,0,0,0,0Z",
    fill: "#92278f"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m23.13,5.15s0,0,0,0c0,0,.01,0,.02,0,0,0,0,0-.01-.01Z",
    fill: "#f7941d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m17.2,11.98h0c-.37-.47-.74-.92-1.1-1.35h0c.37.43.73.88,1.1,1.35Z",
    fill: "#f7941d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m15.94,10.45c.05.06.1.12.15.18h0c-.05-.06-.1-.12-.15-.18,0,0,0,0,0,0Z",
    fill: "#f7941d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m18.14,13.21c.27.37.23.88-.06,1.22,0,0,0,0,0,0,.29-.35.33-.85.06-1.22-.32-.44-.63-.84-.95-1.24h0c.31.4.63.8.95,1.24Z",
    fill: "#f7941d"
  })), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m21.36,16.94c-1.94,0-10.23,0-10.23,0-1.44,0-2.43-1.14-2.66-2.49-.75-4.3-1.09-6.32-1.85-10.62h0s-.19-1.12-.19-1.12c-.04-.23-.23-.39-.46-.39H.79c-.29,0-.51.26-.46.55l.1.57c.04.23.23.39.46.39h3.8c.23,0,.43.17.46.4.72,4.12,1.09,6.22,1.82,10.48.36,2.08,1.97,3.74,4.15,3.74,0,0,8.29,0,10.23,0,.26,0,.46-.21.46-.47v-.57c0-.26-.2-.47-.46-.47Zm-1.49,2.31c-.77,0-1.39.63-1.39,1.39s.63,1.39,1.39,1.39,1.39-.63,1.39-1.39-.62-1.39-1.39-1.39Zm-7.35-.07c-.79,0-1.43.64-1.43,1.43s.64,1.43,1.43,1.43,1.43-.64,1.43-1.43-.64-1.43-1.43-1.43Z",
    fill: "#273a7f",
    "fill-rule": "evenodd"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m23.15,5.18s-.01-.01-.02-.02c0,0-.01,0-.02,0-2.23.56-4.62,2.34-7.18,5.3,0,0,0,0,0,0,0,0,0,0,0,0,.05.06.1.12.15.18.37.43.73.87,1.1,1.34.31.4.63.8.95,1.24.27.37.23.87-.06,1.22,2.38-2.25,4.14-4.36,5.27-6.32v-.02s.3-1.73.3-1.73c.08-.47-.15-.89-.51-1.18Z",
    fill: "#f7941d"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m8.77,5.16s-.02.02-.03.02c-.03.02-.05.05-.08.08-.31.28-.5.67-.42,1.1l.31,1.77s0,0,0,0c1.14,1.97,2.91,4.08,5.3,6.35-.33-.35-.37-.88-.09-1.27.34-.47.68-.91,1.02-1.34.34-.43.69-.85,1.03-1.24.05-.06.1-.12.15-.18-2.55-2.95-4.95-4.73-7.18-5.3Z",
    fill: "#92278f"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m22.11,4.81h-3v-.24c0-1.05-.85-1.9-1.9-1.9h-2.56c-1.05,0-1.9.85-1.9,1.9v.24h-2.97c-.37,0-.72.14-1.01.35,2.23.56,4.62,2.34,7.18,5.3,2.55-2.95,4.95-4.73,7.18-5.3-.29-.21-.65-.35-1.01-.35Zm-4.12,0h-4.12v-.24c0-.43.35-.78.78-.78h2.56c.43,0,.78.35.78.78v.24Z",
    fill: "#d7182a"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "m18.14,13.21c-.32-.44-.63-.84-.95-1.24-.37-.47-.74-.92-1.1-1.35-.05-.06-.1-.12-.15-.18-.05.06-.1.12-.15.18-.34.4-.68.81-1.03,1.24-.34.43-.68.87-1.02,1.34-.28.39-.23.92.09,1.27.15.14.31.29.47.44.32.3.65.59.96.86.02.01.04.03.06.04h1.24s.06-.05.09-.07c.12-.1.24-.21.35-.32h0c.37-.33.73-.67,1.08-.99,0,0,0,0,0,0,0,0,0,0,0,0,.29-.35.33-.85.06-1.22Z",
    fill: "#1b3281"
  }))))),
  "mdsIcon-agent": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "agent",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 12.22c-0.017-4.958-4.040-8.97-9-8.97-4.971 0-9 4.029-9 9 0 0.011 0 0.021 0 0.032v-0.002c-0.599 0.35-0.995 0.988-1 1.719v2.001c0 1.105 0.895 2 2 2v0 0c0.552 0 1-0.448 1-1v0-4.81c-0.001-0.033-0.001-0.072-0.001-0.112 0-3.827 2.99-6.956 6.761-7.177l0.020-0.001c0.066-0.002 0.143-0.003 0.22-0.003 3.866 0 7 3.134 7 7 0 0.001 0 0.002 0 0.004v-0 7.1h-7c-0.552 0-1 0.448-1 1v0h8c1.1 1 2 0.1 2-1v-1.22c0.598-0.314 0.999-0.93 1-1.64v-2.3c-0.007-0.703-0.407-1.311-0.99-1.615l-0.010-0.005z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 13c0 0.552-0.448 1-1 1s-1-0.448-1-1c0-0.552 0.448-1 1-1s1 0.448 1 1z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 11c-0.374-3.011-2.918-5.319-6-5.319-3.338 0-6.044 2.706-6.044 6.044 0 0.256 0.016 0.507 0.047 0.755l-0.003-0.030c2.47-1 5-2.45 4.86-5.45 1.323 2.407 3.842 4.011 6.735 4.011 0.143 0 0.284-0.004 0.425-0.012l-0.020 0.001z"
  })),
  "mdsIcon-social--facebook": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "social--facebook",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.8,3.76H4.71a.94.94,0,0,0-.93.94V19.79a.93.93,0,0,0,.93.93h8.13V14.15H10.63V11.59h2.21V9.71a3.09,3.09,0,0,1,3.29-3.39,18.69,18.69,0,0,1,2,.1V8.71H16.75c-1.06,0-1.27.51-1.27,1.25v1.63H18l-.33,2.56H15.48v6.57h4.33a.93.93,0,0,0,.93-.93V4.7A.94.94,0,0,0,19.8,3.76Z"
  })),
  "mdsIcon-social--twitter": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "social--twitter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21,6a7.16,7.16,0,0,1-2.12.58,3.66,3.66,0,0,0,1.62-2,7.53,7.53,0,0,1-2.34.9,3.68,3.68,0,0,0-6.28,3.36A10.46,10.46,0,0,1,4.29,4.91,3.68,3.68,0,0,0,5.43,9.83a3.71,3.71,0,0,1-1.67-.46,3.69,3.69,0,0,0,3,3.66,3.7,3.7,0,0,1-1.66.06,3.68,3.68,0,0,0,3.44,2.56A7.4,7.4,0,0,1,3,17.18,10.49,10.49,0,0,0,19.16,7.87,7.43,7.43,0,0,0,21,6Z"
  })),
  "mdsIcon-social--link": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "social--link",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8,20c0,0-2,2-3,2c-1.657,0-3-1.343-3-3c0-1,2-3,2-3l3.908-3.908 C7.613,12.037,7.312,12,7,12c-1.144,0-2.163,0.351-3,1l-3,3c-0.624,0.827-1,1.881-1,3c0,2.762,2.238,5,5,5c1.126,0,2.17-0.369,3-1 l3-3c0.636-0.831,1-1.87,1-3c0-0.312-0.037-0.613-0.092-0.908L8,20z M19,0c-1.125,0-2.17,0.369-3,1l-3,3c-0.636,0.832-1,1.87-1,3 c0,0.312,0.037,0.613,0.092,0.908L16,4c0,0,2-2,3-2c1.657,0,3,1.343,3,3c0,1-2,3-2,3l-3.908,3.908C16.387,11.963,16.688,12,17,12 c1.144,0,2.163-0.351,3-1l3-3c0.624-0.827,1-1.881,1-3C24,2.238,21.762,0,19,0z M7,15.5C7,16.328,7.672,17,8.5,17 c0.591,0,1.097-0.345,1.342-0.842l6.316-6.316C16.655,9.597,17,9.091,17,8.5C17,7.672,16.328,7,15.5,7 c-0.591,0-1.097,0.345-1.342,0.842l-6.316,6.316C7.345,14.403,7,14.909,7,15.5z"
  })),
  "mdsIcon-amenities--accessibility": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--accessibility",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.86,5.66a2,2,0,1,0-2-2A2,2,0,0,0,11.86,5.66Zm-2,14a3,3,0,0,1-1-5.83V11.76a5,5,0,1,0,5.9,5.9H12.69A3,3,0,0,1,9.86,19.66Zm7-5.5h-3V10.71a9,9,0,0,0,3.8,1.82A1,1,0,1,0,18,10.59a5.76,5.76,0,0,1-3.23-1.76L13.5,7.4A1.93,1.93,0,0,0,12.89,7h0a2,2,0,0,0-1.25-.25A2,2,0,0,0,9.86,8.76v5.9a2,2,0,0,0,2,2h5v4a1,1,0,0,0,2,0v-4.5A2,2,0,0,0,16.86,14.16Z"
  })),
  "mdsIcon-amenities--business": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--business",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13,15.66H11a1,1,0,0,1-1-1H3v4a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-4H14A1,1,0,0,1,13,15.66Zm7-9H16a4,4,0,0,0-8,0H4a2,2,0,0,0-2,2v3a2,2,0,0,0,2,2h6v-1a1,1,0,0,1,1-1h2a1,1,0,0,1,1,1v1h6a2,2,0,0,0,2-2v-3A2,2,0,0,0,20,6.66Zm-10,0a2,2,0,1,1,4,0H10Z"
  })),
  "mdsIcon-amenities--charging": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--charging",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.9,6.89h0L16.72,3.69a.75.75,0,1,0-1.06,1.06l1.58,1.58A2.49,2.49,0,0,0,15.66,9a2.54,2.54,0,0,0,2.2,2.11,2.44,2.44,0,0,0,1.27-.2v7.21a1,1,0,0,1-2,0v-4.5a2,2,0,0,0-2-2h-1v-7a2,2,0,0,0-2-2h-6a2,2,0,0,0-2,2v15a1,1,0,0,0,1,1h8a1,1,0,0,0,1-1v-6.5h1.5V18a2.6,2.6,0,0,0,2.24,2.63,2.5,2.5,0,0,0,2.76-2.49V8.66A2.5,2.5,0,0,0,19.9,6.89ZM18.13,9.66a1,1,0,1,1,1-1A1,1,0,0,1,18.13,9.66Zm-10,6.12V13.16H7a.5.5,0,0,1-.44-.74l2.67-5a.5.5,0,0,1,.94.24v3h1.14a.5.5,0,0,1,.43.75L9.06,16A.5.5,0,0,1,8.13,15.78Z"
  })),
  "mdsIcon-amenities--eco": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--eco",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.05,8.05a7,7,0,0,0,0,9.88A16.18,16.18,0,0,1,13.39,10,16,16,0,0,0,8,19.32,7,7,0,0,0,16,18c3-3,3.83-11.14,4-13.38A.49.49,0,0,0,19.43,4C17.19,4.22,9,5.06,6.05,8.05Z"
  })),
  "mdsIcon-amenities--fitness": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--fitness",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.57,14.86l.72-.72a1,1,0,0,0,0-1.41l0,0a1,1,0,0,0-1.41,0L17,15.57,8.43,7l2.86-2.86a1,1,0,0,0,0-1.41l0,0a1,1,0,0,0-1.41,0l-.72.72-.72-.72A1,1,0,0,0,7,2.71L5.57,4.14l-.72-.72A1,1,0,0,0,3.42,4.85l.72.72L2.71,7a1,1,0,0,0,0,1.41l.72.72-.72.73a1,1,0,0,0,0,1.41l0,0a1,1,0,0,0,1.41,0L7,8.43,15.57,17l-2.86,2.86a1,1,0,0,0,0,1.41l0,0a1,1,0,0,0,1.41,0l.72-.72.72.72a1,1,0,0,0,1.41,0l1.43-1.43.72.72a1,1,0,0,0,1.43-1.43l-.72-.72L21.29,17a1,1,0,0,0,0-1.41Z"
  })),
  "mdsIcon-amenities--pets": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--pets",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.25,9.35a2.5,2.5,0,1,0-2.5,2.5A2.5,2.5,0,0,0,7.25,9.35Zm2-1.5a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,9.25,7.85Zm6,0a2.5,2.5,0,1,0-2.5-2.5A2.5,2.5,0,0,0,15.25,7.85Zm4.5-1a2.5,2.5,0,1,0,2.5,2.5A2.5,2.5,0,0,0,19.75,6.85Zm-2.16,7.86c-.87-1-1.6-1.89-2.48-2.91a4.24,4.24,0,0,0-1.75-1.32,2,2,0,0,0-.33-.09,5,5,0,0,0-.78,0,4.2,4.2,0,0,0-.79.05,2,2,0,0,0-.33.09,4.31,4.31,0,0,0-1.75,1.32c-.87,1-1.6,1.89-2.48,2.91C5.59,16,4,17.48,4.28,19.51a3.14,3.14,0,0,0,2.33,2.32c.73.15,3.06-.44,5.54-.44h.18c2.48,0,4.81.58,5.54.44a3.15,3.15,0,0,0,2.33-2.32C20.51,17.47,18.9,16,17.59,14.71Z"
  })),
  "mdsIcon-amenities--pool": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--pool",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.36,5.22A4.54,4.54,0,0,1,9.25,6.66l1,1L7,10.91a5.47,5.47,0,0,1,.77.39,1.8,1.8,0,0,0,1.15.36,1.8,1.8,0,0,0,1.15-.36,3.89,3.89,0,0,1,2.19-.64,3.83,3.83,0,0,1,2.18.64,1.88,1.88,0,0,0,1.15.36,1.82,1.82,0,0,0,1.15-.36l.41-.23L10.73,4.66A6.09,6.09,0,0,0,6.55,2.71a1.21,1.21,0,0,0-1.3,1.21V4A1.24,1.24,0,0,0,6.36,5.22ZM3.36,16a4.5,4.5,0,0,0,1.09-.49,1.82,1.82,0,0,1,1.15-.36,1.88,1.88,0,0,1,1.15.36,3.83,3.83,0,0,0,2.18.64,3.83,3.83,0,0,0,2.18-.64,1.8,1.8,0,0,1,1.15-.36,1.88,1.88,0,0,1,1.15.36,4,4,0,0,0,4.36,0,1.8,1.8,0,0,1,1.15-.36,1.88,1.88,0,0,1,1.15.36,4.77,4.77,0,0,0,.85.43A1,1,0,0,0,22.23,15v-.12a.93.93,0,0,0-.64-.86,3.08,3.08,0,0,1-.51-.26,4,4,0,0,0-4.36,0,1.82,1.82,0,0,1-1.15.36,1.88,1.88,0,0,1-1.15-.36,4,4,0,0,0-4.36,0,1.8,1.8,0,0,1-1.15.36,1.88,1.88,0,0,1-1.15-.36,3.83,3.83,0,0,0-2.18-.64,3.83,3.83,0,0,0-2.18.64,3.54,3.54,0,0,1-.5.27.91.91,0,0,0-.65.85v.23A.88.88,0,0,0,3.36,16ZM21.6,18.57a2.24,2.24,0,0,1-.5-.27,4,4,0,0,0-4.36,0,1.82,1.82,0,0,1-1.15.36,1.88,1.88,0,0,1-1.15-.36,3.83,3.83,0,0,0-2.18-.64,3.89,3.89,0,0,0-2.19.64,1.8,1.8,0,0,1-1.15.36,1.8,1.8,0,0,1-1.15-.36,3.83,3.83,0,0,0-2.18-.64,3.89,3.89,0,0,0-2.19.64,3.54,3.54,0,0,1-.5.27.91.91,0,0,0-.65.85v.12a1,1,0,0,0,1.3.91A4.91,4.91,0,0,0,4.44,20a1.87,1.87,0,0,1,1.15-.35A1.82,1.82,0,0,1,6.74,20a3.83,3.83,0,0,0,2.18.64A3.89,3.89,0,0,0,11.11,20a1.8,1.8,0,0,1,1.15-.36,1.88,1.88,0,0,1,1.15.36,4,4,0,0,0,4.36,0,1.8,1.8,0,0,1,1.15-.36,1.88,1.88,0,0,1,1.15.36,4.48,4.48,0,0,0,.88.44,1,1,0,0,0,1.3-.91v-.12A.91.91,0,0,0,21.6,18.57ZM16.75,7.66a2.5,2.5,0,1,0-2.5-2.5A2.49,2.49,0,0,0,16.75,7.66Z"
  })),
  "mdsIcon-amenities--wireless": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "amenities--wireless",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.94,16.23a4.28,4.28,0,0,0-3.91,0,1,1,0,0,0-.21,1.59l1.47,1.47a1,1,0,0,0,1.41,0l1.47-1.47A1,1,0,0,0,13.94,16.23ZM21.85,8A15.59,15.59,0,0,0,2.16,8a1.41,1.41,0,0,0-.1,2.1,1.39,1.39,0,0,0,1.87.1,12.75,12.75,0,0,1,16.13,0A1.41,1.41,0,0,0,21.85,8Zm-4.06,4A9.91,9.91,0,0,0,6.21,12a1.4,1.4,0,0,0-.12,2.12,1.41,1.41,0,0,0,1.83.13,7.06,7.06,0,0,1,8.16,0,1.42,1.42,0,0,0,1.83-.13h0A1.39,1.39,0,0,0,17.79,12Z"
  })),
  "mdsIcon-article": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "article",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.83 2.93h-14c-1.105 0-2 0.895-2 2v0 14c0 1.105 0.895 2 2 2v0h14c1.105 0 2-0.895 2-2v0-14c0-1.105-0.895-2-2-2v0zM12.83 16.93h-5c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h5c0.552 0 1 0.448 1 1s-0.448 1-1 1v0zM15.83 12.93h-8c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h8c0.552 0 1 0.448 1 1s-0.448 1-1 1v0zM15.83 8.93h-8c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h8c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-budget": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "budget",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.82,10.82c-1.33-.5-1.88-.83-1.88-1.35,0-.44,.33-.88,1.35-.88,.78,0,1.55,.19,2.26,.53l.45-1.77c-.71-.33-1.49-.51-2.27-.52v-1.38h-1.53v1.49c-1.68,.33-2.65,1.41-2.65,2.79,0,1.52,1.14,2.3,2.82,2.87,1.16,.39,1.66,.77,1.66,1.36,0,.63-.61,.97-1.5,.97-.91-.01-1.8-.25-2.6-.69l-.47,1.83c.59,.34,1.61,.63,2.66,.67v1.49h1.53v-1.6c1.8-.31,2.79-1.49,2.79-2.9s-.75-2.27-2.62-2.92ZM13.66,.14c-.29-.04-.58-.08-.87-.1-.09,0-.18-.01-.28-.02-.12,0-.23-.02-.35-.02h-.21C5.41-.06,.06,5.2,0,11.74s5.2,11.89,11.74,11.95h.21c6.54,.06,11.89-5.2,11.94-11.74,.05-6.03-4.42-11.02-10.24-11.81Zm6.99,12.12c0,.19-.02,.38-.05,.57,0,.07-.02,.15-.03,.22-.03,.21-.07,.42-.11,.63-.01,.06-.03,.12-.04,.18-.05,.21-.11,.42-.17,.62-.02,.06-.04,.13-.06,.19-.07,.19-.14,.39-.22,.58-.03,.08-.07,.16-.11,.24-.08,.17-.16,.33-.24,.49-.06,.11-.12,.21-.18,.32-.2,.34-.43,.67-.67,.98l-.02,.03c-.25,.31-.51,.6-.8,.88-.02,.01-.03,.03-.05,.04-.25,.24-.52,.45-.81,.66-.07,.05-.14,.1-.21,.15-.3,.21-.62,.4-.96,.58-1.23,.63-2.63,.98-4.11,.95h0c-4.74-.09-8.54-3.96-8.55-8.71,0-4.81,3.89-8.72,8.7-8.72h0c.4,0,.8,.04,1.19,.09,.04,0,.09,.01,.13,.02,.03,0,.07,.01,.1,.02,.36,.06,.72,.14,1.06,.24,.06,.02,.11,.04,.17,.06,.37,.12,.73,.25,1.07,.42h.02c.36,.18,.71,.38,1.04,.6,.02,.01,.04,.03,.06,.04,.09,.06,.17,.12,.25,.18,.13,.09,.26,.19,.39,.29,.02,.01,.04,.03,.06,.04,.04,.03,.07,.06,.11,.09,.95,.81,1.72,1.82,2.25,2.96,.07,.14,.13,.28,.19,.43,.01,.03,.02,.07,.04,.1,.03,.09,.07,.18,.1,.27,.05,.14,.1,.29,.14,.43,.02,.07,.04,.15,.06,.22,.02,.06,.03,.12,.05,.19,.03,.14,.06,.28,.09,.41,.01,.07,.02,.14,.03,.21,.01,.08,.03,.16,.04,.24,.02,.14,.04,.27,.05,.41,0,.06,0,.11,.01,.17,0,.09,.01,.18,.01,.28,0,.14,0,.28,0,.43,0,.09,0,.19,0,.29v.02Z"
  })),
  "mdsIcon-calendar": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "calendar",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 4.2h-1v-1c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 1h-8v-1c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 1h-1c-1.105 0-2 0.895-2 2v0 14c0 1.105 0.895 2 2 2v0h14c1.105 0 2-0.895 2-2v0-14c0-1.105-0.895-2-2-2v0zM19 19.2c0 0.552-0.448 1-1 1v0h-12c-0.552 0-1-0.448-1-1v0-10h14zM7 11.2h2v2h-2zM11 11.2h2v2h-2zM15 11.2h2v2h-2z"
  })),
  "mdsIcon-calendar--booking": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "calendar--booking",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.35 20l0.57 2h-8.92c-1.105 0-2-0.895-2-2v0-14c0-1.105 0.895-2 2-2v0h1v-1c0-0.552 0.448-1 1-1v0 0c0.552 0 1 0.448 1 1v0 1h8v-1c0-0.552 0.448-1 1-1v0 0c0.552 0 1 0.448 1 1v0 1h1c1.105 0 2 0.895 2 2v0 8.92l-2-0.57v-4.35h-14v10zM21 20.59l-2.51-2.51 1.22-0.52c0.179-0.079 0.302-0.255 0.302-0.459 0-0.227-0.151-0.419-0.359-0.48l-0.004-0.001-4.78-1.37c-0.042-0.013-0.090-0.020-0.14-0.020-0.276 0-0.5 0.224-0.5 0.5 0 0.050 0.007 0.098 0.021 0.144l-0.001-0.004 1.37 4.78c0.062 0.211 0.254 0.362 0.481 0.362 0.205 0 0.381-0.123 0.458-0.299l0.001-0.003 0.52-1.22 2.51 2.51c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l-0 0c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0z"
  })),
  "mdsIcon-camera": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "camera",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 13c0 1.657-1.343 3-3 3s-3-1.343-3-3c0-1.657 1.343-3 3-3s3 1.343 3 3z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20 5h-3.17l-1.24-1.35c-0.366-0.399-0.889-0.648-1.47-0.65h-4.24c-0.001 0-0.003 0-0.004 0-0.584 0-1.109 0.25-1.474 0.649l-0.001 0.001-1.23 1.35h-3.17c-1.105 0-2 0.895-2 2v0 12c0 1.105 0.895 2 2 2v0h16c1.105 0 2-0.895 2-2v0-12c0-1.105-0.895-2-2-2v0zM12 18c-2.761 0-5-2.239-5-5s2.239-5 5-5c2.761 0 5 2.239 5 5v0c0 2.761-2.239 5-5 5v0z"
  })),
  "mdsIcon-category--article": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--article",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M19.34,3h-14a2,2,0,0,0-2,2V19a2,2,0,0,0,2,2h14a2,2,0,0,0,2-2V5A2,2,0,0,0,19.34,3Zm-6,14h-5a1,1,0,1,1,0-2h5a1,1,0,1,1,0,2Zm3-4h-8a1,1,0,0,1,0-2h8a1,1,0,0,1,0,2Zm0-4h-8a1,1,0,1,1,0-2h8a1,1,0,0,1,0,2Z"
  })),
  "mdsIcon-category--campgrounds": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--campgrounds",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.41 18.69c0 1.127-0.913 2.040-2.040 2.040s-2.040-0.913-2.040-2.040c0-1.127 0.913-2.040 2.040-2.040s2.040 0.913 2.040 2.040z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22.62 17.94h-1.62c0.384-0.316 0.661-0.749 0.777-1.244l0.003-0.016 0.8-4.21c0.89-4.47-3.1-8.47-8.51-7.78l-6.69 0.84c-4.34 0.53-7 4-6.27 7.59l0.68 3.56c0.372 1.17 1.45 2.003 2.721 2.003 0.049 0 0.097-0.001 0.145-0.004l-0.007 0c0-0.002 0-0.004 0-0.006 0-0.377 0.077-0.736 0.217-1.062l-0.007 0.018c0.288-0.65 0.803-1.155 1.442-1.423l0.018-0.007c0.312-0.133 0.674-0.21 1.055-0.21s0.743 0.077 1.073 0.216l-0.018-0.007c0.651 0.281 1.159 0.789 1.433 1.422l0.007 0.018c0.133 0.308 0.21 0.667 0.21 1.044 0 0.002 0 0.004 0 0.006v-0h11.64v1.59c0 0 0 0 0 0 0 0.206 0.164 0.374 0.369 0.38h0.001c0.21 0 0.38-0.17 0.38-0.38v0-1.59h0.15c0.018 0.003 0.040 0.005 0.061 0.005 0.21 0 0.38-0.17 0.38-0.38s-0.17-0.38-0.38-0.38c-0.022 0-0.043 0.002-0.064 0.005l0.002-0zM5.33 12.1c-0.78-0.006-1.41-0.639-1.41-1.42 0-0.784 0.636-1.42 1.42-1.42s1.42 0.636 1.42 1.42v0c-0.006 0.785-0.644 1.42-1.43 1.42-0 0-0 0-0 0v0zM9.76 12.1c-0.784 0-1.42-0.636-1.42-1.42s0.636-1.42 1.42-1.42c0.784 0 1.42 0.636 1.42 1.42v0c0 0.784-0.636 1.42-1.42 1.42v0zM18.94 12l-0.25 5.33v0.24h-4.69v-0.24l-0.34-5.33c-0.13-1.83 1.050-3.46 2.64-3.46v0c1.6-0.010 2.78 1.62 2.64 3.46z"
  })),
  "mdsIcon-category--cruises": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--cruises",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13,9V7.82a3,3,0,1,0-2,0V9H9a1,1,0,0,0-1,1H8a1,1,0,0,0,1,1h2v8.92a8.06,8.06,0,0,1-5.55-3.37l1.14-1.14a.49.49,0,0,0,0-.75L3.8,12.6A.5.5,0,0,0,3,13v2c0,3.88,4.92,7,9,7s9-3.12,9-7V13a.5.5,0,0,0-.8-.4l-2.74,2.05a.49.49,0,0,0-.05.75l1.14,1.14A8.06,8.06,0,0,1,13,19.91V11h2a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1ZM12,4a1,1,0,1,1-1,1A1,1,0,0,1,12,4Z",
    vectorEffect: "non-scaling-stroke"
  })),
  "mdsIcon-category--guided-tours": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--guided-tours",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.5 5.5c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2v0c0 1.105 0.895 2 2 2v0zM20.84 2.58h-7c-0.552 0-1 0.448-1 1v0 6.94c-0.906-0.413-1.639-1.075-2.128-1.898l-0.012-0.022-1-1.6c-0.387-0.608-1.057-1.006-1.821-1.006-0.299 0-0.584 0.061-0.843 0.172l0.014-0.005-3.83 1.62c-0.723 0.312-1.22 1.019-1.22 1.842 0 0.003 0 0.006 0 0.009v-0 2.37c0 0.552 0.448 1 1 1s1-0.448 1-1v0-2.4l1.8-0.7-2.56 12.91c-0.012 0.057-0.018 0.123-0.018 0.19 0 0.552 0.448 1 1 1 0.006 0 0.013-0 0.019-0l-0.001 0h0.060c0.007 0 0.016 0 0.024 0 0.474 0 0.872-0.33 0.974-0.774l0.001-0.007 1.6-7.22 2.1 2v5c0 0.552 0.448 1 1 1s1-0.448 1-1v0-5.64c0-0.001 0-0.002 0-0.002 0-0.569-0.238-1.083-0.619-1.447l-0.001-0.001-1.48-1.41 0.6-3c0.874 0.995 2.004 1.745 3.289 2.146l0.051 0.014v9.92c-0.002 0.019-0.002 0.041-0.002 0.064 0 0.431 0.329 0.785 0.749 0.826l0.003 0c0.424-0.041 0.752-0.395 0.752-0.826 0-0.022-0.001-0.045-0.003-0.067l0 0.003v-9.73c0.374-0.151 0.632-0.51 0.632-0.93s-0.259-0.779-0.626-0.928l-0.007-0.002v-1.41h6.5c0.552 0 1-0.448 1-1v0-5c0-0.552-0.448-1-1-1v0z"
  })),
  "mdsIcon-category--lodgings": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--lodgings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.5 12c1.381 0 2.5-1.119 2.5-2.5s-1.119-2.5-2.5-2.5c-1.381 0-2.5 1.119-2.5 2.5v0c0 1.381 1.119 2.5 2.5 2.5v0zM18 7h-5c-1.105 0-2 0.895-2 2v0 4h-7v-7c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 12c0 0.552 0.448 1 1 1s1-0.448 1-1v0-2h16v2c0 0.552 0.448 1 1 1s1-0.448 1-1v0-7c0-2.209-1.791-4-4-4v0z"
  })),
  "mdsIcon-category--packages": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--packages",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.46,6.75H17.39a3,3,0,0,0,.17-1,2.85,2.85,0,0,0-5.23-1.57l-.47.64-.48-.65A2.85,2.85,0,0,0,6.16,5.8a2.75,2.75,0,0,0,.17,1H4.26a1.88,1.88,0,0,0-1.89,1.9V19.1A1.89,1.89,0,0,0,4.26,21h15.2a1.9,1.9,0,0,0,1.9-1.9V8.65A1.89,1.89,0,0,0,19.46,6.75Zm-4.75-1.9a1,1,0,1,1-1,1A1,1,0,0,1,14.71,4.85ZM9,4.85a1,1,0,1,1-.95,1A1,1,0,0,1,9,4.85Zm9.5,14.25H5.21a1,1,0,0,1-1-1V17.2h15.2v.95A1,1,0,0,1,18.51,19.1Zm.95-4.75H4.26V9.6a1,1,0,0,1,1-.95H9.08l-1.4,1.92a.94.94,0,0,0,.21,1.33,1,1,0,0,0,1.32-.21l2.65-3.61,2.65,3.61A.95.95,0,1,0,16,10.57L14.63,8.65h3.88a1,1,0,0,1,.95.95Z"
  })),
  "mdsIcon-category--points-of-interest": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--points-of-interest",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-0.001 0-0.002 0-0.003 0-4.418 0-8 3.582-8 8 0 0.070 0.001 0.14 0.003 0.21l-0-0.010q0 4.8 7.33 11.23c0.176 0.157 0.409 0.253 0.665 0.253s0.489-0.096 0.666-0.254l-0.001 0.001q7.34-6.43 7.34-11.23c0.002-0.060 0.003-0.13 0.003-0.2 0-4.418-3.582-8-8-8-0.001 0-0.002 0-0.003 0h0zM17 9.88l-2.42 1.73 0.95 3.080c0.014 0.050 0.022 0.108 0.022 0.168 0 0.365-0.295 0.66-0.66 0.66-0.135 0-0.26-0.040-0.364-0.109l0.002 0.002-2.53-1.87-2.46 1.87c-0.099 0.062-0.22 0.098-0.349 0.098-0.37 0-0.67-0.3-0.67-0.67 0-0.056 0.007-0.111 0.020-0.163l-0.001 0.005 0.95-3.070-2.49-1.74c-0.171-0.121-0.281-0.318-0.281-0.54 0-0.364 0.296-0.66 0.66-0.66 0 0 0 0 0.001 0h3l1-3.23c0.081-0.279 0.335-0.48 0.635-0.48s0.554 0.201 0.634 0.475l0.001 0.005 1 3.23h3c0.35 0.024 0.625 0.314 0.625 0.669 0 0.222-0.108 0.418-0.274 0.54l-0.002 0.001z"
  })),
  "mdsIcon-category--popular-destinations": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--popular-destinations",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-0.001 0-0.002 0-0.003 0-4.418 0-8 3.582-8 8 0 0.070 0.001 0.14 0.003 0.21l-0-0.010q0 4.8 7.33 11.23c0.176 0.157 0.409 0.253 0.665 0.253s0.489-0.096 0.666-0.254l-0.001 0.001q7.34-6.43 7.34-11.23c0.002-0.060 0.003-0.13 0.003-0.2 0-4.418-3.582-8-8-8-0.001 0-0.002 0-0.003 0h0zM12 14c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.485 0 4.5 2.015 4.5 4.5v0c0 0.003 0 0.006 0 0.010 0 2.48-2.010 4.49-4.49 4.49-0.004 0-0.007 0-0.011-0h0.001z"
  })),
  "mdsIcon-category--restaurants": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--restaurants",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.93 10.51l-6.19-6.18c-0.181-0.182-0.432-0.295-0.709-0.295-0.394 0-0.735 0.228-0.898 0.559l-0.003 0.006c-0.248 0.506-0.393 1.101-0.393 1.73 0 1.105 0.448 2.106 1.173 2.83l4.19 4.18zM18.5 11.51l3-3c0.102-0.122 0.165-0.281 0.165-0.455 0-0.392-0.318-0.71-0.71-0.71-0.174 0-0.333 0.062-0.456 0.166l0.001-0.001-3 3-1-1 3-3c0.102-0.122 0.165-0.281 0.165-0.455 0-0.392-0.318-0.71-0.71-0.71-0.174 0-0.333 0.062-0.456 0.166l0.001-0.001-3 3-1-1 3-3c0.102-0.122 0.165-0.281 0.165-0.455 0-0.392-0.318-0.71-0.71-0.71-0.174 0-0.333 0.062-0.456 0.166l0.001-0.001-3 3c-0.508 0.508-0.821 1.21-0.821 1.985 0 0.675 0.238 1.295 0.635 1.78l-0.004-0.005-8.9 8.9c-0.215 0.184-0.35 0.456-0.35 0.76 0 0.552 0.448 1 1 1 0.303 0 0.575-0.135 0.758-0.348l0.001-0.001 6.18-6.17 6.18 6.18c0.174 0.149 0.401 0.24 0.65 0.24 0.552 0 1-0.448 1-1 0-0.249-0.091-0.477-0.242-0.652l0.001 0.001-6.18-6.18 1.32-1.32c0.481 0.399 1.105 0.64 1.786 0.64 0.775 0 1.476-0.313 1.984-0.82l-0 0z"
  })),
  "mdsIcon-category--roadtrips": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--roadtrips",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.32,8.91a.36.36,0,0,0,.32-.2.37.37,0,0,0-.05-.37L19,6.44l1.64-1.89a.38.38,0,0,0,.05-.37.36.36,0,0,0-.32-.2H13V2.54a.35.35,0,0,0-.34-.35H11.05a.35.35,0,0,0-.34.35V4H6.3a.33.33,0,0,0-.21.07L3.22,6.16a.35.35,0,0,0-.14.28.34.34,0,0,0,.14.28L6.09,8.84a.4.4,0,0,0,.21.07h4.41v1.22H3.42a.35.35,0,0,0-.31.2.34.34,0,0,0,.05.37L4.8,12.59l-1.64,1.9a.33.33,0,0,0-.05.37.35.35,0,0,0,.31.2h7.29v6.78a.34.34,0,0,0,.28.34H12.7a.34.34,0,0,0,.34-.35V15.06h4.41a.31.31,0,0,0,.2-.07l2.88-2.12a.34.34,0,0,0,.14-.28.32.32,0,0,0-.14-.27L17.65,10.2a.31.31,0,0,0-.2-.07H13V8.91Z",
    vectorEffect: "non-scaling-stroke"
  })),
  "mdsIcon-category--things-to-do": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--things-to-do",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22 8.54v-2.54c0-1.105-0.895-2-2-2v0h-16c-1.105 0-2 0.895-2 2v0 2.54c-0 0.008-0 0.019-0 0.029 0 0.716 0.401 1.339 0.99 1.657l0.010 0.005c0.602 0.352 1 0.996 1 1.732 0 0.013-0 0.027-0 0.040l0-0.002c-0.002 0.758-0.426 1.417-1.049 1.755l-0.011 0.005c-0.567 0.343-0.94 0.956-0.94 1.657 0 0.015 0 0.030 0.001 0.045l-0-0.002v2.54c0 1.105 0.895 2 2 2v0h16c1.105 0 2-0.895 2-2v0-2.54c0-0.013 0-0.028 0-0.043 0-0.701-0.373-1.314-0.932-1.652l-0.009-0.005c-0.63-0.345-1.050-1.003-1.050-1.76s0.42-1.415 1.040-1.755l0.010-0.005c0.567-0.343 0.94-0.956 0.94-1.657 0-0.015-0-0.030-0.001-0.045l0 0.002zM13 17.54h-2v-2h2zM13 13h-2v-2h2zM13 8.5h-2v-2h2z"
  })),
  "mdsIcon-clock": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "clock",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0zM11.78 7h-0.060c-0.398 0-0.72 0.322-0.72 0.72v0 4.72c0 0.364 0.195 0.683 0.485 0.857l0.005 0.003 4.15 2.49c0.12 0.092 0.272 0.148 0.437 0.148 0.398 0 0.72-0.322 0.72-0.72 0-0.291-0.173-0.542-0.422-0.656l-0.005-0.002-3.87-2.3v-4.54c0-0.398-0.322-0.72-0.72-0.72v0z"
  })),
  "mdsIcon-compare": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "compare",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.25,13.59H3.07a1,1,0,1,0,0,2.05H9.25v1.84a.51.51,0,0,0,.87.36L13,15a.53.53,0,0,0,0-.74l-2.86-2.86a.51.51,0,0,0-.87.36Zm6.15-2.28V9.47h6.18a1,1,0,1,0,0-2.05H15.4V5.58a.51.51,0,0,0-.87-.36L11.67,8.09a.52.52,0,0,0,0,.73l2.86,2.86A.51.51,0,0,0,15.4,11.31Z"
  })),
  "mdsIcon-compass": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "compass",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 10.9c-0.608 0-1.1 0.492-1.1 1.1s0.492 1.1 1.1 1.1c0.608 0 1.1-0.492 1.1-1.1v0c0-0.608-0.492-1.1-1.1-1.1v0zM12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM14.19 14.19l-8.19 3.81 3.81-8.19 8.19-3.81z"
  })),
  "mdsIcon-directions": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "directions",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.71 11.29l-9-9c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l-9 9c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l9 9c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l9-9c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0zM14 14.5v-2.5h-4v3h-2v-4c0-0.552 0.448-1 1-1v0h5v-2.5l3.5 3.5z"
  })),
  "mdsIcon-discounts": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "discounts",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10.47,9.15a1.07,1.07,0,0,0,.32.86,2.42,2.42,0,0,0,.79.45V7.84a2.23,2.23,0,0,0-.77.41A1.13,1.13,0,0,0,10.47,9.15Zm2.34,3.6v3.08a2,2,0,0,0,1-.54,1.48,1.48,0,0,0,.4-1,1.24,1.24,0,0,0-.39-1A3.15,3.15,0,0,0,12.81,12.75Zm6.46-7.7a10,10,0,1,0,0,14.14A10,10,0,0,0,19.27,5.05ZM15.61,15.57a3,3,0,0,1-1.14,1.17,4,4,0,0,1-1.66.52v1.66a.62.62,0,1,1-1.23,0V17.27a4.41,4.41,0,0,1-1.3-.37,3.37,3.37,0,0,1-1.06-.75,3.41,3.41,0,0,1-.63-.95,2.54,2.54,0,0,1-.2-1,.86.86,0,0,1,.27-.62.9.9,0,0,1,.68-.28,1,1,0,0,1,.55.15.77.77,0,0,1,.31.43,8.85,8.85,0,0,0,.34.91,1.69,1.69,0,0,0,.44.57,1.8,1.8,0,0,0,.6.33V12.37a7.81,7.81,0,0,1-1.44-.54,2.67,2.67,0,0,1-1.06-.94,2.74,2.74,0,0,1-.41-1.56,2.84,2.84,0,0,1,.79-2,3.54,3.54,0,0,1,2.12-.9V5.31a.62.62,0,0,1,1.23,0V6.38a4.4,4.4,0,0,1,1.2.29,2.73,2.73,0,0,1,1,.73,3.11,3.11,0,0,1,.5.76,1.73,1.73,0,0,1,.18.72.86.86,0,0,1-.27.63.88.88,0,0,1-.64.26A.91.91,0,0,1,13.83,9a1.6,1.6,0,0,0-1-1.14v3c.53.15,1,.29,1.3.41a2.92,2.92,0,0,1,1,.59,2.73,2.73,0,0,1,.7,1A3.05,3.05,0,0,1,16,14,3.21,3.21,0,0,1,15.61,15.57Z"
  })),
  "mdsIcon-editor-notes": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "editor-notes",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.15,2.52h-16a2,2,0,0,0-2,2v18l4-4h14a2,2,0,0,0,2-2v-12A2,2,0,0,0,20.15,2.52Zm-12,12h-2v-2h2Zm0-3h-2v-2h2Zm0-3h-2v-2h2Zm6,6h-3a1,1,0,0,1,0-2h3a1,1,0,1,1,0,2Zm3-3h-6a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Zm0-3h-6a1,1,0,0,1,0-2h6a1,1,0,0,1,0,2Z"
  })),
  "mdsIcon-gas-station": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "gas-station",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.77 8.23v0l-3.18-3.23c-0.134-0.125-0.314-0.201-0.511-0.201-0.414 0-0.75 0.336-0.75 0.75 0 0.198 0.077 0.378 0.202 0.512l-0-0 1.58 1.58c-0.949 0.366-1.609 1.27-1.609 2.329 0 0.134 0.011 0.266 0.031 0.395l-0.002-0.014c0.187 1.112 1.076 1.969 2.188 2.109l0.012 0.001c0.081 0.009 0.174 0.015 0.269 0.015 0.363 0 0.707-0.079 1.016-0.221l-0.015 0.006v7.24c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-4.5c0-1.105-0.895-2-2-2v0h-1v-9c0-1.105-0.895-2-2-2v0h-8c-1.105 0-2 0.895-2 2v0 17c0 0.552 0.448 1 1 1v0h10c0.552 0 1-0.448 1-1v0-6.5h1.5v4.86c-0.001 0.019-0.001 0.042-0.001 0.065 0 1.309 0.968 2.392 2.227 2.573l0.014 0.002c0.078 0.009 0.168 0.014 0.26 0.014 1.381 0 2.5-1.119 2.5-2.5 0-0.005-0-0.010-0-0.014v0.001-9.5c0-0.001 0-0.003 0-0.004 0-0.689-0.279-1.313-0.73-1.766l0 0zM13 9.25h-8v-4.25c0-0.552 0.448-1 1-1v0h6c0.552 0 1 0.448 1 1v0zM19 11c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1v0c0 0.552-0.448 1-1 1v0z"
  })),
  "mdsIcon-category--fuel": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "category--fuel",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.77 8.23v0l-3.18-3.23c-0.134-0.125-0.314-0.201-0.511-0.201-0.414 0-0.75 0.336-0.75 0.75 0 0.198 0.077 0.378 0.202 0.512l-0-0 1.58 1.58c-0.949 0.366-1.609 1.27-1.609 2.329 0 0.134 0.011 0.266 0.031 0.395l-0.002-0.014c0.187 1.112 1.076 1.969 2.188 2.109l0.012 0.001c0.081 0.009 0.174 0.015 0.269 0.015 0.363 0 0.707-0.079 1.016-0.221l-0.015 0.006v7.24c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-4.5c0-1.105-0.895-2-2-2v0h-1v-9c0-1.105-0.895-2-2-2v0h-8c-1.105 0-2 0.895-2 2v0 17c0 0.552 0.448 1 1 1v0h10c0.552 0 1-0.448 1-1v0-6.5h1.5v4.86c-0.001 0.019-0.001 0.042-0.001 0.065 0 1.309 0.968 2.392 2.227 2.573l0.014 0.002c0.078 0.009 0.168 0.014 0.26 0.014 1.381 0 2.5-1.119 2.5-2.5 0-0.005-0-0.010-0-0.014v0.001-9.5c0-0.001 0-0.003 0-0.004 0-0.689-0.279-1.313-0.73-1.766l0 0zM13 9.25h-8v-4.25c0-0.552 0.448-1 1-1v0h6c0.552 0 1 0.448 1 1v0zM19 11c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1v0c0 0.552-0.448 1-1 1v0z"
  })),
  "mdsIcon-groups": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "groups",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.53,11.13a3.5,3.5,0,1,0-3.06,0c-2.85.48-5,2.25-5,4.37V19h13V15.5C18.5,13.38,16.38,11.61,13.53,11.13Zm-5.72-.19a5.29,5.29,0,0,0-1.26-.36,2.42,2.42,0,1,0-2.1,0c-2,.33-3.45,1.55-3.45,3V16H4.5V15.5A5.32,5.32,0,0,1,7.81,10.94Zm11.74-.36a2.42,2.42,0,1,0-2.1,0,5.29,5.29,0,0,0-1.26.36A5.32,5.32,0,0,1,19.5,15.5V16H23V13.6C23,12.13,21.53,10.91,19.55,10.58Z"
  })),
  "mdsIcon-heart--outline": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "heart--outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.5 5c0.009-0 0.020-0 0.030-0 1.916 0 3.47 1.554 3.47 3.47 0 0.011-0 0.021-0 0.032v-0.002c0 2.89-3.13 5.73-7.86 10v0l-0.1 0.090-0.13-0.11c-4.77-4.25-7.91-7.090-7.91-9.98-0-0.009-0-0.020-0-0.030 0-1.916 1.554-3.47 3.47-3.47 0.011 0 0.021 0 0.032 0h-0.002c1.198 0.010 2.269 0.544 2.996 1.385l1.504 1.785 1.52-1.78c0.727-0.841 1.79-1.374 2.977-1.39l0.003-0zM16.5 3c-1.797 0.016-3.404 0.82-4.493 2.082l-0.007 0.008c-1.096-1.27-2.703-2.074-4.497-2.090l-0.003-0c-0.015-0-0.033-0-0.050-0-3.010 0-5.45 2.44-5.45 5.45 0 0.018 0 0.035 0 0.053l-0-0.003c0 3.78 3.4 6.86 8.55 11.5l1.45 1.35 1.45-1.35c5.15-4.64 8.55-7.72 8.55-11.5 0-0.015 0-0.033 0-0.050 0-3.010-2.44-5.45-5.45-5.45-0.018 0-0.035 0-0.053 0l0.003-0z"
  })),
  "mdsIcon-heart--solid": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "heart--solid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 21.35l-1.45-1.35c-5.15-4.64-8.55-7.72-8.55-11.5-0-0.015-0-0.033-0-0.050 0-3.010 2.44-5.45 5.45-5.45 0.018 0 0.035 0 0.053 0l-0.003-0c1.797 0.016 3.404 0.82 4.493 2.082l0.007 0.008c1.096-1.27 2.703-2.074 4.497-2.090l0.003-0c0.015-0 0.033-0 0.050-0 3.010 0 5.45 2.44 5.45 5.45 0 0.018-0 0.035-0 0.053l0-0.003c0 3.78-3.4 6.86-8.55 11.54z"
  })),
  "mdsIcon-home": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "home",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 19v-5h4v5c0 0.552 0.448 1 1 1v0h3c0.552 0 1-0.448 1-1v0-7h1.7c0.273-0.004 0.494-0.226 0.494-0.5 0-0.146-0.063-0.278-0.163-0.37l-0-0-8.36-7.53c-0.177-0.16-0.412-0.258-0.67-0.258s-0.493 0.098-0.671 0.258l0.001-0.001-8.33 7.53c-0.102 0.092-0.165 0.224-0.165 0.371 0 0.264 0.204 0.48 0.463 0.499l0.002 0h1.7v7c0 0.552 0.448 1 1 1v0h3c0.552 0 1-0.448 1-1v0z"
  })),
  "mdsIcon-itinerary": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "itinerary",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19,3H14.82A3,3,0,0,0,9.18,3H5A2,2,0,0,0,3,5V21a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2V5A2,2,0,0,0,19,3ZM12,3a1,1,0,1,1-1,1A1,1,0,0,1,12,3Zm6,18H6a1,1,0,0,1-1-1V6A1,1,0,0,1,6,5H7V6A2,2,0,0,0,9,8h6a2,2,0,0,0,2-2V5h1a1,1,0,0,1,1,1V20A1,1,0,0,1,18,21Z"
  })),
  "mdsIcon-theme-park": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "theme-park",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M22,12a1.81,1.81,0,0,0-1.07-1.65,9,9,0,0,0-1.44-3.5,1.82,1.82,0,0,0-2.34-2.34,9,9,0,0,0-3.5-1.44,1.81,1.81,0,0,0-3.3,0,9,9,0,0,0-3.5,1.44A1.82,1.82,0,0,0,4.51,6.85a9,9,0,0,0-1.44,3.5,1.81,1.81,0,0,0,0,3.31,8.93,8.93,0,0,0,1.44,3.48,1.81,1.81,0,0,0,2.35,2.34,8.46,8.46,0,0,0,1.34.77l-.57,1.69L9.82,22l.33-1.1a9.1,9.1,0,0,0,3.7,0l.33,1.1,2.18-.06-.57-1.69a8.46,8.46,0,0,0,1.34-.77,1.81,1.81,0,0,0,2.35-2.34,8.93,8.93,0,0,0,1.44-3.48A1.82,1.82,0,0,0,22,12ZM12,19a6.36,6.36,0,0,1-1.24-.12L12,14.77l1.24,4.11A6.36,6.36,0,0,1,12,19Zm3.13-.74-1.71-5.14a1.76,1.76,0,0,0,.4-1.12,1.82,1.82,0,0,0-3.64,0,1.76,1.76,0,0,0,.4,1.12L8.87,18.26a7,7,0,1,1,6.26,0Z"
  })),
  "mdsIcon-library--photos": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "library--photos",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.24 15.88v-11.33c0-1.044-0.846-1.89-1.89-1.89v0h-11.35c-1.031 0.017-1.86 0.857-1.86 1.89 0 0 0 0 0 0v-0 11.33c0.005 1.029 0.833 1.863 1.858 1.88l0.002 0h11.35c0 0 0 0 0 0 1.040 0 1.884-0.84 1.89-1.879v-0.001zM11.24 12.6l1.54 2.060 2.44-3c0.085-0.11 0.217-0.18 0.365-0.18s0.28 0.070 0.364 0.179l0.001 0.001 2.8 3.49c0.061 0.080 0.098 0.181 0.098 0.29 0 0.261-0.208 0.473-0.467 0.48l-0.001 0h-9.38c-0.003 0-0.007 0-0.010 0-0.26 0-0.47-0.21-0.47-0.47 0-0.11 0.038-0.211 0.101-0.291l-0.001 0.001 1.89-2.52c0.087-0.115 0.223-0.189 0.377-0.189 0.135 0 0.257 0.057 0.343 0.149l0 0zM2.36 7.38v12.27c0 1.044 0.846 1.89 1.89 1.89v0h12.27c0.481-0.051 0.853-0.455 0.853-0.945s-0.372-0.894-0.849-0.945l-0.004-0h-11.33c-0.519 0-0.94-0.421-0.94-0.94v-11.33c-0.051-0.481-0.455-0.853-0.945-0.853s-0.894 0.372-0.945 0.849l-0 0.004z"
  })),
  "mdsIcon-library--videos": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "library--videos",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.52 19.65h-11.33c-0.519 0-0.94-0.421-0.94-0.94v-11.33c-0.051-0.481-0.455-0.853-0.945-0.853s-0.894 0.372-0.945 0.849l-0 0.004v12.27c0 1.044 0.846 1.89 1.89 1.89v0h12.27c0.481-0.051 0.853-0.455 0.853-0.945s-0.372-0.894-0.849-0.945l-0.004-0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.35 2.66h-11.35c-1.031 0.017-1.86 0.856-1.86 1.89 0 0 0 0 0 0v-0 11.33c0.005 1.029 0.833 1.863 1.858 1.88l0.002 0h11.35c0 0 0 0 0 0 1.040 0 1.884-0.84 1.89-1.879v-11.331c0-1.044-0.846-1.89-1.89-1.89v0zM11 15v-9l6 4.5z"
  })),
  "mdsIcon-location--add": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "location--add",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 7c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 2h-2c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h2v2c0 0.552 0.448 1 1 1s1-0.448 1-1v0-2h2c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-2zM12 2c0.001 0 0.002 0 0.003 0 4.418 0 8 3.582 8 8 0 0.070-0.001 0.14-0.003 0.21l0-0.010q0 4.8-7.34 11.23c-0.176 0.157-0.409 0.253-0.665 0.253s-0.489-0.096-0.666-0.254l0.001 0.001q-7.33-6.43-7.33-11.23c-0.002-0.060-0.003-0.13-0.003-0.2 0-4.418 3.582-8 8-8 0.001 0 0.002 0 0.003 0h-0z"
  })),
  "mdsIcon-location--edit": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "location--edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.33 1.75l1-1c0.181-0.18 0.43-0.291 0.705-0.291s0.524 0.111 0.705 0.291l0.71 0.71c0.18 0.181 0.291 0.43 0.291 0.705s-0.111 0.524-0.291 0.705l-1 1zM17.33 2.75l2.12 2.12-6 6c-0.086 0.092-0.208 0.15-0.344 0.15-0.002 0-0.004-0-0.006-0h-1.38c-0.276 0-0.5-0.224-0.5-0.5v0-1.44c-0-0.002-0-0.004-0-0.006 0-0.136 0.058-0.258 0.15-0.344l0-0zM15.33 2.62l-5.33 5.38c-0.179 0.181-0.29 0.43-0.29 0.704 0 0.002 0 0.004 0 0.006v-0 2.79c0 0.552 0.448 1 1 1v0h2.83c0.002 0 0.004 0 0.006 0 0.275 0 0.524-0.111 0.704-0.29l5.33-5.33c0.399 0.963 0.63 2.081 0.63 3.253 0 0.020-0 0.040-0 0.060l0-0.003q0 4.77-7.34 11.23c-0.176 0.157-0.409 0.253-0.665 0.253s-0.489-0.096-0.666-0.254l0.001 0.001q-7.31-6.42-7.32-11.23c-0.002-0.060-0.003-0.13-0.003-0.2 0-4.418 3.582-8 8-8 0.001 0 0.002 0 0.003 0h-0c0.002 0 0.004 0 0.006 0 1.128 0 2.202 0.232 3.176 0.65l-0.052-0.020z"
  })),
  "mdsIcon-location--outline": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "location--outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.19 10c0 2.209-1.791 4-4 4s-4-1.791-4-4c0-2.209 1.791-4 4-4s4 1.791 4 4z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.19 2c-0.003 0-0.007 0-0.010 0-4.358 0-7.893 3.524-7.91 7.878v0.002c0 2.82 1.34 5.79 3.86 8.58 0.681 0.745 1.389 1.432 2.137 2.073l0.033 0.027c0.39 0.37 0.79 0.75 1.23 1.13 0.176 0.157 0.409 0.253 0.665 0.253s0.489-0.096 0.666-0.254l-0.001 0.001c0.45-0.4 0.87-0.79 1.28-1.18 0.759-0.651 1.448-1.321 2.093-2.031l0.017-0.019c2.52-2.79 3.86-5.76 3.86-8.58-0.017-4.356-3.552-7.88-7.91-7.88-0.004 0-0.007 0-0.011 0h0.001zM15.33 16.74c-0.89 0.977-1.873 1.843-2.943 2.592l-0.057 0.038-0.18 0.12-0.15-0.12c-1.127-0.787-2.11-1.653-2.987-2.616l-0.013-0.014c-1.732-1.705-2.851-4.029-2.999-6.613l-0.001-0.027c0-3.386 2.744-6.13 6.13-6.13s6.13 2.744 6.13 6.13v0c-0.129 2.602-1.224 4.926-2.93 6.64l0-0z"
  })),
  "mdsIcon-location--solid": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "location--solid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-0.001 0-0.002 0-0.003 0-4.418 0-8 3.582-8 8 0 0.070 0.001 0.14 0.003 0.21l-0-0.010q0 4.8 7.33 11.23c0.176 0.157 0.409 0.253 0.665 0.253s0.489-0.096 0.666-0.254l-0.001 0.001q7.34-6.43 7.34-11.23c0.002-0.060 0.003-0.13 0.003-0.2 0-4.418-3.582-8-8-8-0.001 0-0.002 0-0.003 0h0zM12 14c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.485 0 4.5 2.015 4.5 4.5v0c0 0.003 0 0.006 0 0.010 0 2.48-2.010 4.49-4.49 4.49-0.004 0-0.007 0-0.011-0h0.001z"
  })),
  "mdsIcon-luggage": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "luggage",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17 6.49h-2v-3c0-0.552-0.448-1-1-1v0h-4c-0.552 0-1 0.448-1 1v0 3h-2c-1.105 0-2 0.895-2 2v0 11c0 1.105 0.895 2 2 2v0c0 0.552 0.448 1 1 1s1-0.448 1-1v0h6c0 0.552 0.448 1 1 1s1-0.448 1-1v0c1.105 0 2-0.895 2-2v0-11c0-1.105-0.895-2-2-2v0zM8.75 18.49v0c-0.412-0.006-0.744-0.338-0.75-0.749v-7.501c0.006-0.412 0.338-0.744 0.749-0.75h0.001c0.412 0.006 0.744 0.338 0.75 0.749v7.501c-0.005 0.402-0.321 0.728-0.718 0.75l-0.002 0zM12 18.49v0c-0.412-0.006-0.744-0.338-0.75-0.749v-7.501c0.006-0.412 0.338-0.744 0.749-0.75h0.001c0.412 0.006 0.744 0.338 0.75 0.749v7.501c-0.006 0.412-0.338 0.744-0.749 0.75h-0.001zM13.5 6.49h-3v-2.49h3zM15.25 18.49v0c-0.412-0.006-0.744-0.338-0.75-0.749v-7.501c0.006-0.412 0.338-0.744 0.749-0.75h0.001c0.412 0.006 0.744 0.338 0.75 0.749v7.501c-0.005 0.402-0.321 0.728-0.718 0.75l-0.002 0z"
  })),
  "mdsIcon-map": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "map",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.5,3.23l-.16,0L15,5.33,9,3.23,3.36,5.13A.5.5,0,0,0,3,5.61V20.73a.5.5,0,0,0,.5.5l.16,0L9,19.13l6,2.1,5.64-1.9a.5.5,0,0,0,.36-.48V3.73A.5.5,0,0,0,20.5,3.23Zm-5.5,16L9,17.12V5.23l6,2.11Z"
  })),
  "mdsIcon-notification": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "notification",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.69 21.87c1.105 0 2-0.895 2-2v0h-4c0 1.105 0.895 2 2 2v0zM17.69 15.87v-5c0-3.070-1.64-5.64-4.5-6.32v-0.68c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0 0.68c-2.87 0.68-4.5 3.24-4.5 6.32v5l-1.29 1.29c-0.183 0.181-0.296 0.432-0.296 0.71 0 0.551 0.445 0.998 0.996 1h13.17c0.008 0 0.017 0 0.026 0 0.552 0 1-0.448 1-1 0-0.278-0.113-0.529-0.296-0.71l-0-0z"
  })),
  "mdsIcon-offers": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "offers",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.41,11.58l-9-9A2,2,0,0,0,11,2H4A2,2,0,0,0,2,4v7a2,2,0,0,0,.59,1.42l9,9A2,2,0,0,0,13,22a2,2,0,0,0,1.41-.59l7-7A2,2,0,0,0,22,13,2,2,0,0,0,21.41,11.58ZM5.5,7A1.5,1.5,0,1,1,7,5.5,1.5,1.5,0,0,1,5.5,7Z"
  })),
  "mdsIcon-overview": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "overview",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    d: "M12,4A11.83,11.83,0,0,0,1,11.5a11.82,11.82,0,0,0,22,0A11.83,11.83,0,0,0,12,4Zm0,12.5a5,5,0,1,1,5-5A5,5,0,0,1,12,16.5Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,12,8.5Z"
  })),
  "mdsIcon-package": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "package",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.59 6.39h-2.18c0.099-0.286 0.157-0.615 0.157-0.957 0-1.657-1.343-3-3-3-1.024 0-1.929 0.514-2.47 1.297l-0.007 0.010-0.5 0.67-0.5-0.68c-0.547-0.799-1.455-1.317-2.484-1.317-1.657 0-3 1.343-3 3 0 0.35 0.060 0.686 0.17 0.998l-0.006-0.021h-2.18c-1.105 0-2 0.895-2 2v0 11c0 1.105 0.895 2 2 2v0h16c1.105 0 2-0.895 2-2v0-11c0-1.105-0.895-2-2-2v0zM14.59 4.39c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1v0zM8.59 4.39c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1v0zM18.59 19.39h-14c-0.552 0-1-0.448-1-1v0-1h16v1c0 0.552-0.448 1-1 1v0zM19.59 14.39h-16v-5c0-0.552 0.448-1 1-1v0h4.080l-1.48 2c-0.124 0.165-0.199 0.374-0.199 0.6 0 0.555 0.45 1.004 1.004 1.004 0.328 0 0.62-0.158 0.803-0.401l0.002-0.003 2.79-3.8 2.79 3.8c0.184 0.251 0.478 0.412 0.81 0.412 0.553 0 1.002-0.449 1.002-1.002 0-0.222-0.072-0.427-0.194-0.593l0.002 0.003-1.48-2h4.080c0.552 0 1 0.448 1 1v0z"
  })),
  "mdsIcon-pin": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "pin",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.2 12.84c0-0.006 0-0.013 0-0.020 0-0.482-0.34-0.884-0.794-0.979l-0.007-0.001c-1.262-0.357-2.176-1.489-2.2-2.837l-0-0.003v-5h1c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-10c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h1v5c-0.015 1.359-0.931 2.501-2.179 2.855l-0.021 0.005c-0.46 0.096-0.8 0.498-0.8 0.98 0 0.007 0 0.014 0 0.021l-0-0.001v0.14c0 0.552 0.448 1 1 1v0h5v7c0 0.552 0.448 1 1 1s1-0.448 1-1v0-7h5c0.552 0 1-0.448 1-1v0z"
  })),
  "mdsIcon-plan": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "plan",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17,3H7A2,2,0,0,0,5,5V21l7-3,7,3V5A2,2,0,0,0,17,3Z"
  })),
  "mdsIcon-roadtrip-add": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "roadtrip-add",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.83 18v-2c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 2h-2c-0.552 0-1 0.448-1 1v0 0c0 0.552 0.448 1 1 1v0h2v2c0 0.552 0.448 1 1 1v0 0c0.552 0 1-0.448 1-1v0-2h2c0.552 0 1-0.448 1-1v0 0c0-0.552-0.448-1-1-1v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.83 4v0c-0.552 0-1 0.448-1 1v0 7c0 0.552 0.448 1 1 1v0 0c0.552 0 1-0.448 1-1v0-7c0-0.552-0.448-1-1-1v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.83 20v0c0.552 0 1-0.448 1-1v0-14c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 14c0 0.552 0.448 1 1 1v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.83 8v0c0.552 0 1-0.448 1-1v0-2c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 2c0 0.552 0.448 1 1 1v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.83 14v0c0.552 0 1-0.448 1-1v0-2c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 2c0 0.552 0.448 1 1 1v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.83 20v0c0.552 0 1-0.448 1-1v0-2c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 2c0 0.552 0.448 1 1 1v0z"
  })),
  "mdsIcon-season--fall": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "season--fall",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.050 8.050c-1.261 1.266-2.041 3.012-2.041 4.94s0.78 3.674 2.041 4.94l-0-0c1.504-3.437 4.059-6.182 7.253-7.888l0.087-0.042c-2.748 2.34-4.684 5.56-5.374 9.221l-0.016 0.099c0.897 0.448 1.953 0.71 3.071 0.71 1.923 0 3.664-0.775 4.929-2.030l-0 0c3-3 3.83-11.14 4-13.38 0.013-0.042 0.021-0.090 0.021-0.14 0-0.271-0.219-0.49-0.49-0.49-0.036 0-0.070 0.004-0.104 0.011l0.003-0.001c-2.24 0.22-10.43 1.060-13.38 4.050z"
  })),
  "mdsIcon-season--spring": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "season--spring",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 22c0 0 0 0 0 0 4.547 0 8.307-3.373 8.914-7.753l0.005-0.047c0.005-0.039 0.008-0.083 0.008-0.128 0-0.552-0.448-1-1-1-0.045 0-0.090 0.003-0.133 0.009l0.005-0.001c-4.427 0.613-7.8 4.372-7.8 8.92 0 0 0 0 0 0v-0zM5.6 10.25c0 0.001 0 0.002 0 0.002 0 1.381 1.119 2.5 2.5 2.5 0.531 0 1.023-0.166 1.428-0.448l-0.008 0.005v0.19c0 1.381 1.119 2.5 2.5 2.5s2.5-1.119 2.5-2.5v0-0.19c0.392 0.275 0.879 0.44 1.404 0.44 0.006 0 0.011-0 0.017-0h-0.001c0.004 0 0.010 0 0.015 0 1.375 0 2.49-1.115 2.49-2.49 0-0.996-0.585-1.855-1.43-2.254l-0.015-0.006c0.869-0.404 1.46-1.27 1.46-2.273 0-1.381-1.119-2.5-2.5-2.5-0.544 0-1.047 0.174-1.457 0.468l0.007-0.005v-0.19c0-1.381-1.119-2.5-2.5-2.5s-2.5 1.119-2.5 2.5v0 0.19c-0.392-0.275-0.879-0.44-1.404-0.44-0.002 0-0.004 0-0.006 0h0c-0.017-0-0.036-0.001-0.056-0.001-1.375 0-2.49 1.115-2.49 2.49 0 0.996 0.585 1.856 1.431 2.254l0.015 0.006c-0.836 0.414-1.4 1.26-1.4 2.239 0 0.004 0 0.008 0 0.012v-0.001zM12 5.5c1.381 0 2.5 1.119 2.5 2.5s-1.119 2.5-2.5 2.5c-1.381 0-2.5-1.119-2.5-2.5v0c0-1.381 1.119-2.5 2.5-2.5v0zM3.080 14.2c0.613 4.427 4.372 7.8 8.92 7.8 0 0 0 0 0 0h-0c0-0 0-0 0-0 0-4.547-3.373-8.307-7.753-8.914l-0.047-0.005c-0.039-0.005-0.083-0.008-0.128-0.008-0.552 0-1 0.448-1 1 0 0.045 0.003 0.090 0.009 0.133l-0.001-0.005z"
  })),
  "mdsIcon-season--summer": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "season--summer",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.8 4.12l-0.39-0.39c-0.18-0.177-0.427-0.286-0.7-0.286s-0.52 0.109-0.7 0.286l0-0h-0.010c-0.177 0.18-0.286 0.427-0.286 0.7s0.109 0.52 0.286 0.7l0.39 0.39c0.18 0.177 0.427 0.286 0.7 0.286s0.52-0.109 0.7-0.286l-0 0c0.18-0.181 0.291-0.43 0.291-0.705 0-0.27-0.107-0.515-0.281-0.695l0 0zM2.8 10.48h-1c-0.552 0-1 0.448-1 1v0 0c0 0.552 0.448 1 1 1v0h1c0.552 0 1-0.448 1-1v0 0c0-0 0-0.001 0-0.001 0-0.552-0.448-1-1-1-0.014 0-0.028 0-0.042 0.001l0.002-0zM11.8 0.48v0c-0.552 0-1 0.448-1 1v0 1c0 0.552 0.448 1 1 1v0 0c0.552 0 1-0.448 1-1v0-1c-0.027-0.531-0.464-0.951-0.999-0.951-0.014 0-0.029 0-0.043 0.001l0.002-0zM19.5 3.74c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l-0.39 0.39c-0.177 0.18-0.286 0.427-0.286 0.7s0.109 0.52 0.286 0.7l-0-0c0.18 0.177 0.427 0.286 0.7 0.286s0.52-0.109 0.7-0.286l0.39-0.39c0.18-0.181 0.291-0.43 0.291-0.705 0-0.27-0.107-0.515-0.281-0.695l0 0zM17.69 18.84l0.39 0.39c0.174 0.149 0.401 0.24 0.65 0.24 0.552 0 1-0.448 1-1 0-0.249-0.091-0.477-0.242-0.652l0.001 0.001-0.39-0.39c-0.174-0.149-0.401-0.24-0.65-0.24-0.552 0-1 0.448-1 1 0 0.249 0.091 0.477 0.242 0.652l-0.001-0.001zM19.75 11.47v0c0 0.552 0.448 1 1 1v0h1c0.552 0 1-0.448 1-1v0 0c0-0.552-0.448-1-1-1v0h-1c-0.552 0-1 0.448-1 1v0zM11.75 5.47c-3.314 0-6 2.686-6 6s2.686 6 6 6c3.314 0 6-2.686 6-6v0c-0.006-3.309-2.69-5.99-6-5.99 0 0 0 0 0 0v0zM11.75 22.47v0c0.552 0 1-0.448 1-1v0-1c0-0.552-0.448-1-1-1v0 0c-0.552 0-1 0.448-1 1v0 1c0.022 0.532 0.456 0.955 0.99 0.96h0zM4 19.22c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l0.39-0.39c0.177-0.18 0.286-0.427 0.286-0.7s-0.109-0.52-0.286-0.7l0 0c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l0-0-0.39 0.38c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l-0-0z"
  })),
  "mdsIcon-season--winter": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "season--winter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21 11h-3.17l2.54-2.54c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0c-0.181-0.183-0.432-0.296-0.71-0.296s-0.529 0.113-0.71 0.296l-3.95 3.95h-2v-2l4-3.95c0.183-0.181 0.296-0.432 0.296-0.71s-0.113-0.529-0.296-0.71l-0-0c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l0-0-2.59 2.54v-3.17c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 3.17l-2.54-2.54c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l0-0c-0.183 0.181-0.296 0.432-0.296 0.71s0.113 0.529 0.296 0.71l4 4v2h-2.050l-3.95-4c-0.181-0.183-0.432-0.296-0.71-0.296s-0.529 0.113-0.71 0.296l-0 0c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l2.54 2.54h-3.17c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h3.17l-2.54 2.54c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l-0-0c0.181 0.183 0.432 0.296 0.71 0.296s0.529-0.113 0.71-0.296l3.95-3.95h2v2l-3.95 4c-0.183 0.181-0.296 0.432-0.296 0.71s0.113 0.529 0.296 0.71l0 0c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l-0 0 2.54-2.59v3.17c0 0.552 0.448 1 1 1s1-0.448 1-1v0-3.17l2.54 2.54c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l-0 0c0.184-0.181 0.297-0.433 0.297-0.712 0-0.253-0.094-0.484-0.248-0.66l0.001 0.001-4-4v-2h2l4 4c0.181 0.183 0.432 0.296 0.71 0.296s0.529-0.113 0.71-0.296l0-0c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l-2.59-2.59h3.17c0.552 0 1-0.448 1-1s-0.448-1-1-1v0z"
  })),
  "mdsIcon-seating": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "seating",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M5.5,21A1.5,1.5,0,0,0,7,19.5V18H17v1.5a1.5,1.5,0,0,0,3,0V17a2,2,0,0,0-2-2H6a2,2,0,0,0-2,2v2.5A1.5,1.5,0,0,0,5.5,21ZM20,10h1a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H20a1,1,0,0,1-1-1V11A1,1,0,0,1,20,10ZM3,10H4a1,1,0,0,1,1,1v1a1,1,0,0,1-1,1H3a1,1,0,0,1-1-1V11A1,1,0,0,1,3,10Zm14,3H7V5A2,2,0,0,1,9,3h6a2,2,0,0,1,2,2Z"
  })),
  "mdsIcon-transportation--air": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--air",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21.070 14.56c-0.005-0.371-0.197-0.697-0.486-0.887l-0.004-0.003-7.51-4.67v-5.52c0-0.828-0.672-1.5-1.5-1.5s-1.5 0.672-1.5 1.5v0 5.52l-7.51 4.67c-0.295 0.191-0.489 0.518-0.49 0.89v0c-0.001 0.020-0.002 0.044-0.002 0.068 0 0.552 0.448 1 1 1 0.13 0 0.255-0.025 0.369-0.070l-0.007 0.002 6.64-2.080v5.52l-1.8 1.35c-0.122 0.088-0.2 0.23-0.2 0.39 0 0.004 0 0.007 0 0.011v-0.001 0.59c0 0.276 0.224 0.5 0.5 0.5 0.050 0 0.098-0.007 0.144-0.021l-0.004 0.001 2.86-0.82 2.86 0.82c0.042 0.013 0.090 0.020 0.14 0.020 0.276 0 0.5-0.224 0.5-0.5v0-0.59c0-0.003 0-0.007 0-0.010 0-0.16-0.078-0.302-0.199-0.389l-0.001-0.001-1.8-1.35v-5.5l6.64 2.080c0.108 0.043 0.233 0.069 0.364 0.069 0.552 0 1-0.448 1-1 0-0.031-0.001-0.062-0.004-0.092l0 0.004z"
  })),
  "mdsIcon-transportation--bicycle": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--bicycle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.18 10l-1.7-4.68c-0.286-0.776-1.020-1.32-1.88-1.32h-1.6c-0.552 0-1 0.448-1 1v0 0c0 0.552 0.448 1 1 1v0h1.6l1.46 4h-4.81l-0.36-1h0.11c0.552 0 1-0.448 1-1v0 0c0-0.552-0.448-1-1-1v0h-3c-0.552 0-1 0.448-1 1v0 0c0 0.552 0.448 1 1 1v0h0.75l1.82 5h-0.67c-0.438-2.232-2.336-3.907-4.64-4l-0.010-0c-0.054-0.002-0.117-0.003-0.18-0.003-2.777 0-5.032 2.232-5.070 5l-0 0.004c0 2.761 2.239 5 5 5v0c0.017 0 0.038 0 0.058 0 2.394 0 4.389-1.706 4.836-3.969l0.005-0.031h4.2c0.438 2.232 2.336 3.907 4.64 4l0.010 0c0.051 0.002 0.111 0.003 0.171 0.003 2.778 0 5.036-2.231 5.079-4.999l0-0.004c0-2.761-2.239-5-5-5v0h-0.82zM7.82 16c-0.423 1.178-1.53 2.005-2.83 2.005-0.060 0-0.119-0.002-0.178-0.005l0.008 0c-1.532-0.093-2.749-1.324-2.82-2.853l-0-0.007c-0.002-0.042-0.003-0.091-0.003-0.14 0-1.657 1.343-3 3-3 0.001 0 0.002 0 0.003 0h-0c1.295 0.004 2.397 0.827 2.813 1.979l0.007 0.021h-1.82c-0.552 0-1 0.448-1 1v0 0c0 0.552 0.448 1 1 1v0zM14.1 14h-1.4l-0.7-2h3c-0.435 0.56-0.75 1.234-0.895 1.97l-0.005 0.030zM18.88 18c-1.578-0.065-2.838-1.338-2.88-2.916l-0-0.004c-0.001-0.024-0.001-0.051-0.001-0.079 0-0.911 0.406-1.727 1.047-2.277l0.004-0.003 0.62 1.7c0.144 0.388 0.51 0.659 0.94 0.659 0.141 0 0.275-0.029 0.396-0.082l-0.006 0.002c0.388-0.143 0.659-0.51 0.659-0.94 0-0.122-0.022-0.239-0.062-0.347l0.002 0.007-0.68-1.72c1.646 0.014 2.975 1.352 2.975 3 0 1.657-1.343 3-3 3-0.009 0-0.018-0-0.026-0h0.001z"
  })),
  "mdsIcon-transportation--bus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--bus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 16c0.005 0.881 0.389 1.672 0.997 2.218l0.003 0.002v1.78c0 0.552 0.448 1 1 1v0h1c0.552 0 1-0.448 1-1v0-1h8v1c0 0.552 0.448 1 1 1v0h1c0.552 0 1-0.448 1-1v0-1.78c0.611-0.548 0.995-1.339 1-2.219v-10.001c0-3.5-3.58-4-8-4s-8 0.5-8 4zM7.5 17c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c0 0.828-0.672 1.5-1.5 1.5v0zM16.5 17c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c0 0.828-0.672 1.5-1.5 1.5v0zM18 11h-12v-5h12z"
  })),
  "mdsIcon-transportation--car": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--car",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19 6.18c-0.209-0.587-0.76-1-1.407-1-0.005 0-0.009 0-0.014 0h-10.999c-0.002 0-0.004 0-0.006 0-0.649 0-1.202 0.412-1.411 0.99l-0.003 0.010-2 5.67c-0.069 0.197-0.109 0.424-0.11 0.66v7.16c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-0.5h12v0.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-7.16c-0.002-0.237-0.042-0.463-0.114-0.675l0.004 0.015zM6.58 16.18c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.006 0.824-0.675 1.49-1.5 1.49-0.004 0-0.007-0-0.011-0h0.001zM17.58 16.18c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.006 0.824-0.675 1.49-1.5 1.49-0.004 0-0.007-0-0.011-0h0.001zM5.080 11.18l1.26-3.83c0.137-0.399 0.51-0.681 0.948-0.681 0.018 0 0.037 0 0.055 0.001l-0.003-0h9.56c0.001 0 0.002 0 0.003 0 0.438 0 0.81 0.281 0.945 0.673l0.002 0.007 1.27 3.82z"
  })),
  "mdsIcon-transportation--electric-vehicle": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--electric-vehicle",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.66,4.8a1.49,1.49,0,0,0-1.42-1h-11a1.5,1.5,0,0,0-1.42,1l-2,5.67a2.08,2.08,0,0,0-.11.66v7.16a1.5,1.5,0,0,0,3,0v-.5h12v.5a1.5,1.5,0,0,0,3,0V11.13a2.12,2.12,0,0,0-.11-.66Zm-12.42,10a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,6.24,14.79Zm11,0a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,17.24,14.79Zm-6.08,1.29V14.54h-.69a.3.3,0,0,1-.26-.44l1.57-2.95a.3.3,0,0,1,.56.14v1.77H13a.3.3,0,0,1,.25.45l-1.55,2.72A.3.3,0,0,1,11.16,16.08ZM4.74,9.79,6,6a1,1,0,0,1,1-.68h9.56a1,1,0,0,1,.95.68l1.27,3.82Z"
  })),
  "mdsIcon-transportation--generic": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--generic",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 3.75h-7c-1.657 0-3 1.343-3 3v0 8c0 1.657 1.343 3 3 3v0l-0.77 0.77c-0.102 0.122-0.165 0.281-0.165 0.455 0 0.392 0.318 0.71 0.71 0.71 0.174 0 0.333-0.062 0.456-0.166l-0.001 0.001 1.77-1.77h2v-5h-4.48c-0.276 0-0.5-0.224-0.5-0.5v0-6c0-0.276 0.224-0.5 0.5-0.5v0h8c0.276 0 0.5 0.224 0.5 0.5v0 1.5h2v-1c0-0 0-0 0-0 0-1.657-1.343-3-3-3-0.007 0-0.014 0-0.021 0h0.001zM5 13.75c0.552 0 1 0.448 1 1s-0.448 1-1 1c-0.552 0-1-0.448-1-1v0c0-0.552 0.448-1 1-1v0zM20.59 9.41c-0.143-0.389-0.51-0.662-0.941-0.662-0.021 0-0.041 0.001-0.062 0.002l0.003-0h-7.16c-0.018-0.001-0.038-0.002-0.059-0.002-0.431 0-0.798 0.273-0.939 0.655l-0.002 0.007-1.43 4.11v5.24c0 0.552 0.448 1 1 1s1-0.448 1-1v0-1h8v1c0 0.552 0.448 1 1 1s1-0.448 1-1v0-5.24zM12.79 9.75h6.48c0.216 0.005 0.399 0.144 0.469 0.336l0.001 0.004 0.69 2c0.017 0.048 0.026 0.103 0.026 0.16 0 0.275-0.222 0.498-0.496 0.5h-7.85c-0.275-0.002-0.496-0.225-0.496-0.5 0-0.057 0.010-0.112 0.027-0.164l-0.001 0.004 0.69-2c0.058-0.198 0.238-0.34 0.452-0.34 0.003 0 0.006 0 0.009 0h-0zM12.020 15.75c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1v0c0 0 0 0 0 0 0 0.552-0.448 1-1 1-0.007 0-0.014-0-0.021-0l0.001 0zM20.020 15.75c-0.552 0-1-0.448-1-1s0.448-1 1-1c0.552 0 1 0.448 1 1v0c0 0 0 0 0 0 0 0.552-0.448 1-1 1-0.007 0-0.014-0-0.021-0l0.001 0z"
  })),
  "mdsIcon-transportation--rental": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--rental",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.14 4.8c0.315 0 0.57-0.255 0.57-0.57v0c-0.006-0.313-0.257-0.564-0.569-0.57h-0.571c0-0.315-0.255-0.57-0.57-0.57s-0.57 0.255-0.57 0.57v0h-0.57c-0.313 0.006-0.564 0.257-0.57 0.569v1.711c0 0.315 0.255 0.57 0.57 0.57v0h1.71v0.57h-1.71c-0.313 0.006-0.564 0.257-0.57 0.569v0.001c0 0.315 0.255 0.57 0.57 0.57v0h0.57c0 0.315 0.255 0.57 0.57 0.57s0.57-0.255 0.57-0.57v0h0.57c0.315 0 0.57-0.255 0.57-0.57v0-1.71c-0.006-0.313-0.257-0.564-0.569-0.57h-1.711v-0.57z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.9 11.68l-1-3c-0.34 0.428-0.773 0.768-1.269 0.991l-0.021 0.009 0.39 1.32h-14l1.28-3.82c0.137-0.399 0.51-0.681 0.948-0.681 0.018 0 0.037 0 0.055 0.001l-0.003-0h6.82c-0.038-0.151-0.073-0.342-0.097-0.535l-0.003-0.025c0-0.334 0.040-0.658 0.116-0.968l-0.006 0.028h-7.6c-0.002 0-0.004 0-0.006 0-0.649 0-1.202 0.412-1.411 0.99l-0.003 0.010-2 5.67c-0.069 0.197-0.109 0.424-0.11 0.66v7.17c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-0.5h12.020v0.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-7.16c0-0.005 0-0.011 0-0.016 0-0.23-0.037-0.451-0.104-0.659l0.004 0.015zM6.51 16c-0.003 0-0.006 0-0.010 0-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c0 0 0 0 0 0 0 0.825-0.666 1.494-1.489 1.5h-0.001zM17.51 16c-0.003 0-0.006 0-0.010 0-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c0 0 0 0 0 0 0 0.825-0.666 1.494-1.489 1.5h-0.001z"
  })),
  "mdsIcon-transportation--subway": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--subway",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.82,2.88A16.05,16.05,0,0,0,12,2.08a16,16,0,0,0-5.77.8,6.24,6.24,0,0,0-4.19,6V22H22V8.92A6.24,6.24,0,0,0,17.82,2.88ZM9.23,20l1.49-1.49h2.65L14.86,20ZM7.07,14v-5H17v5Zm9.46,2a1,1,0,1,1-1-1A1,1,0,0,1,16.53,16Zm-8-1a1,1,0,1,1-1,1A1,1,0,0,1,8.56,15ZM20,20H16.53v-.37l-1.15-1.16a3,3,0,0,0,2.64-3V9.06c0-2.62-3-3-6-3s-6,.37-6,3v6.47a3,3,0,0,0,2.64,3L7.56,19.64V20H4.07V8.92A4.24,4.24,0,0,1,7,4.73a14.53,14.53,0,0,1,5-.66,14.55,14.55,0,0,1,5.06.66A4.23,4.23,0,0,1,20,8.92Z"
  })),
  "mdsIcon-transportation--taxi": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--taxi",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.080 6.39c-0.209-0.587-0.76-1-1.407-1-0.005 0-0.009 0-0.014 0h-2.499v-1c0-0.552-0.448-1-1-1v0h-4c-0.552 0-1 0.448-1 1v0 1h-2.5c-0.002 0-0.004 0-0.006 0-0.649 0-1.202 0.412-1.411 0.99l-0.003 0.010-2 5.67c-0.069 0.197-0.109 0.424-0.11 0.66v7.16c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-0.5h12v0.5c0 0.828 0.672 1.5 1.5 1.5s1.5-0.672 1.5-1.5v0-7.16c-0.002-0.237-0.042-0.463-0.114-0.675l0.004 0.015zM6.66 16.39c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.006 0.824-0.675 1.49-1.5 1.49-0 0-0 0-0 0v0zM17.66 16.39c-0.828 0-1.5-0.672-1.5-1.5s0.672-1.5 1.5-1.5c0.828 0 1.5 0.672 1.5 1.5v0c-0.006 0.824-0.675 1.49-1.5 1.49-0 0-0 0-0 0v0zM5.16 11.39l1.5-4.5h11l1.5 4.5z"
  })),
  "mdsIcon-transportation--train": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--train",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12,2c-4,0-8,.5-8,4v9.47a3.48,3.48,0,0,0,3.49,3.48l-1.5,1.5v.5h2l2-2h4l2,2h2v-.5l-1.49-1.5A3.48,3.48,0,0,0,20,15.45V6C20,2.49,16,2,12,2ZM8.55,16a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,8.55,16ZM11,10h-5V7h5Zm4.49,6A1.5,1.5,0,1,1,17,14.45,1.5,1.5,0,0,1,15.53,16ZM18,10H13V7h5Z"
  })),
  "mdsIcon-transportation--tram": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--tram",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.5,2c-4.42,0-8,.5-8,4v9.5A3.5,3.5,0,0,0,7,19L5.85,20.15a.5.5,0,0,0,.36.85H16.8a.49.49,0,0,0,.35-.85L16,19a3.5,3.5,0,0,0,3.5-3.5V6C19.5,2.5,15.92,2,11.5,2ZM7,17a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,7,17Zm3.5-6h-5V6h5ZM16,17a1.5,1.5,0,1,1,1.5-1.5A1.5,1.5,0,0,1,16,17Zm1.5-6h-5V6h5Z"
  })),
  "mdsIcon-transportation--walking": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "transportation--walking",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13.5,5.5a2,2,0,1,0-2-2A2,2,0,0,0,13.5,5.5ZM9.8,8.9,7,23H9.1l1.8-8L13,17v6h2V15.5l-2.1-2,.6-3A7.32,7.32,0,0,0,19,13V11a4.92,4.92,0,0,1-4.3-2.4L13.7,7a2.15,2.15,0,0,0-2.65-.84L6,8.3V13H8V9.6Z"
  })),
  "mdsIcon-trending": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "trending",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.050 6.82l1.44 1.44-4.88 4.88-3.29-3.29c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l-6 6c-0.149 0.174-0.24 0.401-0.24 0.65 0 0.552 0.448 1 1 1 0.249 0 0.477-0.091 0.652-0.242l-0.001 0.001 5.29-5.26 3.29 3.29c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l-0 0 5.59-5.61 1.44 1.44c0.090 0.088 0.214 0.143 0.35 0.143 0.274 0 0.496-0.22 0.5-0.493v-4.3c-0.006-0.261-0.218-0.47-0.48-0.47-0.004 0-0.007 0-0.011 0h-4.289c-0.266 0.013-0.476 0.232-0.476 0.499 0 0.122 0.044 0.234 0.117 0.321l-0.001-0.001z"
  })),
  "mdsIcon-ui-arrange": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrange",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 5.83l2.46 2.46c0.174 0.149 0.401 0.24 0.65 0.24 0.552 0 1-0.448 1-1 0-0.249-0.091-0.477-0.242-0.652l0.001 0.001-3.17-3.18c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l0-0-3.17 3.18c-0.149 0.174-0.24 0.401-0.24 0.65 0 0.552 0.448 1 1 1 0.249 0 0.477-0.091 0.652-0.242l-0.001 0.001zM12 18.17l-2.46-2.46c-0.185-0.215-0.456-0.35-0.76-0.35-0.552 0-1 0.448-1 1 0 0.303 0.135 0.575 0.348 0.758l0.001 0.001 3.17 3.18c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l3.17-3.17c0.149-0.174 0.24-0.401 0.24-0.65 0-0.552-0.448-1-1-1-0.249 0-0.477 0.091-0.652 0.242l0.001-0.001z"
  })),
  "mdsIcon-ui-arrow-circle--up": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-circle--up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.74,2.05a10,10,0,1,0,10,10A10,10,0,0,0,11.74,2.05Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,11.74,20.05Z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.57,15.05l-3.88-3.88L7.81,15.05A1,1,0,0,1,6.4,13.64L11,9.05a1,1,0,0,1,1.41,0L17,13.64a1,1,0,0,1,0,1.41A1,1,0,0,1,15.57,15.05Z"
  })),
  "mdsIcon-ui-arrow-circle--down": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-circle--down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M8.27 8.94l3.88 3.88 3.85-3.88c0.174-0.149 0.401-0.24 0.65-0.24 0.552 0 1 0.448 1 1 0 0.249-0.091 0.477-0.242 0.652l0.001-0.001-4.59 4.59c-0.181 0.18-0.43 0.291-0.705 0.291s-0.524-0.111-0.705-0.291l0 0-4.56-4.59c-0.18-0.181-0.291-0.43-0.291-0.705s0.111-0.524 0.291-0.705l-0 0c0.181-0.183 0.432-0.296 0.71-0.296s0.529 0.113 0.71 0.296l0 0z"
  })),
  "mdsIcon-ui-arrow-circle--left": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-circle--left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.060 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12.060 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.58 7.69l-3.88 3.88 3.88 3.88c0.215 0.184 0.35 0.456 0.35 0.76 0 0.552-0.448 1-1 1-0.303 0-0.575-0.135-0.758-0.348l-0.001-0.001-4.59-4.59c-0.18-0.181-0.291-0.43-0.291-0.705s0.111-0.524 0.291-0.705l4.59-4.59c0.181-0.18 0.43-0.291 0.705-0.291s0.524 0.111 0.705 0.291l-0-0c0.183 0.181 0.296 0.432 0.296 0.71s-0.113 0.529-0.296 0.71l-0 0z"
  })),
  "mdsIcon-ui-arrow-circle--right": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-circle--right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0z"
  }), /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9.52 16.25l3.88-3.88-3.88-3.88c-0.149-0.174-0.24-0.401-0.24-0.65 0-0.552 0.448-1 1-1 0.249 0 0.477 0.091 0.652 0.242l-0.001-0.001 4.59 4.59c0.18 0.181 0.291 0.43 0.291 0.705s-0.111 0.524-0.291 0.705l-4.59 4.59c-0.181 0.18-0.43 0.291-0.705 0.291s-0.524-0.111-0.705-0.291l0 0c-0.183-0.181-0.296-0.432-0.296-0.71s0.113-0.529 0.296-0.71l0-0z"
  })),
  "mdsIcon-ui-arrow-long--down": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-long--down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 4.18v13.17l-2.88-2.88c-0.185-0.215-0.456-0.35-0.76-0.35-0.552 0-1 0.448-1 1 0 0.303 0.135 0.575 0.348 0.758l0.001 0.001 4.59 4.59c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l4.59-4.59c0.149-0.174 0.24-0.401 0.24-0.65 0-0.552-0.448-1-1-1-0.249 0-0.477 0.091-0.652 0.242l0.001-0.001-2.89 2.88v-13.17c0-0.552-0.448-1-1-1s-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-arrow-long--left": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-long--left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.43 11h-13.17l2.88-2.88c0.215-0.185 0.35-0.456 0.35-0.76 0-0.552-0.448-1-1-1-0.303 0-0.575 0.135-0.758 0.348l-0.001 0.001-4.59 4.59c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l4.59 4.59c0.174 0.149 0.401 0.24 0.65 0.24 0.552 0 1-0.448 1-1 0-0.249-0.091-0.477-0.242-0.652l0.001 0.001-2.88-2.89h13.17c0.552 0 1-0.448 1-1s-0.448-1-1-1v0z"
  })),
  "mdsIcon-ui-arrow-long--right": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-long--right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3.85 13h13.15l-2.88 2.88c-0.215 0.184-0.35 0.456-0.35 0.76 0 0.552 0.448 1 1 1 0.303 0 0.575-0.135 0.758-0.348l0.001-0.001 4.59-4.59c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0-4.57-4.59c-0.184-0.215-0.456-0.35-0.76-0.35-0.552 0-1 0.448-1 1 0 0.303 0.135 0.575 0.348 0.758l0.001 0.001 2.86 2.89h-13.15c-0.552 0-1 0.448-1 1s0.448 1 1 1v0z"
  })),
  "mdsIcon-ui-arrow-long--up": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-long--up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M13 19.76v-13.17l2.88 2.88c0.184 0.215 0.456 0.35 0.76 0.35 0.552 0 1-0.448 1-1 0-0.303-0.135-0.575-0.348-0.758l-0.001-0.001-4.59-4.59c-0.181-0.18-0.43-0.291-0.705-0.291s-0.524 0.111-0.705 0.291l-4.59 4.59c-0.215 0.185-0.35 0.456-0.35 0.76 0 0.552 0.448 1 1 1 0.303 0 0.575-0.135 0.758-0.348l0.001-0.001 2.89-2.88v13.17c0 0.552 0.448 1 1 1s1-0.448 1-1v0z"
  })),
  "mdsIcon-ui-arrow-short--down": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-short--down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.72 9l3.88 3.88 3.88-3.88c0.184-0.215 0.456-0.35 0.76-0.35 0.552 0 1 0.448 1 1 0 0.303-0.135 0.575-0.348 0.758l-0.001 0.001-4.59 4.59c-0.181 0.18-0.43 0.291-0.705 0.291s-0.524-0.111-0.705-0.291l0 0-4.59-4.62c-0.171-0.179-0.276-0.422-0.276-0.69s0.105-0.511 0.277-0.69l-0 0c0.181-0.183 0.432-0.296 0.71-0.296s0.529 0.113 0.71 0.296l0 0z"
  })),
  "mdsIcon-ui-arrow-short--left": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-short--left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 7.72l-3.85 3.88 3.85 3.88c0.215 0.184 0.35 0.456 0.35 0.76 0 0.552-0.448 1-1 1-0.303 0-0.575-0.135-0.758-0.348l-0.001-0.001-4.59-4.59c-0.18-0.181-0.291-0.43-0.291-0.705s0.111-0.524 0.291-0.705l-0 0 4.62-4.59c0.179-0.171 0.422-0.276 0.69-0.276s0.511 0.105 0.69 0.277l-0-0c0.183 0.181 0.296 0.432 0.296 0.71s-0.113 0.529-0.296 0.71l-0 0z"
  })),
  "mdsIcon-ui-arrow-short--right": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-short--right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 16.28l3.88-3.88-3.88-3.88c-0.215-0.184-0.35-0.456-0.35-0.76 0-0.552 0.448-1 1-1 0.303 0 0.575 0.135 0.758 0.348l0.001 0.001 4.59 4.59c0.18 0.181 0.291 0.43 0.291 0.705s-0.111 0.524-0.291 0.705l0-0-4.62 4.59c-0.179 0.171-0.422 0.276-0.69 0.276s-0.511-0.105-0.69-0.277l0 0c-0.183-0.181-0.296-0.432-0.296-0.71s0.113-0.529 0.296-0.71l0-0z"
  })),
  "mdsIcon-ui-arrow-short--up": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-short--up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.28 15l-3.88-3.85-3.88 3.85c-0.184 0.215-0.456 0.35-0.76 0.35-0.552 0-1-0.448-1-1 0-0.303 0.135-0.575 0.348-0.758l0.001-0.001 4.59-4.59c0.181-0.18 0.43-0.291 0.705-0.291s0.524 0.111 0.705 0.291l4.59 4.59c0.18 0.181 0.291 0.43 0.291 0.705s-0.111 0.524-0.291 0.705l0-0c-0.181 0.183-0.432 0.296-0.71 0.296s-0.529-0.113-0.71-0.296l-0-0z"
  })),
  "mdsIcon-ui-arrow-tall--down": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-tall--down",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M3,7A1.25,1.25,0,0,0,3,8.77l8.32,8.31a1,1,0,0,0,1.4,0L21,8.77A1.26,1.26,0,0,0,19.24,7L12,14.24,4.74,7A1.25,1.25,0,0,0,3,7Z"
  })),
  "mdsIcon-ui-arrow-tall--up": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-tall--up",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M21,17.17a1.25,1.25,0,0,0,0-1.77L12.68,7.09a1,1,0,0,0-1.41,0L3,15.4a1.25,1.25,0,0,0,1.77,1.77L12,9.93l7.25,7.25A1.25,1.25,0,0,0,21,17.17Z"
  })),
  "mdsIcon-ui-arrow-tall--left": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-tall--left",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.62 3c-0.226-0.227-0.539-0.367-0.885-0.367s-0.659 0.14-0.885 0.367l-0 0-8.31 8.3c-0.18 0.181-0.291 0.43-0.291 0.705s0.111 0.524 0.291 0.705l-0-0 8.31 8.29c0.226 0.227 0.539 0.367 0.885 0.367 0.691 0 1.252-0.56 1.252-1.252 0-0.346-0.14-0.659-0.367-0.885v0l-7.24-7.23 7.25-7.25c0.218-0.225 0.352-0.532 0.352-0.87 0-0.343-0.138-0.654-0.362-0.88l0 0z"
  })),
  "mdsIcon-ui-arrow-tall--right": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-arrow-tall--right",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.38 21c0.226 0.227 0.539 0.367 0.885 0.367s0.659-0.14 0.885-0.367l8.31-8.31c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0-8.31-8.28c-0.216-0.182-0.496-0.292-0.803-0.292-0.69 0-1.25 0.56-1.25 1.25 0 0.302 0.107 0.578 0.285 0.794l-0.002-0.002 7.24 7.25-7.25 7.25c-0.218 0.225-0.352 0.532-0.352 0.87 0 0.343 0.138 0.654 0.362 0.88l-0-0z"
  })),
  "mdsIcon-ui-chat": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-chat",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15 13c1.105 0 2-0.895 2-2v0-7c0-1.105-0.895-2-2-2v0h-11c-1.105 0-2 0.895-2 2v0 13l4-4zM20 6h-1v8c0 0.552-0.448 1-1 1v0h-12v1c0 1.105 0.895 2 2 2v0h10l4 4v-14c0-1.105-0.895-2-2-2v0z"
  })),
  "mdsIcon-ui-check": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M9 16.2l-3.5-3.5c-0.184-0.244-0.474-0.4-0.8-0.4-0.552 0-1 0.448-1 1 0 0.326 0.156 0.616 0.397 0.798l0.003 0.002 4.19 4.19c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l10.6-10.59c0.244-0.184 0.4-0.474 0.4-0.8 0-0.552-0.448-1-1-1-0.326 0-0.616 0.156-0.798 0.397l-0.002 0.003z"
  })),
  "mdsIcon-ui-circle--check": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle--check",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.27,5.05c-3.9-3.9-10.24-3.9-14.14,0s-3.9,10.24,0,14.14c3.9,3.9,10.24,3.9,14.14,0s3.9-10.24,0-14.14Zm-2.11,4.03l-6.74,6.74c-.25,.25-.65,.25-.9,0l-2.67-2.67c-.25-.25-.25-.64,0-.89s.64-.25,.89,0l2.23,2.23,6.3-6.3c.25-.25,.64-.25,.89,0,.25,.25,.25,.64,0,.89Z"
  })),
  "mdsIcon-ui-circle--close": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle--close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.27,5.05a10,10,0,1,0,0,14.14A10,10,0,0,0,19.27,5.05Zm-3.51,9.16a1,1,0,0,1,0,1.41,1,1,0,0,1-1.41,0L12.23,13.5l-2.12,2.12a1,1,0,0,1-1.42,0,1,1,0,0,1,0-1.41l2.12-2.13L8.69,10a1,1,0,0,1,0-1.41,1,1,0,0,1,1.42,0l2.12,2.12,2.12-2.12a1,1,0,0,1,1.41,0,1,1,0,0,1,0,1.41l-2.12,2.12Z"
  })),
  "mdsIcon-ui-circle--minus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle--minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM16 13h-8c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h8c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-circle--plus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle--plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM16 13h-3v3c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-3h-3c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h3v-3c0-0.552 0.448-1 1-1s1 0.448 1 1v0 3h3c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-circle-outline--close": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.54 8.46c-0.181-0.183-0.432-0.296-0.71-0.296s-0.529 0.113-0.71 0.296l-0 0-2.12 2.13-2.12-2.13c-0.182-0.182-0.433-0.294-0.71-0.294-0.555 0-1.004 0.45-1.004 1.004 0 0.277 0.112 0.528 0.294 0.71v0l2.13 2.12-2.13 2.12c-0.182 0.182-0.294 0.433-0.294 0.71 0 0.555 0.45 1.004 1.004 1.004 0.277 0 0.528-0.112 0.71-0.294v0l2.12-2.13 2.12 2.13c0.182 0.182 0.433 0.294 0.71 0.294 0.555 0 1.004-0.45 1.004-1.004 0-0.277-0.112-0.528-0.294-0.71v0l-2.13-2.12 2.13-2.12c0.183-0.181 0.296-0.432 0.296-0.71s-0.113-0.529-0.296-0.71l-0-0zM19.070 4.93c-1.81-1.81-4.31-2.93-7.072-2.93-5.523 0-10 4.477-10 10s4.477 10 10 10c2.762 0 5.262-1.12 7.072-2.93l0-0c1.809-1.81 2.928-4.309 2.928-7.070s-1.119-5.26-2.928-7.070l0 0zM6.34 17.66c-1.446-1.447-2.34-3.446-2.34-5.654 0-4.418 3.582-8 8-8s8 3.582 8 8c0 2.208-0.894 4.206-2.34 5.654l0-0c-1.448 1.45-3.449 2.346-5.66 2.346s-4.212-0.897-5.66-2.346l-0-0z"
  })),
  "mdsIcon-ui-circle-outline--error": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--error",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.22 6.94c0.552 0 1 0.448 1 1v0 4c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-4c0-0.552 0.448-1 1-1v0zM12.22 1.94c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10-0.004 0-0.007 0-0.011 0h0.001zM12.22 19.94c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0zM13.22 16.94h-2v-2h2z"
  })),
  "mdsIcon-ui-circle-outline--help": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12.22 1.92c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12.22 19.92c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0zM11.22 15.92h2v2h-2zM12.83 6c-0.185-0.030-0.398-0.048-0.615-0.048-1.78 0-3.288 1.162-3.807 2.769l-0.008 0.028c-0.024 0.078-0.038 0.167-0.038 0.26 0 0.502 0.406 0.909 0.908 0.91h0.2c0.408-0.027 0.747-0.296 0.878-0.663l0.002-0.007c0.293-0.764 1.020-1.296 1.872-1.296 0.152 0 0.299 0.017 0.441 0.049l-0.013-0.003c0.907 0.202 1.575 1 1.575 1.954 0 0.051-0.002 0.102-0.006 0.152l0-0.007c-0.1 1.34-1.62 1.63-2.45 2.88 0 0 0 0 0 0v0c-0.088 0.142-0.172 0.306-0.242 0.478l-0.008 0.022s0 0.050 0 0.080c-0.001 0.010-0.001 0.023-0.001 0.035s0 0.025 0.001 0.037l-0-0.002c-0.127 0.359-0.2 0.773-0.2 1.204 0 0.016 0 0.032 0 0.048l-0-0.002h2c-0-0.005-0-0.011-0-0.017 0-0.387 0.104-0.751 0.286-1.063l-0.005 0.010 0.050-0.090c0.088-0.147 0.181-0.275 0.283-0.394l-0.003 0.004c0.104-0.123 0.212-0.234 0.327-0.337l0.003-0.003c1-0.91 2.26-1.65 2-3.56-0.273-1.773-1.656-3.157-3.407-3.427l-0.023-0.003z"
  })),
  "mdsIcon-ui-circle-outline--minus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11 11h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h8c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-5zM12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0z"
  })),
  "mdsIcon-ui-circle-outline--pause": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--pause",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M10 15.9c0.552 0 1-0.448 1-1v0-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 6c0 0.552 0.448 1 1 1v0zM12 1.9c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 19.9c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0zM14 15.9c0.552 0 1-0.448 1-1v0-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 6c0 0.552 0.448 1 1 1v0z"
  })),
  "mdsIcon-ui-circle-outline--play": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.7 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM11.7 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0zM10.8 8.080c-0.083-0.062-0.187-0.1-0.3-0.1-0.276 0-0.5 0.224-0.5 0.5v0 7c0 0.276 0.224 0.5 0.5 0.5 0.113 0 0.217-0.038 0.301-0.101l-0.001 0.001 4.67-3.5c0.122-0.092 0.2-0.237 0.2-0.4s-0.078-0.308-0.199-0.399l-0.001-0.001z"
  })),
  "mdsIcon-ui-circle-outline--plus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-outline--plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 7c-0.552 0-1 0.448-1 1v0 3h-3c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h3v3c0 0.552 0.448 1 1 1s1-0.448 1-1v0-3h3c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-3v-3c0-0.552-0.448-1-1-1v0zM12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM12 20c-4.418 0-8-3.582-8-8s3.582-8 8-8c4.418 0 8 3.582 8 8v0c0 4.418-3.582 8-8 8v0z"
  })),
  "mdsIcon-ui-circle-solid--error": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-solid--error",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M2.85 21.17h18.53c0.001 0 0.003 0 0.004 0 0.552 0 1-0.448 1-1 0-0.184-0.050-0.357-0.137-0.505l0.003 0.005-9.25-16c-0.176-0.3-0.498-0.498-0.865-0.498s-0.689 0.198-0.862 0.494l-0.003 0.005-9.27 16c-0.084 0.143-0.134 0.316-0.134 0.5 0 0.547 0.439 0.991 0.983 1h0.001zM13.12 18.17h-2v-2h2zM12.12 14.17c-0.552 0-1-0.448-1-1v0-2c0-0.552 0.448-1 1-1s1 0.448 1 1v0 2c0 0.552-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-circle-solid--help": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-solid--help",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM13 19h-2v-2h2zM15.070 11.25l-0.9 0.92c-0.475 0.445-0.825 1.019-0.995 1.666l-0.005 0.024c-0.099 0.339-0.161 0.731-0.17 1.135l-0 0.005h-2v-0.5c0-0.001 0-0.001 0-0.002 0-0.469 0.081-0.918 0.229-1.336l-0.009 0.028c0.209-0.595 0.534-1.103 0.95-1.52l-0 0 1.24-1.26c0.383-0.365 0.621-0.879 0.621-1.449 0-0.124-0.011-0.246-0.033-0.364l0.002 0.012c-0.148-0.734-0.682-1.314-1.376-1.526l-0.014-0.004c-0.183-0.061-0.394-0.096-0.613-0.096-0.878 0-1.624 0.566-1.893 1.352l-0.004 0.014c-0.102 0.368-0.428 0.636-0.819 0.65l-0.002 0h-0.28c-0.475-0.007-0.857-0.394-0.857-0.87 0-0.089 0.013-0.175 0.038-0.256l-0.002 0.006c0.443-1.48 1.682-2.585 3.207-2.827l0.023-0.003c0.142-0.018 0.307-0.028 0.473-0.028 1.413 0 2.657 0.72 3.387 1.813l0.009 0.015c0.459 0.564 0.737 1.29 0.737 2.082 0 0.903-0.361 1.721-0.947 2.318l0-0.001z"
  })),
  "mdsIcon-ui-circle-solid--pause": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-solid--pause",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 1.9c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM10 15.9c-0.552 0-1-0.448-1-1v0-6c0-0.552 0.448-1 1-1s1 0.448 1 1v0 6c0 0.552-0.448 1-1 1v0zM14 15.9c-0.552 0-1-0.448-1-1v0-6c0-0.552 0.448-1 1-1s1 0.448 1 1v0 6c0 0.552-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-circle-solid--play": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-circle-solid--play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM15.78 12.38l-4.67 3.5c-0.083 0.062-0.187 0.1-0.3 0.1-0.276 0-0.5-0.224-0.5-0.5v0-7c0-0.276 0.224-0.5 0.5-0.5 0.113 0 0.217 0.038 0.301 0.101l-0.001-0.001 4.67 3.5c0.109 0.092 0.177 0.229 0.177 0.382 0 0.162-0.077 0.306-0.196 0.397l-0.001 0.001z"
  })),
  "mdsIcon-ui-close": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-close",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.54 17l-3.54-3.59-3.54 3.59c-0.174 0.149-0.401 0.24-0.65 0.24-0.552 0-1-0.448-1-1 0-0.249 0.091-0.477 0.242-0.652l-0.001 0.001 3.54-3.59-3.54-3.54c-0.149-0.174-0.24-0.401-0.24-0.65 0-0.552 0.448-1 1-1 0.249 0 0.477 0.091 0.652 0.242l-0.001-0.001 3.54 3.54 3.54-3.54c0.185-0.191 0.444-0.31 0.73-0.31 0.56 0 1.015 0.454 1.015 1.015 0 0.274-0.109 0.523-0.285 0.705l0-0-3.59 3.54 3.59 3.54c0.187 0.187 0.302 0.445 0.302 0.73 0 0.57-0.462 1.032-1.032 1.032-0.285 0-0.543-0.116-0.73-0.302v0z"
  })),
  "mdsIcon-ui-dashboard": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-dashboard",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 13h6c0.552 0 1-0.448 1-1v0-8c0-0.552-0.448-1-1-1v0h-6c-0.552 0-1 0.448-1 1v0 8c0 0.552 0.448 1 1 1v0zM4 21h6c0.552 0 1-0.448 1-1v0-4c0-0.552-0.448-1-1-1v0h-6c-0.552 0-1 0.448-1 1v0 4c0 0.552 0.448 1 1 1v0zM14 21h6c0.552 0 1-0.448 1-1v0-8c0-0.552-0.448-1-1-1v0h-6c-0.552 0-1 0.448-1 1v0 8c0 0.552 0.448 1 1 1v0zM13 4v4c0 0.552 0.448 1 1 1v0h6c0.552 0 1-0.448 1-1v0-4c0-0.552-0.448-1-1-1v0h-6c-0.552 0-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-delete": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-delete",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M6.22 18.66c0 1.105 0.895 2 2 2v0h8c1.105 0 2-0.895 2-2v0-10c0-1.105-0.895-2-2-2v0h-8c-1.105 0-2 0.895-2 2v0zM9.22 8.66h6c0.552 0 1 0.448 1 1v0 8c0 0.552-0.448 1-1 1v0h-6c-0.552 0-1-0.448-1-1v0-8c0-0.552 0.448-1 1-1v0zM15.72 3.66l-0.72-0.66c-0.18-0.178-0.427-0.289-0.7-0.29h-4.17c-0.273 0.001-0.52 0.112-0.7 0.29l-0.71 0.71h-2.5c-0.552 0-1 0.448-1 1s0.448 1 1 1v0h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0z"
  })),
  "mdsIcon-ui-download": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-download",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.75 9.34h-1.59v-5c0-0.552-0.448-1-1-1v0h-4c-0.552 0-1 0.448-1 1v0 5h-1.59c-0.002 0-0.004-0-0.006-0-0.552 0-1 0.448-1 1 0 0.278 0.113 0.529 0.296 0.71l4.59 4.59c0.181 0.18 0.43 0.291 0.705 0.291s0.524-0.111 0.705-0.291l4.59-4.59c0.183-0.181 0.296-0.432 0.296-0.71 0-0.551-0.445-0.998-0.996-1h-0zM5.16 19.34c0 0.552 0.448 1 1 1v0h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-drag": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-drag",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 15.69h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM4 10.69h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1s0.448 1 1 1v0z"
  })),
  "mdsIcon-ui-edit": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-edit",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M14.060 9l0.92 0.92-9.060 9.080h-0.92v-0.92l9.060-9.080zM17.66 3c-0.273 0.001-0.52 0.112-0.7 0.29l-1.83 1.83 3.75 3.75 1.83-1.87c0.18-0.181 0.291-0.43 0.291-0.705s-0.111-0.524-0.291-0.705l0 0-2.34-2.3c-0.181-0.179-0.43-0.29-0.704-0.29-0.002 0-0.004 0-0.006 0h0zM14.060 6.19l-11.060 11.060v3.75h3.75l11.060-11.060z"
  })),
  "mdsIcon-ui-ellipses--horizontal": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-ellipses--horizontal",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16 12c0 1.105 0.895 2 2 2s2-0.895 2-2c0-1.105-0.895-2-2-2v0c-1.105 0-2 0.895-2 2v0zM14 12c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2v0c1.105 0 2-0.895 2-2v0zM8 12c0-1.105-0.895-2-2-2s-2 0.895-2 2c0 1.105 0.895 2 2 2v0c1.105 0 2-0.895 2-2v0z"
  })),
  "mdsIcon-ui-ellipses--vertical": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-ellipses--vertical",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M12 8c1.105 0 2-0.895 2-2s-0.895-2-2-2c-1.105 0-2 0.895-2 2v0c0 1.105 0.895 2 2 2v0zM12 10c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0zM12 16c-1.105 0-2 0.895-2 2s0.895 2 2 2c1.105 0 2-0.895 2-2v0c0-1.105-0.895-2-2-2v0z"
  })),
  "mdsIcon-ui-expand": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-expand",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M16.36,7.64v3.48a1,1,0,0,0,2,0V6.63a1,1,0,0,0-1-1H12.88a1,1,0,1,0,0,2ZM7.64,16.36V12.88a1,1,0,0,0-2,0v4.49a1,1,0,0,0,1,1h4.49a1,1,0,0,0,0-2Z"
  })),
  "mdsIcon-ui-feedback": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-feedback",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.22 1.92h-16c-1.105 0-2 0.895-2 2v0 12c0 1.105 0.895 2 2 2v0h14l4 4v-18c0-1.105-0.895-2-2-2v0zM17.22 13.92h-10c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h10c0.552 0 1 0.448 1 1s-0.448 1-1 1v0zM17.22 10.92h-10c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h10c0.552 0 1 0.448 1 1s-0.448 1-1 1v0zM17.22 7.92h-10c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h10c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-filter": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-filter",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4.25,5.61,10,13v5a2,2,0,0,0,2,2h0a2,2,0,0,0,2-2V13l5.75-7.39A1,1,0,0,0,19,4H5A1,1,0,0,0,4.25,5.61Z"
  })),
  "mdsIcon-ui-fullscreen": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-fullscreen",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.85 3.85l1.45 1.45-2.18 2.16c-0.182 0.182-0.294 0.433-0.294 0.71 0 0.555 0.45 1.004 1.004 1.004 0.277 0 0.528-0.112 0.71-0.294v0l2.16-2.18 1.45 1.45c0.090 0.088 0.214 0.143 0.35 0.143 0.276 0 0.5-0.224 0.5-0.5 0-0.001 0-0.002 0-0.003v0-4.29c0-0.276-0.224-0.5-0.5-0.5v0h-4.29c-0.001 0-0.002 0-0.003 0-0.276 0-0.5 0.224-0.5 0.5 0 0.136 0.055 0.26 0.143 0.35l-0-0zM3.85 8.15l1.45-1.45 2.16 2.18c0.182 0.182 0.433 0.294 0.71 0.294 0.555 0 1.004-0.45 1.004-1.004 0-0.277-0.112-0.528-0.294-0.71v0l-2.18-2.16 1.45-1.45c0.088-0.090 0.143-0.214 0.143-0.35 0-0.276-0.224-0.5-0.5-0.5-0.001 0-0.002 0-0.003 0h-4.29c-0.276 0-0.5 0.224-0.5 0.5v0 4.29c0 0.001 0 0.002 0 0.003 0 0.276 0.224 0.5 0.5 0.5 0.136 0 0.26-0.055 0.35-0.143l-0 0zM8.15 20.15l-1.45-1.45 2.18-2.16c0.182-0.182 0.294-0.433 0.294-0.71 0-0.555-0.45-1.004-1.004-1.004-0.277 0-0.528 0.112-0.71 0.294v0l-2.16 2.18-1.45-1.45c-0.090-0.088-0.214-0.143-0.35-0.143-0.276 0-0.5 0.224-0.5 0.5 0 0.001 0 0.002 0 0.003v-0 4.29c0 0.276 0.224 0.5 0.5 0.5v0h4.29c0.001 0 0.002 0 0.003 0 0.276 0 0.5-0.224 0.5-0.5 0-0.136-0.055-0.26-0.143-0.35l0 0zM20.15 15.85l-1.45 1.45-2.16-2.18c-0.182-0.182-0.433-0.294-0.71-0.294-0.555 0-1.004 0.45-1.004 1.004 0 0.277 0.112 0.528 0.294 0.71v0l2.18 2.16-1.45 1.45c-0.088 0.090-0.143 0.214-0.143 0.35 0 0.276 0.224 0.5 0.5 0.5 0.001 0 0.002 0 0.003 0h4.29c0.276 0 0.5-0.224 0.5-0.5v0-4.29c0-0.001 0-0.002 0-0.003 0-0.276-0.224-0.5-0.5-0.5-0.136 0-0.26 0.055-0.35 0.143l0-0z"
  })),
  "mdsIcon-ui-hamburger": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-hamburger",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 17.94h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM4 12.94h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM3 6.94c0 0.552 0.448 1 1 1v0h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-inbox": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-inbox",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.24 4h-16c-1.105 0-2 0.895-2 2v0 12c0 1.105 0.895 2 2 2v0h16c1.105 0 2-0.895 2-2v0-12c0-1.105-0.895-2-2-2v0zM19.24 18h-14c-0.552 0-1-0.448-1-1v0-9l6.94 4.34c0.301 0.191 0.667 0.304 1.060 0.304s0.759-0.113 1.068-0.309l-0.008 0.005 6.94-4.34v9c0 0.552-0.448 1-1 1v0zM12.24 11l-8-5h16z"
  })),
  "mdsIcon-ui-list": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-list",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 13c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM4 17c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM4 9c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM8 13h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM8 17h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM7 8c0 0.552 0.448 1 1 1v0h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1v0zM4 13c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM4 17c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM4 9c0.552 0 1-0.448 1-1s-0.448-1-1-1c-0.552 0-1 0.448-1 1v0c0 0.552 0.448 1 1 1v0zM8 13h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM8 17h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM7 8c0 0.552 0.448 1 1 1v0h12c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-12c-0.552 0-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-minus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-minus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 13h-12c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h12c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-near-me": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-near-me",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18.75 3.94l-14.68 6.14c-0.367 0.154-0.62 0.51-0.62 0.925s0.253 0.771 0.613 0.923l0.007 0.002 5.36 2.070c0.262 0.104 0.466 0.308 0.568 0.563l0.002 0.007 2.060 5.33c0.151 0.374 0.51 0.632 0.93 0.632s0.779-0.259 0.928-0.626l0.002-0.007 6.15-14.64c0.054-0.119 0.086-0.259 0.086-0.406 0-0.552-0.448-1-1-1-0.147 0-0.287 0.032-0.413 0.089l0.006-0.003z"
  })),
  "mdsIcon-ui-play": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-play",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M7.51 16.89l5.77-4.070c0.256-0.184 0.421-0.48 0.421-0.815s-0.165-0.631-0.418-0.813l-0.003-0.002-5.77-4.080c-0.161-0.116-0.362-0.185-0.58-0.185-0.552 0-1 0.448-1 1 0 0.002 0 0.004 0 0.006v-0 8.14c0 0.002-0 0.003-0 0.005 0 0.552 0.448 1 1 1 0.218 0 0.419-0.069 0.583-0.187l-0.003 0.002zM15.93 7v10c0 0.552 0.448 1 1 1s1-0.448 1-1v0-10c0-0.552-0.448-1-1-1s-1 0.448-1 1v0z"
  })),
  "mdsIcon-ui-plus": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-plus",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 13h-5v5c0 0.552-0.448 1-1 1s-1-0.448-1-1v0-5h-5c-0.552 0-1-0.448-1-1s0.448-1 1-1v0h5v-5c0-0.552 0.448-1 1-1s1 0.448 1 1v0 5h5c0.552 0 1 0.448 1 1s-0.448 1-1 1v0z"
  })),
  "mdsIcon-ui-profile": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-profile",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M11.89 2c-5.523 0-10 4.477-10 10s4.477 10 10 10c5.523 0 10-4.477 10-10v0c0-5.523-4.477-10-10-10v0zM18.22 16.89c-1.006-1.958-2.846-3.366-5.037-3.764l-0.043-0.006c1.424-0.526 2.42-1.872 2.42-3.451 0-2.027-1.643-3.67-3.67-3.67s-3.67 1.643-3.67 3.67c0 1.578 0.996 2.924 2.395 3.442l0.025 0.008c-2.23 0.407-4.066 1.815-5.051 3.73l-0.019 0.040c-1.045-1.339-1.675-3.045-1.675-4.898 0-4.418 3.582-8 8-8s8 3.582 8 8c0 1.854-0.63 3.56-1.688 4.916l0.013-0.018z"
  })),
  "mdsIcon-ui-search": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-search",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.5 14h-0.79l-0.28-0.27c0.978-1.134 1.573-2.621 1.573-4.247 0-3.601-2.919-6.52-6.52-6.52s-6.52 2.919-6.52 6.52c0 3.601 2.919 6.52 6.52 6.52 1.626 0 3.113-0.595 4.255-1.58l-0.008 0.007 0.27 0.28v0.79l4.25 4.25c0.191 0.191 0.454 0.309 0.745 0.309 0.582 0 1.054-0.472 1.054-1.054 0-0.291-0.118-0.554-0.309-0.745v0zM9.5 14c-2.485 0-4.5-2.015-4.5-4.5s2.015-4.5 4.5-4.5c2.485 0 4.5 2.015 4.5 4.5v0c0 0.003 0 0.006 0 0.010 0 2.48-2.010 4.49-4.49 4.49-0.004 0-0.007 0-0.011-0h0.001z"
  })),
  "mdsIcon-ui-settings": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-settings",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19.33 13c0.038-0.276 0.060-0.595 0.060-0.919 0-0.007 0-0.015-0-0.022v0.001c0-0.013 0-0.027 0-0.042 0-0.317-0.026-0.628-0.075-0.931l0.004 0.033 2-1.58c0.109-0.091 0.178-0.226 0.178-0.378 0-0.085-0.022-0.165-0.060-0.234l0.001 0.003-1.89-3.31c-0.087-0.143-0.243-0.238-0.42-0.238-0.046 0-0.091 0.006-0.133 0.018l0.003-0.001-2.39 1c-0.465-0.379-0.995-0.707-1.565-0.962l-0.045-0.018-0.36-2.54c-0.035-0.233-0.234-0.41-0.475-0.41-0.002 0-0.004 0-0.005 0h-3.89c-0.001 0-0.002-0-0.004-0-0.238 0-0.435 0.178-0.466 0.408l-0 0.002-0.36 2.54c-0.619 0.262-1.152 0.577-1.636 0.952l0.017-0.012-2.39-1c-0.050-0.019-0.108-0.031-0.168-0.031-0.181 0-0.339 0.1-0.42 0.248l-0.001 0.002-1.91 3.36c-0.044 0.069-0.071 0.152-0.071 0.242 0 0.151 0.075 0.285 0.189 0.367l0.001 0.001 2 1.58c-0.051 0.283-0.080 0.608-0.080 0.94s0.029 0.657 0.085 0.973l-0.005-0.033-2.050 1.58c-0.109 0.091-0.178 0.226-0.178 0.378 0 0.085 0.022 0.165 0.060 0.234l-0.001-0.003 1.92 3.32c0.086 0.149 0.244 0.248 0.426 0.248 0.059 0 0.115-0.010 0.167-0.029l-0.003 0.001 2.39-1c0.468 0.365 1.001 0.681 1.574 0.923l0.046 0.017 0.36 2.54c0.040 0.233 0.239 0.408 0.48 0.41h3.84c0.001 0 0.002 0 0.004 0 0.238 0 0.435-0.178 0.466-0.408l0-0.002 0.36-2.54c0.619-0.257 1.153-0.572 1.635-0.951l-0.015 0.011 2.39 1c0.050 0.019 0.108 0.031 0.168 0.031 0.181 0 0.339-0.1 0.42-0.248l0.001-0.002 1.92-3.32c0.042-0.068 0.067-0.151 0.067-0.24 0-0.151-0.073-0.286-0.186-0.37l-0.001-0.001zM12.19 15.66c-1.988 0-3.6-1.612-3.6-3.6s1.612-3.6 3.6-3.6c1.988 0 3.6 1.612 3.6 3.6v0c0 0 0 0 0 0 0 1.99-1.611 3.604-3.599 3.61h-0.001z"
  })),
  "mdsIcon-ui-share": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-share",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M18 16.080c-0.008-0-0.018-0-0.028-0-0.762 0-1.455 0.293-1.974 0.772l0.002-0.002-7.090-4.15c0.052-0.209 0.085-0.449 0.090-0.697l0-0.003c-0.005-0.251-0.038-0.491-0.095-0.722l0.005 0.022 7.090-4.11c0.528 0.474 1.23 0.764 2 0.764 1.657 0 3-1.343 3-3s-1.343-3-3-3c-1.657 0-3 1.343-3 3 0 0.016 0 0.033 0 0.049l-0-0.002c0.005 0.251 0.038 0.491 0.095 0.722l-0.005-0.022-7.090 4.11c-0.535-0.502-1.257-0.81-2.050-0.81-1.657 0-3 1.343-3 3s1.343 3 3 3c0.794 0 1.515-0.308 2.052-0.812l-0.002 0.002 7.12 4.16c-0.049 0.195-0.079 0.419-0.080 0.649v0.001c0 1.613 1.307 2.92 2.92 2.92s2.92-1.307 2.92-2.92c0-1.599-1.285-2.897-2.878-2.92l-0.002-0z"
  })),
  "mdsIcon-ui-sort": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-sort",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M4 18h4c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-4c-0.552 0-1 0.448-1 1s0.448 1 1 1v0zM3 7c0 0.552 0.448 1 1 1v0h16c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-16c-0.552 0-1 0.448-1 1v0zM4 13h10c0.552 0 1-0.448 1-1s-0.448-1-1-1v0h-10c-0.552 0-1 0.448-1 1s0.448 1 1 1v0z"
  })),
  "mdsIcon-ui-print": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-print",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M19,8H5a3,3,0,0,0-3,3v4a2,2,0,0,0,2,2H6v2a2,2,0,0,0,2,2h8a2,2,0,0,0,2-2V17h2a2,2,0,0,0,2-2V11A3,3,0,0,0,19,8ZM15,19H9a1,1,0,0,1-1-1V14h8v4A1,1,0,0,1,15,19Zm4-7a1,1,0,1,1,1-1A1,1,0,0,1,19,12ZM17,3H7A1,1,0,0,0,6,4V6A1,1,0,0,0,7,7H17a1,1,0,0,0,1-1V4A1,1,0,0,0,17,3Z"
  })),
  "mdsIcon-ui-swap--vertical": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "ui-swap--vertical",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.49 17.24v-6c0-0.552-0.448-1-1-1s-1 0.448-1 1v0 6h-1.79c-0.005-0-0.012-0-0.018-0-0.271 0-0.49 0.219-0.49 0.49 0 0.142 0.061 0.271 0.158 0.36l0 0 2.79 2.78c0.092 0.089 0.217 0.144 0.355 0.144s0.263-0.055 0.355-0.144l-0 0 2.79-2.78c0.088-0.090 0.143-0.214 0.143-0.35 0-0.274-0.22-0.496-0.493-0.5h-0zM8.14 3.58l-2.79 2.79c-0.097 0.090-0.158 0.218-0.158 0.36 0 0.271 0.219 0.49 0.49 0.49 0.006 0 0.013-0 0.019-0l-0.001 0h1.79v6c0 0.552 0.448 1 1 1s1-0.448 1-1v0-6h1.79c0.005 0 0.012 0 0.018 0 0.271 0 0.49-0.219 0.49-0.49 0-0.142-0.061-0.271-0.158-0.36l-0-0-2.79-2.79c-0.090-0.088-0.214-0.143-0.35-0.143s-0.26 0.055-0.35 0.143l0-0z"
  })),
  "mdsIcon-star--solid": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "star--solid",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M20.65,10.11c-0.03-0.29-0.29-0.5-0.58-0.48l-5.23-0.76L12.5,4.14c-0.08-0.28-0.37-0.44-0.64-0.36  c-0.17,0.05-0.31,0.18-0.36,0.36L9.14,8.87L3.91,9.63C3.62,9.6,3.37,9.82,3.33,10.11c0.02,0.19,0.11,0.37,0.26,0.5l3.79,3.69  l-0.9,5.21c0,0.07,0,0.14,0,0.21c0,0.13,0.03,0.26,0.11,0.37c0.08,0.1,0.2,0.16,0.33,0.15c0.15,0,0.29-0.05,0.42-0.12l4.65-2.47  l4.67,2.46c0.13,0.08,0.27,0.12,0.42,0.12c0.13,0.01,0.25-0.05,0.32-0.15c0.08-0.11,0.11-0.24,0.11-0.37c0-0.07,0-0.14,0-0.21  l-0.9-5.21l3.78-3.69c0.15-0.12,0.25-0.3,0.27-0.5l0,0L20.65,10.11z"
  })),
  "mdsIcon-star--half": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "star--half",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.18,13.85l0.12,0.69l0.62,3.7l-3.31-1.75L12,16.16v-10l1.66,3.33L14,10.11l4.39,0.65l-2.68,2.6  L15.18,13.85z M20.4,10.63c0.2-0.14,0.3-0.4,0.24-0.64c-0.1-0.22-0.32-0.36-0.56-0.36l-5.23-0.74l-2.34-4.73  c-0.07-0.23-0.27-0.4-0.51-0.43c-0.24,0.03-0.44,0.2-0.51,0.43L9.15,8.89L3.92,9.65c-0.24,0-0.46,0.14-0.56,0.36  c-0.05,0.24,0.05,0.48,0.24,0.62l3.79,3.69l-0.9,5.21c-0.04,0.18-0.02,0.37,0.06,0.54c0.07,0.12,0.21,0.2,0.35,0.19  c0.15-0.01,0.29-0.05,0.42-0.12L12,17.67l4.67,2.46c0.13,0.07,0.27,0.11,0.42,0.12c0.14,0.01,0.28-0.07,0.35-0.19  c0.08-0.17,0.1-0.36,0.06-0.54l-0.9-5.21l3.78-3.69l0,0L20.4,10.63z"
  })),
  "mdsIcon-star--outline": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "star--outline",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M15.92,18.21l-3.93-2.07l-3.94,2.07l0.76-4.38l-3.18-3.09l4.36-0.65l2-4l2,4l4.39,0.65l-3.19,3.09L15.92,18.21z   M20.66,10.11c-0.03-0.29-0.29-0.5-0.58-0.48l-5.24-0.76L12.5,4.14c-0.08-0.28-0.37-0.44-0.64-0.36c-0.17,0.05-0.31,0.18-0.36,0.36  L9.14,8.87L3.91,9.63C3.62,9.6,3.37,9.82,3.33,10.11c0.02,0.19,0.11,0.37,0.26,0.5l3.79,3.69l-0.9,5.21c0,0.07,0,0.14,0,0.21  c0,0.13,0.03,0.26,0.11,0.37c0.08,0.1,0.2,0.16,0.33,0.15c0.15,0,0.29-0.05,0.42-0.12l4.65-2.47l4.67,2.46  c0.13,0.08,0.27,0.12,0.42,0.12c0.23,0.01,0.43-0.17,0.44-0.4c0-0.04,0-0.08-0.01-0.12c0-0.07,0-0.14,0-0.21l-0.9-5.21l3.78-3.69  C20.55,10.47,20.64,10.29,20.66,10.11L20.66,10.11L20.66,10.11z"
  })),
  "mdsIcon-member--review": /*#__PURE__*/React__default["default"].createElement("symbol", {
    id: "member--review",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React__default["default"].createElement("path", {
    d: "M17.1,11.6c-1.4,0-2.5,1.2-2.5,2.5s1.2,2.5,2.5,2.5s2.5-1.2,2.5-2.5 C19.6,12.7,18.5,11.6,17.1,11.6z M17.1,16c-1,0-1.9-0.8-1.9-1.9s0.8-1.9,1.9-1.9c1,0,1.9,0.8,1.9,1.9S18.1,16,17.1,16z M19.8,15.1l-0.3,0.6c1,0.5,1.6,1.3,1.6,2.2c0,1.5-1.8,2.7-4.1,2.7S13,19.4,13,17.9c0-0.8,0.6-1.6,1.6-2.2l-0.3-0.6 c-1.2,0.6-1.9,1.7-1.9,2.8c0,1.9,2.1,3.4,4.8,3.4s4.8-1.5,4.8-3.4C21.8,16.8,21.1,15.7,19.8,15.1z M11.2,4.4 c3.5,0,6.4,2.5,7.1,5.9c0.2,0,0.5,0.1,0.7,0.2c-0.5-3.8-3.8-6.7-7.8-6.7c-4.3,0-7.9,3.5-7.9,7.9c0,1.5,0.4,2.9,1.2,4.2l-1,3.7 l3.8-1c1.1,0.6,2.2,1,3.4,1c-0.1-0.2-0.2-0.5-0.2-0.7c-1.1-0.1-2-0.4-3-1l-0.1-0.1l-2.9,0.8l0.7-2.9l-0.1-0.1 C4.4,14.4,4,13,4,11.6C4,7.6,7.3,4.4,11.2,4.4z"
  }))
};

function Icon(_ref) {
  var iconName = _ref.iconName,
    _ref$iconWSize = _ref.iconWSize,
    iconWSize = _ref$iconWSize === void 0 ? 24 : _ref$iconWSize,
    _ref$iconHSize = _ref.iconHSize,
    iconHSize = _ref$iconHSize === void 0 ? 24 : _ref$iconHSize,
    iconColor = _ref.iconColor,
    iconShadow = _ref.iconShadow,
    extraClass = _ref.extraClass;
    _ref.z;
  var iconSymbols = "mdsIcon-".concat(iconName);
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("svg", {
    width: iconWSize + "px",
    height: iconHSize + "px",
    className: [iconShadow ? modules_adb0feaa.IconShadow : modules_adb0feaa.Icon, extraClass].join(' '),
    "aria-hidden": "true",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, /*#__PURE__*/React__default["default"].createElement("title", null, iconName), iconList[iconSymbols] ? iconList[iconSymbols] : '', /*#__PURE__*/React__default["default"].createElement("use", {
    href: "#".concat(iconName),
    fill: iconColor
  })));
}
Icon.propTypes = {
  extraClass: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconWSize: propTypes.exports.number,
  iconHSize: propTypes.exports.number,
  iconColor: propTypes.exports.string,
  iconShadow: propTypes.exports.bool
};

var css$10 = "@-webkit-keyframes Loader_module_spin__0aa937a0 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@-moz-keyframes Loader_module_spin__0aa937a0 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@-ms-keyframes Loader_module_spin__0aa937a0 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n@keyframes Loader_module_spin__0aa937a0 {\n  0% {\n    transform: rotate3d(0, 0, 1, 0deg);\n  }\n  100% {\n    transform: rotate3d(0, 0, 1, 360deg);\n  }\n}\n\n.Loader_module_Loading__0aa937a0 {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 8px;\n}\n.Loader_module_Loading__0aa937a0.Loader_module_DarkMode__0aa937a0 .Loader_module_Content__0aa937a0 svg {\n  stroke: #fff;\n}\n.Loader_module_Loading__0aa937a0 .Loader_module_Content__0aa937a0 {\n  width: 30px;\n  height: 30px;\n  animation: Loader_module_spin__0aa937a0 1s infinite;\n}\n.Loader_module_Loading__0aa937a0 .Loader_module_Content__0aa937a0 svg {\n  stroke: #444f6b;\n}";
injectCss(css$10);
var modules_b825b997 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Loading":"Loader_module_Loading__0aa937a0","DarkMode":"Loader_module_DarkMode__0aa937a0","Content":"Loader_module_Content__0aa937a0","spin":"Loader_module_spin__0aa937a0"};

var Loader$1 = function Loader(_ref) {
  var extraClass = _ref.extraClass,
    darkMode = _ref.darkMode,
    loaderHeight = _ref.loaderHeight,
    loaderWidth = _ref.loaderWidth;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_b825b997.Loading, darkMode ? modules_b825b997.DarkMode : "", extraClass || ""].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_b825b997.Content,
    style: {
      height: loaderHeight,
      width: loaderWidth
    }
  }, /*#__PURE__*/React__default["default"].createElement(Circle, null)));
};
var Circle = function Circle() {
  return /*#__PURE__*/React__default["default"].createElement("svg", {
    width: "100%",
    height: "100%",
    viewBox: "15 0 10 40"
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    strokeDasharray: "80, 20",
    cx: "20",
    cy: "20",
    r: "15.91549430918954",
    fill: "transparent",
    strokeWidth: "6",
    strokeDashoffset: "25"
  }));
};
Loader$1.propTypes = {
  extraClass: propTypes.exports.string,
  darkMode: propTypes.exports.bool,
  loaderHeight: propTypes.exports.string,
  loaderWidth: propTypes.exports.string
};

var getClassNames$a = function getClassNames(Button, props) {
  return [Button,
  //buttonSize
  props.size == "S" ? modules_79b43374.Small : "",
  //color
  props.color == "RED" ? modules_79b43374.Red : props.color == "WHITE" ? modules_79b43374.White : "",
  //style
  props.style == "NEU_PRIMARY" ? modules_79b43374.NeuPrimary : props.style == "NEU_SECONDARY" ? modules_79b43374.NeuSecondary : props.style == "OUTLINED" ? modules_79b43374.Outlined : props.style == "PLAIN" ? modules_79b43374.Plain : "",
  //icon
  props.icon == "ICON_RIGHT" ? modules_79b43374.IconRight : props.icon == "ICON_LEFT" ? modules_79b43374.IconLeft : props.icon == "ICON" ? modules_79b43374.Icon : "",
  //Shape
  props.square ? modules_79b43374.Square : "", props.extraClass || ""].join(" ");
};
var ButtonLink = function ButtonLink(props) {
  return /*#__PURE__*/React__default["default"].createElement("a", {
    href: props.href,
    className: getClassNames$a(modules_79b43374.Button, props),
    target: props.target,
    "aria-label": props.ariaLabel,
    tabIndex: props.tabIndex,
    onClick: props.action,
    "aria-current": props.isActive ? "page" : null,
    rel: props.rel
  }, /*#__PURE__*/React__default["default"].createElement("span", null, props.loading ? /*#__PURE__*/React__default["default"].createElement(Loader$1, {
    extraClass: modules_79b43374.Loader,
    darkMode: props.style == "PLAIN" || props.style == "NEU_SECONDARY" ? false : true,
    loaderHeight: "22px",
    loaderWidth: "22px"
  }) : null, props.iconName && props.loading != true ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconDefault: props.iconDefault,
    iconActive: props.iconActive,
    iconColor: props.iconColor,
    iconHSize: props.iconHSize || 24,
    iconWSize: props.iconWSize || 24,
    iconName: props.iconName
  }) : null, props.children, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_79b43374.Label
  }, props.label)));
};
var Button = function Button(props) {
  return /*#__PURE__*/React__default["default"].createElement("button", {
    type: props.type,
    id: props.id,
    className: getClassNames$a(modules_79b43374.Button, props),
    target: props.target,
    "aria-label": props.ariaLabel,
    tabIndex: props.tabIndex,
    onClick: props.action,
    disabled: props.disabled,
    "aria-current": props.isActive ? "page" : null,
    "aria-expanded": props.ariaExpanded ? props.ariaExpanded : null,
    "aria-controls": props.ariaControls ? props.ariaControls : null,
    value: props.value
  }, /*#__PURE__*/React__default["default"].createElement("span", null, props.loading ? /*#__PURE__*/React__default["default"].createElement(Loader$1, {
    extraClass: modules_79b43374.Loader,
    darkMode: props.style == "PLAIN" || props.style == "NEU_SECONDARY" ? false : true,
    loaderHeight: "22px",
    loaderWidth: "22px"
  }) : null, props.iconName && props.loading != true ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconDefault: props.iconDefault,
    iconActive: props.iconActive,
    iconColor: props.iconColor,
    iconHSize: props.iconHSize || 24,
    iconWSize: props.iconWSize || 24,
    iconName: props.iconName
  }) : null, props.children, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_79b43374.Label
  }, props.label)));
};
var buttonPropTypes = {
  label: propTypes.exports.string,
  extraClass: propTypes.exports.string,
  size: propTypes.exports.oneOf(["BASE", "S"]),
  color: propTypes.exports.oneOf(["BASE", "RED", "WHITE"]),
  style: propTypes.exports.oneOf(["BASE", "NEU_PRIMARY", "NEU_SECONDARY", "OUTLINED", "PLAIN"]),
  icon: propTypes.exports.oneOf(["BASE", "ICON_RIGHT", "ICON_LEFT", "ICON"]),
  type: propTypes.exports.oneOf(["button", "submit", "reset"]),
  square: propTypes.exports.bool,
  href: propTypes.exports.string,
  action: propTypes.exports.func,
  // Icon Props
  iconName: propTypes.exports.string,
  iconDefault: propTypes.exports.string,
  iconActive: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  iconHSize: propTypes.exports.number,
  iconWSize: propTypes.exports.number,
  rel: propTypes.exports.string,
  ariaLabel: propTypes.exports.string,
  ariaExpanded: propTypes.exports.string,
  ariaControls: propTypes.exports.string,
  tabIndex: propTypes.exports.string,
  disabled: propTypes.exports.bool,
  isActive: propTypes.exports.bool,
  loading: propTypes.exports.bool,
  value: propTypes.exports.string
};
ButtonLink.propTypes = buttonPropTypes;
Button.propTypes = buttonPropTypes;

var css$$ = ".ButtonGroup_module_BtnGroup__c938b62b {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.ButtonGroup_module_BtnGroup__c938b62b button,\n.ButtonGroup_module_BtnGroup__c938b62b a {\n  margin-left: 0;\n  margin-right: 24px;\n}\n.ButtonGroup_module_BtnGroup__c938b62b button,\n.ButtonGroup_module_BtnGroup__c938b62b a:last-child {\n  margin-right: 0;\n}\n.ButtonGroup_module_BtnGroup__c938b62b.ButtonGroup_module_LooseSpacing__c938b62b button,\n.ButtonGroup_module_BtnGroup__c938b62b.ButtonGroup_module_LooseSpacing__c938b62b a {\n  margin-right: 32px;\n}\n.ButtonGroup_module_BtnGroup__c938b62b.ButtonGroup_module_TightSpacing__c938b62b button,\n.ButtonGroup_module_BtnGroup__c938b62b.ButtonGroup_module_TightSpacing__c938b62b a {\n  margin-right: 14px;\n}";
injectCss(css$$);
var modules_06b04e86 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","BtnGroup":"ButtonGroup_module_BtnGroup__c938b62b","LooseSpacing":"ButtonGroup_module_LooseSpacing__c938b62b","TightSpacing":"ButtonGroup_module_TightSpacing__c938b62b"};

var getClassNames$9 = function getClassNames(BtnGroup, props) {
  return [BtnGroup, props.tightSpacing ? modules_06b04e86.TightSpacing : "", props.looseSpacing ? modules_06b04e86.LooseSpacing : "", props.extraClass].join(" ");
};
var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$9(modules_06b04e86.BtnGroup, props)
  }, props.children);
};
var buttonGroupPropTypes = {
  extraClass: propTypes.exports.string,
  tightSpacing: propTypes.exports.bool,
  looseSpacing: propTypes.exports.bool
};
ButtonGroup.propTypes = buttonGroupPropTypes;

var css$_ = ".Link_module_Link__d99cec13 {\n  font-size: 14px;\n  font-family: \"Karla\", sans-serif;\n  font-weight: 700;\n  text-decoration: underline;\n  color: #444F6B;\n  cursor: pointer;\n  text-decoration: none;\n  display: flex;\n  flex-wrap: wrap;\n  flex-direction: row;\n  align-items: center;\n  position: relative;\n  height: auto;\n  max-width: 320px;\n  transition: all 0.2s ease-in-out;\n  display: inline-flex;\n}\n.Link_module_Link__d99cec13:hover {\n  color: #313E5C;\n  text-decoration: underline;\n}\n.Link_module_Link__d99cec13:focus {\n  outline: none;\n}\n.Link_module_Link__d99cec13:focus-visible {\n  outline: none;\n  border-radius: 10px;\n  box-shadow: inset 0px 0px 0px 3px #ffffff, 0px 0px 0px 4px #7f5f9c, 1px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n}\n.Link_module_Link__d99cec13 svg {\n  margin-right: 14px;\n}\n\n.Link_module_Icon__d99cec13 span {\n  display: none;\n}\n.Link_module_Icon__d99cec13 svg {\n  margin-left: 14px;\n}\n.Link_module_Icon__d99cec13 svg:hover {\n  transform: scale(1.1);\n}\n\n.Link_module_LeftIcon__d99cec13 svg {\n  order: 0;\n  margin-left: 14px;\n}\n\n.Link_module_RightIcon__d99cec13 svg {\n  order: 2;\n  margin-left: 14px;\n}";
injectCss(css$_);
var modules_e20967e9 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Link":"Link_module_Link__d99cec13","Icon":"Link_module_Icon__d99cec13","LeftIcon":"Link_module_LeftIcon__d99cec13","RightIcon":"Link_module_RightIcon__d99cec13"};

function Link(_ref) {
  var href = _ref.href,
    action = _ref.action,
    extraClass = _ref.extraClass,
    icon = _ref.icon,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    color = _ref.color,
    rightIcon = _ref.rightIcon,
    label = _ref.label,
    target = _ref.target;
  return /*#__PURE__*/React__default["default"].createElement("a", {
    className: [modules_e20967e9.Link, extraClass || "", rightIcon ? modules_e20967e9.RightIcon : modules_e20967e9.LeftIcon, icon ? modules_e20967e9.Icon : ""].join(" "),
    href: href,
    onClick: action,
    target: target
  }, iconName ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    className: modules_e20967e9.Icon,
    iconColor: iconColor,
    iconHSize: 24,
    iconName: iconName,
    iconWSize: 24
  }) : "", /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      color: color
    }
  }, label));
}
Link.propTypes = {
  href: propTypes.exports.string,
  action: propTypes.exports.func,
  extraClass: propTypes.exports.string,
  icon: propTypes.exports.bool,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  color: propTypes.exports.string,
  rightIcon: propTypes.exports.bool,
  label: propTypes.exports.string,
  target: propTypes.exports.string
};

var css$Z = ".Containers_module_Flat__c0949091 {\n  position: relative;\n  padding: 24px;\n  font-size: 16px;\n}\n\n.Containers_module_Shadow__c0949091 {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  overflow: hidden;\n  padding: 24px;\n}\n\n.Containers_module_NoPadding__c0949091 {\n  padding: 0;\n}\n\n.Containers_module_PageNeumorphic__c0949091 {\n  background-color: #edeef2;\n  border-radius: 0 48px 0 0;\n  box-shadow: 0px -12px 16px rgba(25, 25, 25, 0.2);\n}\n@media (max-width: 1024px) {\n  .Containers_module_PageNeumorphic__c0949091 {\n    border-radius: 0;\n  }\n}\n\n.Containers_module_Neumorphic__c0949091 {\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  padding: 24px;\n  border-radius: 14px;\n}\n\n.Containers_module_TopRounded__c0949091 {\n  background-color: #edeef2;\n  border-radius: 0 48px 0 0;\n  font-size: 16px;\n}\n\n.Containers_module_Widescreen__c0949091 {\n  max-width: 1920px;\n  margin: 0 auto;\n}\n\n.Containers_module_Large__c0949091 {\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n.Containers_module_Standard__c0949091 {\n  max-width: 1366px;\n  margin: 0 auto;\n}\n\n.Containers_module_Medium__c0949091 {\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n.Containers_module_Small__c0949091 {\n  max-width: 768px;\n  margin: 0 auto;\n}\n\n.Containers_module_TopOverlap__c0949091 {\n  margin-top: -3.75rem;\n}\n\n.Containers_module_mainMenuPadding__c0949091 {\n  padding: 24px 90px 24px 90px;\n}\n@media (max-width: 768px) {\n  .Containers_module_mainMenuPadding__c0949091 {\n    padding: 24px 24px 24px 90px;\n  }\n}\n@media (max-width: 700px) {\n  .Containers_module_mainMenuPadding__c0949091 {\n    padding: 24px;\n  }\n}";
injectCss(css$Z);
var modules_b4609984 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Flat":"Containers_module_Flat__c0949091","Shadow":"Containers_module_Shadow__c0949091","NoPadding":"Containers_module_NoPadding__c0949091","PageNeumorphic":"Containers_module_PageNeumorphic__c0949091","Neumorphic":"Containers_module_Neumorphic__c0949091","TopRounded":"Containers_module_TopRounded__c0949091","Widescreen":"Containers_module_Widescreen__c0949091","Large":"Containers_module_Large__c0949091","Standard":"Containers_module_Standard__c0949091","Medium":"Containers_module_Medium__c0949091","Small":"Containers_module_Small__c0949091","TopOverlap":"Containers_module_TopOverlap__c0949091","mainMenuPadding":"Containers_module_mainMenuPadding__c0949091"};

var getClassNames$8 = function getClassNames(Flat, props) {
  return [Flat, props.style || "", props.width == "1920" ? modules_b4609984.Widescreen : props.width == "1440" ? modules_b4609984.Large : props.width == "1366" ? modules_b4609984.Standard : props.width == "980" ? modules_b4609984.Medium : props.width == "768" ? modules_b4609984.Small : "", props.style == "Shadow" ? modules_b4609984.Shadow : props.style == "PageNeumorphic" ? modules_b4609984.PageNeumorphic : props.style == "Neumorphic" ? modules_b4609984.Neumorphic : props.style == "TopRounded" ? modules_b4609984.TopRounded : modules_b4609984.Flat, props.margins == "TopOverlap" ? modules_b4609984.TopOverlap : null, props.noPadding ? modules_b4609984.NoPadding : null, props.mainMenuPadding ? modules_b4609984.mainMenuPadding : null, props.extraClass || ""].join(" ");
};
var Header = function Header(props) {
  return /*#__PURE__*/React__default["default"].createElement("header", {
    id: props.id,
    className: getClassNames$8(modules_b4609984.Flat, props),
    style: {
      backgrounColor: props.backgroundColor
    }
  }, props.children);
};
var Main = function Main(props) {
  return /*#__PURE__*/React__default["default"].createElement("main", {
    id: props.id,
    className: getClassNames$8(modules_b4609984.Flat, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, props.children);
};
var Footer = function Footer(props) {
  return /*#__PURE__*/React__default["default"].createElement("footer", {
    id: props.id,
    className: getClassNames$8(modules_b4609984.Flat, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, props.children);
};
var Section = function Section(props) {
  return /*#__PURE__*/React__default["default"].createElement("section", {
    id: props.id,
    className: getClassNames$8(modules_b4609984.Flat, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, props.children);
};
var Container = function Container(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: props.id,
    className: getClassNames$8(modules_b4609984.Flat, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, props.children);
};
var containerPropTypes = {
  extraClass: propTypes.exports.string,
  backgroundColor: propTypes.exports.string,
  style: propTypes.exports.oneOf(["Flat", "Shadow", "PageNeumorphic", "Neumorphic", "TopRounded"]),
  width: propTypes.exports.oneOf(["1920", "1440", "1366", "980", "768"]),
  margins: propTypes.exports.oneOf(["TopOverlap"]),
  noPadding: propTypes.exports.bool,
  id: propTypes.exports.string,
  mainMenuPadding: propTypes.exports.bool
};
Section.propTypes = containerPropTypes;
Container.propTypes = containerPropTypes;
Main.propTypes = containerPropTypes;
Header.propTypes = containerPropTypes;
Footer.propTypes = containerPropTypes;

var build = {exports: {}};

(()=>{var e={296:(e,t,r)=>{var o=/^\s+|\s+$/g,n=/^[-+]0x[0-9a-f]+$/i,i=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt,u="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,l="object"==typeof self&&self&&self.Object===Object&&self,a=u||l||Function("return this")(),f=Object.prototype.toString,p=Math.max,y=Math.min,d=function(){return a.Date.now()};function b(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function h(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==f.call(e)}(e))return NaN;if(b(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=b(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(o,"");var r=i.test(e);return r||c.test(e)?s(e.slice(2),r?2:8):n.test(e)?NaN:+e}e.exports=function(e,t,r){var o,n,i,c,s,u,l=0,a=!1,f=!1,v=!0;if("function"!=typeof e)throw new TypeError("Expected a function");function m(t){var r=o,i=n;return o=n=void 0,l=t,c=e.apply(i,r)}function O(e){return l=e,s=setTimeout(g,t),a?m(e):c}function w(e){var r=e-u;return void 0===u||r>=t||r<0||f&&e-l>=i}function g(){var e=d();if(w(e))return P(e);s=setTimeout(g,function(e){var r=t-(e-u);return f?y(r,i-(e-l)):r}(e));}function P(e){return s=void 0,v&&o?m(e):(o=n=void 0,c)}function j(){var e=d(),r=w(e);if(o=arguments,n=this,u=e,r){if(void 0===s)return O(u);if(f)return s=setTimeout(g,t),m(u)}return void 0===s&&(s=setTimeout(g,t)),c}return t=h(t)||0,b(r)&&(a=!!r.leading,i=(f="maxWait"in r)?p(h(r.maxWait)||0,t):i,v="trailing"in r?!!r.trailing:v),j.cancel=function(){void 0!==s&&clearTimeout(s),l=0,o=u=n=s=void 0;},j.flush=function(){return void 0===s?c:P(d())},j};},96:(e,t,r)=>{var o="Expected a function",n=/^\s+|\s+$/g,i=/^[-+]0x[0-9a-f]+$/i,c=/^0b[01]+$/i,s=/^0o[0-7]+$/i,u=parseInt,l="object"==typeof r.g&&r.g&&r.g.Object===Object&&r.g,a="object"==typeof self&&self&&self.Object===Object&&self,f=l||a||Function("return this")(),p=Object.prototype.toString,y=Math.max,d=Math.min,b=function(){return f.Date.now()};function h(e){var t=typeof e;return !!e&&("object"==t||"function"==t)}function v(e){if("number"==typeof e)return e;if(function(e){return "symbol"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Symbol]"==p.call(e)}(e))return NaN;if(h(e)){var t="function"==typeof e.valueOf?e.valueOf():e;e=h(t)?t+"":t;}if("string"!=typeof e)return 0===e?e:+e;e=e.replace(n,"");var r=c.test(e);return r||s.test(e)?u(e.slice(2),r?2:8):i.test(e)?NaN:+e}e.exports=function(e,t,r){var n=!0,i=!0;if("function"!=typeof e)throw new TypeError(o);return h(r)&&(n="leading"in r?!!r.leading:n,i="trailing"in r?!!r.trailing:i),function(e,t,r){var n,i,c,s,u,l,a=0,f=!1,p=!1,m=!0;if("function"!=typeof e)throw new TypeError(o);function O(t){var r=n,o=i;return n=i=void 0,a=t,s=e.apply(o,r)}function w(e){return a=e,u=setTimeout(P,t),f?O(e):s}function g(e){var r=e-l;return void 0===l||r>=t||r<0||p&&e-a>=c}function P(){var e=b();if(g(e))return j(e);u=setTimeout(P,function(e){var r=t-(e-l);return p?d(r,c-(e-a)):r}(e));}function j(e){return u=void 0,m&&n?O(e):(n=i=void 0,s)}function T(){var e=b(),r=g(e);if(n=arguments,i=this,l=e,r){if(void 0===u)return w(l);if(p)return u=setTimeout(P,t),O(l)}return void 0===u&&(u=setTimeout(P,t)),s}return t=v(t)||0,h(r)&&(f=!!r.leading,c=(p="maxWait"in r)?y(v(r.maxWait)||0,t):c,m="trailing"in r?!!r.trailing:m),T.cancel=function(){void 0!==u&&clearTimeout(u),a=0,n=l=i=u=void 0;},T.flush=function(){return void 0===u?s:j(b())},T}(e,t,{leading:n,maxWait:t,trailing:i})};},703:(e,t,r)=>{var o=r(414);function n(){}function i(){}i.resetWarningCache=n,e.exports=function(){function e(e,t,r,n,i,c){if(c!==o){var s=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw s.name="Invariant Violation",s}}function t(){return e}e.isRequired=e;var r={array:e,bool:e,func:e,number:e,object:e,string:e,symbol:e,any:e,arrayOf:t,element:e,elementType:e,instanceOf:t,node:e,objectOf:t,oneOf:t,oneOfType:t,shape:t,exact:t,checkPropTypes:i,resetWarningCache:n};return r.PropTypes=r,r};},697:(e,t,r)=>{e.exports=r(703)();},414:e=>{e.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";}},t={};function r(o){var n=t[o];if(void 0!==n)return n.exports;var i=t[o]={exports:{}};return e[o](i,i.exports,r),i.exports}r.n=e=>{var t=e&&e.__esModule?()=>e.default:()=>e;return r.d(t,{a:t}),t},r.d=(e,t)=>{for(var o in t)r.o(t,o)&&!r.o(e,o)&&Object.defineProperty(e,o,{enumerable:!0,get:t[o]});},r.g=function(){if("object"==typeof globalThis)return globalThis;try{return this||new Function("return this")()}catch(e){if("object"==typeof window)return window}}(),r.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),r.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0});};var o={};(()=>{r.r(o),r.d(o,{LazyLoadComponent:()=>J,LazyLoadImage:()=>ue,trackWindowScroll:()=>C});const e=React__default["default"];var t=r.n(e),n=r(697);const i=n__default["default"];var c=r.n(i);function s(){return "undefined"!=typeof window&&"IntersectionObserver"in window&&"isIntersecting"in window.IntersectionObserverEntry.prototype}function u(e){return (u="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,o);}return r}function a(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function f(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function p(e,t){return (p=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function y(e,t){if(t&&("object"===u(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function d(e){return (d=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var b=function(e){e.forEach((function(e){e.isIntersecting&&e.target.onVisible();}));},h={},v=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&p(e,t);}(v,e);var r,o,n,i,u=(n=v,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=d(n);if(i){var r=d(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return y(this,e)});function v(e){var t;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,v),(t=u.call(this,e)).supportsObserver=!e.scrollPosition&&e.useIntersectionObserver&&s(),t.supportsObserver){var r=e.threshold;t.observer=function(e){return h[e]=h[e]||new IntersectionObserver(b,{rootMargin:e+"px"}),h[e]}(r);}return t}return r=v,(o=[{key:"componentDidMount",value:function(){this.placeholder&&this.observer&&(this.placeholder.onVisible=this.props.onVisible,this.observer.observe(this.placeholder)),this.supportsObserver||this.updateVisibility();}},{key:"componentWillUnmount",value:function(){this.observer&&this.placeholder&&this.observer.unobserve(this.placeholder);}},{key:"componentDidUpdate",value:function(){this.supportsObserver||this.updateVisibility();}},{key:"getPlaceholderBoundingBox",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:this.props.scrollPosition,t=this.placeholder.getBoundingClientRect(),r=c().findDOMNode(this.placeholder).style,o={left:parseInt(r.getPropertyValue("margin-left"),10)||0,top:parseInt(r.getPropertyValue("margin-top"),10)||0};return {bottom:e.y+t.bottom+o.top,left:e.x+t.left+o.left,right:e.x+t.right+o.left,top:e.y+t.top+o.top}}},{key:"isPlaceholderInViewport",value:function(){if("undefined"==typeof window||!this.placeholder)return !1;var e=this.props,t=e.scrollPosition,r=e.threshold,o=this.getPlaceholderBoundingBox(t),n=t.y+window.innerHeight,i=t.x,c=t.x+window.innerWidth,s=t.y;return Boolean(s-r<=o.bottom&&n+r>=o.top&&i-r<=o.right&&c+r>=o.left)}},{key:"updateVisibility",value:function(){this.isPlaceholderInViewport()&&this.props.onVisible();}},{key:"render",value:function(){var e=this,r=this.props,o=r.className,n=r.height,i=r.placeholder,c=r.style,s=r.width;if(i&&"function"!=typeof i.type)return t().cloneElement(i,{ref:function(t){return e.placeholder=t}});var u=function(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?l(Object(r),!0).forEach((function(t){a(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):l(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}({display:"inline-block"},c);return void 0!==s&&(u.width=s),void 0!==n&&(u.height=n),t().createElement("span",{className:o,ref:function(t){return e.placeholder=t},style:u},i)}}])&&f(r.prototype,o),v}(t().Component);v.propTypes={onVisible:n.PropTypes.func.isRequired,className:n.PropTypes.string,height:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string]),placeholder:n.PropTypes.element,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,scrollPosition:n.PropTypes.shape({x:n.PropTypes.number.isRequired,y:n.PropTypes.number.isRequired}),width:n.PropTypes.oneOfType([n.PropTypes.number,n.PropTypes.string])},v.defaultProps={className:"",placeholder:null,threshold:100,useIntersectionObserver:!0};const m=v;var O=r(296),w=r.n(O),g=r(96),P=r.n(g),j=function(e){var t=getComputedStyle(e,null);return t.getPropertyValue("overflow")+t.getPropertyValue("overflow-y")+t.getPropertyValue("overflow-x")};const T=function(e){if(!(e instanceof HTMLElement))return window;for(var t=e;t&&t instanceof HTMLElement;){if(/(scroll|auto)/.test(j(t)))return t;t=t.parentNode;}return window};function S(e){return (S="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var E=["delayMethod","delayTime"];function _(){return (_=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);}return e}).apply(this,arguments)}function I(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function L(e,t){return (L=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function x(e,t){if(t&&("object"===S(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return R(e)}function R(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function k(e){return (k=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var D=function(){return "undefined"==typeof window?0:window.scrollX||window.pageXOffset},N=function(){return "undefined"==typeof window?0:window.scrollY||window.pageYOffset};const C=function(e){var r=function(r){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&L(e,t);}(a,r);var o,n,i,u,l=(i=a,u=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=k(i);if(u){var r=k(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return x(this,e)});function a(e){var r;if(function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,a),(r=l.call(this,e)).useIntersectionObserver=e.useIntersectionObserver&&s(),r.useIntersectionObserver)return x(r);var o=r.onChangeScroll.bind(R(r));return "debounce"===e.delayMethod?r.delayedScroll=w()(o,e.delayTime):"throttle"===e.delayMethod&&(r.delayedScroll=P()(o,e.delayTime)),r.state={scrollPosition:{x:D(),y:N()}},r.baseComponentRef=t().createRef(),r}return o=a,(n=[{key:"componentDidMount",value:function(){this.addListeners();}},{key:"componentWillUnmount",value:function(){this.removeListeners();}},{key:"componentDidUpdate",value:function(){"undefined"==typeof window||this.useIntersectionObserver||T(c().findDOMNode(this.baseComponentRef.current))!==this.scrollElement&&(this.removeListeners(),this.addListeners());}},{key:"addListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement=T(c().findDOMNode(this.baseComponentRef.current)),this.scrollElement.addEventListener("scroll",this.delayedScroll,{passive:!0}),window.addEventListener("resize",this.delayedScroll,{passive:!0}),this.scrollElement!==window&&window.addEventListener("scroll",this.delayedScroll,{passive:!0}));}},{key:"removeListeners",value:function(){"undefined"==typeof window||this.useIntersectionObserver||(this.scrollElement.removeEventListener("scroll",this.delayedScroll),window.removeEventListener("resize",this.delayedScroll),this.scrollElement!==window&&window.removeEventListener("scroll",this.delayedScroll));}},{key:"onChangeScroll",value:function(){this.useIntersectionObserver||this.setState({scrollPosition:{x:D(),y:N()}});}},{key:"render",value:function(){var r=this.props,o=(r.delayMethod,r.delayTime,function(e,t){if(null==e)return {};var r,o,n=function(e,t){if(null==e)return {};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r]);}return n}(r,E)),n=this.useIntersectionObserver?null:this.state.scrollPosition;return t().createElement(e,_({forwardRef:this.baseComponentRef,scrollPosition:n},o))}}])&&I(o.prototype,n),a}(t().Component);return r.propTypes={delayMethod:n.PropTypes.oneOf(["debounce","throttle"]),delayTime:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool},r.defaultProps={delayMethod:"throttle",delayTime:300,useIntersectionObserver:!0},r};function M(e){return (M="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function B(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function V(e,t){return (V=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function W(e,t){if(t&&("object"===M(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function z(e){return (z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var $=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&V(e,t);}(s,e);var r,o,n,i,c=(n=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=z(n);if(i){var r=z(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return W(this,e)});function s(e){return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),c.call(this,e)}return r=s,(o=[{key:"render",value:function(){return t().createElement(m,this.props)}}])&&B(r.prototype,o),s}(t().Component);const U=C($);function q(e){return (q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function F(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function H(e,t){return (H=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function Y(e,t){if(t&&("object"===q(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return X(e)}function X(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function A(e){return (A=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var G=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&H(e,t);}(u,e);var r,o,n,i,c=(n=u,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=A(n);if(i){var r=A(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return Y(this,e)});function u(e){var t;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,u),t=c.call(this,e);var r=e.afterLoad,o=e.beforeLoad,n=e.scrollPosition,i=e.visibleByDefault;return t.state={visible:i},i&&(o(),r()),t.onVisible=t.onVisible.bind(X(t)),t.isScrollTracked=Boolean(n&&Number.isFinite(n.x)&&n.x>=0&&Number.isFinite(n.y)&&n.y>=0),t}return r=u,(o=[{key:"componentDidUpdate",value:function(e,t){t.visible!==this.state.visible&&this.props.afterLoad();}},{key:"onVisible",value:function(){this.props.beforeLoad(),this.setState({visible:!0});}},{key:"render",value:function(){if(this.state.visible)return this.props.children;var e=this.props,r=e.className,o=e.delayMethod,n=e.delayTime,i=e.height,c=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.width;return this.isScrollTracked||f&&s()?t().createElement(m,{className:r,height:i,onVisible:this.onVisible,placeholder:c,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,width:p}):t().createElement(U,{className:r,delayMethod:o,delayTime:n,height:i,onVisible:this.onVisible,placeholder:c,style:l,threshold:a,width:p})}}])&&F(r.prototype,o),u}(t().Component);G.propTypes={afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool},G.defaultProps={afterLoad:function(){return {}},beforeLoad:function(){return {}},useIntersectionObserver:!0,visibleByDefault:!1};const J=G;function K(e){return (K="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}var Q=["afterLoad","beforeLoad","delayMethod","delayTime","effect","placeholder","placeholderSrc","scrollPosition","threshold","useIntersectionObserver","visibleByDefault","wrapperClassName","wrapperProps"];function Z(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var o=Object.getOwnPropertySymbols(e);t&&(o=o.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,o);}return r}function ee(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?Z(Object(r),!0).forEach((function(t){te(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):Z(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function te(e,t,r){return t in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function re(){return (re=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var o in r)Object.prototype.hasOwnProperty.call(r,o)&&(e[o]=r[o]);}return e}).apply(this,arguments)}function oe(e,t){for(var r=0;r<t.length;r++){var o=t[r];o.enumerable=o.enumerable||!1,o.configurable=!0,"value"in o&&(o.writable=!0),Object.defineProperty(e,o.key,o);}}function ne(e,t){return (ne=Object.setPrototypeOf||function(e,t){return e.__proto__=t,e})(e,t)}function ie(e,t){if(t&&("object"===K(t)||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return function(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}(e)}function ce(e){return (ce=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}var se=function(e){!function(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),t&&ne(e,t);}(s,e);var r,o,n,i,c=(n=s,i=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}(),function(){var e,t=ce(n);if(i){var r=ce(this).constructor;e=Reflect.construct(t,arguments,r);}else e=t.apply(this,arguments);return ie(this,e)});function s(e){var t;return function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,s),(t=c.call(this,e)).state={loaded:!1},t}return r=s,(o=[{key:"onImageLoad",value:function(){var e=this;return this.state.loaded?null:function(){e.props.afterLoad(),e.setState({loaded:!0});}}},{key:"getImg",value:function(){var e=this.props,r=(e.afterLoad,e.beforeLoad,e.delayMethod,e.delayTime,e.effect,e.placeholder,e.placeholderSrc,e.scrollPosition,e.threshold,e.useIntersectionObserver,e.visibleByDefault,e.wrapperClassName,e.wrapperProps,function(e,t){if(null==e)return {};var r,o,n=function(e,t){if(null==e)return {};var r,o,n={},i=Object.keys(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||(n[r]=e[r]);return n}(e,t);if(Object.getOwnPropertySymbols){var i=Object.getOwnPropertySymbols(e);for(o=0;o<i.length;o++)r=i[o],t.indexOf(r)>=0||Object.prototype.propertyIsEnumerable.call(e,r)&&(n[r]=e[r]);}return n}(e,Q));return t().createElement("img",re({onLoad:this.onImageLoad()},r))}},{key:"getLazyLoadImage",value:function(){var e=this.props,r=e.beforeLoad,o=e.className,n=e.delayMethod,i=e.delayTime,c=e.height,s=e.placeholder,u=e.scrollPosition,l=e.style,a=e.threshold,f=e.useIntersectionObserver,p=e.visibleByDefault,y=e.width;return t().createElement(J,{beforeLoad:r,className:o,delayMethod:n,delayTime:i,height:c,placeholder:s,scrollPosition:u,style:l,threshold:a,useIntersectionObserver:f,visibleByDefault:p,width:y},this.getImg())}},{key:"getWrappedLazyLoadImage",value:function(e){var r=this.props,o=r.effect,n=r.height,i=r.placeholderSrc,c=r.width,s=r.wrapperClassName,u=r.wrapperProps,l=this.state.loaded,a=l?" lazy-load-image-loaded":"",f=l||!i?{}:{backgroundImage:"url(".concat(i,")"),backgroundSize:"100% 100%"};return t().createElement("span",re({className:s+" lazy-load-image-background "+o+a,style:ee(ee({},f),{},{color:"transparent",display:"inline-block",height:n,width:c})},u),e)}},{key:"render",value:function(){var e=this.props,t=e.effect,r=e.placeholderSrc,o=e.visibleByDefault,n=e.wrapperClassName,i=e.wrapperProps,c=this.getLazyLoadImage();return (t||r)&&!o||n||i?this.getWrappedLazyLoadImage(c):c}}])&&oe(r.prototype,o),s}(t().Component);se.propTypes={afterLoad:n.PropTypes.func,beforeLoad:n.PropTypes.func,delayMethod:n.PropTypes.string,delayTime:n.PropTypes.number,effect:n.PropTypes.string,placeholderSrc:n.PropTypes.string,threshold:n.PropTypes.number,useIntersectionObserver:n.PropTypes.bool,visibleByDefault:n.PropTypes.bool,wrapperClassName:n.PropTypes.string,wrapperProps:n.PropTypes.object},se.defaultProps={afterLoad:function(){return {}},beforeLoad:function(){return {}},delayMethod:"throttle",delayTime:300,effect:"",placeholderSrc:null,threshold:100,useIntersectionObserver:!0,visibleByDefault:!1,wrapperClassName:""};const ue=se;})(),build.exports=o;})();

var css$Y = ".blur_lazyLoadImageBackground__71fb014b.blur_blur__71fb014b {\n  filter: blur(15px);\n}\n\n.blur_lazyLoadImageBackground__71fb014b.blur_blur__71fb014b.blur_lazyLoadImageLoaded__71fb014b {\n  filter: blur(0);\n  transition: filter .3s;\n}\n\n.blur_lazyLoadImageBackground__71fb014b.blur_blur__71fb014b > img {\n  opacity: 0;\n}\n\n.blur_lazyLoadImageBackground__71fb014b.blur_blur__71fb014b.blur_lazyLoadImageLoaded__71fb014b > img {\n  opacity: 1;\n  transition: opacity .3s;\n}\n";
injectCss(css$Y);

var css$X = ".Image_module_radiusXXS__97eac546 {\n  border-radius: 4px;\n}\n\n.Image_module_radiusXS__97eac546 {\n  border-radius: 8px;\n}\n\n.Image_module_radiusS__97eac546 {\n  border-radius: 10px;\n}\n\n.Image_module_radiusBase__97eac546 {\n  border-radius: 14px;\n}\n\n.Image_module_radiusM__97eac546 {\n  border-radius: 24px;\n}\n\n.Image_module_radiusL__97eac546 {\n  border-radius: 48px;\n}\n\n.Image_module_radiusXL__97eac546 {\n  border-radius: 72px;\n}\n\n.Image_module_radiusCircle__97eac546 {\n  border-radius: 50%;\n}\n\n.Image_module_objectFitCover__97eac546 {\n  object-fit: cover;\n}\n\n.Image_module_objectFitFill__97eac546 {\n  object-fit: fill;\n}\n\n.Image_module_objectFitContain__97eac546 {\n  object-fit: contain;\n}\n\n.Image_module_objectFitScaleDown__97eac546 {\n  object-fit: scale-down;\n}\n\n.Image_module_objectPositionCenter__97eac546 {\n  object-position: center;\n}\n\n.Image_module_objectPositionCenterTop__97eac546 {\n  object-position: center top;\n}\n\n.Image_module_objectPositionCenterBottom__97eac546 {\n  object-position: center bottom;\n}\n\n.Image_module_objectPositionLeftCenter__97eac546 {\n  object-position: left center;\n}\n\n.Image_module_objectPositionLeftTop__97eac546 {\n  object-position: left top;\n}\n\n.Image_module_objectPositionLeftBottom__97eac546 {\n  object-position: left bottom;\n}\n\n.Image_module_objectPositionRightCenter__97eac546 {\n  object-position: right center;\n}\n\n.Image_module_objectPositionRightTop__97eac546 {\n  object-position: right top;\n}\n\n.Image_module_objectPositionRightBottom__97eac546 {\n  object-position: right bottom;\n}\n\n.Image_module_aspectRatio4_3__97eac546 {\n  aspect-ratio: 4/3;\n}\n\n.Image_module_aspectRatio3_4__97eac546 {\n  aspect-ratio: 3/4;\n}\n\n.Image_module_aspectRatio16_9__97eac546 {\n  aspect-ratio: 16/9;\n}\n\n.Image_module_aspectRatio9_16__97eac546 {\n  aspect-ratio: 9/16;\n}\n\n.Image_module_aspectRatio1_1__97eac546 {\n  aspect-ratio: 1/1;\n}";
injectCss(css$X);
var modules_6f921488 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","radiusXXS":"Image_module_radiusXXS__97eac546","radiusXS":"Image_module_radiusXS__97eac546","radiusS":"Image_module_radiusS__97eac546","radiusBase":"Image_module_radiusBase__97eac546","radiusM":"Image_module_radiusM__97eac546","radiusL":"Image_module_radiusL__97eac546","radiusXL":"Image_module_radiusXL__97eac546","radiusCircle":"Image_module_radiusCircle__97eac546","objectFitCover":"Image_module_objectFitCover__97eac546","objectFitFill":"Image_module_objectFitFill__97eac546","objectFitContain":"Image_module_objectFitContain__97eac546","objectFitScaleDown":"Image_module_objectFitScaleDown__97eac546","objectPositionCenter":"Image_module_objectPositionCenter__97eac546","objectPositionCenterTop":"Image_module_objectPositionCenterTop__97eac546","objectPositionCenterBottom":"Image_module_objectPositionCenterBottom__97eac546","objectPositionLeftCenter":"Image_module_objectPositionLeftCenter__97eac546","objectPositionLeftTop":"Image_module_objectPositionLeftTop__97eac546","objectPositionLeftBottom":"Image_module_objectPositionLeftBottom__97eac546","objectPositionRightCenter":"Image_module_objectPositionRightCenter__97eac546","objectPositionRightTop":"Image_module_objectPositionRightTop__97eac546","objectPositionRightBottom":"Image_module_objectPositionRightBottom__97eac546","aspectRatio4_3":"Image_module_aspectRatio4_3__97eac546","aspectRatio3_4":"Image_module_aspectRatio3_4__97eac546","aspectRatio16_9":"Image_module_aspectRatio16_9__97eac546","aspectRatio9_16":"Image_module_aspectRatio9_16__97eac546","aspectRatio1_1":"Image_module_aspectRatio1_1__97eac546"};

function Image(_ref) {
  var extraClass = _ref.extraClass,
    alt = _ref.alt,
    height = _ref.height,
    width = _ref.width,
    src = _ref.src,
    loaderSrc = _ref.loaderSrc,
    defaultImg = _ref.defaultImg,
    scrollAmount = _ref.scrollAmount,
    useIntersectionObserver = _ref.useIntersectionObserver,
    onError = _ref.onError,
    roundCornerAll = _ref.roundCornerAll,
    objectFit = _ref.objectFit,
    objectPosition = _ref.objectPosition,
    maskImageSrc = _ref.maskImageSrc,
    _ref$maskRepeat = _ref.maskRepeat,
    maskRepeat = _ref$maskRepeat === void 0 ? "no-repeat" : _ref$maskRepeat,
    _ref$maskSize = _ref.maskSize,
    maskSize = _ref$maskSize === void 0 ? "100% 100%" : _ref$maskSize,
    _ref$maskPosition = _ref.maskPosition,
    maskPosition = _ref$maskPosition === void 0 ? "center center" : _ref$maskPosition,
    aspectRatio = _ref.aspectRatio;
  var onErrorHandler = function onErrorHandler(e) {
    if (e.target.src == defaultImg || !defaultImg) {
      onError === null || onError === void 0 ? void 0 : onError(e);
    } else {
      e.target.src = defaultImg || '';
    }
  };
  return /*#__PURE__*/React__default["default"].createElement(build.exports.LazyLoadImage, {
    className: [extraClass, roundCornerAll == "radiusXXS" ? modules_6f921488.radiusXXS : roundCornerAll == "radiusXS" ? modules_6f921488.radiusXS : roundCornerAll == "radiusS" ? modules_6f921488.radiusS : roundCornerAll == "radiusBase" ? modules_6f921488.radiusBase : roundCornerAll == "radiusM" ? modules_6f921488.radiusM : roundCornerAll == "radiusL" ? modules_6f921488.radiusL : roundCornerAll == "radiusXL" ? modules_6f921488.radiusXL : roundCornerAll == "radiusCircle" ? modules_6f921488.radiusCircle : null, objectFit == "cover" ? modules_6f921488.objectFitCover : objectFit == "fill" ? modules_6f921488.objectFitFill : objectFit == "contain" ? modules_6f921488.objectFitContain : objectFit == "scale-down" ? modules_6f921488.objectFitScaleDown : null, objectPosition == "center" ? modules_6f921488.objectPositionCenter : objectPosition == "center top" ? modules_6f921488.objectPositionCenterTop : objectPosition == "center Bottom" ? modules_6f921488.objectPositionCenterBottom : objectPosition == "left center" ? modules_6f921488.objectPositionLeftCenter : objectPosition == "left top" ? modules_6f921488.objectPositionLeftTop : objectPosition == "left bottom" ? modules_6f921488.objectPositionLeftBottom : objectPosition == "right center" ? modules_6f921488.objectPositionRightCenter : objectPosition == "right top" ? modules_6f921488.objectPositionRightTop : objectPosition == "right bottom" ? modules_6f921488.objectPositionRightBottom : null, aspectRatio == "4 / 3" ? modules_6f921488.aspectRatio4_3 : aspectRatio == "3 / 4" ? modules_6f921488.aspectRatio3_4 : aspectRatio == "16 / 9" ? modules_6f921488.aspectRatio16_9 : aspectRatio == "9 / 16" ? modules_6f921488.aspectRatio9_16 : aspectRatio == "1 / 1" ? modules_6f921488.aspectRatio1_1 : null].join(' '),
    alt: alt,
    height: height,
    width: width,
    src: src,
    placeholder: /*#__PURE__*/React__default["default"].createElement(Loader$1, null),
    placeholderSrc: loaderSrc,
    threshold: scrollAmount,
    useIntersectionObserver: useIntersectionObserver,
    onError: onErrorHandler,
    style: maskImageSrc ? {
      WebkitMaskImage: 'url(' + maskImageSrc + ')',
      maskImage: 'url(' + maskImageSrc + ')',
      WebkitMaskRepeat: '' + maskRepeat + '',
      maskRepeat: '' + maskRepeat + '',
      WebkitMaskSize: '' + maskSize + '',
      maskSize: '' + maskSize + '',
      WebkitMaskPosition: '' + maskPosition + '',
      maskPosition: '' + maskPosition + ''
    } : null
  });
}
var radiusOptions$1 = ["radiusXXS", "radiusXS", "radiusS", "radiusBase", "radiusM", "radiusL", "radiusXL", "radiusCircle"];
var objectFitOptions = ["none", "cover", "fill", "contain", "scale-down"];
var objectPositionOptions = ["none", "center", "center top", "center bottom", "left center", "left top", "left bottom", "right center", "right top", "right bottom"];
var aspectRatioOptions$1 = ["auto", "4 / 3", "3 / 4", "16 / 9", "9 / 16", "1 / 1"];
Image.propTypes = {
  extraClass: propTypes.exports.string,
  alt: propTypes.exports.string,
  height: propTypes.exports.string,
  width: propTypes.exports.string,
  src: propTypes.exports.string,
  defaultImg: propTypes.exports.string,
  loaderSrc: propTypes.exports.string,
  scrollAmount: propTypes.exports.number,
  useIntersectionObserver: propTypes.exports.bool,
  roundCornerAll: propTypes.exports.oneOf(radiusOptions$1),
  objectFit: propTypes.exports.oneOf(objectFitOptions),
  objectPosition: propTypes.exports.oneOf(objectPositionOptions),
  maskImageSrc: propTypes.exports.string,
  maskRepeat: propTypes.exports.string,
  maskSize: propTypes.exports.string,
  maskPosition: propTypes.exports.oneOf(objectPositionOptions),
  aspectRatio: propTypes.exports.oneOf(aspectRatioOptions$1)
};

var css$W = ".Checkbox_module_Checkbox__0a59ac12 {\n  width: auto;\n  margin: 0 24px 24px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n.Checkbox_module_Checkbox__0a59ac12 * {\n  cursor: pointer;\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.Checkbox_module_Checkbox__0a59ac12 label {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #444f6b;\n}\n.Checkbox_module_Checkbox__0a59ac12 label input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  display: inline-block;\n}\n.Checkbox_module_Checkbox__0a59ac12 label input:checked ~ .Checkbox_module_CheckboxBtn__0a59ac12 .Checkbox_module_CheckboxIcon__0a59ac12 {\n  background-color: transparent;\n  opacity: 0;\n  transform: scale(0.5);\n}\n.Checkbox_module_Checkbox__0a59ac12 label input:checked ~ .Checkbox_module_CheckboxBtn__0a59ac12 svg {\n  opacity: 1;\n  transform: scale(1);\n}\n.Checkbox_module_Checkbox__0a59ac12 label input:focus-within ~ .Checkbox_module_CheckboxBtn__0a59ac12 {\n  border: 3px solid #444F6B;\n}\n.Checkbox_module_Checkbox__0a59ac12 label input:focus {\n  outline: none;\n}\n@media only screen and (min-width: 1024px) {\n  .Checkbox_module_Checkbox__0a59ac12 label:hover .Checkbox_module_CheckboxBtn__0a59ac12 {\n    outline: none;\n    background-color: transparent;\n    border: 4px solid #444F6B;\n  }\n}\n.Checkbox_module_Checkbox__0a59ac12 .Checkbox_module_CheckboxBtn__0a59ac12 {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  position: relative;\n  margin: 0 14px 0 0;\n  padding: 0;\n  border: 2px;\n  border-radius: 12px;\n  vertical-align: middle;\n  outline: none;\n  pointer-events: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n}\n.Checkbox_module_Checkbox__0a59ac12 .Checkbox_module_CheckboxBtn__0a59ac12::-ms-expand {\n  display: none;\n}\n.Checkbox_module_Checkbox__0a59ac12 .Checkbox_module_CheckboxBtn__0a59ac12 .Checkbox_module_CheckboxIcon__0a59ac12 {\n  width: 16px;\n  height: 16px;\n  display: block;\n  position: absolute;\n  left: calc(50% - 8px);\n  top: calc(50% - 8px);\n  transform: scale(1);\n  opacity: 1;\n  border: 2px solid #444F6B;\n  border-radius: 8px;\n  margin: auto;\n  transform: scale(1);\n}\n.Checkbox_module_Checkbox__0a59ac12 .Checkbox_module_CheckboxBtn__0a59ac12 svg {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  left: calc(50% - 12px);\n  top: calc(50% - 12px);\n  opacity: 0;\n  transform: scale(0.5);\n}\n.Checkbox_module_Checkbox__0a59ac12 input[type=checkbox] ~ .Checkbox_module_CheckboxBtn__0a59ac12 {\n  border-radius: 12px;\n}\n.Checkbox_module_Checkbox__0a59ac12 input[type=checkbox] ~ .Checkbox_module_CheckboxBtn__0a59ac12 .Checkbox_module_CheckboxIcon__0a59ac12 {\n  width: 16px;\n  height: 16px;\n  border-radius: 4px;\n  position: absolute;\n  left: calc(50% - 8px);\n  top: calc(50% - 8px);\n  background: transparent !important;\n  opacity: 1;\n  transform: scale(1);\n}\n.Checkbox_module_Checkbox__0a59ac12 input[type=checkbox] ~ .Checkbox_module_CheckboxBtn__0a59ac12 svg {\n  width: 24px;\n  height: 24px;\n  position: absolute;\n  left: calc(50% - 12px);\n  top: calc(50% - 12px);\n  opacity: 0;\n  transform: scale(0.5);\n}\n.Checkbox_module_Checkbox__0a59ac12 input[type=checkbox]:checked ~ .Checkbox_module_CheckboxBtn__0a59ac12 .Checkbox_module_CheckboxIcon__0a59ac12 {\n  background-color: transparent;\n  opacity: 0;\n  transform: scale(0.5);\n}\n.Checkbox_module_Checkbox__0a59ac12 input[type=checkbox]:checked ~ .Checkbox_module_CheckboxBtn__0a59ac12 svg {\n  opacity: 1;\n  transform: scale(1);\n}";
injectCss(css$W);
var modules_6238daf1 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Checkbox":"Checkbox_module_Checkbox__0a59ac12","CheckboxBtn":"Checkbox_module_CheckboxBtn__0a59ac12","CheckboxIcon":"Checkbox_module_CheckboxIcon__0a59ac12"};

function Checkbox(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    required = _ref.required;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_6238daf1.Checkbox
  }, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "checkbox",
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    checked: checked,
    disabled: disabled,
    tabIndex: "0",
    required: required
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_6238daf1.CheckboxBtn
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: modules_6238daf1.CheckboxIcon
  }), /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconHSize: 24,
    iconName: 'ui-check',
    iconWSize: 24
  })), label));
}
Checkbox.propTypes = {
  id: propTypes.exports.string.isRequired,
  name: propTypes.exports.string.isRequired,
  value: propTypes.exports.string.isRequired,
  label: propTypes.exports.string.isRequired,
  checked: propTypes.exports.bool,
  disabled: propTypes.exports.bool,
  onChange: propTypes.exports.func,
  required: propTypes.exports.bool
};

var css$V = ".Fieldset_module_Fieldset__b60f6aaf {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.Fieldset_module_Fieldset__b60f6aaf legend {\n  margin-bottom: 14px;\n  display: inline-block;\n}";
injectCss(css$V);
var modules_76ea8ff8 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Fieldset":"Fieldset_module_Fieldset__b60f6aaf"};

var Fieldset = function Fieldset(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("fieldset", {
    className: [modules_76ea8ff8.Fieldset, props.extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("legend", null, /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S",
    bold: true,
    uppercase: true
  }, props.legend)), props.children));
};
Fieldset.propTypes = {
  extraClass: propTypes.exports.string,
  legend: propTypes.exports.string.isRequired,
  size: propTypes.exports.oneOf(['XXL', 'XL', 'L', 'M', 'BASE', 'S', 'XS', 'XXS']),
  serif: propTypes.exports.bool,
  bold: propTypes.exports.bool,
  underline: propTypes.exports.bool,
  uppercase: propTypes.exports.bool,
  lowercase: propTypes.exports.bool
};

var css$U = ".Form_module_Fieldset__496c3632 {\n  margin: 0;\n  padding: 0;\n  border: 0;\n  font-size: 100%;\n  font: inherit;\n  vertical-align: baseline;\n}";
injectCss(css$U);
var modules_b9bf355c = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Fieldset":"Form_module_Fieldset__496c3632"};

var Form = function Form(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("form", {
    className: [modules_b9bf355c.Form, props.extraClass].join(" "),
    name: props.formName,
    method: props.method,
    target: props.target,
    rel: props.rel,
    autoComplete: props.autoComplete,
    action: props.formAction
  }, props.children));
};
Form.propTypes = {
  extraClass: propTypes.exports.string,
  formName: propTypes.exports.string,
  method: propTypes.exports.string,
  target: propTypes.exports.oneOf(['_blank', '_self', '_parent', '_top']),
  rel: propTypes.exports.oneOf(['external', 'help', 'license', 'next', 'nofollow', 'noopener', 'noreferrer', 'opener', 'prev', 'search']),
  autoComplete: propTypes.exports.oneOf(['on', 'off']),
  formAction: propTypes.exports.string
};

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends$4() {
  _extends$4 = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends$4.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf$1(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self);
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var css$T = ".Input_module_Input__78b6c3c8 {\n  height: auto;\n  max-width: 420px;\n  margin: 0 0 24px 0;\n  position: relative;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #444F6B;\n  z-index: 2;\n}\n.Input_module_Input__78b6c3c8 * {\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.Input_module_Input__78b6c3c8 input {\n  width: 100%;\n  height: 52px;\n  margin: 0;\n  border-radius: 48px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  color: #444F6B;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  -webkit-appearance: none;\n  /* add this */\n  padding-left: 32px;\n  position: relative;\n  z-index: 2;\n}\n.Input_module_Input__78b6c3c8 input:focus, .Input_module_Input__78b6c3c8 input:hover {\n  outline: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  border: 4px solid #444F6B;\n}\n.Input_module_Input__78b6c3c8 input::placeholder {\n  color: #444F69;\n  opacity: 1;\n  font-weight: 400;\n}\n.Input_module_Input__78b6c3c8 input.Input_module_Error__78b6c3c8 {\n  outline: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  border: 4px solid #444F6B;\n}\n.Input_module_Input__78b6c3c8 label {\n  width: 100%;\n  text-align: left;\n  padding-left: 5px;\n  margin-bottom: 12px;\n  display: inline-block;\n  color: #444F6B;\n  font-weight: 700;\n}\n.Input_module_Input__78b6c3c8 svg {\n  fill: #444F6B;\n}\n.Input_module_Input_Full__78b6c3c8 {\n  width: 100%;\n  max-width: none;\n}\n.Input_module_Input__78b6c3c8 label.Input_module_hideLabel__78b6c3c8 {\n  position: absolute;\n  z-index: -2;\n}\n.Input_module_Input__78b6c3c8.Input_module_Icon__78b6c3c8 input {\n  padding-left: 52px;\n}\n.Input_module_Input__78b6c3c8.Input_module_Icon__78b6c3c8.Input_module_Input_NoLabel__78b6c3c8 label {\n  left: 46px;\n}\n.Input_module_Input__78b6c3c8.Input_module_Icon__78b6c3c8 svg {\n  width: 24px;\n  height: 52px;\n  position: absolute;\n  left: 18px;\n  bottom: 0px;\n  pointer-events: none;\n  z-index: 4;\n}\n.Input_module_Input__78b6c3c8.Input_module_Icon__78b6c3c8 svg svg.Input_module_mdsIcons__78b6c3c8,\n.Input_module_Input__78b6c3c8.Input_module_Icon__78b6c3c8 svg svg {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  left: auto;\n  top: auto;\n}\n.Input_module_Input__78b6c3c8.Input_module_NoLabel__78b6c3c8 label {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8 input {\n  padding-left: 52px;\n}\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8.Input_module_Input_NoLabel__78b6c3c8 label {\n  left: 46px;\n}\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8 svg {\n  width: 24px;\n  height: 52px;\n  position: absolute;\n  left: 18px;\n  bottom: 0px;\n  pointer-events: none;\n}\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8 svg svg.Input_module_mdsIcons__78b6c3c8,\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8 svg svg {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  left: auto;\n  top: auto;\n}\n.Input_module_Input__78b6c3c8.Input_module_IconNoLabel__78b6c3c8 label {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.Input_module_Input__78b6c3c8.Input_module_autoWidth__78b6c3c8 {\n  max-width: none;\n}\n.Input_module_Input__78b6c3c8.Input_module_autoWidth__78b6c3c8 input {\n  max-width: none;\n}";
injectCss(css$T);
var modules_23691de0 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Input":"Input_module_Input__78b6c3c8","Error":"Input_module_Error__78b6c3c8","Input--full":"Input_module_Input_Full__78b6c3c8","hideLabel":"Input_module_hideLabel__78b6c3c8","Icon":"Input_module_Icon__78b6c3c8","Input--no-label":"Input_module_Input_NoLabel__78b6c3c8","mds-icons":"Input_module_mdsIcons__78b6c3c8","NoLabel":"Input_module_NoLabel__78b6c3c8","IconNoLabel":"Input_module_IconNoLabel__78b6c3c8","autoWidth":"Input_module_autoWidth__78b6c3c8"};

var _InputPropTypes;

//Input Styles
var getClassNames$7 = function getClassNames(Input, props) {
  return [Input, props.style || "", props.hideLabel ? modules_23691de0.NoLabel : "", props.showIcon && props.iconName ? modules_23691de0.Icon : "", props.extraClass || "", props.autoWidth ? modules_23691de0.autoWidth : null].join(" ");
};
var Input = function Input(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$7(modules_23691de0.Input, props)
  }, /*#__PURE__*/React__default["default"].createElement(Label, {
    htmlFor: props.name
  }, props.label), /*#__PURE__*/React__default["default"].createElement("input", {
    className: props.formError ? modules_23691de0.Error : null,
    id: props.id,
    name: props.name,
    type: props.type,
    placeholder: props.placeholder,
    onChange: props.onChange,
    onKeyUp: props.onKeyUp,
    onKeyDown: props.onKeyDown,
    value: props.value,
    autoComplete: props.autocompleteoff ? "off" : null,
    required: props.required,
    pattern: props.pattern,
    minLength: props.minLength,
    maxLength: props.maxLength,
    max: props.max,
    min: props.min
  }), props.children, props.showIcon && props.iconName ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconHSize: 24,
    iconName: props.iconName,
    iconWSize: 24
  }) : null);
};
var InputPropTypes = (_InputPropTypes = {
  type: propTypes.exports.oneOf(["text", "number", "password", "color", "email", "tel", "url", "search", "hidden"]).isRequired,
  id: propTypes.exports.string,
  name: propTypes.exports.string.isRequired,
  label: propTypes.exports.string.isRequired,
  placeholder: propTypes.exports.string.isRequired,
  value: propTypes.exports.string,
  onKeyUp: propTypes.exports.func,
  onKeyDown: propTypes.exports.func,
  hideLabel: propTypes.exports.bool,
  showIcon: propTypes.exports.bool,
  iconName: propTypes.exports.string,
  extraClass: propTypes.exports.string,
  autocompleteoff: propTypes.exports.bool,
  pattern: propTypes.exports.string,
  required: propTypes.exports.bool,
  minLength: propTypes.exports.string,
  maxLength: propTypes.exports.string
}, _defineProperty(_InputPropTypes, "minLength", propTypes.exports.string), _defineProperty(_InputPropTypes, "maxLength", propTypes.exports.string), _defineProperty(_InputPropTypes, "formError", propTypes.exports.bool), _defineProperty(_InputPropTypes, "errorMessage", propTypes.exports.string), _defineProperty(_InputPropTypes, "autoWidth", propTypes.exports.bool), _InputPropTypes);
Input.propTypes = InputPropTypes;

var css$S = ".TextArea_module_TextArea__94e21755 {\n  height: auto;\n  max-width: 420px;\n  margin: 0 0 1.5rem 0;\n  position: relative;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #444F6B;\n}\n.TextArea_module_TextArea__94e21755 * {\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.TextArea_module_TextArea__94e21755 textarea {\n  width: 100%;\n  min-height: 200px;\n  margin: 0;\n  border-radius: 24px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  color: #444F6B;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  -webkit-appearance: none;\n  /* add this */\n  padding: 14px;\n}\n.TextArea_module_TextArea__94e21755 textarea:focus, .TextArea_module_TextArea__94e21755 textarea:hover {\n  outline: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  border: 4px solid #444F6B;\n}\n.TextArea_module_TextArea__94e21755 textarea::placeholder {\n  color: #444F69;\n  opacity: 1;\n}\n.TextArea_module_TextArea__94e21755 label {\n  width: 100%;\n  text-align: left;\n  padding-left: 5px;\n  margin-bottom: 12px;\n  display: inline-block;\n  color: #444F6B;\n  font-weight: 700;\n}\n.TextArea_module_TextArea_Full__94e21755 {\n  width: 100%;\n  max-width: none;\n}\n.TextArea_module_TextArea_Full__94e21755 textarea {\n  width: 100%;\n  max-width: none;\n}";
injectCss(css$S);
var modules_923c63ea = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","TextArea":"TextArea_module_TextArea__94e21755","TextArea--full":"TextArea_module_TextArea_Full__94e21755"};

var getClassNames$6 = function getClassNames(TextArea, props) {
  return [TextArea, props.extraClass || ''].join(' ');
};
var TextArea = function TextArea(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$6(modules_923c63ea.TextArea, props)
  }, /*#__PURE__*/React__default["default"].createElement(Label, {
    htmlFor: props.name
  }, props.label), /*#__PURE__*/React__default["default"].createElement("textarea", {
    id: props.name,
    name: props.name,
    placeholder: props.placeholder,
    onChange: props.onChange,
    required: props.required,
    style: {
      minHeight: props.height
    }
    //   autocomplete={props.autocompleteoff ? ("off") : null}
  }, props.children));
};
var TextAreaPropTypes = {
  name: propTypes.exports.string.isRequired,
  label: propTypes.exports.string.isRequired,
  placeholder: propTypes.exports.string.isRequired,
  onChange: propTypes.exports.func,
  extraClass: propTypes.exports.string,
  required: propTypes.exports.bool,
  height: propTypes.exports.string
};
TextArea.propTypes = TextAreaPropTypes;

var css$R = ".Radio_module_Radio__444459a3 {\n  width: auto;\n  margin: 0 24px 24px 0;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n.Radio_module_Radio__444459a3 * {\n  cursor: pointer;\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.Radio_module_Radio__444459a3 label {\n  display: inline-block;\n  font-size: 14px;\n  font-weight: 700;\n  color: #444f6b;\n}\n.Radio_module_Radio__444459a3 label input {\n  position: absolute;\n  opacity: 0;\n  cursor: pointer;\n  display: inline-block;\n}\n.Radio_module_Radio__444459a3 label input:checked ~ .Radio_module_RadioBtn__444459a3 .Radio_module_RadioIcon__444459a3 {\n  background-color: #444F6B;\n}\n.Radio_module_Radio__444459a3 label input:focus-within ~ .Radio_module_RadioBtn__444459a3 {\n  border: 4px solid #444F6B;\n}\n.Radio_module_Radio__444459a3 label input:focus {\n  outline: none;\n}\n@media only screen and (min-width: 800px) {\n  .Radio_module_Radio__444459a3 label:hover .Radio_module_RadioBtn__444459a3 {\n    outline: none;\n    background-color: transparent;\n    border: 4px solid #444F6B;\n  }\n}\n.Radio_module_Radio__444459a3 .Radio_module_RadioBtn__444459a3 {\n  width: 38px;\n  height: 38px;\n  display: inline-flex;\n  position: relative;\n  margin: 0 14px 0 0;\n  padding: 0;\n  border: 2px;\n  border-radius: 48px;\n  vertical-align: middle;\n  outline: none;\n  pointer-events: none;\n  -webkit-appearance: none;\n  appearance: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n}\n.Radio_module_Radio__444459a3 .Radio_module_RadioBtn__444459a3::-ms-expand {\n  display: none;\n}\n.Radio_module_Radio__444459a3 .Radio_module_RadioBtn__444459a3 .Radio_module_RadioIcon__444459a3 {\n  width: 16px;\n  height: 16px;\n  display: block;\n  position: absolute;\n  left: calc(50% - 8px);\n  top: calc(50% - 8px);\n  transform: scale(1);\n  opacity: 0.9;\n  border: 2px solid #444F6B;\n  border-radius: 8px;\n  margin: auto;\n}";
injectCss(css$R);
var modules_8fc278f9 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Radio":"Radio_module_Radio__444459a3","RadioBtn":"Radio_module_RadioBtn__444459a3","RadioIcon":"Radio_module_RadioIcon__444459a3"};

function Radio(_ref) {
  var id = _ref.id,
    name = _ref.name,
    value = _ref.value,
    label = _ref.label,
    checked = _ref.checked,
    disabled = _ref.disabled,
    onChange = _ref.onChange,
    required = _ref.required,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_8fc278f9.Radio, extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("label", {
    htmlFor: id
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "radio",
    id: id,
    name: name,
    value: value,
    onChange: onChange,
    defaultChecked: checked,
    disabled: disabled,
    tabIndex: "0",
    required: required
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_8fc278f9.RadioBtn
  }, /*#__PURE__*/React__default["default"].createElement("i", {
    className: modules_8fc278f9.RadioIcon
  })), /*#__PURE__*/React__default["default"].createElement("span", null, label)));
}
Radio.propTypes = {
  id: propTypes.exports.string.isRequired,
  name: propTypes.exports.string.isRequired,
  value: propTypes.exports.string.isRequired,
  label: propTypes.exports.string.isRequired,
  checked: propTypes.exports.bool,
  disabled: propTypes.exports.bool,
  onChange: propTypes.exports.func,
  required: propTypes.exports.bool,
  extraClass: propTypes.exports.string
};

var css$Q = ".Select_module_Select__2e3a4529 {\n  position: relative;\n  width: 100%;\n  height: auto;\n  max-width: 420px;\n  display: inline-block;\n  position: relative;\n  margin: 0 0 24px 0;\n  padding: 0;\n  border: 2px;\n  border-radius: 50px;\n  vertical-align: middle;\n  background-color: transparent;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 16px;\n  color: #444F6B;\n  z-index: 2;\n}\n.Select_module_Select__2e3a4529 * {\n  /*Transition*/\n  -webkit-transition: All 0.2s ease;\n  -moz-transition: All 0.2s ease;\n  -o-transition: All 0.2s ease;\n  -ms-transition: All 0.2s ease;\n  transition: All 0.2s ease;\n}\n.Select_module_Select__2e3a4529 select {\n  width: 100%;\n  height: 52px;\n  position: relative;\n  z-index: 2;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  color: #444F6B;\n  margin: 0;\n  padding: 0 32px;\n  border-radius: 48px;\n  margin: 0;\n  text-align: left;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  -webkit-appearance: none;\n  appearance: none;\n}\n.Select_module_Select__2e3a4529 select::-ms-expand {\n  display: none;\n}\n@media only screen and (min-width: 1024px) {\n  .Select_module_Select__2e3a4529 select:hover {\n    outline: none;\n    background-color: white;\n    box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n    border: 4px solid #fff;\n    background: #ffffff;\n    border: 4px solid #444F6B;\n  }\n}\n.Select_module_Select__2e3a4529 select:focus, .Select_module_Select__2e3a4529 select:active {\n  outline: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  background: white;\n  border: 4px solid #444F6B;\n}\n.Select_module_Select__2e3a4529 select.Select_module_Error__2e3a4529 {\n  outline: none;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  background: white;\n  border: 4px solid #444F6B;\n}\n.Select_module_Select__2e3a4529 svg {\n  width: 28px;\n  height: 28px;\n  position: absolute;\n  bottom: 10px;\n  right: 24px;\n  z-index: 4;\n  fill: #444F6B;\n  pointer-events: none;\n}\n.Select_module_Select__2e3a4529 label {\n  width: 100%;\n  text-align: left;\n  padding-left: 5px;\n  margin-bottom: 12px;\n  display: inline-block;\n}";
injectCss(css$Q);
var modules_7db85bb8 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Select":"Select_module_Select__2e3a4529","Error":"Select_module_Error__2e3a4529"};

var css$P = ".Titles_module_Title__a2a984df {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -webkit-align-items: center;\n  align-items: center;\n}\n.Titles_module_Title__a2a984df h1, .Titles_module_Title__a2a984df h2, .Titles_module_Title__a2a984df h3, .Titles_module_Title__a2a984df h4, .Titles_module_Title__a2a984df span {\n  -webkit-box-ordinal-group: 3;\n  -moz-box-ordinal-group: 2;\n  -ms-flex-order: 2;\n  -webkit-order: 2;\n  order: 2;\n}\n.Titles_module_Title__a2a984df svg {\n  -webkit-box-ordinal-group: 2;\n  -moz-box-ordinal-group: 1;\n  -ms-flex-order: 1;\n  -webkit-order: 1;\n  order: 1;\n  margin-right: 14px;\n}\n@media (max-width: 700px) {\n  .Titles_module_Title__a2a984df h1, .Titles_module_Title__a2a984df h2, .Titles_module_Title__a2a984df h3, .Titles_module_Title__a2a984df h4, .Titles_module_Title__a2a984df span {\n    font-family: \"Karla\", sans-serif;\n    font-size: 16px;\n    line-height: 26px;\n    text-transform: uppercase;\n  }\n}\n\n.Titles_module_RightIcon__a2a984df {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: row;\n  -ms-flex-direction: row;\n  flex-direction: row;\n  -webkit-box-align: center;\n  -ms-flex-align: center;\n  -webkit-align-items: center;\n  align-items: center;\n}\n.Titles_module_RightIcon__a2a984df h1, .Titles_module_RightIcon__a2a984df h2, .Titles_module_RightIcon__a2a984df h3, .Titles_module_RightIcon__a2a984df h4, .Titles_module_RightIcon__a2a984df span {\n  order: 1;\n}\n.Titles_module_RightIcon__a2a984df svg {\n  order: 2;\n  margin-left: 14px;\n}\n.Titles_module_Shadow__a2a984df {\n  text-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n}";
injectCss(css$P);
var modules_e78439bd = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Title":"Titles_module_Title__a2a984df","RightIcon":"Titles_module_RightIcon__a2a984df","Shadow":"Titles_module_Shadow__a2a984df"};

var getClassNames$5 = function getClassNames(Title, props) {
  return [Title,
  //Right Icon
  props.rightIcon ? modules_e78439bd.RightIcon : "", props.shadow ? modules_e78439bd.Shadow : "", props.extraClass ? props.extraClass : ""].join(" ");
};
var TitleH1 = function TitleH1(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$5(modules_e78439bd.Title, props)
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: props.iconColor,
    iconHSize: 32,
    iconName: props.iconName,
    iconWSize: 32,
    iconShadow: props.shadow
  }), /*#__PURE__*/React__default["default"].createElement(Header1, {
    bold: true,
    serif: props.serif,
    color: props.color,
    fontSize: props.titleSize,
    uppercase: props.uppercase
  }, props.children));
};
var TitleH2 = function TitleH2(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$5(modules_e78439bd.Title, props)
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: props.iconColor,
    iconHSize: 32,
    iconName: props.iconName,
    iconWSize: 32,
    iconShadow: props.shadow
  }), /*#__PURE__*/React__default["default"].createElement(Header2, {
    bold: true,
    serif: props.serif,
    color: props.color,
    fontSize: props.titleSize,
    uppercase: props.uppercase
  }, props.children));
};
var TitleH3 = function TitleH3(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$5(modules_e78439bd.Title, props)
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: props.iconColor,
    iconHSize: 24,
    iconName: props.iconName,
    iconWSize: 24,
    iconShadow: props.shadow
  }), /*#__PURE__*/React__default["default"].createElement(Header3, {
    bold: true,
    serif: props.serif,
    color: props.color,
    fontSize: props.titleSize,
    uppercase: props.uppercase
  }, props.children));
};
var TitleH4 = function TitleH4(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$5(modules_e78439bd.Title, props)
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: props.iconColor,
    iconHSize: 24,
    iconName: props.iconName,
    iconWSize: 24,
    iconShadow: props.shadow
  }), /*#__PURE__*/React__default["default"].createElement(Header4, {
    bold: true,
    serif: props.serif,
    color: props.color,
    extraClass: props.extraClass,
    fontSize: props.titleSize,
    uppercase: props.uppercase
  }, props.children));
};
var Title = function Title(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$5(modules_e78439bd.Title, props)
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: props.iconColor,
    iconHSize: 24,
    iconName: props.iconName,
    iconWSize: 24,
    iconShadow: props.shadow
  }), /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    serif: props.serif,
    color: props.color,
    extraClass: props.extraClass,
    fontSize: props.titleSize,
    uppercase: props.uppercase
  }, props.children));
};
var titlePropTypes = {
  color: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  iconName: propTypes.exports.string,
  serif: propTypes.exports.bool,
  rightIcon: propTypes.exports.bool,
  extraClass: propTypes.exports.string,
  titleSize: propTypes.exports.oneOf(["XXL", "XL", "L", "M", "BASE", "S", "XS", "XXS"]),
  uppercase: propTypes.exports.bool,
  shadow: propTypes.exports.bool
};
TitleH1.propTypes = titlePropTypes;
TitleH2.propTypes = titlePropTypes;
TitleH3.propTypes = titlePropTypes;
TitleH4.propTypes = titlePropTypes;
Title.propTypes = titlePropTypes;

var css$O = ".FormError_module_Error__5fa58ac2 {\n  position: absolute;\n  width: 100%;\n  background-color: #444f6b;\n  border-radius: 0 0 14px 14px;\n  margin-top: -24px;\n  padding: 32px 14px 14px 14px;\n  z-index: 1;\n}\n.FormError_module_Error__5fa58ac2 svg {\n  position: relative !important;\n  left: 0 !important;\n  bottom: auto !important;\n  height: auto !important;\n}\n.FormError_module_Error__5fa58ac2 span {\n  text-transform: none !important;\n  font-size: 14px !important;\n}";
injectCss(css$O);

({
  extraClass: propTypes.exports.string,
  errorMessage: propTypes.exports.string,
  color: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string
});

var getClassNames$4 = function getClassNames(Select, props) {
  return [Select, props.extraClass || ""].join(" ");
};
var Select = function Select(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$4(modules_7db85bb8.Select, props)
  }, /*#__PURE__*/React__default["default"].createElement(Label, {
    uppercase: true,
    bold: true,
    htmlFor: props.name
  }, props.label), /*#__PURE__*/React__default["default"].createElement("select", {
    className: props.formError ? modules_7db85bb8.Error : null,
    id: props.id,
    name: props.name,
    onChange: props.onChange,
    value: props.value,
    required: props.required,
    defaultValue: props.defaultValue
  }, props.children), /*#__PURE__*/React__default["default"].createElement(Icon, {
    extraClass: modules_7db85bb8.SelectArrow,
    iconHSize: 24,
    iconName: "ui-arrow-short--down",
    iconWSize: 24
  }));
};
var SelectPropTypes = {
  id: propTypes.exports.string.isRequired,
  name: propTypes.exports.string.isRequired,
  label: propTypes.exports.string.isRequired,
  defaultValue: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  onChange: propTypes.exports.func,
  extraClass: propTypes.exports.string,
  required: propTypes.exports.bool,
  formError: propTypes.exports.bool,
  errorMessage: propTypes.exports.string
};
Select.propTypes = SelectPropTypes;

function SelectOption(_ref) {
  var name = _ref.name,
    value = _ref.value,
    disabled = _ref.disabled;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("option", {
    value: value,
    disabled: disabled
  }, name));
}
SelectOption.propTypes = {
  name: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  value: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  disabled: propTypes.exports.bool
};

var SelectOptionGroup = function SelectOptionGroup(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("optgroup", {
    label: props.label
  }, props.children));
};
SelectOptionGroup.propTypes = {
  label: propTypes.exports.string.isRequired
};

var css$N = ".RichContentWrapper_module_RichContentWrapper__c726f30a {\n  font-family: \"Karla\", sans-serif;\n  color: #444F6B;\n  font-weight: 400;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h1 {\n  font-size: 48px;\n  line-height: 52px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h2 {\n  font-size: 32px;\n  line-height: 42px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h3 {\n  font-size: 24px;\n  line-height: 34px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h4 {\n  font-size: 18px;\n  line-height: 28px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h5 {\n  font-size: 16px;\n  line-height: 26px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a h6 {\n  font-size: 14px;\n  line-height: 24px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a p, .RichContentWrapper_module_RichContentWrapper__c726f30a ul li, .RichContentWrapper_module_RichContentWrapper__c726f30a ol li {\n  font-size: 16px;\n  line-height: 26px;\n  margin: 0;\n  margin-bottom: 12px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a a {\n  text-decoration: underline;\n  font-weight: 700;\n  color: #444f6b;\n  transition: all 0.3s;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a a:hover {\n  color: #363f56;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a small {\n  font-size: 14px;\n  line-height: 24px;\n  margin: 0;\n  margin-bottom: 10px;\n  padding: 0;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a blockquote {\n  font-size: 16px;\n  line-height: 26px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a blockquote::before {\n  content: '\"';\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a blockquote::after {\n  content: '\"';\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a pre {\n  font-size: 16px;\n  line-height: 26px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a b, .RichContentWrapper_module_RichContentWrapper__c726f30a strong {\n  font-weight: 700;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a i, .RichContentWrapper_module_RichContentWrapper__c726f30a em {\n  font-style: italic;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a img {\n  width: 100%;\n  height: auto;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .SerifFont, .RichContentWrapper_module_RichContentWrapper__c726f30a .Serif, .RichContentWrapper_module_RichContentWrapper__c726f30a .ql-font-serif {\n  font-family: \"Vollkorn\", serif;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .Center, .RichContentWrapper_module_RichContentWrapper__c726f30a .ql-align-center {\n  text-align: center;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .Right, .RichContentWrapper_module_RichContentWrapper__c726f30a .ql-align-right {\n  text-align: right;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .Underline, .RichContentWrapper_module_RichContentWrapper__c726f30a u {\n  text-decoration: underline;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .LineThrough, .RichContentWrapper_module_RichContentWrapper__c726f30a s {\n  text-decoration: line-through;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .XXLText {\n  font-size: 48px;\n  line-height: 52px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .XLText {\n  font-size: 32px;\n  line-height: 42px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .LText {\n  font-size: 24px;\n  line-height: 34px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .MText {\n  font-size: 18px;\n  line-height: 28px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .BaseText {\n  font-size: 16px;\n  line-height: 26px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .SText {\n  font-size: 14px;\n  line-height: 24px;\n}\n.RichContentWrapper_module_RichContentWrapper__c726f30a .XSText {\n  font-size: 12px;\n  line-height: 22px;\n}";
injectCss(css$N);
var modules_1b71ea3d = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","RichContentWrapper":"RichContentWrapper_module_RichContentWrapper__c726f30a"};

var getClassNames$3 = function getClassNames(RichContentWrapper, props) {
  return [RichContentWrapper, props.extraClass || ''].join(' ');
};
var RichContentWrapper = function RichContentWrapper(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: getClassNames$3(modules_1b71ea3d.RichContentWrapper, props)
  }, props.children);
};
var RichContentWrapperPropTypes = {
  extraClass: propTypes.exports.string
};
RichContentWrapper.propTypes = RichContentWrapperPropTypes;

var css$M = ".Spacing_module_Spacing__18073a04 {\n  width: 100%;\n  position: relative;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperTighttop__18073a04 {\n  padding-top: 4px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraTighttop__18073a04 {\n  padding-top: 8px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingTighttop__18073a04 {\n  padding-top: 14px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingBasetop__18073a04 {\n  padding-top: 24px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingLoosetop__18073a04 {\n  padding-top: 32px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraLoosetop__18073a04 {\n  padding-top: 36px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperLoosetop__18073a04 {\n  padding-top: 54px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperTightright__18073a04 {\n  padding-right: 4px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraTightright__18073a04 {\n  padding-right: 8px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingTightright__18073a04 {\n  padding-right: 14px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingBaseright__18073a04 {\n  padding-right: 24px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingLooseright__18073a04 {\n  padding-right: 32px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraLooseright__18073a04 {\n  padding-right: 36px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperLooseright__18073a04 {\n  padding-right: 54px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperTightbottom__18073a04 {\n  padding-bottom: 4px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraTightbottom__18073a04 {\n  padding-bottom: 8px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingTightbottom__18073a04 {\n  padding-bottom: 14px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingBasebottom__18073a04 {\n  padding-bottom: 24px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingLoosebottom__18073a04 {\n  padding-bottom: 32px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraLoosebottom__18073a04 {\n  padding-bottom: 36px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperLoosebottom__18073a04 {\n  padding-bottom: 54px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperTightleft__18073a04 {\n  padding-left: 4px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraTightleft__18073a04 {\n  padding-left: 8px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingTightleft__18073a04 {\n  padding-left: 14px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingBaseleft__18073a04 {\n  padding-left: 24px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingLooseleft__18073a04 {\n  padding-left: 32px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingExtraLooseleft__18073a04 {\n  padding-left: 36px;\n}\n.Spacing_module_Spacing__18073a04.Spacing_module_spacingSuperLooseleft__18073a04 {\n  padding-left: 54px;\n}";
injectCss(css$M);
var modules_05240b51 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Spacing":"Spacing_module_Spacing__18073a04","spacingSuperTighttop":"Spacing_module_spacingSuperTighttop__18073a04","spacingExtraTighttop":"Spacing_module_spacingExtraTighttop__18073a04","spacingTighttop":"Spacing_module_spacingTighttop__18073a04","spacingBasetop":"Spacing_module_spacingBasetop__18073a04","spacingLoosetop":"Spacing_module_spacingLoosetop__18073a04","spacingExtraLoosetop":"Spacing_module_spacingExtraLoosetop__18073a04","spacingSuperLoosetop":"Spacing_module_spacingSuperLoosetop__18073a04","spacingSuperTightright":"Spacing_module_spacingSuperTightright__18073a04","spacingExtraTightright":"Spacing_module_spacingExtraTightright__18073a04","spacingTightright":"Spacing_module_spacingTightright__18073a04","spacingBaseright":"Spacing_module_spacingBaseright__18073a04","spacingLooseright":"Spacing_module_spacingLooseright__18073a04","spacingExtraLooseright":"Spacing_module_spacingExtraLooseright__18073a04","spacingSuperLooseright":"Spacing_module_spacingSuperLooseright__18073a04","spacingSuperTightbottom":"Spacing_module_spacingSuperTightbottom__18073a04","spacingExtraTightbottom":"Spacing_module_spacingExtraTightbottom__18073a04","spacingTightbottom":"Spacing_module_spacingTightbottom__18073a04","spacingBasebottom":"Spacing_module_spacingBasebottom__18073a04","spacingLoosebottom":"Spacing_module_spacingLoosebottom__18073a04","spacingExtraLoosebottom":"Spacing_module_spacingExtraLoosebottom__18073a04","spacingSuperLoosebottom":"Spacing_module_spacingSuperLoosebottom__18073a04","spacingSuperTightleft":"Spacing_module_spacingSuperTightleft__18073a04","spacingExtraTightleft":"Spacing_module_spacingExtraTightleft__18073a04","spacingTightleft":"Spacing_module_spacingTightleft__18073a04","spacingBaseleft":"Spacing_module_spacingBaseleft__18073a04","spacingLooseleft":"Spacing_module_spacingLooseleft__18073a04","spacingExtraLooseleft":"Spacing_module_spacingExtraLooseleft__18073a04","spacingSuperLooseleft":"Spacing_module_spacingSuperLooseleft__18073a04"};

var getClassNames$2 = function getClassNames(Flat, props) {
  return [Flat, props.extraClass || '', props.spacingTop == 'spacingBase' ? modules_05240b51.spacingBasetop : props.spacingTop == 'spacingSuperTight' ? modules_05240b51.spacingSuperTighttop : props.spacingTop == 'spacingExtraTight' ? modules_05240b51.spacingExtraTighttop : props.spacingTop == 'spacingTight' ? modules_05240b51.spacingTighttop : props.spacingTop == 'spacingLoose' ? modules_05240b51.spacingLoosetop : props.spacingTop == 'spacingExtraLoose' ? modules_05240b51.spacingExtraLoosetop : props.spacingTop == 'spacingSuperLoose' ? modules_05240b51.spacingSuperLoosetop : null, props.spacingRight == 'spacingBase' ? modules_05240b51.spacingBaseright : props.spacingRight == 'spacingSuperTight' ? modules_05240b51.spacingSuperTightright : props.spacingRight == 'spacingExtraTight' ? modules_05240b51.spacingExtraTightright : props.spacingRight == 'spacingTight' ? modules_05240b51.spacingTightright : props.spacingRight == 'spacingLoose' ? modules_05240b51.spacingLooseright : props.spacingRight == 'spacingExtraLoose' ? modules_05240b51.spacingExtraLooseright : props.spacingRight == 'spacingSuperLoose' ? modules_05240b51.spacingSuperLooseright : null, props.spacingBottom == 'spacingBase' ? modules_05240b51.spacingBasebottom : props.spacingBottom == 'spacingSuperTight' ? modules_05240b51.spacingSuperTightbottom : props.spacingBottom == 'spacingExtraTight' ? modules_05240b51.spacingExtraTightbottom : props.spacingBottom == 'spacingTight' ? modules_05240b51.spacingTightbottom : props.spacingBottom == 'spacingLoose' ? modules_05240b51.spacingLoosebottom : props.spacingBottom == 'spacingExtraLoose' ? modules_05240b51.spacingExtraLoosebottom : props.spacingBottom == 'spacingSuperLoose' ? modules_05240b51.spacingSuperLoosebottom : null, props.spacingLeft == 'spacingBase' ? modules_05240b51.spacingBaseleft : props.spacingLeft == 'spacingSuperTight' ? modules_05240b51.spacingSuperTightleft : props.spacingLeft == 'spacingExtraTight' ? modules_05240b51.spacingExtraTightleft : props.spacingLeft == 'spacingTight' ? modules_05240b51.spacingTightleft : props.spacingLeft == 'spacingLoose' ? modules_05240b51.spacingLooseleft : props.spacingLeft == 'spacingExtraLoose' ? modules_05240b51.spacingExtraLooseleft : props.spacingLeft == 'spacingSuperLoose' ? modules_05240b51.spacingSuperLooseleft : null, props.noPadding ? modules_05240b51.NoPadding : null].join(" ");
};
var Spacing = function Spacing(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    id: props.id,
    className: getClassNames$2(modules_05240b51.Spacing, props)
  }, props.children);
};
var spacingOptions = ["noSpacing", "spacingSuperTight", "spacingExtraTight", "spacingTight", "spacingBase", "spacingLoose", "spacingExtraLoose", "spacingSuperLoose"];
var spacingPropTypes = {
  extraClass: propTypes.exports.string,
  spacingTop: propTypes.exports.oneOf(spacingOptions),
  spacingBottom: propTypes.exports.oneOf(spacingOptions),
  spacingRight: propTypes.exports.oneOf(spacingOptions),
  spacingLeft: propTypes.exports.oneOf(spacingOptions)
};
Spacing.propTypes = spacingPropTypes;

var css$L = ".Accordion_module_Accordion__109e4a6e {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  cursor: pointer;\n  width: 100%;\n  background-color: #ffffff;\n  padding-bottom: 24px;\n  border-bottom: 1px solid #d4d4d8;\n}\n.Accordion_module_Accordion__109e4a6e :hover h3 {\n  text-decoration: underline;\n}\n.Accordion_module_Accordion__109e4a6e.Accordion_module_Open__109e4a6e button {\n  transform: rotate(180deg);\n}\n.Accordion_module_Accordion__109e4a6e.Accordion_module_Closed__109e4a6e button {\n  transform: rotate(0deg);\n}\n\n.Accordion_module_AccordionTop__109e4a6e h3 {\n  padding: 24px 64px 0 24px;\n}\n.Accordion_module_AccordionTop__109e4a6e button {\n  padding: 0;\n  position: absolute;\n  right: 8px;\n  top: 14px;\n  width: 48px;\n  transition: all 0.5s;\n}\n.Accordion_module_AccordionTop__109e4a6e button :hover,\n.Accordion_module_AccordionTop__109e4a6e button :focus {\n  background-color: transparent;\n}\n.Accordion_module_AccordionTop__109e4a6e button span {\n  padding-left: 0;\n  padding-right: 0;\n  background-color: transparent;\n  width: 48px;\n}\n\n.Accordion_module_CloseContent__109e4a6e {\n  max-height: 0;\n  background-color: #ffffff;\n  overflow: hidden;\n  -webkit-transition: max-height 0.5s;\n  -moz-transition: max-height 0.5s;\n  transition: max-height 0.5s;\n  display: block;\n  padding: 0 100px 0 24px;\n}\n\n.Accordion_module_OpenContent__109e4a6e {\n  max-height: 400px;\n}";
injectCss(css$L);
var modules_0a5b548b = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Accordion":"Accordion_module_Accordion__109e4a6e","Open":"Accordion_module_Open__109e4a6e","Closed":"Accordion_module_Closed__109e4a6e","AccordionTop":"Accordion_module_AccordionTop__109e4a6e","CloseContent":"Accordion_module_CloseContent__109e4a6e","OpenContent":"Accordion_module_OpenContent__109e4a6e"};

var Accordion = function Accordion(_ref) {
  var title = _ref.title,
    children = _ref.children,
    faq = _ref.faq,
    accordionId = _ref.accordionId,
    openByDefault = _ref.openByDefault;
  var _useState = React.useState(openByDefault),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var accordionSetId = accordionId ? accordionId : title.replace(/['"!@#$%^&*();><+=,.{}|~`/? ]/g, "-").toLowerCase();
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$4({
    onClick: function onClick() {
      return setIsActive(!isActive);
    },
    className: [modules_0a5b548b.Accordion, isActive ? modules_0a5b548b.Open : modules_0a5b548b.Closed].join(" ")
  }, faq ? {
    itemScope: " ",
    itemProp: "mainEntity",
    itemType: "https://schema.org/Question"
  } : {}), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_0a5b548b.AccordionTop
  }, /*#__PURE__*/React__default["default"].createElement(Header3, _extends$4({
    id: "title-" + accordionSetId + "",
    fontSize: "BASE",
    bold: true
  }, faq ? {
    itemProp: "name"
  } : {}), title), /*#__PURE__*/React__default["default"].createElement(Button, {
    icon: "ICON",
    iconName: "ui-arrow-short--down",
    iconActive: "ui-arrow-short--up",
    iconColor: "#444f6b",
    iconWSize: 42,
    iconHSize: 42,
    ariaLabel: title,
    label: title,
    ariaExpanded: isActive ? "true" : "false",
    ariaControls: accordionSetId
  })), /*#__PURE__*/React__default["default"].createElement("div", _extends$4({
    id: accordionSetId,
    className: [modules_0a5b548b.CloseContent, isActive ? modules_0a5b548b.OpenContent : null].join(" ")
  }, faq ? {
    itemScope: " ",
    itemProp: "acceptedAnswer",
    itemType: "https://schema.org/Answer"
  } : {}, {
    "aria-hidden": isActive ? "true" : "false",
    "aria-labelledby": "title-" + accordionSetId + "",
    role: "region"
  }), /*#__PURE__*/React__default["default"].createElement("div", faq ? {
    itemProp: "text"
  } : {}, children)));
};
var accordionPropTypes = {
  faq: propTypes.exports.bool,
  title: propTypes.exports.string,
  accordionId: propTypes.exports.string,
  openByDefault: propTypes.exports.bool
};
Accordion.propTypes = accordionPropTypes;

var css$K = ".DiamondRating_module_DiamondReturn__b4261d75 {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n}\n\n.DiamondRating_module_InspectedClean__b4261d75 {\n  margin-left: 14px;\n  margin-top: 4px;\n}";
injectCss(css$K);
var modules_9b2b1943 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","DiamondReturn":"DiamondRating_module_DiamondReturn__b4261d75","InspectedClean":"DiamondRating_module_InspectedClean__b4261d75"};

function DiamondRating(_ref) {
  var diamondIcon = _ref.diamondIcon,
    diamondWidth = _ref.diamondWidth,
    diamondHeight = _ref.diamondHeight,
    inspectedClean = _ref.inspectedClean;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_9b2b1943.DiamondReturn
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconHSize: diamondHeight,
    iconName: diamondIcon,
    iconWSize: diamondWidth
  }), inspectedClean ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    extraClass: modules_9b2b1943.InspectedClean,
    iconHSize: 40,
    iconName: "inspected-clean",
    iconWSize: 140
  }) : null));
}
DiamondRating.propTypes = {
  diamondIcon: propTypes.exports.string,
  diamondWidth: propTypes.exports.number,
  diamondHeight: propTypes.exports.number,
  inspectedClean: propTypes.exports.bool
};

var css$J = ".Badge_module_Badge__8ec127e9 {\n  position: relative;\n  width: 44px;\n  height: 42px;\n  display: block;\n}\n.Badge_module_Badge__8ec127e9 .Badge_module_BadgeCount__8ec127e9 {\n  position: absolute;\n  top: 50%;\n  transform: translate(0, -50%);\n  left: 0;\n  right: 0;\n  text-align: center;\n}\n\n.Badge_module_Rounded__8ec127e9 {\n  border-radius: 50%;\n}";
injectCss(css$J);
var modules_c87a512f = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Badge":"Badge_module_Badge__8ec127e9","BadgeCount":"Badge_module_BadgeCount__8ec127e9","Rounded":"Badge_module_Rounded__8ec127e9"};

function Badge(_ref) {
  var extraClass = _ref.extraClass,
    badgeCount = _ref.badgeCount,
    bgColor = _ref.bgColor,
    icon = _ref.icon,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    iconHSize = _ref.iconHSize,
    iconWSize = _ref.iconWSize,
    iconShadow = _ref.iconShadow,
    badgeHeight = _ref.badgeHeight,
    badgeWidth = _ref.badgeWidth,
    badgeCountColor = _ref.badgeCountColor,
    rounded = _ref.rounded;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_c87a512f.Badge, rounded ? modules_c87a512f.Rounded : "", extraClass].join(' '),
    style: {
      height: badgeHeight,
      width: badgeWidth,
      backgroundColor: bgColor
    }
  }, icon ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: iconColor,
    iconHSize: iconHSize || 44,
    iconName: iconName,
    iconWSize: iconWSize || 44,
    iconShadow: iconShadow
  }) : null, /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S",
    bold: true,
    color: badgeCountColor,
    extraClass: modules_c87a512f.BadgeCount
  }, badgeCount)));
}
Badge.propTypes = {
  extraClass: propTypes.exports.string,
  badgeCount: propTypes.exports.string,
  badgeCountColor: propTypes.exports.string,
  bgColor: propTypes.exports.string,
  icon: propTypes.exports.bool,
  iconName: propTypes.exports.oneOf(["agent", "amenities--accessibility", "amenities--business", "amenities--charging", "amenities--eco", "amenities--fitness", "amenities--pets", "amenities--pool", "amenities--wireless", "article", "budget", "calendar", "calendar--booking", "camera", "category--article", "category--campgrounds", "category--cruises", "category--guided-tours", "category--lodgings", "category--packages", "category--points-of-interest", "category--popular-destinations", "category--restaurants", "category--roadtrips", "category--things-to-do", "clock", "compare", "compass", "directions", "discounts", "editor-notes", "gas-station", "category--fuel", "groups", "heart--outline", "heart--solid", "home", "itinerary", "theme-park", "library--photos", "library--videos", "location--add", "location--edit", "location--outline", "location--solid", "luggage", "map", "notification", "offers", "overview", "package", "pin", "plan", "roadtrip-add", "season--fall", "season--spring", "season--summer", "season--winter", "seating", "transportation--air", "transportation--bicycle", "transportation--bus", "transportation--car", "transportation--electric-vehicle", "transportation--generic", "transportation--rental", "transportation--subway", "transportation--taxi", "transportation--train", "transportation--tram", "transportation--walking", "trending", "ui-arrange", "ui-arrow-circle--up", "ui-arrow-circle--down", "ui-arrow-circle--left", "ui-arrow-circle--right", "ui-arrow-long--down", "ui-arrow-long--left", "ui-arrow-long--right", "ui-arrow-long--up", "ui-arrow-short--down", "ui-arrow-short--left", "ui-arrow-short--right", "ui-arrow-short--up", "ui-arrow-tall--down", "ui-arrow-tall--up", "ui-arrow-tall--left", "ui-arrow-tall--right", "ui-chat", "ui-check", "ui-circle--check", "ui-circle--close", "ui-circle--minus", "ui-circle--plus", "ui-circle-outline--close", "ui-circle-outline--error", "ui-circle-outline--help", "ui-circle-outline--minus", "ui-circle-outline--pause", "ui-circle-outline--play", "ui-circle-outline--plus", "ui-circle-solid--error", "ui-circle-solid--help", "ui-circle-solid--pause", "ui-circle-solid--play", "ui-close", "ui-dashboard", "ui-delete", "ui-download", "ui-drag", "ui-edit", "ui-ellipses--horizontal", "ui-ellipses--vertical", "ui-expand", "ui-feedback", "ui-filter", "ui-fullscreen", "ui-hamburger", "ui-inbox", "ui-list", "ui-minus", "ui-near-me", "ui-play", "ui-plus", "ui-profile", "ui-search", "ui-settings", "ui-share", "ui-sort", "ui-print", "ui-swap--vertical"]),
  iconColor: propTypes.exports.string,
  iconShadow: propTypes.exports.bool,
  iconHSize: propTypes.exports.number,
  iconWSize: propTypes.exports.number,
  badgeHeight: propTypes.exports.number,
  badgeWidth: propTypes.exports.number,
  rounded: propTypes.exports.bool
};

var css$I = ".Pill_module_Pill__e89e0cc3 {\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n  padding: 2px 14px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  flex-direction: row;\n  color: #191919;\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  z-index: 4;\n  align-items: center;\n}\n.Pill_module_Pill__e89e0cc3 svg {\n  margin-right: 4px;\n}";
injectCss(css$I);
var modules_548be2f4 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Pill":"Pill_module_Pill__e89e0cc3"};

function Pill(_ref) {
  var pillIcon = _ref.pillIcon,
    pillTitle = _ref.pillTitle,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_548be2f4.Pill, extraClass].join(" ")
  }, pillIcon ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: pillIcon,
    iconHSize: 20,
    iconWSize: 20,
    iconColor: "#191919"
  }) : null, /*#__PURE__*/React__default["default"].createElement("span", null, pillTitle)));
}
Pill.propTypes = {
  extraClass: propTypes.exports.string,
  pillIcon: propTypes.exports.string,
  pillTitle: propTypes.exports.string
};

var css$H = "/*Hearted Animation*/\n@keyframes ActionIcon_module_grow__0b9f630e {\n  0% {\n    transform: scale(1);\n  }\n  100% {\n    transform: scale(1.2);\n  }\n}\n@keyframes ActionIcon_module_shrink__0b9f630e {\n  0% {\n    transform: scale(1.2);\n  }\n  100% {\n    transform: scale(1);\n  }\n}\n\n/*Heart Action*/\n.ActionIcon_module_HeartItem__0b9f630e {\n  animation: ActionIcon_module_shrink__0b9f630e 0.3s 2;\n  transition: all 0.3s ease-in;\n  width: 44px;\n  height: 44px;\n  display: block;\n  background-color: Transparent;\n  transition: all 0.2s ease-in-out;\n  z-index: 2;\n  border: none;\n  cursor: pointer;\n}\n.ActionIcon_module_HeartItem__0b9f630e .ActionIcon_module_Label__0b9f630e:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.ActionIcon_module_HeartItem__0b9f630e:hover {\n  transform: scale(1.1);\n}\n\n.ActionIcon_module_HeartedItem__0b9f630e {\n  animation: ActionIcon_module_grow__0b9f630e 0.3s 2;\n  transition: all 0.3s ease-in;\n  width: 44px;\n  height: 44px;\n  display: block;\n  background-color: Transparent;\n  z-index: 2;\n  border: none;\n  cursor: pointer;\n}\n.ActionIcon_module_HeartedItem__0b9f630e svg {\n  height: 100%;\n}\n.ActionIcon_module_HeartedItem__0b9f630e:hover {\n  transform: scale(1.1);\n}\n.ActionIcon_module_HeartedItem__0b9f630e:focus {\n  outline: none;\n}\n.ActionIcon_module_HeartedItem__0b9f630e:focus-visible {\n  border-radius: 48px;\n  background-color: #ffffff;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, 0px 0px 0px 2px #ffffff, 1px 8px 16px rgba(25, 25, 25, 0.2);\n}\n.ActionIcon_module_HeartedItem__0b9f630e:focus-visible svg use {\n  fill: #444F6B !important;\n}\n.ActionIcon_module_HeartedItem__0b9f630e .ActionIcon_module_Label__0b9f630e:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}";
injectCss(css$H);
var modules_6e9ae1bf = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","HeartItem":"ActionIcon_module_HeartItem__0b9f630e","shrink":"ActionIcon_module_shrink__0b9f630e","Label":"ActionIcon_module_Label__0b9f630e","HeartedItem":"ActionIcon_module_HeartedItem__0b9f630e","grow":"ActionIcon_module_grow__0b9f630e"};

function ActionIcon(_ref) {
  var color = _ref.color,
    activeColor = _ref.activeColor,
    light = _ref.light,
    label = _ref.label,
    ariaLabel = _ref.ariaLabel,
    iconDefault = _ref.iconDefault,
    iconActive = _ref.iconActive,
    onClick = _ref.onClick,
    isActive = _ref.isActive,
    iconHSize = _ref.iconHSize,
    iconWSize = _ref.iconWSize,
    extraClass = _ref.extraClass;
  if (light) {
    var iconColor = "#ffffff";
    var shadow = true;
  } else {
    var iconColor = color;
  }
  return /*#__PURE__*/React__default["default"].createElement("button", {
    "aria-label": ariaLabel,
    onClick: onClick,
    className: [isActive ? modules_6e9ae1bf.HeartItem : modules_6e9ae1bf.HeartedItem, extraClass].join(' ')
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: !isActive ? iconColor : activeColor,
    iconHSize: iconHSize || 32,
    iconName: !isActive ? iconDefault : iconActive,
    iconWSize: iconWSize || 32,
    iconShadow: shadow
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_6e9ae1bf.Label
  }, ariaLabel ? ariaLabel : label));
}

//export default HeartItemAction;
ActionIcon.propTypes = {
  activeColor: propTypes.exports.string,
  iconWSize: propTypes.exports.number,
  iconHSize: propTypes.exports.number,
  color: propTypes.exports.string,
  light: propTypes.exports.bool,
  label: propTypes.exports.string,
  ariaLabel: propTypes.exports.string.isRequired,
  iconDefault: propTypes.exports.string,
  iconActive: propTypes.exports.string,
  onClick: propTypes.exports.func,
  isActive: propTypes.exports.bool,
  extraClass: propTypes.exports.string
};

var css$G = ".CircleIcon_module_CardIcon__87bd9f5a {\n  background-color: #5e5e60;\n  width: 42px;\n  height: 42px;\n  border-radius: 48px;\n  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n  display: block;\n}\n.CircleIcon_module_CardIcon__87bd9f5a svg {\n  margin: 8px 8px 2px 9px;\n  width: 24px;\n  height: 26px;\n}";
injectCss(css$G);
var modules_6d77a973 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","CardIcon":"CircleIcon_module_CardIcon__87bd9f5a"};

function CircleIcon(_ref) {
  var extraClass = _ref.extraClass,
    bgColor = _ref.bgColor,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    iconHSize = _ref.iconHSize,
    iconWSize = _ref.iconWSize,
    circleHeight = _ref.circleHeight,
    circleWidth = _ref.circleWidth;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_6d77a973.CardIcon, extraClass].join(' '),
    style: {
      backgroundColor: bgColor,
      height: circleHeight,
      width: circleWidth
    }
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: iconColor,
    iconHSize: iconHSize || 24,
    iconName: iconName,
    iconWSize: iconWSize || 24
  })));
}
CircleIcon.propTypes = {
  extraClass: propTypes.exports.string,
  bgColor: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  iconHSize: propTypes.exports.number,
  iconWSize: propTypes.exports.number,
  circleHeight: propTypes.exports.number,
  circleWidth: propTypes.exports.number
};

var css$F = ".IconIndicator_module_IconIndicator__8549599d {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  max-width: fit-content;\n  -moz-transition: all 0.4s ease-in-out;\n  -o-transition: all 0.4s ease-in-out;\n  -webkit-transition: all 0.4s ease-in-out;\n  transition: all 0.4s ease-in-out;\n}\n.IconIndicator_module_IconIndicator__8549599d span {\n  display: block;\n}\n.IconIndicator_module_IconIndicator__8549599d .IconIndicator_module_iconLabel__8549599d {\n  padding-top: 10px;\n  line-height: normal;\n}\n\na, button {\n  text-decoration: none;\n}\na .IconIndicator_module_IconIndicator__8549599d, button .IconIndicator_module_IconIndicator__8549599d {\n  text-decoration: none;\n  cursor: pointer;\n}\na .IconIndicator_module_IconIndicator__8549599d:hover, button .IconIndicator_module_IconIndicator__8549599d:hover {\n  transform: scale(1.1);\n}\na .IconIndicator_module_IconIndicator__8549599d span, button .IconIndicator_module_IconIndicator__8549599d span {\n  text-decoration: none;\n}\n\n.IconIndicator_module_IconLabelLeft__8549599d {\n  flex-direction: row-reverse;\n}\n.IconIndicator_module_IconLabelLeft__8549599d span {\n  margin-right: 8px;\n}\n\n.IconIndicator_module_IconLabelRight__8549599d {\n  flex-direction: row;\n}\n.IconIndicator_module_IconLabelRight__8549599d span {\n  margin-left: 8px;\n}\n\n.IconIndicator_module_IconLabelTop__8549599d {\n  flex-direction: column-reverse;\n}";
injectCss(css$F);
var modules_c7eafb5e = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","IconIndicator":"IconIndicator_module_IconIndicator__8549599d","iconLabel":"IconIndicator_module_iconLabel__8549599d","IconLabelLeft":"IconIndicator_module_IconLabelLeft__8549599d","IconLabelRight":"IconIndicator_module_IconLabelRight__8549599d","IconLabelTop":"IconIndicator_module_IconLabelTop__8549599d"};

function IconIndicator(_ref) {
  var iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    iconLabel = _ref.iconLabel,
    iconLabelTop = _ref.iconLabelTop,
    iconLabelLeft = _ref.iconLabelLeft,
    iconLabelRight = _ref.iconLabelRight,
    labelUppercase = _ref.labelUppercase,
    _ref$fontSize = _ref.fontSize,
    fontSize = _ref$fontSize === void 0 ? 'XS' : _ref$fontSize,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_c7eafb5e.IconIndicator, iconLabelTop ? modules_c7eafb5e.IconLabelTop : "", iconLabelLeft ? modules_c7eafb5e.IconLabelLeft : "", iconLabelRight ? modules_c7eafb5e.IconLabelRight : "", extraClass ? extraClass : ""].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: iconName,
    iconHSize: 24,
    iconWSize: 24,
    iconColor: iconColor
  }), /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: fontSize,
    bold: true,
    centerText: true,
    color: iconColor,
    uppercase: labelUppercase ? true : false,
    extraClass: modules_c7eafb5e.iconLabel
  }, iconLabel));
}
IconIndicator.propTypes = {
  extraClass: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  iconLabel: propTypes.exports.string,
  iconLabelTop: propTypes.exports.bool,
  iconLabelLeft: propTypes.exports.bool,
  iconLabelRight: propTypes.exports.bool,
  labelUppercase: propTypes.exports.bool,
  fontSize: propTypes.exports.oneOf(["XXL", "XL", "L", "M", "BASE", "S", "XS", "XXS"])
};

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow$1(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow$1(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow$1(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow$1(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement$1(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$1(element) ? getWindow$1(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle$2(element) {
  return getWindow$1(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle$2(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle$2(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle$2(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow$1(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle$2(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle$2(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within$1(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within$1(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement$1(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within$1(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (process.env.NODE_ENV !== "production") {
    if (!isHTMLElement(arrowElement)) {
      console.error(['Popper: "arrow" element must be an HTMLElement (not an SVGElement).', 'To use an SVG arrow, wrap it in an HTMLElement that will be used as', 'the arrow.'].join(' '));
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: "arrow" modifier\'s `element` must be a child of the popper', 'element.'].join(' '));
    }

    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref) {
  var x = _ref.x,
      y = _ref.y;
  var win = window;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow$1(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle$2(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;

  if (process.env.NODE_ENV !== "production") {
    var transitionProperty = getComputedStyle$2(state.elements.popper).transitionProperty || '';

    if (adaptive && ['transform', 'top', 'right', 'bottom', 'left'].some(function (property) {
      return transitionProperty.indexOf(property) >= 0;
    })) {
      console.warn(['Popper: Detected CSS transitions on at least one of the following', 'CSS properties: "transform", "top", "right", "bottom", "left".', '\n\n', 'Disable the "computeStyles" modifier\'s `adaptive` option to allow', 'for smooth transitions, or remove these properties from the CSS', 'transition declaration on the popper element if only transitioning', 'opacity or background-color for example.', '\n\n', 'We recommend using the popper element as a wrapper around an inner', 'element that can have any CSS property transitioned for animations.'].join(' '));
    }
  }

  var commonStyles = {
    placement: getBasePlacement$1(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow$1(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow$1(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow$1(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle$2(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle$2(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow$1(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle$2(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement$1(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;

    if (process.env.NODE_ENV !== "production") {
      console.error(['Popper: The `allowedAutoPlacements` option did not allow any', 'placements. Ensure the `placement` option matches the variation', 'of the allowed placements.', 'For example, "auto" cannot be used to allow "bottom-start".', 'Use "auto-start" instead.'].join(' '));
    }
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement$1(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement$1(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement$1(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement$1(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement$1(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement$1(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$2 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset$1
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement$1(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within$1(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within$1(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within$1(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow$1(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce$1(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function format(str) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return [].concat(args).reduce(function (p, c) {
    return p.replace(/%s/, c);
  }, str);
}

var INVALID_MODIFIER_ERROR = 'Popper: modifier "%s" provided an invalid %s property, expected %s but got %s';
var MISSING_DEPENDENCY_ERROR = 'Popper: modifier "%s" requires "%s", but "%s" modifier is not available';
var VALID_PROPERTIES = ['name', 'enabled', 'phase', 'fn', 'effect', 'requires', 'options'];
function validateModifiers(modifiers) {
  modifiers.forEach(function (modifier) {
    [].concat(Object.keys(modifier), VALID_PROPERTIES) // IE11-compatible replacement for `new Set(iterable)`
    .filter(function (value, index, self) {
      return self.indexOf(value) === index;
    }).forEach(function (key) {
      switch (key) {
        case 'name':
          if (typeof modifier.name !== 'string') {
            console.error(format(INVALID_MODIFIER_ERROR, String(modifier.name), '"name"', '"string"', "\"" + String(modifier.name) + "\""));
          }

          break;

        case 'enabled':
          if (typeof modifier.enabled !== 'boolean') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"enabled"', '"boolean"', "\"" + String(modifier.enabled) + "\""));
          }

          break;

        case 'phase':
          if (modifierPhases.indexOf(modifier.phase) < 0) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"phase"', "either " + modifierPhases.join(', '), "\"" + String(modifier.phase) + "\""));
          }

          break;

        case 'fn':
          if (typeof modifier.fn !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"fn"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'effect':
          if (modifier.effect != null && typeof modifier.effect !== 'function') {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"effect"', '"function"', "\"" + String(modifier.fn) + "\""));
          }

          break;

        case 'requires':
          if (modifier.requires != null && !Array.isArray(modifier.requires)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requires"', '"array"', "\"" + String(modifier.requires) + "\""));
          }

          break;

        case 'requiresIfExists':
          if (!Array.isArray(modifier.requiresIfExists)) {
            console.error(format(INVALID_MODIFIER_ERROR, modifier.name, '"requiresIfExists"', '"array"', "\"" + String(modifier.requiresIfExists) + "\""));
          }

          break;

        case 'options':
        case 'data':
          break;

        default:
          console.error("PopperJS: an invalid property has been provided to the \"" + modifier.name + "\" modifier, valid properties are " + VALID_PROPERTIES.map(function (s) {
            return "\"" + s + "\"";
          }).join(', ') + "; but \"" + key + "\" was provided.");
      }

      modifier.requires && modifier.requires.forEach(function (requirement) {
        if (modifiers.find(function (mod) {
          return mod.name === requirement;
        }) == null) {
          console.error(format(MISSING_DEPENDENCY_ERROR, String(modifier.name), requirement, requirement));
        }
      });
    });
  });
}

function uniqueBy(arr, fn) {
  var identifiers = new Set();
  return arr.filter(function (item) {
    var identifier = fn(item);

    if (!identifiers.has(identifier)) {
      identifiers.add(identifier);
      return true;
    }
  });
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var INVALID_ELEMENT_ERROR = 'Popper: Invalid reference or popper argument provided. They must be either a DOM element or virtual element.';
var INFINITE_LOOP_ERROR = 'Popper: An infinite loop in the modifiers cycle has been detected! The cycle has been interrupted to prevent a browser crash.';
var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        }); // Validate the provided modifiers so that the consumer will get warned
        // if one of the modifiers is invalid for any reason

        if (process.env.NODE_ENV !== "production") {
          var modifiers = uniqueBy([].concat(orderedModifiers, state.options.modifiers), function (_ref) {
            var name = _ref.name;
            return name;
          });
          validateModifiers(modifiers);

          if (getBasePlacement$1(state.options.placement) === auto) {
            var flipModifier = state.orderedModifiers.find(function (_ref2) {
              var name = _ref2.name;
              return name === 'flip';
            });

            if (!flipModifier) {
              console.error(['Popper: "auto" placements require the "flip" modifier be', 'present and enabled to work.'].join(' '));
            }
          }

          var _getComputedStyle = getComputedStyle$2(popper),
              marginTop = _getComputedStyle.marginTop,
              marginRight = _getComputedStyle.marginRight,
              marginBottom = _getComputedStyle.marginBottom,
              marginLeft = _getComputedStyle.marginLeft; // We no longer take into account `margins` on the popper, and it can
          // cause bugs with positioning, so we'll warn the consumer


          if ([marginTop, marginRight, marginBottom, marginLeft].some(function (margin) {
            return parseFloat(margin);
          })) {
            console.warn(['Popper: CSS "margin" styles cannot be used to apply padding', 'between the popper and its reference element or boundary.', 'To replicate margin, use the `offset` modifier, as well as', 'the `padding` option in the `preventOverflow` and `flip`', 'modifiers.'].join(' '));
          }
        }

        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          if (process.env.NODE_ENV !== "production") {
            console.error(INVALID_ELEMENT_ERROR);
          }

          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });
        var __debug_loops__ = 0;

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (process.env.NODE_ENV !== "production") {
            __debug_loops__ += 1;

            if (__debug_loops__ > 100) {
              console.error(INFINITE_LOOP_ERROR);
              break;
            }
          }

          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce$1(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      if (process.env.NODE_ENV !== "production") {
        console.error(INVALID_ELEMENT_ERROR);
      }

      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref3) {
        var name = _ref3.name,
            _ref3$options = _ref3.options,
            options = _ref3$options === void 0 ? {} : _ref3$options,
            effect = _ref3.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$2, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/**!
* tippy.js v6.3.7
* (c) 2017-2021 atomiks
* MIT License
*/
var BOX_CLASS = "tippy-box";
var CONTENT_CLASS = "tippy-content";
var BACKDROP_CLASS = "tippy-backdrop";
var ARROW_CLASS = "tippy-arrow";
var SVG_ARROW_CLASS = "tippy-svg-arrow";
var TOUCH_OPTIONS = {
  passive: true,
  capture: true
};
var TIPPY_DEFAULT_APPEND_TO = function TIPPY_DEFAULT_APPEND_TO() {
  return document.body;
};

function hasOwnProperty(obj, key) {
  return {}.hasOwnProperty.call(obj, key);
}
function getValueAtIndexOrReturn(value, index, defaultValue) {
  if (Array.isArray(value)) {
    var v = value[index];
    return v == null ? Array.isArray(defaultValue) ? defaultValue[index] : defaultValue : v;
  }

  return value;
}
function isType(value, type) {
  var str = {}.toString.call(value);
  return str.indexOf('[object') === 0 && str.indexOf(type + "]") > -1;
}
function invokeWithArgsOrReturn(value, args) {
  return typeof value === 'function' ? value.apply(void 0, args) : value;
}
function debounce(fn, ms) {
  // Avoid wrapping in `setTimeout` if ms is 0 anyway
  if (ms === 0) {
    return fn;
  }

  var timeout;
  return function (arg) {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      fn(arg);
    }, ms);
  };
}
function removeProperties(obj, keys) {
  var clone = Object.assign({}, obj);
  keys.forEach(function (key) {
    delete clone[key];
  });
  return clone;
}
function splitBySpaces(value) {
  return value.split(/\s+/).filter(Boolean);
}
function normalizeToArray(value) {
  return [].concat(value);
}
function pushIfUnique(arr, value) {
  if (arr.indexOf(value) === -1) {
    arr.push(value);
  }
}
function unique(arr) {
  return arr.filter(function (item, index) {
    return arr.indexOf(item) === index;
  });
}
function getBasePlacement(placement) {
  return placement.split('-')[0];
}
function arrayFrom(value) {
  return [].slice.call(value);
}
function removeUndefinedProps(obj) {
  return Object.keys(obj).reduce(function (acc, key) {
    if (obj[key] !== undefined) {
      acc[key] = obj[key];
    }

    return acc;
  }, {});
}

function div() {
  return document.createElement('div');
}
function isElement(value) {
  return ['Element', 'Fragment'].some(function (type) {
    return isType(value, type);
  });
}
function isNodeList(value) {
  return isType(value, 'NodeList');
}
function isMouseEvent(value) {
  return isType(value, 'MouseEvent');
}
function isReferenceElement(value) {
  return !!(value && value._tippy && value._tippy.reference === value);
}
function getArrayOfElements(value) {
  if (isElement(value)) {
    return [value];
  }

  if (isNodeList(value)) {
    return arrayFrom(value);
  }

  if (Array.isArray(value)) {
    return value;
  }

  return arrayFrom(document.querySelectorAll(value));
}
function setTransitionDuration(els, value) {
  els.forEach(function (el) {
    if (el) {
      el.style.transitionDuration = value + "ms";
    }
  });
}
function setVisibilityState(els, state) {
  els.forEach(function (el) {
    if (el) {
      el.setAttribute('data-state', state);
    }
  });
}
function getOwnerDocument(elementOrElements) {
  var _element$ownerDocumen;

  var _normalizeToArray = normalizeToArray(elementOrElements),
      element = _normalizeToArray[0]; // Elements created via a <template> have an ownerDocument with no reference to the body


  return element != null && (_element$ownerDocumen = element.ownerDocument) != null && _element$ownerDocumen.body ? element.ownerDocument : document;
}
function isCursorOutsideInteractiveBorder(popperTreeData, event) {
  var clientX = event.clientX,
      clientY = event.clientY;
  return popperTreeData.every(function (_ref) {
    var popperRect = _ref.popperRect,
        popperState = _ref.popperState,
        props = _ref.props;
    var interactiveBorder = props.interactiveBorder;
    var basePlacement = getBasePlacement(popperState.placement);
    var offsetData = popperState.modifiersData.offset;

    if (!offsetData) {
      return true;
    }

    var topDistance = basePlacement === 'bottom' ? offsetData.top.y : 0;
    var bottomDistance = basePlacement === 'top' ? offsetData.bottom.y : 0;
    var leftDistance = basePlacement === 'right' ? offsetData.left.x : 0;
    var rightDistance = basePlacement === 'left' ? offsetData.right.x : 0;
    var exceedsTop = popperRect.top - clientY + topDistance > interactiveBorder;
    var exceedsBottom = clientY - popperRect.bottom - bottomDistance > interactiveBorder;
    var exceedsLeft = popperRect.left - clientX + leftDistance > interactiveBorder;
    var exceedsRight = clientX - popperRect.right - rightDistance > interactiveBorder;
    return exceedsTop || exceedsBottom || exceedsLeft || exceedsRight;
  });
}
function updateTransitionEndListener(box, action, listener) {
  var method = action + "EventListener"; // some browsers apparently support `transition` (unprefixed) but only fire
  // `webkitTransitionEnd`...

  ['transitionend', 'webkitTransitionEnd'].forEach(function (event) {
    box[method](event, listener);
  });
}
/**
 * Compared to xxx.contains, this function works for dom structures with shadow
 * dom
 */

function actualContains(parent, child) {
  var target = child;

  while (target) {
    var _target$getRootNode;

    if (parent.contains(target)) {
      return true;
    }

    target = target.getRootNode == null ? void 0 : (_target$getRootNode = target.getRootNode()) == null ? void 0 : _target$getRootNode.host;
  }

  return false;
}

var currentInput = {
  isTouch: false
};
var lastMouseMoveTime = 0;
/**
 * When a `touchstart` event is fired, it's assumed the user is using touch
 * input. We'll bind a `mousemove` event listener to listen for mouse input in
 * the future. This way, the `isTouch` property is fully dynamic and will handle
 * hybrid devices that use a mix of touch + mouse input.
 */

function onDocumentTouchStart() {
  if (currentInput.isTouch) {
    return;
  }

  currentInput.isTouch = true;

  if (window.performance) {
    document.addEventListener('mousemove', onDocumentMouseMove);
  }
}
/**
 * When two `mousemove` event are fired consecutively within 20ms, it's assumed
 * the user is using mouse input again. `mousemove` can fire on touch devices as
 * well, but very rarely that quickly.
 */

function onDocumentMouseMove() {
  var now = performance.now();

  if (now - lastMouseMoveTime < 20) {
    currentInput.isTouch = false;
    document.removeEventListener('mousemove', onDocumentMouseMove);
  }

  lastMouseMoveTime = now;
}
/**
 * When an element is in focus and has a tippy, leaving the tab/window and
 * returning causes it to show again. For mouse users this is unexpected, but
 * for keyboard use it makes sense.
 * TODO: find a better technique to solve this problem
 */

function onWindowBlur() {
  var activeElement = document.activeElement;

  if (isReferenceElement(activeElement)) {
    var instance = activeElement._tippy;

    if (activeElement.blur && !instance.state.isVisible) {
      activeElement.blur();
    }
  }
}
function bindGlobalEventListeners() {
  document.addEventListener('touchstart', onDocumentTouchStart, TOUCH_OPTIONS);
  window.addEventListener('blur', onWindowBlur);
}

var isBrowser$1 = typeof window !== 'undefined' && typeof document !== 'undefined';
var isIE11 = isBrowser$1 ? // @ts-ignore
!!window.msCrypto : false;

function createMemoryLeakWarning(method) {
  var txt = method === 'destroy' ? 'n already-' : ' ';
  return [method + "() was called on a" + txt + "destroyed instance. This is a no-op but", 'indicates a potential memory leak.'].join(' ');
}
function clean(value) {
  var spacesAndTabs = /[ \t]{2,}/g;
  var lineStartWithSpaces = /^[ \t]*/gm;
  return value.replace(spacesAndTabs, ' ').replace(lineStartWithSpaces, '').trim();
}

function getDevMessage(message) {
  return clean("\n  %ctippy.js\n\n  %c" + clean(message) + "\n\n  %c\uD83D\uDC77\u200D This is a development-only message. It will be removed in production.\n  ");
}

function getFormattedMessage(message) {
  return [getDevMessage(message), // title
  'color: #00C584; font-size: 1.3em; font-weight: bold;', // message
  'line-height: 1.5', // footer
  'color: #a6a095;'];
} // Assume warnings and errors never have the same message

var visitedMessages;

if (process.env.NODE_ENV !== "production") {
  resetVisitedMessages();
}

function resetVisitedMessages() {
  visitedMessages = new Set();
}
function warnWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console;

    visitedMessages.add(message);

    (_console = console).warn.apply(_console, getFormattedMessage(message));
  }
}
function errorWhen(condition, message) {
  if (condition && !visitedMessages.has(message)) {
    var _console2;

    visitedMessages.add(message);

    (_console2 = console).error.apply(_console2, getFormattedMessage(message));
  }
}
function validateTargets(targets) {
  var didPassFalsyValue = !targets;
  var didPassPlainObject = Object.prototype.toString.call(targets) === '[object Object]' && !targets.addEventListener;
  errorWhen(didPassFalsyValue, ['tippy() was passed', '`' + String(targets) + '`', 'as its targets (first) argument. Valid types are: String, Element,', 'Element[], or NodeList.'].join(' '));
  errorWhen(didPassPlainObject, ['tippy() was passed a plain object which is not supported as an argument', 'for virtual positioning. Use props.getReferenceClientRect instead.'].join(' '));
}

var pluginProps = {
  animateFill: false,
  followCursor: false,
  inlinePositioning: false,
  sticky: false
};
var renderProps = {
  allowHTML: false,
  animation: 'fade',
  arrow: true,
  content: '',
  inertia: false,
  maxWidth: 350,
  role: 'tooltip',
  theme: '',
  zIndex: 9999
};
var defaultProps = Object.assign({
  appendTo: TIPPY_DEFAULT_APPEND_TO,
  aria: {
    content: 'auto',
    expanded: 'auto'
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: true,
  ignoreAttributes: false,
  interactive: false,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: '',
  offset: [0, 10],
  onAfterUpdate: function onAfterUpdate() {},
  onBeforeUpdate: function onBeforeUpdate() {},
  onCreate: function onCreate() {},
  onDestroy: function onDestroy() {},
  onHidden: function onHidden() {},
  onHide: function onHide() {},
  onMount: function onMount() {},
  onShow: function onShow() {},
  onShown: function onShown() {},
  onTrigger: function onTrigger() {},
  onUntrigger: function onUntrigger() {},
  onClickOutside: function onClickOutside() {},
  placement: 'top',
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: false,
  touch: true,
  trigger: 'mouseenter focus',
  triggerTarget: null
}, pluginProps, renderProps);
var defaultKeys = Object.keys(defaultProps);
var setDefaultProps = function setDefaultProps(partialProps) {
  /* istanbul ignore else */
  if (process.env.NODE_ENV !== "production") {
    validateProps(partialProps, []);
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (key) {
    defaultProps[key] = partialProps[key];
  });
};
function getExtendedPassedProps(passedProps) {
  var plugins = passedProps.plugins || [];
  var pluginProps = plugins.reduce(function (acc, plugin) {
    var name = plugin.name,
        defaultValue = plugin.defaultValue;

    if (name) {
      var _name;

      acc[name] = passedProps[name] !== undefined ? passedProps[name] : (_name = defaultProps[name]) != null ? _name : defaultValue;
    }

    return acc;
  }, {});
  return Object.assign({}, passedProps, pluginProps);
}
function getDataAttributeProps(reference, plugins) {
  var propKeys = plugins ? Object.keys(getExtendedPassedProps(Object.assign({}, defaultProps, {
    plugins: plugins
  }))) : defaultKeys;
  var props = propKeys.reduce(function (acc, key) {
    var valueAsString = (reference.getAttribute("data-tippy-" + key) || '').trim();

    if (!valueAsString) {
      return acc;
    }

    if (key === 'content') {
      acc[key] = valueAsString;
    } else {
      try {
        acc[key] = JSON.parse(valueAsString);
      } catch (e) {
        acc[key] = valueAsString;
      }
    }

    return acc;
  }, {});
  return props;
}
function evaluateProps(reference, props) {
  var out = Object.assign({}, props, {
    content: invokeWithArgsOrReturn(props.content, [reference])
  }, props.ignoreAttributes ? {} : getDataAttributeProps(reference, props.plugins));
  out.aria = Object.assign({}, defaultProps.aria, out.aria);
  out.aria = {
    expanded: out.aria.expanded === 'auto' ? props.interactive : out.aria.expanded,
    content: out.aria.content === 'auto' ? props.interactive ? null : 'describedby' : out.aria.content
  };
  return out;
}
function validateProps(partialProps, plugins) {
  if (partialProps === void 0) {
    partialProps = {};
  }

  if (plugins === void 0) {
    plugins = [];
  }

  var keys = Object.keys(partialProps);
  keys.forEach(function (prop) {
    var nonPluginProps = removeProperties(defaultProps, Object.keys(pluginProps));
    var didPassUnknownProp = !hasOwnProperty(nonPluginProps, prop); // Check if the prop exists in `plugins`

    if (didPassUnknownProp) {
      didPassUnknownProp = plugins.filter(function (plugin) {
        return plugin.name === prop;
      }).length === 0;
    }

    warnWhen(didPassUnknownProp, ["`" + prop + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", 'a plugin, forgot to pass it in an array as props.plugins.', '\n\n', 'All props: https://atomiks.github.io/tippyjs/v6/all-props/\n', 'Plugins: https://atomiks.github.io/tippyjs/v6/plugins/'].join(' '));
  });
}

var innerHTML = function innerHTML() {
  return 'innerHTML';
};

function dangerouslySetInnerHTML(element, html) {
  element[innerHTML()] = html;
}

function createArrowElement(value) {
  var arrow = div();

  if (value === true) {
    arrow.className = ARROW_CLASS;
  } else {
    arrow.className = SVG_ARROW_CLASS;

    if (isElement(value)) {
      arrow.appendChild(value);
    } else {
      dangerouslySetInnerHTML(arrow, value);
    }
  }

  return arrow;
}

function setContent(content, props) {
  if (isElement(props.content)) {
    dangerouslySetInnerHTML(content, '');
    content.appendChild(props.content);
  } else if (typeof props.content !== 'function') {
    if (props.allowHTML) {
      dangerouslySetInnerHTML(content, props.content);
    } else {
      content.textContent = props.content;
    }
  }
}
function getChildren$1(popper) {
  var box = popper.firstElementChild;
  var boxChildren = arrayFrom(box.children);
  return {
    box: box,
    content: boxChildren.find(function (node) {
      return node.classList.contains(CONTENT_CLASS);
    }),
    arrow: boxChildren.find(function (node) {
      return node.classList.contains(ARROW_CLASS) || node.classList.contains(SVG_ARROW_CLASS);
    }),
    backdrop: boxChildren.find(function (node) {
      return node.classList.contains(BACKDROP_CLASS);
    })
  };
}
function render(instance) {
  var popper = div();
  var box = div();
  box.className = BOX_CLASS;
  box.setAttribute('data-state', 'hidden');
  box.setAttribute('tabindex', '-1');
  var content = div();
  content.className = CONTENT_CLASS;
  content.setAttribute('data-state', 'hidden');
  setContent(content, instance.props);
  popper.appendChild(box);
  box.appendChild(content);
  onUpdate(instance.props, instance.props);

  function onUpdate(prevProps, nextProps) {
    var _getChildren = getChildren$1(popper),
        box = _getChildren.box,
        content = _getChildren.content,
        arrow = _getChildren.arrow;

    if (nextProps.theme) {
      box.setAttribute('data-theme', nextProps.theme);
    } else {
      box.removeAttribute('data-theme');
    }

    if (typeof nextProps.animation === 'string') {
      box.setAttribute('data-animation', nextProps.animation);
    } else {
      box.removeAttribute('data-animation');
    }

    if (nextProps.inertia) {
      box.setAttribute('data-inertia', '');
    } else {
      box.removeAttribute('data-inertia');
    }

    box.style.maxWidth = typeof nextProps.maxWidth === 'number' ? nextProps.maxWidth + "px" : nextProps.maxWidth;

    if (nextProps.role) {
      box.setAttribute('role', nextProps.role);
    } else {
      box.removeAttribute('role');
    }

    if (prevProps.content !== nextProps.content || prevProps.allowHTML !== nextProps.allowHTML) {
      setContent(content, instance.props);
    }

    if (nextProps.arrow) {
      if (!arrow) {
        box.appendChild(createArrowElement(nextProps.arrow));
      } else if (prevProps.arrow !== nextProps.arrow) {
        box.removeChild(arrow);
        box.appendChild(createArrowElement(nextProps.arrow));
      }
    } else if (arrow) {
      box.removeChild(arrow);
    }
  }

  return {
    popper: popper,
    onUpdate: onUpdate
  };
} // Runtime check to identify if the render function is the default one; this
// way we can apply default CSS transitions logic and it can be tree-shaken away

render.$$tippy = true;

var idCounter = 1;
var mouseMoveListeners = []; // Used by `hideAll()`

var mountedInstances = [];
function createTippy(reference, passedProps) {
  var props = evaluateProps(reference, Object.assign({}, defaultProps, getExtendedPassedProps(removeUndefinedProps(passedProps)))); // ===========================================================================
  // 🔒 Private members
  // ===========================================================================

  var showTimeout;
  var hideTimeout;
  var scheduleHideAnimationFrame;
  var isVisibleFromClick = false;
  var didHideDueToDocumentMouseDown = false;
  var didTouchMove = false;
  var ignoreOnFirstUpdate = false;
  var lastTriggerEvent;
  var currentTransitionEndListener;
  var onFirstUpdate;
  var listeners = [];
  var debouncedOnMouseMove = debounce(onMouseMove, props.interactiveDebounce);
  var currentTarget; // ===========================================================================
  // 🔑 Public members
  // ===========================================================================

  var id = idCounter++;
  var popperInstance = null;
  var plugins = unique(props.plugins);
  var state = {
    // Is the instance currently enabled?
    isEnabled: true,
    // Is the tippy currently showing and not transitioning out?
    isVisible: false,
    // Has the instance been destroyed?
    isDestroyed: false,
    // Is the tippy currently mounted to the DOM?
    isMounted: false,
    // Has the tippy finished transitioning in?
    isShown: false
  };
  var instance = {
    // properties
    id: id,
    reference: reference,
    popper: div(),
    popperInstance: popperInstance,
    props: props,
    state: state,
    plugins: plugins,
    // methods
    clearDelayTimeouts: clearDelayTimeouts,
    setProps: setProps,
    setContent: setContent,
    show: show,
    hide: hide,
    hideWithInteractivity: hideWithInteractivity,
    enable: enable,
    disable: disable,
    unmount: unmount,
    destroy: destroy
  }; // TODO: Investigate why this early return causes a TDZ error in the tests —
  // it doesn't seem to happen in the browser

  /* istanbul ignore if */

  if (!props.render) {
    if (process.env.NODE_ENV !== "production") {
      errorWhen(true, 'render() function has not been supplied.');
    }

    return instance;
  } // ===========================================================================
  // Initial mutations
  // ===========================================================================


  var _props$render = props.render(instance),
      popper = _props$render.popper,
      onUpdate = _props$render.onUpdate;

  popper.setAttribute('data-tippy-root', '');
  popper.id = "tippy-" + instance.id;
  instance.popper = popper;
  reference._tippy = instance;
  popper._tippy = instance;
  var pluginsHooks = plugins.map(function (plugin) {
    return plugin.fn(instance);
  });
  var hasAriaExpanded = reference.hasAttribute('aria-expanded');
  addListeners();
  handleAriaExpandedAttribute();
  handleStyles();
  invokeHook('onCreate', [instance]);

  if (props.showOnCreate) {
    scheduleShow();
  } // Prevent a tippy with a delay from hiding if the cursor left then returned
  // before it started hiding


  popper.addEventListener('mouseenter', function () {
    if (instance.props.interactive && instance.state.isVisible) {
      instance.clearDelayTimeouts();
    }
  });
  popper.addEventListener('mouseleave', function () {
    if (instance.props.interactive && instance.props.trigger.indexOf('mouseenter') >= 0) {
      getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    }
  });
  return instance; // ===========================================================================
  // 🔒 Private methods
  // ===========================================================================

  function getNormalizedTouchSettings() {
    var touch = instance.props.touch;
    return Array.isArray(touch) ? touch : [touch, 0];
  }

  function getIsCustomTouchBehavior() {
    return getNormalizedTouchSettings()[0] === 'hold';
  }

  function getIsDefaultRenderFn() {
    var _instance$props$rende;

    // @ts-ignore
    return !!((_instance$props$rende = instance.props.render) != null && _instance$props$rende.$$tippy);
  }

  function getCurrentTarget() {
    return currentTarget || reference;
  }

  function getDocument() {
    var parent = getCurrentTarget().parentNode;
    return parent ? getOwnerDocument(parent) : document;
  }

  function getDefaultTemplateChildren() {
    return getChildren$1(popper);
  }

  function getDelay(isShow) {
    // For touch or keyboard input, force `0` delay for UX reasons
    // Also if the instance is mounted but not visible (transitioning out),
    // ignore delay
    if (instance.state.isMounted && !instance.state.isVisible || currentInput.isTouch || lastTriggerEvent && lastTriggerEvent.type === 'focus') {
      return 0;
    }

    return getValueAtIndexOrReturn(instance.props.delay, isShow ? 0 : 1, defaultProps.delay);
  }

  function handleStyles(fromHide) {
    if (fromHide === void 0) {
      fromHide = false;
    }

    popper.style.pointerEvents = instance.props.interactive && !fromHide ? '' : 'none';
    popper.style.zIndex = "" + instance.props.zIndex;
  }

  function invokeHook(hook, args, shouldInvokePropsHook) {
    if (shouldInvokePropsHook === void 0) {
      shouldInvokePropsHook = true;
    }

    pluginsHooks.forEach(function (pluginHooks) {
      if (pluginHooks[hook]) {
        pluginHooks[hook].apply(pluginHooks, args);
      }
    });

    if (shouldInvokePropsHook) {
      var _instance$props;

      (_instance$props = instance.props)[hook].apply(_instance$props, args);
    }
  }

  function handleAriaContentAttribute() {
    var aria = instance.props.aria;

    if (!aria.content) {
      return;
    }

    var attr = "aria-" + aria.content;
    var id = popper.id;
    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      var currentValue = node.getAttribute(attr);

      if (instance.state.isVisible) {
        node.setAttribute(attr, currentValue ? currentValue + " " + id : id);
      } else {
        var nextValue = currentValue && currentValue.replace(id, '').trim();

        if (nextValue) {
          node.setAttribute(attr, nextValue);
        } else {
          node.removeAttribute(attr);
        }
      }
    });
  }

  function handleAriaExpandedAttribute() {
    if (hasAriaExpanded || !instance.props.aria.expanded) {
      return;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      if (instance.props.interactive) {
        node.setAttribute('aria-expanded', instance.state.isVisible && node === getCurrentTarget() ? 'true' : 'false');
      } else {
        node.removeAttribute('aria-expanded');
      }
    });
  }

  function cleanupInteractiveMouseListeners() {
    getDocument().removeEventListener('mousemove', debouncedOnMouseMove);
    mouseMoveListeners = mouseMoveListeners.filter(function (listener) {
      return listener !== debouncedOnMouseMove;
    });
  }

  function onDocumentPress(event) {
    // Moved finger to scroll instead of an intentional tap outside
    if (currentInput.isTouch) {
      if (didTouchMove || event.type === 'mousedown') {
        return;
      }
    }

    var actualTarget = event.composedPath && event.composedPath()[0] || event.target; // Clicked on interactive popper

    if (instance.props.interactive && actualContains(popper, actualTarget)) {
      return;
    } // Clicked on the event listeners target


    if (normalizeToArray(instance.props.triggerTarget || reference).some(function (el) {
      return actualContains(el, actualTarget);
    })) {
      if (currentInput.isTouch) {
        return;
      }

      if (instance.state.isVisible && instance.props.trigger.indexOf('click') >= 0) {
        return;
      }
    } else {
      invokeHook('onClickOutside', [instance, event]);
    }

    if (instance.props.hideOnClick === true) {
      instance.clearDelayTimeouts();
      instance.hide(); // `mousedown` event is fired right before `focus` if pressing the
      // currentTarget. This lets a tippy with `focus` trigger know that it
      // should not show

      didHideDueToDocumentMouseDown = true;
      setTimeout(function () {
        didHideDueToDocumentMouseDown = false;
      }); // The listener gets added in `scheduleShow()`, but this may be hiding it
      // before it shows, and hide()'s early bail-out behavior can prevent it
      // from being cleaned up

      if (!instance.state.isMounted) {
        removeDocumentPress();
      }
    }
  }

  function onTouchMove() {
    didTouchMove = true;
  }

  function onTouchStart() {
    didTouchMove = false;
  }

  function addDocumentPress() {
    var doc = getDocument();
    doc.addEventListener('mousedown', onDocumentPress, true);
    doc.addEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.addEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.addEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function removeDocumentPress() {
    var doc = getDocument();
    doc.removeEventListener('mousedown', onDocumentPress, true);
    doc.removeEventListener('touchend', onDocumentPress, TOUCH_OPTIONS);
    doc.removeEventListener('touchstart', onTouchStart, TOUCH_OPTIONS);
    doc.removeEventListener('touchmove', onTouchMove, TOUCH_OPTIONS);
  }

  function onTransitionedOut(duration, callback) {
    onTransitionEnd(duration, function () {
      if (!instance.state.isVisible && popper.parentNode && popper.parentNode.contains(popper)) {
        callback();
      }
    });
  }

  function onTransitionedIn(duration, callback) {
    onTransitionEnd(duration, callback);
  }

  function onTransitionEnd(duration, callback) {
    var box = getDefaultTemplateChildren().box;

    function listener(event) {
      if (event.target === box) {
        updateTransitionEndListener(box, 'remove', listener);
        callback();
      }
    } // Make callback synchronous if duration is 0
    // `transitionend` won't fire otherwise


    if (duration === 0) {
      return callback();
    }

    updateTransitionEndListener(box, 'remove', currentTransitionEndListener);
    updateTransitionEndListener(box, 'add', listener);
    currentTransitionEndListener = listener;
  }

  function on(eventType, handler, options) {
    if (options === void 0) {
      options = false;
    }

    var nodes = normalizeToArray(instance.props.triggerTarget || reference);
    nodes.forEach(function (node) {
      node.addEventListener(eventType, handler, options);
      listeners.push({
        node: node,
        eventType: eventType,
        handler: handler,
        options: options
      });
    });
  }

  function addListeners() {
    if (getIsCustomTouchBehavior()) {
      on('touchstart', onTrigger, {
        passive: true
      });
      on('touchend', onMouseLeave, {
        passive: true
      });
    }

    splitBySpaces(instance.props.trigger).forEach(function (eventType) {
      if (eventType === 'manual') {
        return;
      }

      on(eventType, onTrigger);

      switch (eventType) {
        case 'mouseenter':
          on('mouseleave', onMouseLeave);
          break;

        case 'focus':
          on(isIE11 ? 'focusout' : 'blur', onBlurOrFocusOut);
          break;

        case 'focusin':
          on('focusout', onBlurOrFocusOut);
          break;
      }
    });
  }

  function removeListeners() {
    listeners.forEach(function (_ref) {
      var node = _ref.node,
          eventType = _ref.eventType,
          handler = _ref.handler,
          options = _ref.options;
      node.removeEventListener(eventType, handler, options);
    });
    listeners = [];
  }

  function onTrigger(event) {
    var _lastTriggerEvent;

    var shouldScheduleClickHide = false;

    if (!instance.state.isEnabled || isEventListenerStopped(event) || didHideDueToDocumentMouseDown) {
      return;
    }

    var wasFocused = ((_lastTriggerEvent = lastTriggerEvent) == null ? void 0 : _lastTriggerEvent.type) === 'focus';
    lastTriggerEvent = event;
    currentTarget = event.currentTarget;
    handleAriaExpandedAttribute();

    if (!instance.state.isVisible && isMouseEvent(event)) {
      // If scrolling, `mouseenter` events can be fired if the cursor lands
      // over a new target, but `mousemove` events don't get fired. This
      // causes interactive tooltips to get stuck open until the cursor is
      // moved
      mouseMoveListeners.forEach(function (listener) {
        return listener(event);
      });
    } // Toggle show/hide when clicking click-triggered tooltips


    if (event.type === 'click' && (instance.props.trigger.indexOf('mouseenter') < 0 || isVisibleFromClick) && instance.props.hideOnClick !== false && instance.state.isVisible) {
      shouldScheduleClickHide = true;
    } else {
      scheduleShow(event);
    }

    if (event.type === 'click') {
      isVisibleFromClick = !shouldScheduleClickHide;
    }

    if (shouldScheduleClickHide && !wasFocused) {
      scheduleHide(event);
    }
  }

  function onMouseMove(event) {
    var target = event.target;
    var isCursorOverReferenceOrPopper = getCurrentTarget().contains(target) || popper.contains(target);

    if (event.type === 'mousemove' && isCursorOverReferenceOrPopper) {
      return;
    }

    var popperTreeData = getNestedPopperTree().concat(popper).map(function (popper) {
      var _instance$popperInsta;

      var instance = popper._tippy;
      var state = (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.state;

      if (state) {
        return {
          popperRect: popper.getBoundingClientRect(),
          popperState: state,
          props: props
        };
      }

      return null;
    }).filter(Boolean);

    if (isCursorOutsideInteractiveBorder(popperTreeData, event)) {
      cleanupInteractiveMouseListeners();
      scheduleHide(event);
    }
  }

  function onMouseLeave(event) {
    var shouldBail = isEventListenerStopped(event) || instance.props.trigger.indexOf('click') >= 0 && isVisibleFromClick;

    if (shouldBail) {
      return;
    }

    if (instance.props.interactive) {
      instance.hideWithInteractivity(event);
      return;
    }

    scheduleHide(event);
  }

  function onBlurOrFocusOut(event) {
    if (instance.props.trigger.indexOf('focusin') < 0 && event.target !== getCurrentTarget()) {
      return;
    } // If focus was moved to within the popper


    if (instance.props.interactive && event.relatedTarget && popper.contains(event.relatedTarget)) {
      return;
    }

    scheduleHide(event);
  }

  function isEventListenerStopped(event) {
    return currentInput.isTouch ? getIsCustomTouchBehavior() !== event.type.indexOf('touch') >= 0 : false;
  }

  function createPopperInstance() {
    destroyPopperInstance();
    var _instance$props2 = instance.props,
        popperOptions = _instance$props2.popperOptions,
        placement = _instance$props2.placement,
        offset = _instance$props2.offset,
        getReferenceClientRect = _instance$props2.getReferenceClientRect,
        moveTransition = _instance$props2.moveTransition;
    var arrow = getIsDefaultRenderFn() ? getChildren$1(popper).arrow : null;
    var computedReference = getReferenceClientRect ? {
      getBoundingClientRect: getReferenceClientRect,
      contextElement: getReferenceClientRect.contextElement || getCurrentTarget()
    } : reference;
    var tippyModifier = {
      name: '$$tippy',
      enabled: true,
      phase: 'beforeWrite',
      requires: ['computeStyles'],
      fn: function fn(_ref2) {
        var state = _ref2.state;

        if (getIsDefaultRenderFn()) {
          var _getDefaultTemplateCh = getDefaultTemplateChildren(),
              box = _getDefaultTemplateCh.box;

          ['placement', 'reference-hidden', 'escaped'].forEach(function (attr) {
            if (attr === 'placement') {
              box.setAttribute('data-placement', state.placement);
            } else {
              if (state.attributes.popper["data-popper-" + attr]) {
                box.setAttribute("data-" + attr, '');
              } else {
                box.removeAttribute("data-" + attr);
              }
            }
          });
          state.attributes.popper = {};
        }
      }
    };
    var modifiers = [{
      name: 'offset',
      options: {
        offset: offset
      }
    }, {
      name: 'preventOverflow',
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: 'flip',
      options: {
        padding: 5
      }
    }, {
      name: 'computeStyles',
      options: {
        adaptive: !moveTransition
      }
    }, tippyModifier];

    if (getIsDefaultRenderFn() && arrow) {
      modifiers.push({
        name: 'arrow',
        options: {
          element: arrow,
          padding: 3
        }
      });
    }

    modifiers.push.apply(modifiers, (popperOptions == null ? void 0 : popperOptions.modifiers) || []);
    instance.popperInstance = createPopper(computedReference, popper, Object.assign({}, popperOptions, {
      placement: placement,
      onFirstUpdate: onFirstUpdate,
      modifiers: modifiers
    }));
  }

  function destroyPopperInstance() {
    if (instance.popperInstance) {
      instance.popperInstance.destroy();
      instance.popperInstance = null;
    }
  }

  function mount() {
    var appendTo = instance.props.appendTo;
    var parentNode; // By default, we'll append the popper to the triggerTargets's parentNode so
    // it's directly after the reference element so the elements inside the
    // tippy can be tabbed to
    // If there are clipping issues, the user can specify a different appendTo
    // and ensure focus management is handled correctly manually

    var node = getCurrentTarget();

    if (instance.props.interactive && appendTo === TIPPY_DEFAULT_APPEND_TO || appendTo === 'parent') {
      parentNode = node.parentNode;
    } else {
      parentNode = invokeWithArgsOrReturn(appendTo, [node]);
    } // The popper element needs to exist on the DOM before its position can be
    // updated as Popper needs to read its dimensions


    if (!parentNode.contains(popper)) {
      parentNode.appendChild(popper);
    }

    instance.state.isMounted = true;
    createPopperInstance();
    /* istanbul ignore else */

    if (process.env.NODE_ENV !== "production") {
      // Accessibility check
      warnWhen(instance.props.interactive && appendTo === defaultProps.appendTo && node.nextElementSibling !== popper, ['Interactive tippy element may not be accessible via keyboard', 'navigation because it is not directly after the reference element', 'in the DOM source order.', '\n\n', 'Using a wrapper <div> or <span> tag around the reference element', 'solves this by creating a new parentNode context.', '\n\n', 'Specifying `appendTo: document.body` silences this warning, but it', 'assumes you are using a focus management solution to handle', 'keyboard navigation.', '\n\n', 'See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity'].join(' '));
    }
  }

  function getNestedPopperTree() {
    return arrayFrom(popper.querySelectorAll('[data-tippy-root]'));
  }

  function scheduleShow(event) {
    instance.clearDelayTimeouts();

    if (event) {
      invokeHook('onTrigger', [instance, event]);
    }

    addDocumentPress();
    var delay = getDelay(true);

    var _getNormalizedTouchSe = getNormalizedTouchSettings(),
        touchValue = _getNormalizedTouchSe[0],
        touchDelay = _getNormalizedTouchSe[1];

    if (currentInput.isTouch && touchValue === 'hold' && touchDelay) {
      delay = touchDelay;
    }

    if (delay) {
      showTimeout = setTimeout(function () {
        instance.show();
      }, delay);
    } else {
      instance.show();
    }
  }

  function scheduleHide(event) {
    instance.clearDelayTimeouts();
    invokeHook('onUntrigger', [instance, event]);

    if (!instance.state.isVisible) {
      removeDocumentPress();
      return;
    } // For interactive tippies, scheduleHide is added to a document.body handler
    // from onMouseLeave so must intercept scheduled hides from mousemove/leave
    // events when trigger contains mouseenter and click, and the tip is
    // currently shown as a result of a click.


    if (instance.props.trigger.indexOf('mouseenter') >= 0 && instance.props.trigger.indexOf('click') >= 0 && ['mouseleave', 'mousemove'].indexOf(event.type) >= 0 && isVisibleFromClick) {
      return;
    }

    var delay = getDelay(false);

    if (delay) {
      hideTimeout = setTimeout(function () {
        if (instance.state.isVisible) {
          instance.hide();
        }
      }, delay);
    } else {
      // Fixes a `transitionend` problem when it fires 1 frame too
      // late sometimes, we don't want hide() to be called.
      scheduleHideAnimationFrame = requestAnimationFrame(function () {
        instance.hide();
      });
    }
  } // ===========================================================================
  // 🔑 Public methods
  // ===========================================================================


  function enable() {
    instance.state.isEnabled = true;
  }

  function disable() {
    // Disabling the instance should also hide it
    // https://github.com/atomiks/tippy.js-react/issues/106
    instance.hide();
    instance.state.isEnabled = false;
  }

  function clearDelayTimeouts() {
    clearTimeout(showTimeout);
    clearTimeout(hideTimeout);
    cancelAnimationFrame(scheduleHideAnimationFrame);
  }

  function setProps(partialProps) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('setProps'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    invokeHook('onBeforeUpdate', [instance, partialProps]);
    removeListeners();
    var prevProps = instance.props;
    var nextProps = evaluateProps(reference, Object.assign({}, prevProps, removeUndefinedProps(partialProps), {
      ignoreAttributes: true
    }));
    instance.props = nextProps;
    addListeners();

    if (prevProps.interactiveDebounce !== nextProps.interactiveDebounce) {
      cleanupInteractiveMouseListeners();
      debouncedOnMouseMove = debounce(onMouseMove, nextProps.interactiveDebounce);
    } // Ensure stale aria-expanded attributes are removed


    if (prevProps.triggerTarget && !nextProps.triggerTarget) {
      normalizeToArray(prevProps.triggerTarget).forEach(function (node) {
        node.removeAttribute('aria-expanded');
      });
    } else if (nextProps.triggerTarget) {
      reference.removeAttribute('aria-expanded');
    }

    handleAriaExpandedAttribute();
    handleStyles();

    if (onUpdate) {
      onUpdate(prevProps, nextProps);
    }

    if (instance.popperInstance) {
      createPopperInstance(); // Fixes an issue with nested tippies if they are all getting re-rendered,
      // and the nested ones get re-rendered first.
      // https://github.com/atomiks/tippyjs-react/issues/177
      // TODO: find a cleaner / more efficient solution(!)

      getNestedPopperTree().forEach(function (nestedPopper) {
        // React (and other UI libs likely) requires a rAF wrapper as it flushes
        // its work in one
        requestAnimationFrame(nestedPopper._tippy.popperInstance.forceUpdate);
      });
    }

    invokeHook('onAfterUpdate', [instance, partialProps]);
  }

  function setContent(content) {
    instance.setProps({
      content: content
    });
  }

  function show() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('show'));
    } // Early bail-out


    var isAlreadyVisible = instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var isTouchAndTouchDisabled = currentInput.isTouch && !instance.props.touch;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 0, defaultProps.duration);

    if (isAlreadyVisible || isDestroyed || isDisabled || isTouchAndTouchDisabled) {
      return;
    } // Normalize `disabled` behavior across browsers.
    // Firefox allows events on disabled elements, but Chrome doesn't.
    // Using a wrapper element (i.e. <span>) is recommended.


    if (getCurrentTarget().hasAttribute('disabled')) {
      return;
    }

    invokeHook('onShow', [instance], false);

    if (instance.props.onShow(instance) === false) {
      return;
    }

    instance.state.isVisible = true;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'visible';
    }

    handleStyles();
    addDocumentPress();

    if (!instance.state.isMounted) {
      popper.style.transition = 'none';
    } // If flipping to the opposite side after hiding at least once, the
    // animation will use the wrong placement without resetting the duration


    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh2 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh2.box,
          content = _getDefaultTemplateCh2.content;

      setTransitionDuration([box, content], 0);
    }

    onFirstUpdate = function onFirstUpdate() {
      var _instance$popperInsta2;

      if (!instance.state.isVisible || ignoreOnFirstUpdate) {
        return;
      }

      ignoreOnFirstUpdate = true; // reflow

      void popper.offsetHeight;
      popper.style.transition = instance.props.moveTransition;

      if (getIsDefaultRenderFn() && instance.props.animation) {
        var _getDefaultTemplateCh3 = getDefaultTemplateChildren(),
            _box = _getDefaultTemplateCh3.box,
            _content = _getDefaultTemplateCh3.content;

        setTransitionDuration([_box, _content], duration);
        setVisibilityState([_box, _content], 'visible');
      }

      handleAriaContentAttribute();
      handleAriaExpandedAttribute();
      pushIfUnique(mountedInstances, instance); // certain modifiers (e.g. `maxSize`) require a second update after the
      // popper has been positioned for the first time

      (_instance$popperInsta2 = instance.popperInstance) == null ? void 0 : _instance$popperInsta2.forceUpdate();
      invokeHook('onMount', [instance]);

      if (instance.props.animation && getIsDefaultRenderFn()) {
        onTransitionedIn(duration, function () {
          instance.state.isShown = true;
          invokeHook('onShown', [instance]);
        });
      }
    };

    mount();
  }

  function hide() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hide'));
    } // Early bail-out


    var isAlreadyHidden = !instance.state.isVisible;
    var isDestroyed = instance.state.isDestroyed;
    var isDisabled = !instance.state.isEnabled;
    var duration = getValueAtIndexOrReturn(instance.props.duration, 1, defaultProps.duration);

    if (isAlreadyHidden || isDestroyed || isDisabled) {
      return;
    }

    invokeHook('onHide', [instance], false);

    if (instance.props.onHide(instance) === false) {
      return;
    }

    instance.state.isVisible = false;
    instance.state.isShown = false;
    ignoreOnFirstUpdate = false;
    isVisibleFromClick = false;

    if (getIsDefaultRenderFn()) {
      popper.style.visibility = 'hidden';
    }

    cleanupInteractiveMouseListeners();
    removeDocumentPress();
    handleStyles(true);

    if (getIsDefaultRenderFn()) {
      var _getDefaultTemplateCh4 = getDefaultTemplateChildren(),
          box = _getDefaultTemplateCh4.box,
          content = _getDefaultTemplateCh4.content;

      if (instance.props.animation) {
        setTransitionDuration([box, content], duration);
        setVisibilityState([box, content], 'hidden');
      }
    }

    handleAriaContentAttribute();
    handleAriaExpandedAttribute();

    if (instance.props.animation) {
      if (getIsDefaultRenderFn()) {
        onTransitionedOut(duration, instance.unmount);
      }
    } else {
      instance.unmount();
    }
  }

  function hideWithInteractivity(event) {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('hideWithInteractivity'));
    }

    getDocument().addEventListener('mousemove', debouncedOnMouseMove);
    pushIfUnique(mouseMoveListeners, debouncedOnMouseMove);
    debouncedOnMouseMove(event);
  }

  function unmount() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('unmount'));
    }

    if (instance.state.isVisible) {
      instance.hide();
    }

    if (!instance.state.isMounted) {
      return;
    }

    destroyPopperInstance(); // If a popper is not interactive, it will be appended outside the popper
    // tree by default. This seems mainly for interactive tippies, but we should
    // find a workaround if possible

    getNestedPopperTree().forEach(function (nestedPopper) {
      nestedPopper._tippy.unmount();
    });

    if (popper.parentNode) {
      popper.parentNode.removeChild(popper);
    }

    mountedInstances = mountedInstances.filter(function (i) {
      return i !== instance;
    });
    instance.state.isMounted = false;
    invokeHook('onHidden', [instance]);
  }

  function destroy() {
    /* istanbul ignore else */
    if (process.env.NODE_ENV !== "production") {
      warnWhen(instance.state.isDestroyed, createMemoryLeakWarning('destroy'));
    }

    if (instance.state.isDestroyed) {
      return;
    }

    instance.clearDelayTimeouts();
    instance.unmount();
    removeListeners();
    delete reference._tippy;
    instance.state.isDestroyed = true;
    invokeHook('onDestroy', [instance]);
  }
}

function tippy(targets, optionalProps) {
  if (optionalProps === void 0) {
    optionalProps = {};
  }

  var plugins = defaultProps.plugins.concat(optionalProps.plugins || []);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    validateTargets(targets);
    validateProps(optionalProps, plugins);
  }

  bindGlobalEventListeners();
  var passedProps = Object.assign({}, optionalProps, {
    plugins: plugins
  });
  var elements = getArrayOfElements(targets);
  /* istanbul ignore else */

  if (process.env.NODE_ENV !== "production") {
    var isSingleContentElement = isElement(passedProps.content);
    var isMoreThanOneReferenceElement = elements.length > 1;
    warnWhen(isSingleContentElement && isMoreThanOneReferenceElement, ['tippy() was passed an Element as the `content` prop, but more than', 'one tippy instance was created by this invocation. This means the', 'content element will only be appended to the last tippy instance.', '\n\n', 'Instead, pass the .innerHTML of the element, or use a function that', 'returns a cloned version of the element instead.', '\n\n', '1) content: element.innerHTML\n', '2) content: () => element.cloneNode(true)'].join(' '));
  }

  var instances = elements.reduce(function (acc, reference) {
    var instance = reference && createTippy(reference, passedProps);

    if (instance) {
      acc.push(instance);
    }

    return acc;
  }, []);
  return isElement(targets) ? instances[0] : instances;
}

tippy.defaultProps = defaultProps;
tippy.setDefaultProps = setDefaultProps;
tippy.currentInput = currentInput;

// every time the popper is destroyed (i.e. a new target), removing the styles
// and causing transitions to break for singletons when the console is open, but
// most notably for non-transform styles being used, `gpuAcceleration: false`.

Object.assign({}, applyStyles$1, {
  effect: function effect(_ref) {
    var state = _ref.state;
    var initialStyles = {
      popper: {
        position: state.options.strategy,
        left: '0',
        top: '0',
        margin: '0'
      },
      arrow: {
        position: 'absolute'
      },
      reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;

    if (state.elements.arrow) {
      Object.assign(state.elements.arrow.style, initialStyles.arrow);
    } // intentionally return no cleanup function
    // return () => { ... }

  }
});

tippy.setDefaultProps({
  render: render
});

function _objectWithoutPropertiesLoose$1(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined';
function preserveRef(ref, node) {
  if (ref) {
    if (typeof ref === 'function') {
      ref(node);
    }

    if ({}.hasOwnProperty.call(ref, 'current')) {
      ref.current = node;
    }
  }
}
function ssrSafeCreateDiv() {
  return isBrowser && document.createElement('div');
}
function toDataAttributes(attrs) {
  var dataAttrs = {
    'data-placement': attrs.placement
  };

  if (attrs.referenceHidden) {
    dataAttrs['data-reference-hidden'] = '';
  }

  if (attrs.escaped) {
    dataAttrs['data-escaped'] = '';
  }

  return dataAttrs;
}

function deepEqual(x, y) {
  if (x === y) {
    return true;
  } else if (typeof x === 'object' && x != null && typeof y === 'object' && y != null) {
    if (Object.keys(x).length !== Object.keys(y).length) {
      return false;
    }

    for (var prop in x) {
      if (y.hasOwnProperty(prop)) {
        if (!deepEqual(x[prop], y[prop])) {
          return false;
        }
      } else {
        return false;
      }
    }

    return true;
  } else {
    return false;
  }
}

function uniqueByShape(arr) {
  var output = [];
  arr.forEach(function (item) {
    if (!output.find(function (outputItem) {
      return deepEqual(item, outputItem);
    })) {
      output.push(item);
    }
  });
  return output;
}
function deepPreserveProps(instanceProps, componentProps) {
  var _instanceProps$popper, _componentProps$poppe;

  return Object.assign({}, componentProps, {
    popperOptions: Object.assign({}, instanceProps.popperOptions, componentProps.popperOptions, {
      modifiers: uniqueByShape([].concat(((_instanceProps$popper = instanceProps.popperOptions) == null ? void 0 : _instanceProps$popper.modifiers) || [], ((_componentProps$poppe = componentProps.popperOptions) == null ? void 0 : _componentProps$poppe.modifiers) || []))
    })
  });
}

var useIsomorphicLayoutEffect$1 = isBrowser ? React.useLayoutEffect : React.useEffect;
function useMutableBox(initialValue) {
  // Using refs instead of state as it's recommended to not store imperative
  // values in state due to memory problems in React(?)
  var ref = React.useRef();

  if (!ref.current) {
    ref.current = typeof initialValue === 'function' ? initialValue() : initialValue;
  }

  return ref.current;
}

function updateClassName(box, action, classNames) {
  classNames.split(/\s+/).forEach(function (name) {
    if (name) {
      box.classList[action](name);
    }
  });
}

var classNamePlugin = {
  name: 'className',
  defaultValue: '',
  fn: function fn(instance) {
    var box = instance.popper.firstElementChild;

    var isDefaultRenderFn = function isDefaultRenderFn() {
      var _instance$props$rende;

      return !!((_instance$props$rende = instance.props.render) == null ? void 0 : _instance$props$rende.$$tippy);
    };

    function add() {
      if (instance.props.className && !isDefaultRenderFn()) {
        if (process.env.NODE_ENV !== 'production') {
          console.warn(['@tippyjs/react: Cannot use `className` prop in conjunction with', '`render` prop. Place the className on the element you are', 'rendering.'].join(' '));
        }

        return;
      }

      updateClassName(box, 'add', instance.props.className);
    }

    function remove() {
      if (isDefaultRenderFn()) {
        updateClassName(box, 'remove', instance.props.className);
      }
    }

    return {
      onCreate: add,
      onBeforeUpdate: remove,
      onAfterUpdate: add
    };
  }
};

function TippyGenerator(tippy) {
  function Tippy(_ref) {
    var children = _ref.children,
        content = _ref.content,
        visible = _ref.visible,
        singleton = _ref.singleton,
        render = _ref.render,
        reference = _ref.reference,
        _ref$disabled = _ref.disabled,
        disabled = _ref$disabled === void 0 ? false : _ref$disabled,
        _ref$ignoreAttributes = _ref.ignoreAttributes,
        ignoreAttributes = _ref$ignoreAttributes === void 0 ? true : _ref$ignoreAttributes;
        _ref.__source;
        _ref.__self;
        var restOfNativeProps = _objectWithoutPropertiesLoose$1(_ref, ["children", "content", "visible", "singleton", "render", "reference", "disabled", "ignoreAttributes", "__source", "__self"]);

    var isControlledMode = visible !== undefined;
    var isSingletonMode = singleton !== undefined;

    var _useState = React.useState(false),
        mounted = _useState[0],
        setMounted = _useState[1];

    var _useState2 = React.useState({}),
        attrs = _useState2[0],
        setAttrs = _useState2[1];

    var _useState3 = React.useState(),
        singletonContent = _useState3[0],
        setSingletonContent = _useState3[1];

    var mutableBox = useMutableBox(function () {
      return {
        container: ssrSafeCreateDiv(),
        renders: 1
      };
    });
    var props = Object.assign({
      ignoreAttributes: ignoreAttributes
    }, restOfNativeProps, {
      content: mutableBox.container
    });

    if (isControlledMode) {
      if (process.env.NODE_ENV !== 'production') {
        ['trigger', 'hideOnClick', 'showOnCreate'].forEach(function (nativeStateProp) {
          if (props[nativeStateProp] !== undefined) {
            console.warn(["@tippyjs/react: Cannot specify `" + nativeStateProp + "` prop in", "controlled mode (`visible` prop)"].join(' '));
          }
        });
      }

      props.trigger = 'manual';
      props.hideOnClick = false;
    }

    if (isSingletonMode) {
      disabled = true;
    }

    var computedProps = props;
    var plugins = props.plugins || [];

    if (render) {
      computedProps = Object.assign({}, props, {
        plugins: isSingletonMode && singleton.data != null ? [].concat(plugins, [{
          fn: function fn() {
            return {
              onTrigger: function onTrigger(instance, event) {
                var node = singleton.data.children.find(function (_ref2) {
                  var instance = _ref2.instance;
                  return instance.reference === event.currentTarget;
                });
                instance.state.$$activeSingletonInstance = node.instance;
                setSingletonContent(node.content);
              }
            };
          }
        }]) : plugins,
        render: function render() {
          return {
            popper: mutableBox.container
          };
        }
      });
    }

    var deps = [reference].concat(children ? [children.type] : []); // CREATE

    useIsomorphicLayoutEffect$1(function () {
      var element = reference;

      if (reference && reference.hasOwnProperty('current')) {
        element = reference.current;
      }

      var instance = tippy(element || mutableBox.ref || ssrSafeCreateDiv(), Object.assign({}, computedProps, {
        plugins: [classNamePlugin].concat(props.plugins || [])
      }));
      mutableBox.instance = instance;

      if (disabled) {
        instance.disable();
      }

      if (visible) {
        instance.show();
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }

      setMounted(true);
      return function () {
        instance.destroy();
        singleton == null ? void 0 : singleton.cleanup(instance);
      };
    }, deps); // UPDATE

    useIsomorphicLayoutEffect$1(function () {
      var _instance$popperInsta;

      // Prevent this effect from running on 1st render
      if (mutableBox.renders === 1) {
        mutableBox.renders++;
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps(deepPreserveProps(instance.props, computedProps)); // Fixes #264

      (_instance$popperInsta = instance.popperInstance) == null ? void 0 : _instance$popperInsta.forceUpdate();

      if (disabled) {
        instance.disable();
      } else {
        instance.enable();
      }

      if (isControlledMode) {
        if (visible) {
          instance.show();
        } else {
          instance.hide();
        }
      }

      if (isSingletonMode) {
        singleton.hook({
          instance: instance,
          content: content,
          props: computedProps,
          setSingletonContent: setSingletonContent
        });
      }
    });
    useIsomorphicLayoutEffect$1(function () {
      var _instance$props$poppe;

      if (!render) {
        return;
      }

      var instance = mutableBox.instance;
      instance.setProps({
        popperOptions: Object.assign({}, instance.props.popperOptions, {
          modifiers: [].concat((((_instance$props$poppe = instance.props.popperOptions) == null ? void 0 : _instance$props$poppe.modifiers) || []).filter(function (_ref3) {
            var name = _ref3.name;
            return name !== '$$tippyReact';
          }), [{
            name: '$$tippyReact',
            enabled: true,
            phase: 'beforeWrite',
            requires: ['computeStyles'],
            fn: function fn(_ref4) {
              var _state$modifiersData;

              var state = _ref4.state;
              var hideData = (_state$modifiersData = state.modifiersData) == null ? void 0 : _state$modifiersData.hide; // WARNING: this is a high-risk path that can cause an infinite
              // loop. This expression _must_ evaluate to false when required

              if (attrs.placement !== state.placement || attrs.referenceHidden !== (hideData == null ? void 0 : hideData.isReferenceHidden) || attrs.escaped !== (hideData == null ? void 0 : hideData.hasPopperEscaped)) {
                setAttrs({
                  placement: state.placement,
                  referenceHidden: hideData == null ? void 0 : hideData.isReferenceHidden,
                  escaped: hideData == null ? void 0 : hideData.hasPopperEscaped
                });
              }

              state.attributes.popper = {};
            }
          }])
        })
      });
    }, [attrs.placement, attrs.referenceHidden, attrs.escaped].concat(deps));
    return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, children ? /*#__PURE__*/React.cloneElement(children, {
      ref: function ref(node) {
        mutableBox.ref = node;
        preserveRef(children.ref, node);
      }
    }) : null, mounted && /*#__PURE__*/n$1.createPortal(render ? render(toDataAttributes(attrs), singletonContent, mutableBox.instance) : content, mutableBox.container));
  }

  return Tippy;
}

var forwardRef = (function (Tippy, defaultProps) {
  return /*#__PURE__*/React.forwardRef(function TippyWrapper(_ref, _ref2) {
    var children = _ref.children,
        props = _objectWithoutPropertiesLoose$1(_ref, ["children"]);

    return (
      /*#__PURE__*/
      // If I spread them separately here, Babel adds the _extends ponyfill for
      // some reason
      React__default["default"].createElement(Tippy, Object.assign({}, defaultProps, props), children ? /*#__PURE__*/React.cloneElement(children, {
        ref: function ref(node) {
          preserveRef(_ref2, node);
          preserveRef(children.ref, node);
        }
      }) : null)
    );
  });
});
var index$1 = /*#__PURE__*/forwardRef( /*#__PURE__*/TippyGenerator(tippy));

var css$E = "@import \"https://unpkg.com/tippy.js/animations/scale.css\";\n@import \"https://unpkg.com/tippy.js/dist/tippy.css\";\n\n.Tooltip_module_mdsTooltip__dfdc321b[data-theme=mdsTooltip] {\n  cursor: pointer;\n  pointer-events: all;\n  border: none;\n  color: #444f6b;\n  background-color: #fff;\n  box-shadow: 1px 8px 16px rgba(25, 25, 25, 0.2);\n  border-radius: 0.875rem;\n  text-align: left;\n  padding: 8px;\n}\n.Tooltip_module_mdsTooltip__dfdc321b[data-theme=mdsTooltip] .tippy-arrow {\n  color: white;\n}";
injectCss(css$E);
var modules_16974fb0 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsTooltip":"Tooltip_module_mdsTooltip__dfdc321b"};

var Tooltip = function Tooltip(props) {
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(index$1, {
    className: modules_16974fb0.mdsTooltip,
    placement: "bottom",
    theme: "mdsTooltip",
    animation: "scale",
    options: props.options,
    content: props.content,
    interactive: props.interactive || false,
    maxWidth: "none",
    trigger: props.focusIn ? "mouseenter focusin" : "mouseenter" + props.clickTrigger ? "mouseenter click" : "",
    showOnCreate: props.showOnCreate
  }, props.children));
};
Tooltip.propTypes = {
  extraClass: propTypes.exports.string,
  content: propTypes.exports.node,
  options: propTypes.exports.object,
  interactive: propTypes.exports.bool,
  focusIn: propTypes.exports.bool,
  showOnCreate: propTypes.exports.bool,
  clickTrigger: propTypes.exports.bool
};

var css$D = ".SkipToMainContent_module_skip__5f0b7d21 {\n  position: absolute;\n  left: -10000px;\n  top: auto;\n  width: 1px;\n  height: 1px;\n  overflow: hidden;\n  transition-property: all;\n}\n.SkipToMainContent_module_skip__5f0b7d21:focus {\n  position: fixed;\n  width: auto;\n  height: auto;\n  left: 210px;\n  top: 12px;\n  z-index: 9999;\n  transition-property: all;\n}";
injectCss(css$D);
var modules_4244a4e1 = {"skip":"SkipToMainContent_module_skip__5f0b7d21"};

function SkipToMainContent(_ref) {
  var label = _ref.label,
    sectionTarget = _ref.sectionTarget,
    action = _ref.action;
  var scrollToElementOnClick = function scrollToElementOnClick() {
    var target = document.getElementById(sectionTarget);
    target.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: modules_4244a4e1.skip,
    label: label,
    action: action ? action : scrollToElementOnClick
  }));
}
SkipToMainContent.propTypes = {
  label: propTypes.exports.string.isRequired,
  sectionTarget: propTypes.exports.string,
  action: propTypes.exports.func
};

var css$C = ".Breadcrumbs_module_Breadcrumbs__ee2a01b1 {\n  width: 100%;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol {\n  width: 100%;\n  display: block;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  white-space: nowrap;\n  overflow-x: auto;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n@media only screen and (min-width: 768px) {\n  .Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol {\n    text-align: left;\n  }\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol::-webkit-scrollbar {\n  display: none;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 {\n  display: inline-flex;\n  vertical-align: middle;\n  align-items: center;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1::before {\n  content: \"/\";\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1:first-child:before {\n  content: \"\";\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1:last-child {\n  font-weight: 700;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1 {\n  height: auto;\n  display: inline-block;\n  position: relative;\n  padding: 8px 14px;\n  border-radius: 48px;\n  border: 2px;\n  background-color: transparent;\n  outline: none;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 100%;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1 > span {\n  height: 34px;\n  position: relative;\n  z-index: 1;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n  color: #444F6B;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  line-height: 16px;\n  text-align: center;\n  border: 0;\n  border-radius: 48px;\n  cursor: pointer;\n  box-shadow: none;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1 > span svg {\n  margin-right: 12px;\n  fill: #444F6B;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1 .Breadcrumbs_module_Label__ee2a01b1 {\n  max-width: 175px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1:hover {\n  text-decoration: underline;\n  color: #444F6B;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1 .Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1:focus-visible {\n  box-shadow: inset 0 0 0px 3px #0985BE;\n  color: #444F6B;\n}\n.Breadcrumbs_module_Breadcrumbs__ee2a01b1 ol li.Breadcrumbs_module_BreadcrumbItem__ee2a01b1.Breadcrumbs_module_BreadcrumbItemUppercase__ee2a01b1 {\n  text-transform: uppercase;\n}";
injectCss(css$C);
var modules_a04642f2 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Breadcrumbs":"Breadcrumbs_module_Breadcrumbs__ee2a01b1","BreadcrumbItem":"Breadcrumbs_module_BreadcrumbItem__ee2a01b1","BreadcrumbItemLink":"Breadcrumbs_module_BreadcrumbItemLink__ee2a01b1","Label":"Breadcrumbs_module_Label__ee2a01b1","BreadcrumbItemUppercase":"Breadcrumbs_module_BreadcrumbItemUppercase__ee2a01b1"};

function Breadcrumbs(_ref) {
  _ref.ariaLabel;
    var breadcrumbsItems = _ref.breadcrumbsItems,
    extraClass = _ref.extraClass,
    backgroundColor = _ref.backgroundColor;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    "aria-label": "Breadcrumb",
    className: [modules_a04642f2.Breadcrumbs, extraClass].join(" "),
    style: {
      backgroundColor: backgroundColor
    }
  }, /*#__PURE__*/React__default["default"].createElement("ol", {
    className: modules_a04642f2.BreadcrumbContent
  }, breadcrumbsItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: [modules_a04642f2.BreadcrumbItem, item.uppercase ? modules_a04642f2.BreadcrumbItemUppercase : null].join(" ")
    }, item.isButton ? /*#__PURE__*/React__default["default"].createElement("button", {
      className: modules_a04642f2.BreadcrumbItemLink,
      "aria-label": item.ariaLabel,
      "aria-current": item.isActive ? "page" : null,
      "aria-hasPopUp": item.hasPopUp ? "true" : null,
      onClick: item.onClick,
      title: item.label
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.iconDefault ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconWSize: 24,
      iconHSize: 24,
      iconName: iconDefault
    }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.Label
    }, item.label))) : /*#__PURE__*/React__default["default"].createElement("a", {
      key: index,
      href: item.href,
      className: modules_a04642f2.BreadcrumbItemLink,
      "aria-current": item.isActive ? "page" : null,
      title: item.label,
      onClick: item.onClick
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.iconDefault ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconWSize: 24,
      iconHSize: 24,
      iconName: iconDefault
    }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_a04642f2.Label,
      style: item.maxWidth ? {
        maxWidth: item.maxWidth
      } : null
    }, item.label))));
  })));
}
Breadcrumbs.propTypes = {
  breadcrumbsItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    label: propTypes.exports.string,
    href: propTypes.exports.string,
    isButton: propTypes.exports.bool,
    onClick: propTypes.exports.func,
    isActive: propTypes.exports.bool,
    maxWidth: propTypes.exports.string,
    uppercase: propTypes.exports.bool,
    //WCAG
    ariaLabel: propTypes.exports.string,
    hasPopUp: propTypes.exports.bool,
    //Icon
    iconDefault: propTypes.exports.string
  })),
  extraClass: propTypes.exports.string,
  backgroundColor: propTypes.exports.string
};

var css$B = ".BaseCard_module_CardContainer__ab2383ac {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  width: 300px;\n  overflow: hidden;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainer__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n\n.BaseCard_module_Loader__ab2383ac {\n  position: absolute;\n  right: 4px;\n  top: 0px;\n  z-index: 4;\n  width: 62px;\n  height: 62px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_Loader__ab2383ac svg {\n    stroke: #ffffff !important;\n  }\n}\n\n.BaseCard_module_HeartAction__ab2383ac {\n  position: absolute;\n  right: 14px;\n  top: 8px;\n  z-index: 4;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HeartAction__ab2383ac svg {\n    fill: #ffffff;\n  }\n}\n\n.BaseCard_module_CardLink__ab2383ac {\n  text-decoration: none;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 300px;\n  height: 524px;\n  padding-top: 34px;\n  border-radius: inherit;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardLink__ab2383ac {\n    flex-direction: column-reverse;\n    width: 300px;\n    height: 360px;\n    padding-right: 0;\n    padding-top: 0;\n  }\n}\n.BaseCard_module_CardLink__ab2383ac:hover .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n.BaseCard_module_CardLink__ab2383ac:focus {\n  outline: none;\n}\n.BaseCard_module_CardLink__ab2383ac:focus-visible {\n  box-shadow: inset 0px 0px 0px 4px #7f5f9c;\n  border-radius: 14px;\n}\n.BaseCard_module_CardLink__ab2383ac:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: inset 0px 0px 0px 4px #7f5f9c, inset 0px 0px 0px 5px #ffffff;\n  transition: all 0.2s ease-in-out;\n}\n.BaseCard_module_CardLink__ab2383ac:focus-visible .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n\n.BaseCard_module_CardContent__ab2383ac {\n  padding: 24px;\n  flex-grow: 0;\n  display: block;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContent__ab2383ac {\n    padding: 14px 24px;\n  }\n}\n.BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n  position: relative;\n  flex-grow: 3;\n  display: flex;\n  padding: 0;\n  height: 122px;\n}\n\n.BaseCard_module_CardCategory__ab2383ac {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.BaseCard_module_cardCategoryContainer__ab2383ac {\n  display: flex;\n  align-items: center;\n}\n\n.BaseCard_module_titleRating__ab2383ac {\n  display: flex;\n  align-items: center;\n}\n.BaseCard_module_titleRating__ab2383ac::before {\n  width: 1px;\n  height: 100%;\n  display: block;\n  color: #444F6B;\n  padding: 0 7px;\n  content: \"|\";\n}\n.BaseCard_module_titleRating__ab2383ac .BaseCard_module_titleRatingNumber__ab2383ac {\n  display: flex;\n  align-items: center;\n}\n.BaseCard_module_titleRating__ab2383ac .BaseCard_module_titleRatingLabel__ab2383ac {\n  text-transform: uppercase;\n  padding-left: 4px;\n}\n\n.BaseCard_module_CardIconPlacement__ab2383ac {\n  position: absolute;\n  right: 24px;\n  top: -18px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardIconPlacement__ab2383ac {\n    display: block;\n    bottom: -16px;\n    top: auto;\n  }\n}\n\n.BaseCard_module_CardBadge__ab2383ac {\n  position: absolute;\n  right: 24px;\n  top: -18px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardBadge__ab2383ac {\n    display: block;\n    bottom: -16px;\n    top: auto;\n  }\n}\n\n.BaseCard_module_CardTitle__ab2383ac {\n  display: block;\n}\n\n.BaseCard_module_CardSub__ab2383ac {\n  display: block;\n}\n\n.BaseCard_module_CardDesc__ab2383ac {\n  margin-top: 14px;\n  display: block;\n}\n\n.BaseCard_module_ContentArea__ab2383ac button {\n  margin-top: 14px;\n}\n.BaseCard_module_ContentArea__ab2383ac a {\n  margin-top: 14px;\n}\n\n.BaseCard_module_CardImgFilter__ab2383ac {\n  position: absolute;\n  top: 0px;\n  left: 0px;\n  background: linear-gradient(180deg, rgba(27, 32, 43, 0.8) 0%, rgba(27, 32, 43, 0) 100%);\n  width: 100%;\n  height: 58px;\n  border-radius: 14px 14px 0px 0px;\n  display: none;\n  z-index: 3;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardImgFilter__ab2383ac {\n    display: block;\n  }\n}\n\n.BaseCard_module_CardImg__ab2383ac {\n  width: 100%;\n  min-height: 240px;\n  object-fit: cover;\n  border-radius: 0px 0px 14px 14px;\n  background-color: #edeef2;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardImg__ab2383ac {\n    border-radius: 14px 14px 0 0;\n    width: 300px;\n    height: auto;\n    min-height: 0;\n  }\n}\n\n.BaseCard_module_VideoPlay__ab2383ac {\n  display: none;\n  width: 44px;\n  height: 44px;\n  opacity: 0.7;\n  filter: drop-shadow(0px 6px 3px rgba(25, 25, 25, 0.2));\n  z-index: 4;\n  position: absolute;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.BaseCard_module_Pill__ab2383ac {\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n  padding: 2px 14px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  display: flex;\n  flex-direction: row;\n  color: #191919;\n  position: absolute;\n  top: 14px;\n  left: 14px;\n  z-index: 4;\n}\n.BaseCard_module_Pill__ab2383ac svg {\n  margin-right: 4px;\n}\n\n.BaseCard_module_CardContainerReverse__ab2383ac {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  text-decoration: none;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  width: 300px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerReverse__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n  padding-top: 0;\n  height: 524px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n    flex-direction: column-reverse;\n    width: 300px;\n    height: 360px;\n    padding-right: 0;\n  }\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n  min-height: 72px;\n  order: -1;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n    height: 92px;\n    order: inherit;\n  }\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardImgFilter__ab2383ac {\n  display: block;\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n  width: 300px;\n  min-height: 72px;\n  border-radius: 14px 14px 0px 0px;\n  object-fit: cover;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n    min-height: auto;\n    width: 100%;\n    max-height: 236px;\n    height: 100%;\n  }\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardIconPlacement__ab2383ac {\n  bottom: -18px;\n  top: auto;\n}\n.BaseCard_module_CardContainerReverse__ab2383ac .BaseCard_module_CardBadge__ab2383ac {\n  bottom: -18px;\n  top: auto;\n}\n\n.BaseCard_module_CardContainerSquare__ab2383ac {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  text-decoration: none;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  width: 300px;\n  height: 250px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerSquare__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n  height: 250px;\n  padding-top: 0;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n    flex-direction: column-reverse;\n    width: 300px;\n    height: 360px;\n    padding-right: 0;\n  }\n}\n.BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n  min-height: 72px;\n  order: -1;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n    min-height: auto;\n    order: inherit;\n  }\n}\n.BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardImgFilter__ab2383ac {\n  display: block;\n}\n.BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n  width: 300px;\n  min-height: 72px;\n  border-radius: 14px 14px 0px 0px;\n  object-fit: cover;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n    min-height: auto;\n    width: 100%;\n    max-height: none;\n    height: 100%;\n  }\n}\n.BaseCard_module_CardContainerSquare__ab2383ac .BaseCard_module_CardIconPlacement__ab2383ac {\n  bottom: -18px;\n  top: auto;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  text-decoration: none;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  width: 300px;\n  height: 250px;\n  cursor: pointer;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerImageFill__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n  height: 250px;\n  padding: 0;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardLink__ab2383ac:focus {\n  outline: none;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardLink__ab2383ac:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  z-index: 2;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, inset 0px 0px 0px 5px #ffffff;\n  transition: all 0.2s ease-in-out;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardLink__ab2383ac:focus-visible .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardContent__ab2383ac {\n  position: absolute;\n  color: #ffffff;\n  bottom: 0;\n  text-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n  z-index: 3;\n  padding-left: 64px;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n  padding-left: 0;\n  z-index: 2;\n  height: 100%;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardImgFilter__ab2383ac {\n  background: radial-gradient(circle at center, rgba(27, 32, 43, 0.6) 0%, rgba(27, 32, 43, 0.7) 100%);\n  width: 100%;\n  height: 100%;\n  border-radius: 14px;\n  display: block;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n  border-radius: 14px;\n  object-fit: none;\n  height: 100%;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardTitle__ab2383ac {\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 24px;\n  font-weight: 700;\n  color: #ffffff;\n  text-transform: uppercase;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_CardIconPlacement__ab2383ac {\n  left: 14px;\n  bottom: 28px;\n  top: auto;\n  z-index: 4;\n}\n.BaseCard_module_CardContainerImageFill__ab2383ac .BaseCard_module_VideoPlay__ab2383ac {\n  display: block;\n}\n\n.BaseCard_module_HorizontalCardContainer__ab2383ac {\n  position: relative;\n  border-radius: 14px;\n  background-color: #ffffff;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  width: 700px;\n  height: 260px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HorizontalCardContainer__ab2383ac {\n    width: 300px;\n    height: 360px;\n  }\n}\n.BaseCard_module_HorizontalCardContainer__ab2383ac .BaseCard_module_CardContent__ab2383ac {\n  width: 100%;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HorizontalCardContainer__ab2383ac .BaseCard_module_CardContent__ab2383ac {\n    width: 100%;\n  }\n}\n.BaseCard_module_HorizontalCardContainer__ab2383ac:focus-visible {\n  box-shadow: inset 0px 0px 0px 4px #7f5f9c;\n  border-radius: 14px;\n}\n.BaseCard_module_HorizontalCardContainer__ab2383ac:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: inset 0px 0px 0px 4px #7f5f9c, inset 0px 0px 0px 5px #ffffff;\n  transition: all 0.2s ease-in-out;\n}\n.BaseCard_module_HorizontalCardContainer__ab2383ac:focus-visible .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac {\n  text-decoration: none;\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n  height: 260px;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HorizontalCardLeftImage__ab2383ac {\n    flex-direction: column-reverse;\n    width: 300px;\n    height: 360px;\n    padding-right: 0;\n    padding-top: 0;\n  }\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac:hover .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac:focus {\n  outline: none;\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac:focus-visible {\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c;\n  border-radius: 14px;\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: inherit;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, inset 0px 0px 0px 5px #ffffff;\n  transition: all 0.2s ease-in-out;\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac:focus-visible .BaseCard_module_CardTitle__ab2383ac {\n  text-decoration: underline;\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n  border-radius: 14px 0 0 14px;\n  position: absolute;\n  height: 100%;\n  z-index: 1;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HorizontalCardLeftImage__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n    border-radius: 14px 14px 0 0;\n  }\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac .BaseCard_module_CardIconPlacement__ab2383ac {\n  display: none;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_HorizontalCardLeftImage__ab2383ac .BaseCard_module_CardIconPlacement__ab2383ac {\n    display: block;\n    bottom: -16px;\n    top: auto;\n    z-index: 2;\n  }\n}\n.BaseCard_module_HorizontalCardLeftImage__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n  height: auto;\n}\n\n.BaseCard_module_AutoWidth__ab2383ac {\n  width: 100%;\n}\n.BaseCard_module_AutoWidth__ab2383ac .BaseCard_module_CardLink__ab2383ac {\n  width: 100%;\n}\n.BaseCard_module_AutoWidth__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n  width: 100%;\n}\n@media (max-width: 700px) {\n  .BaseCard_module_AutoWidth__ab2383ac .BaseCard_module_CardImg__ab2383ac {\n    max-height: none;\n  }\n}\n@media (max-width: 700px) {\n  .BaseCard_module_AutoWidth__ab2383ac .BaseCard_module_CardContent__ab2383ac.BaseCard_module_NoPadding__ab2383ac {\n    width: 100%;\n  }\n}";
injectCss(css$B);
var modules_086023fc = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","CardContainer":"BaseCard_module_CardContainer__ab2383ac","Loader":"BaseCard_module_Loader__ab2383ac","HeartAction":"BaseCard_module_HeartAction__ab2383ac","CardLink":"BaseCard_module_CardLink__ab2383ac","CardTitle":"BaseCard_module_CardTitle__ab2383ac","CardContent":"BaseCard_module_CardContent__ab2383ac","NoPadding":"BaseCard_module_NoPadding__ab2383ac","CardCategory":"BaseCard_module_CardCategory__ab2383ac","cardCategoryContainer":"BaseCard_module_cardCategoryContainer__ab2383ac","titleRating":"BaseCard_module_titleRating__ab2383ac","titleRatingNumber":"BaseCard_module_titleRatingNumber__ab2383ac","titleRatingLabel":"BaseCard_module_titleRatingLabel__ab2383ac","CardIconPlacement":"BaseCard_module_CardIconPlacement__ab2383ac","CardBadge":"BaseCard_module_CardBadge__ab2383ac","CardSub":"BaseCard_module_CardSub__ab2383ac","CardDesc":"BaseCard_module_CardDesc__ab2383ac","ContentArea":"BaseCard_module_ContentArea__ab2383ac","CardImgFilter":"BaseCard_module_CardImgFilter__ab2383ac","CardImg":"BaseCard_module_CardImg__ab2383ac","VideoPlay":"BaseCard_module_VideoPlay__ab2383ac","Pill":"BaseCard_module_Pill__ab2383ac","CardContainerReverse":"BaseCard_module_CardContainerReverse__ab2383ac","CardContainerSquare":"BaseCard_module_CardContainerSquare__ab2383ac","CardContainerImageFill":"BaseCard_module_CardContainerImageFill__ab2383ac","HorizontalCardContainer":"BaseCard_module_HorizontalCardContainer__ab2383ac","HorizontalCardLeftImage":"BaseCard_module_HorizontalCardLeftImage__ab2383ac","AutoWidth":"BaseCard_module_AutoWidth__ab2383ac"};

function Card(_ref) {
  var loading = _ref.loading,
    cardType = _ref.cardType,
    cardStyleSquare = _ref.cardStyleSquare,
    cardStyleImageFill = _ref.cardStyleImageFill,
    horizontalCardLeftImage = _ref.horizontalCardLeftImage,
    reverseCardImage = _ref.reverseCardImage,
    video = _ref.video,
    categoryTitle = _ref.categoryTitle,
    cardBadge = _ref.cardBadge,
    cardBadgeNumber = _ref.cardBadgeNumber,
    categoryIcon = _ref.categoryIcon,
    categoryColor = _ref.categoryColor,
    iconName = _ref.iconName,
    iconBGcolor = _ref.iconBGcolor,
    detailURL = _ref.detailURL,
    imgURL = _ref.imgURL,
    defaultImg = _ref.defaultImg,
    pill = _ref.pill,
    pillIcon = _ref.pillIcon,
    pillTitle = _ref.pillTitle,
    price = _ref.price,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    diamondAward = _ref.diamondAward,
    inspectedClean = _ref.inspectedClean,
    contentArea = _ref.contentArea,
    actionIcon = _ref.actionIcon,
    actionIconColor = _ref.actionIconColor,
    actionIconDefault = _ref.actionIconDefault,
    actionIconActive = _ref.actionIconActive,
    actionIconOnClick = _ref.actionIconOnClick,
    actionIconIsActive = _ref.actionIconIsActive,
    actionIconSpinner = _ref.actionIconSpinner,
    actionIconActiveColor = _ref.actionIconActiveColor,
    ariaLabel = _ref.ariaLabel,
    actionIconLabel = _ref.actionIconLabel,
    actionIconLight = _ref.actionIconLight,
    cardAction = _ref.cardAction,
    placeholderSrc = _ref.placeholderSrc,
    scrollAmount = _ref.scrollAmount,
    useIntersectionObserver = _ref.useIntersectionObserver,
    extraClass = _ref.extraClass,
    truncate = _ref.truncate,
    autoWidth = _ref.autoWidth,
    ratingNumber = _ref.ratingNumber,
    ratingLabel = _ref.ratingLabel;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgHasError = _useState2[0],
    setImgHasError = _useState2[1];
  if (loading) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "card-" + cardType.toLowerCase().replace(/ /g, "") + " cardLoading cardContainer cardContainer-" + cardStyle.toLowerCase()
    }, loading ? /*#__PURE__*/React__default["default"].createElement("div", null, "Loading") : null);
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [cardStyleSquare ? modules_086023fc.CardContainerSquare : cardStyleImageFill ? modules_086023fc.CardContainerImageFill : reverseCardImage ? modules_086023fc.CardContainerReverse : horizontalCardLeftImage ? modules_086023fc.HorizontalCardContainer : modules_086023fc.CardContainer, autoWidth ? modules_086023fc.AutoWidth : "", extraClass ? extraClass : null].join(" ")
  }, loading ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "circle-loader"
  }, "LOADING") : null, actionIconSpinner ? /*#__PURE__*/React__default["default"].createElement(Loader$1, {
    extraClass: modules_086023fc.Loader,
    darkMode: reverseCardImage ? true : false
  }) : actionIcon ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_086023fc.HeartAction
  }, /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    light: actionIconLight,
    ariaLabel: ariaLabel,
    label: actionIconLabel,
    iconDefault: actionIconDefault,
    iconActive: actionIconActive,
    activeColor: actionIconActiveColor || "#b30c1c",
    color: actionIconColor,
    onClick: actionIconOnClick,
    isActive: actionIconIsActive
  })) : null, price ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.Pill
  }, price) : null, pill ? /*#__PURE__*/React__default["default"].createElement(Pill, {
    pillIcon: pillIcon,
    pillTitle: pillTitle
  }) : null, /*#__PURE__*/React__default["default"].createElement("a", {
    className: horizontalCardLeftImage ? modules_086023fc.HorizontalCardLeftImage : modules_086023fc.CardLink,
    href: detailURL,
    onClick: cardAction
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.CardContent
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.cardCategoryContainer
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "XS",
    color: categoryColor,
    extraClass: modules_086023fc.CardCategorie,
    uppercase: true
  }, categoryTitle), ratingNumber ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.titleRating
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "S",
    extraClass: modules_086023fc.titleRatingNumber
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: "star--solid",
    iconWSize: 16,
    iconHSize: 16,
    iconColor: "#444f6b",
    iconShadow: false
  }), ratingNumber), ratingLabel ? /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "XS",
    extraClass: modules_086023fc.titleRatingLabel
  }, ratingLabel) : null) : null), /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "M",
    serif: true,
    extraClass: modules_086023fc.CardTitle
  }, truncate && title.length >= 50 ? "".concat(title.substring(0, 50), "...") : title), subtitle ? /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "XS",
    extraClass: modules_086023fc.CardSub
  }, truncate && subtitle.length >= 40 ? "".concat(title.substring(0, 40), "...") : subtitle) : null, description ? /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S",
    extraClass: modules_086023fc.CardDesc
  }, truncate && description.length >= 100 ? "".concat(description.substring(0, 100), "...") : description) : null, diamondAward ? /*#__PURE__*/React__default["default"].createElement(DiamondRating, {
    diamondIcon: diamondAward,
    diamondWidth: 95,
    diamondHeight: 40,
    inspectedClean: inspectedClean
  }) : null, contentArea ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.ContentArea
  }, contentArea) : null), /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_086023fc.CardContent, modules_086023fc.NoPadding].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.CardImgFilter
  }), video ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_086023fc.VideoPlay
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: "ui-circle-solid--play",
    iconWSize: 44,
    iconHSize: 44,
    iconColor: "#ffffff",
    iconShadow: true
  })) : null, categoryIcon ? /*#__PURE__*/React__default["default"].createElement(CircleIcon, {
    extraClass: modules_086023fc.CardIconPlacement,
    bgColor: iconBGcolor,
    iconName: iconName,
    iconColor: "#ffffff"
  }) : null, !categoryIcon && cardBadge ? /*#__PURE__*/React__default["default"].createElement(Badge, {
    extraClass: modules_086023fc.CardBadge,
    iconName: "heart--solid",
    iconColor: "#ce0c1c",
    iconShadow: true,
    badgeCount: cardBadgeNumber,
    badgeCountColor: "#ffffff",
    icon: true
  }) : null, (!!imgURL || !!defaultImg) && !imgHasError && /*#__PURE__*/React__default["default"].createElement(Image, {
    extraClass: modules_086023fc.CardImg,
    alt: title,
    src: imgURL,
    loaderSrc: placeholderSrc,
    defaultImg: defaultImg,
    scrollAmount: scrollAmount,
    useIntersectionObserver: useIntersectionObserver,
    onError: function onError() {
      return setImgHasError(true);
    }
  })))));
}
Card.propTypes = {
  loading: propTypes.exports.bool,
  cardType: propTypes.exports.string,
  cardStyleSquare: propTypes.exports.bool,
  cardStyleImageFill: propTypes.exports.bool,
  horizontalCardLeftImage: propTypes.exports.bool,
  reverseCardImage: propTypes.exports.bool,
  video: propTypes.exports.bool,
  detailURL: propTypes.exports.string,
  imgURL: propTypes.exports.string,
  defaultImg: propTypes.exports.string,
  placeholderSrc: propTypes.exports.string,
  scrollAmount: propTypes.exports.number,
  useIntersectionObserver: propTypes.exports.bool,
  categoryTitle: propTypes.exports.string,
  pill: propTypes.exports.bool,
  pillIcon: propTypes.exports.string,
  pillTitle: propTypes.exports.string,
  price: propTypes.exports.string,
  title: propTypes.exports.string,
  subtitle: propTypes.exports.string,
  description: propTypes.exports.string,
  diamondAward: propTypes.exports.string,
  inspectedClean: propTypes.exports.bool,
  contentArea: propTypes.exports.node,
  actionIcon: propTypes.exports.bool,
  actionIconColor: propTypes.exports.string,
  actionIconDefault: propTypes.exports.string,
  actionIconActive: propTypes.exports.string,
  actionIconOnClick: propTypes.exports.func,
  actionIconIsActive: propTypes.exports.bool,
  actionIconActiveColor: propTypes.exports.string,
  actionIconLabel: propTypes.exports.string,
  actionIconSpinner: propTypes.exports.bool,
  heartLight: propTypes.exports.bool,
  heartDark: propTypes.exports.bool,
  cardBadge: propTypes.exports.bool,
  cardBadgeNumber: propTypes.exports.string,
  categoryIcon: propTypes.exports.bool,
  categoryColor: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconBGcolor: propTypes.exports.string,
  cruiseLogoURL: propTypes.exports.string,
  cardAction: propTypes.exports.func,
  contactAgentAction: propTypes.exports.func,
  cardButtonAction: propTypes.exports.func,
  ariaLabel: propTypes.exports.string,
  extraClass: propTypes.exports.string,
  truncate: propTypes.exports.bool,
  autoWidth: propTypes.exports.bool,
  ratingNumber: propTypes.exports.string,
  ratingLabel: propTypes.exports.node
};

var css$A = ".HeaderCard_module_HeaderCardContainer__5ab4f15c {\n  padding: 0;\n}\n@media (max-width: 700px) {\n  .HeaderCard_module_HeaderCardContainer__5ab4f15c {\n    max-height: none;\n  }\n}\n\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c {\n  padding: 0;\n  max-height: 250px;\n  background-color: #292f40;\n}\n@media (max-width: 700px) {\n  .HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c {\n    max-height: none;\n  }\n}\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c .HeaderCard_module_CardImg__5ab4f15c {\n  width: 100%;\n  max-height: 250px;\n  opacity: 0.5;\n}\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c .HeaderCard_module_HeaderCard__5ab4f15c {\n  display: block;\n}\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c .HeaderCard_module_CardContentImgFill__5ab4f15c {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  z-index: 2;\n  width: 100%;\n  text-align: center;\n}\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c .HeaderCard_module_CardContentImgFill__5ab4f15c * {\n  color: #ffffff;\n  text-shadow: 0px 1px 4px rgba(0, 0, 0, 0.2);\n  font-size: 32px;\n}\n.HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c .HeaderCard_module_NoPadding__5ab4f15c {\n  display: block;\n  z-index: 1;\n}\n\n.HeaderCard_module_HeaderCard__5ab4f15c {\n  text-decoration: none;\n  position: relative;\n  display: flex;\n  flex-direction: row-reverse;\n  height: auto;\n}\n@media (max-width: 700px) {\n  .HeaderCard_module_HeaderCard__5ab4f15c {\n    flex-direction: column-reverse;\n  }\n}\n\n.HeaderCard_module_CardContent__5ab4f15c {\n  padding: 36px;\n  flex-grow: 0;\n  display: block;\n}\n@media (max-width: 700px) {\n  .HeaderCard_module_CardContent__5ab4f15c {\n    padding: 14px 24px;\n  }\n}\n.HeaderCard_module_CardContent__5ab4f15c.HeaderCard_module_NoPadding__5ab4f15c {\n  position: relative;\n  display: flex;\n  padding: 0;\n}\n\n.HeaderCard_module_HeaderCardSubtitle__5ab4f15c {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.HeaderCard_module_CardImg__5ab4f15c {\n  width: 100%;\n  object-fit: cover;\n  border-radius: 14px 0 0 14px;\n  background-color: #edeef2;\n}\n@media (max-width: 700px) {\n  .HeaderCard_module_CardImg__5ab4f15c {\n    border-radius: 14px 14px 0 0;\n    max-height: 200px;\n  }\n}";
injectCss(css$A);
var modules_f1d63447 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","HeaderCardContainer":"HeaderCard_module_HeaderCardContainer__5ab4f15c","HeaderCardContainerImgFill":"HeaderCard_module_HeaderCardContainerImgFill__5ab4f15c","CardImg":"HeaderCard_module_CardImg__5ab4f15c","HeaderCard":"HeaderCard_module_HeaderCard__5ab4f15c","CardContentImgFill":"HeaderCard_module_CardContentImgFill__5ab4f15c","NoPadding":"HeaderCard_module_NoPadding__5ab4f15c","CardContent":"HeaderCard_module_CardContent__5ab4f15c","HeaderCardSubtitle":"HeaderCard_module_HeaderCardSubtitle__5ab4f15c"};

function HeaderCard(_ref) {
  var imgURL = _ref.imgURL,
    defaultImg = _ref.defaultImg,
    imgFill = _ref.imgFill,
    title = _ref.title,
    subtitle = _ref.subtitle,
    description = _ref.description,
    placeholderSrc = _ref.placeholderSrc,
    scrollAmount = _ref.scrollAmount,
    useIntersectionObserver = _ref.useIntersectionObserver,
    href = _ref.href,
    onClick = _ref.onClick;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgHasError = _useState2[0],
    setImgHasError = _useState2[1];
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Section, {
    extraClass: imgFill ? modules_f1d63447.HeaderCardContainerImgFill : modules_f1d63447.HeaderCardContainer,
    style: "Shadow",
    width: "1366"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_f1d63447.HeaderCard
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [imgFill ? modules_f1d63447.CardContentImgFill : modules_f1d63447.CardContent].join(' ')
  }, subtitle ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    bold: true,
    size: "XS",
    extraClass: modules_f1d63447.HeaderCardSubtitle
  }, subtitle) : null, /*#__PURE__*/React__default["default"].createElement(Header4, {
    bold: true,
    fontSize: 'L',
    serif: true,
    extraClass: modules_f1d63447.CardTitle
  }, title.length >= 50 ? "".concat(title.substring(0, 50), "...") : title), description ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    fontSize: 'BASE',
    extraClass: modules_f1d63447.CardDesc
  }, description.length >= 180 ? "".concat(description.substring(0, 180), "...") : description) : null, href ? /*#__PURE__*/React__default["default"].createElement(Link, {
    iconName: "ui-circle--plus",
    label: "Create Trip",
    href: href,
    onClick: onClick
  }) : null), /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_f1d63447.CardContent, modules_f1d63447.NoPadding].join(" ")
  }, (!!imgURL || !!defaultImg) && !imgHasError && /*#__PURE__*/React__default["default"].createElement(Image, {
    extraClass: modules_f1d63447.CardImg,
    alt: title,
    src: imgURL,
    loaderSrc: placeholderSrc,
    defaultImg: defaultImg,
    scrollAmount: scrollAmount,
    useIntersectionObserver: useIntersectionObserver,
    onError: function onError() {
      return setImgHasError(true);
    }
  })))));
}
HeaderCard.propTypes = {
  imgURL: propTypes.exports.string,
  defaultImg: propTypes.exports.string,
  imgFill: propTypes.exports.bool,
  placeholderSrc: propTypes.exports.string,
  title: propTypes.exports.string,
  subtitle: propTypes.exports.string,
  description: propTypes.exports.string,
  scrollAmount: propTypes.exports.number,
  useIntersectionObserver: propTypes.exports.bool,
  href: propTypes.exports.string,
  onClick: propTypes.exports.func
};

var css$z = ".BaseListing_module_ListingContainer__c41908d4 {\n  position: relative;\n  box-shadow: none;\n  border-bottom: 1px solid #dcdee3;\n  border-radius: 0;\n  width: 100%;\n  padding: 12px;\n  max-width: 680px;\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n}\n.BaseListing_module_ListingContainer__c41908d4.BaseListing_module_NoBorderBottom__c41908d4 {\n  border-bottom: none;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingContainer__c41908d4 {\n    padding: 12px;\n    padding-bottom: 0;\n  }\n}\n\n.BaseListing_module_Listing__c41908d4 {\n  text-decoration: none;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px;\n  padding-right: 0;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  transition: all 0.2s ease-in-out;\n}\n.BaseListing_module_Listing__c41908d4.BaseListing_module_StackLayout__c41908d4 {\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  text-align: center;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_Listing__c41908d4 {\n    -webkit-box-orient: vertical;\n    -webkit-box-direction: normal;\n    -webkit-flex-direction: column;\n    -ms-flex-direction: column;\n    flex-direction: column;\n    padding: 12px;\n  }\n}\n.BaseListing_module_Listing__c41908d4:hover h4 {\n  text-decoration: underline;\n}\n.BaseListing_module_Listing__c41908d4 .BaseListing_module_ListingImg__c41908d4 {\n  border-radius: 14px;\n}\n.BaseListing_module_Listing__c41908d4:focus-visible {\n  outline: none;\n}\n.BaseListing_module_Listing__c41908d4:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: 14px;\n  outline: none;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, 1px 8px 16px rgba(25, 25, 25, 0.2);\n  transition: all 0.2s ease-in-out;\n}\n.BaseListing_module_Listing__c41908d4:focus-visible .BaseListing_module_ListingTitle__c41908d4 {\n  text-decoration: underline;\n}\n.BaseListing_module_Listing__c41908d4:focus {\n  outline: none;\n}\n\n.BaseListing_module_HeartAction__c41908d4 {\n  position: absolute;\n  right: 14px;\n  overflow: hidden;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_HeartAction__c41908d4 {\n    top: 200px;\n    transform: none;\n  }\n}\n\n.BaseListing_module_ListingLink__c41908d4 {\n  text-decoration: none;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  width: 300px;\n  height: 524px;\n  padding-top: 34px;\n}\n.BaseListing_module_ListingLink__c41908d4:hover h4 {\n  text-decoration: underline;\n}\n\n.BaseListing_module_ListingImgContainer__c41908d4 {\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  display: block;\n  margin-right: 24px;\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  height: 90px;\n  background-color: #ffffff;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingImgContainer__c41908d4 {\n    margin-bottom: 24px;\n    margin-right: 0;\n    width: 100%;\n    height: 154px;\n  }\n}\n\n.BaseListing_module_ListingImgAutoSize__c41908d4 {\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  display: block;\n  margin-right: 0;\n  border-radius: 0;\n  box-shadow: none;\n  height: auto;\n  background-color: #ffffff;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingImgAutoSize__c41908d4 {\n    margin-bottom: 24px;\n    margin-right: 0;\n    width: 100%;\n    height: auto;\n  }\n}\n\n.BaseListing_module_ListingContentAutoSize__c41908d4 {\n  padding: 0;\n}\n\n@media (max-width: 700px) {\n  .BaseListing_module_NoImage__c41908d4 {\n    top: 24px;\n  }\n}\n\n.BaseListing_module_ListingContent__c41908d4 {\n  padding: 0 54px 0 0;\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  display: block;\n}\n.BaseListing_module_ListingContent__c41908d4.BaseListing_module_ListingContentAutoSize__c41908d4 {\n  padding: 0;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingContent__c41908d4 {\n    padding-bottom: 24px;\n    padding-right: 24px;\n    width: 100%;\n  }\n}\n\n.BaseListing_module_listingCategory__c41908d4 {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.BaseListing_module_listingCategoryContainer__c41908d4 {\n  display: flex;\n  align-items: center;\n}\n\n.BaseListing_module_titleRating__c41908d4 {\n  display: flex;\n  align-items: center;\n}\n.BaseListing_module_titleRating__c41908d4::before {\n  width: 1px;\n  height: 100%;\n  display: block;\n  color: #444F6B;\n  padding: 0 7px;\n  content: \"|\";\n}\n.BaseListing_module_titleRating__c41908d4 .BaseListing_module_titleRatingNumber__c41908d4 {\n  display: flex;\n  align-items: center;\n}\n.BaseListing_module_titleRating__c41908d4 .BaseListing_module_titleRatingLabel__c41908d4 {\n  text-transform: uppercase;\n  padding-left: 4px;\n}\n\n.BaseListing_module_ListingImg__c41908d4 {\n  width: 90px;\n  height: 90px;\n  object-fit: cover;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingImg__c41908d4 {\n    width: 100%;\n    height: 154px;\n  }\n}\n\n.BaseListing_module_ListingImgNoObjectFit__c41908d4 {\n  width: auto;\n  height: auto;\n  margin-right: 24px;\n}\n@media (max-width: 700px) {\n  .BaseListing_module_ListingImgNoObjectFit__c41908d4 {\n    width: 100%;\n  }\n}\n\n.BaseListing_module_ListingSub__c41908d4 {\n  margin-bottom: 8px;\n}\n\n.BaseListing_module_VideoPlay__c41908d4 {\n  display: none;\n  width: 44px;\n  height: 44px;\n  opacity: 0.7;\n  filter: drop-shadow(0px 6px 3px rgba(25, 25, 25, 0.2));\n  z-index: 2;\n  position: absolute;\n  margin: 0 auto;\n  left: 0;\n  right: 0;\n  top: 50%;\n  -ms-transform: translateY(-50%);\n  transform: translateY(-50%);\n}\n\n.BaseListing_module_PricePill__c41908d4 {\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n  padding: 2px 14px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  line-height: 22px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #191919;\n  display: inline-block;\n  z-index: 2;\n  margin: 0 0 14px 0;\n}";
injectCss(css$z);
var modules_37668416 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","ListingContainer":"BaseListing_module_ListingContainer__c41908d4","NoBorderBottom":"BaseListing_module_NoBorderBottom__c41908d4","Listing":"BaseListing_module_Listing__c41908d4","StackLayout":"BaseListing_module_StackLayout__c41908d4","ListingImg":"BaseListing_module_ListingImg__c41908d4","ListingTitle":"BaseListing_module_ListingTitle__c41908d4","HeartAction":"BaseListing_module_HeartAction__c41908d4","ListingLink":"BaseListing_module_ListingLink__c41908d4","ListingImgContainer":"BaseListing_module_ListingImgContainer__c41908d4","ListingImgAutoSize":"BaseListing_module_ListingImgAutoSize__c41908d4","ListingContentAutoSize":"BaseListing_module_ListingContentAutoSize__c41908d4","NoImage":"BaseListing_module_NoImage__c41908d4","ListingContent":"BaseListing_module_ListingContent__c41908d4","listingCategory":"BaseListing_module_listingCategory__c41908d4","listingCategoryContainer":"BaseListing_module_listingCategoryContainer__c41908d4","titleRating":"BaseListing_module_titleRating__c41908d4","titleRatingNumber":"BaseListing_module_titleRatingNumber__c41908d4","titleRatingLabel":"BaseListing_module_titleRatingLabel__c41908d4","ListingImgNoObjectFit":"BaseListing_module_ListingImgNoObjectFit__c41908d4","ListingSub":"BaseListing_module_ListingSub__c41908d4","VideoPlay":"BaseListing_module_VideoPlay__c41908d4","PricePill":"BaseListing_module_PricePill__c41908d4"};

function Listing(_ref) {
  var extraClass = _ref.extraClass,
    actionIcon = _ref.actionIcon,
    actionIconDefault = _ref.actionIconDefault,
    actionIconActive = _ref.actionIconActive,
    actionIconAriaLabel = _ref.actionIconAriaLabel,
    categoryColor = _ref.categoryColor,
    categoryTitle = _ref.categoryTitle,
    description = _ref.description,
    detailURL = _ref.detailURL,
    diamondAward = _ref.diamondAward,
    imgURL = _ref.imgURL,
    imageSizeAuto = _ref.imageSizeAuto,
    defaultImg = _ref.defaultImg,
    inspectedClean = _ref.inspectedClean,
    listingAction = _ref.listingAction,
    listingType = _ref.listingType,
    loading = _ref.loading,
    price = _ref.price,
    subtitle = _ref.subtitle,
    title = _ref.title,
    placeholderSrc = _ref.placeholderSrc,
    scrollAmount = _ref.scrollAmount,
    useIntersectionObserver = _ref.useIntersectionObserver,
    actionIconActiveColor = _ref.actionIconActiveColor,
    actionIconDefaultColor = _ref.actionIconDefaultColor,
    actionIconOnClick = _ref.actionIconOnClick,
    actionIconIsActive = _ref.actionIconIsActive,
    actionIconSpinner = _ref.actionIconSpinner,
    actionIconLabel = _ref.actionIconLabel,
    stack = _ref.stack,
    truncate = _ref.truncate,
    noBottomBorder = _ref.noBottomBorder,
    ratingNumber = _ref.ratingNumber,
    ratingLabel = _ref.ratingLabel;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgHasError = _useState2[0],
    setImgHasError = _useState2[1];
  if (loading) {
    var _listingType$toLowerC, _listingType$toLowerC2;
    return /*#__PURE__*/React__default["default"].createElement("div", {
      className: "listing-" + ((listingType === null || listingType === void 0 ? void 0 : (_listingType$toLowerC = listingType.toLowerCase) === null || _listingType$toLowerC === void 0 ? void 0 : (_listingType$toLowerC2 = _listingType$toLowerC.call(listingType)) === null || _listingType$toLowerC2 === void 0 ? void 0 : _listingType$toLowerC2.replace(/ /g, "")) || "") + " listingLoading listingContainer listingContainer-"
      //listingStyle.toLowerCase() // Not sure where this var came from. Leaving this commented out
    }, loading ? /*#__PURE__*/React__default["default"].createElement("div", null, "Loading") : null);
  }
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_37668416.ListingContainer, noBottomBorder ? modules_37668416.NoBorderBottom : '', extraClass].join(" ")
  }, loading ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "circle-loader"
  }, "LOADING") : null, /*#__PURE__*/React__default["default"].createElement("a", {
    className: [modules_37668416.Listing, stack ? modules_37668416.StackLayout : ''].join(' '),
    href: detailURL,
    onClick: listingAction,
    tabIndex: "0"
  }, (!!imgURL || !!defaultImg) && !imgHasError && /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_37668416.ListingImgContainer, imageSizeAuto ? modules_37668416.ListingImgAutoSize : ''].join(' ')
  }, /*#__PURE__*/React__default["default"].createElement(Image, {
    extraClass: [modules_37668416.ListingImg, imageSizeAuto ? modules_37668416.ListingImgNoObjectFit : ''].join(' '),
    alt: "",
    src: imgURL,
    height: "90px",
    width: "90px",
    loaderSrc: placeholderSrc,
    defaultImg: defaultImg,
    scrollAmount: scrollAmount,
    useIntersectionObserver: useIntersectionObserver,
    onError: function onError() {
      return setImgHasError(true);
    }
  })), /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_37668416.ListingContent, imageSizeAuto ? modules_37668416.ListingContentAutoSize : ''].join(' ')
  }, price ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_37668416.PricePill
  }, price) : null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_37668416.listingCategoryContainer
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "XS",
    color: categoryColor,
    extraClass: modules_37668416.listingCategory
  }, categoryTitle), ratingNumber ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_37668416.titleRating
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "S",
    extraClass: modules_37668416.titleRatingNumber
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: "star--solid",
    iconWSize: 16,
    iconHSize: 16,
    iconColor: "#444f6b",
    iconShadow: false
  }), ratingNumber), ratingLabel ? /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "XS",
    extraClass: modules_37668416.titleRatingLabel
  }, ratingLabel) : null) : null), /*#__PURE__*/React__default["default"].createElement(Header4, {
    bold: true,
    fontSize: 'M',
    serif: true,
    extraClass: modules_37668416.ListingTitle
  }, title), subtitle ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    fontSize: 'XS',
    extraClass: modules_37668416.ListingSub
  }, subtitle.length >= 40 ? "".concat(subtitle.substring(0, 40), "...") : subtitle) : null, description ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    fontSize: 'S',
    extraClass: modules_37668416.ListingDesc
  }, truncate && description.length >= 120 ? "".concat(description.substring(0, 120), "...") : description) : null, diamondAward ? /*#__PURE__*/React__default["default"].createElement(DiamondRating, {
    diamondIcon: diamondAward,
    diamondWidth: 115,
    diamondHeight: 40,
    inspectedClean: inspectedClean
  }) : null)), actionIcon ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_37668416.HeartAction, imgHasError || !imgURL ? modules_37668416.NoImage : null].join(" ")
  }, actionIconSpinner ? /*#__PURE__*/React__default["default"].createElement(Loader$1, null) : /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    ariaLabel: actionIconAriaLabel,
    label: actionIconLabel,
    iconDefault: actionIconDefault,
    iconActive: actionIconActive,
    color: actionIconDefaultColor || "#191919",
    activeColor: actionIconActiveColor || "#b30c1c",
    onClick: actionIconOnClick,
    isActive: actionIconIsActive
  })) : null));
}
Listing.propTypes = {
  extraClass: propTypes.exports.string,
  actionIcon: propTypes.exports.bool,
  actionIconDefault: propTypes.exports.string,
  actionIconActive: propTypes.exports.string,
  actionIconLabel: propTypes.exports.string,
  actionIconAriaLabel: propTypes.exports.string,
  categoryColor: propTypes.exports.string,
  categoryTitle: propTypes.exports.string,
  description: propTypes.exports.string,
  detailURL: propTypes.exports.string,
  diamondAward: propTypes.exports.string,
  imgURL: propTypes.exports.string,
  imageSizeAuto: propTypes.exports.bool,
  defaultImg: propTypes.exports.string,
  placeholderSrc: propTypes.exports.string,
  scrollAmount: propTypes.exports.number,
  useIntersectionObserver: propTypes.exports.bool,
  inspectedClean: propTypes.exports.bool,
  listingAction: propTypes.exports.func,
  listingType: propTypes.exports.string,
  loading: propTypes.exports.bool,
  price: propTypes.exports.string,
  subtitle: propTypes.exports.string,
  title: propTypes.exports.string,
  actionIconActiveColor: propTypes.exports.string,
  actionIconDefaultColor: propTypes.exports.string,
  actionIconOnClick: propTypes.exports.func,
  actionIconIsActive: propTypes.exports.bool,
  actionIconSpinner: propTypes.exports.bool,
  stack: propTypes.exports.bool,
  truncate: propTypes.exports.bool,
  noBottomBorder: propTypes.exports.bool,
  ratingNumber: propTypes.exports.string,
  ratingLabel: propTypes.exports.string
};

var css$y = ".Tabs_module_mdsTabs__9086ff29 {\n  width: 100%;\n  overflow: hidden;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 {\n  position: relative;\n  overflow: hidden;\n  overflow-x: auto;\n  white-space: nowrap;\n  padding: 0 36px;\n  padding-top: 14px;\n  -ms-overflow-style: none; /* IE and Edge */\n  scrollbar-width: none; /* Firefox */\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29::-webkit-scrollbar {\n  display: none;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29 {\n  min-height: 56px;\n  position: relative;\n  color: #444f6b;\n  cursor: pointer;\n  background-color: #ffffff;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  text-transform: uppercase;\n  font-weight: 700;\n  outline: none;\n  border: transparent;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.3);\n  padding: 14px 24px;\n  border-top-left-radius: 14px;\n  border-top-right-radius: 14px;\n  border-bottom: none;\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: -1px;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(1) {\n  z-index: calc(100 / 1);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(2) {\n  z-index: calc(100 / 2);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(3) {\n  z-index: calc(100 / 3);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(4) {\n  z-index: calc(100 / 4);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(5) {\n  z-index: calc(100 / 5);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(6) {\n  z-index: calc(100 / 6);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(7) {\n  z-index: calc(100 / 7);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(8) {\n  z-index: calc(100 / 8);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(9) {\n  z-index: calc(100 / 9);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(10) {\n  z-index: calc(100 / 10);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(11) {\n  z-index: calc(100 / 11);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(12) {\n  z-index: calc(100 / 12);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(13) {\n  z-index: calc(100 / 13);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(14) {\n  z-index: calc(100 / 14);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(15) {\n  z-index: calc(100 / 15);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(16) {\n  z-index: calc(100 / 16);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(17) {\n  z-index: calc(100 / 17);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(18) {\n  z-index: calc(100 / 18);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(19) {\n  z-index: calc(100 / 19);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(20) {\n  z-index: calc(100 / 20);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(21) {\n  z-index: calc(100 / 21);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(22) {\n  z-index: calc(100 / 22);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(23) {\n  z-index: calc(100 / 23);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(24) {\n  z-index: calc(100 / 24);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(25) {\n  z-index: calc(100 / 25);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(26) {\n  z-index: calc(100 / 26);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(27) {\n  z-index: calc(100 / 27);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(28) {\n  z-index: calc(100 / 28);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(29) {\n  z-index: calc(100 / 29);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(30) {\n  z-index: calc(100 / 30);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(31) {\n  z-index: calc(100 / 31);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(32) {\n  z-index: calc(100 / 32);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(33) {\n  z-index: calc(100 / 33);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(34) {\n  z-index: calc(100 / 34);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(35) {\n  z-index: calc(100 / 35);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(36) {\n  z-index: calc(100 / 36);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(37) {\n  z-index: calc(100 / 37);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(38) {\n  z-index: calc(100 / 38);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(39) {\n  z-index: calc(100 / 39);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(40) {\n  z-index: calc(100 / 40);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(41) {\n  z-index: calc(100 / 41);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(42) {\n  z-index: calc(100 / 42);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(43) {\n  z-index: calc(100 / 43);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(44) {\n  z-index: calc(100 / 44);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(45) {\n  z-index: calc(100 / 45);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(46) {\n  z-index: calc(100 / 46);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(47) {\n  z-index: calc(100 / 47);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(48) {\n  z-index: calc(100 / 48);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(49) {\n  z-index: calc(100 / 49);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(50) {\n  z-index: calc(100 / 50);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(51) {\n  z-index: calc(100 / 51);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(52) {\n  z-index: calc(100 / 52);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(53) {\n  z-index: calc(100 / 53);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(54) {\n  z-index: calc(100 / 54);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(55) {\n  z-index: calc(100 / 55);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(56) {\n  z-index: calc(100 / 56);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(57) {\n  z-index: calc(100 / 57);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(58) {\n  z-index: calc(100 / 58);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(59) {\n  z-index: calc(100 / 59);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(60) {\n  z-index: calc(100 / 60);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(61) {\n  z-index: calc(100 / 61);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(62) {\n  z-index: calc(100 / 62);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(63) {\n  z-index: calc(100 / 63);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(64) {\n  z-index: calc(100 / 64);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(65) {\n  z-index: calc(100 / 65);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(66) {\n  z-index: calc(100 / 66);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(67) {\n  z-index: calc(100 / 67);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(68) {\n  z-index: calc(100 / 68);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(69) {\n  z-index: calc(100 / 69);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(70) {\n  z-index: calc(100 / 70);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(71) {\n  z-index: calc(100 / 71);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(72) {\n  z-index: calc(100 / 72);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(73) {\n  z-index: calc(100 / 73);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(74) {\n  z-index: calc(100 / 74);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(75) {\n  z-index: calc(100 / 75);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(76) {\n  z-index: calc(100 / 76);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(77) {\n  z-index: calc(100 / 77);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(78) {\n  z-index: calc(100 / 78);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(79) {\n  z-index: calc(100 / 79);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(80) {\n  z-index: calc(100 / 80);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(81) {\n  z-index: calc(100 / 81);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(82) {\n  z-index: calc(100 / 82);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(83) {\n  z-index: calc(100 / 83);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(84) {\n  z-index: calc(100 / 84);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(85) {\n  z-index: calc(100 / 85);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(86) {\n  z-index: calc(100 / 86);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(87) {\n  z-index: calc(100 / 87);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(88) {\n  z-index: calc(100 / 88);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(89) {\n  z-index: calc(100 / 89);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(90) {\n  z-index: calc(100 / 90);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(91) {\n  z-index: calc(100 / 91);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(92) {\n  z-index: calc(100 / 92);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(93) {\n  z-index: calc(100 / 93);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(94) {\n  z-index: calc(100 / 94);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(95) {\n  z-index: calc(100 / 95);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(96) {\n  z-index: calc(100 / 96);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(97) {\n  z-index: calc(100 / 97);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(98) {\n  z-index: calc(100 / 98);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(99) {\n  z-index: calc(100 / 99);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:nth-child(100) {\n  z-index: calc(100 / 100);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29.Tabs_module_TabsButtonActive__9086ff29 {\n  color: #444f6b;\n  border-top: 4px solid #444f6b;\n  background-color: #ffffff;\n  position: relative;\n  z-index: 102;\n  text-decoration: underline;\n  font-weight: 700;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29.Tabs_module_TabsButtonActive__9086ff29 svg {\n  fill: #444f6b;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:hover {\n  text-decoration: underline;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29 .Tabs_module_TabsButton__9086ff29:focus-visible {\n  text-decoration: underline;\n  box-shadow: inset 0 0 0px 3px #0985BE, 1px 4px 14px rgba(25, 25, 25, 0.3);\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsList__9086ff29::before {\n  content: \"\";\n  width: 100%;\n  height: 15px;\n  display: block;\n  position: absolute;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.3);\n  z-index: 101;\n  bottom: -14px;\n  left: 0;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsPanels__9086ff29 {\n  width: 100%;\n  z-index: 3;\n  position: relative;\n  padding: 36px;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsPanels__9086ff29 .Tabs_module_TabsPanel__9086ff29 {\n  width: 100%;\n  visibility: hidden;\n  height: 0;\n  overflow: auto;\n}\n.Tabs_module_mdsTabs__9086ff29 .Tabs_module_TabsPanels__9086ff29 .Tabs_module_TabsPanel__9086ff29.Tabs_module_TabsPanelActive__9086ff29 {\n  visibility: visible;\n  height: auto;\n  overflow: visible;\n}";
injectCss(css$y);
var modules_d0cc66ee = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsTabs":"Tabs_module_mdsTabs__9086ff29","TabsList":"Tabs_module_TabsList__9086ff29","TabsButton":"Tabs_module_TabsButton__9086ff29","TabsButtonActive":"Tabs_module_TabsButtonActive__9086ff29","TabsPanels":"Tabs_module_TabsPanels__9086ff29","TabsPanel":"Tabs_module_TabsPanel__9086ff29","TabsPanelActive":"Tabs_module_TabsPanelActive__9086ff29"};

function Tabs(_ref) {
  var tabsItems = _ref.tabsItems,
    defaultActive = _ref.defaultActive,
    extraClass = _ref.extraClass;
  var _useState = React.useState(defaultActive),
    _useState2 = _slicedToArray(_useState, 2),
    focusedItemId = _useState2[0],
    setFocusedItemId = _useState2[1];
  var handleClick = function handleClick(id) {
    return setFocusedItemId(id);
  };
  var tabRefs = React.useRef({});
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_d0cc66ee.mdsTabs, extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_d0cc66ee.TabsList,
    role: "tablist"
  }, tabsItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("button", {
      key: index,
      ref: function ref(element) {
        return tabRefs.current[index] = element;
      },
      id: "TabsButton" + item.id + "",
      className: [modules_d0cc66ee.TabsButton, focusedItemId === item.id ? modules_d0cc66ee.TabsButtonActive : null].join(" "),
      onClick: function onClick() {
        return handleClick(item.id);
      },
      onFocus: function onFocus() {
        return handleClick(item.id);
      },
      "aria-selected": focusedItemId === item.id ? true : false,
      "aria-controls": "TabsPanel" + item.id + "",
      role: "tab",
      tabIndex: focusedItemId === item.id ? "0" : "-1"
    }, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_d0cc66ee.TabsButtonIcon
    }, item.iconName ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconHSize: 24,
      iconName: item.iconName,
      iconWSize: 24
    }) : null), /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_d0cc66ee.TabsButtonLabel
    }, item.label));
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_d0cc66ee.TabsPanels
  }, tabsItems.map(function (item) {
    return /*#__PURE__*/React__default["default"].createElement("div", {
      key: item.id,
      id: "TabsPanel" + item.id + "",
      className: [modules_d0cc66ee.TabsPanel, focusedItemId === item.id ? modules_d0cc66ee.TabsPanelActive : null].join(" "),
      "aria-labelledby": "TabsButton" + item.id + "",
      role: "tabpanel"
    }, item.content);
  })));
}
Tabs.propTypes = {
  extraClass: propTypes.exports.string,
  tabsItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    id: propTypes.exports.string,
    label: propTypes.exports.string,
    iconName: propTypes.exports.string
  }))
};

var eventemitter3 = {exports: {}};

(function (module) {

	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';

	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}

	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);

	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}

	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}

	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }

	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;

	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];

	  return emitter;
	}

	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}

	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}

	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;

	  if (this._eventsCount === 0) return names;

	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }

	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }

	  return names;
	};

	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];

	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];

	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }

	  return ee;
	};

	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];

	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};

	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return false;

	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;

	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }

	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }

	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;

	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }

	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }

	  return true;
	};

	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};

	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};

	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;

	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }

	  var listeners = this._events[evt];

	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }

	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }

	  return this;
	};

	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;

	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }

	  return this;
	};

	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;

	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;

	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;

	//
	// Expose the module.
	//
	{
	  module.exports = EventEmitter;
	}
} (eventemitter3));

var r = eventemitter3.exports;

// do not edit .js files directly - edit src/index.jst



var fastDeepEqual = function equal(a, b) {
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }



    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;

    for (i = length; i-- !== 0;) {
      var key = keys[i];

      if (!equal(a[key], b[key])) return false;
    }

    return true;
  }

  // true if both NaN, false otherwise
  return a!==a && b!==b;
};

/**
 * Copyright 2019 Google LLC. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at.
 *
 *      Http://www.apache.org/licenses/LICENSE-2.0.
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
const DEFAULT_ID = "__googleMapsScriptId";
/**
 * The status of the [[Loader]].
 */
var LoaderStatus;
(function (LoaderStatus) {
    LoaderStatus[LoaderStatus["INITIALIZED"] = 0] = "INITIALIZED";
    LoaderStatus[LoaderStatus["LOADING"] = 1] = "LOADING";
    LoaderStatus[LoaderStatus["SUCCESS"] = 2] = "SUCCESS";
    LoaderStatus[LoaderStatus["FAILURE"] = 3] = "FAILURE";
})(LoaderStatus || (LoaderStatus = {}));
/**
 * [[Loader]] makes it easier to add Google Maps JavaScript API to your application
 * dynamically using
 * [Promises](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
 * It works by dynamically creating and appending a script node to the the
 * document head and wrapping the callback function so as to return a promise.
 *
 * ```
 * const loader = new Loader({
 *   apiKey: "",
 *   version: "weekly",
 *   libraries: ["places"]
 * });
 *
 * loader.load().then((google) => {
 *   const map = new google.maps.Map(...)
 * })
 * ```
 */
class Loader {
    /**
     * Creates an instance of Loader using [[LoaderOptions]]. No defaults are set
     * using this library, instead the defaults are set by the Google Maps
     * JavaScript API server.
     *
     * ```
     * const loader = Loader({apiKey, version: 'weekly', libraries: ['places']});
     * ```
     */
    constructor({ apiKey, authReferrerPolicy, channel, client, id = DEFAULT_ID, language, libraries = [], mapIds, nonce, region, retries = 3, url = "https://maps.googleapis.com/maps/api/js", version, }) {
        this.CALLBACK = "__googleMapsCallback";
        this.callbacks = [];
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.apiKey = apiKey;
        this.authReferrerPolicy = authReferrerPolicy;
        this.channel = channel;
        this.client = client;
        this.id = id || DEFAULT_ID; // Do not allow empty string
        this.language = language;
        this.libraries = libraries;
        this.mapIds = mapIds;
        this.nonce = nonce;
        this.region = region;
        this.retries = retries;
        this.url = url;
        this.version = version;
        if (Loader.instance) {
            if (!fastDeepEqual(this.options, Loader.instance.options)) {
                throw new Error(`Loader must not be called again with different options. ${JSON.stringify(this.options)} !== ${JSON.stringify(Loader.instance.options)}`);
            }
            return Loader.instance;
        }
        Loader.instance = this;
    }
    get options() {
        return {
            version: this.version,
            apiKey: this.apiKey,
            channel: this.channel,
            client: this.client,
            id: this.id,
            libraries: this.libraries,
            language: this.language,
            region: this.region,
            mapIds: this.mapIds,
            nonce: this.nonce,
            url: this.url,
            authReferrerPolicy: this.authReferrerPolicy,
        };
    }
    get status() {
        if (this.errors.length) {
            return LoaderStatus.FAILURE;
        }
        if (this.done) {
            return LoaderStatus.SUCCESS;
        }
        if (this.loading) {
            return LoaderStatus.LOADING;
        }
        return LoaderStatus.INITIALIZED;
    }
    get failed() {
        return this.done && !this.loading && this.errors.length >= this.retries + 1;
    }
    /**
     * CreateUrl returns the Google Maps JavaScript API script url given the [[LoaderOptions]].
     *
     * @ignore
     */
    createUrl() {
        let url = this.url;
        url += `?callback=${this.CALLBACK}`;
        if (this.apiKey) {
            url += `&key=${this.apiKey}`;
        }
        if (this.channel) {
            url += `&channel=${this.channel}`;
        }
        if (this.client) {
            url += `&client=${this.client}`;
        }
        if (this.libraries.length > 0) {
            url += `&libraries=${this.libraries.join(",")}`;
        }
        if (this.language) {
            url += `&language=${this.language}`;
        }
        if (this.region) {
            url += `&region=${this.region}`;
        }
        if (this.version) {
            url += `&v=${this.version}`;
        }
        if (this.mapIds) {
            url += `&map_ids=${this.mapIds.join(",")}`;
        }
        if (this.authReferrerPolicy) {
            url += `&auth_referrer_policy=${this.authReferrerPolicy}`;
        }
        return url;
    }
    deleteScript() {
        const script = document.getElementById(this.id);
        if (script) {
            script.remove();
        }
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     */
    load() {
        return this.loadPromise();
    }
    /**
     * Load the Google Maps JavaScript API script and return a Promise.
     *
     * @ignore
     */
    loadPromise() {
        return new Promise((resolve, reject) => {
            this.loadCallback((err) => {
                if (!err) {
                    resolve(window.google);
                }
                else {
                    reject(err.error);
                }
            });
        });
    }
    /**
     * Load the Google Maps JavaScript API script with a callback.
     */
    loadCallback(fn) {
        this.callbacks.push(fn);
        this.execute();
    }
    /**
     * Set the script on document.
     */
    setScript() {
        if (document.getElementById(this.id)) {
            // TODO wrap onerror callback for cases where the script was loaded elsewhere
            this.callback();
            return;
        }
        const url = this.createUrl();
        const script = document.createElement("script");
        script.id = this.id;
        script.type = "text/javascript";
        script.src = url;
        script.onerror = this.loadErrorCallback.bind(this);
        script.defer = true;
        script.async = true;
        if (this.nonce) {
            script.nonce = this.nonce;
        }
        document.head.appendChild(script);
    }
    /**
     * Reset the loader state.
     */
    reset() {
        this.deleteScript();
        this.done = false;
        this.loading = false;
        this.errors = [];
        this.onerrorEvent = null;
    }
    resetIfRetryingFailed() {
        if (this.failed) {
            this.reset();
        }
    }
    loadErrorCallback(e) {
        this.errors.push(e);
        if (this.errors.length <= this.retries) {
            const delay = this.errors.length * Math.pow(2, this.errors.length);
            console.log(`Failed to load Google Maps script, retrying in ${delay} ms.`);
            setTimeout(() => {
                this.deleteScript();
                this.setScript();
            }, delay);
        }
        else {
            this.onerrorEvent = e;
            this.callback();
        }
    }
    setCallback() {
        window.__googleMapsCallback = this.callback.bind(this);
    }
    callback() {
        this.done = true;
        this.loading = false;
        this.callbacks.forEach((cb) => {
            cb(this.onerrorEvent);
        });
        this.callbacks = [];
    }
    execute() {
        this.resetIfRetryingFailed();
        if (this.done) {
            this.callback();
        }
        else {
            // short circuit and warn if google.maps is already loaded
            if (window.google && window.google.maps && window.google.maps.version) {
                console.warn("Google Maps already loaded outside @googlemaps/js-api-loader." +
                    "This may result in undesirable behavior as options and script parameters may not match.");
                this.callback();
                return;
            }
            if (this.loading) ;
            else {
                this.loading = true;
                this.setCallback();
                this.setScript();
            }
        }
    }
}

var pointGeometry = Point;

/**
 * A standalone point geometry with useful accessor, comparison, and
 * modification methods.
 *
 * @class Point
 * @param {Number} x the x-coordinate. this could be longitude or screen
 * pixels, or any other sort of unit.
 * @param {Number} y the y-coordinate. this could be latitude or screen
 * pixels, or any other sort of unit.
 * @example
 * var point = new Point(-77, 38);
 */
function Point(x, y) {
    this.x = x;
    this.y = y;
}

Point.prototype = {

    /**
     * Clone this point, returning a new point that can be modified
     * without affecting the old one.
     * @return {Point} the clone
     */
    clone: function() { return new Point(this.x, this.y); },

    /**
     * Add this point's x & y coordinates to another point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    add:     function(p) { return this.clone()._add(p); },

    /**
     * Subtract this point's x & y coordinates to from point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    sub:     function(p) { return this.clone()._sub(p); },

    /**
     * Multiply this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    multByPoint:    function(p) { return this.clone()._multByPoint(p); },

    /**
     * Divide this point's x & y coordinates by point,
     * yielding a new point.
     * @param {Point} p the other point
     * @return {Point} output point
     */
    divByPoint:     function(p) { return this.clone()._divByPoint(p); },

    /**
     * Multiply this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    mult:    function(k) { return this.clone()._mult(k); },

    /**
     * Divide this point's x & y coordinates by a factor,
     * yielding a new point.
     * @param {Point} k factor
     * @return {Point} output point
     */
    div:     function(k) { return this.clone()._div(k); },

    /**
     * Rotate this point around the 0, 0 origin by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @return {Point} output point
     */
    rotate:  function(a) { return this.clone()._rotate(a); },

    /**
     * Rotate this point around p point by an angle a,
     * given in radians
     * @param {Number} a angle to rotate around, in radians
     * @param {Point} p Point to rotate around
     * @return {Point} output point
     */
    rotateAround:  function(a,p) { return this.clone()._rotateAround(a,p); },

    /**
     * Multiply this point by a 4x1 transformation matrix
     * @param {Array<Number>} m transformation matrix
     * @return {Point} output point
     */
    matMult: function(m) { return this.clone()._matMult(m); },

    /**
     * Calculate this point but as a unit vector from 0, 0, meaning
     * that the distance from the resulting point to the 0, 0
     * coordinate will be equal to 1 and the angle from the resulting
     * point to the 0, 0 coordinate will be the same as before.
     * @return {Point} unit vector point
     */
    unit:    function() { return this.clone()._unit(); },

    /**
     * Compute a perpendicular point, where the new y coordinate
     * is the old x coordinate and the new x coordinate is the old y
     * coordinate multiplied by -1
     * @return {Point} perpendicular point
     */
    perp:    function() { return this.clone()._perp(); },

    /**
     * Return a version of this point with the x & y coordinates
     * rounded to integers.
     * @return {Point} rounded point
     */
    round:   function() { return this.clone()._round(); },

    /**
     * Return the magitude of this point: this is the Euclidean
     * distance from the 0, 0 coordinate to this point's x and y
     * coordinates.
     * @return {Number} magnitude
     */
    mag: function() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    },

    /**
     * Judge whether this point is equal to another point, returning
     * true or false.
     * @param {Point} other the other point
     * @return {boolean} whether the points are equal
     */
    equals: function(other) {
        return this.x === other.x &&
               this.y === other.y;
    },

    /**
     * Calculate the distance from this point to another point
     * @param {Point} p the other point
     * @return {Number} distance
     */
    dist: function(p) {
        return Math.sqrt(this.distSqr(p));
    },

    /**
     * Calculate the distance from this point to another point,
     * without the square root step. Useful if you're comparing
     * relative distances.
     * @param {Point} p the other point
     * @return {Number} distance
     */
    distSqr: function(p) {
        var dx = p.x - this.x,
            dy = p.y - this.y;
        return dx * dx + dy * dy;
    },

    /**
     * Get the angle from the 0, 0 coordinate to this point, in radians
     * coordinates.
     * @return {Number} angle
     */
    angle: function() {
        return Math.atan2(this.y, this.x);
    },

    /**
     * Get the angle from this point to another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleTo: function(b) {
        return Math.atan2(this.y - b.y, this.x - b.x);
    },

    /**
     * Get the angle between this point and another point, in radians
     * @param {Point} b the other point
     * @return {Number} angle
     */
    angleWith: function(b) {
        return this.angleWithSep(b.x, b.y);
    },

    /*
     * Find the angle of the two vectors, solving the formula for
     * the cross product a x b = |a||b|sin(θ) for θ.
     * @param {Number} x the x-coordinate
     * @param {Number} y the y-coordinate
     * @return {Number} the angle in radians
     */
    angleWithSep: function(x, y) {
        return Math.atan2(
            this.x * y - this.y * x,
            this.x * x + this.y * y);
    },

    _matMult: function(m) {
        var x = m[0] * this.x + m[1] * this.y,
            y = m[2] * this.x + m[3] * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _add: function(p) {
        this.x += p.x;
        this.y += p.y;
        return this;
    },

    _sub: function(p) {
        this.x -= p.x;
        this.y -= p.y;
        return this;
    },

    _mult: function(k) {
        this.x *= k;
        this.y *= k;
        return this;
    },

    _div: function(k) {
        this.x /= k;
        this.y /= k;
        return this;
    },

    _multByPoint: function(p) {
        this.x *= p.x;
        this.y *= p.y;
        return this;
    },

    _divByPoint: function(p) {
        this.x /= p.x;
        this.y /= p.y;
        return this;
    },

    _unit: function() {
        this._div(this.mag());
        return this;
    },

    _perp: function() {
        var y = this.y;
        this.y = this.x;
        this.x = -y;
        return this;
    },

    _rotate: function(angle) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = cos * this.x - sin * this.y,
            y = sin * this.x + cos * this.y;
        this.x = x;
        this.y = y;
        return this;
    },

    _rotateAround: function(angle, p) {
        var cos = Math.cos(angle),
            sin = Math.sin(angle),
            x = p.x + cos * (this.x - p.x) - sin * (this.y - p.y),
            y = p.y + sin * (this.x - p.x) + cos * (this.y - p.y);
        this.x = x;
        this.y = y;
        return this;
    },

    _round: function() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
};

/**
 * Construct a point from an array if necessary, otherwise if the input
 * is already a Point, or an unknown type, return it unchanged
 * @param {Array<Number>|Point|*} a any kind of input value
 * @return {Point} constructed point, or passed-through value.
 * @example
 * // this
 * var point = Point.convert([0, 1]);
 * // is equivalent to
 * var point = new Point(0, 1);
 */
Point.convert = function (a) {
    if (a instanceof Point) {
        return a;
    }
    if (Array.isArray(a)) {
        return new Point(a[0], a[1]);
    }
    return a;
};

function a(){return (a=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var o=arguments[t];for(var n in o)Object.prototype.hasOwnProperty.call(o,n)&&(e[n]=o[n]);}return e}).apply(this,arguments)}function p(e,t){e.prototype=Object.create(t.prototype),e.prototype.constructor=e,e.__proto__=t;}function l(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var u={width:"100%",height:"100%",left:0,top:0,margin:0,padding:0,position:"absolute"},h=function(t){function o(){return t.apply(this,arguments)||this}p(o,t);var n=o.prototype;return n.shouldComponentUpdate=function(){return !1},n.render=function(){return React__default["default"].createElement("div",{ref:this.props.registerChild,style:u})},o}(React.Component),c=function(e){function t(t){var o;return (o=e.call(this)||this).gmapInstance=t,o}p(t,e);var o=t.prototype;return o.getChildren=function(){return this.gmapInstance.props.children},o.getMousePosition=function(){return this.gmapInstance.mouse_},o.getUpdateCounter=function(){return this.gmapInstance.updateCounter_},o.dispose=function(){this.gmapInstance=null,this.removeAllListeners();},t}(r),d=function(e,t){for(var o=a({},e),n=0;n<t.length;n++){var r=t[n];r in o&&delete o[r];}return o},m=Object.prototype.hasOwnProperty;function g(e,t){return e===t?0!==e||0!==t||1/e==1/t:e!=e&&t!=t}function _(e,t){if(g(e,t))return !0;if("object"!=typeof e||null===e||"object"!=typeof t||null===t)return !1;var o=Object.keys(e),n=Object.keys(t);if(o.length!==n.length)return !1;for(var r=0;r<o.length;r++)if(!m.call(t,o[r])||!g(e[o[r]],t[o[r]]))return !1;return !0}var f={width:"100%",height:"100%",left:0,top:0,margin:0,padding:0,position:"absolute"},v={width:0,height:0,left:0,top:0,backgroundColor:"transparent",position:"absolute"},M=function(t){function o(o){var n;return (n=t.call(this,o)||this)._getState=function(){return {children:n.props.dispatcher.getChildren(),updateCounter:n.props.dispatcher.getUpdateCounter()}},n._onChangeHandler=function(){if(n.dimensionsCache_){var e=(n.state.children||[]).length,t=n._getState();n.setState(t,function(){return (t.children||[]).length!==e&&n._onMouseChangeHandler()});}},n._onChildClick=function(){n.props.onChildClick&&n.hoverChildProps_&&n.props.onChildClick(n.hoverKey_,n.hoverChildProps_);},n._onChildMouseDown=function(){n.props.onChildMouseDown&&n.hoverChildProps_&&n.props.onChildMouseDown(n.hoverKey_,n.hoverChildProps_);},n._onChildMouseEnter=function(e,t){n.dimensionsCache_&&(n.props.onChildMouseEnter&&n.props.onChildMouseEnter(e,t),n.hoverChildProps_=t,n.hoverKey_=e,n.setState({hoverKey:e}));},n._onChildMouseLeave=function(){if(n.dimensionsCache_){var e=n.hoverKey_;null!=e&&(n.props.onChildMouseLeave&&n.props.onChildMouseLeave(e,n.hoverChildProps_),n.hoverKey_=null,n.hoverChildProps_=null,n.setState({hoverKey:null}));}},n._onMouseAllow=function(e){e||n._onChildMouseLeave(),n.allowMouse_=e;},n._onMouseChangeHandler=function(){n.allowMouse_&&n._onMouseChangeHandlerRaf();},n._onMouseChangeHandlerRaf=function(){if(n.dimensionsCache_){var t=n.props.dispatcher.getMousePosition();if(t){var o=[],r=n.props.getHoverDistance();if(React__default["default"].Children.forEach(n.state.children,function(e,i){if(e&&(void 0!==e.props.latLng||void 0!==e.props.lat||void 0!==e.props.lng)){var s=null!=e.key?e.key:i,a=n.props.distanceToMouse(n.dimensionsCache_[s],t,e.props);a<r&&o.push({key:s,dist:a,props:e.props});}}),o.length){o.sort(function(e,t){return e.dist-t.dist});var i=o[0].key,s=o[0].props;n.hoverKey_!==i&&(n._onChildMouseLeave(),n._onChildMouseEnter(i,s));}else n._onChildMouseLeave();}else n._onChildMouseLeave();}},n._getDimensions=function(e){return n.dimensionsCache_[e]},n.dimensionsCache_={},n.hoverKey_=null,n.hoverChildProps_=null,n.allowMouse_=!0,n.state=a({},n._getState(),{hoverKey:null}),n}p(o,t);var n=o.prototype;return n.componentDidMount=function(){this.props.dispatcher.on("kON_CHANGE",this._onChangeHandler),this.props.dispatcher.on("kON_MOUSE_POSITION_CHANGE",this._onMouseChangeHandler),this.props.dispatcher.on("kON_CLICK",this._onChildClick),this.props.dispatcher.on("kON_MDOWN",this._onChildMouseDown);},n.shouldComponentUpdate=function(e,t){return !0===this.props.experimental?!_(this.props,e)||!_(d(this.state,["hoverKey"]),d(t,["hoverKey"])):!_(this.props,e)||!_(this.state,t)},n.componentWillUnmount=function(){this.props.dispatcher.removeListener("kON_CHANGE",this._onChangeHandler),this.props.dispatcher.removeListener("kON_MOUSE_POSITION_CHANGE",this._onMouseChangeHandler),this.props.dispatcher.removeListener("kON_CLICK",this._onChildClick),this.props.dispatcher.removeListener("kON_MDOWN",this._onChildMouseDown),this.dimensionsCache_=null;},n.render=function(){var t=this,o=this.props.style||f;this.dimensionsCache_={};var n=React__default["default"].Children.map(this.state.children,function(o,n){if(o){if(void 0===o.props.latLng&&void 0===o.props.lat&&void 0===o.props.lng)return React__default["default"].cloneElement(o,{$geoService:t.props.geoService,$onMouseAllow:t._onMouseAllow,$prerender:t.props.prerender});var r=void 0!==o.props.latLng?o.props.latLng:{lat:o.props.lat,lng:o.props.lng},i=t.props.insideMapPanes?t.props.geoService.fromLatLngToDivPixel(r):t.props.geoService.fromLatLngToCenterPixel(r),s={left:i.x,top:i.y};if(void 0!==o.props.seLatLng||void 0!==o.props.seLat&&void 0!==o.props.seLng){var p=void 0!==o.props.seLatLng?o.props.seLatLng:{lat:o.props.seLat,lng:o.props.seLng},l=t.props.insideMapPanes?t.props.geoService.fromLatLngToDivPixel(p):t.props.geoService.fromLatLngToCenterPixel(p);s.width=l.x-i.x,s.height=l.y-i.y;}var u=t.props.geoService.fromLatLngToContainerPixel(r),h=null!=o.key?o.key:n;return t.dimensionsCache_[h]=a({x:u.x,y:u.y},r),React__default["default"].createElement("div",{key:h,style:a({},v,s),className:o.props.$markerHolderClassName},React__default["default"].cloneElement(o,{$hover:h===t.state.hoverKey,$getDimensions:t._getDimensions,$dimensionKey:h,$geoService:t.props.geoService,$onMouseAllow:t._onMouseAllow,$prerender:t.props.prerender}))}});return React__default["default"].createElement("div",{style:o},n)},o}(React.Component);M.propTypes={geoService:propTypes.exports.any,style:propTypes.exports.any,distanceToMouse:propTypes.exports.func,dispatcher:propTypes.exports.any,onChildClick:propTypes.exports.func,onChildMouseDown:propTypes.exports.func,onChildMouseLeave:propTypes.exports.func,onChildMouseEnter:propTypes.exports.func,getHoverDistance:propTypes.exports.func,insideMapPanes:propTypes.exports.bool,prerender:propTypes.exports.bool},M.defaultProps={insideMapPanes:!1,prerender:!1};var y={width:"50%",height:"50%",left:"50%",top:"50%",margin:0,padding:0,position:"absolute"};function C$1(t){return React__default["default"].createElement("div",{style:y},React__default["default"].createElement(M,a({},t,{prerender:!0})))}var w,L,b,D=new Promise(function(e){b=e;}),z=function(e,t){if(!e)return D;if(L)return L;e.libraries||(e.libraries=[]);var o=[].concat(e.libraries);if(t&&(0!==o.length&&o.includes("visualization")||o.push("visualization"),console.warn("heatmapLibrary will be deprecated in the future. Please use { libraries: ['visualization'] } in bootstrapURLKeys property instead")),"production"!==process.env.NODE_ENV&&Object.keys(e).indexOf("callback")>-1){var n='"callback" key in bootstrapURLKeys is not allowed,\n                      use onGoogleApiLoaded property instead';throw console.error(n),new Error(n)}if("undefined"==typeof window)throw new Error("google map cannot be loaded outside browser env");var r=e.key,s=function(e,t){if(null==e)return {};var o,n,r={},i=Object.keys(e);for(n=0;n<i.length;n++)t.indexOf(o=i[n])>=0||(r[o]=e[o]);return r}(e,["key"]);return w||(w=new Loader(a({apiKey:r||""},s,{libraries:o}))),L=w.load().then(function(){return b(window.google.maps),window.google.maps}),b(L),L};function k(e,t,o){var n=o-t;return e===o?e:((e-t)%n+n)%n+t}var O=function(){function e(e,t){if(isNaN(e)||isNaN(t))throw new Error("Invalid LatLng object: ("+e+", "+t+")");this.lat=+e,this.lng=+t;}return e.prototype.wrap=function(){return new e(this.lat,k(this.lng,-180,180))},e}();O.convert=function(e){return e instanceof O?e:Array.isArray(e)?new O(e[0],e[1]):"lng"in e&&"lat"in e?new O(e.lat,e.lng):e};var x=function(){function e(e,t,o){this.tileSize=e||512,this._minZoom=t||0,this._maxZoom=o||52,this.latRange=[-85.05113,85.05113],this.width=0,this.height=0,this.zoom=0,this.center=new O(0,0),this.angle=0;}var t,o=e.prototype;return o.zoomScale=function(e){return Math.pow(2,e)},o.scaleZoom=function(e){return Math.log(e)/Math.LN2},o.project=function(e,t){return new pointGeometry(this.lngX(e.lng,t),this.latY(e.lat,t))},o.unproject=function(e,t){return new O(this.yLat(e.y,t),this.xLng(e.x,t))},o.lngX=function(e,t){return (180+e)*(t||this.worldSize)/360},o.latY=function(e,t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+e*Math.PI/360)))*(t||this.worldSize)/360},o.xLng=function(e,t){return 360*e/(t||this.worldSize)-180},o.yLat=function(e,t){return 360/Math.PI*Math.atan(Math.exp((180-360*e/(t||this.worldSize))*Math.PI/180))-90},o.locationPoint=function(e){var t=this.project(e);return this.centerPoint._sub(this.point._sub(t)._rotate(this.angle))},o.pointLocation=function(e){var t=this.centerPoint._sub(e)._rotate(-this.angle);return this.unproject(this.point.sub(t))},(t=[{key:"minZoom",get:function(){return this._minZoom},set:function(e){this._minZoom=e,this.zoom=Math.max(this.zoom,e);}},{key:"maxZoom",get:function(){return this._maxZoom},set:function(e){this._maxZoom=e,this.zoom=Math.min(this.zoom,e);}},{key:"worldSize",get:function(){return this.tileSize*this.scale}},{key:"centerPoint",get:function(){return new pointGeometry(0,0)}},{key:"size",get:function(){return new pointGeometry(this.width,this.height)}},{key:"bearing",get:function(){return -this.angle/Math.PI*180},set:function(e){this.angle=-k(e,-180,180)*Math.PI/180;}},{key:"zoom",get:function(){return this._zoom},set:function(e){var t=Math.min(Math.max(e,this.minZoom),this.maxZoom);this._zoom=t,this.scale=this.zoomScale(t),this.tileZoom=Math.floor(t),this.zoomFraction=t-this.tileZoom;}},{key:"x",get:function(){return this.lngX(this.center.lng)}},{key:"y",get:function(){return this.latY(this.center.lat)}},{key:"point",get:function(){return new pointGeometry(this.x,this.y)}}])&&function(e,t){for(var o=0;o<t.length;o++){var n=t[o];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n);}}(e.prototype,t),e}(),T=function(){function e(e){this.hasSize_=!1,this.hasView_=!1,this.transform_=new x(e||512);}var t=e.prototype;return t.setView=function(e,t,o){this.transform_.center=O.convert(e),this.transform_.zoom=+t,this.transform_.bearing=+o,this.hasView_=!0;},t.setViewSize=function(e,t){this.transform_.width=e,this.transform_.height=t,this.hasSize_=!0;},t.setMapCanvasProjection=function(e,t){this.maps_=e,this.mapCanvasProjection_=t;},t.canProject=function(){return this.hasSize_&&this.hasView_},t.hasSize=function(){return this.hasSize_},t.fromLatLngToCenterPixel=function(e){return this.transform_.locationPoint(O.convert(e))},t.fromLatLngToDivPixel=function(e){if(this.mapCanvasProjection_){var t=new this.maps_.LatLng(e.lat,e.lng);return this.mapCanvasProjection_.fromLatLngToDivPixel(t)}return this.fromLatLngToCenterPixel(e)},t.fromLatLngToContainerPixel=function(e){if(this.mapCanvasProjection_){var t=new this.maps_.LatLng(e.lat,e.lng);return this.mapCanvasProjection_.fromLatLngToContainerPixel(t)}var o=this.fromLatLngToCenterPixel(e);return o.x-=this.transform_.worldSize*Math.round(o.x/this.transform_.worldSize),o.x+=this.transform_.width/2,o.y+=this.transform_.height/2,o},t.fromContainerPixelToLatLng=function(e){if(this.mapCanvasProjection_){var t=this.mapCanvasProjection_.fromContainerPixelToLatLng(e);return {lat:t.lat(),lng:t.lng()}}var o=a({},e);o.x-=this.transform_.width/2,o.y-=this.transform_.height/2;var n=this.transform_.pointLocation(pointGeometry.convert(o));return n.lng-=360*Math.round(n.lng/360),n},t.getWidth=function(){return this.transform_.width},t.getHeight=function(){return this.transform_.height},t.getZoom=function(){return this.transform_.zoom},t.getCenter=function(){return this.transform_.pointLocation({x:0,y:0})},t.getBounds=function(e,t){var o=e&&e[0]||0,n=e&&e[1]||0,r=e&&e[2]||0,i=e&&e[3]||0;if(this.getWidth()-n-i>0&&this.getHeight()-o-r>0){var a=this.transform_.pointLocation(pointGeometry.convert({x:i-this.getWidth()/2,y:o-this.getHeight()/2})),p=this.transform_.pointLocation(pointGeometry.convert({x:this.getWidth()/2-n,y:this.getHeight()/2-r})),l=[a.lat,a.lng,p.lat,p.lng,p.lat,a.lng,a.lat,p.lng];return t&&(l=l.map(function(e){return Math.round(e*t)/t})),l}return [0,0,0,0]},e}();function S(e){if(window.requestAnimationFrame)return window.requestAnimationFrame(e);var t=window.webkitRequestAnimationFrame||window.mozRequestAnimationFrame;return t?t(e):window.setTimeout(e,1e3/60)}var E=Math.log2?Math.log2:function(e){return Math.log(e)/Math.LN2};function P(e,t){return Object.keys(e).reduce(function(o,n){return t(e[n])&&(o[n]=e[n]),o},{})}var A$1=function(e){if(null!==e&&"object"==typeof e){if(0===Object.keys(e).length)return !0}else if(null==e||""===e)return !0;return !1},I=Object.prototype.toString;function N(e){return "number"==typeof e||function(e){return !!e&&"object"==typeof e}(e)&&"[object Number]"===I.call(e)}var Z=null;function j(){if(Z)return Z;if("undefined"!=typeof navigator){var e=navigator.userAgent.indexOf("MSIE")>-1,t=navigator.userAgent.indexOf("Firefox")>-1,o=navigator.userAgent.toLowerCase().indexOf("op")>-1,n=navigator.userAgent.indexOf("Chrome")>-1,r=navigator.userAgent.indexOf("Safari")>-1;return n&&r&&(r=!1),n&&o&&(n=!1),Z={isExplorer:e,isFirefox:t,isOpera:o,isChrome:n,isSafari:r}}return Z={isChrome:!0,isExplorer:!1,isFirefox:!1,isOpera:!1,isSafari:!1}}var U=function(e){return Function.prototype.toString.call(e)};function H(e){if(!e||"object"!=typeof e)return !1;var t="function"==typeof e.constructor?Object.getPrototypeOf(e):Object.prototype;if(null===t)return !0;var o=t.constructor;return "function"==typeof o&&o instanceof o&&U(o)===U(Object)}function K(e,t,o,n){e.addEventListener(t,o,function(){var e=!1;try{var t=Object.defineProperty({},"passive",{get:function(){e=!0;}});window.addEventListener("test",t,t),window.removeEventListener("test",t,t);}catch(t){e=!1;}return e}()?{capture:n,passive:!0}:n);}var R,G=!("undefined"==typeof window||!window.document||!window.document.createElement);R=G?window:"undefined"!=typeof self?self:void 0;var B$1,W="undefined"!=typeof document&&document.attachEvent,V=!1;if(G&&!W){var F=function(){var e=R.requestAnimationFrame||R.mozRequestAnimationFrame||R.webkitRequestAnimationFrame||function(e){return R.setTimeout(e,20)};return function(t){return e(t)}}(),$$1=(B$1=R.cancelAnimationFrame||R.mozCancelAnimationFrame||R.webkitCancelAnimationFrame||R.clearTimeout,function(e){return B$1(e)}),q=function(e){var t=e.__resizeTriggers__,o=t.firstElementChild,n=t.lastElementChild,r=o.firstElementChild;n.scrollLeft=n.scrollWidth,n.scrollTop=n.scrollHeight,r.style.width=o.offsetWidth+1+"px",r.style.height=o.offsetHeight+1+"px",o.scrollLeft=o.scrollWidth,o.scrollTop=o.scrollHeight;},Y=function(e){var t=this;q(this),this.__resizeRAF__&&$$1(this.__resizeRAF__),this.__resizeRAF__=F(function(){(function(e){return e.offsetWidth!=e.__resizeLast__.width||e.offsetHeight!=e.__resizeLast__.height})(t)&&(t.__resizeLast__.width=t.offsetWidth,t.__resizeLast__.height=t.offsetHeight,t.__resizeListeners__.forEach(function(o){o.call(t,e);}));});},X=!1,J="",Q="animationstart",ee="Webkit Moz O ms".split(" "),te="webkitAnimationStart animationstart oAnimationStart MSAnimationStart".split(" ");if(G){var oe=document.createElement("fakeelement");if(void 0!==oe.style.animationName&&(X=!0),!1===X)for(var ne=0;ne<ee.length;ne++)if(void 0!==oe.style[ee[ne]+"AnimationName"]){J="-"+ee[ne].toLowerCase()+"-",Q=te[ne],X=!0;break}}var re="resizeanim",ie="@"+J+"keyframes "+re+" { from { opacity: 0; } to { opacity: 0; } } ",se=J+"animation: 1ms "+re+"; ";}var ae=void 0!==n__default["default"].createPortal,pe=ae?n__default["default"].createPortal:n__default["default"].unstable_renderSubtreeIntoContainer,le=function(e){return H(e)?e:{lat:e[0],lng:e[1]}},ue=function(e,t){return "production"!==process.env.NODE_ENV&&e<t&&console.warn("GoogleMap: minZoom option is less than recommended minZoom option for your map sizes.\noverrided to value "+t),t<e?e:t},he=function(t){function o(o){var r;if((r=t.call(this,o)||this)._getMinZoom=function(){if(r.geoService_.getWidth()>0||r.geoService_.getHeight()>0){var e=Math.ceil(r.geoService_.getWidth()/256)+2,t=Math.ceil(r.geoService_.getHeight()/256)+2,o=Math.max(e,t);return Math.ceil(E(o))}return 3},r._computeMinZoom=function(e){return A$1(e)?r._getMinZoom():e},r._mapDomResizeCallback=function(){if(r.resetSizeOnIdle_=!0,r.maps_){var e=r.props.center||r.props.defaultCenter,t=r.map_.getCenter();r.maps_.event.trigger(r.map_,"resize"),r.map_.setCenter(r.props.resetBoundsOnResize?e:t);}},r._setLayers=function(e){e.forEach(function(e){r.layers_[e]=new r.maps_[e],r.layers_[e].setMap(r.map_);});},r._renderPortal=function(){return React__default["default"].createElement(M,{experimental:r.props.experimental,onChildClick:r._onChildClick,onChildMouseDown:r._onChildMouseDown,onChildMouseEnter:r._onChildMouseEnter,onChildMouseLeave:r._onChildMouseLeave,geoService:r.geoService_,insideMapPanes:!0,distanceToMouse:r.props.distanceToMouse,getHoverDistance:r._getHoverDistance,dispatcher:r.markersDispatcher_})},r._initMap=function(){if(!r.initialized_){r.initialized_=!0;var e=le(r.props.center||r.props.defaultCenter);r.geoService_.setView(e,r.props.zoom||r.props.defaultZoom,0),r._onBoundsChanged();var t=a({},r.props.apiKey&&{key:r.props.apiKey},r.props.bootstrapURLKeys);r.props.googleMapLoader(t,r.props.heatmapLibrary).then(function(e){if(r.mounted_){var t,o,i=r.geoService_.getCenter(),s={zoom:r.props.zoom||r.props.defaultZoom,center:new e.LatLng(i.lat,i.lng)};r.props.heatmap.positions&&(Object.assign(l(r),{heatmap:(t=e,o=r.props.heatmap,new t.visualization.HeatmapLayer({data:o.positions.reduce(function(e,o){var n=o.weight,r=void 0===n?1:n;return e.push({location:new t.LatLng(o.lat,o.lng),weight:r}),e},[])}))}),function(e,t){var o=t.options,n=void 0===o?{}:o;Object.keys(n).map(function(t){return e.set(t,n[t])});}(r.heatmap,r.props.heatmap));var p=P(e,H),u="function"==typeof r.props.options?r.props.options(p):r.props.options,h=!A$1(r.props.draggable)&&{draggable:r.props.draggable},c=r._computeMinZoom(u.minZoom);r.minZoom_=c;var d=a({},{overviewMapControl:!1,streetViewControl:!1,rotateControl:!0,mapTypeControl:!1,styles:[{featureType:"poi",elementType:"labels",stylers:[{visibility:"off"}]}],minZoom:3},{minZoom:c},u,s);r.defaultDraggableOption_=A$1(d.draggable)?r.defaultDraggableOption_:d.draggable;var m=a({},d,h);m.minZoom=ue(m.minZoom,c);var g=new e.Map(n__default["default"].findDOMNode(r.googleMapDom_),m);r.map_=g,r.maps_=e,r._setLayers(r.props.layerTypes);var _=e.version.match(/^3\.(\d+)\./),f=_&&Number(_[1]),v=l(r),M=Object.assign(new e.OverlayView,{onAdd:function(){var t="undefined"!=typeof screen?screen.width+"px":"2000px",o="undefined"!=typeof screen?screen.height+"px":"2000px",n=document.createElement("div");if(n.style.backgroundColor="transparent",n.style.position="absolute",n.style.left="0px",n.style.top="0px",n.style.width=t,n.style.height=o,v.props.overlayViewDivStyle){var r=v.props.overlayViewDivStyle;"object"==typeof r&&Object.keys(r).forEach(function(e){n.style[e]=r[e];});}this.getPanes().overlayMouseTarget.appendChild(n),v.geoService_.setMapCanvasProjection(e,M.getProjection()),ae?v.setState({overlay:n}):pe(v,v._renderPortal(),n,function(){return v.setState({overlay:n})});},onRemove:function(){var e=v.state.overlay;e&&!ae&&n__default["default"].unmountComponentAtNode(e),v.setState({overlay:null});},draw:function(){if(v.updateCounter_++,v._onBoundsChanged(g,e,!v.props.debounced),v.googleApiLoadedCalled_||(v._onGoogleApiLoaded({map:g,maps:e,ref:v.googleMapDom_}),v.googleApiLoadedCalled_=!0),v.mouse_){var t=v.geoService_.fromContainerPixelToLatLng(v.mouse_);v.mouse_.lat=t.lat,v.mouse_.lng=t.lng;}v._onChildMouseMove(),v.markersDispatcher_&&(v.markersDispatcher_.emit("kON_CHANGE"),v.fireMouseEventOnIdle_&&v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"));}});r.overlay_=M,M.setMap(g),r.props.heatmap.positions&&r.heatmap.setMap(g),r.props.onTilesLoaded&&e.event.addListener(g,"tilesloaded",function(){v._onTilesLoaded();}),e.event.addListener(g,"zoom_changed",function(){v.geoService_.getZoom()!==g.getZoom()&&(v.zoomAnimationInProgress_||(v.zoomAnimationInProgress_=!0,v._onZoomAnimationStart(g.zoom)),f<32)&&((new Date).getTime()-r.zoomControlClickTime_<300?S(function(){return S(function(){v.updateCounter_++,v._onBoundsChanged(g,e);})}):(v.updateCounter_++,v._onBoundsChanged(g,e)));}),e.event.addListener(g,"idle",function(){if(r.resetSizeOnIdle_){r._setViewSize();var t=r._computeMinZoom(u.minZoom);t!==r.minZoom_&&(r.minZoom_=t,g.setOptions({minZoom:t})),r.resetSizeOnIdle_=!1;}v.zoomAnimationInProgress_&&(v.zoomAnimationInProgress_=!1,v._onZoomAnimationEnd(g.zoom)),v.updateCounter_++,v._onBoundsChanged(g,e),v.dragTime_=0,v.markersDispatcher_&&v.markersDispatcher_.emit("kON_CHANGE");}),e.event.addListener(g,"mouseover",function(){v.mouseInMap_=!0;}),e.event.addListener(g,"click",function(){v.mouseInMap_=!0;}),e.event.addListener(g,"mouseout",function(){v.mouseInMap_=!1,v.mouse_=null,v.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");}),e.event.addListener(g,"drag",function(){v.dragTime_=(new Date).getTime(),v._onDrag(g);}),e.event.addListener(g,"dragend",function(){var t=e.event.addListener(g,"idle",function(){e.event.removeListener(t),v._onDragEnd(g);});}),e.event.addListener(g,"maptypeid_changed",function(){v._onMapTypeIdChange(g.getMapTypeId());});}}).catch(function(e){throw r._onGoogleApiLoaded({map:null,maps:null,ref:r.googleMapDom_}),console.error(e),e});}},r._onGoogleApiLoaded=function(){var e;r.props.onGoogleApiLoaded&&("production"!==process.env.NODE_ENV&&!0!==r.props.yesIWantToUseGoogleMapApiInternals&&console.warn("GoogleMap: Usage of internal api objects is dangerous and can cause a lot of issues.\nTo hide this warning add yesIWantToUseGoogleMapApiInternals={true} to <GoogleMap instance"),(e=r.props).onGoogleApiLoaded.apply(e,arguments));},r._getHoverDistance=function(){return r.props.hoverDistance},r._onDrag=function(){var e;return r.props.onDrag&&(e=r.props).onDrag.apply(e,arguments)},r._onDragEnd=function(){var e;return r.props.onDragEnd&&(e=r.props).onDragEnd.apply(e,arguments)},r._onMapTypeIdChange=function(){var e;return r.props.onMapTypeIdChange&&(e=r.props).onMapTypeIdChange.apply(e,arguments)},r._onZoomAnimationStart=function(){var e;return r.props.onZoomAnimationStart&&(e=r.props).onZoomAnimationStart.apply(e,arguments)},r._onZoomAnimationEnd=function(){var e;return r.props.onZoomAnimationEnd&&(e=r.props).onZoomAnimationEnd.apply(e,arguments)},r._onTilesLoaded=function(){return r.props.onTilesLoaded&&r.props.onTilesLoaded()},r._onChildClick=function(){var e;if(r.props.onChildClick)return (e=r.props).onChildClick.apply(e,arguments)},r._onChildMouseDown=function(e,t){r.childMouseDownArgs_=[e,t],r.props.onChildMouseDown&&r.props.onChildMouseDown(e,t,a({},r.mouse_));},r._onChildMouseUp=function(){var e;r.childMouseDownArgs_&&(r.props.onChildMouseUp&&(e=r.props).onChildMouseUp.apply(e,r.childMouseDownArgs_.concat([a({},r.mouse_)])),r.childMouseDownArgs_=null,r.childMouseUpTime_=(new Date).getTime());},r._onChildMouseMove=function(){var e;r.childMouseDownArgs_&&r.props.onChildMouseMove&&(e=r.props).onChildMouseMove.apply(e,r.childMouseDownArgs_.concat([a({},r.mouse_)]));},r._onChildMouseEnter=function(){var e;if(r.props.onChildMouseEnter)return (e=r.props).onChildMouseEnter.apply(e,arguments)},r._onChildMouseLeave=function(){var e;if(r.props.onChildMouseLeave)return (e=r.props).onChildMouseLeave.apply(e,arguments)},r._setViewSize=function(){if(r.mounted_){if(document.fullscreen||document.webkitIsFullScreen||document.mozFullScreen||document.msFullscreenElement)r.geoService_.setViewSize(window.innerWidth,window.innerHeight);else {var e=n__default["default"].findDOMNode(r.googleMapDom_);r.geoService_.setViewSize(e.clientWidth,e.clientHeight);}r._onBoundsChanged();}},r._onWindowResize=function(){r.resetSizeOnIdle_=!0;},r._onMapMouseMove=function(e){if(r.mouseInMap_){var t=(new Date).getTime();t-r.mouseMoveTime_>50&&(r.boundingRect_=e.currentTarget.getBoundingClientRect()),r.mouseMoveTime_=t;var o=e.clientX-r.boundingRect_.left,n=e.clientY-r.boundingRect_.top;r.mouse_||(r.mouse_={x:0,y:0,lat:0,lng:0}),r.mouse_.x=o,r.mouse_.y=n;var i=r.geoService_.fromContainerPixelToLatLng(r.mouse_);r.mouse_.lat=i.lat,r.mouse_.lng=i.lng,r._onChildMouseMove(),t-r.dragTime_<100?r.fireMouseEventOnIdle_=!0:(r.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE"),r.fireMouseEventOnIdle_=!1);}},r._onClick=function(){var e;return r.props.onClick&&!r.childMouseDownArgs_&&(new Date).getTime()-r.childMouseUpTime_>300&&0===r.dragTime_&&(e=r.props).onClick.apply(e,arguments)},r._onMapClick=function(e){r.markersDispatcher_&&(r._onMapMouseMove(e),(new Date).getTime()-r.dragTime_>100&&(r.mouse_&&r._onClick(a({},r.mouse_,{event:e})),r.markersDispatcher_.emit("kON_CLICK",e)));},r._onMapMouseDownNative=function(e){r.mouseInMap_&&r._onMapMouseDown(e);},r._onMapMouseDown=function(e){r.markersDispatcher_&&(new Date).getTime()-r.dragTime_>100&&(r._onMapMouseMove(e),r.markersDispatcher_.emit("kON_MDOWN",e));},r._onMapMouseDownCapture=function(){j().isChrome&&(r.zoomControlClickTime_=(new Date).getTime());},r._onKeyDownCapture=function(){j().isChrome&&(r.zoomControlClickTime_=(new Date).getTime());},r._isCenterDefined=function(e){return e&&(H(e)&&N(e.lat)&&N(e.lng)||2===e.length&&N(e[0])&&N(e[1]))},r._onBoundsChanged=function(e,t,o){if(e){var n=e.getCenter();r.geoService_.setView([n.lat(),n.lng()],e.getZoom(),0);}if((r.props.onChange||r.props.onBoundsChange)&&r.geoService_.canProject()){var i=r.geoService_.getZoom(),s=r.geoService_.getBounds(),p=r.geoService_.getCenter();if(!function(e,t,o){if(e&&t){for(var n=0;n!==e.length;++n)if(Math.abs(e[n]-t[n])>1e-5)return !1;return !0}return !1}(s,r.prevBounds_)&&!1!==o){var l=r.geoService_.getBounds(r.props.margin);r.props.onBoundsChange&&r.props.onBoundsChange(r.centerIsObject_?a({},p):[p.lat,p.lng],i,s,l),r.props.onChange&&r.props.onChange({center:a({},p),zoom:i,bounds:{nw:{lat:s[0],lng:s[1]},se:{lat:s[2],lng:s[3]},sw:{lat:s[4],lng:s[5]},ne:{lat:s[6],lng:s[7]}},marginBounds:{nw:{lat:l[0],lng:l[1]},se:{lat:l[2],lng:l[3]},sw:{lat:l[4],lng:l[5]},ne:{lat:l[6],lng:l[7]}},size:r.geoService_.hasSize()?{width:r.geoService_.getWidth(),height:r.geoService_.getHeight()}:{width:0,height:0}}),r.prevBounds_=s;}}},r._registerChild=function(e){r.googleMapDom_=e;},r.mounted_=!1,r.initialized_=!1,r.googleApiLoadedCalled_=!1,r.map_=null,r.maps_=null,r.prevBounds_=null,r.heatmap=null,r.layers_={},r.mouse_=null,r.mouseMoveTime_=0,r.boundingRect_=null,r.mouseInMap_=!0,r.dragTime_=0,r.fireMouseEventOnIdle_=!1,r.updateCounter_=0,r.markersDispatcher_=new c(l(r)),r.geoService_=new T(256),r.centerIsObject_=H(r.props.center),r.minZoom_=3,r.defaultDraggableOption_=!0,r.zoomControlClickTime_=0,r.childMouseDownArgs_=null,r.childMouseUpTime_=0,r.googleMapDom_=null,"production"!==process.env.NODE_ENV&&(r.props.apiKey&&console.warn("GoogleMap: apiKey is deprecated, use bootstrapURLKeys={{key: YOUR_API_KEY}} instead."),r.props.onBoundsChange&&console.warn("GoogleMap: onBoundsChange is deprecated, use onChange({center, zoom, bounds, ...other}) instead."),A$1(r.props.center)&&A$1(r.props.defaultCenter)&&console.warn("GoogleMap: center or defaultCenter property must be defined"),A$1(r.props.zoom)&&A$1(r.props.defaultZoom)&&console.warn("GoogleMap: zoom or defaultZoom property must be defined")),r._isCenterDefined(r.props.center||r.props.defaultCenter)){var i=le(r.props.center||r.props.defaultCenter);r.geoService_.setView(i,r.props.zoom||r.props.defaultZoom,0);}return r.zoomAnimationInProgress_=!1,r.state={overlay:null},r}p(o,t);var r=o.prototype;return r.componentDidMount=function(){var e=this;this.mounted_=!0,K(window,"resize",this._onWindowResize,!1),K(window,"keydown",this._onKeyDownCapture,!0);var t=n__default["default"].findDOMNode(this.googleMapDom_);t&&K(t,"mousedown",this._onMapMouseDownNative,!0),K(window,"mouseup",this._onChildMouseUp,!1);var o=a({},this.props.apiKey&&{key:this.props.apiKey},this.props.bootstrapURLKeys);this.props.googleMapLoader(o,this.props.heatmapLibrary),setTimeout(function(){e._setViewSize(),e._isCenterDefined(e.props.center||e.props.defaultCenter)&&e._initMap();},0,this),this.props.resetBoundsOnResize&&function(e,t){if(void 0===e.parentNode){var o=document.createElement("div");e.parentNode=o;}e=e.parentNode,W?e.attachEvent("onresize",t):(e.__resizeTriggers__||("static"==getComputedStyle(e).position&&(e.style.position="relative"),function(){if(!V){var e=(ie||"")+".resize-triggers { "+(se||"")+'visibility: hidden; opacity: 0; } .resize-triggers, .resize-triggers > div, .contract-trigger:before { content: " "; display: block; position: absolute; top: 0; left: 0; height: 100%; width: 100%; overflow: hidden; } .resize-triggers > div { background: #eee; overflow: auto; } .contract-trigger:before { width: 200%; height: 200%; }',t=document.head||document.getElementsByTagName("head")[0],o=document.createElement("style");o.type="text/css",o.styleSheet?o.styleSheet.cssText=e:o.appendChild(document.createTextNode(e)),t.appendChild(o),V=!0;}}(),e.__resizeLast__={},e.__resizeListeners__=[],(e.__resizeTriggers__=document.createElement("div")).className="resize-triggers",e.__resizeTriggers__.innerHTML='<div class="expand-trigger"><div></div></div><div class="contract-trigger"></div>',e.appendChild(e.__resizeTriggers__),q(e),K(e,"scroll",Y,!0),Q&&e.__resizeTriggers__.addEventListener(Q,function(t){t.animationName==re&&q(e);})),e.__resizeListeners__.push(t));}(t,this._mapDomResizeCallback);},r.shouldComponentUpdate=function(e,t){return !_(d(this.props,["draggable"]),d(e,["draggable"]))||!_(this.state,t)},r.componentDidUpdate=function(e){var t=this;if("production"!==process.env.NODE_ENV&&(_(e.defaultCenter,this.props.defaultCenter)||console.warn("GoogleMap: defaultCenter prop changed. You can't change default props."),_(e.defaultZoom,this.props.defaultZoom)||console.warn("GoogleMap: defaultZoom prop changed. You can't change default props.")),!this._isCenterDefined(e.center)&&this._isCenterDefined(this.props.center)&&setTimeout(function(){return t._initMap()},0),this.map_){var o=this.geoService_.getCenter();if(this._isCenterDefined(this.props.center)){var n=le(this.props.center),r=this._isCenterDefined(e.center)?le(e.center):null;(!r||Math.abs(n.lat-r.lat)+Math.abs(n.lng-r.lng)>1e-5)&&Math.abs(n.lat-o.lat)+Math.abs(n.lng-o.lng)>1e-5&&this.map_.panTo({lat:n.lat,lng:n.lng});}if(A$1(this.props.zoom)||Math.abs(this.props.zoom-e.zoom)>0&&this.map_.setZoom(this.props.zoom),!A$1(e.draggable)&&A$1(this.props.draggable)?this.map_.setOptions({draggable:this.defaultDraggableOption_}):_(e.draggable,this.props.draggable)||this.map_.setOptions({draggable:this.props.draggable}),!A$1(this.props.options)&&!_(e.options,this.props.options)){var i=P(this.maps_,H),s="function"==typeof this.props.options?this.props.options(i):this.props.options;if("minZoom"in(s=d(s,["zoom","center","draggable"]))){var a=this._computeMinZoom(s.minZoom);s.minZoom=ue(s.minZoom,a);}this.map_.setOptions(s);}_(this.props.layerTypes,e.layerTypes)||(Object.keys(this.layers_).forEach(function(e){t.layers_[e].setMap(null),delete t.layers_[e];}),this._setLayers(this.props.layerTypes)),this.heatmap&&!_(this.props.heatmap.positions,e.heatmap.positions)&&this.heatmap.setData(this.props.heatmap.positions.map(function(e){return {location:new t.maps_.LatLng(e.lat,e.lng),weight:e.weight}})),this.heatmap&&!_(this.props.heatmap.options,e.heatmap.options)&&Object.keys(this.props.heatmap.options).forEach(function(e){t.heatmap.set(e,t.props.heatmap.options[e]);});}this.markersDispatcher_.emit("kON_CHANGE"),_(this.props.hoverDistance,e.hoverDistance)||this.markersDispatcher_.emit("kON_MOUSE_POSITION_CHANGE");},r.componentWillUnmount=function(){this.mounted_=!1;var e,t,o=n__default["default"].findDOMNode(this.googleMapDom_);o&&o.removeEventListener("mousedown",this._onMapMouseDownNative,!0),window.removeEventListener("resize",this._onWindowResize),window.removeEventListener("keydown",this._onKeyDownCapture),window.removeEventListener("mouseup",this._onChildMouseUp,!1),this.props.resetBoundsOnResize&&(t=this._mapDomResizeCallback,e=(e=o).parentNode,W?e.detachEvent("onresize",t):(e.__resizeListeners__.splice(e.__resizeListeners__.indexOf(t),1),e.__resizeListeners__.length||(e.removeEventListener("scroll",Y),e.__resizeTriggers__=!e.removeChild(e.__resizeTriggers__)))),this.overlay_&&this.overlay_.setMap(null),this.maps_&&this.map_&&this.props.shouldUnregisterMapOnUnmount&&(this.map_.setOptions({scrollwheel:!1}),this.maps_.event.clearInstanceListeners(this.map_)),this.props.shouldUnregisterMapOnUnmount&&(this.map_=null,this.maps_=null),this.markersDispatcher_.dispose(),this.resetSizeOnIdle_=!1,this.props.shouldUnregisterMapOnUnmount&&(delete this.map_,delete this.markersDispatcher_);},r.render=function(){var t=this.state.overlay,o=t?null:React__default["default"].createElement(C$1,{experimental:this.props.experimental,onChildClick:this._onChildClick,onChildMouseDown:this._onChildMouseDown,onChildMouseEnter:this._onChildMouseEnter,onChildMouseLeave:this._onChildMouseLeave,geoService:this.geoService_,insideMapPanes:!1,distanceToMouse:this.props.distanceToMouse,getHoverDistance:this._getHoverDistance,dispatcher:this.markersDispatcher_});return React__default["default"].createElement("div",{style:this.props.style,onMouseMove:this._onMapMouseMove,onMouseDownCapture:this._onMapMouseDownCapture,onClick:this._onMapClick},React__default["default"].createElement(h,{registerChild:this._registerChild}),ae&&t&&pe(this._renderPortal(),t),o)},o}(React.Component);he.propTypes={apiKey:propTypes.exports.string,bootstrapURLKeys:propTypes.exports.any,defaultCenter:propTypes.exports.oneOfType([propTypes.exports.array,propTypes.exports.shape({lat:propTypes.exports.number,lng:propTypes.exports.number})]),center:propTypes.exports.oneOfType([propTypes.exports.array,propTypes.exports.shape({lat:propTypes.exports.number,lng:propTypes.exports.number})]),defaultZoom:propTypes.exports.number,zoom:propTypes.exports.number,onBoundsChange:propTypes.exports.func,onChange:propTypes.exports.func,onClick:propTypes.exports.func,onChildClick:propTypes.exports.func,onChildMouseDown:propTypes.exports.func,onChildMouseUp:propTypes.exports.func,onChildMouseMove:propTypes.exports.func,onChildMouseEnter:propTypes.exports.func,onChildMouseLeave:propTypes.exports.func,onZoomAnimationStart:propTypes.exports.func,onZoomAnimationEnd:propTypes.exports.func,onDrag:propTypes.exports.func,onDragEnd:propTypes.exports.func,onMapTypeIdChange:propTypes.exports.func,onTilesLoaded:propTypes.exports.func,options:propTypes.exports.any,distanceToMouse:propTypes.exports.func,hoverDistance:propTypes.exports.number,debounced:propTypes.exports.bool,margin:propTypes.exports.array,googleMapLoader:propTypes.exports.any,onGoogleApiLoaded:propTypes.exports.func,yesIWantToUseGoogleMapApiInternals:propTypes.exports.bool,draggable:propTypes.exports.bool,style:propTypes.exports.any,resetBoundsOnResize:propTypes.exports.bool,layerTypes:propTypes.exports.arrayOf(propTypes.exports.string),shouldUnregisterMapOnUnmount:propTypes.exports.bool},he.defaultProps={distanceToMouse:function(e,t){return Math.sqrt((e.x-t.x)*(e.x-t.x)+(e.y-t.y)*(e.y-t.y))},hoverDistance:30,debounced:!0,options:function(){return {overviewMapControl:!1,streetViewControl:!1,rotateControl:!0,mapTypeControl:!1,styles:[{featureType:"poi",elementType:"labels",stylers:[{visibility:"off"}]}],minZoom:3}},googleMapLoader:z,yesIWantToUseGoogleMapApiInternals:!1,style:{width:"100%",height:"100%",margin:0,padding:0,position:"relative"},layerTypes:[],heatmap:{},heatmapLibrary:!1,shouldUnregisterMapOnUnmount:!0},he.googleMapLoader=z;

function sortKD(ids, coords, nodeSize, left, right, depth) {
    if (right - left <= nodeSize) return;

    const m = (left + right) >> 1;

    select(ids, coords, m, left, right, depth % 2);

    sortKD(ids, coords, nodeSize, left, m - 1, depth + 1);
    sortKD(ids, coords, nodeSize, m + 1, right, depth + 1);
}

function select(ids, coords, k, left, right, inc) {

    while (right > left) {
        if (right - left > 600) {
            const n = right - left + 1;
            const m = k - left + 1;
            const z = Math.log(n);
            const s = 0.5 * Math.exp(2 * z / 3);
            const sd = 0.5 * Math.sqrt(z * s * (n - s) / n) * (m - n / 2 < 0 ? -1 : 1);
            const newLeft = Math.max(left, Math.floor(k - m * s / n + sd));
            const newRight = Math.min(right, Math.floor(k + (n - m) * s / n + sd));
            select(ids, coords, k, newLeft, newRight, inc);
        }

        const t = coords[2 * k + inc];
        let i = left;
        let j = right;

        swapItem(ids, coords, left, k);
        if (coords[2 * right + inc] > t) swapItem(ids, coords, left, right);

        while (i < j) {
            swapItem(ids, coords, i, j);
            i++;
            j--;
            while (coords[2 * i + inc] < t) i++;
            while (coords[2 * j + inc] > t) j--;
        }

        if (coords[2 * left + inc] === t) swapItem(ids, coords, left, j);
        else {
            j++;
            swapItem(ids, coords, j, right);
        }

        if (j <= k) left = j + 1;
        if (k <= j) right = j - 1;
    }
}

function swapItem(ids, coords, i, j) {
    swap(ids, i, j);
    swap(coords, 2 * i, 2 * j);
    swap(coords, 2 * i + 1, 2 * j + 1);
}

function swap(arr, i, j) {
    const tmp = arr[i];
    arr[i] = arr[j];
    arr[j] = tmp;
}

function range(ids, coords, minX, minY, maxX, maxY, nodeSize) {
    const stack = [0, ids.length - 1, 0];
    const result = [];
    let x, y;

    while (stack.length) {
        const axis = stack.pop();
        const right = stack.pop();
        const left = stack.pop();

        if (right - left <= nodeSize) {
            for (let i = left; i <= right; i++) {
                x = coords[2 * i];
                y = coords[2 * i + 1];
                if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[i]);
            }
            continue;
        }

        const m = Math.floor((left + right) / 2);

        x = coords[2 * m];
        y = coords[2 * m + 1];

        if (x >= minX && x <= maxX && y >= minY && y <= maxY) result.push(ids[m]);

        const nextAxis = (axis + 1) % 2;

        if (axis === 0 ? minX <= x : minY <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? maxX >= x : maxY >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}

function within(ids, coords, qx, qy, r, nodeSize) {
    const stack = [0, ids.length - 1, 0];
    const result = [];
    const r2 = r * r;

    while (stack.length) {
        const axis = stack.pop();
        const right = stack.pop();
        const left = stack.pop();

        if (right - left <= nodeSize) {
            for (let i = left; i <= right; i++) {
                if (sqDist(coords[2 * i], coords[2 * i + 1], qx, qy) <= r2) result.push(ids[i]);
            }
            continue;
        }

        const m = Math.floor((left + right) / 2);

        const x = coords[2 * m];
        const y = coords[2 * m + 1];

        if (sqDist(x, y, qx, qy) <= r2) result.push(ids[m]);

        const nextAxis = (axis + 1) % 2;

        if (axis === 0 ? qx - r <= x : qy - r <= y) {
            stack.push(left);
            stack.push(m - 1);
            stack.push(nextAxis);
        }
        if (axis === 0 ? qx + r >= x : qy + r >= y) {
            stack.push(m + 1);
            stack.push(right);
            stack.push(nextAxis);
        }
    }

    return result;
}

function sqDist(ax, ay, bx, by) {
    const dx = ax - bx;
    const dy = ay - by;
    return dx * dx + dy * dy;
}

const defaultGetX = p => p[0];
const defaultGetY = p => p[1];

class KDBush {
    constructor(points, getX = defaultGetX, getY = defaultGetY, nodeSize = 64, ArrayType = Float64Array) {
        this.nodeSize = nodeSize;
        this.points = points;

        const IndexArrayType = points.length < 65536 ? Uint16Array : Uint32Array;

        const ids = this.ids = new IndexArrayType(points.length);
        const coords = this.coords = new ArrayType(points.length * 2);

        for (let i = 0; i < points.length; i++) {
            ids[i] = i;
            coords[2 * i] = getX(points[i]);
            coords[2 * i + 1] = getY(points[i]);
        }

        sortKD(ids, coords, nodeSize, 0, ids.length - 1, 0);
    }

    range(minX, minY, maxX, maxY) {
        return range(this.ids, this.coords, minX, minY, maxX, maxY, this.nodeSize);
    }

    within(x, y, r) {
        return within(this.ids, this.coords, x, y, r, this.nodeSize);
    }
}

const defaultOptions = {
    minZoom: 0,   // min zoom to generate clusters on
    maxZoom: 16,  // max zoom level to cluster the points on
    minPoints: 2, // minimum points to form a cluster
    radius: 40,   // cluster radius in pixels
    extent: 512,  // tile extent (radius is calculated relative to it)
    nodeSize: 64, // size of the KD-tree leaf node, affects performance
    log: false,   // whether to log timing info

    // whether to generate numeric ids for input features (in vector tiles)
    generateId: false,

    // a reduce function for calculating custom cluster properties
    reduce: null, // (accumulated, props) => { accumulated.sum += props.sum; }

    // properties to use for individual points when running the reducer
    map: props => props // props => ({sum: props.my_value})
};

const fround = Math.fround || (tmp => ((x) => { tmp[0] = +x; return tmp[0]; }))(new Float32Array(1));

class Supercluster {
    constructor(options) {
        this.options = extend$3(Object.create(defaultOptions), options);
        this.trees = new Array(this.options.maxZoom + 1);
    }

    load(points) {
        const {log, minZoom, maxZoom, nodeSize} = this.options;

        if (log) console.time('total time');

        const timerId = `prepare ${  points.length  } points`;
        if (log) console.time(timerId);

        this.points = points;

        // generate a cluster object for each point and index input points into a KD-tree
        let clusters = [];
        for (let i = 0; i < points.length; i++) {
            if (!points[i].geometry) continue;
            clusters.push(createPointCluster(points[i], i));
        }
        this.trees[maxZoom + 1] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);

        if (log) console.timeEnd(timerId);

        // cluster points on max zoom, then cluster the results on previous zoom, etc.;
        // results in a cluster hierarchy across zoom levels
        for (let z = maxZoom; z >= minZoom; z--) {
            const now = +Date.now();

            // create a new set of clusters for the zoom and index them with a KD-tree
            clusters = this._cluster(clusters, z);
            this.trees[z] = new KDBush(clusters, getX, getY, nodeSize, Float32Array);

            if (log) console.log('z%d: %d clusters in %dms', z, clusters.length, +Date.now() - now);
        }

        if (log) console.timeEnd('total time');

        return this;
    }

    getClusters(bbox, zoom) {
        let minLng = ((bbox[0] + 180) % 360 + 360) % 360 - 180;
        const minLat = Math.max(-90, Math.min(90, bbox[1]));
        let maxLng = bbox[2] === 180 ? 180 : ((bbox[2] + 180) % 360 + 360) % 360 - 180;
        const maxLat = Math.max(-90, Math.min(90, bbox[3]));

        if (bbox[2] - bbox[0] >= 360) {
            minLng = -180;
            maxLng = 180;
        } else if (minLng > maxLng) {
            const easternHem = this.getClusters([minLng, minLat, 180, maxLat], zoom);
            const westernHem = this.getClusters([-180, minLat, maxLng, maxLat], zoom);
            return easternHem.concat(westernHem);
        }

        const tree = this.trees[this._limitZoom(zoom)];
        const ids = tree.range(lngX(minLng), latY(maxLat), lngX(maxLng), latY(minLat));
        const clusters = [];
        for (const id of ids) {
            const c = tree.points[id];
            clusters.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
        }
        return clusters;
    }

    getChildren(clusterId) {
        const originId = this._getOriginId(clusterId);
        const originZoom = this._getOriginZoom(clusterId);
        const errorMsg = 'No cluster with the specified id.';

        const index = this.trees[originZoom];
        if (!index) throw new Error(errorMsg);

        const origin = index.points[originId];
        if (!origin) throw new Error(errorMsg);

        const r = this.options.radius / (this.options.extent * Math.pow(2, originZoom - 1));
        const ids = index.within(origin.x, origin.y, r);
        const children = [];
        for (const id of ids) {
            const c = index.points[id];
            if (c.parentId === clusterId) {
                children.push(c.numPoints ? getClusterJSON(c) : this.points[c.index]);
            }
        }

        if (children.length === 0) throw new Error(errorMsg);

        return children;
    }

    getLeaves(clusterId, limit, offset) {
        limit = limit || 10;
        offset = offset || 0;

        const leaves = [];
        this._appendLeaves(leaves, clusterId, limit, offset, 0);

        return leaves;
    }

    getTile(z, x, y) {
        const tree = this.trees[this._limitZoom(z)];
        const z2 = Math.pow(2, z);
        const {extent, radius} = this.options;
        const p = radius / extent;
        const top = (y - p) / z2;
        const bottom = (y + 1 + p) / z2;

        const tile = {
            features: []
        };

        this._addTileFeatures(
            tree.range((x - p) / z2, top, (x + 1 + p) / z2, bottom),
            tree.points, x, y, z2, tile);

        if (x === 0) {
            this._addTileFeatures(
                tree.range(1 - p / z2, top, 1, bottom),
                tree.points, z2, y, z2, tile);
        }
        if (x === z2 - 1) {
            this._addTileFeatures(
                tree.range(0, top, p / z2, bottom),
                tree.points, -1, y, z2, tile);
        }

        return tile.features.length ? tile : null;
    }

    getClusterExpansionZoom(clusterId) {
        let expansionZoom = this._getOriginZoom(clusterId) - 1;
        while (expansionZoom <= this.options.maxZoom) {
            const children = this.getChildren(clusterId);
            expansionZoom++;
            if (children.length !== 1) break;
            clusterId = children[0].properties.cluster_id;
        }
        return expansionZoom;
    }

    _appendLeaves(result, clusterId, limit, offset, skipped) {
        const children = this.getChildren(clusterId);

        for (const child of children) {
            const props = child.properties;

            if (props && props.cluster) {
                if (skipped + props.point_count <= offset) {
                    // skip the whole cluster
                    skipped += props.point_count;
                } else {
                    // enter the cluster
                    skipped = this._appendLeaves(result, props.cluster_id, limit, offset, skipped);
                    // exit the cluster
                }
            } else if (skipped < offset) {
                // skip a single point
                skipped++;
            } else {
                // add a single point
                result.push(child);
            }
            if (result.length === limit) break;
        }

        return skipped;
    }

    _addTileFeatures(ids, points, x, y, z2, tile) {
        for (const i of ids) {
            const c = points[i];
            const isCluster = c.numPoints;

            let tags, px, py;
            if (isCluster) {
                tags = getClusterProperties(c);
                px = c.x;
                py = c.y;
            } else {
                const p = this.points[c.index];
                tags = p.properties;
                px = lngX(p.geometry.coordinates[0]);
                py = latY(p.geometry.coordinates[1]);
            }

            const f = {
                type: 1,
                geometry: [[
                    Math.round(this.options.extent * (px * z2 - x)),
                    Math.round(this.options.extent * (py * z2 - y))
                ]],
                tags
            };

            // assign id
            let id;
            if (isCluster) {
                id = c.id;
            } else if (this.options.generateId) {
                // optionally generate id
                id = c.index;
            } else if (this.points[c.index].id) {
                // keep id if already assigned
                id = this.points[c.index].id;
            }

            if (id !== undefined) f.id = id;

            tile.features.push(f);
        }
    }

    _limitZoom(z) {
        return Math.max(this.options.minZoom, Math.min(Math.floor(+z), this.options.maxZoom + 1));
    }

    _cluster(points, zoom) {
        const clusters = [];
        const {radius, extent, reduce, minPoints} = this.options;
        const r = radius / (extent * Math.pow(2, zoom));

        // loop through each point
        for (let i = 0; i < points.length; i++) {
            const p = points[i];
            // if we've already visited the point at this zoom level, skip it
            if (p.zoom <= zoom) continue;
            p.zoom = zoom;

            // find all nearby points
            const tree = this.trees[zoom + 1];
            const neighborIds = tree.within(p.x, p.y, r);

            const numPointsOrigin = p.numPoints || 1;
            let numPoints = numPointsOrigin;

            // count the number of points in a potential cluster
            for (const neighborId of neighborIds) {
                const b = tree.points[neighborId];
                // filter out neighbors that are already processed
                if (b.zoom > zoom) numPoints += b.numPoints || 1;
            }

            // if there were neighbors to merge, and there are enough points to form a cluster
            if (numPoints > numPointsOrigin && numPoints >= minPoints) {
                let wx = p.x * numPointsOrigin;
                let wy = p.y * numPointsOrigin;

                let clusterProperties = reduce && numPointsOrigin > 1 ? this._map(p, true) : null;

                // encode both zoom and point index on which the cluster originated -- offset by total length of features
                const id = (i << 5) + (zoom + 1) + this.points.length;

                for (const neighborId of neighborIds) {
                    const b = tree.points[neighborId];

                    if (b.zoom <= zoom) continue;
                    b.zoom = zoom; // save the zoom (so it doesn't get processed twice)

                    const numPoints2 = b.numPoints || 1;
                    wx += b.x * numPoints2; // accumulate coordinates for calculating weighted center
                    wy += b.y * numPoints2;

                    b.parentId = id;

                    if (reduce) {
                        if (!clusterProperties) clusterProperties = this._map(p, true);
                        reduce(clusterProperties, this._map(b));
                    }
                }

                p.parentId = id;
                clusters.push(createCluster(wx / numPoints, wy / numPoints, id, numPoints, clusterProperties));

            } else { // left points as unclustered
                clusters.push(p);

                if (numPoints > 1) {
                    for (const neighborId of neighborIds) {
                        const b = tree.points[neighborId];
                        if (b.zoom <= zoom) continue;
                        b.zoom = zoom;
                        clusters.push(b);
                    }
                }
            }
        }

        return clusters;
    }

    // get index of the point from which the cluster originated
    _getOriginId(clusterId) {
        return (clusterId - this.points.length) >> 5;
    }

    // get zoom of the point from which the cluster originated
    _getOriginZoom(clusterId) {
        return (clusterId - this.points.length) % 32;
    }

    _map(point, clone) {
        if (point.numPoints) {
            return clone ? extend$3({}, point.properties) : point.properties;
        }
        const original = this.points[point.index].properties;
        const result = this.options.map(original);
        return clone && result === original ? extend$3({}, result) : result;
    }
}

function createCluster(x, y, id, numPoints, properties) {
    return {
        x: fround(x), // weighted cluster center; round for consistency with Float32Array index
        y: fround(y),
        zoom: Infinity, // the last zoom the cluster was processed at
        id, // encodes index of the first child of the cluster and its zoom level
        parentId: -1, // parent cluster id
        numPoints,
        properties
    };
}

function createPointCluster(p, id) {
    const [x, y] = p.geometry.coordinates;
    return {
        x: fround(lngX(x)), // projected point coordinates
        y: fround(latY(y)),
        zoom: Infinity, // the last zoom the point was processed at
        index: id, // index of the source feature in the original input array,
        parentId: -1 // parent cluster id
    };
}

function getClusterJSON(cluster) {
    return {
        type: 'Feature',
        id: cluster.id,
        properties: getClusterProperties(cluster),
        geometry: {
            type: 'Point',
            coordinates: [xLng(cluster.x), yLat(cluster.y)]
        }
    };
}

function getClusterProperties(cluster) {
    const count = cluster.numPoints;
    const abbrev =
        count >= 10000 ? `${Math.round(count / 1000)  }k` :
        count >= 1000 ? `${Math.round(count / 100) / 10  }k` : count;
    return extend$3(extend$3({}, cluster.properties), {
        cluster: true,
        cluster_id: cluster.id,
        point_count: count,
        point_count_abbreviated: abbrev
    });
}

// longitude/latitude to spherical mercator in [0..1] range
function lngX(lng) {
    return lng / 360 + 0.5;
}
function latY(lat) {
    const sin = Math.sin(lat * Math.PI / 180);
    const y = (0.5 - 0.25 * Math.log((1 + sin) / (1 - sin)) / Math.PI);
    return y < 0 ? 0 : y > 1 ? 1 : y;
}

// spherical mercator to longitude/latitude
function xLng(x) {
    return (x - 0.5) * 360;
}
function yLat(y) {
    const y2 = (180 - y * 360) * Math.PI / 180;
    return 360 * Math.atan(Math.exp(y2)) / Math.PI - 90;
}

function extend$3(dest, src) {
    for (const id in src) dest[id] = src[id];
    return dest;
}

function getX(p) {
    return p.x;
}
function getY(p) {
    return p.y;
}

var has = Object.prototype.hasOwnProperty;

function find$1(iter, tar, key) {
	for (key of iter.keys()) {
		if (dequal(key, tar)) return key;
	}
}

function dequal(foo, bar) {
	var ctor, len, tmp;
	if (foo === bar) return true;

	if (foo && bar && (ctor=foo.constructor) === bar.constructor) {
		if (ctor === Date) return foo.getTime() === bar.getTime();
		if (ctor === RegExp) return foo.toString() === bar.toString();

		if (ctor === Array) {
			if ((len=foo.length) === bar.length) {
				while (len-- && dequal(foo[len], bar[len]));
			}
			return len === -1;
		}

		if (ctor === Set) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len;
				if (tmp && typeof tmp === 'object') {
					tmp = find$1(bar, tmp);
					if (!tmp) return false;
				}
				if (!bar.has(tmp)) return false;
			}
			return true;
		}

		if (ctor === Map) {
			if (foo.size !== bar.size) {
				return false;
			}
			for (len of foo) {
				tmp = len[0];
				if (tmp && typeof tmp === 'object') {
					tmp = find$1(bar, tmp);
					if (!tmp) return false;
				}
				if (!dequal(len[1], bar.get(tmp))) {
					return false;
				}
			}
			return true;
		}

		if (ctor === ArrayBuffer) {
			foo = new Uint8Array(foo);
			bar = new Uint8Array(bar);
		} else if (ctor === DataView) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo.getInt8(len) === bar.getInt8(len));
			}
			return len === -1;
		}

		if (ArrayBuffer.isView(foo)) {
			if ((len=foo.byteLength) === bar.byteLength) {
				while (len-- && foo[len] === bar[len]);
			}
			return len === -1;
		}

		if (!ctor || typeof foo === 'object') {
			len = 0;
			for (ctor in foo) {
				if (has.call(foo, ctor) && ++len && !has.call(bar, ctor)) return false;
				if (!(ctor in bar) || !dequal(foo[ctor], bar[ctor])) return false;
			}
			return Object.keys(bar).length === len;
		}
	}

	return foo !== foo && bar !== bar;
}

/**
 * @param value the value to be memoized (usually a dependency list)
 * @returns a momoized version of the value as long as it remains deeply equal
 */


function useDeepCompareMemoize(value) {
  var ref = React__namespace.useRef(value);
  var signalRef = React__namespace.useRef(0);

  if (!dequal(value, ref.current)) {
    ref.current = value;
    signalRef.current += 1;
  } // eslint-disable-next-line react-hooks/exhaustive-deps


  return React__namespace.useMemo(function () {
    return ref.current;
  }, [signalRef.current]);
}

function useDeepCompareEffectNoCheck(callback, dependencies) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return React__namespace.useEffect(callback, useDeepCompareMemoize(dependencies));
}

var useSupercluster = function useSupercluster(_ref) {
  var points = _ref.points,
      bounds = _ref.bounds,
      zoom = _ref.zoom,
      options = _ref.options;
  var superclusterRef = React.useRef();
  var pointsRef = React.useRef();

  var _useState = React.useState([]),
      clusters = _useState[0],
      setClusters = _useState[1];

  var zoomInt = Math.round(zoom);
  useDeepCompareEffectNoCheck(function () {
    if (!superclusterRef.current || !dequal(pointsRef.current, points) || !dequal(superclusterRef.current.options, options)) {
      superclusterRef.current = new Supercluster(options);
      superclusterRef.current.load(points);
    }

    if (bounds) {
      setClusters(superclusterRef.current.getClusters(bounds, zoomInt));
    }

    pointsRef.current = points;
  }, [points, bounds, zoomInt, options]);
  return {
    clusters: clusters,
    supercluster: superclusterRef.current
  };
};

var css$x = ".MapList_module_MapListContainer__efbafe6c {\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 2;\n}\n@media (max-width: 1024px) {\n  .MapList_module_MapListContainer__efbafe6c {\n    position: fixed;\n    width: 100%;\n    z-index: 200;\n  }\n}\n.MapList_module_MapListContainer__efbafe6c ul {\n  padding: 0;\n  margin: 0;\n}\n.MapList_module_MapListContainer__efbafe6c li {\n  list-style: none;\n}\n.MapList_module_MapListContainer__efbafe6c img {\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n\n.MapList_module_MapList__efbafe6c {\n  position: relative;\n  background-color: #ffffff;\n  height: 100%;\n  width: 400px;\n  border-radius: 14px 0 0 14px;\n  box-shadow: 1px 8px 16px rgba(25, 25, 25, 0.2);\n  overflow-y: scroll;\n  overflow-x: hidden;\n  padding: 54px 0 24px 24px;\n}\n@media (max-width: 1024px) {\n  .MapList_module_MapList__efbafe6c {\n    width: 100%;\n    border-radius: 14px;\n  }\n}\n\n.MapList_module_Title__efbafe6c {\n  text-transform: uppercase;\n}\n\n.MapList_module_MapHeading__efbafe6c {\n  position: absolute;\n  padding: 14px 14px 14px 24px;\n  width: 100%;\n  left: 0;\n  top: 0;\n  border-radius: 14px 0 0 0;\n  background-color: #ffffff;\n  box-shadow: 1px 8px 16px rgba(25, 25, 25, 0.2);\n  z-index: 1;\n}\n@media (max-width: 1024px) {\n  .MapList_module_MapHeading__efbafe6c {\n    border-radius: 0;\n  }\n}\n.MapList_module_MapHeading__efbafe6c .MapList_module_Close__efbafe6c {\n  position: absolute;\n  right: 0;\n  top: 2px;\n}\n\n.MapList_module_Show__efbafe6c {\n  opacity: 1;\n  transition: all 0.2s ease-in-out;\n}\n\n.MapList_module_Hide__efbafe6c {\n  pointer-events: none;\n  opacity: 0;\n  transition: all 0.2s ease-in-out;\n}";
injectCss(css$x);
var modules_b72f6772 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","MapListContainer":"MapList_module_MapListContainer__efbafe6c","MapList":"MapList_module_MapList__efbafe6c","Title":"MapList_module_Title__efbafe6c","MapHeading":"MapList_module_MapHeading__efbafe6c","Close":"MapList_module_Close__efbafe6c","Show":"MapList_module_Show__efbafe6c","Hide":"MapList_module_Hide__efbafe6c"};

function MapList(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_b72f6772.MapListContainer, props.showMapList ? modules_b72f6772.Show : modules_b72f6772.Hide, props.extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_b72f6772.MapHeading
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    extraClass: modules_b72f6772.Title
  }, props.mapListTitle), " ", /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    extraClass: modules_b72f6772.Title
  }, "(" + props.mapListCount + ")"), /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: modules_b72f6772.Close,
    label: "Button Label",
    icon: "ICON",
    style: "PLAIN",
    iconName: "ui-close",
    action: props.closeMapListOnClick
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_b72f6772.MapList
  }, props.children));
}
MapList.propTypes = {
  extraClass: propTypes.exports.string,
  mapListTitle: propTypes.exports.string,
  mapListCount: propTypes.exports.number,
  closeMapListOnClick: propTypes.exports.func,
  showMapList: propTypes.exports.bool
};

var css$w = ".MapBubble_module_MapBubbleContainer__1282d826 {\n  position: relative;\n  background-color: #ffffff;\n  box-shadow: none;\n  border-radius: 0;\n  width: 100%;\n  display: flex;\n  align-items: center;\n}\n.MapBubble_module_MapBubbleContainer__1282d826 h4 {\n  min-width: 200px;\n}\n@media (max-width: 500px) {\n  .MapBubble_module_MapBubbleContainer__1282d826 h4 {\n    width: auto;\n    font-size: 16px;\n    line-height: 26px;\n    min-width: 160px;\n  }\n}\n@media (max-width: 500px) {\n  .MapBubble_module_MapBubbleContainer__1282d826 {\n    max-width: 300px;\n  }\n}\n\n.MapBubble_module_MapBubble__1282d826 {\n  text-decoration: none;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  padding: 12px;\n  padding-right: 0;\n  height: 100%;\n  align-items: center;\n  transition: all 0.2s ease-in-out;\n}\n@media (max-width: 500px) {\n  .MapBubble_module_MapBubble__1282d826 {\n    max-width: 274px;\n    padding: 0;\n  }\n}\n.MapBubble_module_MapBubble__1282d826:hover h4 {\n  text-decoration: underline;\n}\n.MapBubble_module_MapBubble__1282d826 .MapBubble_module_MapBubbleImg__1282d826 {\n  border-radius: 14px;\n}\n.MapBubble_module_MapBubble__1282d826:focus-visible {\n  outline: none;\n}\n.MapBubble_module_MapBubble__1282d826:focus-visible::after {\n  content: \"\";\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  display: block;\n  border-radius: 14px;\n  outline: none;\n  box-shadow: inset 0px 0px 0px 3px #7f5f9c, 1px 8px 16px rgba(25, 25, 25, 0.2);\n  transition: all 0.2s ease-in-out;\n}\n.MapBubble_module_MapBubble__1282d826:focus-visible .MapBubble_module_MapBubbleTitle__1282d826 {\n  text-decoration: underline;\n}\n.MapBubble_module_MapBubble__1282d826:focus {\n  outline: none;\n}\n\n.MapBubble_module_MapBubbleLink__1282d826 {\n  text-decoration: none;\n  position: relative;\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: column;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  padding-top: 34px;\n}\n.MapBubble_module_MapBubbleLink__1282d826:hover h4 {\n  text-decoration: underline;\n}\n\n.MapBubble_module_MapBubbleImgContainer__1282d826 {\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  display: block;\n  margin-right: 24px;\n  border-radius: 14px;\n  height: 90px;\n  background-color: #ffffff;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n@media (max-width: 500px) {\n  .MapBubble_module_MapBubbleImgContainer__1282d826 {\n    height: 80px;\n  }\n}\n\n.MapBubble_module_MapBubbleContent__1282d826 {\n  padding: 0 24px 0 0;\n  -webkit-box-flex: 0;\n  -webkit-flex-grow: 0;\n  -ms-flex-positive: 0;\n  flex-grow: 0;\n  display: block;\n}\n\n.MapBubble_module_MapBubbleCategorie__1282d826 {\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.MapBubble_module_MapBubbleImg__1282d826 {\n  width: 90px;\n  height: 90px;\n  object-fit: cover;\n}\n@media (max-width: 500px) {\n  .MapBubble_module_MapBubbleImg__1282d826 {\n    height: 80px;\n    width: 80px;\n  }\n}\n\n.MapBubble_module_MapBubbleSub__1282d826 {\n  margin-bottom: 8px;\n}\n\n.MapBubble_module_MapBubbleAction__1282d826 {\n  right: 14px;\n  position: relative;\n}\n\n.MapBubble_module_MapBubbleLoader__1282d826 {\n  right: 14px;\n  position: relative;\n}\n\n.MapBubble_module_PricePill__1282d826 {\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  background-color: #ffffff;\n  padding: 2px 14px;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  line-height: 22px;\n  font-weight: 700;\n  letter-spacing: 1px;\n  color: #191919;\n  display: inline-block;\n  z-index: 2;\n  margin: 0 0 14px 0;\n}\n\n.MapBubble_module_Rating__1282d826 {\n  margin-top: 14px;\n}";
injectCss(css$w);
var modules_521abe75 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","MapBubbleContainer":"MapBubble_module_MapBubbleContainer__1282d826","MapBubble":"MapBubble_module_MapBubble__1282d826","MapBubbleImg":"MapBubble_module_MapBubbleImg__1282d826","MapBubbleTitle":"MapBubble_module_MapBubbleTitle__1282d826","MapBubbleLink":"MapBubble_module_MapBubbleLink__1282d826","MapBubbleImgContainer":"MapBubble_module_MapBubbleImgContainer__1282d826","MapBubbleContent":"MapBubble_module_MapBubbleContent__1282d826","MapBubbleCategorie":"MapBubble_module_MapBubbleCategorie__1282d826","MapBubbleSub":"MapBubble_module_MapBubbleSub__1282d826","MapBubbleAction":"MapBubble_module_MapBubbleAction__1282d826","MapBubbleLoader":"MapBubble_module_MapBubbleLoader__1282d826","PricePill":"MapBubble_module_PricePill__1282d826","Rating":"MapBubble_module_Rating__1282d826"};

var css$v = ".Rating_module_Rating__bd2b3737 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  max-width: fit-content;\n}\n.Rating_module_Rating__bd2b3737 .Rating_module_StarRating__bd2b3737 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #ffffff;\n  padding: 2px 14px 2px 8px;\n  border-radius: 10px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n.Rating_module_Rating__bd2b3737 .Rating_module_RatingLabel__bd2b3737 {\n  margin-left: 8px;\n}\n.Rating_module_Rating__bd2b3737 .Rating_module_Total__bd2b3737 {\n  margin-left: 14px;\n}";
injectCss(css$v);
var modules_7b60ba63 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Rating":"Rating_module_Rating__bd2b3737","StarRating":"Rating_module_StarRating__bd2b3737","RatingLabel":"Rating_module_RatingLabel__bd2b3737","Total":"Rating_module_Total__bd2b3737"};

function Rating(_ref) {
  var ratingNumber = _ref.ratingNumber,
    extraClass = _ref.extraClass,
    ratingLabel = _ref.ratingLabel;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: [modules_7b60ba63.Rating, extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_7b60ba63.StarRating
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconHSize: 24,
    iconName: "star--solid",
    iconWSize: 24
  }), /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    fontSize: "M"
  }, ratingNumber), ratingLabel ? /*#__PURE__*/React__default["default"].createElement(Span, {
    extraClass: modules_7b60ba63.RatingLabel,
    fontSize: "S",
    uppercase: true
  }, ratingLabel) : null)));
}
Rating.propTypes = {
  ratingNumber: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  extraClass: propTypes.exports.string
};

function MapBubble(_ref) {
  var actionIcon = _ref.actionIcon,
    actionIconDefault = _ref.actionIconDefault,
    actionIconActive = _ref.actionIconActive,
    actionIconSpinner = _ref.actionIconSpinner,
    ariaLabel = _ref.ariaLabel,
    categoryColor = _ref.categoryColor,
    categoryTitle = _ref.categoryTitle,
    description = _ref.description,
    detailURL = _ref.detailURL,
    diamondAward = _ref.diamondAward,
    ratingNumber = _ref.ratingNumber,
    totalRatings = _ref.totalRatings,
    imgURL = _ref.imgURL,
    defaultImg = _ref.defaultImg,
    inspectedClean = _ref.inspectedClean,
    mapBubbleActionOnClick = _ref.mapBubbleActionOnClick,
    price = _ref.price,
    subtitle = _ref.subtitle,
    title = _ref.title,
    placeholderSrc = _ref.placeholderSrc,
    scrollAmount = _ref.scrollAmount,
    useIntersectionObserver = _ref.useIntersectionObserver,
    actionIconActiveColor = _ref.actionIconActiveColor,
    actionIconDefaultColor = _ref.actionIconDefaultColor,
    actionIconOnClick = _ref.actionIconOnClick,
    actionIconIsActive = _ref.actionIconIsActive,
    actionIconLabel = _ref.actionIconLabel;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    imgHasError = _useState2[0],
    setImgHasError = _useState2[1];
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_521abe75.MapBubbleContainer
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    className: modules_521abe75.MapBubble,
    href: detailURL,
    onClick: mapBubbleActionOnClick,
    tabIndex: "0"
  }, (!!imgURL || !!defaultImg) && !imgHasError && /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_521abe75.MapBubbleImgContainer
  }, /*#__PURE__*/React__default["default"].createElement(Image, {
    extraClass: modules_521abe75.MapBubbleImg,
    alt: "",
    src: imgURL,
    height: "90px",
    width: "90px",
    loaderSrc: placeholderSrc,
    defaultImg: defaultImg,
    scrollAmount: scrollAmount,
    useIntersectionObserver: useIntersectionObserver,
    onError: function onError() {
      return setImgHasError(true);
    }
  })), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_521abe75.MapBubbleContent
  }, price ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_521abe75.PricePill
  }, price) : null, /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    bold: true,
    fontSize: "XS",
    color: categoryColor,
    extraClass: modules_521abe75.MapBubbleCategorie
  }, categoryTitle), /*#__PURE__*/React__default["default"].createElement(Header4, {
    bold: true,
    fontSize: "M",
    serif: true,
    extraClass: modules_521abe75.MapBubbleTitle
  }, title.length >= 34 ? "".concat(title.substring(0, 34), "...") : title), subtitle ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    fontSize: "XS",
    extraClass: modules_521abe75.MapBubbleSub
  }, subtitle.length >= 40 ? "".concat(subtitle.substring(0, 40), "...") : subtitle) : null, description ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    fontSize: "S",
    extraClass: modules_521abe75.MapBubbleDesc
  }, description.length >= 120 ? "".concat(description.substring(0, 120), "...") : description) : null, diamondAward ? /*#__PURE__*/React__default["default"].createElement(DiamondRating, {
    diamondIcon: diamondAward,
    diamondWidth: 115,
    diamondHeight: 40,
    inspectedClean: inspectedClean
  }) : null, ratingNumber ? /*#__PURE__*/React__default["default"].createElement(Rating, {
    extraClass: modules_521abe75.Rating,
    ratingNumber: ratingNumber,
    totalRatings: totalRatings
  }) : null)), actionIcon ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_521abe75.HeartAction, imgHasError || !imgURL ? modules_521abe75.NoImage : null].join(" ")
  }, actionIconSpinner ? /*#__PURE__*/React__default["default"].createElement(Loader$1, {
    extraClass: modules_521abe75.MapBubbleLoader
  }) : /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    extraClass: modules_521abe75.MapBubbleAction,
    ariaLabel: ariaLabel,
    label: actionIconLabel,
    iconDefault: actionIconDefault,
    iconActive: actionIconActive,
    color: actionIconDefaultColor || "#191919",
    activeColor: actionIconActiveColor || "#b30c1c",
    onClick: actionIconOnClick,
    isActive: actionIconIsActive
  })) : null));
}
MapBubble.propTypes = {
  actionIcon: propTypes.exports.bool,
  actionIconActive: propTypes.exports.string,
  actionIconActiveColor: propTypes.exports.string,
  actionIconDefault: propTypes.exports.string,
  actionIconDefaultColor: propTypes.exports.string,
  actionIconOnClick: propTypes.exports.func,
  actionIconIsActive: propTypes.exports.bool,
  actionIconSpinner: propTypes.exports.bool,
  actionIconLabel: propTypes.exports.string,
  ariaLabel: propTypes.exports.string,
  categoryColor: propTypes.exports.string,
  categoryTitle: propTypes.exports.string,
  description: propTypes.exports.string,
  defaultImg: propTypes.exports.string,
  detailURL: propTypes.exports.string,
  diamondAward: propTypes.exports.string,
  ratingNumber: propTypes.exports.string,
  totalRatings: propTypes.exports.string,
  imgURL: propTypes.exports.string,
  inspectedClean: propTypes.exports.bool,
  mapBubbleActionOnClick: propTypes.exports.func,
  placeholderSrc: propTypes.exports.string,
  price: propTypes.exports.string,
  scrollAmount: propTypes.exports.number,
  subtitle: propTypes.exports.string,
  title: propTypes.exports.string,
  useIntersectionObserver: propTypes.exports.bool
};

var css$u = ".MapPin_module_MapPin__d0f5d8aa {\n  padding: 0;\n  background-color: transparent;\n  display: block;\n  border-radius: 50px;\n  position: absolute;\n  cursor: pointer;\n  border: 6px solid transparent;\n  transform: translate(-50%, -50%);\n  z-index: 1;\n}\n\n.MapPin_module_BouncePin__d0f5d8aa {\n  animation: MapPin_module_bounce__d0f5d8aa 0.3s;\n  animation-direction: alternate;\n  animation-timing-function: cubic-bezier(0.5, 0.05, 1, 0.5);\n  animation-iteration-count: infinite;\n  position: relative;\n  z-index: 3;\n}\n\n@keyframes MapPin_module_bounce__d0f5d8aa {\n  from {\n    transform: translate3d(0, 0, 0);\n  }\n  to {\n    transform: translate3d(0, 20px, 0);\n  }\n}\n.MapPin_module_Active__d0f5d8aa {\n  border: 6px solid #ffffff;\n  box-shadow: 0px 2px 4px rgba(25, 25, 25, 0.2);\n  z-index: 2;\n}\n\n.MapPin_module_MapBubble__d0f5d8aa {\n  padding: 24px;\n  border-radius: 24px;\n  background-color: #ffffff;\n  position: absolute;\n  bottom: 68px;\n  margin: 0 auto;\n}\n\n.MapPin_module_ShowBubble__d0f5d8aa {\n  animation: MapPin_module_fadeIn__d0f5d8aa 0.5s;\n}\n\n@keyframes MapPin_module_fadeIn__d0f5d8aa {\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n}\n.MapPin_module_Pin__d0f5d8aa svg {\n  height: 22px;\n  width: 20px;\n}\n\n.MapPin_module_HeartBadge__d0f5d8aa {\n  position: absolute;\n  top: -14px;\n  right: -10px;\n}\n.MapPin_module_HeartBadge__d0f5d8aa svg {\n  height: 14px;\n  width: 14px;\n  margin-left: 7px;\n}";
injectCss(css$u);
var modules_3a5bf774 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","MapPin":"MapPin_module_MapPin__d0f5d8aa","BouncePin":"MapPin_module_BouncePin__d0f5d8aa","bounce":"MapPin_module_bounce__d0f5d8aa","Active":"MapPin_module_Active__d0f5d8aa","MapBubble":"MapPin_module_MapBubble__d0f5d8aa","ShowBubble":"MapPin_module_ShowBubble__d0f5d8aa","fadeIn":"MapPin_module_fadeIn__d0f5d8aa","Pin":"MapPin_module_Pin__d0f5d8aa","HeartBadge":"MapPin_module_HeartBadge__d0f5d8aa"};

function MapPin(_ref) {
  var id = _ref.id,
    extraClass = _ref.extraClass,
    bgColor = _ref.bgColor,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    pinFocus = _ref.pinFocus,
    heartPinBadge = _ref.heartPinBadge,
    mapBubbleCategoryTitle = _ref.mapBubbleCategoryTitle,
    mapBubbleDetailURL = _ref.mapBubbleDetailURL,
    mapBubbleImgURL = _ref.mapBubbleImgURL,
    mapBubbleTitle = _ref.mapBubbleTitle,
    mapBubbleSubtitle = _ref.mapBubbleSubtitle,
    mapBubbleCategoryColor = _ref.mapBubbleCategoryColor,
    mapBubbleActionIcon = _ref.mapBubbleActionIcon,
    mapBubbleActionOnClick = _ref.mapBubbleActionOnClick,
    mapBubbleActionIconActive = _ref.mapBubbleActionIconActive,
    mapBubbleActionIconActiveColor = _ref.mapBubbleActionIconActiveColor,
    mapBubbleActionIconDefault = _ref.mapBubbleActionIconDefault,
    mapBubbleAriaLabel = _ref.mapBubbleAriaLabel,
    mapBubbleActionIconDefaultColor = _ref.mapBubbleActionIconDefaultColor,
    mapBubbleActionSpinner = _ref.mapBubbleActionSpinner,
    mapBubbleDiamond = _ref.mapBubbleDiamond,
    mapBubbleRating = _ref.mapBubbleRating,
    mapBubbleRatingNumber = _ref.mapBubbleRatingNumber,
    mapBubbleTotalRatings = _ref.mapBubbleTotalRatings,
    mapBubbleActionIconIsActive = _ref.mapBubbleActionIconIsActive,
    mapBubbleActionIconLabel = _ref.mapBubbleActionIconLabel,
    mapBubbleShowOnCreate = _ref.mapBubbleShowOnCreate;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isHovering = _useState2[0],
    setIsHovering = _useState2[1];
  var handleMouseOver = function handleMouseOver() {
    setIsHovering(true);
  };
  var handleMouseOut = function handleMouseOut() {
    setIsHovering(false);
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: pinFocus ? modules_3a5bf774.BouncePin : null
  }, /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    showOnCreate: mapBubbleShowOnCreate,
    content: /*#__PURE__*/React__default["default"].createElement(MapBubble, {
      categoryTitle: mapBubbleCategoryTitle,
      detailURL: mapBubbleDetailURL,
      imgURL: mapBubbleImgURL,
      title: mapBubbleTitle,
      subtitle: mapBubbleSubtitle,
      categoryColor: mapBubbleCategoryColor,
      mapBubbleActionOnClick: mapBubbleActionOnClick,
      ariaLabel: mapBubbleAriaLabel,
      actionIcon: mapBubbleActionIcon,
      actionIconSpinner: mapBubbleActionSpinner,
      actionIconOnClick: mapBubbleActionOnClick,
      actionIconActiveColor: mapBubbleActionIconActiveColor,
      actionIconActive: mapBubbleActionIconActive,
      actionIconDefault: mapBubbleActionIconDefault,
      actionIconIsActive: mapBubbleActionIconIsActive,
      actionIconLabel: mapBubbleActionIconLabel,
      actionIconDefaultColor: mapBubbleActionIconDefaultColor,
      diamondAward: mapBubbleDiamond,
      rating: mapBubbleRating,
      ratingNumber: mapBubbleRatingNumber,
      totalRatings: mapBubbleTotalRatings
    }),
    options: {
      offset: [0, 0],
      maxWidth: "680px"
    },
    interactive: true,
    clickTrigger: true
  }, /*#__PURE__*/React__default["default"].createElement("button", {
    id: id,
    className: [modules_3a5bf774.MapPin, isHovering || pinFocus ? modules_3a5bf774.Active : null, extraClass].join(" "),
    onMouseOver: handleMouseOver,
    onMouseOut: handleMouseOut,
    "aria-label": mapBubbleAriaLabel
  }, heartPinBadge ? /*#__PURE__*/React__default["default"].createElement(CircleIcon, {
    extraClass: modules_3a5bf774.HeartBadge,
    bgColor: "#ffffff",
    iconHSize: 12,
    iconWSize: 12,
    circleHeight: 28,
    circleWidth: 28,
    iconColor: "#ce0c1c",
    iconName: "heart--solid"
  }) : null, /*#__PURE__*/React__default["default"].createElement(CircleIcon, {
    extraClass: modules_3a5bf774.Pin,
    bgColor: bgColor,
    iconName: iconName,
    iconColor: iconColor,
    iconHSize: 22,
    iconWSize: 22,
    circleHeight: 38,
    circleWidth: 38
  }))));
}
MapPin.propTypes = {
  id: propTypes.exports.string,
  lat: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  lng: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  extraClass: propTypes.exports.string,
  bgColor: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  pinFocus: propTypes.exports.bool,
  heartPinBadge: propTypes.exports.bool,
  mapBubbleCategoryTitle: propTypes.exports.string,
  mapBubbleDetailURL: propTypes.exports.string,
  mapBubbleActionOnClick: propTypes.exports.func,
  mapBubbleImgURL: propTypes.exports.string,
  mapBubbleTitle: propTypes.exports.string,
  mapBubbleSubtitle: propTypes.exports.string,
  mapBubbleCategoryColor: propTypes.exports.string,
  mapBubbleActionIcon: propTypes.exports.bool,
  mapBubbleActionIconActive: propTypes.exports.string,
  mapBubbleActionIconActiveColor: propTypes.exports.string,
  mapBubbleActionIconDefault: propTypes.exports.string,
  mapBubbleActionIconLabel: propTypes.exports.string,
  mapBubbleAriaLabel: propTypes.exports.string,
  mapBubbleActionIconDefaultColor: propTypes.exports.string,
  mapBubbleActionSpinner: propTypes.exports.bool,
  mapBubbleDiamond: propTypes.exports.string,
  mapBubbleRatingNumber: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  mapBubbleTotalRatings: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  mapBubbleActionIconIsActive: propTypes.exports.bool,
  mapBubbleShowOnCreate: propTypes.exports.bool
};

var css$t = ".ClusterMarker_module_ClusterMarker__6e9f7a0b {\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  border-radius: 50%;\n  padding: 14px;\n  height: 58px;\n  width: 58px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: translate(-50%, -50%);\n  background-image: url(\"data:image/png;base64,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\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.ClusterMarker_module_MediumCluster__6e9f7a0b {\n  color: #191919;\n  background-image: url(\"data:image/png;base64,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\");\n}\n\n.ClusterMarker_module_LargeCluster__6e9f7a0b {\n  background-image: url(\"data:image/png;base64,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\");\n}";
injectCss(css$t);
var modules_dde2fd37 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","ClusterMarker":"ClusterMarker_module_ClusterMarker__6e9f7a0b","MediumCluster":"ClusterMarker_module_MediumCluster__6e9f7a0b","LargeCluster":"ClusterMarker_module_LargeCluster__6e9f7a0b"};

function ClusterMarker(_ref) {
  _ref.key;
    var lat = _ref.lat,
    lng = _ref.lng,
    clusterCount = _ref.clusterCount,
    onClick = _ref.onClick;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    lat: lat,
    lng: lng
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_dde2fd37.ClusterMarker, clusterCount > 10 && clusterCount < 100 ? modules_dde2fd37.MediumCluster : "", clusterCount > 99 ? modules_dde2fd37.LargeCluster : ""].join(" "),
    onClick: onClick
  }, clusterCount));
}
ClusterMarker.propTypes = {
  lat: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  lng: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  clusterCount: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  onClick: propTypes.exports.func
};

var css$s = ".SpottingMap_module_MapContainer__feb7d6b1 {\n  position: relative;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n  border-radius: 14px;\n  margin: 14px 14px 24px 14px;\n}\n\n.SpottingMap_module_MapInnerContainer__feb7d6b1 {\n  height: 100%;\n  width: 100%;\n  border-radius: 14px;\n  overflow: hidden;\n}\n@media (max-width: 700px) {\n  .SpottingMap_module_MapInnerContainer__feb7d6b1 .SpottingMap_module_MarginBottom__feb7d6b1 {\n    margin-bottom: 340px;\n  }\n}\n\n.SpottingMap_module_ListingItem__feb7d6b1 {\n  padding: 0;\n  border-bottom: none;\n  max-width: none;\n}\n.SpottingMap_module_ListingItem__feb7d6b1 div {\n  top: auto;\n}\n.SpottingMap_module_ListingItem__feb7d6b1 a {\n  padding: 14px 0;\n}\n@media (max-width: 700px) {\n  .SpottingMap_module_ListingItem__feb7d6b1 a {\n    flex-direction: row;\n    min-width: 300px;\n  }\n  .SpottingMap_module_ListingItem__feb7d6b1 a span {\n    margin-right: 24px;\n    margin-bottom: 0px;\n    padding-bottom: 0px;\n    width: auto;\n    height: auto;\n  }\n  .SpottingMap_module_ListingItem__feb7d6b1 a img {\n    height: 90px;\n    width: 90px;\n  }\n}\n.SpottingMap_module_ListingItem__feb7d6b1 span {\n  box-shadow: none;\n}\n\n.SpottingMap_module_ClusterMarker__feb7d6b1 {\n  font-size: 14px;\n  font-weight: 700;\n  color: #ffffff;\n  border-radius: 50%;\n  padding: 14px;\n  height: 58px;\n  width: 58px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  transform: translate(-50%, -50%);\n  background-image: url(\"data:image/png;base64,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\");\n  background-repeat: no-repeat;\n  background-size: contain;\n}\n\n.SpottingMap_module_MediumCluster__feb7d6b1 {\n  color: #191919;\n  background-image: url(\"data:image/png;base64,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\");\n}\n\n.SpottingMap_module_LargeCluster__feb7d6b1 {\n  background-image: url(\"data:image/png;base64,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\");\n}\n\n.SpottingMap_module_ShowMapListWrapper__feb7d6b1 {\n  position: absolute;\n  left: 14px;\n  top: 14px;\n  height: 44px;\n  width: 44px;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  border-radius: 50px;\n}\n.SpottingMap_module_ShowMapListWrapper__feb7d6b1 .SpottingMap_module_ShowMapList__feb7d6b1 {\n  padding: 4px;\n}\n.SpottingMap_module_ShowMapListWrapper__feb7d6b1 .SpottingMap_module_ShowMapList__feb7d6b1 span {\n  height: 28px;\n  width: 28px;\n}";
injectCss(css$s);
var modules_2d31c3a6 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","MapContainer":"SpottingMap_module_MapContainer__feb7d6b1","MapInnerContainer":"SpottingMap_module_MapInnerContainer__feb7d6b1","MarginBottom":"SpottingMap_module_MarginBottom__feb7d6b1","ListingItem":"SpottingMap_module_ListingItem__feb7d6b1","ClusterMarker":"SpottingMap_module_ClusterMarker__feb7d6b1","MediumCluster":"SpottingMap_module_MediumCluster__feb7d6b1","LargeCluster":"SpottingMap_module_LargeCluster__feb7d6b1","ShowMapListWrapper":"SpottingMap_module_ShowMapListWrapper__feb7d6b1","ShowMapList":"SpottingMap_module_ShowMapList__feb7d6b1"};

function SpottingMap(_ref) {
  var mapKey = _ref.mapKey,
    mapCenterLat = _ref.mapCenterLat,
    mapCenterLng = _ref.mapCenterLng,
    mapZoomLevel = _ref.mapZoomLevel,
    mapItems = _ref.mapItems,
    mapList = _ref.mapList,
    mapListTitle = _ref.mapListTitle,
    mapListCount = _ref.mapListCount,
    height = _ref.height,
    extraClass = _ref.extraClass,
    fitAutomatically = _ref.fitAutomatically,
    clusterMap = _ref.clusterMap,
    clusterRadius = _ref.clusterRadius;
  var defaultProps = {
    center: {
      lat: mapCenterLat,
      lng: mapCenterLng
    },
    zoom: mapZoomLevel || 6
  };
  var _useState = React.useState(),
    _useState2 = _slicedToArray(_useState, 2),
    mapApi = _useState2[0],
    setMapApi = _useState2[1];
  var _useState3 = React.useState(""),
    _useState4 = _slicedToArray(_useState3, 2),
    focusedItemId = _useState4[0],
    setFocusedItemId = _useState4[1];
  var _useState5 = React.useState(mapList),
    _useState6 = _slicedToArray(_useState5, 2),
    mapListVisable = _useState6[0],
    setMapListVisable = _useState6[1];

  //Set close and show of map list action
  var showList = function showList() {
    setMapListVisable(true);
  };
  var hideList = function hideList() {
    setMapListVisable(false);
  };

  //Clustering
  var mapRef = React.useRef();
  var points = mapItems.map(function (item) {
    return {
      type: "Feature",
      properties: {
        cluster: false,
        itemId: item.id,
        bgColor: item.mapPinBgColor,
        iconName: item.mapPinIconName,
        iconColor: item.mapPinIconColor,
        heartPinBadge: item.mapPinHeartPinBadge,
        mapBubbleActionIconDefaultColor: item.actionIconDefaultColor,
        mapBubbleCategoryTitle: item.categoryTitle,
        mapBubbleSubtitle: item.subtitle,
        mapBubbleCategoryColor: item.categoryColor,
        mapBubbleActionIconActive: item.actionIconActive,
        mapBubbleActionIconDefault: item.actionIconDefault,
        mapBubbleAriaLabel: item.ariaLabel,
        mapBubbleactionIconLabel: item.actionIconLabel,
        mapBubbleAction: item.action,
        mapBubbleActionOnClick: item.iconAction,
        mapBubbleActionSpinner: item.isLoading,
        mapBubbleImgURL: item.imgURL,
        mapBubbleTitle: item.title,
        mapBubbleDetailURL: item.detailURL,
        mapBubbleDiamond: item.diamondAward,
        mapBubbleRatingNumber: item.ratingNumber,
        mapBubbleTotalRatings: item.totalRatings,
        mapBubbleActionIconIsActive: item.isActive
      },
      geometry: {
        type: "Point",
        coordinates: [parseFloat(item.lng), parseFloat(item.lat)]
      }
    };
  });
  var _useState7 = React.useState(null),
    _useState8 = _slicedToArray(_useState7, 2),
    bounds = _useState8[0],
    setBounds = _useState8[1];
  var _useState9 = React.useState(10),
    _useState10 = _slicedToArray(_useState9, 2),
    zoom = _useState10[0],
    setZoom = _useState10[1];
  var _useSupercluster = useSupercluster({
      points: points,
      bounds: bounds,
      zoom: zoom,
      options: {
        radius: clusterRadius || 75,
        maxZoom: 20
      }
    }),
    clusters = _useSupercluster.clusters;
  var setClusterZoom = function setClusterZoom() {
    mapApi.setZoom(mapApi.getZoom() + 1);
  };
  var getWidth = function getWidth() {
    if (typeof window !== "undefined") {
      return window.innerWidth;
    }
    if (typeof document !== "undefined") {
      var _document$documentEle, _document$body;
      return ((_document$documentEle = document.documentElement) === null || _document$documentEle === void 0 ? void 0 : _document$documentEle.clientWidth) || ((_document$body = document.body) === null || _document$body === void 0 ? void 0 : _document$body.clientWidth);
    }
  };
  function useCurrentWidth() {
    var _useState11 = React.useState(getWidth()),
      _useState12 = _slicedToArray(_useState11, 2),
      width = _useState12[0],
      setWidth = _useState12[1];
    React.useEffect(function () {
      // timeoutId for debounce mechanism
      var timeoutId = null;
      var resizeListener = function resizeListener() {
        // prevent execution of previous setTimeout
        clearTimeout(timeoutId);
        // change width from the state object after 150 milliseconds
        if (typeof window !== 'undefined') {
          timeoutId = setTimeout(function () {
            return setWidth(getWidth());
          }, 150);
        }
      };
      if (typeof window !== 'undefined') {
        // set resize listener
        window.addEventListener("resize", resizeListener);

        // clean up function
        return function () {
          // remove resize listener
          window.removeEventListener("resize", resizeListener);
          if (width < 1024) {
            setMapListVisable(false);
          }
        };
      }
    }, []);
    return width;
  }
  var width = useCurrentWidth();
  React.useEffect(function () {
    setMapListVisable(mapList);
    if (width < 1024) {
      setMapListVisable(false);
    }
    if (!fitAutomatically || !mapApi || typeof google === "undefined") return;
    var bounds = new google.maps.LatLngBounds();
    for (var i = 0; i < mapItems.length; i++) {
      bounds.extend({
        lat: parseFloat(mapItems[i].lat),
        lng: parseFloat(mapItems[i].lng)
      });
    }

    //center the map to the geometric center of all mapItems
    mapApi.setCenter(bounds.getCenter());
    mapApi.fitBounds(bounds);

    //set a minimum zoom
    //if you got only 1 marker or all mapItems are on the same address mapApi will be zoomed too much.
    if (mapApi.getZoom() > 15) {
      mapApi.setZoom(15);
    }
  }, [fitAutomatically, mapApi, mapItems, mapList, width]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_2d31c3a6.MapContainer, extraClass].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_2d31c3a6.MapInnerContainer, mapList ? modules_2d31c3a6.MarginBottom : ""].join(" "),
    style: {
      height: height || "100vh"
    }
  }, /*#__PURE__*/React__default["default"].createElement(he, {
    bootstrapURLKeys: {
      key: mapKey
    },
    defaultCenter: defaultProps.center,
    defaultZoom: defaultProps.zoom,
    yesIWantToUseGoogleMapApiInternals: true,
    setClickableIcons: true,
    onChange: function onChange(_ref2) {
      _ref2.all;
        var zoom = _ref2.zoom,
        bounds = _ref2.bounds;
      setZoom(zoom);
      setBounds([bounds.nw.lng, bounds.se.lat, bounds.se.lng, bounds.nw.lat]);
    },
    onGoogleApiLoaded: function onGoogleApiLoaded(_ref3) {
      var map = _ref3.map;
      setMapApi(map);
      map.setClickableIcons(false);
      mapRef.current = map;
    }
  }, clusterMap ? clusters.map(function (cluster) {
    var _cluster$geometry$coo = _slicedToArray(cluster.geometry.coordinates, 2),
      longitude = _cluster$geometry$coo[0],
      latitude = _cluster$geometry$coo[1];
    var _cluster$properties = cluster.properties,
      isCluster = _cluster$properties.cluster,
      pointCount = _cluster$properties.point_count;
    if (isCluster) {
      return /*#__PURE__*/React__default["default"].createElement(ClusterMarker, {
        key: "cluster-".concat(cluster.id),
        lat: latitude,
        lng: longitude,
        clusterCount: pointCount,
        onClick: setClusterZoom
      });
    }
    return /*#__PURE__*/React__default["default"].createElement(MapPin, {
      key: "mappin-".concat(cluster.properties.itemId),
      id: cluster.id,
      pinFocus: focusedItemId === cluster.properties.itemId ? true : null,
      lat: latitude,
      lng: longitude,
      bgColor: cluster.properties.bgColor,
      iconName: cluster.properties.iconName,
      iconColor: cluster.properties.iconColor,
      heartPinBadge: cluster.properties.heartPinBadge,
      mapBubbleActionIconDefaultColor: cluster.properties.mapBubbleActionIconDefaultColor,
      mapBubbleCategoryTitle: cluster.properties.mapBubbleCategoryTitle,
      mapBubbleSubtitle: cluster.properties.mapBubbleSubtitle,
      mapBubbleCategoryColor: cluster.properties.mapBubbleCategoryColor,
      mapBubbleActionIconActive: cluster.properties.mapBubbleActionIconActive,
      mapBubbleActionIconDefault: cluster.properties.mapBubbleActionIconDefault,
      mapBubbleAriaLabel: cluster.properties.mapBubbleAriaLabel,
      mapBubbleactionIconLabel: cluster.properties.mapBubbleactionIconLabel,
      mapBubbleAction: cluster.properties.mapBubbleAction,
      mapBubbleActionOnClick: cluster.properties.mapBubbleActionOnClick,
      mapBubbleActionSpinner: cluster.properties.mapBubbleActionSpinner,
      mapBubbleImgURL: cluster.properties.mapBubbleImgURL,
      mapBubbleTitle: cluster.properties.mapBubbleTitle,
      mapBubbleDetailURL: cluster.properties.mapBubbleDetailURL,
      mapBubbleDiamond: cluster.properties.mapBubbleDiamond,
      mapBubbleRatingNumber: cluster.properties.mapBubbleRatingNumber,
      mapBubbleTotalRatings: cluster.properties.mapBubbleTotalRatings,
      mapBubbleActionIcon: true,
      mapBubbleActionIconIsActive: cluster.properties.mapBubbleActionIconIsActive,
      mapBubbleShowOnCreate: mapItems.length == 1 ? true : false
    });
  }) : null, clusterMap == false ? mapItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(MapPin, {
      key: index,
      id: item.id,
      pinFocus: focusedItemId === item.id ? true : null,
      lat: item.lat,
      lng: item.lng,
      bgColor: item.mapPinBgColor,
      iconName: item.mapPinIconName,
      iconColor: item.mapPinIconColor,
      heartPinBadge: item.mapPinHeartPinBadge,
      mapBubbleActionIconDefaultColor: item.actionIconDefaultColor,
      mapBubbleCategoryTitle: item.categoryTitle,
      mapBubbleSubtitle: item.subtitle,
      mapBubbleCategoryColor: item.categoryColor,
      mapBubbleActionIconActive: item.actionIconActive,
      mapBubbleActionIconDefault: item.actionIconDefault,
      mapBubbleAriaLabel: item.ariaLabel,
      mapBubbleactionIconLabel: item.actionIconLabel,
      mapBubbleAction: item.action,
      mapBubbleActionOnClick: item.iconAction,
      mapBubbleActionSpinner: item.isLoading,
      mapBubbleImgURL: item.imgURL,
      mapBubbleTitle: item.title,
      mapBubbleDetailURL: item.detailURL,
      mapBubbleDiamond: item.diamondAward,
      mapBubbleRatingNumber: item.ratingNumber,
      mapBubbleTotalRatings: item.totalRatings,
      mapBubbleActionIcon: true,
      mapBubbleActionIconIsActive: item.isActive,
      mapBubbleShowOnCreate: mapItems.length == 1 ? true : false
    });
  }) : null), mapList && mapItems.length != 1 ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_2d31c3a6.ShowMapListWrapper
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: modules_2d31c3a6.ShowMapList,
    label: "Button Label",
    icon: "ICON",
    style: "PLAIN",
    iconName: "ui-list",
    action: showList
  })) : null, /*#__PURE__*/React__default["default"].createElement(MapList, {
    extraClass: modules_2d31c3a6.MapListContainer,
    mapListTitle: mapListTitle,
    mapListCount: mapListCount,
    closeMapListOnClick: hideList,
    showMapList: mapListVisable && mapItems.length != 1 ? true : false
  }, /*#__PURE__*/React__default["default"].createElement("ul", null, mapItems.map(function (item) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: item.id,
      onMouseOver: function onMouseOver() {
        return setFocusedItemId(item.id);
      },
      onMouseOut: function onMouseOut() {
        return setFocusedItemId("");
      }
    }, /*#__PURE__*/React__default["default"].createElement(Listing, {
      extraClass: modules_2d31c3a6.ListingItem,
      actionIcon: true,
      actionIconIsActive: item.isActive,
      actionIconOnClick: item.iconAction,
      listingAction: item.iconAction,
      actionIconSpinner: item.isLoading,
      actionIconActive: item.actionIconActive,
      actionIconActiveColor: item.actionIconActiveColor,
      actionIconDefault: item.actionIconDefault,
      actionIconDefaultColor: item.actionIconDefaultColor,
      actionIconLabel: item.actionIconLabel,
      actionIconAriaLabel: item.ariaLabel,
      categoryColor: item.categoryColor,
      categoryTitle: item.categoryTitle,
      detailURL: item.detailURL,
      imgURL: item.imgURL,
      title: item.title,
      subtitle: item.subtitle,
      diamondAward: item.diamondAward,
      ratingNumber: item.ratingNumber,
      totalRatings: item.totalRatings
    }));
  })))));
}
SpottingMap.propTypes = {
  mapKey: propTypes.exports.string.isRequired,
  mapCenterLat: propTypes.exports.number.isRequired,
  mapCenterLng: propTypes.exports.number.isRequired,
  mapZoomLevel: propTypes.exports.number,
  mapItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    id: propTypes.exports.string,
    imgURL: propTypes.exports.string,
    lat: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    lng: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    title: propTypes.exports.string,
    subtitle: propTypes.exports.string,
    isLoading: propTypes.exports.bool,
    iconAction: propTypes.exports.func,
    actionIconActive: propTypes.exports.string,
    actionIconActiveColor: propTypes.exports.string,
    actionIconDefault: propTypes.exports.string,
    actionIconDefaultColor: propTypes.exports.string,
    actionIconLabel: propTypes.exports.string,
    ariaLabel: propTypes.exports.string,
    categoryColor: propTypes.exports.string,
    categoryTitle: propTypes.exports.string,
    mapPinBgColor: propTypes.exports.string,
    mapPinHeartPinBadge: propTypes.exports.bool,
    mapPinIconName: propTypes.exports.string,
    mapPinIconColor: propTypes.exports.string,
    diamondAward: propTypes.exports.string,
    ratingNumber: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    totalRatings: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
    detailURL: propTypes.exports.string
  })),
  height: propTypes.exports.string,
  extraClass: propTypes.exports.string,
  mapList: propTypes.exports.bool,
  mapListTitle: propTypes.exports.string,
  mapListCount: propTypes.exports.number,
  fitAutomatically: propTypes.exports.bool,
  clusterMap: propTypes.exports.bool,
  clusterRadius: propTypes.exports.number
};

var css$r = ".Autocomplete_module_Autocomplete__b09d6507 {\n  max-width: 420px;\n  position: relative;\n}\n.Autocomplete_module_Autocomplete__b09d6507 label {\n  display: block;\n  margin-bottom: 14px;\n}\n\n.Autocomplete_module_Suggestions__b09d6507 {\n  color: #ffffff;\n  padding: 14px;\n  background-color: #444f6b;\n  border-radius: 0 0 14px 14px;\n  padding: 24px 0 0 0;\n  margin-top: -44px;\n  position: absolute;\n  width: 100%;\n  z-index: 1;\n}\n.Autocomplete_module_Suggestions__b09d6507 a {\n  color: #ffffff;\n  text-decoration: none;\n  border-top: 1px solid #697289;\n  padding: 2px;\n  display: block;\n}\n.Autocomplete_module_Suggestions__b09d6507 a:hover li {\n  background-color: #292f40;\n  border-radius: 24px;\n}\n.Autocomplete_module_Suggestions__b09d6507 a:first-child {\n  border-top: none;\n}\n.Autocomplete_module_Suggestions__b09d6507 li {\n  font-family: \"Karla\", sans-serif;\n  font-size: 16px;\n  line-height: 26px;\n  font-weight: 400;\n  padding: 8px 24px;\n  list-style: none;\n}\n\n.Autocomplete_module_SuggestionActive__b09d6507 {\n  background-color: #363f56;\n  border-radius: 24px;\n}\n\n.Autocomplete_module_NoSuggestions__b09d6507 {\n  color: #ffffff;\n  padding: 14px;\n  background-color: #444f6b;\n  border-radius: 0 0 14px 14px;\n  padding: 34px 24px 14px 24px;\n  margin-top: -44px;\n  position: absolute;\n  width: 100%;\n}";
injectCss(css$r);
var modules_c8f42129 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Autocomplete":"Autocomplete_module_Autocomplete__b09d6507","Suggestions":"Autocomplete_module_Suggestions__b09d6507","SuggestionActive":"Autocomplete_module_SuggestionActive__b09d6507","NoSuggestions":"Autocomplete_module_NoSuggestions__b09d6507"};

var Autocomplete = /*#__PURE__*/function (_Component) {
  _inherits(Autocomplete, _Component);
  var _super = _createSuper(Autocomplete);
  function Autocomplete(props) {
    var _this;
    _classCallCheck(this, Autocomplete);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onChange", function (e) {
      var suggestions = _this.props.suggestions;
      var dynamicList = _this.props.dynamicList;
      var userInput = e.currentTarget.value;
      var autoCompleteList = dynamicList || suggestions;
      var filteredSuggestions = autoCompleteList.filter(function (suggestion) {
        return suggestion.toLowerCase().indexOf(userInput.toLowerCase()) > -1;
      });
      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: filteredSuggestions,
        showSuggestions: true,
        userInput: e.currentTarget.value
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onClick", function (e) {
      _this.setState({
        activeSuggestion: 0,
        filteredSuggestions: [],
        showSuggestions: false,
        userInput: e.currentTarget.innerText
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onKeyDown", function (e) {
      var _this$state = _this.state,
        activeSuggestion = _this$state.activeSuggestion,
        filteredSuggestions = _this$state.filteredSuggestions;
      if (e.keyCode === 13) {
        _this.setState({
          activeSuggestion: 0,
          showSuggestions: false,
          userInput: filteredSuggestions[activeSuggestion]
        });
      } else if (e.keyCode === 38) {
        if (activeSuggestion === 0) {
          return;
        }
        _this.setState({
          activeSuggestion: activeSuggestion - 1
        });
      }
      // User pressed the down arrow, increment the index
      else if (e.keyCode === 40) {
        if (activeSuggestion - 1 === filteredSuggestions.length) {
          return;
        }
        _this.setState({
          activeSuggestion: activeSuggestion + 1
        });
      }
    });
    _this.state = {
      activeSuggestion: 0,
      filteredSuggestions: [],
      showSuggestions: false,
      userInput: ""
    };
    return _this;
  }
  _createClass(Autocomplete, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _onChange = this.onChange,
        onClick = this.onClick,
        onKeyDown = this.onKeyDown,
        _this$state2 = this.state,
        activeSuggestion = _this$state2.activeSuggestion,
        filteredSuggestions = _this$state2.filteredSuggestions,
        showSuggestions = _this$state2.showSuggestions,
        userInput = _this$state2.userInput;
      var suggestionsListComponent;
      if (showSuggestions && userInput) {
        if (filteredSuggestions.length) {
          suggestionsListComponent = /*#__PURE__*/React__default["default"].createElement("ul", {
            className: modules_c8f42129.Suggestions
          }, filteredSuggestions.map(function (suggestion, index) {
            var className;

            // Flag the active suggestion with a class
            if (index === activeSuggestion) {
              className = modules_c8f42129.SuggestionActive;
            }
            return /*#__PURE__*/React__default["default"].createElement("a", {
              href: "#",
              key: index
            }, /*#__PURE__*/React__default["default"].createElement("li", {
              className: className,
              key: suggestion,
              onClick: onClick
            }, suggestion));
          }));
        } else {
          suggestionsListComponent = /*#__PURE__*/React__default["default"].createElement("div", {
            className: modules_c8f42129.NoSuggestions
          }, /*#__PURE__*/React__default["default"].createElement(Span, {
            color: "#ffffff"
          }, "No suggestions available."));
        }
      }
      return /*#__PURE__*/React__default["default"].createElement("div", {
        className: [modules_c8f42129.Autocomplete, this.props.extraClass].join(" ")
      }, /*#__PURE__*/React__default["default"].createElement(Input, {
        iconName: "location--solid",
        showIcon: true,
        label: this.props.label,
        id: this.props.id,
        name: this.props.name,
        onChange: function onChange(e) {
          _onChange(e);
          _this2.props.userTerms(e);
        },
        onKeyDown: onKeyDown,
        placeholder: this.props.placeholder || "Placeholder Text",
        hideLabel: this.props.hideLabel,
        type: "text",
        value: userInput
      }), suggestionsListComponent);
    }
  }]);
  return Autocomplete;
}(React.Component);
var autoCompletePropTypes = {
  extraClass: propTypes.exports.string,
  placeholder: propTypes.exports.string,
  label: propTypes.exports.string.isRequired,
  hideLabel: propTypes.exports.bool,
  id: propTypes.exports.string.isRequired,
  name: propTypes.exports.string.isRequired
};
Autocomplete.propTypes = autoCompletePropTypes;

var css$q = ".SubMenu_module_SubMenu__6b4cc19a {\n  width: 100%;\n  position: relative;\n  background-color: white;\n}\n.SubMenu_module_SubMenu__6b4cc19a .SubMenu_module_SubMenuShadow__6b4cc19a {\n  content: \"\";\n  width: 100%;\n  height: 16px;\n  display: block;\n  position: absolute;\n  bottom: -16px;\n  left: 0;\n  pointer-events: none;\n  background: linear-gradient(180deg, rgba(25, 25, 25, 0.1) 0%, rgba(25, 25, 25, 0) 95%);\n}\n.SubMenu_module_SubMenu__6b4cc19a ul {\n  width: 100%;\n  display: block;\n  list-style-type: none;\n  padding: 0;\n  margin: 0;\n  white-space: nowrap;\n  overflow-x: auto;\n  text-align: right;\n  background-color: white;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n@media only screen and (min-width: 768px) {\n  .SubMenu_module_SubMenu__6b4cc19a ul {\n    text-align: center;\n  }\n}\n.SubMenu_module_SubMenu__6b4cc19a ul::-webkit-scrollbar {\n  display: none;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a {\n  display: inline-block;\n  vertical-align: middle;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a {\n  height: auto;\n  display: inline-block;\n  position: relative;\n  padding: 14px 24px;\n  border: 2px;\n  outline: none;\n  cursor: pointer;\n  text-decoration: none;\n  text-align: center;\n  line-height: 100%;\n  transition: all 0.5s;\n  color: #444f6b;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a > span {\n  height: 34px;\n  position: relative;\n  display: flex;\n  flex-wrap: wrap;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n  color: #444f6b;\n  font-family: \"Karla\", sans-serif;\n  font-size: 14px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  text-transform: uppercase;\n  border: 0;\n  cursor: pointer;\n  box-shadow: none;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a > span svg {\n  margin-right: 12px;\n  fill: #444f6b;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a .SubMenu_module_Label__6b4cc19a {\n  max-width: 175px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  display: inline-block;\n  color: #444f6b;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a:hover {\n  text-decoration: none;\n  background-color: #edeef2;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a:focus-visible {\n  box-shadow: inset 0 0 0px 3px #0985BE;\n  color: #444F6B;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a:focus-visible .SubMenu_module_Label__6b4cc19a {\n  text-decoration: underline;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a[data-isactive=true] {\n  color: white;\n  background-color: #444f6b;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a[data-isactive=true] .SubMenu_module_Label__6b4cc19a {\n  color: white;\n}\n.SubMenu_module_SubMenu__6b4cc19a ul li.SubMenu_module_SubMenuItem__6b4cc19a .SubMenu_module_SubMenuItemLink__6b4cc19a[data-isactive=true] svg {\n  fill: white;\n}";
injectCss(css$q);
var modules_5f2dee03 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","SubMenu":"SubMenu_module_SubMenu__6b4cc19a","SubMenuShadow":"SubMenu_module_SubMenuShadow__6b4cc19a","SubMenuItem":"SubMenu_module_SubMenuItem__6b4cc19a","SubMenuItemLink":"SubMenu_module_SubMenuItemLink__6b4cc19a","Label":"SubMenu_module_Label__6b4cc19a"};

function SubMenu(_ref) {
  var _ref$ariaLabel = _ref.ariaLabel,
    ariaLabel = _ref$ariaLabel === void 0 ? ariaLabel ? ariaLabel : "sub-menu" : _ref$ariaLabel,
    subMenuItems = _ref.subMenuItems;
  return /*#__PURE__*/React__default["default"].createElement("nav", {
    "aria-label": ariaLabel,
    className: modules_5f2dee03.SubMenu
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    role: "menubar",
    "aria-label": ariaLabel,
    className: modules_5f2dee03.SubMenuContent
  }, subMenuItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      role: "none",
      className: modules_5f2dee03.SubMenuItem
    }, item.isButton ? /*#__PURE__*/React__default["default"].createElement("button", {
      key: index,
      className: modules_5f2dee03.SubMenuItemLink,
      role: "menuitem",
      "data-isactive": item.isActive ? "true" : null,
      "aria-current": item.isActive ? "page" : null,
      "aria-haspopup": item.hasPopUp ? "true" : "false",
      "aria-expanded": item.isExpanded ? "true" : "false",
      onClick: item.onClick,
      "data-index": index
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.iconName ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconHSize: 24,
      iconName: item.iconName,
      iconWSize: 24
    }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_5f2dee03.Label
    }, item.label))) : /*#__PURE__*/React__default["default"].createElement("a", {
      key: index,
      href: item.href,
      className: modules_5f2dee03.SubMenuItemLink,
      role: "menuitem",
      "data-isactive": item.isActive ? "true" : null,
      "aria-current": item.isActive ? "page" : null,
      "aria-haspopup": item.hasPopUp ? "true" : "false",
      "aria-expanded": item.isExpanded ? "true" : "false",
      onClick: item.onClick
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.iconName ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconHSize: 24,
      iconName: item.iconName,
      iconWSize: 24
    }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_5f2dee03.Label
    }, item.label))));
  })), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_5f2dee03.SubMenuShadow
  }));
}
SubMenu.propTypes = {
  ariaLabel: propTypes.exports.string,
  subMenuItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    label: propTypes.exports.string.isRequired,
    href: propTypes.exports.string,
    isButton: propTypes.exports.bool,
    onClick: propTypes.exports.func,
    isActive: propTypes.exports.bool,
    //WCAG
    ariaLabel: propTypes.exports.string,
    hasPopUp: propTypes.exports.bool,
    isExpanded: propTypes.exports.bool,
    //Icon
    iconName: propTypes.exports.string
  }))
};

var css$p = ".HighlightBar_module_mdsHighlightBar__0cf62aa5 {\n  width: 100%;\n  position: relative;\n  background-color: white;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul {\n  width: 100%;\n  max-width: 1920px;\n  display: block;\n  list-style-type: none;\n  padding: 0;\n  margin: 0 auto;\n  white-space: nowrap;\n  overflow-x: auto;\n  text-align: right;\n  -ms-overflow-style: none;\n  /* IE and Edge */\n  scrollbar-width: none;\n  /* Firefox */\n}\n@media only screen and (min-width: 768px) {\n  .HighlightBar_module_mdsHighlightBar__0cf62aa5 ul {\n    text-align: center;\n  }\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul::-webkit-scrollbar {\n  display: none;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 {\n  display: inline-block;\n  vertical-align: middle;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5 {\n  height: auto;\n  display: inline-block;\n  position: relative;\n  padding: 8px 24px;\n  border: 2px;\n  outline: none;\n  text-decoration: none;\n  text-align: center;\n  line-height: 100%;\n  transition: all 0.5s;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5 > span {\n  height: 34px;\n  position: relative;\n  display: flex;\n  align-self: center;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 0;\n  font-family: \"Karla\", sans-serif;\n  font-size: 18px;\n  font-weight: 700;\n  line-height: 16px;\n  text-align: center;\n  border: 0;\n  box-shadow: none;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5 > span svg {\n  margin-right: 12px;\n  fill: #2e64ad;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5 .HighlightBar_module_Label__0cf62aa5 {\n  display: inline-block;\n  color: #2e64ad;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5:focus-visible {\n  box-shadow: inset 0 0 0px 3px #0985BE;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 .HighlightBar_module_HighlightBarItemLink__0cf62aa5:focus-visible .HighlightBar_module_Label__0cf62aa5 {\n  text-decoration: underline;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 a.HighlightBar_module_HighlightBarItemLink__0cf62aa5 {\n  cursor: pointer;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5 ul li.HighlightBar_module_HighlightBarItem__0cf62aa5 a.HighlightBar_module_HighlightBarItemLink__0cf62aa5:hover {\n  text-decoration: underline;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarWhite__0cf62aa5 {\n  background-color: white;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarWhite__0cf62aa5 .HighlightBar_module_Label__0cf62aa5,\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarWhite__0cf62aa5 a {\n  color: #444F6B;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarGray__0cf62aa5 {\n  background-color: #edeef2;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarGray__0cf62aa5 .HighlightBar_module_Label__0cf62aa5,\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarGray__0cf62aa5 a {\n  color: #444F6B;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarBlueReverse__0cf62aa5 {\n  background-color: #444F6B;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarBlueReverse__0cf62aa5 .HighlightBar_module_Label__0cf62aa5,\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarBlueReverse__0cf62aa5 a {\n  color: white !important;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarBlueReverse__0cf62aa5 svg use {\n  fill: white !important;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarHertz__0cf62aa5 {\n  background-color: #ffcc00;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarHertz__0cf62aa5 .HighlightBar_module_Label__0cf62aa5,\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarHertz__0cf62aa5 a {\n  color: #191919 !important;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarHertz__0cf62aa5 svg {\n  fill: #191919 !important;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarTmobile__0cf62aa5 {\n  background-color: #E20074;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarTmobile__0cf62aa5 .HighlightBar_module_Label__0cf62aa5,\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarTmobile__0cf62aa5 a {\n  color: white !important;\n}\n.HighlightBar_module_mdsHighlightBar__0cf62aa5.HighlightBar_module_mdsHighlightBarTmobile__0cf62aa5 svg use {\n  fill: white !important;\n}";
injectCss(css$p);
var modules_28add18a = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsHighlightBar":"HighlightBar_module_mdsHighlightBar__0cf62aa5","HighlightBarItem":"HighlightBar_module_HighlightBarItem__0cf62aa5","HighlightBarItemLink":"HighlightBar_module_HighlightBarItemLink__0cf62aa5","Label":"HighlightBar_module_Label__0cf62aa5","mdsHighlightBarWhite":"HighlightBar_module_mdsHighlightBarWhite__0cf62aa5","mdsHighlightBarGray":"HighlightBar_module_mdsHighlightBarGray__0cf62aa5","mdsHighlightBarBlueReverse":"HighlightBar_module_mdsHighlightBarBlueReverse__0cf62aa5","mdsHighlightBarHertz":"HighlightBar_module_mdsHighlightBarHertz__0cf62aa5","mdsHighlightBarTmobile":"HighlightBar_module_mdsHighlightBarTmobile__0cf62aa5"};

function HighlightBar(_ref) {
  var highlightBarItems = _ref.highlightBarItems,
    highlightBarBackground = _ref.highlightBarBackground,
    IconTextColor = _ref.IconTextColor,
    theme = _ref.theme;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_28add18a.mdsHighlightBar, theme == "Gray" ? modules_28add18a.mdsHighlightBarGray : theme == "Hertz" ? modules_28add18a.mdsHighlightBarHertz : theme == "BlueReverse" ? modules_28add18a.mdsHighlightBarBlueReverse : theme == "Tmobile" ? modules_28add18a.mdsHighlightBarTmobile : modules_28add18a.mdsHighlightBarWhite].join(" "),
    style: theme ? null : {
      backgroundColor: highlightBarBackground
    }
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: modules_28add18a.mdsHighlightBarContent
  }, highlightBarItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement("li", {
      key: index,
      className: modules_28add18a.HighlightBarItem
    }, item.href ? /*#__PURE__*/React__default["default"].createElement("a", {
      href: item.href,
      className: modules_28add18a.HighlightBarItemLink,
      "aria-label": item.ariaLabel,
      tabIndex: "0"
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.hideIcon ? null : /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconHSize: 24,
      iconName: item.iconName ? item.iconName : "ui-check",
      iconWSize: 24,
      iconColor: IconTextColor || "#191919"
    }), /*#__PURE__*/React__default["default"].createElement(Span, {
      extraClass: modules_28add18a.Label,
      serif: true,
      bold: true,
      fontSize: "M",
      color: IconTextColor || "#191919"
    }, item.label))) : /*#__PURE__*/React__default["default"].createElement("span", {
      className: modules_28add18a.HighlightBarItemLink
    }, /*#__PURE__*/React__default["default"].createElement("span", null, item.hideIcon ? null : /*#__PURE__*/React__default["default"].createElement(Icon, {
      iconHSize: 24,
      iconName: item.iconName ? item.iconName : "ui-check",
      iconWSize: 24,
      iconColor: IconTextColor || "#191919"
    }), /*#__PURE__*/React__default["default"].createElement(Span, {
      extraClass: modules_28add18a.Label,
      serif: true,
      bold: true,
      fontSize: "M",
      color: IconTextColor || "#191919"
    }, item.label))));
  })));
}
HighlightBar.propTypes = {
  ariaLabel: propTypes.exports.string,
  theme: propTypes.exports.oneOf(["White", "Gray", "BlueReverse", "Hertz", "Tmobile"]),
  highlightBarBackground: propTypes.exports.string,
  IconTextColor: propTypes.exports.string,
  highlightBarItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    label: propTypes.exports.string,
    href: propTypes.exports.string,
    //WCAG
    ariaLabel: propTypes.exports.string,
    //Icon
    iconName: propTypes.exports.string,
    hideIcon: propTypes.exports.bool
  }))
};

var css$o = ".Banner_module_Banner__8707124d {\n  position: relative;\n  width: 100%;\n  background-color: #ffffff;\n  border-radius: 14px;\n  border: 1px solid #444f6b;\n  padding: 14px;\n  z-index: 1;\n  margin-bottom: 24px;\n  transition: all 0.4s ease;\n}\n.Banner_module_Banner__8707124d svg {\n  position: relative !important;\n  left: 0 !important;\n  bottom: auto !important;\n  height: auto !important;\n}\n\n.Banner_module_Title__8707124d {\n  padding-right: 44px;\n}\n\n.Banner_module_Paragraph__8707124d {\n  padding-left: 36px;\n  padding-right: 44px;\n}\n\n.Banner_module_Close__8707124d {\n  position: absolute;\n  right: 0;\n  top: 0;\n  padding: 2px 0 !important;\n}\n\n.Banner_module_Show__8707124d {\n  visibility: visible;\n  opacity: 1;\n  transform: translate(0, 0);\n}\n\n.Banner_module_Hide__8707124d {\n  visibility: hidden;\n  pointer-events: none;\n  opacity: 0;\n  transform: translate(0, -25%);\n}";
injectCss(css$o);
var modules_22e079fa = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Banner":"Banner_module_Banner__8707124d","Title":"Banner_module_Title__8707124d","Paragraph":"Banner_module_Paragraph__8707124d","Close":"Banner_module_Close__8707124d","Show":"Banner_module_Show__8707124d","Hide":"Banner_module_Hide__8707124d"};

function Banner(_ref) {
  var extraClass = _ref.extraClass,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    color = _ref.color,
    title = _ref.title,
    message = _ref.message,
    backgroundColor = _ref.backgroundColor,
    borderColor = _ref.borderColor,
    showBanner = _ref.showBanner,
    closeAction = _ref.closeAction,
    showCloseButton = _ref.showCloseButton;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_22e079fa.Banner, extraClass, showBanner ? modules_22e079fa.Show : modules_22e079fa.Hide].join(" "),
    style: {
      backgroundColor: backgroundColor,
      borderColor: borderColor
    }
  }, /*#__PURE__*/React__default["default"].createElement(Title, {
    iconName: iconName,
    iconColor: iconColor,
    color: color,
    titleSize: "BASE",
    bold: true,
    extraClass: modules_22e079fa.Title
  }, title), /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    color: color,
    extraClass: modules_22e079fa.Paragraph
  }, message), showCloseButton ? /*#__PURE__*/React__default["default"].createElement(Button, {
    action: closeAction,
    extraClass: modules_22e079fa.Close,
    style: "PLAIN",
    iconColor: iconColor,
    icon: "ICON",
    iconName: "ui-close",
    label: "close"
  }) : null);
}
Banner.propTypes = {
  extraClass: propTypes.exports.string,
  title: propTypes.exports.string,
  message: propTypes.exports.string,
  color: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  backgroundColor: propTypes.exports.string,
  borderColor: propTypes.exports.string,
  showBanner: propTypes.exports.bool,
  closeAction: propTypes.exports.func,
  showCloseButton: propTypes.exports.bool
};

var css$n = ".ReadMore_module_ReadMore__2b83d7fd {\n  position: relative;\n}\n\n.ReadMore_module_FadeCover__2b83d7fd {\n  position: absolute;\n  width: 100%;\n  bottom: 0;\n  left: 0;\n  height: 154px;\n  background: rgb(255, 255, 255);\n  background: linear-gradient(360deg, rgb(255, 255, 255) 17%, rgba(255, 255, 255, 0) 100%);\n  display: block;\n}\n\n.ReadMore_module_CloseContent__2b83d7fd {\n  overflow: hidden;\n  -webkit-transition: max-height 0.5s;\n  -moz-transition: max-height 0.5s;\n  transition: max-height 0.5s;\n  display: block;\n}\n\n.ReadMore_module_OpenContent__2b83d7fd {\n  max-height: none !important;\n  position: relative;\n  overflow: auto;\n  padding-bottom: 24px;\n  -webkit-transition: max-height 0.5s;\n  -moz-transition: max-height 0.5s;\n  transition: max-height 0.5s;\n}\n.ReadMore_module_OpenContent__2b83d7fd .ReadMore_module_FadeCover__2b83d7fd {\n  display: none;\n}\n\n.ReadMore_module_ReadMoreLink__2b83d7fd {\n  padding: 0;\n  max-width: fit-content;\n  padding: 0 !important;\n  transition: all 0.5s;\n}\n.ReadMore_module_ReadMoreLink__2b83d7fd.ReadMore_module_Open__2b83d7fd svg {\n  transform: rotate(0deg);\n}\n.ReadMore_module_ReadMoreLink__2b83d7fd.ReadMore_module_Open__2b83d7fd :hover svg {\n  transform: rotate(0deg);\n}\n.ReadMore_module_ReadMoreLink__2b83d7fd.ReadMore_module_Close__2b83d7fd svg {\n  transform: rotate(180deg);\n}\n.ReadMore_module_ReadMoreLink__2b83d7fd.ReadMore_module_Close__2b83d7fd :hover svg {\n  transform: rotate(180deg);\n}";
injectCss(css$n);
var modules_fc293334 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","ReadMore":"ReadMore_module_ReadMore__2b83d7fd","FadeCover":"ReadMore_module_FadeCover__2b83d7fd","CloseContent":"ReadMore_module_CloseContent__2b83d7fd","OpenContent":"ReadMore_module_OpenContent__2b83d7fd","ReadMoreLink":"ReadMore_module_ReadMoreLink__2b83d7fd","Open":"ReadMore_module_Open__2b83d7fd","Close":"ReadMore_module_Close__2b83d7fd"};

var ReadMore = function ReadMore(_ref) {
  var children = _ref.children,
    readMoreId = _ref.readMoreId,
    fadeColor = _ref.fadeColor,
    readMoreIntialHeight = _ref.readMoreIntialHeight;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isActive = _useState2[0],
    setIsActive = _useState2[1];
  var readMoreSetId = readMoreId;
  var contentRef = React.useRef();
  var _useState3 = React.useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    height = _useState4[0],
    setHeight = _useState4[1];
  React.useEffect(function () {
    var currentHeight = contentRef.current.clientHeight;
    setHeight(currentHeight);
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_fc293334.ReadMore].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    id: readMoreSetId,
    className: [modules_fc293334.CloseContent, isActive ? modules_fc293334.OpenContent : null].join(" "),
    "aria-hidden": isActive ? "true" : "false",
    "aria-labelledby": "title-" + readMoreSetId + "",
    role: "region",
    ref: contentRef,
    style: {
      maxHeight: height > readMoreIntialHeight ? readMoreIntialHeight + "px" : isActive ? "none" : null
    }
  }, children, height > readMoreIntialHeight ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_fc293334.FadeCover,
    style: _defineProperty({
      background: fadeColor
    }, "background", "linear-gradient(360deg,rgb(" + fadeColor + ",1) 17%, rgba(255,255,255,0) 100%)")
  }) : null), height > readMoreIntialHeight ? /*#__PURE__*/React__default["default"].createElement(ButtonLink, {
    action: function action() {
      return setIsActive(!isActive);
    },
    extraClass: [modules_fc293334.ReadMoreLink, isActive ? modules_fc293334.Open : modules_fc293334.Close].join(" "),
    icon: "ICON_RIGHT",
    iconName: "ui-arrow-short--up",
    iconActive: "ui-arrow-short--down",
    style: "PLAIN",
    iconWSize: 42,
    iconHSize: 42,
    ariaLabel: isActive ? "Read less" : "Read more",
    label: isActive ? "Read less" : "Read more",
    ariaExpanded: isActive ? "true" : "false",
    ariaControls: readMoreSetId
  }) : null);
};
var readMorePropTypes = {
  readMoreId: propTypes.exports.string,
  fadeColor: propTypes.exports.string,
  readMoreIntialHeight: propTypes.exports.number
};
ReadMore.propTypes = readMorePropTypes;

var css$m = ".IconIndicatorGroup_module_IconIndicatorWrapper__0ec6aefa {\n  display: flex;\n  flex-direction: row;\n  overflow-x: scroll;\n  padding-bottom: 24px;\n}\n\n.IconIndicatorGroup_module_Stack__0ec6aefa {\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}";
injectCss(css$m);
var modules_937c09e9 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","IconIndicatorWrapper":"IconIndicatorGroup_module_IconIndicatorWrapper__0ec6aefa","Stack":"IconIndicatorGroup_module_Stack__0ec6aefa"};

function IconIndicatorGroup(_ref) {
  var children = _ref.children,
    stack = _ref.stack;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_937c09e9.IconIndicatorWrapper, stack ? modules_937c09e9.Stack : ""].join(" ")
  }, children);
}
IconIndicatorGroup.propTypes = {
  children: propTypes.exports.node,
  stack: propTypes.exports.bool
};

var css$l = "/*g-nav.scss*/\n.MainNavigation_module_mdsNav__d4d6f84c {\n  width: 100%;\n  position: absolute;\n  top: auto;\n  right: auto;\n  bottom: 0;\n  left: 0;\n  z-index: 106;\n  padding: 0 14px 14px 14px;\n  font-size: 14px;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNav__d4d6f84c {\n    width: auto;\n    height: auto;\n    display: block;\n    max-width: 1920px;\n    right: auto;\n    bottom: auto;\n    left: 0;\n    z-index: 106;\n    position: fixed;\n    left: 0;\n    top: 14px;\n    padding: 0;\n  }\n}\n.MainNavigation_module_mdsNavContent__d4d6f84c {\n  width: 100%;\n  height: 70px;\n  max-width: 375px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-around;\n  border-top-left-radius: 54px;\n  border-top-right-radius: 54px;\n  border-bottom-right-radius: 54px;\n  border-bottom-left-radius: 54px;\n  border-radius: 50px;\n  background-color: #ffffff;\n  background-color: white;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.2), inset 1px 8px 16px rgba(223, 227, 240, 0.5607843137);\n  border: 4px solid #fff;\n  padding: 9px;\n  margin: 0 auto;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNavContent__d4d6f84c {\n    width: 60px;\n    height: auto;\n    min-height: 250px;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    padding: 32px 4px 32px 4px;\n    border-left: none;\n    border-radius: 0 48px 48px 0;\n    margin: 0;\n  }\n}\n.MainNavigation_module_mdsNavContent__d4d6f84c li {\n  min-height: 44px;\n  list-style-type: none;\n  list-style: none;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNavContent__d4d6f84c li {\n    min-width: 100%;\n    min-height: auto;\n    margin: 0 0 16px 0;\n    padding: 0;\n  }\n}\n.MainNavigation_module_mdsNavContent__d4d6f84c li:last-child {\n  margin-bottom: 0;\n}\n.MainNavigation_module_mdsNav__d4d6f84c button {\n  outline: none;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c {\n  width: auto;\n  min-width: 44px;\n  max-width: fit-content;\n  height: 44px;\n  text-align: center;\n  text-decoration: none;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n  position: relative;\n  cursor: pointer;\n  font-weight: 700;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNav_item__d4d6f84c {\n    min-width: 100%;\n    height: 100%;\n    min-height: 45px;\n    margin: 0 0 14px 0;\n    padding: 0;\n  }\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c:last-child {\n  margin-bottom: 0;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c svg {\n  width: 100%;\n  height: 28px;\n  display: block;\n  transition-property: all;\n  transition-duration: 0.2s;\n  transition-timing-function: ease-out;\n}\n.MainNavigation_module_mdsNav_itemLabel__d4d6f84c {\n  display: block;\n  font-family: \"Karla\", sans-serif;\n  font-size: 12px;\n  font-weight: 700;\n  line-height: 12px;\n  color: #444F6B;\n  text-decoration: none;\n  text-align: center;\n  -webkit-box-orient: horizontal;\n  -webkit-box-direction: normal;\n  -webkit-flex-direction: \"row\";\n  -ms-flex-direction: \"row\";\n  flex-direction: \"row\";\n  -webkit-box-pack: \"center\";\n  -ms-flex-pack: \"center\";\n  -webkit-justify-content: \"center\";\n  justify-content: \"center\";\n  -ms-flex-line-pack: \"nowrap\";\n  -webkit-align-content: \"nowrap\";\n  align-content: \"nowrap\";\n  text-transform: uppercase;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNav_itemLabel__d4d6f84c {\n    width: 100%;\n    height: auto;\n  }\n}\n.MainNavigation_module_mdsNav_item_feedbackIndicator__d4d6f84c {\n  width: 100%;\n  height: 16px;\n  position: absolute;\n  top: 6px;\n  font-size: 10px;\n  text-align: center;\n  color: white;\n  display: flex;\n  align-content: center;\n  align-items: center;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: 700;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNav_item_feedbackIndicator__d4d6f84c {\n    top: 4px;\n    height: 20px;\n  }\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-iconmenuitem=true] {\n  height: 100%;\n  min-height: auto;\n  justify-content: center;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-iconmenuitem=true] svg {\n  width: 48px;\n  height: 32px;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-iconmenuitem=true] .MainNavigation_module_mdsNav_itemLabel__d4d6f84c:not(:focus):not(:active) {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true] {\n  border-radius: 26px;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true] .MainNavigation_module_mdsNav_item_feedbackIndicator__d4d6f84c {\n  height: 100%;\n  top: -1px;\n  color: #ce0c1c;\n  font-weight: 700;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true] .MainNavigation_module_mdsNav_itemLabel__d4d6f84c {\n  display: none;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true] svg {\n  width: 44px;\n  height: 44px;\n  display: block;\n  background-color: #ce0c1c;\n  box-shadow: inset 4px -4px 12px rgba(26, 0, 0, 0.6);\n  border-radius: 26px;\n  padding-top: 0;\n  padding: 6px;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true] svg svg.MainNavigation_module_mdsIcons__d4d6f84c {\n  width: 24px;\n  height: 100%;\n  fill: #ffffff;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c[data-isactive=true]:hover svg use {\n  fill: #ffffff !important;\n}\n.MainNavigation_module_mdsNav_item_Hamburger__d4d6f84c .MainNavigation_module_mdsNav_itemLabel__d4d6f84c {\n  display: none;\n}\n.MainNavigation_module_mdsNav_item_Hamburger__d4d6f84c .MainNavigation_module_mdsNav_itemIcon__d4d6f84c {\n  width: 48px;\n  height: 48px;\n  display: block;\n}\n.MainNavigation_module_mdsNav_item_Hamburger__d4d6f84c .MainNavigation_module_mdsNav_itemIcon__d4d6f84c svg.MainNavigation_module_mdsIcons__d4d6f84c {\n  width: 32px;\n  height: 100%;\n  fill: #ffffff;\n}\n.MainNavigation_module_mdsNav_item_Hamburger__d4d6f84c.MainNavigation_module_mdsNav_item__d4d6f84c:hover .MainNavigation_module_mdsNav_itemIcon__d4d6f84c svg.MainNavigation_module_mdsIcons__d4d6f84c {\n  fill: #ffffff;\n}\n.MainNavigation_module_mdsNav_item__d4d6f84c:focus-visible {\n  border-radius: 10px;\n  outline: none;\n  box-shadow: inset 0px 0px 0px 3px #ffffff, 0px 0px 0px 3px #7f5f9c, 1px 8px 16px rgba(25, 25, 25, 0.2);\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNav_item__d4d6f84c:hover .MainNavigation_module_mdsNav_itemLabel__d4d6f84c {\n    color: #CE0C1C;\n  }\n  .MainNavigation_module_mdsNav_item__d4d6f84c:hover svg {\n    transform: scale(1.125);\n  }\n  .MainNavigation_module_mdsNav_item__d4d6f84c:hover svg use {\n    fill: #CE0C1C !important;\n  }\n}\n\n.MainNavigation_module_mdsNavWrapper__d4d6f84c {\n  pointer-events: none;\n  width: 100%;\n  height: 100%;\n  position: fixed;\n  z-index: 106;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNavWrapper__d4d6f84c {\n    width: 100%;\n    height: auto;\n    max-width: 1920px;\n    position: fixed;\n    left: 0;\n    right: 0;\n    margin: 0 auto;\n    padding-bottom: 60px;\n  }\n}\n.MainNavigation_module_mdsNavWrapper__d4d6f84c .MainNavigation_module_mdsNav__d4d6f84c {\n  pointer-events: all;\n}\n@media only screen and (min-width: 768px) {\n  .MainNavigation_module_mdsNavWrapper__d4d6f84c .MainNavigation_module_mdsNav__d4d6f84c {\n    width: 60px;\n    position: relative;\n  }\n}";
injectCss(css$l);
var modules_62b819f0 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsNav":"MainNavigation_module_mdsNav__d4d6f84c","mdsNavContent":"MainNavigation_module_mdsNavContent__d4d6f84c","mdsNav_item":"MainNavigation_module_mdsNav_item__d4d6f84c","mdsNav_itemLabel":"MainNavigation_module_mdsNav_itemLabel__d4d6f84c","mdsNav_item_feedbackIndicator":"MainNavigation_module_mdsNav_item_feedbackIndicator__d4d6f84c","mds-icons":"MainNavigation_module_mdsIcons__d4d6f84c","mdsNav_item--hamburger":"MainNavigation_module_mdsNav_item_Hamburger__d4d6f84c","mdsNav_item-label":"MainNavigation_module_mdsNav_itemLabel__d4d6f84c","mdsNav_item-icon":"MainNavigation_module_mdsNav_itemIcon__d4d6f84c","mdsNavWrapper":"MainNavigation_module_mdsNavWrapper__d4d6f84c"};

var MainNavigation = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var id = _ref.id,
    extraProps = _ref.extraProps,
    maxWidth = _ref.maxWidth,
    ariaLabel = _ref.ariaLabel,
    children = _ref.children,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement("div", _extends$4({
    id: id,
    ref: ref,
    className: [modules_62b819f0.mdsNavWrapper, extraClass].join(" "),
    style: {
      maxWidth: maxWidth + "px"
    }
  }, extraProps || {}), /*#__PURE__*/React__default["default"].createElement("nav", {
    role: "navigation",
    "aria-label": ariaLabel,
    className: modules_62b819f0.mdsNav
  }, /*#__PURE__*/React__default["default"].createElement("ul", {
    className: modules_62b819f0.mdsNavContent
  }, children)));
});
MainNavigation.propTypes = {
  ariaLabel: propTypes.exports.string,
  maxWidth: propTypes.exports.number,
  extraClass: propTypes.exports.string
};

function MainNavigationItem(_ref) {
  var itemLabel = _ref.itemLabel,
    href = _ref.href,
    isButton = _ref.isButton,
    action = _ref.action,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    target = _ref.target,
    ariaDescription = _ref.ariaDescription,
    ariaDescriptionId = _ref.ariaDescriptionId,
    hasPopUp = _ref.hasPopUp,
    iconDefault = _ref.iconDefault,
    iconActive = _ref.iconActive,
    iconMenuItem = _ref.iconMenuItem,
    feedbackIndicator = _ref.feedbackIndicator,
    feedbackIndicatorColor = _ref.feedbackIndicatorColor;
    _ref.feedbackIndicatorColorActive;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("li", null, isButton ? /*#__PURE__*/React__default["default"].createElement("button", {
    className: modules_62b819f0.mdsNav_item,
    "data-isactive": isActive ? true : null,
    "data-iconmenuitem": iconMenuItem ? true : null,
    "aria-haspopup": hasPopUp ? true : false,
    tabIndex: isActive ? '-1' : '0',
    onClick: action,
    "aria-current": isActive ? 'page' : false,
    "aria-describedby": ariaDescription ? ariaDescriptionId : null,
    disabled: isDisabled
  }, iconDefault ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: !isActive ? '#444f6b' : '#fff',
    iconHSize: 24,
    iconName: !isActive ? iconDefault : iconActive || iconDefault,
    iconWSize: 24
  }) : null, feedbackIndicator ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_62b819f0.mdsNav_item_feedbackIndicator,
    style: {
      color: feedbackIndicatorColor
    }
  }, feedbackIndicator) : null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_62b819f0.mdsNav_itemLabel
  }, itemLabel), ariaDescription ? /*#__PURE__*/React__default["default"].createElement("span", {
    id: ariaDescriptionId,
    style: {
      display: 'none'
    }
  }, ariaDescription) : null) : /*#__PURE__*/React__default["default"].createElement("a", {
    href: isDisabled ? undefined : href,
    className: modules_62b819f0.mdsNav_item,
    "data-isactive": isActive ? true : null,
    "data-iconmenuitem": iconMenuItem ? true : null,
    "aria-haspopup": hasPopUp ? true : false,
    tabIndex: isActive ? '-1' : '0',
    onClick: action,
    "aria-current": isActive ? 'page' : false,
    "aria-describedby": ariaDescription ? ariaDescriptionId : null,
    target: target
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: !isActive ? '#444f6b' : '#fff',
    iconHSize: 24,
    iconName: !isActive ? iconDefault : iconActive || iconDefault,
    iconWSize: 24
  }), feedbackIndicator ? /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_62b819f0.mdsNav_item_feedbackIndicator,
    style: {
      color: feedbackIndicatorColor
    }
  }, feedbackIndicator) : null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_62b819f0.mdsNav_itemLabel
  }, itemLabel), ariaDescription ? /*#__PURE__*/React__default["default"].createElement("span", {
    id: ariaDescriptionId,
    style: {
      display: 'none'
    }
  }, ariaDescription) : null)));
}
MainNavigationItem.propTypes = {
  itemLabel: propTypes.exports.string.isRequired,
  href: propTypes.exports.string,
  isButton: propTypes.exports.bool,
  action: propTypes.exports.func,
  isActive: propTypes.exports.bool,
  isDisabled: propTypes.exports.bool,
  target: propTypes.exports.oneOf(['_blank', '_self', '_parent', '_top']),
  //WCAG
  hasPopUp: propTypes.exports.bool,
  ariaDescription: propTypes.exports.string,
  ariaDescriptionId: propTypes.exports.string,
  //Icon
  iconDefault: propTypes.exports.string,
  iconActive: propTypes.exports.string,
  iconMenuItem: propTypes.exports.bool,
  feedbackIndicator: propTypes.exports.number,
  feedbackIndicatorColor: propTypes.exports.string,
  feedbackIndicatorColorActive: propTypes.exports.string
};
//https://www.aditus.io/aria/aria-current/

var css$k = ".MainFooter_module_mdsFooter__496bedd2 {\n  position: relative;\n  background-color: #fff;\n  min-height: 280px;\n  border-top-left-radius: 50px;\n  border-top-right-radius: 50px;\n  box-shadow: 0 -8px 16px rgba(25, 25, 25, 0.2);\n  max-width: 1920px;\n  padding: 24px 54px 24px 84px;\n  padding-bottom: 36px;\n  margin: 0 auto;\n  color: #444F6B;\n  font-size: 14px;\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 0 24px;\n  margin-top: -114px;\n  z-index: 2;\n}\n.MainFooter_module_mdsFooter__496bedd2 a:link,\n.MainFooter_module_mdsFooter__496bedd2 a:active,\n.MainFooter_module_mdsFooter__496bedd2 a:visited {\n  color: #444F6B;\n  text-decoration: underline;\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 {\n    padding: 24px;\n    padding-bottom: 100px;\n    gap: 0;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterLogo__496bedd2 {\n  padding: 0 0 14px 0;\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterLogo__496bedd2 {\n    padding: 0 0 14px 0;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 {\n  grid-column: span 7;\n}\n@media (min-width: 1366px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 {\n    grid-column: span 5;\n  }\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 {\n    grid-column: span 12;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 {\n  padding: 0 0 14px 0;\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 {\n    padding-bottom: 14px;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 ul {\n  padding: 0;\n  margin: 0;\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 0 24px;\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 ul {\n    gap: 0 14px;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 li {\n  grid-column: span 4;\n  padding: 0;\n  list-style: none;\n  list-style-type: none;\n  display: inline-block;\n}\n@media (max-width: 700px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 li {\n    grid-column: span 6;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2 {\n  background: none;\n  border: none;\n  cursor: pointer;\n  padding: 0;\n  padding-bottom: 16px;\n  font-size: 14px;\n  font-family: \"Karla\", sans-serif;\n  font-weight: 500;\n  color: #444F6B;\n  text-decoration: underline;\n  display: inline-flex;\n  align-items: flex-start;\n  text-align: left;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2 span,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2 span {\n  display: inline-block;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2 svg,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2 svg {\n  margin-right: 12px;\n  height: 100%;\n  display: inline-block;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2 svg use,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2 svg use {\n  fill: white !important;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2:hover,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2:hover {\n  text-decoration: underline;\n  color: #CE0C1C;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2:focus,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2:focus {\n  outline: none;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2:focus-visible,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2:focus-visible {\n  box-shadow: 0 0 0px 3px #0985BE;\n  color: #444F6B;\n  background-color: #fff;\n  border-radius: 24px;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 .MainFooter_module_mdsFooterLink__496bedd2:focus-visible svg use,\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterlinks__496bedd2 button.MainFooter_module_mdsFooterLink__496bedd2:focus-visible svg use {\n  fill: #444F6B !important;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterNav__496bedd2 .MainFooter_module_mdsFooterLeftContent__496bedd2 {\n  padding: 0 0 14px 0;\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterRightContent__496bedd2 {\n  width: 100%;\n  grid-column: span 5;\n}\n@media (max-width: 1024px) {\n  .MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterRightContent__496bedd2 {\n    grid-column: span 12;\n    padding-bottom: 14px;\n  }\n}\n.MainFooter_module_mdsFooter__496bedd2 .MainFooter_module_mdsFooterCopyright__496bedd2 {\n  grid-column: span 12;\n  width: 100%;\n}";
injectCss(css$k);
var modules_1ec8798f = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsFooter":"MainFooter_module_mdsFooter__496bedd2","mdsFooterLogo":"MainFooter_module_mdsFooterLogo__496bedd2","mdsFooterNav":"MainFooter_module_mdsFooterNav__496bedd2","mdsFooterlinks":"MainFooter_module_mdsFooterlinks__496bedd2","mdsFooterLink":"MainFooter_module_mdsFooterLink__496bedd2","mdsFooterLeftContent":"MainFooter_module_mdsFooterLeftContent__496bedd2","mdsFooterRightContent":"MainFooter_module_mdsFooterRightContent__496bedd2","mdsFooterCopyright":"MainFooter_module_mdsFooterCopyright__496bedd2"};

var MainFooter = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var footerLinksAriaLabel = _ref.footerLinksAriaLabel,
    id = _ref.id,
    logo = _ref.logo,
    links = _ref.links,
    leftContent = _ref.leftContent,
    rightContent = _ref.rightContent,
    copyright = _ref.copyright,
    extraProps = _ref.extraProps;
  return /*#__PURE__*/React__default["default"].createElement("footer", _extends$4({
    className: modules_1ec8798f.mdsFooter,
    id: id,
    ref: ref
  }, extraProps || {}), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_1ec8798f.mdsFooterNav
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_1ec8798f.mdsFooterLogo
  }, logo), /*#__PURE__*/React__default["default"].createElement("nav", {
    className: modules_1ec8798f.mdsFooterlinks,
    "aria-label": footerLinksAriaLabel
  }, /*#__PURE__*/React__default["default"].createElement("ul", null, links)), leftContent ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_1ec8798f.mdsFooterLeftContent
  }, leftContent) : null), rightContent ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_1ec8798f.mdsFooterRightContent
  }, rightContent) : null, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_1ec8798f.mdsFooterCopyright
  }, copyright));
});
var FooterPropTypes = {
  ariaLabel: propTypes.exports.string,
  footerLinksAriaLabel: propTypes.exports.string
};
MainFooter.propTypes = FooterPropTypes;

function FooterLink(_ref) {
  var label = _ref.label,
    href = _ref.href,
    isButton = _ref.isButton,
    action = _ref.action,
    isActive = _ref.isActive,
    isDisabled = _ref.isDisabled,
    target = _ref.target,
    ariaDescription = _ref.ariaDescription,
    ariaDescriptionId = _ref.ariaDescriptionId,
    hasPopUp = _ref.hasPopUp,
    iconDefault = _ref.iconDefault,
    iconActive = _ref.iconActive,
    iconMenuItem = _ref.iconMenuItem;
  return /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("li", null, isButton ? /*#__PURE__*/React__default["default"].createElement("button", {
    className: modules_1ec8798f.mdsFooterLink,
    "data-isactive": isActive ? true : null,
    "aria-haspopup": hasPopUp ? true : false,
    tabIndex: isActive ? '-1' : '0',
    onClick: action,
    "aria-current": isActive ? 'page' : false,
    "aria-describedby": ariaDescription ? ariaDescriptionId : null,
    disabled: isDisabled
  }, iconDefault ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: !isActive ? '#444f6b' : '#fff',
    iconHSize: 24,
    iconName: !isActive ? iconDefault : iconActive || iconDefault,
    iconWSize: 24
  }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_1ec8798f.mdsFooterLinkLabel
  }, label), ariaDescription ? /*#__PURE__*/React__default["default"].createElement("span", {
    id: ariaDescriptionId,
    style: {
      display: 'none'
    }
  }, ariaDescription) : null) : /*#__PURE__*/React__default["default"].createElement("a", {
    href: isDisabled ? undefined : href,
    className: modules_1ec8798f.mdsFooterLink,
    "data-isactive": isActive ? true : null,
    "data-iconmenuitem": iconMenuItem ? true : null,
    "aria-haspopup": hasPopUp ? true : false,
    tabIndex: isActive ? '-1' : '0',
    onClick: action,
    "aria-current": isActive ? 'page' : false,
    "aria-describedby": ariaDescription ? ariaDescriptionId : null,
    target: target
  }, iconDefault ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconColor: !isActive ? '#444f6b' : '#fff',
    iconHSize: 24,
    iconName: !isActive ? iconDefault : iconActive || iconDefault,
    iconWSize: 24
  }) : null, /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_1ec8798f.mdsFooterLinkLabel
  }, label), ariaDescription ? /*#__PURE__*/React__default["default"].createElement("span", {
    id: ariaDescriptionId,
    style: {
      display: 'none'
    }
  }, ariaDescription) : null)));
}
FooterLink.propTypes = {
  label: propTypes.exports.string.isRequired,
  href: propTypes.exports.string,
  isButton: propTypes.exports.bool,
  action: propTypes.exports.func,
  isActive: propTypes.exports.bool,
  isDisabled: propTypes.exports.bool,
  target: propTypes.exports.oneOf(['_blank', '_self', '_parent', '_top']),
  //WCAG
  hasPopUp: propTypes.exports.bool,
  ariaDescription: propTypes.exports.string,
  ariaDescriptionId: propTypes.exports.string,
  //Icon
  iconDefault: propTypes.exports.string,
  iconActive: propTypes.exports.string,
  iconMenuItem: propTypes.exports.bool
};
//https://www.aditus.io/aria/aria-current/

var css$j = ".Pagination_module_Pagination__e8352a7c {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-direction: row;\n}\n.Pagination_module_Pagination__e8352a7c label {\n  height: 0;\n  overflow: hidden;\n}\n.Pagination_module_Pagination__e8352a7c .Pagination_module_Text__e8352a7c {\n  margin: 0 0 0 8px;\n}\n\n.Pagination_module_PageSelect__e8352a7c {\n  width: 128px;\n}\n\n.Pagination_module_Disabled__e8352a7c {\n  opacity: 0.3;\n  pointer-events: none;\n}";
injectCss(css$j);
var modules_e3c5bce1 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Pagination":"Pagination_module_Pagination__e8352a7c","Text":"Pagination_module_Text__e8352a7c","PageSelect":"Pagination_module_PageSelect__e8352a7c","Disabled":"Pagination_module_Disabled__e8352a7c"};

function Pagination$1(_ref) {
  var currentPage = _ref.currentPage,
    onChange = _ref.onChange,
    totalPages = _ref.totalPages,
    scrollUserTo = _ref.scrollUserTo;
  var _useState = React.useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    anchorTarget = _useState2[0],
    setAnchorTarget = _useState2[1];
  React.useEffect(function () {
    setAnchorTarget(document.getElementById(scrollUserTo));
  }, [scrollUserTo]);
  var _useState3 = React.useState(currentPage),
    _useState4 = _slicedToArray(_useState3, 2),
    current = _useState4[0],
    setCurrentPage = _useState4[1];
  var nextPage = function nextPage(event) {
    setCurrentPage(current + 1);
    onChange(current + 1);
    event.preventDefault();
    anchorTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  var previousPage = function previousPage(event) {
    setCurrentPage(current - 1);
    onChange(current - 1);
    event.preventDefault();
    anchorTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  var selectValue = function selectValue(page) {
    setCurrentPage(Number(page));
    onChange(Number(page));
    anchorTarget.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  };
  React.useEffect(function () {
    setCurrentPage(currentPage);
  }, [currentPage]);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_e3c5bce1.Pagination
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: current == 1 ? modules_e3c5bce1.Disabled : null,
    icon: "ICON",
    iconName: "ui-arrow-tall--left",
    label: "Button Label",
    style: "PLAIN",
    action: previousPage
  }), /*#__PURE__*/React__default["default"].createElement(Select, {
    id: "PageSelect",
    extraClass: modules_e3c5bce1.PageSelect,
    name: "page select",
    label: "Page Select",
    onChange: function onChange(e) {
      return selectValue(e.target.value);
    },
    value: current
  }, Array.from(Array(totalPages)).map(function (index, page) {
    return /*#__PURE__*/React__default["default"].createElement(SelectOption, {
      key: page,
      label: page + 1,
      value: page + 1,
      name: page + 1
    });
  })), /*#__PURE__*/React__default["default"].createElement(Span, {
    extraClass: modules_e3c5bce1.Text
  }, "of"), /*#__PURE__*/React__default["default"].createElement(Span, {
    extraClass: modules_e3c5bce1.Text
  }, totalPages), /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: current == totalPages ? modules_e3c5bce1.Disabled : null,
    icon: "ICON",
    iconName: "ui-arrow-tall--right",
    label: "Button Label",
    style: "PLAIN",
    action: nextPage
  }));
}
Pagination$1.propTypes = {
  currentPage: propTypes.exports.number,
  totalPages: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  scrollUserTo: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
};

/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */
/* eslint-disable no-param-reassign */
function isObject$2(obj) {
    return (obj !== null &&
        typeof obj === 'object' &&
        'constructor' in obj &&
        obj.constructor === Object);
}
function extend$2(target = {}, src = {}) {
    Object.keys(src).forEach((key) => {
        if (typeof target[key] === 'undefined')
            target[key] = src[key];
        else if (isObject$2(src[key]) &&
            isObject$2(target[key]) &&
            Object.keys(src[key]).length > 0) {
            extend$2(target[key], src[key]);
        }
    });
}

const ssrDocument = {
    body: {},
    addEventListener() { },
    removeEventListener() { },
    activeElement: {
        blur() { },
        nodeName: '',
    },
    querySelector() {
        return null;
    },
    querySelectorAll() {
        return [];
    },
    getElementById() {
        return null;
    },
    createEvent() {
        return {
            initEvent() { },
        };
    },
    createElement() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute() { },
            getElementsByTagName() {
                return [];
            },
        };
    },
    createElementNS() {
        return {};
    },
    importNode() {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
};
function getDocument() {
    const doc = typeof document !== 'undefined' ? document : {};
    extend$2(doc, ssrDocument);
    return doc;
}

const ssrWindow = {
    document: ssrDocument,
    navigator: {
        userAgent: '',
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: '',
    },
    history: {
        replaceState() { },
        pushState() { },
        go() { },
        back() { },
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener() { },
    removeEventListener() { },
    getComputedStyle() {
        return {
            getPropertyValue() {
                return '';
            },
        };
    },
    Image() { },
    Date() { },
    screen: {},
    setTimeout() { },
    clearTimeout() { },
    matchMedia() {
        return {};
    },
    requestAnimationFrame(callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame(id) {
        if (typeof setTimeout === 'undefined') {
            return;
        }
        clearTimeout(id);
    },
};
function getWindow() {
    const win = typeof window !== 'undefined' ? window : {};
    extend$2(win, ssrWindow);
    return win;
}

/**
 * Dom7 4.0.4
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2022, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: January 11, 2022
 */

/* eslint-disable no-proto */
function makeReactive(obj) {
  const proto = obj.__proto__;
  Object.defineProperty(obj, '__proto__', {
    get() {
      return proto;
    },

    set(value) {
      proto.__proto__ = value;
    }

  });
}

class Dom7 extends Array {
  constructor(items) {
    if (typeof items === 'number') {
      super(items);
    } else {
      super(...(items || []));
      makeReactive(this);
    }
  }

}

function arrayFlat(arr = []) {
  const res = [];
  arr.forEach(el => {
    if (Array.isArray(el)) {
      res.push(...arrayFlat(el));
    } else {
      res.push(el);
    }
  });
  return res;
}
function arrayFilter(arr, callback) {
  return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
  const uniqueArray = [];

  for (let i = 0; i < arr.length; i += 1) {
    if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
  }

  return uniqueArray;
}

// eslint-disable-next-line

function qsa(selector, context) {
  if (typeof selector !== 'string') {
    return [selector];
  }

  const a = [];
  const res = context.querySelectorAll(selector);

  for (let i = 0; i < res.length; i += 1) {
    a.push(res[i]);
  }

  return a;
}

function $(selector, context) {
  const window = getWindow();
  const document = getDocument();
  let arr = [];

  if (!context && selector instanceof Dom7) {
    return selector;
  }

  if (!selector) {
    return new Dom7(arr);
  }

  if (typeof selector === 'string') {
    const html = selector.trim();

    if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
      let toCreate = 'div';
      if (html.indexOf('<li') === 0) toCreate = 'ul';
      if (html.indexOf('<tr') === 0) toCreate = 'tbody';
      if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
      if (html.indexOf('<tbody') === 0) toCreate = 'table';
      if (html.indexOf('<option') === 0) toCreate = 'select';
      const tempParent = document.createElement(toCreate);
      tempParent.innerHTML = html;

      for (let i = 0; i < tempParent.childNodes.length; i += 1) {
        arr.push(tempParent.childNodes[i]);
      }
    } else {
      arr = qsa(selector.trim(), context || document);
    } // arr = qsa(selector, document);

  } else if (selector.nodeType || selector === window || selector === document) {
    arr.push(selector);
  } else if (Array.isArray(selector)) {
    if (selector instanceof Dom7) return selector;
    arr = selector;
  }

  return new Dom7(arrayUnique(arr));
}

$.fn = Dom7.prototype;

// eslint-disable-next-line

function addClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.add(...classNames);
  });
  return this;
}

function removeClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    el.classList.remove(...classNames);
  });
  return this;
}

function toggleClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  this.forEach(el => {
    classNames.forEach(className => {
      el.classList.toggle(className);
    });
  });
}

function hasClass(...classes) {
  const classNames = arrayFlat(classes.map(c => c.split(' ')));
  return arrayFilter(this, el => {
    return classNames.filter(className => el.classList.contains(className)).length > 0;
  }).length > 0;
}

function attr(attrs, value) {
  if (arguments.length === 1 && typeof attrs === 'string') {
    // Get attr
    if (this[0]) return this[0].getAttribute(attrs);
    return undefined;
  } // Set attrs


  for (let i = 0; i < this.length; i += 1) {
    if (arguments.length === 2) {
      // String
      this[i].setAttribute(attrs, value);
    } else {
      // Object
      for (const attrName in attrs) {
        this[i][attrName] = attrs[attrName];
        this[i].setAttribute(attrName, attrs[attrName]);
      }
    }
  }

  return this;
}

function removeAttr(attr) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].removeAttribute(attr);
  }

  return this;
}

function transform(transform) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transform = transform;
  }

  return this;
}

function transition$1(duration) {
  for (let i = 0; i < this.length; i += 1) {
    this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
  }

  return this;
}

function on(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;

  function handleLiveEvent(e) {
    const target = e.target;
    if (!target) return;
    const eventData = e.target.dom7EventData || [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    if ($(target).is(targetSelector)) listener.apply(target, eventData);else {
      const parents = $(target).parents(); // eslint-disable-line

      for (let k = 0; k < parents.length; k += 1) {
        if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
      }
    }
  }

  function handleEvent(e) {
    const eventData = e && e.target ? e.target.dom7EventData || [] : [];

    if (eventData.indexOf(e) < 0) {
      eventData.unshift(e);
    }

    listener.apply(this, eventData);
  }

  const events = eventType.split(' ');
  let j;

  for (let i = 0; i < this.length; i += 1) {
    const el = this[i];

    if (!targetSelector) {
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7Listeners) el.dom7Listeners = {};
        if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
        el.dom7Listeners[event].push({
          listener,
          proxyListener: handleEvent
        });
        el.addEventListener(event, handleEvent, capture);
      }
    } else {
      // Live events
      for (j = 0; j < events.length; j += 1) {
        const event = events[j];
        if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
        if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
        el.dom7LiveListeners[event].push({
          listener,
          proxyListener: handleLiveEvent
        });
        el.addEventListener(event, handleLiveEvent, capture);
      }
    }
  }

  return this;
}

function off(...args) {
  let [eventType, targetSelector, listener, capture] = args;

  if (typeof args[1] === 'function') {
    [eventType, listener, capture] = args;
    targetSelector = undefined;
  }

  if (!capture) capture = false;
  const events = eventType.split(' ');

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];
      let handlers;

      if (!targetSelector && el.dom7Listeners) {
        handlers = el.dom7Listeners[event];
      } else if (targetSelector && el.dom7LiveListeners) {
        handlers = el.dom7LiveListeners[event];
      }

      if (handlers && handlers.length) {
        for (let k = handlers.length - 1; k >= 0; k -= 1) {
          const handler = handlers[k];

          if (listener && handler.listener === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          } else if (!listener) {
            el.removeEventListener(event, handler.proxyListener, capture);
            handlers.splice(k, 1);
          }
        }
      }
    }
  }

  return this;
}

function trigger(...args) {
  const window = getWindow();
  const events = args[0].split(' ');
  const eventData = args[1];

  for (let i = 0; i < events.length; i += 1) {
    const event = events[i];

    for (let j = 0; j < this.length; j += 1) {
      const el = this[j];

      if (window.CustomEvent) {
        const evt = new window.CustomEvent(event, {
          detail: eventData,
          bubbles: true,
          cancelable: true
        });
        el.dom7EventData = args.filter((data, dataIndex) => dataIndex > 0);
        el.dispatchEvent(evt);
        el.dom7EventData = [];
        delete el.dom7EventData;
      }
    }
  }

  return this;
}

function transitionEnd$1(callback) {
  const dom = this;

  function fireCallBack(e) {
    if (e.target !== this) return;
    callback.call(this, e);
    dom.off('transitionend', fireCallBack);
  }

  if (callback) {
    dom.on('transitionend', fireCallBack);
  }

  return this;
}

function outerWidth(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
    }

    return this[0].offsetWidth;
  }

  return null;
}

function outerHeight(includeMargins) {
  if (this.length > 0) {
    if (includeMargins) {
      const styles = this.styles();
      return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
    }

    return this[0].offsetHeight;
  }

  return null;
}

function offset() {
  if (this.length > 0) {
    const window = getWindow();
    const document = getDocument();
    const el = this[0];
    const box = el.getBoundingClientRect();
    const body = document.body;
    const clientTop = el.clientTop || body.clientTop || 0;
    const clientLeft = el.clientLeft || body.clientLeft || 0;
    const scrollTop = el === window ? window.scrollY : el.scrollTop;
    const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
    return {
      top: box.top + scrollTop - clientTop,
      left: box.left + scrollLeft - clientLeft
    };
  }

  return null;
}

function styles() {
  const window = getWindow();
  if (this[0]) return window.getComputedStyle(this[0], null);
  return {};
}

function css$i(props, value) {
  const window = getWindow();
  let i;

  if (arguments.length === 1) {
    if (typeof props === 'string') {
      // .css('width')
      if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
    } else {
      // .css({ width: '100px' })
      for (i = 0; i < this.length; i += 1) {
        for (const prop in props) {
          this[i].style[prop] = props[prop];
        }
      }

      return this;
    }
  }

  if (arguments.length === 2 && typeof props === 'string') {
    // .css('width', '100px')
    for (i = 0; i < this.length; i += 1) {
      this[i].style[props] = value;
    }

    return this;
  }

  return this;
}

function each(callback) {
  if (!callback) return this;
  this.forEach((el, index) => {
    callback.apply(el, [el, index]);
  });
  return this;
}

function filter(callback) {
  const result = arrayFilter(this, callback);
  return $(result);
}

function html(html) {
  if (typeof html === 'undefined') {
    return this[0] ? this[0].innerHTML : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].innerHTML = html;
  }

  return this;
}

function text(text) {
  if (typeof text === 'undefined') {
    return this[0] ? this[0].textContent.trim() : null;
  }

  for (let i = 0; i < this.length; i += 1) {
    this[i].textContent = text;
  }

  return this;
}

function is(selector) {
  const window = getWindow();
  const document = getDocument();
  const el = this[0];
  let compareWith;
  let i;
  if (!el || typeof selector === 'undefined') return false;

  if (typeof selector === 'string') {
    if (el.matches) return el.matches(selector);
    if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    if (el.msMatchesSelector) return el.msMatchesSelector(selector);
    compareWith = $(selector);

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  if (selector === document) {
    return el === document;
  }

  if (selector === window) {
    return el === window;
  }

  if (selector.nodeType || selector instanceof Dom7) {
    compareWith = selector.nodeType ? [selector] : selector;

    for (i = 0; i < compareWith.length; i += 1) {
      if (compareWith[i] === el) return true;
    }

    return false;
  }

  return false;
}

function index() {
  let child = this[0];
  let i;

  if (child) {
    i = 0; // eslint-disable-next-line

    while ((child = child.previousSibling) !== null) {
      if (child.nodeType === 1) i += 1;
    }

    return i;
  }

  return undefined;
}

function eq(index) {
  if (typeof index === 'undefined') return this;
  const length = this.length;

  if (index > length - 1) {
    return $([]);
  }

  if (index < 0) {
    const returnIndex = length + index;
    if (returnIndex < 0) return $([]);
    return $([this[returnIndex]]);
  }

  return $([this[index]]);
}

function append(...els) {
  let newChild;
  const document = getDocument();

  for (let k = 0; k < els.length; k += 1) {
    newChild = els[k];

    for (let i = 0; i < this.length; i += 1) {
      if (typeof newChild === 'string') {
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = newChild;

        while (tempDiv.firstChild) {
          this[i].appendChild(tempDiv.firstChild);
        }
      } else if (newChild instanceof Dom7) {
        for (let j = 0; j < newChild.length; j += 1) {
          this[i].appendChild(newChild[j]);
        }
      } else {
        this[i].appendChild(newChild);
      }
    }
  }

  return this;
}

function prepend(newChild) {
  const document = getDocument();
  let i;
  let j;

  for (i = 0; i < this.length; i += 1) {
    if (typeof newChild === 'string') {
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = newChild;

      for (j = tempDiv.childNodes.length - 1; j >= 0; j -= 1) {
        this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
      }
    } else if (newChild instanceof Dom7) {
      for (j = 0; j < newChild.length; j += 1) {
        this[i].insertBefore(newChild[j], this[i].childNodes[0]);
      }
    } else {
      this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
  }

  return this;
}

function next(selector) {
  if (this.length > 0) {
    if (selector) {
      if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) {
        return $([this[0].nextElementSibling]);
      }

      return $([]);
    }

    if (this[0].nextElementSibling) return $([this[0].nextElementSibling]);
    return $([]);
  }

  return $([]);
}

function nextAll(selector) {
  const nextEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.nextElementSibling) {
    const next = el.nextElementSibling; // eslint-disable-line

    if (selector) {
      if ($(next).is(selector)) nextEls.push(next);
    } else nextEls.push(next);

    el = next;
  }

  return $(nextEls);
}

function prev(selector) {
  if (this.length > 0) {
    const el = this[0];

    if (selector) {
      if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) {
        return $([el.previousElementSibling]);
      }

      return $([]);
    }

    if (el.previousElementSibling) return $([el.previousElementSibling]);
    return $([]);
  }

  return $([]);
}

function prevAll(selector) {
  const prevEls = [];
  let el = this[0];
  if (!el) return $([]);

  while (el.previousElementSibling) {
    const prev = el.previousElementSibling; // eslint-disable-line

    if (selector) {
      if ($(prev).is(selector)) prevEls.push(prev);
    } else prevEls.push(prev);

    el = prev;
  }

  return $(prevEls);
}

function parent(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode !== null) {
      if (selector) {
        if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
      } else {
        parents.push(this[i].parentNode);
      }
    }
  }

  return $(parents);
}

function parents(selector) {
  const parents = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    let parent = this[i].parentNode; // eslint-disable-line

    while (parent) {
      if (selector) {
        if ($(parent).is(selector)) parents.push(parent);
      } else {
        parents.push(parent);
      }

      parent = parent.parentNode;
    }
  }

  return $(parents);
}

function closest(selector) {
  let closest = this; // eslint-disable-line

  if (typeof selector === 'undefined') {
    return $([]);
  }

  if (!closest.is(selector)) {
    closest = closest.parents(selector).eq(0);
  }

  return closest;
}

function find(selector) {
  const foundElements = [];

  for (let i = 0; i < this.length; i += 1) {
    const found = this[i].querySelectorAll(selector);

    for (let j = 0; j < found.length; j += 1) {
      foundElements.push(found[j]);
    }
  }

  return $(foundElements);
}

function children(selector) {
  const children = []; // eslint-disable-line

  for (let i = 0; i < this.length; i += 1) {
    const childNodes = this[i].children;

    for (let j = 0; j < childNodes.length; j += 1) {
      if (!selector || $(childNodes[j]).is(selector)) {
        children.push(childNodes[j]);
      }
    }
  }

  return $(children);
}

function remove() {
  for (let i = 0; i < this.length; i += 1) {
    if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
  }

  return this;
}

const Methods = {
  addClass,
  removeClass,
  hasClass,
  toggleClass,
  attr,
  removeAttr,
  transform,
  transition: transition$1,
  on,
  off,
  trigger,
  transitionEnd: transitionEnd$1,
  outerWidth,
  outerHeight,
  styles,
  offset,
  css: css$i,
  each,
  html,
  text,
  is,
  index,
  eq,
  append,
  prepend,
  next,
  nextAll,
  prev,
  prevAll,
  parent,
  parents,
  closest,
  find,
  children,
  filter,
  remove
};
Object.keys(Methods).forEach(methodName => {
  Object.defineProperty($.fn, methodName, {
    value: Methods[methodName],
    writable: true
  });
});

function deleteProps(obj) {
  const object = obj;
  Object.keys(object).forEach(key => {
    try {
      object[key] = null;
    } catch (e) {// no getter for object
    }

    try {
      delete object[key];
    } catch (e) {// something got wrong
    }
  });
}

function nextTick(callback, delay = 0) {
  return setTimeout(callback, delay);
}

function now() {
  return Date.now();
}

function getComputedStyle$1(el) {
  const window = getWindow();
  let style;

  if (window.getComputedStyle) {
    style = window.getComputedStyle(el, null);
  }

  if (!style && el.currentStyle) {
    style = el.currentStyle;
  }

  if (!style) {
    style = el.style;
  }

  return style;
}

function getTranslate(el, axis = 'x') {
  const window = getWindow();
  let matrix;
  let curTransform;
  let transformMatrix;
  const curStyle = getComputedStyle$1(el);

  if (window.WebKitCSSMatrix) {
    curTransform = curStyle.transform || curStyle.webkitTransform;

    if (curTransform.split(',').length > 6) {
      curTransform = curTransform.split(', ').map(a => a.replace(',', '.')).join(', ');
    } // Some old versions of Webkit choke when 'none' is passed; pass
    // empty string instead in this case


    transformMatrix = new window.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
  } else {
    transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
    matrix = transformMatrix.toString().split(',');
  }

  if (axis === 'x') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
    else curTransform = parseFloat(matrix[4]);
  }

  if (axis === 'y') {
    // Latest Chrome and webkits Fix
    if (window.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
    else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
    else curTransform = parseFloat(matrix[5]);
  }

  return curTransform || 0;
}

function isObject$1(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function isNode(node) {
  // eslint-disable-next-line
  if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') {
    return node instanceof HTMLElement;
  }

  return node && (node.nodeType === 1 || node.nodeType === 11);
}

function extend$1(...args) {
  const to = Object(args[0]);
  const noExtend = ['__proto__', 'constructor', 'prototype'];

  for (let i = 1; i < args.length; i += 1) {
    const nextSource = args[i];

    if (nextSource !== undefined && nextSource !== null && !isNode(nextSource)) {
      const keysArray = Object.keys(Object(nextSource)).filter(key => noExtend.indexOf(key) < 0);

      for (let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1) {
        const nextKey = keysArray[nextIndex];
        const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);

        if (desc !== undefined && desc.enumerable) {
          if (isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else if (!isObject$1(to[nextKey]) && isObject$1(nextSource[nextKey])) {
            to[nextKey] = {};

            if (nextSource[nextKey].__swiper__) {
              to[nextKey] = nextSource[nextKey];
            } else {
              extend$1(to[nextKey], nextSource[nextKey]);
            }
          } else {
            to[nextKey] = nextSource[nextKey];
          }
        }
      }
    }
  }

  return to;
}

function setCSSProperty(el, varName, varValue) {
  el.style.setProperty(varName, varValue);
}

function animateCSSModeScroll({
  swiper,
  targetPosition,
  side
}) {
  const window = getWindow();
  const startPosition = -swiper.translate;
  let startTime = null;
  let time;
  const duration = swiper.params.speed;
  swiper.wrapperEl.style.scrollSnapType = 'none';
  window.cancelAnimationFrame(swiper.cssModeFrameID);
  const dir = targetPosition > startPosition ? 'next' : 'prev';

  const isOutOfBound = (current, target) => {
    return dir === 'next' && current >= target || dir === 'prev' && current <= target;
  };

  const animate = () => {
    time = new Date().getTime();

    if (startTime === null) {
      startTime = time;
    }

    const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
    const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
    let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);

    if (isOutOfBound(currentPosition, targetPosition)) {
      currentPosition = targetPosition;
    }

    swiper.wrapperEl.scrollTo({
      [side]: currentPosition
    });

    if (isOutOfBound(currentPosition, targetPosition)) {
      swiper.wrapperEl.style.overflow = 'hidden';
      swiper.wrapperEl.style.scrollSnapType = '';
      setTimeout(() => {
        swiper.wrapperEl.style.overflow = '';
        swiper.wrapperEl.scrollTo({
          [side]: currentPosition
        });
      });
      window.cancelAnimationFrame(swiper.cssModeFrameID);
      return;
    }

    swiper.cssModeFrameID = window.requestAnimationFrame(animate);
  };

  animate();
}

let support;

function calcSupport() {
  const window = getWindow();
  const document = getDocument();
  return {
    smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
    touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
    passiveListener: function checkPassiveListener() {
      let supportsPassive = false;

      try {
        const opts = Object.defineProperty({}, 'passive', {
          // eslint-disable-next-line
          get() {
            supportsPassive = true;
          }

        });
        window.addEventListener('testPassiveListener', null, opts);
      } catch (e) {// No support
      }

      return supportsPassive;
    }(),
    gestures: function checkGestures() {
      return 'ongesturestart' in window;
    }()
  };
}

function getSupport() {
  if (!support) {
    support = calcSupport();
  }

  return support;
}

let deviceCached;

function calcDevice({
  userAgent
} = {}) {
  const support = getSupport();
  const window = getWindow();
  const platform = window.navigator.platform;
  const ua = userAgent || window.navigator.userAgent;
  const device = {
    ios: false,
    android: false
  };
  const screenWidth = window.screen.width;
  const screenHeight = window.screen.height;
  const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line

  let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
  const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
  const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
  const windows = platform === 'Win32';
  let macos = platform === 'MacIntel'; // iPadOs 13 fix

  const iPadScreens = ['1024x1366', '1366x1024', '834x1194', '1194x834', '834x1112', '1112x834', '768x1024', '1024x768', '820x1180', '1180x820', '810x1080', '1080x810'];

  if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
    ipad = ua.match(/(Version)\/([\d.]+)/);
    if (!ipad) ipad = [0, 1, '13_0_0'];
    macos = false;
  } // Android


  if (android && !windows) {
    device.os = 'android';
    device.android = true;
  }

  if (ipad || iphone || ipod) {
    device.os = 'ios';
    device.ios = true;
  } // Export object


  return device;
}

function getDevice(overrides = {}) {
  if (!deviceCached) {
    deviceCached = calcDevice(overrides);
  }

  return deviceCached;
}

let browser;

function calcBrowser() {
  const window = getWindow();

  function isSafari() {
    const ua = window.navigator.userAgent.toLowerCase();
    return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
  }

  return {
    isSafari: isSafari(),
    isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
  };
}

function getBrowser() {
  if (!browser) {
    browser = calcBrowser();
  }

  return browser;
}

function Resize({
  swiper,
  on,
  emit
}) {
  const window = getWindow();
  let observer = null;
  let animationFrame = null;

  const resizeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('beforeResize');
    emit('resize');
  };

  const createObserver = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    observer = new ResizeObserver(entries => {
      animationFrame = window.requestAnimationFrame(() => {
        const {
          width,
          height
        } = swiper;
        let newWidth = width;
        let newHeight = height;
        entries.forEach(({
          contentBoxSize,
          contentRect,
          target
        }) => {
          if (target && target !== swiper.el) return;
          newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
          newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
        });

        if (newWidth !== width || newHeight !== height) {
          resizeHandler();
        }
      });
    });
    observer.observe(swiper.el);
  };

  const removeObserver = () => {
    if (animationFrame) {
      window.cancelAnimationFrame(animationFrame);
    }

    if (observer && observer.unobserve && swiper.el) {
      observer.unobserve(swiper.el);
      observer = null;
    }
  };

  const orientationChangeHandler = () => {
    if (!swiper || swiper.destroyed || !swiper.initialized) return;
    emit('orientationchange');
  };

  on('init', () => {
    if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
      createObserver();
      return;
    }

    window.addEventListener('resize', resizeHandler);
    window.addEventListener('orientationchange', orientationChangeHandler);
  });
  on('destroy', () => {
    removeObserver();
    window.removeEventListener('resize', resizeHandler);
    window.removeEventListener('orientationchange', orientationChangeHandler);
  });
}

function Observer({
  swiper,
  extendParams,
  on,
  emit
}) {
  const observers = [];
  const window = getWindow();

  const attach = (target, options = {}) => {
    const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
    const observer = new ObserverFunc(mutations => {
      // The observerUpdate event should only be triggered
      // once despite the number of mutations.  Additional
      // triggers are redundant and are very costly
      if (mutations.length === 1) {
        emit('observerUpdate', mutations[0]);
        return;
      }

      const observerUpdate = function observerUpdate() {
        emit('observerUpdate', mutations[0]);
      };

      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(observerUpdate);
      } else {
        window.setTimeout(observerUpdate, 0);
      }
    });
    observer.observe(target, {
      attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
      childList: typeof options.childList === 'undefined' ? true : options.childList,
      characterData: typeof options.characterData === 'undefined' ? true : options.characterData
    });
    observers.push(observer);
  };

  const init = () => {
    if (!swiper.params.observer) return;

    if (swiper.params.observeParents) {
      const containerParents = swiper.$el.parents();

      for (let i = 0; i < containerParents.length; i += 1) {
        attach(containerParents[i]);
      }
    } // Observe container


    attach(swiper.$el[0], {
      childList: swiper.params.observeSlideChildren
    }); // Observe wrapper

    attach(swiper.$wrapperEl[0], {
      attributes: false
    });
  };

  const destroy = () => {
    observers.forEach(observer => {
      observer.disconnect();
    });
    observers.splice(0, observers.length);
  };

  extendParams({
    observer: false,
    observeParents: false,
    observeSlideChildren: false
  });
  on('init', init);
  on('destroy', destroy);
}

/* eslint-disable no-underscore-dangle */
var eventsEmitter = {
  on(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';
    events.split(' ').forEach(event => {
      if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
      self.eventsListeners[event][method](handler);
    });
    return self;
  },

  once(events, handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;

    function onceHandler(...args) {
      self.off(events, onceHandler);

      if (onceHandler.__emitterProxy) {
        delete onceHandler.__emitterProxy;
      }

      handler.apply(self, args);
    }

    onceHandler.__emitterProxy = handler;
    return self.on(events, onceHandler, priority);
  },

  onAny(handler, priority) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (typeof handler !== 'function') return self;
    const method = priority ? 'unshift' : 'push';

    if (self.eventsAnyListeners.indexOf(handler) < 0) {
      self.eventsAnyListeners[method](handler);
    }

    return self;
  },

  offAny(handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsAnyListeners) return self;
    const index = self.eventsAnyListeners.indexOf(handler);

    if (index >= 0) {
      self.eventsAnyListeners.splice(index, 1);
    }

    return self;
  },

  off(events, handler) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    events.split(' ').forEach(event => {
      if (typeof handler === 'undefined') {
        self.eventsListeners[event] = [];
      } else if (self.eventsListeners[event]) {
        self.eventsListeners[event].forEach((eventHandler, index) => {
          if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) {
            self.eventsListeners[event].splice(index, 1);
          }
        });
      }
    });
    return self;
  },

  emit(...args) {
    const self = this;
    if (!self.eventsListeners || self.destroyed) return self;
    if (!self.eventsListeners) return self;
    let events;
    let data;
    let context;

    if (typeof args[0] === 'string' || Array.isArray(args[0])) {
      events = args[0];
      data = args.slice(1, args.length);
      context = self;
    } else {
      events = args[0].events;
      data = args[0].data;
      context = args[0].context || self;
    }

    data.unshift(context);
    const eventsArray = Array.isArray(events) ? events : events.split(' ');
    eventsArray.forEach(event => {
      if (self.eventsAnyListeners && self.eventsAnyListeners.length) {
        self.eventsAnyListeners.forEach(eventHandler => {
          eventHandler.apply(context, [event, ...data]);
        });
      }

      if (self.eventsListeners && self.eventsListeners[event]) {
        self.eventsListeners[event].forEach(eventHandler => {
          eventHandler.apply(context, data);
        });
      }
    });
    return self;
  }

};

function updateSize() {
  const swiper = this;
  let width;
  let height;
  const $el = swiper.$el;

  if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) {
    width = swiper.params.width;
  } else {
    width = $el[0].clientWidth;
  }

  if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) {
    height = swiper.params.height;
  } else {
    height = $el[0].clientHeight;
  }

  if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) {
    return;
  } // Subtract paddings


  width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
  height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
  if (Number.isNaN(width)) width = 0;
  if (Number.isNaN(height)) height = 0;
  Object.assign(swiper, {
    width,
    height,
    size: swiper.isHorizontal() ? width : height
  });
}

function updateSlides() {
  const swiper = this;

  function getDirectionLabel(property) {
    if (swiper.isHorizontal()) {
      return property;
    } // prettier-ignore


    return {
      'width': 'height',
      'margin-top': 'margin-left',
      'margin-bottom ': 'margin-right',
      'margin-left': 'margin-top',
      'margin-right': 'margin-bottom',
      'padding-left': 'padding-top',
      'padding-right': 'padding-bottom',
      'marginRight': 'marginBottom'
    }[property];
  }

  function getDirectionPropertyValue(node, label) {
    return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
  }

  const params = swiper.params;
  const {
    $wrapperEl,
    size: swiperSize,
    rtlTranslate: rtl,
    wrongRTL
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
  const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
  const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
  let snapGrid = [];
  const slidesGrid = [];
  const slidesSizesGrid = [];
  let offsetBefore = params.slidesOffsetBefore;

  if (typeof offsetBefore === 'function') {
    offsetBefore = params.slidesOffsetBefore.call(swiper);
  }

  let offsetAfter = params.slidesOffsetAfter;

  if (typeof offsetAfter === 'function') {
    offsetAfter = params.slidesOffsetAfter.call(swiper);
  }

  const previousSnapGridLength = swiper.snapGrid.length;
  const previousSlidesGridLength = swiper.slidesGrid.length;
  let spaceBetween = params.spaceBetween;
  let slidePosition = -offsetBefore;
  let prevSlideSize = 0;
  let index = 0;

  if (typeof swiperSize === 'undefined') {
    return;
  }

  if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) {
    spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
  }

  swiper.virtualSize = -spaceBetween; // reset margins

  if (rtl) slides.css({
    marginLeft: '',
    marginBottom: '',
    marginTop: ''
  });else slides.css({
    marginRight: '',
    marginBottom: '',
    marginTop: ''
  }); // reset cssMode offsets

  if (params.centeredSlides && params.cssMode) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', '');
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', '');
  }

  const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;

  if (gridEnabled) {
    swiper.grid.initSlides(slidesLength);
  } // Calc slides


  let slideSize;
  const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter(key => {
    return typeof params.breakpoints[key].slidesPerView !== 'undefined';
  }).length > 0;

  for (let i = 0; i < slidesLength; i += 1) {
    slideSize = 0;
    const slide = slides.eq(i);

    if (gridEnabled) {
      swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
    }

    if (slide.css('display') === 'none') continue; // eslint-disable-line

    if (params.slidesPerView === 'auto') {
      if (shouldResetSlideSize) {
        slides[i].style[getDirectionLabel('width')] = ``;
      }

      const slideStyles = getComputedStyle(slide[0]);
      const currentTransform = slide[0].style.transform;
      const currentWebKitTransform = slide[0].style.webkitTransform;

      if (currentTransform) {
        slide[0].style.transform = 'none';
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = 'none';
      }

      if (params.roundLengths) {
        slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
      } else {
        // eslint-disable-next-line
        const width = getDirectionPropertyValue(slideStyles, 'width');
        const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
        const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
        const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
        const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
        const boxSizing = slideStyles.getPropertyValue('box-sizing');

        if (boxSizing && boxSizing === 'border-box') {
          slideSize = width + marginLeft + marginRight;
        } else {
          const {
            clientWidth,
            offsetWidth
          } = slide[0];
          slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
        }
      }

      if (currentTransform) {
        slide[0].style.transform = currentTransform;
      }

      if (currentWebKitTransform) {
        slide[0].style.webkitTransform = currentWebKitTransform;
      }

      if (params.roundLengths) slideSize = Math.floor(slideSize);
    } else {
      slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
      if (params.roundLengths) slideSize = Math.floor(slideSize);

      if (slides[i]) {
        slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
      }
    }

    if (slides[i]) {
      slides[i].swiperSlideSize = slideSize;
    }

    slidesSizesGrid.push(slideSize);

    if (params.centeredSlides) {
      slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
      if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
      if (Math.abs(slidePosition) < 1 / 1000) slidePosition = 0;
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
    } else {
      if (params.roundLengths) slidePosition = Math.floor(slidePosition);
      if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
      slidesGrid.push(slidePosition);
      slidePosition = slidePosition + slideSize + spaceBetween;
    }

    swiper.virtualSize += slideSize + spaceBetween;
    prevSlideSize = slideSize;
    index += 1;
  }

  swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;

  if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) {
    $wrapperEl.css({
      width: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (params.setWrapperSize) {
    $wrapperEl.css({
      [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
  }

  if (gridEnabled) {
    swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
  } // Remove last grid elements depending on width


  if (!params.centeredSlides) {
    const newSlidesGrid = [];

    for (let i = 0; i < snapGrid.length; i += 1) {
      let slidesGridItem = snapGrid[i];
      if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);

      if (snapGrid[i] <= swiper.virtualSize - swiperSize) {
        newSlidesGrid.push(slidesGridItem);
      }
    }

    snapGrid = newSlidesGrid;

    if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) {
      snapGrid.push(swiper.virtualSize - swiperSize);
    }
  }

  if (snapGrid.length === 0) snapGrid = [0];

  if (params.spaceBetween !== 0) {
    const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
    slides.filter((_, slideIndex) => {
      if (!params.cssMode) return true;

      if (slideIndex === slides.length - 1) {
        return false;
      }

      return true;
    }).css({
      [key]: `${spaceBetween}px`
    });
  }

  if (params.centeredSlides && params.centeredSlidesBounds) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;
    const maxSnap = allSlidesSize - swiperSize;
    snapGrid = snapGrid.map(snap => {
      if (snap < 0) return -offsetBefore;
      if (snap > maxSnap) return maxSnap + offsetAfter;
      return snap;
    });
  }

  if (params.centerInsufficientSlides) {
    let allSlidesSize = 0;
    slidesSizesGrid.forEach(slideSizeValue => {
      allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
    });
    allSlidesSize -= params.spaceBetween;

    if (allSlidesSize < swiperSize) {
      const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
      snapGrid.forEach((snap, snapIndex) => {
        snapGrid[snapIndex] = snap - allSlidesOffset;
      });
      slidesGrid.forEach((snap, snapIndex) => {
        slidesGrid[snapIndex] = snap + allSlidesOffset;
      });
    }
  }

  Object.assign(swiper, {
    slides,
    snapGrid,
    slidesGrid,
    slidesSizesGrid
  });

  if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
    setCSSProperty(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
    const addToSnapGrid = -swiper.snapGrid[0];
    const addToSlidesGrid = -swiper.slidesGrid[0];
    swiper.snapGrid = swiper.snapGrid.map(v => v + addToSnapGrid);
    swiper.slidesGrid = swiper.slidesGrid.map(v => v + addToSlidesGrid);
  }

  if (slidesLength !== previousSlidesLength) {
    swiper.emit('slidesLengthChange');
  }

  if (snapGrid.length !== previousSnapGridLength) {
    if (swiper.params.watchOverflow) swiper.checkOverflow();
    swiper.emit('snapGridLengthChange');
  }

  if (slidesGrid.length !== previousSlidesGridLength) {
    swiper.emit('slidesGridLengthChange');
  }

  if (params.watchSlidesProgress) {
    swiper.updateSlidesOffset();
  }

  if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
    const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
    const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);

    if (slidesLength <= params.maxBackfaceHiddenSlides) {
      if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
    } else if (hasClassBackfaceClassAdded) {
      swiper.$el.removeClass(backFaceHiddenClass);
    }
  }
}

function updateAutoHeight(speed) {
  const swiper = this;
  const activeSlides = [];
  const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
  let newHeight = 0;
  let i;

  if (typeof speed === 'number') {
    swiper.setTransition(speed);
  } else if (speed === true) {
    swiper.setTransition(swiper.params.speed);
  }

  const getSlideByIndex = index => {
    if (isVirtual) {
      return swiper.slides.filter(el => parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
    }

    return swiper.slides.eq(index)[0];
  }; // Find slides currently in view


  if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
    if (swiper.params.centeredSlides) {
      (swiper.visibleSlides || $([])).each(slide => {
        activeSlides.push(slide);
      });
    } else {
      for (i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1) {
        const index = swiper.activeIndex + i;
        if (index > swiper.slides.length && !isVirtual) break;
        activeSlides.push(getSlideByIndex(index));
      }
    }
  } else {
    activeSlides.push(getSlideByIndex(swiper.activeIndex));
  } // Find new height from highest slide in view


  for (i = 0; i < activeSlides.length; i += 1) {
    if (typeof activeSlides[i] !== 'undefined') {
      const height = activeSlides[i].offsetHeight;
      newHeight = height > newHeight ? height : newHeight;
    }
  } // Update Height


  if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}

function updateSlidesOffset() {
  const swiper = this;
  const slides = swiper.slides;

  for (let i = 0; i < slides.length; i += 1) {
    slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
  }
}

function updateSlidesProgress(translate = this && this.translate || 0) {
  const swiper = this;
  const params = swiper.params;
  const {
    slides,
    rtlTranslate: rtl,
    snapGrid
  } = swiper;
  if (slides.length === 0) return;
  if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
  let offsetCenter = -translate;
  if (rtl) offsetCenter = translate; // Visible Slides

  slides.removeClass(params.slideVisibleClass);
  swiper.visibleSlidesIndexes = [];
  swiper.visibleSlides = [];

  for (let i = 0; i < slides.length; i += 1) {
    const slide = slides[i];
    let slideOffset = slide.swiperSlideOffset;

    if (params.cssMode && params.centeredSlides) {
      slideOffset -= slides[0].swiperSlideOffset;
    }

    const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
    const slideBefore = -(offsetCenter - slideOffset);
    const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
    const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;

    if (isVisible) {
      swiper.visibleSlides.push(slide);
      swiper.visibleSlidesIndexes.push(i);
      slides.eq(i).addClass(params.slideVisibleClass);
    }

    slide.progress = rtl ? -slideProgress : slideProgress;
    slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
  }

  swiper.visibleSlides = $(swiper.visibleSlides);
}

function updateProgress(translate) {
  const swiper = this;

  if (typeof translate === 'undefined') {
    const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line

    translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
  }

  const params = swiper.params;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
  let {
    progress,
    isBeginning,
    isEnd
  } = swiper;
  const wasBeginning = isBeginning;
  const wasEnd = isEnd;

  if (translatesDiff === 0) {
    progress = 0;
    isBeginning = true;
    isEnd = true;
  } else {
    progress = (translate - swiper.minTranslate()) / translatesDiff;
    isBeginning = progress <= 0;
    isEnd = progress >= 1;
  }

  Object.assign(swiper, {
    progress,
    isBeginning,
    isEnd
  });
  if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);

  if (isBeginning && !wasBeginning) {
    swiper.emit('reachBeginning toEdge');
  }

  if (isEnd && !wasEnd) {
    swiper.emit('reachEnd toEdge');
  }

  if (wasBeginning && !isBeginning || wasEnd && !isEnd) {
    swiper.emit('fromEdge');
  }

  swiper.emit('progress', progress);
}

function updateSlidesClasses() {
  const swiper = this;
  const {
    slides,
    params,
    $wrapperEl,
    activeIndex,
    realIndex
  } = swiper;
  const isVirtual = swiper.virtual && params.virtual.enabled;
  slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
  let activeSlide;

  if (isVirtual) {
    activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
  } else {
    activeSlide = slides.eq(activeIndex);
  } // Active classes


  activeSlide.addClass(params.slideActiveClass);

  if (params.loop) {
    // Duplicate to all looped slides
    if (activeSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    }
  } // Next Slide


  let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);

  if (params.loop && nextSlide.length === 0) {
    nextSlide = slides.eq(0);
    nextSlide.addClass(params.slideNextClass);
  } // Prev Slide


  let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);

  if (params.loop && prevSlide.length === 0) {
    prevSlide = slides.eq(-1);
    prevSlide.addClass(params.slidePrevClass);
  }

  if (params.loop) {
    // Duplicate to all looped slides
    if (nextSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
    }

    if (prevSlide.hasClass(params.slideDuplicateClass)) {
      $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    } else {
      $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
  }

  swiper.emitSlidesClasses();
}

function updateActiveIndex(newActiveIndex) {
  const swiper = this;
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
  const {
    slidesGrid,
    snapGrid,
    params,
    activeIndex: previousIndex,
    realIndex: previousRealIndex,
    snapIndex: previousSnapIndex
  } = swiper;
  let activeIndex = newActiveIndex;
  let snapIndex;

  if (typeof activeIndex === 'undefined') {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) {
          activeIndex = i;
        } else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) {
          activeIndex = i + 1;
        }
      } else if (translate >= slidesGrid[i]) {
        activeIndex = i;
      }
    } // Normalize slideIndex


    if (params.normalizeSlideIndex) {
      if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
    }
  }

  if (snapGrid.indexOf(translate) >= 0) {
    snapIndex = snapGrid.indexOf(translate);
  } else {
    const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
    snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
  }

  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;

  if (activeIndex === previousIndex) {
    if (snapIndex !== previousSnapIndex) {
      swiper.snapIndex = snapIndex;
      swiper.emit('snapIndexChange');
    }

    return;
  } // Get real index


  const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
  Object.assign(swiper, {
    snapIndex,
    realIndex,
    previousIndex,
    activeIndex
  });
  swiper.emit('activeIndexChange');
  swiper.emit('snapIndexChange');

  if (previousRealIndex !== realIndex) {
    swiper.emit('realIndexChange');
  }

  if (swiper.initialized || swiper.params.runCallbacksOnInit) {
    swiper.emit('slideChange');
  }
}

function updateClickedSlide(e) {
  const swiper = this;
  const params = swiper.params;
  const slide = $(e).closest(`.${params.slideClass}`)[0];
  let slideFound = false;
  let slideIndex;

  if (slide) {
    for (let i = 0; i < swiper.slides.length; i += 1) {
      if (swiper.slides[i] === slide) {
        slideFound = true;
        slideIndex = i;
        break;
      }
    }
  }

  if (slide && slideFound) {
    swiper.clickedSlide = slide;

    if (swiper.virtual && swiper.params.virtual.enabled) {
      swiper.clickedIndex = parseInt($(slide).attr('data-swiper-slide-index'), 10);
    } else {
      swiper.clickedIndex = slideIndex;
    }
  } else {
    swiper.clickedSlide = undefined;
    swiper.clickedIndex = undefined;
    return;
  }

  if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) {
    swiper.slideToClickedSlide();
  }
}

var update = {
  updateSize,
  updateSlides,
  updateAutoHeight,
  updateSlidesOffset,
  updateSlidesProgress,
  updateProgress,
  updateSlidesClasses,
  updateActiveIndex,
  updateClickedSlide
};

function getSwiperTranslate(axis = this.isHorizontal() ? 'x' : 'y') {
  const swiper = this;
  const {
    params,
    rtlTranslate: rtl,
    translate,
    $wrapperEl
  } = swiper;

  if (params.virtualTranslate) {
    return rtl ? -translate : translate;
  }

  if (params.cssMode) {
    return translate;
  }

  let currentTranslate = getTranslate($wrapperEl[0], axis);
  if (rtl) currentTranslate = -currentTranslate;
  return currentTranslate || 0;
}

function setTranslate(translate, byController) {
  const swiper = this;
  const {
    rtlTranslate: rtl,
    params,
    $wrapperEl,
    wrapperEl,
    progress
  } = swiper;
  let x = 0;
  let y = 0;
  const z = 0;

  if (swiper.isHorizontal()) {
    x = rtl ? -translate : translate;
  } else {
    y = translate;
  }

  if (params.roundLengths) {
    x = Math.floor(x);
    y = Math.floor(y);
  }

  if (params.cssMode) {
    wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
  } else if (!params.virtualTranslate) {
    $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
  }

  swiper.previousTranslate = swiper.translate;
  swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress

  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== progress) {
    swiper.updateProgress(translate);
  }

  swiper.emit('setTranslate', swiper.translate, byController);
}

function minTranslate() {
  return -this.snapGrid[0];
}

function maxTranslate() {
  return -this.snapGrid[this.snapGrid.length - 1];
}

function translateTo(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
  const swiper = this;
  const {
    params,
    wrapperEl
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return false;
  }

  const minTranslate = swiper.minTranslate();
  const maxTranslate = swiper.maxTranslate();
  let newTranslate;
  if (translateBounds && translate > minTranslate) newTranslate = minTranslate;else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;else newTranslate = translate; // Update progress

  swiper.updateProgress(newTranslate);

  if (params.cssMode) {
    const isH = swiper.isHorizontal();

    if (speed === 0) {
      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: -newTranslate,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: -newTranslate,
        behavior: 'smooth'
      });
    }

    return true;
  }

  if (speed === 0) {
    swiper.setTransition(0);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionEnd');
    }
  } else {
    swiper.setTransition(speed);
    swiper.setTranslate(newTranslate);

    if (runCallbacks) {
      swiper.emit('beforeTransitionStart', speed, internal);
      swiper.emit('transitionStart');
    }

    if (!swiper.animating) {
      swiper.animating = true;

      if (!swiper.onTranslateToWrapperTransitionEnd) {
        swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
          if (!swiper || swiper.destroyed) return;
          if (e.target !== this) return;
          swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
          swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
          swiper.onTranslateToWrapperTransitionEnd = null;
          delete swiper.onTranslateToWrapperTransitionEnd;

          if (runCallbacks) {
            swiper.emit('transitionEnd');
          }
        };
      }

      swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
      swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
    }
  }

  return true;
}

var translate = {
  getTranslate: getSwiperTranslate,
  setTranslate,
  minTranslate,
  maxTranslate,
  translateTo
};

function setTransition(duration, byController) {
  const swiper = this;

  if (!swiper.params.cssMode) {
    swiper.$wrapperEl.transition(duration);
  }

  swiper.emit('setTransition', duration, byController);
}

function transitionEmit({
  swiper,
  runCallbacks,
  direction,
  step
}) {
  const {
    activeIndex,
    previousIndex
  } = swiper;
  let dir = direction;

  if (!dir) {
    if (activeIndex > previousIndex) dir = 'next';else if (activeIndex < previousIndex) dir = 'prev';else dir = 'reset';
  }

  swiper.emit(`transition${step}`);

  if (runCallbacks && activeIndex !== previousIndex) {
    if (dir === 'reset') {
      swiper.emit(`slideResetTransition${step}`);
      return;
    }

    swiper.emit(`slideChangeTransition${step}`);

    if (dir === 'next') {
      swiper.emit(`slideNextTransition${step}`);
    } else {
      swiper.emit(`slidePrevTransition${step}`);
    }
  }
}

function transitionStart(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  if (params.cssMode) return;

  if (params.autoHeight) {
    swiper.updateAutoHeight();
  }

  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'Start'
  });
}

function transitionEnd(runCallbacks = true, direction) {
  const swiper = this;
  const {
    params
  } = swiper;
  swiper.animating = false;
  if (params.cssMode) return;
  swiper.setTransition(0);
  transitionEmit({
    swiper,
    runCallbacks,
    direction,
    step: 'End'
  });
}

var transition = {
  setTransition,
  transitionStart,
  transitionEnd
};

function slideTo(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
  if (typeof index !== 'number' && typeof index !== 'string') {
    throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
  }

  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let slideIndex = index;
  if (slideIndex < 0) slideIndex = 0;
  const {
    params,
    snapGrid,
    slidesGrid,
    previousIndex,
    activeIndex,
    rtlTranslate: rtl,
    wrapperEl,
    enabled
  } = swiper;

  if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) {
    return false;
  }

  const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
  let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
  if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
  const translate = -snapGrid[snapIndex]; // Normalize slideIndex

  if (params.normalizeSlideIndex) {
    for (let i = 0; i < slidesGrid.length; i += 1) {
      const normalizedTranslate = -Math.floor(translate * 100);
      const normalizedGrid = Math.floor(slidesGrid[i] * 100);
      const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);

      if (typeof slidesGrid[i + 1] !== 'undefined') {
        if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) {
          slideIndex = i;
        } else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) {
          slideIndex = i + 1;
        }
      } else if (normalizedTranslate >= normalizedGrid) {
        slideIndex = i;
      }
    }
  } // Directions locks


  if (swiper.initialized && slideIndex !== activeIndex) {
    if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) {
      return false;
    }

    if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
      if ((activeIndex || 0) !== slideIndex) return false;
    }
  }

  if (slideIndex !== (previousIndex || 0) && runCallbacks) {
    swiper.emit('beforeSlideChangeStart');
  } // Update progress


  swiper.updateProgress(translate);
  let direction;
  if (slideIndex > activeIndex) direction = 'next';else if (slideIndex < activeIndex) direction = 'prev';else direction = 'reset'; // Update Index

  if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
    swiper.updateActiveIndex(slideIndex); // Update Height

    if (params.autoHeight) {
      swiper.updateAutoHeight();
    }

    swiper.updateSlidesClasses();

    if (params.effect !== 'slide') {
      swiper.setTranslate(translate);
    }

    if (direction !== 'reset') {
      swiper.transitionStart(runCallbacks, direction);
      swiper.transitionEnd(runCallbacks, direction);
    }

    return false;
  }

  if (params.cssMode) {
    const isH = swiper.isHorizontal();
    const t = rtl ? translate : -translate;

    if (speed === 0) {
      const isVirtual = swiper.virtual && swiper.params.virtual.enabled;

      if (isVirtual) {
        swiper.wrapperEl.style.scrollSnapType = 'none';
        swiper._immediateVirtual = true;
      }

      wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;

      if (isVirtual) {
        requestAnimationFrame(() => {
          swiper.wrapperEl.style.scrollSnapType = '';
          swiper._swiperImmediateVirtual = false;
        });
      }
    } else {
      if (!swiper.support.smoothScroll) {
        animateCSSModeScroll({
          swiper,
          targetPosition: t,
          side: isH ? 'left' : 'top'
        });
        return true;
      }

      wrapperEl.scrollTo({
        [isH ? 'left' : 'top']: t,
        behavior: 'smooth'
      });
    }

    return true;
  }

  swiper.setTransition(speed);
  swiper.setTranslate(translate);
  swiper.updateActiveIndex(slideIndex);
  swiper.updateSlidesClasses();
  swiper.emit('beforeTransitionStart', speed, internal);
  swiper.transitionStart(runCallbacks, direction);

  if (speed === 0) {
    swiper.transitionEnd(runCallbacks, direction);
  } else if (!swiper.animating) {
    swiper.animating = true;

    if (!swiper.onSlideToWrapperTransitionEnd) {
      swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
        if (!swiper || swiper.destroyed) return;
        if (e.target !== this) return;
        swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
        swiper.onSlideToWrapperTransitionEnd = null;
        delete swiper.onSlideToWrapperTransitionEnd;
        swiper.transitionEnd(runCallbacks, direction);
      };
    }

    swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
    swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
  }

  return true;
}

function slideToLoop(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
  if (typeof index === 'string') {
    /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */
    const indexAsNumber = parseInt(index, 10);
    /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */

    const isValidNumber = isFinite(indexAsNumber);

    if (!isValidNumber) {
      throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
    } // Knowing that the converted `index` is a valid number,
    // we can update the original argument's value.


    index = indexAsNumber;
  }

  const swiper = this;
  let newIndex = index;

  if (swiper.params.loop) {
    newIndex += swiper.loopedSlides;
  }

  return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideNext(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    animating,
    enabled,
    params
  } = swiper;
  if (!enabled) return swiper;
  let perGroup = params.slidesPerGroup;

  if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
    perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
  }

  const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  if (params.rewind && swiper.isEnd) {
    return swiper.slideTo(0, speed, runCallbacks, internal);
  }

  return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slidePrev(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  const {
    params,
    animating,
    snapGrid,
    slidesGrid,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return swiper;

  if (params.loop) {
    if (animating && params.loopPreventsSlide) return false;
    swiper.loopFix(); // eslint-disable-next-line

    swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
  }

  const translate = rtlTranslate ? swiper.translate : -swiper.translate;

  function normalize(val) {
    if (val < 0) return -Math.floor(Math.abs(val));
    return Math.floor(val);
  }

  const normalizedTranslate = normalize(translate);
  const normalizedSnapGrid = snapGrid.map(val => normalize(val));
  let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];

  if (typeof prevSnap === 'undefined' && params.cssMode) {
    let prevSnapIndex;
    snapGrid.forEach((snap, snapIndex) => {
      if (normalizedTranslate >= snap) {
        // prevSnap = snap;
        prevSnapIndex = snapIndex;
      }
    });

    if (typeof prevSnapIndex !== 'undefined') {
      prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
  }

  let prevIndex = 0;

  if (typeof prevSnap !== 'undefined') {
    prevIndex = slidesGrid.indexOf(prevSnap);
    if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;

    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
      prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
      prevIndex = Math.max(prevIndex, 0);
    }
  }

  if (params.rewind && swiper.isBeginning) {
    const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
  }

  return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideReset(speed = this.params.speed, runCallbacks = true, internal) {
  const swiper = this;
  return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}

/* eslint no-unused-vars: "off" */
function slideToClosest(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
  const swiper = this;
  let index = swiper.activeIndex;
  const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
  const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
  const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;

  if (translate >= swiper.snapGrid[snapIndex]) {
    // The current translate is on or after the current snap index, so the choice
    // is between the current index and the one after it.
    const currentSnap = swiper.snapGrid[snapIndex];
    const nextSnap = swiper.snapGrid[snapIndex + 1];

    if (translate - currentSnap > (nextSnap - currentSnap) * threshold) {
      index += swiper.params.slidesPerGroup;
    }
  } else {
    // The current translate is before the current snap index, so the choice
    // is between the current index and the one before it.
    const prevSnap = swiper.snapGrid[snapIndex - 1];
    const currentSnap = swiper.snapGrid[snapIndex];

    if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) {
      index -= swiper.params.slidesPerGroup;
    }
  }

  index = Math.max(index, 0);
  index = Math.min(index, swiper.slidesGrid.length - 1);
  return swiper.slideTo(index, speed, runCallbacks, internal);
}

function slideToClickedSlide() {
  const swiper = this;
  const {
    params,
    $wrapperEl
  } = swiper;
  const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
  let slideToIndex = swiper.clickedIndex;
  let realIndex;

  if (params.loop) {
    if (swiper.animating) return;
    realIndex = parseInt($(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);

    if (params.centeredSlides) {
      if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
        swiper.loopFix();
        slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
        nextTick(() => {
          swiper.slideTo(slideToIndex);
        });
      } else {
        swiper.slideTo(slideToIndex);
      }
    } else if (slideToIndex > swiper.slides.length - slidesPerView) {
      swiper.loopFix();
      slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
      nextTick(() => {
        swiper.slideTo(slideToIndex);
      });
    } else {
      swiper.slideTo(slideToIndex);
    }
  } else {
    swiper.slideTo(slideToIndex);
  }
}

var slide = {
  slideTo,
  slideToLoop,
  slideNext,
  slidePrev,
  slideReset,
  slideToClosest,
  slideToClickedSlide
};

function loopCreate() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    $wrapperEl
  } = swiper; // Remove duplicated slides

  const $selector = $wrapperEl.children().length > 0 ? $($wrapperEl.children()[0].parentNode) : $wrapperEl;
  $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
  let slides = $selector.children(`.${params.slideClass}`);

  if (params.loopFillGroupWithBlank) {
    const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;

    if (blankSlidesNum !== params.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankNode = $(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
        $selector.append(blankNode);
      }

      slides = $selector.children(`.${params.slideClass}`);
    }
  }

  if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
  swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
  swiper.loopedSlides += params.loopAdditionalSlides;

  if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) {
    swiper.loopedSlides = slides.length;
  }

  const prependSlides = [];
  const appendSlides = [];
  slides.each((el, index) => {
    const slide = $(el);
    slide.attr('data-swiper-slide-index', index);
  });

  for (let i = 0; i < swiper.loopedSlides; i += 1) {
    const index = i - Math.floor(i / slides.length) * slides.length;
    appendSlides.push(slides.eq(index)[0]);
    prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
  }

  for (let i = 0; i < appendSlides.length; i += 1) {
    $selector.append($(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }

  for (let i = prependSlides.length - 1; i >= 0; i -= 1) {
    $selector.prepend($(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
  }
}

function loopFix() {
  const swiper = this;
  swiper.emit('beforeLoopFix');
  const {
    activeIndex,
    slides,
    loopedSlides,
    allowSlidePrev,
    allowSlideNext,
    snapGrid,
    rtlTranslate: rtl
  } = swiper;
  let newIndex;
  swiper.allowSlidePrev = true;
  swiper.allowSlideNext = true;
  const snapTranslate = -snapGrid[activeIndex];
  const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding

  if (activeIndex < loopedSlides) {
    newIndex = slides.length - loopedSlides * 3 + activeIndex;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  } else if (activeIndex >= slides.length - loopedSlides) {
    // Fix For Positive Oversliding
    newIndex = -slides.length + activeIndex + loopedSlides;
    newIndex += loopedSlides;
    const slideChanged = swiper.slideTo(newIndex, 0, false, true);

    if (slideChanged && diff !== 0) {
      swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
  }

  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;
  swiper.emit('loopFix');
}

function loopDestroy() {
  const swiper = this;
  const {
    $wrapperEl,
    params,
    slides
  } = swiper;
  $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
  slides.removeAttr('data-swiper-slide-index');
}

var loop = {
  loopCreate,
  loopFix,
  loopDestroy
};

function setGrabCursor(moving) {
  const swiper = this;
  if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
  const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
  el.style.cursor = 'move';
  el.style.cursor = moving ? 'grabbing' : 'grab';
}

function unsetGrabCursor() {
  const swiper = this;

  if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) {
    return;
  }

  swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}

var grabCursor = {
  setGrabCursor,
  unsetGrabCursor
};

function closestElement(selector, base = this) {
  function __closestFrom(el) {
    if (!el || el === getDocument() || el === getWindow()) return null;
    if (el.assignedSlot) el = el.assignedSlot;
    const found = el.closest(selector);

    if (!found && !el.getRootNode) {
      return null;
    }

    return found || __closestFrom(el.getRootNode().host);
  }

  return __closestFrom(base);
}

function onTouchStart(event) {
  const swiper = this;
  const document = getDocument();
  const window = getWindow();
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    enabled
  } = swiper;
  if (!enabled) return;

  if (swiper.animating && params.preventInteractionOnTransition) {
    return;
  }

  if (!swiper.animating && params.cssMode && params.loop) {
    swiper.loopFix();
  }

  let e = event;
  if (e.originalEvent) e = e.originalEvent;
  let $targetEl = $(e.target);

  if (params.touchEventsTarget === 'wrapper') {
    if (!$targetEl.closest(swiper.wrapperEl).length) return;
  }

  data.isTouchEvent = e.type === 'touchstart';
  if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
  if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
  if (data.isTouched && data.isMoved) return; // change target el for shadow root component

  const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line

  const eventPath = event.composedPath ? event.composedPath() : event.path;

  if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) {
    $targetEl = $(eventPath[0]);
  }

  const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
  const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element

  if (params.noSwiping && (isTargetShadow ? closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
    swiper.allowClick = true;
    return;
  }

  if (params.swipeHandler) {
    if (!$targetEl.closest(params.swipeHandler)[0]) return;
  }

  touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
  touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
  const startX = touches.currentX;
  const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore

  const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
  const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;

  if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
    if (edgeSwipeDetection === 'prevent') {
      event.preventDefault();
    } else {
      return;
    }
  }

  Object.assign(data, {
    isTouched: true,
    isMoved: false,
    allowTouchCallbacks: true,
    isScrolling: undefined,
    startMoving: undefined
  });
  touches.startX = startX;
  touches.startY = startY;
  data.touchStartTime = now();
  swiper.allowClick = true;
  swiper.updateSize();
  swiper.swipeDirection = undefined;
  if (params.threshold > 0) data.allowThresholdMove = false;

  if (e.type !== 'touchstart') {
    let preventDefault = true;

    if ($targetEl.is(data.focusableElements)) {
      preventDefault = false;

      if ($targetEl[0].nodeName === 'SELECT') {
        data.isTouched = false;
      }
    }

    if (document.activeElement && $(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) {
      document.activeElement.blur();
    }

    const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;

    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) {
      e.preventDefault();
    }
  }

  if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) {
    swiper.freeMode.onTouchStart();
  }

  swiper.emit('touchStart', e);
}

function onTouchMove(event) {
  const document = getDocument();
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (!data.isTouched) {
    if (data.startMoving && data.isScrolling) {
      swiper.emit('touchMoveOpposite', e);
    }

    return;
  }

  if (data.isTouchEvent && e.type !== 'touchmove') return;
  const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
  const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
  const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;

  if (e.preventedByNestedSwiper) {
    touches.startX = pageX;
    touches.startY = pageY;
    return;
  }

  if (!swiper.allowTouchMove) {
    if (!$(e.target).is(data.focusableElements)) {
      swiper.allowClick = false;
    }

    if (data.isTouched) {
      Object.assign(touches, {
        startX: pageX,
        startY: pageY,
        currentX: pageX,
        currentY: pageY
      });
      data.touchStartTime = now();
    }

    return;
  }

  if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
    if (swiper.isVertical()) {
      // Vertical
      if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
        data.isTouched = false;
        data.isMoved = false;
        return;
      }
    } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) {
      return;
    }
  }

  if (data.isTouchEvent && document.activeElement) {
    if (e.target === document.activeElement && $(e.target).is(data.focusableElements)) {
      data.isMoved = true;
      swiper.allowClick = false;
      return;
    }
  }

  if (data.allowTouchCallbacks) {
    swiper.emit('touchMove', e);
  }

  if (e.targetTouches && e.targetTouches.length > 1) return;
  touches.currentX = pageX;
  touches.currentY = pageY;
  const diffX = touches.currentX - touches.startX;
  const diffY = touches.currentY - touches.startY;
  if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;

  if (typeof data.isScrolling === 'undefined') {
    let touchAngle;

    if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) {
      data.isScrolling = false;
    } else {
      // eslint-disable-next-line
      if (diffX * diffX + diffY * diffY >= 25) {
        touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
        data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
      }
    }
  }

  if (data.isScrolling) {
    swiper.emit('touchMoveOpposite', e);
  }

  if (typeof data.startMoving === 'undefined') {
    if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) {
      data.startMoving = true;
    }
  }

  if (data.isScrolling) {
    data.isTouched = false;
    return;
  }

  if (!data.startMoving) {
    return;
  }

  swiper.allowClick = false;

  if (!params.cssMode && e.cancelable) {
    e.preventDefault();
  }

  if (params.touchMoveStopPropagation && !params.nested) {
    e.stopPropagation();
  }

  if (!data.isMoved) {
    if (params.loop && !params.cssMode) {
      swiper.loopFix();
    }

    data.startTranslate = swiper.getTranslate();
    swiper.setTransition(0);

    if (swiper.animating) {
      swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
    }

    data.allowMomentumBounce = false; // Grab Cursor

    if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
      swiper.setGrabCursor(true);
    }

    swiper.emit('sliderFirstMove', e);
  }

  swiper.emit('sliderMove', e);
  data.isMoved = true;
  let diff = swiper.isHorizontal() ? diffX : diffY;
  touches.diff = diff;
  diff *= params.touchRatio;
  if (rtl) diff = -diff;
  swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
  data.currentTranslate = diff + data.startTranslate;
  let disableParentSwiper = true;
  let resistanceRatio = params.resistanceRatio;

  if (params.touchReleaseOnEdges) {
    resistanceRatio = 0;
  }

  if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
  } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
    disableParentSwiper = false;
    if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
  }

  if (disableParentSwiper) {
    e.preventedByNestedSwiper = true;
  } // Directions locks


  if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) {
    data.currentTranslate = data.startTranslate;
  }

  if (!swiper.allowSlidePrev && !swiper.allowSlideNext) {
    data.currentTranslate = data.startTranslate;
  } // Threshold


  if (params.threshold > 0) {
    if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
      if (!data.allowThresholdMove) {
        data.allowThresholdMove = true;
        touches.startX = touches.currentX;
        touches.startY = touches.currentY;
        data.currentTranslate = data.startTranslate;
        touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
        return;
      }
    } else {
      data.currentTranslate = data.startTranslate;
      return;
    }
  }

  if (!params.followFinger || params.cssMode) return; // Update active index in free mode

  if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) {
    swiper.freeMode.onTouchMove();
  } // Update progress


  swiper.updateProgress(data.currentTranslate); // Update translate

  swiper.setTranslate(data.currentTranslate);
}

function onTouchEnd(event) {
  const swiper = this;
  const data = swiper.touchEventsData;
  const {
    params,
    touches,
    rtlTranslate: rtl,
    slidesGrid,
    enabled
  } = swiper;
  if (!enabled) return;
  let e = event;
  if (e.originalEvent) e = e.originalEvent;

  if (data.allowTouchCallbacks) {
    swiper.emit('touchEnd', e);
  }

  data.allowTouchCallbacks = false;

  if (!data.isTouched) {
    if (data.isMoved && params.grabCursor) {
      swiper.setGrabCursor(false);
    }

    data.isMoved = false;
    data.startMoving = false;
    return;
  } // Return Grab Cursor


  if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) {
    swiper.setGrabCursor(false);
  } // Time diff


  const touchEndTime = now();
  const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click

  if (swiper.allowClick) {
    const pathTree = e.path || e.composedPath && e.composedPath();
    swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
    swiper.emit('tap click', e);

    if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) {
      swiper.emit('doubleTap doubleClick', e);
    }
  }

  data.lastClickTime = now();
  nextTick(() => {
    if (!swiper.destroyed) swiper.allowClick = true;
  });

  if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    return;
  }

  data.isTouched = false;
  data.isMoved = false;
  data.startMoving = false;
  let currentPos;

  if (params.followFinger) {
    currentPos = rtl ? swiper.translate : -swiper.translate;
  } else {
    currentPos = -data.currentTranslate;
  }

  if (params.cssMode) {
    return;
  }

  if (swiper.params.freeMode && params.freeMode.enabled) {
    swiper.freeMode.onTouchEnd({
      currentPos
    });
    return;
  } // Find current slide


  let stopIndex = 0;
  let groupSize = swiper.slidesSizesGrid[0];

  for (let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup) {
    const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

    if (typeof slidesGrid[i + increment] !== 'undefined') {
      if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
        stopIndex = i;
        groupSize = slidesGrid[i + increment] - slidesGrid[i];
      }
    } else if (currentPos >= slidesGrid[i]) {
      stopIndex = i;
      groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
    }
  }

  let rewindFirstIndex = null;
  let rewindLastIndex = null;

  if (params.rewind) {
    if (swiper.isBeginning) {
      rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
    } else if (swiper.isEnd) {
      rewindFirstIndex = 0;
    }
  } // Find current slide size


  const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
  const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;

  if (timeDiff > params.longSwipesMs) {
    // Long touches
    if (!params.longSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (swiper.swipeDirection === 'next') {
      if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);else swiper.slideTo(stopIndex);
    }

    if (swiper.swipeDirection === 'prev') {
      if (ratio > 1 - params.longSwipesRatio) {
        swiper.slideTo(stopIndex + increment);
      } else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) {
        swiper.slideTo(rewindLastIndex);
      } else {
        swiper.slideTo(stopIndex);
      }
    }
  } else {
    // Short swipes
    if (!params.shortSwipes) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);

    if (!isNavButtonTarget) {
      if (swiper.swipeDirection === 'next') {
        swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
      }

      if (swiper.swipeDirection === 'prev') {
        swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
      }
    } else if (e.target === swiper.navigation.nextEl) {
      swiper.slideTo(stopIndex + increment);
    } else {
      swiper.slideTo(stopIndex);
    }
  }
}

function onResize() {
  const swiper = this;
  const {
    params,
    el
  } = swiper;
  if (el && el.offsetWidth === 0) return; // Breakpoints

  if (params.breakpoints) {
    swiper.setBreakpoint();
  } // Save locks


  const {
    allowSlideNext,
    allowSlidePrev,
    snapGrid
  } = swiper; // Disable locks on resize

  swiper.allowSlideNext = true;
  swiper.allowSlidePrev = true;
  swiper.updateSize();
  swiper.updateSlides();
  swiper.updateSlidesClasses();

  if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) {
    swiper.slideTo(swiper.slides.length - 1, 0, false, true);
  } else {
    swiper.slideTo(swiper.activeIndex, 0, false, true);
  }

  if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
    swiper.autoplay.run();
  } // Return locks after resize


  swiper.allowSlidePrev = allowSlidePrev;
  swiper.allowSlideNext = allowSlideNext;

  if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) {
    swiper.checkOverflow();
  }
}

function onClick(e) {
  const swiper = this;
  if (!swiper.enabled) return;

  if (!swiper.allowClick) {
    if (swiper.params.preventClicks) e.preventDefault();

    if (swiper.params.preventClicksPropagation && swiper.animating) {
      e.stopPropagation();
      e.stopImmediatePropagation();
    }
  }
}

function onScroll() {
  const swiper = this;
  const {
    wrapperEl,
    rtlTranslate,
    enabled
  } = swiper;
  if (!enabled) return;
  swiper.previousTranslate = swiper.translate;

  if (swiper.isHorizontal()) {
    swiper.translate = -wrapperEl.scrollLeft;
  } else {
    swiper.translate = -wrapperEl.scrollTop;
  } // eslint-disable-next-line


  if (swiper.translate === 0) swiper.translate = 0;
  swiper.updateActiveIndex();
  swiper.updateSlidesClasses();
  let newProgress;
  const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();

  if (translatesDiff === 0) {
    newProgress = 0;
  } else {
    newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
  }

  if (newProgress !== swiper.progress) {
    swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
  }

  swiper.emit('setTranslate', swiper.translate, false);
}

let dummyEventAttached = false;

function dummyEventListener() {}

const events = (swiper, method) => {
  const document = getDocument();
  const {
    params,
    touchEvents,
    el,
    wrapperEl,
    device,
    support
  } = swiper;
  const capture = !!params.nested;
  const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
  const swiperMethod = method; // Touch Events

  if (!support.touch) {
    el[domMethod](touchEvents.start, swiper.onTouchStart, false);
    document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
    document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
  } else {
    const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
    el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
      passive: false,
      capture
    } : capture);
    el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);

    if (touchEvents.cancel) {
      el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    }
  } // Prevent Links Clicks


  if (params.preventClicks || params.preventClicksPropagation) {
    el[domMethod]('click', swiper.onClick, true);
  }

  if (params.cssMode) {
    wrapperEl[domMethod]('scroll', swiper.onScroll);
  } // Resize handler


  if (params.updateOnWindowResize) {
    swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', onResize, true);
  } else {
    swiper[swiperMethod]('observerUpdate', onResize, true);
  }
};

function attachEvents() {
  const swiper = this;
  const document = getDocument();
  const {
    params,
    support
  } = swiper;
  swiper.onTouchStart = onTouchStart.bind(swiper);
  swiper.onTouchMove = onTouchMove.bind(swiper);
  swiper.onTouchEnd = onTouchEnd.bind(swiper);

  if (params.cssMode) {
    swiper.onScroll = onScroll.bind(swiper);
  }

  swiper.onClick = onClick.bind(swiper);

  if (support.touch && !dummyEventAttached) {
    document.addEventListener('touchstart', dummyEventListener);
    dummyEventAttached = true;
  }

  events(swiper, 'on');
}

function detachEvents() {
  const swiper = this;
  events(swiper, 'off');
}

var events$1 = {
  attachEvents,
  detachEvents
};

const isGridEnabled = (swiper, params) => {
  return swiper.grid && params.grid && params.grid.rows > 1;
};

function setBreakpoint() {
  const swiper = this;
  const {
    activeIndex,
    initialized,
    loopedSlides = 0,
    params,
    $el
  } = swiper;
  const breakpoints = params.breakpoints;
  if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters

  const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
  if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
  const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
  const breakpointParams = breakpointOnlyParams || swiper.originalParams;
  const wasMultiRow = isGridEnabled(swiper, params);
  const isMultiRow = isGridEnabled(swiper, breakpointParams);
  const wasEnabled = params.enabled;

  if (wasMultiRow && !isMultiRow) {
    $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
    swiper.emitContainerClasses();
  } else if (!wasMultiRow && isMultiRow) {
    $el.addClass(`${params.containerModifierClass}grid`);

    if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') {
      $el.addClass(`${params.containerModifierClass}grid-column`);
    }

    swiper.emitContainerClasses();
  } // Toggle navigation, pagination, scrollbar


  ['navigation', 'pagination', 'scrollbar'].forEach(prop => {
    const wasModuleEnabled = params[prop] && params[prop].enabled;
    const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;

    if (wasModuleEnabled && !isModuleEnabled) {
      swiper[prop].disable();
    }

    if (!wasModuleEnabled && isModuleEnabled) {
      swiper[prop].enable();
    }
  });
  const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
  const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);

  if (directionChanged && initialized) {
    swiper.changeDirection();
  }

  extend$1(swiper.params, breakpointParams);
  const isEnabled = swiper.params.enabled;
  Object.assign(swiper, {
    allowTouchMove: swiper.params.allowTouchMove,
    allowSlideNext: swiper.params.allowSlideNext,
    allowSlidePrev: swiper.params.allowSlidePrev
  });

  if (wasEnabled && !isEnabled) {
    swiper.disable();
  } else if (!wasEnabled && isEnabled) {
    swiper.enable();
  }

  swiper.currentBreakpoint = breakpoint;
  swiper.emit('_beforeBreakpoint', breakpointParams);

  if (needsReLoop && initialized) {
    swiper.loopDestroy();
    swiper.loopCreate();
    swiper.updateSlides();
    swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
  }

  swiper.emit('breakpoint', breakpointParams);
}

function getBreakpoint(breakpoints, base = 'window', containerEl) {
  if (!breakpoints || base === 'container' && !containerEl) return undefined;
  let breakpoint = false;
  const window = getWindow();
  const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
  const points = Object.keys(breakpoints).map(point => {
    if (typeof point === 'string' && point.indexOf('@') === 0) {
      const minRatio = parseFloat(point.substr(1));
      const value = currentHeight * minRatio;
      return {
        value,
        point
      };
    }

    return {
      value: point,
      point
    };
  });
  points.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10));

  for (let i = 0; i < points.length; i += 1) {
    const {
      point,
      value
    } = points[i];

    if (base === 'window') {
      if (window.matchMedia(`(min-width: ${value}px)`).matches) {
        breakpoint = point;
      }
    } else if (value <= containerEl.clientWidth) {
      breakpoint = point;
    }
  }

  return breakpoint || 'max';
}

var breakpoints = {
  setBreakpoint,
  getBreakpoint
};

function prepareClasses(entries, prefix) {
  const resultClasses = [];
  entries.forEach(item => {
    if (typeof item === 'object') {
      Object.keys(item).forEach(classNames => {
        if (item[classNames]) {
          resultClasses.push(prefix + classNames);
        }
      });
    } else if (typeof item === 'string') {
      resultClasses.push(prefix + item);
    }
  });
  return resultClasses;
}

function addClasses() {
  const swiper = this;
  const {
    classNames,
    params,
    rtl,
    $el,
    device,
    support
  } = swiper; // prettier-ignore

  const suffixes = prepareClasses(['initialized', params.direction, {
    'pointer-events': !support.touch
  }, {
    'free-mode': swiper.params.freeMode && params.freeMode.enabled
  }, {
    'autoheight': params.autoHeight
  }, {
    'rtl': rtl
  }, {
    'grid': params.grid && params.grid.rows > 1
  }, {
    'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
  }, {
    'android': device.android
  }, {
    'ios': device.ios
  }, {
    'css-mode': params.cssMode
  }, {
    'centered': params.cssMode && params.centeredSlides
  }, {
    'watch-progress': params.watchSlidesProgress
  }], params.containerModifierClass);
  classNames.push(...suffixes);
  $el.addClass([...classNames].join(' '));
  swiper.emitContainerClasses();
}

function removeClasses() {
  const swiper = this;
  const {
    $el,
    classNames
  } = swiper;
  $el.removeClass(classNames.join(' '));
  swiper.emitContainerClasses();
}

var classes = {
  addClasses,
  removeClasses
};

function loadImage(imageEl, src, srcset, sizes, checkForComplete, callback) {
  const window = getWindow();
  let image;

  function onReady() {
    if (callback) callback();
  }

  const isPicture = $(imageEl).parent('picture')[0];

  if (!isPicture && (!imageEl.complete || !checkForComplete)) {
    if (src) {
      image = new window.Image();
      image.onload = onReady;
      image.onerror = onReady;

      if (sizes) {
        image.sizes = sizes;
      }

      if (srcset) {
        image.srcset = srcset;
      }

      if (src) {
        image.src = src;
      }
    } else {
      onReady();
    }
  } else {
    // image already loaded...
    onReady();
  }
}

function preloadImages() {
  const swiper = this;
  swiper.imagesToLoad = swiper.$el.find('img');

  function onReady() {
    if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
    if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;

    if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
      if (swiper.params.updateOnImagesReady) swiper.update();
      swiper.emit('imagesReady');
    }
  }

  for (let i = 0; i < swiper.imagesToLoad.length; i += 1) {
    const imageEl = swiper.imagesToLoad[i];
    swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
  }
}

var images = {
  loadImage,
  preloadImages
};

function checkOverflow() {
  const swiper = this;
  const {
    isLocked: wasLocked,
    params
  } = swiper;
  const {
    slidesOffsetBefore
  } = params;

  if (slidesOffsetBefore) {
    const lastSlideIndex = swiper.slides.length - 1;
    const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
    swiper.isLocked = swiper.size > lastSlideRightEdge;
  } else {
    swiper.isLocked = swiper.snapGrid.length === 1;
  }

  if (params.allowSlideNext === true) {
    swiper.allowSlideNext = !swiper.isLocked;
  }

  if (params.allowSlidePrev === true) {
    swiper.allowSlidePrev = !swiper.isLocked;
  }

  if (wasLocked && wasLocked !== swiper.isLocked) {
    swiper.isEnd = false;
  }

  if (wasLocked !== swiper.isLocked) {
    swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
  }
}

var checkOverflow$1 = {
  checkOverflow
};

var defaults = {
  init: true,
  direction: 'horizontal',
  touchEventsTarget: 'wrapper',
  initialSlide: 0,
  speed: 300,
  cssMode: false,
  updateOnWindowResize: true,
  resizeObserver: true,
  nested: false,
  createElements: false,
  enabled: true,
  focusableElements: 'input, select, option, textarea, button, video, label',
  // Overrides
  width: null,
  height: null,
  //
  preventInteractionOnTransition: false,
  // ssr
  userAgent: null,
  url: null,
  // To support iOS's swipe-to-go-back gesture (when being used in-app).
  edgeSwipeDetection: false,
  edgeSwipeThreshold: 20,
  // Autoheight
  autoHeight: false,
  // Set wrapper width
  setWrapperSize: false,
  // Virtual Translate
  virtualTranslate: false,
  // Effects
  effect: 'slide',
  // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
  // Breakpoints
  breakpoints: undefined,
  breakpointsBase: 'window',
  // Slides grid
  spaceBetween: 0,
  slidesPerView: 1,
  slidesPerGroup: 1,
  slidesPerGroupSkip: 0,
  slidesPerGroupAuto: false,
  centeredSlides: false,
  centeredSlidesBounds: false,
  slidesOffsetBefore: 0,
  // in px
  slidesOffsetAfter: 0,
  // in px
  normalizeSlideIndex: true,
  centerInsufficientSlides: false,
  // Disable swiper and hide navigation when container not overflow
  watchOverflow: true,
  // Round length
  roundLengths: false,
  // Touches
  touchRatio: 1,
  touchAngle: 45,
  simulateTouch: true,
  shortSwipes: true,
  longSwipes: true,
  longSwipesRatio: 0.5,
  longSwipesMs: 300,
  followFinger: true,
  allowTouchMove: true,
  threshold: 0,
  touchMoveStopPropagation: false,
  touchStartPreventDefault: true,
  touchStartForcePreventDefault: false,
  touchReleaseOnEdges: false,
  // Unique Navigation Elements
  uniqueNavElements: true,
  // Resistance
  resistance: true,
  resistanceRatio: 0.85,
  // Progress
  watchSlidesProgress: false,
  // Cursor
  grabCursor: false,
  // Clicks
  preventClicks: true,
  preventClicksPropagation: true,
  slideToClickedSlide: false,
  // Images
  preloadImages: true,
  updateOnImagesReady: true,
  // loop
  loop: false,
  loopAdditionalSlides: 0,
  loopedSlides: null,
  loopedSlidesLimit: true,
  loopFillGroupWithBlank: false,
  loopPreventsSlide: true,
  // rewind
  rewind: false,
  // Swiping/no swiping
  allowSlidePrev: true,
  allowSlideNext: true,
  swipeHandler: null,
  // '.swipe-handler',
  noSwiping: true,
  noSwipingClass: 'swiper-no-swiping',
  noSwipingSelector: null,
  // Passive Listeners
  passiveListeners: true,
  maxBackfaceHiddenSlides: 10,
  // NS
  containerModifierClass: 'swiper-',
  // NEW
  slideClass: 'swiper-slide',
  slideBlankClass: 'swiper-slide-invisible-blank',
  slideActiveClass: 'swiper-slide-active',
  slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
  slideVisibleClass: 'swiper-slide-visible',
  slideDuplicateClass: 'swiper-slide-duplicate',
  slideNextClass: 'swiper-slide-next',
  slideDuplicateNextClass: 'swiper-slide-duplicate-next',
  slidePrevClass: 'swiper-slide-prev',
  slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
  wrapperClass: 'swiper-wrapper',
  // Callbacks
  runCallbacksOnInit: true,
  // Internals
  _emitClasses: false
};

function moduleExtendParams(params, allModulesParams) {
  return function extendParams(obj = {}) {
    const moduleParamName = Object.keys(obj)[0];
    const moduleParams = obj[moduleParamName];

    if (typeof moduleParams !== 'object' || moduleParams === null) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (['navigation', 'pagination', 'scrollbar'].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) {
      params[moduleParamName] = {
        auto: true
      };
    }

    if (!(moduleParamName in params && 'enabled' in moduleParams)) {
      extend$1(allModulesParams, obj);
      return;
    }

    if (params[moduleParamName] === true) {
      params[moduleParamName] = {
        enabled: true
      };
    }

    if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) {
      params[moduleParamName].enabled = true;
    }

    if (!params[moduleParamName]) params[moduleParamName] = {
      enabled: false
    };
    extend$1(allModulesParams, obj);
  };
}

/* eslint no-param-reassign: "off" */
const prototypes = {
  eventsEmitter,
  update,
  translate,
  transition,
  slide,
  loop,
  grabCursor,
  events: events$1,
  breakpoints,
  checkOverflow: checkOverflow$1,
  classes,
  images
};
const extendedDefaults = {};

class Swiper$1 {
  constructor(...args) {
    let el;
    let params;

    if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') {
      params = args[0];
    } else {
      [el, params] = args;
    }

    if (!params) params = {};
    params = extend$1({}, params);
    if (el && !params.el) params.el = el;

    if (params.el && $(params.el).length > 1) {
      const swipers = [];
      $(params.el).each(containerEl => {
        const newParams = extend$1({}, params, {
          el: containerEl
        });
        swipers.push(new Swiper$1(newParams));
      }); // eslint-disable-next-line no-constructor-return

      return swipers;
    } // Swiper Instance


    const swiper = this;
    swiper.__swiper__ = true;
    swiper.support = getSupport();
    swiper.device = getDevice({
      userAgent: params.userAgent
    });
    swiper.browser = getBrowser();
    swiper.eventsListeners = {};
    swiper.eventsAnyListeners = [];
    swiper.modules = [...swiper.__modules__];

    if (params.modules && Array.isArray(params.modules)) {
      swiper.modules.push(...params.modules);
    }

    const allModulesParams = {};
    swiper.modules.forEach(mod => {
      mod({
        swiper,
        extendParams: moduleExtendParams(params, allModulesParams),
        on: swiper.on.bind(swiper),
        once: swiper.once.bind(swiper),
        off: swiper.off.bind(swiper),
        emit: swiper.emit.bind(swiper)
      });
    }); // Extend defaults with modules params

    const swiperParams = extend$1({}, defaults, allModulesParams); // Extend defaults with passed params

    swiper.params = extend$1({}, swiperParams, extendedDefaults, params);
    swiper.originalParams = extend$1({}, swiper.params);
    swiper.passedParams = extend$1({}, params); // add event listeners

    if (swiper.params && swiper.params.on) {
      Object.keys(swiper.params.on).forEach(eventName => {
        swiper.on(eventName, swiper.params.on[eventName]);
      });
    }

    if (swiper.params && swiper.params.onAny) {
      swiper.onAny(swiper.params.onAny);
    } // Save Dom lib


    swiper.$ = $; // Extend Swiper

    Object.assign(swiper, {
      enabled: swiper.params.enabled,
      el,
      // Classes
      classNames: [],
      // Slides
      slides: $(),
      slidesGrid: [],
      snapGrid: [],
      slidesSizesGrid: [],

      // isDirection
      isHorizontal() {
        return swiper.params.direction === 'horizontal';
      },

      isVertical() {
        return swiper.params.direction === 'vertical';
      },

      // Indexes
      activeIndex: 0,
      realIndex: 0,
      //
      isBeginning: true,
      isEnd: false,
      // Props
      translate: 0,
      previousTranslate: 0,
      progress: 0,
      velocity: 0,
      animating: false,
      // Locks
      allowSlideNext: swiper.params.allowSlideNext,
      allowSlidePrev: swiper.params.allowSlidePrev,
      // Touch Events
      touchEvents: function touchEvents() {
        const touch = ['touchstart', 'touchmove', 'touchend', 'touchcancel'];
        const desktop = ['pointerdown', 'pointermove', 'pointerup'];
        swiper.touchEventsTouch = {
          start: touch[0],
          move: touch[1],
          end: touch[2],
          cancel: touch[3]
        };
        swiper.touchEventsDesktop = {
          start: desktop[0],
          move: desktop[1],
          end: desktop[2]
        };
        return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
      }(),
      touchEventsData: {
        isTouched: undefined,
        isMoved: undefined,
        allowTouchCallbacks: undefined,
        touchStartTime: undefined,
        isScrolling: undefined,
        currentTranslate: undefined,
        startTranslate: undefined,
        allowThresholdMove: undefined,
        // Form elements to match
        focusableElements: swiper.params.focusableElements,
        // Last click time
        lastClickTime: now(),
        clickTimeout: undefined,
        // Velocities
        velocities: [],
        allowMomentumBounce: undefined,
        isTouchEvent: undefined,
        startMoving: undefined
      },
      // Clicks
      allowClick: true,
      // Touches
      allowTouchMove: swiper.params.allowTouchMove,
      touches: {
        startX: 0,
        startY: 0,
        currentX: 0,
        currentY: 0,
        diff: 0
      },
      // Images
      imagesToLoad: [],
      imagesLoaded: 0
    });
    swiper.emit('_swiper'); // Init

    if (swiper.params.init) {
      swiper.init();
    } // Return app instance
    // eslint-disable-next-line no-constructor-return


    return swiper;
  }

  enable() {
    const swiper = this;
    if (swiper.enabled) return;
    swiper.enabled = true;

    if (swiper.params.grabCursor) {
      swiper.setGrabCursor();
    }

    swiper.emit('enable');
  }

  disable() {
    const swiper = this;
    if (!swiper.enabled) return;
    swiper.enabled = false;

    if (swiper.params.grabCursor) {
      swiper.unsetGrabCursor();
    }

    swiper.emit('disable');
  }

  setProgress(progress, speed) {
    const swiper = this;
    progress = Math.min(Math.max(progress, 0), 1);
    const min = swiper.minTranslate();
    const max = swiper.maxTranslate();
    const current = (max - min) * progress + min;
    swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  emitContainerClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const cls = swiper.el.className.split(' ').filter(className => {
      return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
    });
    swiper.emit('_containerClasses', cls.join(' '));
  }

  getSlideClasses(slideEl) {
    const swiper = this;
    if (swiper.destroyed) return '';
    return slideEl.className.split(' ').filter(className => {
      return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
    }).join(' ');
  }

  emitSlidesClasses() {
    const swiper = this;
    if (!swiper.params._emitClasses || !swiper.el) return;
    const updates = [];
    swiper.slides.each(slideEl => {
      const classNames = swiper.getSlideClasses(slideEl);
      updates.push({
        slideEl,
        classNames
      });
      swiper.emit('_slideClass', slideEl, classNames);
    });
    swiper.emit('_slideClasses', updates);
  }

  slidesPerViewDynamic(view = 'current', exact = false) {
    const swiper = this;
    const {
      params,
      slides,
      slidesGrid,
      slidesSizesGrid,
      size: swiperSize,
      activeIndex
    } = swiper;
    let spv = 1;

    if (params.centeredSlides) {
      let slideSize = slides[activeIndex].swiperSlideSize;
      let breakLoop;

      for (let i = activeIndex + 1; i < slides.length; i += 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }

      for (let i = activeIndex - 1; i >= 0; i -= 1) {
        if (slides[i] && !breakLoop) {
          slideSize += slides[i].swiperSlideSize;
          spv += 1;
          if (slideSize > swiperSize) breakLoop = true;
        }
      }
    } else {
      // eslint-disable-next-line
      if (view === 'current') {
        for (let i = activeIndex + 1; i < slides.length; i += 1) {
          const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      } else {
        // previous
        for (let i = activeIndex - 1; i >= 0; i -= 1) {
          const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;

          if (slideInView) {
            spv += 1;
          }
        }
      }
    }

    return spv;
  }

  update() {
    const swiper = this;
    if (!swiper || swiper.destroyed) return;
    const {
      snapGrid,
      params
    } = swiper; // Breakpoints

    if (params.breakpoints) {
      swiper.setBreakpoint();
    }

    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSlidesClasses();

    function setTranslate() {
      const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
      const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
      swiper.setTranslate(newTranslate);
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }

    let translated;

    if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
      setTranslate();

      if (swiper.params.autoHeight) {
        swiper.updateAutoHeight();
      }
    } else {
      if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) {
        translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
      } else {
        translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
      }

      if (!translated) {
        setTranslate();
      }
    }

    if (params.watchOverflow && snapGrid !== swiper.snapGrid) {
      swiper.checkOverflow();
    }

    swiper.emit('update');
  }

  changeDirection(newDirection, needUpdate = true) {
    const swiper = this;
    const currentDirection = swiper.params.direction;

    if (!newDirection) {
      // eslint-disable-next-line
      newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
    }

    if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') {
      return swiper;
    }

    swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
    swiper.emitContainerClasses();
    swiper.params.direction = newDirection;
    swiper.slides.each(slideEl => {
      if (newDirection === 'vertical') {
        slideEl.style.width = '';
      } else {
        slideEl.style.height = '';
      }
    });
    swiper.emit('changeDirection');
    if (needUpdate) swiper.update();
    return swiper;
  }

  changeLanguageDirection(direction) {
    const swiper = this;
    if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
    swiper.rtl = direction === 'rtl';
    swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;

    if (swiper.rtl) {
      swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'rtl';
    } else {
      swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
      swiper.el.dir = 'ltr';
    }

    swiper.update();
  }

  mount(el) {
    const swiper = this;
    if (swiper.mounted) return true; // Find el

    const $el = $(el || swiper.params.el);
    el = $el[0];

    if (!el) {
      return false;
    }

    el.swiper = swiper;

    const getWrapperSelector = () => {
      return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
    };

    const getWrapper = () => {
      if (el && el.shadowRoot && el.shadowRoot.querySelector) {
        const res = $(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items

        res.children = options => $el.children(options);

        return res;
      }

      if (!$el.children) {
        return $($el).children(getWrapperSelector());
      }

      return $el.children(getWrapperSelector());
    }; // Find Wrapper


    let $wrapperEl = getWrapper();

    if ($wrapperEl.length === 0 && swiper.params.createElements) {
      const document = getDocument();
      const wrapper = document.createElement('div');
      $wrapperEl = $(wrapper);
      wrapper.className = swiper.params.wrapperClass;
      $el.append(wrapper);
      $el.children(`.${swiper.params.slideClass}`).each(slideEl => {
        $wrapperEl.append(slideEl);
      });
    }

    Object.assign(swiper, {
      $el,
      el,
      $wrapperEl,
      wrapperEl: $wrapperEl[0],
      mounted: true,
      // RTL
      rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
      rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
      wrongRTL: $wrapperEl.css('display') === '-webkit-box'
    });
    return true;
  }

  init(el) {
    const swiper = this;
    if (swiper.initialized) return swiper;
    const mounted = swiper.mount(el);
    if (mounted === false) return swiper;
    swiper.emit('beforeInit'); // Set breakpoint

    if (swiper.params.breakpoints) {
      swiper.setBreakpoint();
    } // Add Classes


    swiper.addClasses(); // Create loop

    if (swiper.params.loop) {
      swiper.loopCreate();
    } // Update size


    swiper.updateSize(); // Update slides

    swiper.updateSlides();

    if (swiper.params.watchOverflow) {
      swiper.checkOverflow();
    } // Set Grab Cursor


    if (swiper.params.grabCursor && swiper.enabled) {
      swiper.setGrabCursor();
    }

    if (swiper.params.preloadImages) {
      swiper.preloadImages();
    } // Slide To Initial Slide


    if (swiper.params.loop) {
      swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
    } else {
      swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
    } // Attach events


    swiper.attachEvents(); // Init Flag

    swiper.initialized = true; // Emit

    swiper.emit('init');
    swiper.emit('afterInit');
    return swiper;
  }

  destroy(deleteInstance = true, cleanStyles = true) {
    const swiper = this;
    const {
      params,
      $el,
      $wrapperEl,
      slides
    } = swiper;

    if (typeof swiper.params === 'undefined' || swiper.destroyed) {
      return null;
    }

    swiper.emit('beforeDestroy'); // Init Flag

    swiper.initialized = false; // Detach events

    swiper.detachEvents(); // Destroy loop

    if (params.loop) {
      swiper.loopDestroy();
    } // Cleanup styles


    if (cleanStyles) {
      swiper.removeClasses();
      $el.removeAttr('style');
      $wrapperEl.removeAttr('style');

      if (slides && slides.length) {
        slides.removeClass([params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
      }
    }

    swiper.emit('destroy'); // Detach emitter events

    Object.keys(swiper.eventsListeners).forEach(eventName => {
      swiper.off(eventName);
    });

    if (deleteInstance !== false) {
      swiper.$el[0].swiper = null;
      deleteProps(swiper);
    }

    swiper.destroyed = true;
    return null;
  }

  static extendDefaults(newDefaults) {
    extend$1(extendedDefaults, newDefaults);
  }

  static get extendedDefaults() {
    return extendedDefaults;
  }

  static get defaults() {
    return defaults;
  }

  static installModule(mod) {
    if (!Swiper$1.prototype.__modules__) Swiper$1.prototype.__modules__ = [];
    const modules = Swiper$1.prototype.__modules__;

    if (typeof mod === 'function' && modules.indexOf(mod) < 0) {
      modules.push(mod);
    }
  }

  static use(module) {
    if (Array.isArray(module)) {
      module.forEach(m => Swiper$1.installModule(m));
      return Swiper$1;
    }

    Swiper$1.installModule(module);
    return Swiper$1;
  }

}

Object.keys(prototypes).forEach(prototypeGroup => {
  Object.keys(prototypes[prototypeGroup]).forEach(protoMethod => {
    Swiper$1.prototype[protoMethod] = prototypes[prototypeGroup][protoMethod];
  });
});
Swiper$1.use([Resize, Observer]);

/* eslint-disable consistent-return */
function Keyboard({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  const window = getWindow();
  swiper.keyboard = {
    enabled: false
  };
  extendParams({
    keyboard: {
      enabled: false,
      onlyInViewport: true,
      pageUpDown: true
    }
  });

  function handle(event) {
    if (!swiper.enabled) return;
    const {
      rtlTranslate: rtl
    } = swiper;
    let e = event;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    const kc = e.keyCode || e.charCode;
    const pageUpDown = swiper.params.keyboard.pageUpDown;
    const isPageUp = pageUpDown && kc === 33;
    const isPageDown = pageUpDown && kc === 34;
    const isArrowLeft = kc === 37;
    const isArrowRight = kc === 39;
    const isArrowUp = kc === 38;
    const isArrowDown = kc === 40; // Directions locks

    if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) {
      return false;
    }

    if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) {
      return false;
    }

    if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) {
      return undefined;
    }

    if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) {
      return undefined;
    }

    if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
      let inView = false; // Check that swiper should be inside of visible area of window

      if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) {
        return undefined;
      }

      const $el = swiper.$el;
      const swiperWidth = $el[0].clientWidth;
      const swiperHeight = $el[0].clientHeight;
      const windowWidth = window.innerWidth;
      const windowHeight = window.innerHeight;
      const swiperOffset = swiper.$el.offset();
      if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
      const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiperWidth, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiperHeight], [swiperOffset.left + swiperWidth, swiperOffset.top + swiperHeight]];

      for (let i = 0; i < swiperCoord.length; i += 1) {
        const point = swiperCoord[i];

        if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
          if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

          inView = true;
        }
      }

      if (!inView) return undefined;
    }

    if (swiper.isHorizontal()) {
      if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
      if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
    } else {
      if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
        if (e.preventDefault) e.preventDefault();else e.returnValue = false;
      }

      if (isPageDown || isArrowDown) swiper.slideNext();
      if (isPageUp || isArrowUp) swiper.slidePrev();
    }

    emit('keyPress', kc);
    return undefined;
  }

  function enable() {
    if (swiper.keyboard.enabled) return;
    $(document).on('keydown', handle);
    swiper.keyboard.enabled = true;
  }

  function disable() {
    if (!swiper.keyboard.enabled) return;
    $(document).off('keydown', handle);
    swiper.keyboard.enabled = false;
  }

  on('init', () => {
    if (swiper.params.keyboard.enabled) {
      enable();
    }
  });
  on('destroy', () => {
    if (swiper.keyboard.enabled) {
      disable();
    }
  });
  Object.assign(swiper.keyboard, {
    enable,
    disable
  });
}

/* eslint-disable consistent-return */
function Mousewheel({
  swiper,
  extendParams,
  on,
  emit
}) {
  const window = getWindow();
  extendParams({
    mousewheel: {
      enabled: false,
      releaseOnEdges: false,
      invert: false,
      forceToAxis: false,
      sensitivity: 1,
      eventsTarget: 'container',
      thresholdDelta: null,
      thresholdTime: null
    }
  });
  swiper.mousewheel = {
    enabled: false
  };
  let timeout;
  let lastScrollTime = now();
  let lastEventBeforeSnap;
  const recentWheelEvents = [];

  function normalize(e) {
    // Reasonable defaults
    const PIXEL_STEP = 10;
    const LINE_HEIGHT = 40;
    const PAGE_HEIGHT = 800;
    let sX = 0;
    let sY = 0; // spinX, spinY

    let pX = 0;
    let pY = 0; // pixelX, pixelY
    // Legacy

    if ('detail' in e) {
      sY = e.detail;
    }

    if ('wheelDelta' in e) {
      sY = -e.wheelDelta / 120;
    }

    if ('wheelDeltaY' in e) {
      sY = -e.wheelDeltaY / 120;
    }

    if ('wheelDeltaX' in e) {
      sX = -e.wheelDeltaX / 120;
    } // side scrolling on FF with DOMMouseScroll


    if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
      sX = sY;
      sY = 0;
    }

    pX = sX * PIXEL_STEP;
    pY = sY * PIXEL_STEP;

    if ('deltaY' in e) {
      pY = e.deltaY;
    }

    if ('deltaX' in e) {
      pX = e.deltaX;
    }

    if (e.shiftKey && !pX) {
      // if user scrolls with shift he wants horizontal scroll
      pX = pY;
      pY = 0;
    }

    if ((pX || pY) && e.deltaMode) {
      if (e.deltaMode === 1) {
        // delta in LINE units
        pX *= LINE_HEIGHT;
        pY *= LINE_HEIGHT;
      } else {
        // delta in PAGE units
        pX *= PAGE_HEIGHT;
        pY *= PAGE_HEIGHT;
      }
    } // Fall-back if spin cannot be determined


    if (pX && !sX) {
      sX = pX < 1 ? -1 : 1;
    }

    if (pY && !sY) {
      sY = pY < 1 ? -1 : 1;
    }

    return {
      spinX: sX,
      spinY: sY,
      pixelX: pX,
      pixelY: pY
    };
  }

  function handleMouseEnter() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = true;
  }

  function handleMouseLeave() {
    if (!swiper.enabled) return;
    swiper.mouseEntered = false;
  }

  function animateSlider(newEvent) {
    if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) {
      // Prevent if delta of wheel scroll delta is below configured threshold
      return false;
    }

    if (swiper.params.mousewheel.thresholdTime && now() - lastScrollTime < swiper.params.mousewheel.thresholdTime) {
      // Prevent if time between scrolls is below configured threshold
      return false;
    } // If the movement is NOT big enough and
    // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
    //   Don't go any further (avoid insignificant scroll movement).


    if (newEvent.delta >= 6 && now() - lastScrollTime < 60) {
      // Return false as a default
      return true;
    } // If user is scrolling towards the end:
    //   If the slider hasn't hit the latest slide or
    //   if the slider is a loop and
    //   if the slider isn't moving right now:
    //     Go to next slide and
    //     emit a scroll event.
    // Else (the user is scrolling towards the beginning) and
    // if the slider hasn't hit the first slide or
    // if the slider is a loop and
    // if the slider isn't moving right now:
    //   Go to prev slide and
    //   emit a scroll event.


    if (newEvent.direction < 0) {
      if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
        swiper.slideNext();
        emit('scroll', newEvent.raw);
      }
    } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
      swiper.slidePrev();
      emit('scroll', newEvent.raw);
    } // If you got here is because an animation has been triggered so store the current time


    lastScrollTime = new window.Date().getTime(); // Return false as a default

    return false;
  }

  function releaseScroll(newEvent) {
    const params = swiper.params.mousewheel;

    if (newEvent.direction < 0) {
      if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) {
        // Return true to animate scroll on edges
        return true;
      }
    } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) {
      // Return true to animate scroll on edges
      return true;
    }

    return false;
  }

  function handle(event) {
    let e = event;
    let disableParentSwiper = true;
    if (!swiper.enabled) return;
    const params = swiper.params.mousewheel;

    if (swiper.params.cssMode) {
      e.preventDefault();
    }

    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
    if (e.originalEvent) e = e.originalEvent; // jquery fix

    let delta = 0;
    const rtlFactor = swiper.rtlTranslate ? -1 : 1;
    const data = normalize(e);

    if (params.forceToAxis) {
      if (swiper.isHorizontal()) {
        if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;else return true;
      } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;else return true;
    } else {
      delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
    }

    if (delta === 0) return true;
    if (params.invert) delta = -delta; // Get the scroll positions

    let positions = swiper.getTranslate() + delta * params.sensitivity;
    if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
    if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
    //     the disableParentSwiper will be true.
    // When loop is false:
    //     if the scroll positions is not on edge,
    //     then the disableParentSwiper will be true.
    //     if the scroll on edge positions,
    //     then the disableParentSwiper will be false.

    disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
    if (disableParentSwiper && swiper.params.nested) e.stopPropagation();

    if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
      // Register the new event in a variable which stores the relevant data
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta),
        raw: event
      }; // Keep the most recent events

      if (recentWheelEvents.length >= 2) {
        recentWheelEvents.shift(); // only store the last N events
      }

      const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
      recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
      //   If direction has changed or
      //   if the scroll is quicker than the previous one:
      //     Animate the slider.
      // Else (this is the first time the wheel is moved):
      //     Animate the slider.

      if (prevEvent) {
        if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) {
          animateSlider(newEvent);
        }
      } else {
        animateSlider(newEvent);
      } // If it's time to release the scroll:
      //   Return now so you don't hit the preventDefault.


      if (releaseScroll(newEvent)) {
        return true;
      }
    } else {
      // Freemode or scrollContainer:
      // If we recently snapped after a momentum scroll, then ignore wheel events
      // to give time for the deceleration to finish. Stop ignoring after 500 msecs
      // or if it's a new scroll (larger delta or inverse sign as last event before
      // an end-of-momentum snap).
      const newEvent = {
        time: now(),
        delta: Math.abs(delta),
        direction: Math.sign(delta)
      };
      const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;

      if (!ignoreWheelEvents) {
        lastEventBeforeSnap = undefined;

        if (swiper.params.loop) {
          swiper.loopFix();
        }

        let position = swiper.getTranslate() + delta * params.sensitivity;
        const wasBeginning = swiper.isBeginning;
        const wasEnd = swiper.isEnd;
        if (position >= swiper.minTranslate()) position = swiper.minTranslate();
        if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
        swiper.setTransition(0);
        swiper.setTranslate(position);
        swiper.updateProgress();
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();

        if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) {
          swiper.updateSlidesClasses();
        }

        if (swiper.params.freeMode.sticky) {
          // When wheel scrolling starts with sticky (aka snap) enabled, then detect
          // the end of a momentum scroll by storing recent (N=15?) wheel events.
          // 1. do all N events have decreasing or same (absolute value) delta?
          // 2. did all N events arrive in the last M (M=500?) msecs?
          // 3. does the earliest event have an (absolute value) delta that's
          //    at least P (P=1?) larger than the most recent event's delta?
          // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
          // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
          // Snap immediately and ignore remaining wheel events in this scroll.
          // See comment above for "remaining wheel events in this scroll" determination.
          // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
          clearTimeout(timeout);
          timeout = undefined;

          if (recentWheelEvents.length >= 15) {
            recentWheelEvents.shift(); // only store the last N events
          }

          const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
          const firstEvent = recentWheelEvents[0];
          recentWheelEvents.push(newEvent);

          if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) {
            // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
            recentWheelEvents.splice(0);
          } else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
            // We're at the end of the deceleration of a momentum scroll, so there's no need
            // to wait for more events. Snap ASAP on the next tick.
            // Also, because there's some remaining momentum we'll bias the snap in the
            // direction of the ongoing scroll because it's better UX for the scroll to snap
            // in the same direction as the scroll instead of reversing to snap.  Therefore,
            // if it's already scrolled more than 20% in the current direction, keep going.
            const snapToThreshold = delta > 0 ? 0.8 : 0.2;
            lastEventBeforeSnap = newEvent;
            recentWheelEvents.splice(0);
            timeout = nextTick(() => {
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 0); // no delay; move on next tick
          }

          if (!timeout) {
            // if we get here, then we haven't detected the end of a momentum scroll, so
            // we'll consider a scroll "complete" when there haven't been any wheel events
            // for 500ms.
            timeout = nextTick(() => {
              const snapToThreshold = 0.5;
              lastEventBeforeSnap = newEvent;
              recentWheelEvents.splice(0);
              swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
            }, 500);
          }
        } // Emit event


        if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay

        if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions

        if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
      }
    }

    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    return false;
  }

  function events(method) {
    let target = swiper.$el;

    if (swiper.params.mousewheel.eventsTarget !== 'container') {
      target = $(swiper.params.mousewheel.eventsTarget);
    }

    target[method]('mouseenter', handleMouseEnter);
    target[method]('mouseleave', handleMouseLeave);
    target[method]('wheel', handle);
  }

  function enable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.removeEventListener('wheel', handle);
      return true;
    }

    if (swiper.mousewheel.enabled) return false;
    events('on');
    swiper.mousewheel.enabled = true;
    return true;
  }

  function disable() {
    if (swiper.params.cssMode) {
      swiper.wrapperEl.addEventListener(event, handle);
      return true;
    }

    if (!swiper.mousewheel.enabled) return false;
    events('off');
    swiper.mousewheel.enabled = false;
    return true;
  }

  on('init', () => {
    if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) {
      disable();
    }

    if (swiper.params.mousewheel.enabled) enable();
  });
  on('destroy', () => {
    if (swiper.params.cssMode) {
      enable();
    }

    if (swiper.mousewheel.enabled) disable();
  });
  Object.assign(swiper.mousewheel, {
    enable,
    disable
  });
}

function createElementIfNotDefined(swiper, originalParams, params, checkProps) {
  const document = getDocument();

  if (swiper.params.createElements) {
    Object.keys(checkProps).forEach(key => {
      if (!params[key] && params.auto === true) {
        let element = swiper.$el.children(`.${checkProps[key]}`)[0];

        if (!element) {
          element = document.createElement('div');
          element.className = checkProps[key];
          swiper.$el.append(element);
        }

        params[key] = element;
        originalParams[key] = element;
      }
    });
  }

  return params;
}

function Navigation({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    navigation: {
      nextEl: null,
      prevEl: null,
      hideOnClick: false,
      disabledClass: 'swiper-button-disabled',
      hiddenClass: 'swiper-button-hidden',
      lockClass: 'swiper-button-lock',
      navigationDisabledClass: 'swiper-navigation-disabled'
    }
  });
  swiper.navigation = {
    nextEl: null,
    $nextEl: null,
    prevEl: null,
    $prevEl: null
  };

  function getEl(el) {
    let $el;

    if (el) {
      $el = $(el);

      if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) {
        $el = swiper.$el.find(el);
      }
    }

    return $el;
  }

  function toggleEl($el, disabled) {
    const params = swiper.params.navigation;

    if ($el && $el.length > 0) {
      $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
      if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;

      if (swiper.params.watchOverflow && swiper.enabled) {
        $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
      }
    }
  }

  function update() {
    // Update Navigation Buttons
    if (swiper.params.loop) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
    toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
  }

  function onPrevClick(e) {
    e.preventDefault();
    if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slidePrev();
    emit('navigationPrev');
  }

  function onNextClick(e) {
    e.preventDefault();
    if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
    swiper.slideNext();
    emit('navigationNext');
  }

  function init() {
    const params = swiper.params.navigation;
    swiper.params.navigation = createElementIfNotDefined(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
      nextEl: 'swiper-button-next',
      prevEl: 'swiper-button-prev'
    });
    if (!(params.nextEl || params.prevEl)) return;
    const $nextEl = getEl(params.nextEl);
    const $prevEl = getEl(params.prevEl);

    if ($nextEl && $nextEl.length > 0) {
      $nextEl.on('click', onNextClick);
    }

    if ($prevEl && $prevEl.length > 0) {
      $prevEl.on('click', onPrevClick);
    }

    Object.assign(swiper.navigation, {
      $nextEl,
      nextEl: $nextEl && $nextEl[0],
      $prevEl,
      prevEl: $prevEl && $prevEl[0]
    });

    if (!swiper.enabled) {
      if ($nextEl) $nextEl.addClass(params.lockClass);
      if ($prevEl) $prevEl.addClass(params.lockClass);
    }
  }

  function destroy() {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl && $nextEl.length) {
      $nextEl.off('click', onNextClick);
      $nextEl.removeClass(swiper.params.navigation.disabledClass);
    }

    if ($prevEl && $prevEl.length) {
      $prevEl.off('click', onPrevClick);
      $prevEl.removeClass(swiper.params.navigation.disabledClass);
    }
  }

  on('init', () => {
    if (swiper.params.navigation.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      update();
    }
  });
  on('toEdge fromEdge lock unlock', () => {
    update();
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($nextEl) {
      $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }

    if ($prevEl) {
      $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    }
  });
  on('click', (_s, e) => {
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;
    const targetEl = e.target;

    if (swiper.params.navigation.hideOnClick && !$(targetEl).is($prevEl) && !$(targetEl).is($nextEl)) {
      if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
      let isHidden;

      if ($nextEl) {
        isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
      } else if ($prevEl) {
        isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
      }

      if (isHidden === true) {
        emit('navigationShow');
      } else {
        emit('navigationHide');
      }

      if ($nextEl) {
        $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
      }

      if ($prevEl) {
        $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
      }
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
    init();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
    destroy();
  };

  Object.assign(swiper.navigation, {
    enable,
    disable,
    update,
    init,
    destroy
  });
}

function classesToSelector(classes = '') {
  return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
  .replace(/ /g, '.')}`;
}

function Pagination({
  swiper,
  extendParams,
  on,
  emit
}) {
  const pfx = 'swiper-pagination';
  extendParams({
    pagination: {
      el: null,
      bulletElement: 'span',
      clickable: false,
      hideOnClick: false,
      renderBullet: null,
      renderProgressbar: null,
      renderFraction: null,
      renderCustom: null,
      progressbarOpposite: false,
      type: 'bullets',
      // 'bullets' or 'progressbar' or 'fraction' or 'custom'
      dynamicBullets: false,
      dynamicMainBullets: 1,
      formatFractionCurrent: number => number,
      formatFractionTotal: number => number,
      bulletClass: `${pfx}-bullet`,
      bulletActiveClass: `${pfx}-bullet-active`,
      modifierClass: `${pfx}-`,
      currentClass: `${pfx}-current`,
      totalClass: `${pfx}-total`,
      hiddenClass: `${pfx}-hidden`,
      progressbarFillClass: `${pfx}-progressbar-fill`,
      progressbarOppositeClass: `${pfx}-progressbar-opposite`,
      clickableClass: `${pfx}-clickable`,
      lockClass: `${pfx}-lock`,
      horizontalClass: `${pfx}-horizontal`,
      verticalClass: `${pfx}-vertical`,
      paginationDisabledClass: `${pfx}-disabled`
    }
  });
  swiper.pagination = {
    el: null,
    $el: null,
    bullets: []
  };
  let bulletSize;
  let dynamicBulletIndex = 0;

  function isPaginationDisabled() {
    return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
  }

  function setSideBullets($bulletEl, position) {
    const {
      bulletActiveClass
    } = swiper.params.pagination;
    $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
  }

  function update() {
    // Render || Update Pagination bullets/items
    const rtl = swiper.rtl;
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el; // Current/Total

    let current;
    const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

    if (swiper.params.loop) {
      current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);

      if (current > slidesLength - 1 - swiper.loopedSlides * 2) {
        current -= slidesLength - swiper.loopedSlides * 2;
      }

      if (current > total - 1) current -= total;
      if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
    } else if (typeof swiper.snapIndex !== 'undefined') {
      current = swiper.snapIndex;
    } else {
      current = swiper.activeIndex || 0;
    } // Types


    if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
      const bullets = swiper.pagination.bullets;
      let firstIndex;
      let lastIndex;
      let midIndex;

      if (params.dynamicBullets) {
        bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
        $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);

        if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
          dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);

          if (dynamicBulletIndex > params.dynamicMainBullets - 1) {
            dynamicBulletIndex = params.dynamicMainBullets - 1;
          } else if (dynamicBulletIndex < 0) {
            dynamicBulletIndex = 0;
          }
        }

        firstIndex = Math.max(current - dynamicBulletIndex, 0);
        lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
        midIndex = (lastIndex + firstIndex) / 2;
      }

      bullets.removeClass(['', '-next', '-next-next', '-prev', '-prev-prev', '-main'].map(suffix => `${params.bulletActiveClass}${suffix}`).join(' '));

      if ($el.length > 1) {
        bullets.each(bullet => {
          const $bullet = $(bullet);
          const bulletIndex = $bullet.index();

          if (bulletIndex === current) {
            $bullet.addClass(params.bulletActiveClass);
          }

          if (params.dynamicBullets) {
            if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) {
              $bullet.addClass(`${params.bulletActiveClass}-main`);
            }

            if (bulletIndex === firstIndex) {
              setSideBullets($bullet, 'prev');
            }

            if (bulletIndex === lastIndex) {
              setSideBullets($bullet, 'next');
            }
          }
        });
      } else {
        const $bullet = bullets.eq(current);
        const bulletIndex = $bullet.index();
        $bullet.addClass(params.bulletActiveClass);

        if (params.dynamicBullets) {
          const $firstDisplayedBullet = bullets.eq(firstIndex);
          const $lastDisplayedBullet = bullets.eq(lastIndex);

          for (let i = firstIndex; i <= lastIndex; i += 1) {
            bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
          }

          if (swiper.params.loop) {
            if (bulletIndex >= bullets.length) {
              for (let i = params.dynamicMainBullets; i >= 0; i -= 1) {
                bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
              }

              bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
            } else {
              setSideBullets($firstDisplayedBullet, 'prev');
              setSideBullets($lastDisplayedBullet, 'next');
            }
          } else {
            setSideBullets($firstDisplayedBullet, 'prev');
            setSideBullets($lastDisplayedBullet, 'next');
          }
        }
      }

      if (params.dynamicBullets) {
        const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
        const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
        const offsetProp = rtl ? 'right' : 'left';
        bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
      }
    }

    if (params.type === 'fraction') {
      $el.find(classesToSelector(params.currentClass)).text(params.formatFractionCurrent(current + 1));
      $el.find(classesToSelector(params.totalClass)).text(params.formatFractionTotal(total));
    }

    if (params.type === 'progressbar') {
      let progressbarDirection;

      if (params.progressbarOpposite) {
        progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
      } else {
        progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
      }

      const scale = (current + 1) / total;
      let scaleX = 1;
      let scaleY = 1;

      if (progressbarDirection === 'horizontal') {
        scaleX = scale;
      } else {
        scaleY = scale;
      }

      $el.find(classesToSelector(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
    }

    if (params.type === 'custom' && params.renderCustom) {
      $el.html(params.renderCustom(swiper, current + 1, total));
      emit('paginationRender', $el[0]);
    } else {
      emit('paginationUpdate', $el[0]);
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
  }

  function render() {
    // Render Container
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
    const $el = swiper.pagination.$el;
    let paginationHTML = '';

    if (params.type === 'bullets') {
      let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;

      if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) {
        numberOfBullets = slidesLength;
      }

      for (let i = 0; i < numberOfBullets; i += 1) {
        if (params.renderBullet) {
          paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
        } else {
          paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
        }
      }

      $el.html(paginationHTML);
      swiper.pagination.bullets = $el.find(classesToSelector(params.bulletClass));
    }

    if (params.type === 'fraction') {
      if (params.renderFraction) {
        paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
      } else {
        paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type === 'progressbar') {
      if (params.renderProgressbar) {
        paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
      } else {
        paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
      }

      $el.html(paginationHTML);
    }

    if (params.type !== 'custom') {
      emit('paginationRender', swiper.pagination.$el[0]);
    }
  }

  function init() {
    swiper.params.pagination = createElementIfNotDefined(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
      el: 'swiper-pagination'
    });
    const params = swiper.params.pagination;
    if (!params.el) return;
    let $el = $(params.el);
    if ($el.length === 0) return;

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
      $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper

      if ($el.length > 1) {
        $el = $el.filter(el => {
          if ($(el).parents('.swiper')[0] !== swiper.el) return false;
          return true;
        });
      }
    }

    if (params.type === 'bullets' && params.clickable) {
      $el.addClass(params.clickableClass);
    }

    $el.addClass(params.modifierClass + params.type);
    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);

    if (params.type === 'bullets' && params.dynamicBullets) {
      $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
      dynamicBulletIndex = 0;

      if (params.dynamicMainBullets < 1) {
        params.dynamicMainBullets = 1;
      }
    }

    if (params.type === 'progressbar' && params.progressbarOpposite) {
      $el.addClass(params.progressbarOppositeClass);
    }

    if (params.clickable) {
      $el.on('click', classesToSelector(params.bulletClass), function onClick(e) {
        e.preventDefault();
        let index = $(this).index() * swiper.params.slidesPerGroup;
        if (swiper.params.loop) index += swiper.loopedSlides;
        swiper.slideTo(index);
      });
    }

    Object.assign(swiper.pagination, {
      $el,
      el: $el[0]
    });

    if (!swiper.enabled) {
      $el.addClass(params.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.pagination;
    if (isPaginationDisabled()) return;
    const $el = swiper.pagination.$el;
    $el.removeClass(params.hiddenClass);
    $el.removeClass(params.modifierClass + params.type);
    $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);

    if (params.clickable) {
      $el.off('click', classesToSelector(params.bulletClass));
    }
  }

  on('init', () => {
    if (swiper.params.pagination.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      render();
      update();
    }
  });
  on('activeIndexChange', () => {
    if (swiper.params.loop) {
      update();
    } else if (typeof swiper.snapIndex === 'undefined') {
      update();
    }
  });
  on('snapIndexChange', () => {
    if (!swiper.params.loop) {
      update();
    }
  });
  on('slidesLengthChange', () => {
    if (swiper.params.loop) {
      render();
      update();
    }
  });
  on('snapGridLengthChange', () => {
    if (!swiper.params.loop) {
      render();
      update();
    }
  });
  on('destroy', () => {
    destroy();
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.pagination;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    }
  });
  on('lock unlock', () => {
    update();
  });
  on('click', (_s, e) => {
    const targetEl = e.target;
    const {
      $el
    } = swiper.pagination;

    if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !$(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
      if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
      const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);

      if (isHidden === true) {
        emit('paginationShow');
      } else {
        emit('paginationHide');
      }

      $el.toggleClass(swiper.params.pagination.hiddenClass);
    }
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
    }

    init();
    render();
    update();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);

    if (swiper.pagination.$el) {
      swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.pagination, {
    enable,
    disable,
    render,
    update,
    init,
    destroy
  });
}

function Scrollbar({
  swiper,
  extendParams,
  on,
  emit
}) {
  const document = getDocument();
  let isTouched = false;
  let timeout = null;
  let dragTimeout = null;
  let dragStartPos;
  let dragSize;
  let trackSize;
  let divider;
  extendParams({
    scrollbar: {
      el: null,
      dragSize: 'auto',
      hide: false,
      draggable: false,
      snapOnRelease: true,
      lockClass: 'swiper-scrollbar-lock',
      dragClass: 'swiper-scrollbar-drag',
      scrollbarDisabledClass: 'swiper-scrollbar-disabled',
      horizontalClass: `swiper-scrollbar-horizontal`,
      verticalClass: `swiper-scrollbar-vertical`
    }
  });
  swiper.scrollbar = {
    el: null,
    dragEl: null,
    $el: null,
    $dragEl: null
  };

  function setTranslate() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar,
      rtlTranslate: rtl,
      progress
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    const params = swiper.params.scrollbar;
    let newSize = dragSize;
    let newPos = (trackSize - dragSize) * progress;

    if (rtl) {
      newPos = -newPos;

      if (newPos > 0) {
        newSize = dragSize - newPos;
        newPos = 0;
      } else if (-newPos + dragSize > trackSize) {
        newSize = trackSize + newPos;
      }
    } else if (newPos < 0) {
      newSize = dragSize + newPos;
      newPos = 0;
    } else if (newPos + dragSize > trackSize) {
      newSize = trackSize - newPos;
    }

    if (swiper.isHorizontal()) {
      $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
      $dragEl[0].style.width = `${newSize}px`;
    } else {
      $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
      $dragEl[0].style.height = `${newSize}px`;
    }

    if (params.hide) {
      clearTimeout(timeout);
      $el[0].style.opacity = 1;
      timeout = setTimeout(() => {
        $el[0].style.opacity = 0;
        $el.transition(400);
      }, 1000);
    }
  }

  function setTransition(duration) {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    swiper.scrollbar.$dragEl.transition(duration);
  }

  function updateSize() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    const {
      scrollbar
    } = swiper;
    const {
      $dragEl,
      $el
    } = scrollbar;
    $dragEl[0].style.width = '';
    $dragEl[0].style.height = '';
    trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
    divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));

    if (swiper.params.scrollbar.dragSize === 'auto') {
      dragSize = trackSize * divider;
    } else {
      dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
    }

    if (swiper.isHorizontal()) {
      $dragEl[0].style.width = `${dragSize}px`;
    } else {
      $dragEl[0].style.height = `${dragSize}px`;
    }

    if (divider >= 1) {
      $el[0].style.display = 'none';
    } else {
      $el[0].style.display = '';
    }

    if (swiper.params.scrollbar.hide) {
      $el[0].style.opacity = 0;
    }

    if (swiper.params.watchOverflow && swiper.enabled) {
      scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function getPointerPosition(e) {
    if (swiper.isHorizontal()) {
      return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
    }

    return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
  }

  function setDragPosition(e) {
    const {
      scrollbar,
      rtlTranslate: rtl
    } = swiper;
    const {
      $el
    } = scrollbar;
    let positionRatio;
    positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
    positionRatio = Math.max(Math.min(positionRatio, 1), 0);

    if (rtl) {
      positionRatio = 1 - positionRatio;
    }

    const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
    swiper.updateProgress(position);
    swiper.setTranslate(position);
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
  }

  function onDragStart(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    isTouched = true;
    dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
    e.preventDefault();
    e.stopPropagation();
    $wrapperEl.transition(100);
    $dragEl.transition(100);
    setDragPosition(e);
    clearTimeout(dragTimeout);
    $el.transition(0);

    if (params.hide) {
      $el.css('opacity', 1);
    }

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', 'none');
    }

    emit('scrollbarDragStart', e);
  }

  function onDragMove(e) {
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el,
      $dragEl
    } = scrollbar;
    if (!isTouched) return;
    if (e.preventDefault) e.preventDefault();else e.returnValue = false;
    setDragPosition(e);
    $wrapperEl.transition(0);
    $el.transition(0);
    $dragEl.transition(0);
    emit('scrollbarDragMove', e);
  }

  function onDragEnd(e) {
    const params = swiper.params.scrollbar;
    const {
      scrollbar,
      $wrapperEl
    } = swiper;
    const {
      $el
    } = scrollbar;
    if (!isTouched) return;
    isTouched = false;

    if (swiper.params.cssMode) {
      swiper.$wrapperEl.css('scroll-snap-type', '');
      $wrapperEl.transition('');
    }

    if (params.hide) {
      clearTimeout(dragTimeout);
      dragTimeout = nextTick(() => {
        $el.css('opacity', 0);
        $el.transition(400);
      }, 1000);
    }

    emit('scrollbarDragEnd', e);

    if (params.snapOnRelease) {
      swiper.slideToClosest();
    }
  }

  function events(method) {
    const {
      scrollbar,
      touchEventsTouch,
      touchEventsDesktop,
      params,
      support
    } = swiper;
    const $el = scrollbar.$el;
    if (!$el) return;
    const target = $el[0];
    const activeListener = support.passiveListener && params.passiveListeners ? {
      passive: false,
      capture: false
    } : false;
    const passiveListener = support.passiveListener && params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;
    if (!target) return;
    const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';

    if (!support.touch) {
      target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
      document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
      document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
    } else {
      target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
      target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
      target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
    }
  }

  function enableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('on');
  }

  function disableDraggable() {
    if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
    events('off');
  }

  function init() {
    const {
      scrollbar,
      $el: $swiperEl
    } = swiper;
    swiper.params.scrollbar = createElementIfNotDefined(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
      el: 'swiper-scrollbar'
    });
    const params = swiper.params.scrollbar;
    if (!params.el) return;
    let $el = $(params.el);

    if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) {
      $el = $swiperEl.find(params.el);
    }

    $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);

    if ($dragEl.length === 0) {
      $dragEl = $(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
      $el.append($dragEl);
    }

    Object.assign(scrollbar, {
      $el,
      el: $el[0],
      $dragEl,
      dragEl: $dragEl[0]
    });

    if (params.draggable) {
      enableDraggable();
    }

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  }

  function destroy() {
    const params = swiper.params.scrollbar;
    const $el = swiper.scrollbar.$el;

    if ($el) {
      $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
    }

    disableDraggable();
  }

  on('init', () => {
    if (swiper.params.scrollbar.enabled === false) {
      // eslint-disable-next-line
      disable();
    } else {
      init();
      updateSize();
      setTranslate();
    }
  });
  on('update resize observerUpdate lock unlock', () => {
    updateSize();
  });
  on('setTranslate', () => {
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    setTransition(duration);
  });
  on('enable disable', () => {
    const {
      $el
    } = swiper.scrollbar;

    if ($el) {
      $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
  });
  on('destroy', () => {
    destroy();
  });

  const enable = () => {
    swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    init();
    updateSize();
    setTranslate();
  };

  const disable = () => {
    swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);

    if (swiper.scrollbar.$el) {
      swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
    }

    destroy();
  };

  Object.assign(swiper.scrollbar, {
    enable,
    disable,
    updateSize,
    setTranslate,
    init,
    destroy
  });
}

function Parallax({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    parallax: {
      enabled: false
    }
  });

  const setTransform = (el, progress) => {
    const {
      rtl
    } = swiper;
    const $el = $(el);
    const rtlFactor = rtl ? -1 : 1;
    const p = $el.attr('data-swiper-parallax') || '0';
    let x = $el.attr('data-swiper-parallax-x');
    let y = $el.attr('data-swiper-parallax-y');
    const scale = $el.attr('data-swiper-parallax-scale');
    const opacity = $el.attr('data-swiper-parallax-opacity');

    if (x || y) {
      x = x || '0';
      y = y || '0';
    } else if (swiper.isHorizontal()) {
      x = p;
      y = '0';
    } else {
      y = p;
      x = '0';
    }

    if (x.indexOf('%') >= 0) {
      x = `${parseInt(x, 10) * progress * rtlFactor}%`;
    } else {
      x = `${x * progress * rtlFactor}px`;
    }

    if (y.indexOf('%') >= 0) {
      y = `${parseInt(y, 10) * progress}%`;
    } else {
      y = `${y * progress}px`;
    }

    if (typeof opacity !== 'undefined' && opacity !== null) {
      const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
      $el[0].style.opacity = currentOpacity;
    }

    if (typeof scale === 'undefined' || scale === null) {
      $el.transform(`translate3d(${x}, ${y}, 0px)`);
    } else {
      const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
      $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
    }
  };

  const setTranslate = () => {
    const {
      $el,
      slides,
      progress,
      snapGrid
    } = swiper;
    $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
      setTransform(el, progress);
    });
    slides.each((slideEl, slideIndex) => {
      let slideProgress = slideEl.progress;

      if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') {
        slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
      }

      slideProgress = Math.min(Math.max(slideProgress, -1), 1);
      $(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(el => {
        setTransform(el, slideProgress);
      });
    });
  };

  const setTransition = (duration = swiper.params.speed) => {
    const {
      $el
    } = swiper;
    $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each(parallaxEl => {
      const $parallaxEl = $(parallaxEl);
      let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
      if (duration === 0) parallaxDuration = 0;
      $parallaxEl.transition(parallaxDuration);
    });
  };

  on('beforeInit', () => {
    if (!swiper.params.parallax.enabled) return;
    swiper.params.watchSlidesProgress = true;
    swiper.originalParams.watchSlidesProgress = true;
  });
  on('init', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTranslate', () => {
    if (!swiper.params.parallax.enabled) return;
    setTranslate();
  });
  on('setTransition', (_swiper, duration) => {
    if (!swiper.params.parallax.enabled) return;
    setTransition(duration);
  });
}

function Lazy({
  swiper,
  extendParams,
  on,
  emit
}) {
  extendParams({
    lazy: {
      checkInView: false,
      enabled: false,
      loadPrevNext: false,
      loadPrevNextAmount: 1,
      loadOnTransitionStart: false,
      scrollingElement: '',
      elementClass: 'swiper-lazy',
      loadingClass: 'swiper-lazy-loading',
      loadedClass: 'swiper-lazy-loaded',
      preloaderClass: 'swiper-lazy-preloader'
    }
  });
  swiper.lazy = {};
  let scrollHandlerAttached = false;
  let initialImageLoaded = false;

  function loadInSlide(index, loadInDuplicate = true) {
    const params = swiper.params.lazy;
    if (typeof index === 'undefined') return;
    if (swiper.slides.length === 0) return;
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
    const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);

    if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) {
      $images.push($slideEl[0]);
    }

    if ($images.length === 0) return;
    $images.each(imageEl => {
      const $imageEl = $(imageEl);
      $imageEl.addClass(params.loadingClass);
      const background = $imageEl.attr('data-background');
      const src = $imageEl.attr('data-src');
      const srcset = $imageEl.attr('data-srcset');
      const sizes = $imageEl.attr('data-sizes');
      const $pictureEl = $imageEl.parent('picture');
      swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, () => {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;

        if (background) {
          $imageEl.css('background-image', `url("${background}")`);
          $imageEl.removeAttr('data-background');
        } else {
          if (srcset) {
            $imageEl.attr('srcset', srcset);
            $imageEl.removeAttr('data-srcset');
          }

          if (sizes) {
            $imageEl.attr('sizes', sizes);
            $imageEl.removeAttr('data-sizes');
          }

          if ($pictureEl.length) {
            $pictureEl.children('source').each(sourceEl => {
              const $source = $(sourceEl);

              if ($source.attr('data-srcset')) {
                $source.attr('srcset', $source.attr('data-srcset'));
                $source.removeAttr('data-srcset');
              }
            });
          }

          if (src) {
            $imageEl.attr('src', src);
            $imageEl.removeAttr('data-src');
          }
        }

        $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
        $slideEl.find(`.${params.preloaderClass}`).remove();

        if (swiper.params.loop && loadInDuplicate) {
          const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');

          if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
            const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
            loadInSlide(originalSlide.index(), false);
          } else {
            const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
            loadInSlide(duplicatedSlide.index(), false);
          }
        }

        emit('lazyImageReady', $slideEl[0], $imageEl[0]);

        if (swiper.params.autoHeight) {
          swiper.updateAutoHeight();
        }
      });
      emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
    });
  }

  function load() {
    const {
      $wrapperEl,
      params: swiperParams,
      slides,
      activeIndex
    } = swiper;
    const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
    const params = swiperParams.lazy;
    let slidesPerView = swiperParams.slidesPerView;

    if (slidesPerView === 'auto') {
      slidesPerView = 0;
    }

    function slideExist(index) {
      if (isVirtual) {
        if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) {
          return true;
        }
      } else if (slides[index]) return true;

      return false;
    }

    function slideIndex(slideEl) {
      if (isVirtual) {
        return $(slideEl).attr('data-swiper-slide-index');
      }

      return $(slideEl).index();
    }

    if (!initialImageLoaded) initialImageLoaded = true;

    if (swiper.params.watchSlidesProgress) {
      $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each(slideEl => {
        const index = isVirtual ? $(slideEl).attr('data-swiper-slide-index') : $(slideEl).index();
        loadInSlide(index);
      });
    } else if (slidesPerView > 1) {
      for (let i = activeIndex; i < activeIndex + slidesPerView; i += 1) {
        if (slideExist(i)) loadInSlide(i);
      }
    } else {
      loadInSlide(activeIndex);
    }

    if (params.loadPrevNext) {
      if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
        const amount = params.loadPrevNextAmount;
        const spv = Math.ceil(slidesPerView);
        const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
        const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides

        for (let i = activeIndex + spv; i < maxIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        } // Prev Slides


        for (let i = minIndex; i < activeIndex; i += 1) {
          if (slideExist(i)) loadInSlide(i);
        }
      } else {
        const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
        if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
        const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
        if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
      }
    }
  }

  function checkInViewOnLoad() {
    const window = getWindow();
    if (!swiper || swiper.destroyed) return;
    const $scrollElement = swiper.params.lazy.scrollingElement ? $(swiper.params.lazy.scrollingElement) : $(window);
    const isWindow = $scrollElement[0] === window;
    const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
    const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
    const swiperOffset = swiper.$el.offset();
    const {
      rtlTranslate: rtl
    } = swiper;
    let inView = false;
    if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
    const swiperCoord = [[swiperOffset.left, swiperOffset.top], [swiperOffset.left + swiper.width, swiperOffset.top], [swiperOffset.left, swiperOffset.top + swiper.height], [swiperOffset.left + swiper.width, swiperOffset.top + swiper.height]];

    for (let i = 0; i < swiperCoord.length; i += 1) {
      const point = swiperCoord[i];

      if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
        if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line

        inView = true;
      }
    }

    const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
      passive: true,
      capture: false
    } : false;

    if (inView) {
      load();
      $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
    } else if (!scrollHandlerAttached) {
      scrollHandlerAttached = true;
      $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
    }
  }

  on('beforeInit', () => {
    if (swiper.params.lazy.enabled && swiper.params.preloadImages) {
      swiper.params.preloadImages = false;
    }
  });
  on('init', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('scroll', () => {
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) {
      load();
    }
  });
  on('scrollbarDragMove resize _freeModeNoMomentumRelease', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('transitionStart', () => {
    if (swiper.params.lazy.enabled) {
      if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
        if (swiper.params.lazy.checkInView) {
          checkInViewOnLoad();
        } else {
          load();
        }
      }
    }
  });
  on('transitionEnd', () => {
    if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
      if (swiper.params.lazy.checkInView) {
        checkInViewOnLoad();
      } else {
        load();
      }
    }
  });
  on('slideChange', () => {
    const {
      lazy,
      cssMode,
      watchSlidesProgress,
      touchReleaseOnEdges,
      resistanceRatio
    } = swiper.params;

    if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) {
      load();
    }
  });
  on('destroy', () => {
    if (!swiper.$el) return;
    swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
  });
  Object.assign(swiper.lazy, {
    load,
    loadInSlide
  });
}

function A11y({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    a11y: {
      enabled: true,
      notificationClass: 'swiper-notification',
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
      firstSlideMessage: 'This is the first slide',
      lastSlideMessage: 'This is the last slide',
      paginationBulletMessage: 'Go to slide {{index}}',
      slideLabelMessage: '{{index}} / {{slidesLength}}',
      containerMessage: null,
      containerRoleDescriptionMessage: null,
      itemRoleDescriptionMessage: null,
      slideRole: 'group',
      id: null
    }
  });
  swiper.a11y = {
    clicked: false
  };
  let liveRegion = null;

  function notify(message) {
    const notification = liveRegion;
    if (notification.length === 0) return;
    notification.html('');
    notification.html(message);
  }

  function getRandomNumber(size = 16) {
    const randomChar = () => Math.round(16 * Math.random()).toString(16);

    return 'x'.repeat(size).replace(/x/g, randomChar);
  }

  function makeElFocusable($el) {
    $el.attr('tabIndex', '0');
  }

  function makeElNotFocusable($el) {
    $el.attr('tabIndex', '-1');
  }

  function addElRole($el, role) {
    $el.attr('role', role);
  }

  function addElRoleDescription($el, description) {
    $el.attr('aria-roledescription', description);
  }

  function addElControls($el, controls) {
    $el.attr('aria-controls', controls);
  }

  function addElLabel($el, label) {
    $el.attr('aria-label', label);
  }

  function addElId($el, id) {
    $el.attr('id', id);
  }

  function addElLive($el, live) {
    $el.attr('aria-live', live);
  }

  function disableEl($el) {
    $el.attr('aria-disabled', true);
  }

  function enableEl($el) {
    $el.attr('aria-disabled', false);
  }

  function onEnterOrSpaceKey(e) {
    if (e.keyCode !== 13 && e.keyCode !== 32) return;
    const params = swiper.params.a11y;
    const $targetEl = $(e.target);

    if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
      if (!(swiper.isEnd && !swiper.params.loop)) {
        swiper.slideNext();
      }

      if (swiper.isEnd) {
        notify(params.lastSlideMessage);
      } else {
        notify(params.nextSlideMessage);
      }
    }

    if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
      if (!(swiper.isBeginning && !swiper.params.loop)) {
        swiper.slidePrev();
      }

      if (swiper.isBeginning) {
        notify(params.firstSlideMessage);
      } else {
        notify(params.prevSlideMessage);
      }
    }

    if (swiper.pagination && $targetEl.is(classesToSelector(swiper.params.pagination.bulletClass))) {
      $targetEl[0].click();
    }
  }

  function updateNavigation() {
    if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
    const {
      $nextEl,
      $prevEl
    } = swiper.navigation;

    if ($prevEl && $prevEl.length > 0) {
      if (swiper.isBeginning) {
        disableEl($prevEl);
        makeElNotFocusable($prevEl);
      } else {
        enableEl($prevEl);
        makeElFocusable($prevEl);
      }
    }

    if ($nextEl && $nextEl.length > 0) {
      if (swiper.isEnd) {
        disableEl($nextEl);
        makeElNotFocusable($nextEl);
      } else {
        enableEl($nextEl);
        makeElFocusable($nextEl);
      }
    }
  }

  function hasPagination() {
    return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
  }

  function hasClickablePagination() {
    return hasPagination() && swiper.params.pagination.clickable;
  }

  function updatePagination() {
    const params = swiper.params.a11y;
    if (!hasPagination()) return;
    swiper.pagination.bullets.each(bulletEl => {
      const $bulletEl = $(bulletEl);

      if (swiper.params.pagination.clickable) {
        makeElFocusable($bulletEl);

        if (!swiper.params.pagination.renderBullet) {
          addElRole($bulletEl, 'button');
          addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
        }
      }

      if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) {
        $bulletEl.attr('aria-current', 'true');
      } else {
        $bulletEl.removeAttr('aria-current');
      }
    });
  }

  const initNavEl = ($el, wrapperId, message) => {
    makeElFocusable($el);

    if ($el[0].tagName !== 'BUTTON') {
      addElRole($el, 'button');
      $el.on('keydown', onEnterOrSpaceKey);
    }

    addElLabel($el, message);
    addElControls($el, wrapperId);
  };

  const handlePointerDown = () => {
    swiper.a11y.clicked = true;
  };

  const handlePointerUp = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        if (!swiper.destroyed) {
          swiper.a11y.clicked = false;
        }
      });
    });
  };

  const handleFocus = e => {
    if (swiper.a11y.clicked) return;
    const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
    if (!slideEl || !swiper.slides.includes(slideEl)) return;
    const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
    const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
    if (isActive || isVisible) return;
    if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;

    if (swiper.isHorizontal()) {
      swiper.el.scrollLeft = 0;
    } else {
      swiper.el.scrollTop = 0;
    }

    swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
  };

  const initSlides = () => {
    const params = swiper.params.a11y;

    if (params.itemRoleDescriptionMessage) {
      addElRoleDescription($(swiper.slides), params.itemRoleDescriptionMessage);
    }

    if (params.slideRole) {
      addElRole($(swiper.slides), params.slideRole);
    }

    const slidesLength = swiper.params.loop ? swiper.slides.filter(el => !el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;

    if (params.slideLabelMessage) {
      swiper.slides.each((slideEl, index) => {
        const $slideEl = $(slideEl);
        const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
        const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
        addElLabel($slideEl, ariaLabelMessage);
      });
    }
  };

  const init = () => {
    const params = swiper.params.a11y;
    swiper.$el.append(liveRegion); // Container

    const $containerEl = swiper.$el;

    if (params.containerRoleDescriptionMessage) {
      addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
    }

    if (params.containerMessage) {
      addElLabel($containerEl, params.containerMessage);
    } // Wrapper


    const $wrapperEl = swiper.$wrapperEl;
    const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
    const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
    addElId($wrapperEl, wrapperId);
    addElLive($wrapperEl, live); // Slide

    initSlides(); // Navigation

    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl && $nextEl.length) {
      initNavEl($nextEl, wrapperId, params.nextSlideMessage);
    }

    if ($prevEl && $prevEl.length) {
      initNavEl($prevEl, wrapperId, params.prevSlideMessage);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.on('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.on('focus', handleFocus, true);
    swiper.$el.on('pointerdown', handlePointerDown, true);
    swiper.$el.on('pointerup', handlePointerUp, true);
  };

  function destroy() {
    if (liveRegion && liveRegion.length > 0) liveRegion.remove();
    let $nextEl;
    let $prevEl;

    if (swiper.navigation && swiper.navigation.$nextEl) {
      $nextEl = swiper.navigation.$nextEl;
    }

    if (swiper.navigation && swiper.navigation.$prevEl) {
      $prevEl = swiper.navigation.$prevEl;
    }

    if ($nextEl) {
      $nextEl.off('keydown', onEnterOrSpaceKey);
    }

    if ($prevEl) {
      $prevEl.off('keydown', onEnterOrSpaceKey);
    } // Pagination


    if (hasClickablePagination()) {
      swiper.pagination.$el.off('keydown', classesToSelector(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
    } // Tab focus


    swiper.$el.off('focus', handleFocus, true);
    swiper.$el.off('pointerdown', handlePointerDown, true);
    swiper.$el.off('pointerup', handlePointerUp, true);
  }

  on('beforeInit', () => {
    liveRegion = $(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
  });
  on('afterInit', () => {
    if (!swiper.params.a11y.enabled) return;
    init();
  });
  on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', () => {
    if (!swiper.params.a11y.enabled) return;
    initSlides();
  });
  on('fromEdge toEdge afterInit lock unlock', () => {
    if (!swiper.params.a11y.enabled) return;
    updateNavigation();
  });
  on('paginationUpdate', () => {
    if (!swiper.params.a11y.enabled) return;
    updatePagination();
  });
  on('destroy', () => {
    if (!swiper.params.a11y.enabled) return;
    destroy();
  });
}

function freeMode({
  swiper,
  extendParams,
  emit,
  once
}) {
  extendParams({
    freeMode: {
      enabled: false,
      momentum: true,
      momentumRatio: 1,
      momentumBounce: true,
      momentumBounceRatio: 1,
      momentumVelocityRatio: 1,
      sticky: false,
      minimumVelocity: 0.02
    }
  });

  function onTouchStart() {
    const translate = swiper.getTranslate();
    swiper.setTranslate(translate);
    swiper.setTransition(0);
    swiper.touchEventsData.velocities.length = 0;
    swiper.freeMode.onTouchEnd({
      currentPos: swiper.rtl ? swiper.translate : -swiper.translate
    });
  }

  function onTouchMove() {
    const {
      touchEventsData: data,
      touches
    } = swiper; // Velocity

    if (data.velocities.length === 0) {
      data.velocities.push({
        position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
        time: data.touchStartTime
      });
    }

    data.velocities.push({
      position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
      time: now()
    });
  }

  function onTouchEnd({
    currentPos
  }) {
    const {
      params,
      $wrapperEl,
      rtlTranslate: rtl,
      snapGrid,
      touchEventsData: data
    } = swiper; // Time diff

    const touchEndTime = now();
    const timeDiff = touchEndTime - data.touchStartTime;

    if (currentPos < -swiper.minTranslate()) {
      swiper.slideTo(swiper.activeIndex);
      return;
    }

    if (currentPos > -swiper.maxTranslate()) {
      if (swiper.slides.length < snapGrid.length) {
        swiper.slideTo(snapGrid.length - 1);
      } else {
        swiper.slideTo(swiper.slides.length - 1);
      }

      return;
    }

    if (params.freeMode.momentum) {
      if (data.velocities.length > 1) {
        const lastMoveEvent = data.velocities.pop();
        const velocityEvent = data.velocities.pop();
        const distance = lastMoveEvent.position - velocityEvent.position;
        const time = lastMoveEvent.time - velocityEvent.time;
        swiper.velocity = distance / time;
        swiper.velocity /= 2;

        if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) {
          swiper.velocity = 0;
        } // this implies that the user stopped moving a finger then released.
        // There would be no events with distance zero, so the last event is stale.


        if (time > 150 || now() - lastMoveEvent.time > 300) {
          swiper.velocity = 0;
        }
      } else {
        swiper.velocity = 0;
      }

      swiper.velocity *= params.freeMode.momentumVelocityRatio;
      data.velocities.length = 0;
      let momentumDuration = 1000 * params.freeMode.momentumRatio;
      const momentumDistance = swiper.velocity * momentumDuration;
      let newPosition = swiper.translate + momentumDistance;
      if (rtl) newPosition = -newPosition;
      let doBounce = false;
      let afterBouncePosition;
      const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
      let needsLoopFix;

      if (newPosition < swiper.maxTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition + swiper.maxTranslate() < -bounceAmount) {
            newPosition = swiper.maxTranslate() - bounceAmount;
          }

          afterBouncePosition = swiper.maxTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.maxTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (newPosition > swiper.minTranslate()) {
        if (params.freeMode.momentumBounce) {
          if (newPosition - swiper.minTranslate() > bounceAmount) {
            newPosition = swiper.minTranslate() + bounceAmount;
          }

          afterBouncePosition = swiper.minTranslate();
          doBounce = true;
          data.allowMomentumBounce = true;
        } else {
          newPosition = swiper.minTranslate();
        }

        if (params.loop && params.centeredSlides) needsLoopFix = true;
      } else if (params.freeMode.sticky) {
        let nextSlide;

        for (let j = 0; j < snapGrid.length; j += 1) {
          if (snapGrid[j] > -newPosition) {
            nextSlide = j;
            break;
          }
        }

        if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') {
          newPosition = snapGrid[nextSlide];
        } else {
          newPosition = snapGrid[nextSlide - 1];
        }

        newPosition = -newPosition;
      }

      if (needsLoopFix) {
        once('transitionEnd', () => {
          swiper.loopFix();
        });
      } // Fix duration


      if (swiper.velocity !== 0) {
        if (rtl) {
          momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
        } else {
          momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
        }

        if (params.freeMode.sticky) {
          // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
          // event, then durations can be 20+ seconds to slide one (or zero!) slides.
          // It's easy to see this when simulating touch with mouse events. To fix this,
          // limit single-slide swipes to the default slide duration. This also has the
          // nice side effect of matching slide speed if the user stopped moving before
          // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
          // For faster swipes, also apply limits (albeit higher ones).
          const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
          const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];

          if (moveDistance < currentSlideSize) {
            momentumDuration = params.speed;
          } else if (moveDistance < 2 * currentSlideSize) {
            momentumDuration = params.speed * 1.5;
          } else {
            momentumDuration = params.speed * 2.5;
          }
        }
      } else if (params.freeMode.sticky) {
        swiper.slideToClosest();
        return;
      }

      if (params.freeMode.momentumBounce && doBounce) {
        swiper.updateProgress(afterBouncePosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);
        swiper.animating = true;
        $wrapperEl.transitionEnd(() => {
          if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
          emit('momentumBounce');
          swiper.setTransition(params.speed);
          setTimeout(() => {
            swiper.setTranslate(afterBouncePosition);
            $wrapperEl.transitionEnd(() => {
              if (!swiper || swiper.destroyed) return;
              swiper.transitionEnd();
            });
          }, 0);
        });
      } else if (swiper.velocity) {
        emit('_freeModeNoMomentumRelease');
        swiper.updateProgress(newPosition);
        swiper.setTransition(momentumDuration);
        swiper.setTranslate(newPosition);
        swiper.transitionStart(true, swiper.swipeDirection);

        if (!swiper.animating) {
          swiper.animating = true;
          $wrapperEl.transitionEnd(() => {
            if (!swiper || swiper.destroyed) return;
            swiper.transitionEnd();
          });
        }
      } else {
        swiper.updateProgress(newPosition);
      }

      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    } else if (params.freeMode.sticky) {
      swiper.slideToClosest();
      return;
    } else if (params.freeMode) {
      emit('_freeModeNoMomentumRelease');
    }

    if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
      swiper.updateProgress();
      swiper.updateActiveIndex();
      swiper.updateSlidesClasses();
    }
  }

  Object.assign(swiper, {
    freeMode: {
      onTouchStart,
      onTouchMove,
      onTouchEnd
    }
  });
}

function effectInit(params) {
  const {
    effect,
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams,
    perspective,
    recreateShadows,
    getEffectParams
  } = params;
  on('beforeInit', () => {
    if (swiper.params.effect !== effect) return;
    swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);

    if (perspective && perspective()) {
      swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
    }

    const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
    Object.assign(swiper.params, overwriteParamsResult);
    Object.assign(swiper.originalParams, overwriteParamsResult);
  });
  on('setTranslate', () => {
    if (swiper.params.effect !== effect) return;
    setTranslate();
  });
  on('setTransition', (_s, duration) => {
    if (swiper.params.effect !== effect) return;
    setTransition(duration);
  });
  on('transitionEnd', () => {
    if (swiper.params.effect !== effect) return;

    if (recreateShadows) {
      if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows

      swiper.slides.each(slideEl => {
        const $slideEl = swiper.$(slideEl);
        $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
      }); // create new one

      recreateShadows();
    }
  });
  let requireUpdateOnVirtual;
  on('virtualUpdate', () => {
    if (swiper.params.effect !== effect) return;

    if (!swiper.slides.length) {
      requireUpdateOnVirtual = true;
    }

    requestAnimationFrame(() => {
      if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
        setTranslate();
        requireUpdateOnVirtual = false;
      }
    });
  });
}

function effectTarget(effectParams, $slideEl) {
  if (effectParams.transformEl) {
    return $slideEl.find(effectParams.transformEl).css({
      'backface-visibility': 'hidden',
      '-webkit-backface-visibility': 'hidden'
    });
  }

  return $slideEl;
}

function effectVirtualTransitionEnd({
  swiper,
  duration,
  transformEl,
  allSlides
}) {
  const {
    slides,
    activeIndex,
    $wrapperEl
  } = swiper;

  if (swiper.params.virtualTranslate && duration !== 0) {
    let eventTriggered = false;
    let $transitionEndTarget;

    if (allSlides) {
      $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
    } else {
      $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
    }

    $transitionEndTarget.transitionEnd(() => {
      if (eventTriggered) return;
      if (!swiper || swiper.destroyed) return;
      eventTriggered = true;
      swiper.animating = false;
      const triggerEvents = ['webkitTransitionEnd', 'transitionend'];

      for (let i = 0; i < triggerEvents.length; i += 1) {
        $wrapperEl.trigger(triggerEvents[i]);
      }
    });
  }
}

function EffectFade({
  swiper,
  extendParams,
  on
}) {
  extendParams({
    fadeEffect: {
      crossFade: false,
      transformEl: null
    }
  });

  const setTranslate = () => {
    const {
      slides
    } = swiper;
    const params = swiper.params.fadeEffect;

    for (let i = 0; i < slides.length; i += 1) {
      const $slideEl = swiper.slides.eq(i);
      const offset = $slideEl[0].swiperSlideOffset;
      let tx = -offset;
      if (!swiper.params.virtualTranslate) tx -= swiper.translate;
      let ty = 0;

      if (!swiper.isHorizontal()) {
        ty = tx;
        tx = 0;
      }

      const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
      const $targetEl = effectTarget(params, $slideEl);
      $targetEl.css({
        opacity: slideOpacity
      }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
    }
  };

  const setTransition = duration => {
    const {
      transformEl
    } = swiper.params.fadeEffect;
    const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
    $transitionElements.transition(duration);
    effectVirtualTransitionEnd({
      swiper,
      duration,
      transformEl,
      allSlides: true
    });
  };

  effectInit({
    effect: 'fade',
    swiper,
    on,
    setTranslate,
    setTransition,
    overwriteParams: () => ({
      slidesPerView: 1,
      slidesPerGroup: 1,
      watchSlidesProgress: true,
      spaceBetween: 0,
      virtualTranslate: !swiper.params.cssMode
    })
  });
}

function isObject(o) {
  return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}

function extend(target, src) {
  const noExtend = ['__proto__', 'constructor', 'prototype'];
  Object.keys(src).filter(key => noExtend.indexOf(key) < 0).forEach(key => {
    if (typeof target[key] === 'undefined') target[key] = src[key];else if (isObject(src[key]) && isObject(target[key]) && Object.keys(src[key]).length > 0) {
      if (src[key].__swiper__) target[key] = src[key];else extend(target[key], src[key]);
    } else {
      target[key] = src[key];
    }
  });
}

function needsNavigation(params = {}) {
  return params.navigation && typeof params.navigation.nextEl === 'undefined' && typeof params.navigation.prevEl === 'undefined';
}

function needsPagination(params = {}) {
  return params.pagination && typeof params.pagination.el === 'undefined';
}

function needsScrollbar(params = {}) {
  return params.scrollbar && typeof params.scrollbar.el === 'undefined';
}

function uniqueClasses(classNames = '') {
  const classes = classNames.split(' ').map(c => c.trim()).filter(c => !!c);
  const unique = [];
  classes.forEach(c => {
    if (unique.indexOf(c) < 0) unique.push(c);
  });
  return unique.join(' ');
}

/* underscore in name -> watch for changes */
const paramsList = ['modules', 'init', '_direction', 'touchEventsTarget', 'initialSlide', '_speed', 'cssMode', 'updateOnWindowResize', 'resizeObserver', 'nested', 'focusableElements', '_enabled', '_width', '_height', 'preventInteractionOnTransition', 'userAgent', 'url', '_edgeSwipeDetection', '_edgeSwipeThreshold', '_freeMode', '_autoHeight', 'setWrapperSize', 'virtualTranslate', '_effect', 'breakpoints', '_spaceBetween', '_slidesPerView', 'maxBackfaceHiddenSlides', '_grid', '_slidesPerGroup', '_slidesPerGroupSkip', '_slidesPerGroupAuto', '_centeredSlides', '_centeredSlidesBounds', '_slidesOffsetBefore', '_slidesOffsetAfter', 'normalizeSlideIndex', '_centerInsufficientSlides', '_watchOverflow', 'roundLengths', 'touchRatio', 'touchAngle', 'simulateTouch', '_shortSwipes', '_longSwipes', 'longSwipesRatio', 'longSwipesMs', '_followFinger', 'allowTouchMove', '_threshold', 'touchMoveStopPropagation', 'touchStartPreventDefault', 'touchStartForcePreventDefault', 'touchReleaseOnEdges', 'uniqueNavElements', '_resistance', '_resistanceRatio', '_watchSlidesProgress', '_grabCursor', 'preventClicks', 'preventClicksPropagation', '_slideToClickedSlide', '_preloadImages', 'updateOnImagesReady', '_loop', '_loopAdditionalSlides', '_loopedSlides', '_loopedSlidesLimit', '_loopFillGroupWithBlank', 'loopPreventsSlide', '_rewind', '_allowSlidePrev', '_allowSlideNext', '_swipeHandler', '_noSwiping', 'noSwipingClass', 'noSwipingSelector', 'passiveListeners', 'containerModifierClass', 'slideClass', 'slideBlankClass', 'slideActiveClass', 'slideDuplicateActiveClass', 'slideVisibleClass', 'slideDuplicateClass', 'slideNextClass', 'slideDuplicateNextClass', 'slidePrevClass', 'slideDuplicatePrevClass', 'wrapperClass', 'runCallbacksOnInit', 'observer', 'observeParents', 'observeSlideChildren', // modules
'a11y', '_autoplay', '_controller', 'coverflowEffect', 'cubeEffect', 'fadeEffect', 'flipEffect', 'creativeEffect', 'cardsEffect', 'hashNavigation', 'history', 'keyboard', 'lazy', 'mousewheel', '_navigation', '_pagination', 'parallax', '_scrollbar', '_thumbs', 'virtual', 'zoom'];

function getParams(obj = {}, splitEvents = true) {
  const params = {
    on: {}
  };
  const events = {};
  const passedParams = {};
  extend(params, Swiper$1.defaults);
  extend(params, Swiper$1.extendedDefaults);
  params._emitClasses = true;
  params.init = false;
  const rest = {};
  const allowedParams = paramsList.map(key => key.replace(/_/, ''));
  const plainObj = Object.assign({}, obj);
  Object.keys(plainObj).forEach(key => {
    if (typeof obj[key] === 'undefined') return;

    if (allowedParams.indexOf(key) >= 0) {
      if (isObject(obj[key])) {
        params[key] = {};
        passedParams[key] = {};
        extend(params[key], obj[key]);
        extend(passedParams[key], obj[key]);
      } else {
        params[key] = obj[key];
        passedParams[key] = obj[key];
      }
    } else if (key.search(/on[A-Z]/) === 0 && typeof obj[key] === 'function') {
      if (splitEvents) {
        events[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      } else {
        params.on[`${key[2].toLowerCase()}${key.substr(3)}`] = obj[key];
      }
    } else {
      rest[key] = obj[key];
    }
  });
  ['navigation', 'pagination', 'scrollbar'].forEach(key => {
    if (params[key] === true) params[key] = {};
    if (params[key] === false) delete params[key];
  });
  return {
    params,
    passedParams,
    rest,
    events
  };
}

function mountSwiper({
  el,
  nextEl,
  prevEl,
  paginationEl,
  scrollbarEl,
  swiper
}, swiperParams) {
  if (needsNavigation(swiperParams) && nextEl && prevEl) {
    swiper.params.navigation.nextEl = nextEl;
    swiper.originalParams.navigation.nextEl = nextEl;
    swiper.params.navigation.prevEl = prevEl;
    swiper.originalParams.navigation.prevEl = prevEl;
  }

  if (needsPagination(swiperParams) && paginationEl) {
    swiper.params.pagination.el = paginationEl;
    swiper.originalParams.pagination.el = paginationEl;
  }

  if (needsScrollbar(swiperParams) && scrollbarEl) {
    swiper.params.scrollbar.el = scrollbarEl;
    swiper.originalParams.scrollbar.el = scrollbarEl;
  }

  swiper.init(el);
}

const calcLoopedSlides = (slides, swiperParams) => {
  let slidesPerViewParams = swiperParams.slidesPerView;

  if (swiperParams.breakpoints) {
    const breakpoint = Swiper$1.prototype.getBreakpoint(swiperParams.breakpoints);
    const breakpointOnlyParams = breakpoint in swiperParams.breakpoints ? swiperParams.breakpoints[breakpoint] : undefined;

    if (breakpointOnlyParams && breakpointOnlyParams.slidesPerView) {
      slidesPerViewParams = breakpointOnlyParams.slidesPerView;
    }
  }

  let loopedSlides = Math.ceil(parseFloat(swiperParams.loopedSlides || slidesPerViewParams, 10));
  loopedSlides += swiperParams.loopAdditionalSlides;

  if (loopedSlides > slides.length && swiperParams.loopedSlidesLimit) {
    loopedSlides = slides.length;
  }

  return loopedSlides;
};

function renderLoop(swiper, slides, swiperParams) {
  const modifiedSlides = slides.map((child, index) => {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      swiper,
      'data-swiper-slide-index': index
    });
  });

  function duplicateSlide(child, index, position) {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      key: `${child.key}-duplicate-${index}-${position}`,
      className: `${child.props.className || ''} ${swiperParams.slideDuplicateClass}`
    });
  }

  if (swiperParams.loopFillGroupWithBlank) {
    const blankSlidesNum = swiperParams.slidesPerGroup - modifiedSlides.length % swiperParams.slidesPerGroup;

    if (blankSlidesNum !== swiperParams.slidesPerGroup) {
      for (let i = 0; i < blankSlidesNum; i += 1) {
        const blankSlide = /*#__PURE__*/React__default["default"].createElement("div", {
          className: `${swiperParams.slideClass} ${swiperParams.slideBlankClass}`
        });
        modifiedSlides.push(blankSlide);
      }
    }
  }

  if (swiperParams.slidesPerView === 'auto' && !swiperParams.loopedSlides) {
    swiperParams.loopedSlides = modifiedSlides.length;
  }

  const loopedSlides = calcLoopedSlides(modifiedSlides, swiperParams);
  const prependSlides = [];
  const appendSlides = [];

  for (let i = 0; i < loopedSlides; i += 1) {
    const index = i - Math.floor(i / modifiedSlides.length) * modifiedSlides.length;
    appendSlides.push(duplicateSlide(modifiedSlides[index], i, 'append'));
    prependSlides.unshift(duplicateSlide(modifiedSlides[modifiedSlides.length - index - 1], i, 'prepend'));
  }

  if (swiper) {
    swiper.loopedSlides = loopedSlides;
  }

  return [...prependSlides, ...modifiedSlides, ...appendSlides];
}

function getChangedParams(swiperParams, oldParams, children, oldChildren, getKey) {
  const keys = [];
  if (!oldParams) return keys;

  const addKey = key => {
    if (keys.indexOf(key) < 0) keys.push(key);
  };

  if (children && oldChildren) {
    const oldChildrenKeys = oldChildren.map(getKey);
    const childrenKeys = children.map(getKey);
    if (oldChildrenKeys.join('') !== childrenKeys.join('')) addKey('children');
    if (oldChildren.length !== children.length) addKey('children');
  }

  const watchParams = paramsList.filter(key => key[0] === '_').map(key => key.replace(/_/, ''));
  watchParams.forEach(key => {
    if (key in swiperParams && key in oldParams) {
      if (isObject(swiperParams[key]) && isObject(oldParams[key])) {
        const newKeys = Object.keys(swiperParams[key]);
        const oldKeys = Object.keys(oldParams[key]);

        if (newKeys.length !== oldKeys.length) {
          addKey(key);
        } else {
          newKeys.forEach(newKey => {
            if (swiperParams[key][newKey] !== oldParams[key][newKey]) {
              addKey(key);
            }
          });
          oldKeys.forEach(oldKey => {
            if (swiperParams[key][oldKey] !== oldParams[key][oldKey]) addKey(key);
          });
        }
      } else if (swiperParams[key] !== oldParams[key]) {
        addKey(key);
      }
    }
  });
  return keys;
}

function isChildSwiperSlide(child) {
  return child.type && child.type.displayName && child.type.displayName.includes('SwiperSlide');
}

function processChildren(c) {
  const slides = [];
  React__default["default"].Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.children) {
      processChildren(child.props.children).forEach(slide => slides.push(slide));
    }
  });
  return slides;
}

function getChildren(c) {
  const slides = [];
  const slots = {
    'container-start': [],
    'container-end': [],
    'wrapper-start': [],
    'wrapper-end': []
  };
  React__default["default"].Children.toArray(c).forEach(child => {
    if (isChildSwiperSlide(child)) {
      slides.push(child);
    } else if (child.props && child.props.slot && slots[child.props.slot]) {
      slots[child.props.slot].push(child);
    } else if (child.props && child.props.children) {
      const foundSlides = processChildren(child.props.children);

      if (foundSlides.length > 0) {
        foundSlides.forEach(slide => slides.push(slide));
      } else {
        slots['container-end'].push(child);
      }
    } else {
      slots['container-end'].push(child);
    }
  });
  return {
    slides,
    slots
  };
}

function updateSwiper({
  swiper,
  slides,
  passedParams,
  changedParams,
  nextEl,
  prevEl,
  scrollbarEl,
  paginationEl
}) {
  const updateParams = changedParams.filter(key => key !== 'children' && key !== 'direction');
  const {
    params: currentParams,
    pagination,
    navigation,
    scrollbar,
    virtual,
    thumbs
  } = swiper;
  let needThumbsInit;
  let needControllerInit;
  let needPaginationInit;
  let needScrollbarInit;
  let needNavigationInit;

  if (changedParams.includes('thumbs') && passedParams.thumbs && passedParams.thumbs.swiper && currentParams.thumbs && !currentParams.thumbs.swiper) {
    needThumbsInit = true;
  }

  if (changedParams.includes('controller') && passedParams.controller && passedParams.controller.control && currentParams.controller && !currentParams.controller.control) {
    needControllerInit = true;
  }

  if (changedParams.includes('pagination') && passedParams.pagination && (passedParams.pagination.el || paginationEl) && (currentParams.pagination || currentParams.pagination === false) && pagination && !pagination.el) {
    needPaginationInit = true;
  }

  if (changedParams.includes('scrollbar') && passedParams.scrollbar && (passedParams.scrollbar.el || scrollbarEl) && (currentParams.scrollbar || currentParams.scrollbar === false) && scrollbar && !scrollbar.el) {
    needScrollbarInit = true;
  }

  if (changedParams.includes('navigation') && passedParams.navigation && (passedParams.navigation.prevEl || prevEl) && (passedParams.navigation.nextEl || nextEl) && (currentParams.navigation || currentParams.navigation === false) && navigation && !navigation.prevEl && !navigation.nextEl) {
    needNavigationInit = true;
  }

  const destroyModule = mod => {
    if (!swiper[mod]) return;
    swiper[mod].destroy();

    if (mod === 'navigation') {
      currentParams[mod].prevEl = undefined;
      currentParams[mod].nextEl = undefined;
      swiper[mod].prevEl = undefined;
      swiper[mod].nextEl = undefined;
    } else {
      currentParams[mod].el = undefined;
      swiper[mod].el = undefined;
    }
  };

  updateParams.forEach(key => {
    if (isObject(currentParams[key]) && isObject(passedParams[key])) {
      extend(currentParams[key], passedParams[key]);
    } else {
      const newValue = passedParams[key];

      if ((newValue === true || newValue === false) && (key === 'navigation' || key === 'pagination' || key === 'scrollbar')) {
        if (newValue === false) {
          destroyModule(key);
        }
      } else {
        currentParams[key] = passedParams[key];
      }
    }
  });

  if (updateParams.includes('controller') && !needControllerInit && swiper.controller && swiper.controller.control && currentParams.controller && currentParams.controller.control) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (changedParams.includes('children') && slides && virtual && currentParams.virtual.enabled) {
    virtual.slides = slides;
    virtual.update(true);
  } else if (changedParams.includes('children') && swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (needThumbsInit) {
    const initialized = thumbs.init();
    if (initialized) thumbs.update(true);
  }

  if (needControllerInit) {
    swiper.controller.control = currentParams.controller.control;
  }

  if (needPaginationInit) {
    if (paginationEl) currentParams.pagination.el = paginationEl;
    pagination.init();
    pagination.render();
    pagination.update();
  }

  if (needScrollbarInit) {
    if (scrollbarEl) currentParams.scrollbar.el = scrollbarEl;
    scrollbar.init();
    scrollbar.updateSize();
    scrollbar.setTranslate();
  }

  if (needNavigationInit) {
    if (nextEl) currentParams.navigation.nextEl = nextEl;
    if (prevEl) currentParams.navigation.prevEl = prevEl;
    navigation.init();
    navigation.update();
  }

  if (changedParams.includes('allowSlideNext')) {
    swiper.allowSlideNext = passedParams.allowSlideNext;
  }

  if (changedParams.includes('allowSlidePrev')) {
    swiper.allowSlidePrev = passedParams.allowSlidePrev;
  }

  if (changedParams.includes('direction')) {
    swiper.changeDirection(passedParams.direction, false);
  }

  swiper.update();
}

function renderVirtual(swiper, slides, virtualData) {
  if (!virtualData) return null;
  const style = swiper.isHorizontal() ? {
    [swiper.rtlTranslate ? 'right' : 'left']: `${virtualData.offset}px`
  } : {
    top: `${virtualData.offset}px`
  };
  return slides.filter((child, index) => index >= virtualData.from && index <= virtualData.to).map(child => {
    return /*#__PURE__*/React__default["default"].cloneElement(child, {
      swiper,
      style
    });
  });
}

const updateOnVirtualData = swiper => {
  if (!swiper || swiper.destroyed || !swiper.params.virtual || swiper.params.virtual && !swiper.params.virtual.enabled) return;
  swiper.updateSlides();
  swiper.updateProgress();
  swiper.updateSlidesClasses();

  if (swiper.lazy && swiper.params.lazy.enabled) {
    swiper.lazy.load();
  }

  if (swiper.parallax && swiper.params.parallax && swiper.params.parallax.enabled) {
    swiper.parallax.setTranslate();
  }
};

function useIsomorphicLayoutEffect(callback, deps) {
  // eslint-disable-next-line
  if (typeof window === 'undefined') return React.useEffect(callback, deps);
  return React.useLayoutEffect(callback, deps);
}

const SwiperSlideContext = /*#__PURE__*/React.createContext(null);
const SwiperContext = /*#__PURE__*/React.createContext(null);

function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
const Swiper = /*#__PURE__*/React.forwardRef(function (_temp, externalElRef) {
  let {
    className,
    tag: Tag = 'div',
    wrapperTag: WrapperTag = 'div',
    children,
    onSwiper,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  let eventsAssigned = false;
  const [containerClasses, setContainerClasses] = React.useState('swiper');
  const [virtualData, setVirtualData] = React.useState(null);
  const [breakpointChanged, setBreakpointChanged] = React.useState(false);
  const initializedRef = React.useRef(false);
  const swiperElRef = React.useRef(null);
  const swiperRef = React.useRef(null);
  const oldPassedParamsRef = React.useRef(null);
  const oldSlides = React.useRef(null);
  const nextElRef = React.useRef(null);
  const prevElRef = React.useRef(null);
  const paginationElRef = React.useRef(null);
  const scrollbarElRef = React.useRef(null);
  const {
    params: swiperParams,
    passedParams,
    rest: restProps,
    events
  } = getParams(rest);
  const {
    slides,
    slots
  } = getChildren(children);

  const onBeforeBreakpoint = () => {
    setBreakpointChanged(!breakpointChanged);
  };

  Object.assign(swiperParams.on, {
    _containerClasses(swiper, classes) {
      setContainerClasses(classes);
    }

  });

  const initSwiper = () => {
    // init swiper
    Object.assign(swiperParams.on, events);
    eventsAssigned = true;
    swiperRef.current = new Swiper$1(swiperParams);

    swiperRef.current.loopCreate = () => {};

    swiperRef.current.loopDestroy = () => {};

    if (swiperParams.loop) {
      swiperRef.current.loopedSlides = calcLoopedSlides(slides, swiperParams);
    }

    if (swiperRef.current.virtual && swiperRef.current.params.virtual.enabled) {
      swiperRef.current.virtual.slides = slides;
      const extendWith = {
        cache: false,
        slides,
        renderExternal: setVirtualData,
        renderExternalUpdate: false
      };
      extend(swiperRef.current.params.virtual, extendWith);
      extend(swiperRef.current.originalParams.virtual, extendWith);
    }
  };

  if (!swiperElRef.current) {
    initSwiper();
  } // Listen for breakpoints change


  if (swiperRef.current) {
    swiperRef.current.on('_beforeBreakpoint', onBeforeBreakpoint);
  }

  const attachEvents = () => {
    if (eventsAssigned || !events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.on(eventName, events[eventName]);
    });
  };

  const detachEvents = () => {
    if (!events || !swiperRef.current) return;
    Object.keys(events).forEach(eventName => {
      swiperRef.current.off(eventName, events[eventName]);
    });
  };

  React.useEffect(() => {
    return () => {
      if (swiperRef.current) swiperRef.current.off('_beforeBreakpoint', onBeforeBreakpoint);
    };
  }); // set initialized flag

  React.useEffect(() => {
    if (!initializedRef.current && swiperRef.current) {
      swiperRef.current.emitSlidesClasses();
      initializedRef.current = true;
    }
  }); // mount swiper

  useIsomorphicLayoutEffect(() => {
    if (externalElRef) {
      externalElRef.current = swiperElRef.current;
    }

    if (!swiperElRef.current) return;

    if (swiperRef.current.destroyed) {
      initSwiper();
    }

    mountSwiper({
      el: swiperElRef.current,
      nextEl: nextElRef.current,
      prevEl: prevElRef.current,
      paginationEl: paginationElRef.current,
      scrollbarEl: scrollbarElRef.current,
      swiper: swiperRef.current
    }, swiperParams);
    if (onSwiper) onSwiper(swiperRef.current); // eslint-disable-next-line

    return () => {
      if (swiperRef.current && !swiperRef.current.destroyed) {
        swiperRef.current.destroy(true, false);
      }
    };
  }, []); // watch for params change

  useIsomorphicLayoutEffect(() => {
    attachEvents();
    const changedParams = getChangedParams(passedParams, oldPassedParamsRef.current, slides, oldSlides.current, c => c.key);
    oldPassedParamsRef.current = passedParams;
    oldSlides.current = slides;

    if (changedParams.length && swiperRef.current && !swiperRef.current.destroyed) {
      updateSwiper({
        swiper: swiperRef.current,
        slides,
        passedParams,
        changedParams,
        nextEl: nextElRef.current,
        prevEl: prevElRef.current,
        scrollbarEl: scrollbarElRef.current,
        paginationEl: paginationElRef.current
      });
    }

    return () => {
      detachEvents();
    };
  }); // update on virtual update

  useIsomorphicLayoutEffect(() => {
    updateOnVirtualData(swiperRef.current);
  }, [virtualData]); // bypass swiper instance to slides

  function renderSlides() {
    if (swiperParams.virtual) {
      return renderVirtual(swiperRef.current, slides, virtualData);
    }

    if (!swiperParams.loop || swiperRef.current && swiperRef.current.destroyed) {
      return slides.map(child => {
        return /*#__PURE__*/React__default["default"].cloneElement(child, {
          swiper: swiperRef.current
        });
      });
    }

    return renderLoop(swiperRef.current, slides, swiperParams);
  }

  return /*#__PURE__*/React__default["default"].createElement(Tag, _extends$3({
    ref: swiperElRef,
    className: uniqueClasses(`${containerClasses}${className ? ` ${className}` : ''}`)
  }, restProps), /*#__PURE__*/React__default["default"].createElement(SwiperContext.Provider, {
    value: swiperRef.current
  }, slots['container-start'], /*#__PURE__*/React__default["default"].createElement(WrapperTag, {
    className: "swiper-wrapper"
  }, slots['wrapper-start'], renderSlides(), slots['wrapper-end']), needsNavigation(swiperParams) && /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("div", {
    ref: prevElRef,
    className: "swiper-button-prev"
  }), /*#__PURE__*/React__default["default"].createElement("div", {
    ref: nextElRef,
    className: "swiper-button-next"
  })), needsScrollbar(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
    ref: scrollbarElRef,
    className: "swiper-scrollbar"
  }), needsPagination(swiperParams) && /*#__PURE__*/React__default["default"].createElement("div", {
    ref: paginationElRef,
    className: "swiper-pagination"
  }), slots['container-end']));
});
Swiper.displayName = 'Swiper';

function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
const SwiperSlide = /*#__PURE__*/React.forwardRef(function (_temp, externalRef) {
  let {
    tag: Tag = 'div',
    children,
    className = '',
    swiper,
    zoom,
    virtualIndex,
    ...rest
  } = _temp === void 0 ? {} : _temp;
  const slideElRef = React.useRef(null);
  const [slideClasses, setSlideClasses] = React.useState('swiper-slide');

  function updateClasses(_s, el, classNames) {
    if (el === slideElRef.current) {
      setSlideClasses(classNames);
    }
  }

  useIsomorphicLayoutEffect(() => {
    if (externalRef) {
      externalRef.current = slideElRef.current;
    }

    if (!slideElRef.current || !swiper) {
      return;
    }

    if (swiper.destroyed) {
      if (slideClasses !== 'swiper-slide') {
        setSlideClasses('swiper-slide');
      }

      return;
    }

    swiper.on('_slideClass', updateClasses); // eslint-disable-next-line

    return () => {
      if (!swiper) return;
      swiper.off('_slideClass', updateClasses);
    };
  });
  useIsomorphicLayoutEffect(() => {
    if (swiper && slideElRef.current && !swiper.destroyed) {
      setSlideClasses(swiper.getSlideClasses(slideElRef.current));
    }
  }, [swiper]);
  const slideData = {
    isActive: slideClasses.indexOf('swiper-slide-active') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-active') >= 0,
    isVisible: slideClasses.indexOf('swiper-slide-visible') >= 0,
    isDuplicate: slideClasses.indexOf('swiper-slide-duplicate') >= 0,
    isPrev: slideClasses.indexOf('swiper-slide-prev') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-prev') >= 0,
    isNext: slideClasses.indexOf('swiper-slide-next') >= 0 || slideClasses.indexOf('swiper-slide-duplicate-next') >= 0
  };

  const renderChildren = () => {
    return typeof children === 'function' ? children(slideData) : children;
  };

  return /*#__PURE__*/React__default["default"].createElement(Tag, _extends$2({
    ref: slideElRef,
    className: uniqueClasses(`${slideClasses}${className ? ` ${className}` : ''}`),
    "data-swiper-slide-index": virtualIndex
  }, rest), /*#__PURE__*/React__default["default"].createElement(SwiperSlideContext.Provider, {
    value: slideData
  }, zoom ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: "swiper-zoom-container",
    "data-swiper-zoom": typeof zoom === 'number' ? zoom : undefined
  }, renderChildren()) : renderChildren()));
});
SwiperSlide.displayName = 'SwiperSlide';

var css$h = ".Lightbox_module_Lightbox__858f3c0b {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(27, 32, 43, 0.95);\n  z-index: 9999;\n  backdrop-filter: blur(6px);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 0.5s;\n  padding: 0;\n}\n.Lightbox_module_Lightbox__858f3c0b.Lightbox_module_LightboxOpen__858f3c0b {\n  opacity: 1;\n  pointer-events: all;\n  transition: all 0.5s;\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_swiperButtonPrev__858f3c0b {\n  background-color: transparent;\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSwiper__858f3c0b {\n  width: 100%;\n  align-items: center;\n  display: flex;\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b {\n  width: 100%;\n  height: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.3;\n  transition: all 0.5s;\n  position: relative;\n  cursor: pointer;\n  filter: blur(6px);\n}\n@media only screen and (min-width: 768px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b {\n    width: 95vw;\n    height: 100vh;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b {\n    width: 80vh;\n    height: 80vh;\n  }\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.3);\n}\n@media only screen and (min-width: 768px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b img {\n    object-fit: contain;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b img {\n    border-radius: 14px;\n  }\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 16/9;\n  border: none;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.3);\n}\n@media only screen and (min-width: 768px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n    max-height: 90vh;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n    border-radius: 14px;\n  }\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b.Lightbox_module_isVerticalVideo__858f3c0b {\n  height: 100%;\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b.Lightbox_module_isVerticalVideo__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n  aspect-ratio: 9/16;\n  width: 100%;\n  height: auto;\n}\n@media only screen and (min-width: 768px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b.Lightbox_module_isVerticalVideo__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n    width: auto;\n    height: 100%;\n    max-height: none;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxSlide__858f3c0b.Lightbox_module_LightboxVideoSlide__858f3c0b.Lightbox_module_isVerticalVideo__858f3c0b .Lightbox_module_LightboxVideoFrame__858f3c0b {\n    width: auto;\n    max-height: 90vh;\n  }\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxCaption__858f3c0b {\n  width: calc(100% - 24px);\n  min-height: 24px;\n  display: block;\n  font-family: \"Karla\", sans-serif;\n  font-size: 16px;\n  text-align: center;\n  color: #ffffff;\n  padding-top: 14px;\n  display: -webkit-box;\n  -webkit-line-clamp: 1;\n  -webkit-box-orient: vertical;\n  overflow-y: hidden;\n}\n@media only screen and (min-width: 768px) {\n  .Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxCaption__858f3c0b {\n    min-height: 42px;\n    -webkit-line-clamp: 2;\n  }\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxCaption__858f3c0b.Lightbox_module_LightCaptionHide__858f3c0b {\n  display: none;\n}\n.Lightbox_module_Lightbox__858f3c0b .Lightbox_module_LightboxClose__858f3c0b {\n  width: 48px;\n  height: 48px;\n  position: absolute;\n  top: 14px;\n  right: 14px;\n}\n\n.mdsLightbox .swiper-slide-active {\n  opacity: 1 !important;\n  filter: blur(0px);\n}\n.mdsLightbox .swiper-slide iframe, .mdsLightbox .swiper-slide video {\n  pointer-events: none;\n}\n.mdsLightbox .swiper-slide-active iframe, .mdsLightbox .swiper-slide-active video {\n  pointer-events: all;\n}\n.mdsLightbox .LightboxSwiperPrev, .mdsLightbox .LightboxSwiperNext {\n  width: 48px;\n  height: 72px;\n  position: absolute;\n  top: 50%;\n  left: 14px;\n  margin-top: -36px;\n  border-radius: 14px;\n  background-size: auto 32px;\n  transition: all 0.3s ease-in;\n  background-color: white;\n}\n.mdsLightbox .LightboxSwiperNext {\n  top: 50%;\n  right: 14px;\n  left: auto;\n}\n@media (max-width: 1024px) {\n  .mdsLightbox .LightboxSwiperNext:hover, .mdsLightbox .LightboxSwiperPrev:hover {\n    transform: scale(1.1);\n  }\n}\n.mdsLightbox .swiper-wrapper {\n  align-items: center;\n  display: flex;\n}\n.mdsLightbox .LightboxSwiperNext.swiper-button-disabled, .mdsLightbox .LightboxSwiperPrev.swiper-button-disabled {\n  pointer-events: all;\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n.mdsLightbox .LightboxSwiperNext.swiper-button-lock, .mdsLightbox .LightboxSwiperPrev.swiper-button-lock {\n  display: none;\n}";
injectCss(css$h);
var modules_cc10d3f1 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Lightbox":"Lightbox_module_Lightbox__858f3c0b","LightboxOpen":"Lightbox_module_LightboxOpen__858f3c0b","swiper-button-prev":"Lightbox_module_swiperButtonPrev__858f3c0b","LightboxSwiper":"Lightbox_module_LightboxSwiper__858f3c0b","LightboxSlide":"Lightbox_module_LightboxSlide__858f3c0b","LightboxVideoSlide":"Lightbox_module_LightboxVideoSlide__858f3c0b","LightboxVideoFrame":"Lightbox_module_LightboxVideoFrame__858f3c0b","isVerticalVideo":"Lightbox_module_isVerticalVideo__858f3c0b","LightboxCaption":"Lightbox_module_LightboxCaption__858f3c0b","LightCaptionHide":"Lightbox_module_LightCaptionHide__858f3c0b","LightboxClose":"Lightbox_module_LightboxClose__858f3c0b"};

function Lightbox(_ref, ref) {
  var LightboxItems = _ref.LightboxItems,
    _ref$appendTo = _ref.appendTo,
    appendTo = _ref$appendTo === void 0 ? document.body : _ref$appendTo,
    setSlide = _ref.setSlide;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var close = React.useCallback(function () {
    return setIsOpen(false);
  }, []);
  React.useImperativeHandle(ref, function () {
    return {
      open: function open() {
        return setIsOpen(true);
      },
      close: close
    };
  }, [close]);
  var handleEscape = React.useCallback(function (event) {
    if (event.keyCode === 27) close();
  }, [close]);
  React.useEffect(function () {
    if (isOpen) document.addEventListener("keydown", handleEscape, false);
    return function () {
      document.removeEventListener("keydown", handleEscape, false);
    };
  }, [handleEscape, isOpen]);
  return /*#__PURE__*/n$1.createPortal( /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement("dialog", {
    className: [modules_cc10d3f1.Lightbox, "mdsCloseLightbox", "mdsLightbox", isOpen ? modules_cc10d3f1.LightboxOpen : null].join(" "),
    "aria-label": "Media Lightbox",
    "aria-modal": "true"
  }, isOpen && /*#__PURE__*/React__default["default"].createElement(Swiper, {
    modules: [Navigation, Pagination, Scrollbar, A11y, Mousewheel, Keyboard, freeMode],
    slidesPerView: 'auto',
    breakpoints: {
      //when window width is >= 640px
      320: {
        slidesPerView: 1,
        spaceBetween: 24
      },
      //when window width is >= 768px
      768: {
        slidesPerView: 1,
        spaceBetween: 24
      },
      1024: {
        slidesPerView: "auto",
        spaceBetween: 24
      }
    },
    navigation: {
      nextEl: ".LightboxSwiperNext",
      prevEl: ".LightboxSwiperPrev"
    },
    centeredSlides: true,
    initialSlide: setSlide,
    slideToClickedSlide: true,
    keyboard: true,
    className: [modules_cc10d3f1.LightboxSwiper, "mdsCloseLightbox"].join(' ')
  }, LightboxItems.map(function (item, i) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      key: i,
      className: [modules_cc10d3f1.LightboxSlide, item.videoIframeSrc || item.videoFileSrc ? modules_cc10d3f1.LightboxVideoSlide : null, item.isVerticalVideo ? modules_cc10d3f1.isVerticalVideo : null].join(' ')
    }, item.videoIframeSrc ? /*#__PURE__*/React__default["default"].createElement("iframe", {
      src: item.videoIframeSrc,
      className: [modules_cc10d3f1.LightboxVideoFrame, item.isVerticalVideo ? modules_cc10d3f1.isVerticalVideo : null].join(' ')
    }) : item.videoFileSrc ? /*#__PURE__*/React__default["default"].createElement("video", {
      width: "320",
      height: "240",
      controls: true,
      className: modules_cc10d3f1.LightboxVideoFrame
    }, /*#__PURE__*/React__default["default"].createElement("source", {
      src: item.videoFileSrc,
      type: "video/mp4"
    })) : /*#__PURE__*/React__default["default"].createElement(Image, {
      src: item.src,
      alt: item.alt
    }), /*#__PURE__*/React__default["default"].createElement("div", {
      className: [modules_cc10d3f1.LightboxCaption, item.videoFileSrc || item.videoIframeSrc ? modules_cc10d3f1.LightboxCaptionHide : null].join(' '),
      title: item.caption
    }, item.caption));
  }), /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    onClick: close,
    ariaLabel: "close",
    extraClass: [modules_cc10d3f1.LightboxClose, "mdsCloseLightbox"].join(' '),
    iconDefault: "ui-close",
    color: "#fff"
  }), /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    ariaLabel: "Previous Ligthbox Slide",
    extraClass: [modules_cc10d3f1.LightboxSwiperPrev, "LightboxSwiperPrev"].join(' '),
    iconDefault: "ui-arrow-short--left",
    iconWSize: "32",
    iconHSize: "32"
  }), /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    ariaLabel: "Next Ligthbox Slide",
    extraClass: [modules_cc10d3f1.LightboxSwiperNext, "LightboxSwiperNext"].join(' '),
    iconDefault: "ui-arrow-short--right",
    iconWSize: "32",
    iconHSize: "32"
  })))), appendTo);
}
var Lightbox$1 = /*#__PURE__*/React.forwardRef(Lightbox);
Lightbox.propTypes = {
  LightboxItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    src: propTypes.exports.string.isRequired,
    mobileSrc: propTypes.exports.string,
    thumbnailSrc: propTypes.exports.string,
    videoIframeSrc: propTypes.exports.string,
    videoFileSrc: propTypes.exports.string,
    isVerticalVideo: propTypes.exports.bool,
    alt: propTypes.exports.string.isRequired,
    caption: propTypes.exports.string,
    onClick: propTypes.exports.func
  })),
  setSlide: propTypes.exports.number,
  appendTo: propTypes.exports.string
};

var css$g = ".Gallery_module_Gallery__aaad083b {\n  width: 100%;\n  height: auto;\n  position: relative;\n  padding: 24px 0;\n}\n@media (min-width: 768px) {\n  .Gallery_module_Gallery__aaad083b {\n    padding-left: 90px;\n  }\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b {\n  width: 100%;\n  height: 400px;\n  display: grid;\n  position: relative;\n  flex-shrink: 0;\n}\n@media (min-width: 575px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b {\n    min-width: calc(100vw - 104px);\n    max-width: calc(100vw - 104px);\n    max-height: 400px;\n  }\n}\n@media (min-width: 1024px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b {\n    min-width: 740px;\n    max-width: 740px;\n    height: 400px;\n  }\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: block;\n  outline: none;\n  border: 0;\n  box-shadow: 1px 4px 14px rgba(25, 25, 25, 0.3);\n  padding: 0;\n  transition: transform 0.3s ease-in-out;\n  cursor: pointer;\n}\n@media (min-width: 768px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b {\n    border-radius: 14px;\n  }\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b img {\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  position: absolute;\n  object-fit: cover;\n}\n@media (min-width: 768px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b img {\n    border-radius: 14px;\n  }\n}\n@media (min-width: 1200px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b:hover {\n    transform: skew(1deg, -1deg) scale3d(1.05, 1.05, 1);\n    z-index: 700;\n  }\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b .Gallery_module_GalleryImgButton__aaad083b:focus-visible {\n  box-shadow: 0px 0px 0px 3px #7f5f9c, 0 8px 16px rgba(68, 79, 107, 0.3);\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b:last-child {\n  margin-right: 24px;\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b:first-child {\n  padding-left: 0px;\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b.Gallery_module_GallerySlideFour__aaad083b {\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, 1fr);\n  gap: 24px;\n  grid-auto-flow: column;\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b.Gallery_module_GallerySlideFour__aaad083b.Gallery_module_GallerySlideSmall__aaad083b {\n  grid-template-columns: auto;\n}\n@media (min-width: 1024px) {\n  .Gallery_module_Gallery__aaad083b .Gallery_module_GallerySlide__aaad083b.Gallery_module_GallerySlideFour__aaad083b.Gallery_module_GallerySlideSmall__aaad083b {\n    width: 358px;\n  }\n}\n.Gallery_module_Gallery__aaad083b .Gallery_module_GalleryPlayIcon__aaad083b {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  opacity: 0.85;\n  transform: scale(0.3);\n}\n\n.gallerySwiper.swiper {\n  padding: 24px 0;\n}\n@media (min-width: 768px) {\n  .gallerySwiper.swiper {\n    padding-left: 90px;\n  }\n}\n.gallerySwiper .swiper-slide-active {\n  opacity: 1 !important;\n}\n.gallerySwiper .swiper-slide iframe, .gallerySwiper .swiper-slide video {\n  pointer-events: none;\n}\n.gallerySwiper .swiper-slide-active iframe, .gallerySwiper .swiper-slide-active video {\n  pointer-events: all;\n}\n.gallerySwiper .gallerySwiperPrev, .gallerySwiper .gallerySwiperNext {\n  width: 48px;\n  height: 72px;\n  top: 50%;\n  left: 14px;\n  margin-top: -36px;\n  border-radius: 14px;\n  background-size: auto 32px;\n  transition: all 0.3s ease-in;\n  opacity: 1;\n  position: absolute;\n  background: white;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n@media (min-width: 768px) {\n  .gallerySwiper .gallerySwiperPrev {\n    left: 104px;\n  }\n}\n.gallerySwiper .gallerySwiperNext {\n  top: 50%;\n  right: 14px;\n  left: auto;\n}\n@media (max-width: 1024px) {\n  .gallerySwiper .gallerySwiperNext:hover, .gallerySwiper .gallerySwiperPrev:hover {\n    transform: scale(1.1);\n  }\n}\n.gallerySwiper .swiper-wrapper {\n  align-items: center;\n  display: flex;\n}\n.gallerySwiper .gallerySwiperNext.swiper-button-disabled, .gallerySwiper .gallerySwiperPrev.swiper-button-disabled {\n  pointer-events: all;\n  cursor: not-allowed;\n  opacity: 0.35;\n}\n.gallerySwiper .gallerySwiperNext.swiper-button-lock, .gallerySwiper .gallerySwiperPrev.swiper-button-lock {\n  display: none;\n}";
injectCss(css$g);
var modules_7e62a870 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Gallery":"Gallery_module_Gallery__aaad083b","GallerySlide":"Gallery_module_GallerySlide__aaad083b","GalleryImgButton":"Gallery_module_GalleryImgButton__aaad083b","GallerySlideFour":"Gallery_module_GallerySlideFour__aaad083b","GallerySlideSmall":"Gallery_module_GallerySlideSmall__aaad083b","GalleryPlayIcon":"Gallery_module_GalleryPlayIcon__aaad083b"};

function Gallery(_ref) {
  var galleryItems = _ref.galleryItems,
    _ref$GalleryLenghtMob = _ref.GalleryLenghtMobileSwitch,
    GalleryLenghtMobileSwitch = _ref$GalleryLenghtMob === void 0 ? 5 : _ref$GalleryLenghtMob,
    isMobile = _ref.isMobile;
  var GalleryLength = galleryItems.length;
  var _React$useState = React__default["default"].useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2);
    _React$useState2[0];
    _React$useState2[1];
  var galleryItemsData = _toConsumableArray(Array(galleryItems.length - 1).keys());
  var galleryGroupedItems = [];
  while (galleryItemsData.length) {
    galleryGroupedItems.push(galleryItemsData.splice(0, 4));
  }
  var lightbox = React.useRef(null);
  var _useState = React.useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    currentItemIndex = _useState2[0],
    setCurrentItemIndex = _useState2[1];
  var _useState3 = React.useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    lightboxItems = _useState4[0],
    setLightboxItems = _useState4[1];
  var showLightbox = function showLightbox(index) {
    setCurrentItemIndex(index || 0);
    lightbox.current.open();
    setLightboxItems(galleryItems);
  };
  return /*#__PURE__*/React__default["default"].createElement(Section, {
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Swiper, {
    modules: [Navigation, Pagination, Scrollbar, A11y, Mousewheel, Keyboard, freeMode, Lazy],
    spaceBetween: 24,
    slidesPerView: 1,
    breakpoints: {
      // when window width is >= 640px
      320: {
        slidesPerView: 1,
        spaceBetween: 24
      },
      // when window width is >= 768px
      768: {
        slidesPerView: "auto",
        spaceBetween: 24
      }
    },
    lazy: true,
    navigation: {
      nextEl: ".gallerySwiperNext",
      prevEl: ".gallerySwiperPrev"
    },
    keyboard: true,
    className: [modules_7e62a870.Gallery, 'gallerySwiper'].join(' ')
  }, isMobile || GalleryLength < GalleryLenghtMobileSwitch ? null : /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
    className: modules_7e62a870.GallerySlide
  }, /*#__PURE__*/React__default["default"].createElement("button", {
    className: modules_7e62a870.GalleryImgButton,
    "aria-label": galleryItems[0].alt,
    "data-src": galleryItems[0].src,
    onClick: function onClick() {
      return showLightbox(0);
    }
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    src: galleryItems[0].src,
    alt: galleryItems[0].alt || galleryItems[0].caption,
    loading: "lazy"
  }), galleryItems[0].videoIframeSrc || galleryItems[0].videoFileSrc ? /*#__PURE__*/React__default["default"].createElement(Icon, {
    extraClass: modules_7e62a870.GalleryPlayIcon,
    iconName: "ui-circle-solid--play",
    iconColor: "white"
  }) : null)), isMobile || GalleryLength < GalleryLenghtMobileSwitch ? galleryItems.map(function (item, i) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      key: i,
      className: modules_7e62a870.GallerySlide
    }, /*#__PURE__*/React__default["default"].createElement("button", {
      className: modules_7e62a870.GalleryImgButton,
      "aria-label": item.alt,
      "data-src": item.src,
      onClick: function onClick() {
        return showLightbox(i);
      }
    }, /*#__PURE__*/React__default["default"].createElement("img", {
      src: item.thumbnailSrc ? item.thumbnailSrc : item.src,
      alt: item.alt || item.caption,
      loading: "lazy"
    }), item.videoIframeSrc || item.videoFileSrc ? /*#__PURE__*/React__default["default"].createElement(Icon, {
      extraClass: modules_7e62a870.GalleryPlayIcon,
      iconName: "ui-circle-solid--play",
      iconColor: "white"
    }) : null));
  }) : galleryGroupedItems.map(function (group, i) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      key: i,
      className: [modules_7e62a870.GallerySlide, modules_7e62a870.GallerySlideFour, group.length < 3 ? modules_7e62a870.GallerySlideSmall : null].join(" ")
    }, group.map(function (item, index) {
      return /*#__PURE__*/React__default["default"].createElement("button", {
        key: index,
        className: modules_7e62a870.GalleryImgButton,
        "aria-label": galleryItems[item + 1].alt,
        onClick: function onClick() {
          return showLightbox(item + 1);
        }
      }, /*#__PURE__*/React__default["default"].createElement("img", {
        src: galleryItems[item + 1].thumbnailSrc ? galleryItems[item + 1].thumbnailSrc : galleryItems[item + 1].src,
        alt: galleryItems[item + 1].alt || galleryItems[item + 1].caption,
        loading: "lazy"
      }), galleryItems[item + 1].videoIframeSrc || galleryItems[item + 1].videoFileSrc ? /*#__PURE__*/React__default["default"].createElement(Icon, {
        extraClass: modules_7e62a870.GalleryPlayIcon,
        iconName: "ui-circle-solid--play",
        iconColor: "white"
      }) : null);
    }));
  }), /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    ariaLabel: "Open Lightbox",
    extraClass: [modules_7e62a870.GallerySwiperPrev, "gallerySwiperPrev"].join(' '),
    iconDefault: "ui-arrow-short--left",
    iconWSize: 32,
    iconHSize: 32
  }), /*#__PURE__*/React__default["default"].createElement(ActionIcon, {
    ariaLabel: "Open Lightbox",
    extraClass: [modules_7e62a870.GallerySwiperNext, "gallerySwiperNext"].join(' '),
    iconDefault: "ui-arrow-short--right",
    iconWSize: 32,
    iconHSize: 32
  })), /*#__PURE__*/React__default["default"].createElement(Lightbox$1, {
    ref: lightbox,
    ariaLabel: "Main Navigation",
    LightboxItems: lightboxItems,
    setSlide: currentItemIndex
  }));
}
Gallery.propTypes = {
  isMobile: propTypes.exports.bool,
  GalleryLenghtMobileSwitch: propTypes.exports.number,
  galleryItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    src: propTypes.exports.string.isRequired,
    mobileSrc: propTypes.exports.string,
    thumbnailSrc: propTypes.exports.string,
    videoIframeSrc: propTypes.exports.string,
    videoFileSrc: propTypes.exports.string,
    alt: propTypes.exports.string.isRequired,
    onClick: propTypes.exports.func,
    caption: propTypes.exports.string
  }))
};

var css$f = "@import \"https://cdnjs.cloudflare.com/ajax/libs/Swiper/8.3.2/swiper-bundle.min.css\";\n\n.mainSwiper.swiperContainer {\n  max-width: fit-content;\n  margin: 0 auto;\n  padding: 24px 0 54px;\n}\n@media (max-width: 700px) {\n  .mainSwiper.swiperContainer {\n    padding-right: 24px;\n    padding-left: 24px;\n  }\n}\n.mainSwiper .swiper-button-next {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMjYgMjYiIGlkPSJMYXllcl8xXzE2NTQ3MjQ1OTE5NzAiIHdpZHRoPSI0NCIgaGVpZ2h0PSI0NCI+PGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMSwgMSkiPjxwYXRoIGQ9Ik03LDIxYTEuMjUsMS4yNSwwLDAsMCwxLjc3LDBsOC4zMS04LjMyYTEsMSwwLDAsMCwwLTEuNEw4Ljc3LDNBMS4yNiwxLjI2LDAsMCwwLDcsNC43NkwxNC4yNCwxMiw3LDE5LjI2QTEuMjUsMS4yNSwwLDAsMCw3LDIxWiIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHlsZT0iZmlsbDogcmdiKDY4LCA3OSwgMTA3KTsiLz48L2c+PC9zdmc+);\n  background-repeat: no-repeat;\n  background-size: 24px auto;\n  background-position: center;\n  background-color: #fff;\n  width: 48px;\n  height: 72px;\n  top: 42%;\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n@media (max-width: 700px) {\n  .mainSwiper .swiper-button-next {\n    display: none !important;\n  }\n}\n.mainSwiper .swiper-button-next::after {\n  display: none;\n}\n.mainSwiper .swiper-button-prev {\n  background-image: url(data:image/svg+xml;base64,PHN2ZyB2ZXJzaW9uPSIxLjIiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIG92ZXJmbG93PSJ2aXNpYmxlIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJub25lIiB2aWV3Qm94PSIwIDAgMjYgMjYiIGlkPSJMYXllcl8xIiB3aWR0aD0iNDQiIGhlaWdodD0iNDQiPjxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDEsIDEpIj48cGF0aCBkPSJNMTcsMy4xNWExLjI1LDEuMjUsMCwwLDAtMS43NywwTDYuOSwxMS40NmExLDEsMCwwLDAsMCwxLjQxbDguMzEsOC4zMUExLjI1LDEuMjUsMCwwLDAsMTcsMTkuNDFMOS43NCwxMi4xNiwxNyw0LjkxQTEuMjUsMS4yNSwwLDAsMCwxNywzLjE1WiIgdmVjdG9yLWVmZmVjdD0ibm9uLXNjYWxpbmctc3Ryb2tlIiBzdHlsZT0iZmlsbDogcmdiKDY4LCA3OSwgMTA3KTsiLz48L2c+PC9zdmc+);\n  background-repeat: no-repeat;\n  background-size: 24px auto;\n  background-position: center;\n  background-color: #fff;\n  width: 48px;\n  height: 72px;\n  top: 42%;\n  border-radius: 14px;\n  box-shadow: 0px 8px 16px rgba(25, 25, 25, 0.2);\n}\n@media (max-width: 700px) {\n  .mainSwiper .swiper-button-prev {\n    display: none !important;\n  }\n}\n.mainSwiper .swiper-button-prev::after {\n  display: none;\n}\n.mainSwiper .swiperAuto {\n  width: auto;\n}\n.mainSwiper .swiper-pagination {\n  font-family: \"Karla\", sans-serif;\n}\n.mainSwiper .swiper-pagination-total {\n  font-size: 16px;\n  font-weight: 700;\n  color: #444f6b;\n}\n.mainSwiper .swiper-pagination-current {\n  font-size: 16px;\n  font-weight: 400;\n  color: #444f6b;\n}\n.mainSwiper .swiper-pagination-progressbar {\n  background: #d4d4d8;\n  border-radius: 14px;\n  overflow: hidden;\n  max-width: 1920px;\n  margin: 0 auto;\n}\n.mainSwiper .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {\n  background: #444f6b;\n  border-radius: 14px;\n}";
injectCss(css$f);

function SwiperWrapper(props) {
  return /*#__PURE__*/React__default["default"].createElement(Swiper, {
    className: ["mainSwiper", "swiperContainer", props.swiperFullscreen ? "swiperFullscreen" : "", props.extraClass].join(" "),
    modules: [Navigation, Pagination, Scrollbar, A11y, Keyboard, Mousewheel, EffectFade, Parallax, freeMode],
    spaceBetween: props.spaceBetween || 24,
    slidesPerView: props.slidesPerView || "auto",
    slidesPerGroupAuto: props.slidesPerGroupAuto,
    slidesPerGroup: props.slidesPerGroup,
    loop: props.loop,
    freeMode: props.freeMode,
    loopedSlides: props.loopedSlides,
    navigation: props.navigation,
    pagination: props.pagination ? {
      clickable: true
    } : props.progressbar ? {
      type: "progressbar"
    } : props.fraction ? {
      type: "fraction"
    } : "",
    centeredSlides: props.centeredSlides,
    scrollbar: props.scrollbar ? {
      draggable: true
    } : "",
    keyboard: props.keyboard ? {
      enabled: true
    } : "",
    mousewheel: props.mousewheel,
    effect: props.fade ? "fade" : "",
    direction: props.verticalScroll ? "vertical" : "horizontal"
  }, props.children.length > 1 ? props.children.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      className: props.swiperAuto ? "swiperAuto" : "",
      key: index
    }, item);
  }) : /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
    className: props.swiperAuto ? "swiperAuto" : ""
  }, props.children));
}
var swiperPropTypes = {
  slidesPerView: propTypes.exports.number,
  slidesPerGroup: propTypes.exports.number,
  slidesPerGroupAuto: propTypes.exports.number,
  swiperAuto: propTypes.exports.bool,
  navigation: propTypes.exports.bool,
  pagination: propTypes.exports.bool,
  loop: propTypes.exports.bool,
  loopedSlides: propTypes.exports.number,
  centeredSlides: propTypes.exports.bool,
  scrollbar: propTypes.exports.bool,
  keyboard: propTypes.exports.bool,
  mousewheel: propTypes.exports.bool,
  verticalDirection: propTypes.exports.bool,
  fade: propTypes.exports.bool,
  verticalScroll: propTypes.exports.bool,
  progressbar: propTypes.exports.bool,
  fraction: propTypes.exports.bool,
  freeMode: propTypes.exports.bool,
  extraClass: propTypes.exports.string,
  slideExtraClass: propTypes.exports.string,
  spaceBetween: propTypes.exports.number
};
SwiperWrapper.propTypes = swiperPropTypes;

/**
 * https://github.com/gre/bezier-easing
 * BezierEasing - use bezier curve for transition easing function
 * by Gaëtan Renaudeau 2014 - 2015 – MIT License
 */

// These values are established by empiricism with tests (tradeoff: performance VS precision)
var NEWTON_ITERATIONS = 4;
var NEWTON_MIN_SLOPE = 0.001;
var SUBDIVISION_PRECISION = 0.0000001;
var SUBDIVISION_MAX_ITERATIONS = 10;

var kSplineTableSize = 11;
var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);

var float32ArraySupported = typeof Float32Array === 'function';

function A (aA1, aA2) { return 1.0 - 3.0 * aA2 + 3.0 * aA1; }
function B (aA1, aA2) { return 3.0 * aA2 - 6.0 * aA1; }
function C (aA1)      { return 3.0 * aA1; }

// Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.
function calcBezier (aT, aA1, aA2) { return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT; }

// Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.
function getSlope (aT, aA1, aA2) { return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1); }

function binarySubdivide (aX, aA, aB, mX1, mX2) {
  var currentX, currentT, i = 0;
  do {
    currentT = aA + (aB - aA) / 2.0;
    currentX = calcBezier(currentT, mX1, mX2) - aX;
    if (currentX > 0.0) {
      aB = currentT;
    } else {
      aA = currentT;
    }
  } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);
  return currentT;
}

function newtonRaphsonIterate (aX, aGuessT, mX1, mX2) {
 for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
   var currentSlope = getSlope(aGuessT, mX1, mX2);
   if (currentSlope === 0.0) {
     return aGuessT;
   }
   var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
   aGuessT -= currentX / currentSlope;
 }
 return aGuessT;
}

function LinearEasing (x) {
  return x;
}

var src = function bezier (mX1, mY1, mX2, mY2) {
  if (!(0 <= mX1 && mX1 <= 1 && 0 <= mX2 && mX2 <= 1)) {
    throw new Error('bezier x values must be in [0, 1] range');
  }

  if (mX1 === mY1 && mX2 === mY2) {
    return LinearEasing;
  }

  // Precompute samples table
  var sampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
  for (var i = 0; i < kSplineTableSize; ++i) {
    sampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
  }

  function getTForX (aX) {
    var intervalStart = 0.0;
    var currentSample = 1;
    var lastSample = kSplineTableSize - 1;

    for (; currentSample !== lastSample && sampleValues[currentSample] <= aX; ++currentSample) {
      intervalStart += kSampleStepSize;
    }
    --currentSample;

    // Interpolate to provide an initial guess for t
    var dist = (aX - sampleValues[currentSample]) / (sampleValues[currentSample + 1] - sampleValues[currentSample]);
    var guessForT = intervalStart + dist * kSampleStepSize;

    var initialSlope = getSlope(guessForT, mX1, mX2);
    if (initialSlope >= NEWTON_MIN_SLOPE) {
      return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
    } else if (initialSlope === 0.0) {
      return guessForT;
    } else {
      return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
    }
  }

  return function BezierEasing (x) {
    // Because JavaScript number are imprecise, we should guarantee the extremes are right.
    if (x === 0) {
      return 0;
    }
    if (x === 1) {
      return 1;
    }
    return calcBezier(getTForX(x), mY1, mY2);
  };
};

var Limits = function Limits(properties) {
  this.startX = properties.startX;
  this.startY = properties.startY;
  this.endX = properties.endX;
  this.endY = properties.endY; // Used to calculate the progress of the element

  this.totalX = this.endX - this.startX;
  this.totalY = this.endY - this.startY; // Used to scale translate effects

  this.startMultiplierX = properties.startMultiplierX || 1;
  this.endMultiplierX = properties.endMultiplierX || 1;
  this.startMultiplierY = properties.startMultiplierY || 1;
  this.endMultiplierY = properties.endMultiplierY || 1;
};

function _extends$1() {
  _extends$1 = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends$1.apply(this, arguments);
}

var ValidCSSEffects;

(function (ValidCSSEffects) {
  ValidCSSEffects["speed"] = "speed";
  ValidCSSEffects["translateX"] = "translateX";
  ValidCSSEffects["translateY"] = "translateY";
  ValidCSSEffects["rotate"] = "rotate";
  ValidCSSEffects["rotateX"] = "rotateX";
  ValidCSSEffects["rotateY"] = "rotateY";
  ValidCSSEffects["rotateZ"] = "rotateZ";
  ValidCSSEffects["scale"] = "scale";
  ValidCSSEffects["scaleX"] = "scaleX";
  ValidCSSEffects["scaleY"] = "scaleY";
  ValidCSSEffects["scaleZ"] = "scaleZ";
  ValidCSSEffects["opacity"] = "opacity";
})(ValidCSSEffects || (ValidCSSEffects = {}));

var Units;

(function (Units) {
  Units["px"] = "px";
  Units["%"] = "%";
  Units["vh"] = "vh";
  Units["vw"] = "vw";
})(Units || (Units = {}));

var RotationUnits;

(function (RotationUnits) {
  RotationUnits["deg"] = "deg";
  RotationUnits["turn"] = "turn";
  RotationUnits["rad"] = "rad";
})(RotationUnits || (RotationUnits = {}));

var ScaleUnits;

(function (ScaleUnits) {
  ScaleUnits[""] = "";
})(ScaleUnits || (ScaleUnits = {}));

var ScrollAxis;

(function (ScrollAxis) {
  ScrollAxis["vertical"] = "vertical";
  ScrollAxis["horizontal"] = "horizontal";
})(ScrollAxis || (ScrollAxis = {}));

var EasingPreset;

(function (EasingPreset) {
  EasingPreset["ease"] = "ease";
  EasingPreset["easeIn"] = "easeIn";
  EasingPreset["easeOut"] = "easeOut";
  EasingPreset["easeInOut"] = "easeInOut";
  EasingPreset["easeInQuad"] = "easeInQuad";
  EasingPreset["easeInCubic"] = "easeInCubic";
  EasingPreset["easeInQuart"] = "easeInQuart";
  EasingPreset["easeInQuint"] = "easeInQuint";
  EasingPreset["easeInSine"] = "easeInSine";
  EasingPreset["easeInExpo"] = "easeInExpo";
  EasingPreset["easeInCirc"] = "easeInCirc";
  EasingPreset["easeOutQuad"] = "easeOutQuad";
  EasingPreset["easeOutCubic"] = "easeOutCubic";
  EasingPreset["easeOutQuart"] = "easeOutQuart";
  EasingPreset["easeOutQuint"] = "easeOutQuint";
  EasingPreset["easeOutSine"] = "easeOutSine";
  EasingPreset["easeOutExpo"] = "easeOutExpo";
  EasingPreset["easeOutCirc"] = "easeOutCirc";
  EasingPreset["easeInOutQuad"] = "easeInOutQuad";
  EasingPreset["easeInOutCubic"] = "easeInOutCubic";
  EasingPreset["easeInOutQuart"] = "easeInOutQuart";
  EasingPreset["easeInOutQuint"] = "easeInOutQuint";
  EasingPreset["easeInOutSine"] = "easeInOutSine";
  EasingPreset["easeInOutExpo"] = "easeInOutExpo";
  EasingPreset["easeInOutCirc"] = "easeInOutCirc";
  EasingPreset["easeInBack"] = "easeInBack";
  EasingPreset["easeOutBack"] = "easeOutBack";
  EasingPreset["easeInOutBack"] = "easeInOutBack";
})(EasingPreset || (EasingPreset = {}));

/**
 * Creates a unique id to distinguish parallax elements.
 */
var id = 0;
function createId() {
  ++id;
  return id;
}

var Rect = /*#__PURE__*/function () {
  function Rect(options) {
    var rect = options.el.getBoundingClientRect(); // rect is based on viewport -- must adjust for relative scroll container

    if (options.view.scrollContainer) {
      var scrollRect = options.view.scrollContainer.getBoundingClientRect();
      rect = _extends$1({}, rect, {
        top: rect.top - scrollRect.top,
        right: rect.right - scrollRect.left,
        bottom: rect.bottom - scrollRect.top,
        left: rect.left - scrollRect.left
      });
    }

    this.height = options.el.offsetHeight;
    this.width = options.el.offsetWidth;
    this.left = rect.left;
    this.right = rect.right;
    this.top = rect.top;
    this.bottom = rect.bottom;

    if (options.rootMargin) {
      this._setRectWithRootMargin(options.rootMargin);
    }
  }
  /**
   * Apply root margin to all properties
   */


  var _proto = Rect.prototype;

  _proto._setRectWithRootMargin = function _setRectWithRootMargin(rootMargin) {
    var totalRootY = rootMargin.top + rootMargin.bottom;
    var totalRootX = rootMargin.left + rootMargin.right;
    this.top -= rootMargin.top;
    this.right += rootMargin.right;
    this.bottom += rootMargin.bottom;
    this.left -= rootMargin.left;
    this.height += totalRootY;
    this.width += totalRootX;
  };

  return Rect;
}();

var VALID_UNITS = [ScaleUnits[''], Units.px, Units['%'], Units['vh'], Units['vw'], RotationUnits.deg, RotationUnits.turn, RotationUnits.rad];
/**
 * Determines the unit of a string and parses the value
 */

function parseValueAndUnit(str, defaultUnit) {
  if (defaultUnit === void 0) {
    defaultUnit = Units['%'];
  }

  var out = {
    value: 0,
    unit: defaultUnit
  };
  if (typeof str === 'undefined') return out;
  var isValid = typeof str === 'number' || typeof str === 'string';

  if (!isValid) {
    throw new Error('Invalid value provided. Must provide a value as a string or number');
  }

  str = String(str);
  out.value = parseFloat(str); // @ts-ignore

  out.unit = str.match(/[\d.\-+]*\s*(.*)/)[1] || defaultUnit; // @ts-expect-error

  var isValidUnit = VALID_UNITS.includes(out.unit);

  if (!isValidUnit) {
    throw new Error('Invalid unit provided.');
  }

  return out;
}

var easingPresets = {
  ease: [0.25, 0.1, 0.25, 1.0],
  easeIn: [0.42, 0.0, 1.0, 1.0],
  easeOut: [0.0, 0.0, 0.58, 1.0],
  easeInOut: [0.42, 0.0, 0.58, 1.0],

  /* Ease IN curves */
  easeInQuad: [0.55, 0.085, 0.68, 0.53],
  easeInCubic: [0.55, 0.055, 0.675, 0.19],
  easeInQuart: [0.895, 0.03, 0.685, 0.22],
  easeInQuint: [0.755, 0.05, 0.855, 0.06],
  easeInSine: [0.47, 0.0, 0.745, 0.715],
  easeInExpo: [0.95, 0.05, 0.795, 0.035],
  easeInCirc: [0.6, 0.04, 0.98, 0.335],

  /* Ease Out Curves */
  easeOutQuad: [0.25, 0.46, 0.45, 0.94],
  easeOutCubic: [0.215, 0.61, 0.355, 1.0],
  easeOutQuart: [0.165, 0.84, 0.44, 1.0],
  easeOutQuint: [0.23, 1.0, 0.32, 1.0],
  easeOutSine: [0.39, 0.575, 0.565, 1.0],
  easeOutExpo: [0.19, 1.0, 0.22, 1.0],
  easeOutCirc: [0.075, 0.82, 0.165, 1.0],

  /* Ease IN Out Curves */
  easeInOutQuad: [0.455, 0.03, 0.515, 0.955],
  easeInOutCubic: [0.645, 0.045, 0.355, 1.0],
  easeInOutQuart: [0.77, 0.0, 0.175, 1.0],
  easeInOutQuint: [0.86, 0.0, 0.07, 1.0],
  easeInOutSine: [0.445, 0.05, 0.55, 0.95],
  easeInOutExpo: [1.0, 0.0, 0.0, 1.0],
  easeInOutCirc: [0.785, 0.135, 0.15, 0.86],

  /* Ease Bounce Curves */
  easeInBack: [0.6, -0.28, 0.735, 0.045],
  easeOutBack: [0.175, 0.885, 0.32, 1.275],
  easeInOutBack: [0.68, -0.55, 0.265, 1.55]
};

function createEasingFunction(easing) {
  if (Array.isArray(easing)) {
    return src(easing[0], easing[1], easing[2], easing[3]);
  }

  if (typeof easing === 'string' && typeof easingPresets[easing] !== 'undefined') {
    var params = easingPresets[easing];
    return src(params[0], params[1], params[2], params[3]);
  }

  return;
}

var PARALLAX_EFFECTS = /*#__PURE__*/Object.values(ValidCSSEffects);
var MAP_EFFECT_TO_DEFAULT_UNIT = {
  speed: 'px',
  translateX: '%',
  translateY: '%',
  rotate: 'deg',
  rotateX: 'deg',
  rotateY: 'deg',
  rotateZ: 'deg',
  scale: '',
  scaleX: '',
  scaleY: '',
  scaleZ: '',
  opacity: ''
};
/**
 * Takes a parallax element effects and parses the properties to get the start and end values and units.
 */

function parseElementTransitionEffects(props, scrollAxis) {
  var parsedEffects = {};
  PARALLAX_EFFECTS.forEach(function (key) {
    var defaultValue = MAP_EFFECT_TO_DEFAULT_UNIT[key]; // If the provided type is a number, this must be the speed prop
    // in which case we need to construct the proper translate config

    if (typeof (props == null ? void 0 : props[key]) === 'number') {
      var value = props == null ? void 0 : props[key];
      var startSpeed = (value || 0) * 10 + "px";
      var endSpeed = (value || 0) * -10 + "px";
      var startParsed = parseValueAndUnit(startSpeed);
      var endParsed = parseValueAndUnit(endSpeed);
      var speedConfig = {
        start: startParsed.value,
        end: endParsed.value,
        unit: startParsed.unit
      }; // Manually set translate y value

      if (scrollAxis === ScrollAxis.vertical) {
        parsedEffects.translateY = speedConfig;
      } // Manually set translate y value


      if (scrollAxis === ScrollAxis.horizontal) {
        parsedEffects.translateX = speedConfig;
      }
    } // The rest are standard effect being parsed


    if (Array.isArray(props == null ? void 0 : props[key])) {
      var _value = props == null ? void 0 : props[key];

      if (typeof _value[0] !== 'undefined' && typeof _value[1] !== 'undefined') {
        var _startParsed = parseValueAndUnit(_value == null ? void 0 : _value[0], defaultValue);

        var _endParsed = parseValueAndUnit(_value == null ? void 0 : _value[1], defaultValue);

        var easing = createEasingFunction(_value == null ? void 0 : _value[2]);
        parsedEffects[key] = {
          start: _startParsed.value,
          end: _endParsed.value,
          unit: _startParsed.unit,
          easing: easing
        };

        if (_startParsed.unit !== _endParsed.unit) {
          throw new Error('Must provide matching units for the min and max offset values of each axis.');
        }
      }
    }
  });
  return parsedEffects;
}

/**
 * Returns the percent (0 - 100) moved based on position in the viewport
 */
function getProgressAmount(
/*
 * The start value from cache
 */
start,
/*
 * total dist the element has to move to be 100% complete (view width/height + element width/height)
 */
totalDist,
/*
 * Current scroll value
 */
currentScroll,
/*
 * an optional easing function to apply
 */
easing) {
  // adjust cached value
  var startAdjustedScroll = currentScroll - start; // Amount the element has moved based on current and total distance to move

  var amount = startAdjustedScroll / totalDist; // Apply bezier easing if provided

  if (easing) {
    amount = easing(amount);
  }

  return amount;
}

/**
 * Takes two values (start, end) and returns whether the current scroll is within range
 * @param {number} start - start of scroll (x/y)
 * @param {number} end - end of scroll (x/y)
 * @param {number} scroll - current scroll (x/y)
 * @return {boolean} isInView
 */
function isElementInView(start, end, scroll) {
  var isInView = scroll >= start && scroll <= end;
  return isInView;
}

// Scale between AKA normalize
function scaleBetween(value, newMin, newMax, oldMin, oldMax) {
  return (newMax - newMin) * (value - oldMin) / (oldMax - oldMin) + newMin;
}

/**
 * Scales a start and end value of an effect based on percent moved and easing function
 */

function scaleEffectByProgress(effect, progress) {
  var value = scaleBetween(typeof effect.easing === 'function' ? effect.easing(progress) : progress, (effect == null ? void 0 : effect.start) || 0, (effect == null ? void 0 : effect.end) || 0, 0, 1);
  return {
    value: value,
    unit: effect == null ? void 0 : effect.unit
  };
}

var TRANSFORM_EFFECTS = /*#__PURE__*/Object.values(ValidCSSEffects).filter(function (v) {
  return v !== 'opacity';
});
function setWillChangeStyles(el, effects) {
  var keys = Object.keys(effects);
  var hasOpacity = keys.includes('opacity');
  var willChange = "transform" + (hasOpacity ? ',opacity' : '');
  el.style.willChange = willChange;
}
function setElementStyles(effects, progress, el) {
  if (!el) return;
  var transform = getTransformStyles(effects, progress);
  var opacity = getOpacityStyles(effects, progress);
  el.style.transform = transform;
  el.style.opacity = opacity;
}
function getOpacityStyles(effects, progress) {
  var scaledOpacity = effects['opacity'] && scaleEffectByProgress(effects['opacity'], progress);

  if (typeof scaledOpacity === 'undefined' || typeof scaledOpacity.value === 'undefined' || typeof scaledOpacity.unit === 'undefined') {
    return '';
  }

  var styleStr = "" + scaledOpacity.value;
  return styleStr;
}
function getTransformStyles(effects, progress) {
  var transform = TRANSFORM_EFFECTS.reduce(function (acc, key) {
    var scaledEffect = // @ts-expect-error
    effects[key] && scaleEffectByProgress(effects[key], progress);

    if (typeof scaledEffect === 'undefined' || typeof scaledEffect.value === 'undefined' || typeof scaledEffect.unit === 'undefined') {
      return acc;
    }

    var styleStr = key + "(" + scaledEffect.value + scaledEffect.unit + ")";
    return acc + styleStr;
  }, '');
  return transform;
}
/**
 * Takes a parallax element and removes parallax offset styles.
 * @param {object} element
 */

function resetStyles(element) {
  var el = element.el;
  if (!el) return;
  el.style.transform = '';
  el.style.opacity = '';
}

function createLimitsForRelativeElements(rect, view, scroll, shouldAlwaysCompleteAnimation) {
  var startY = rect.top - view.height;
  var startX = rect.left - view.width;
  var endY = rect.bottom;
  var endX = rect.right; // add scroll

  startX += scroll.x;
  endX += scroll.x;
  startY += scroll.y;
  endY += scroll.y;

  if (shouldAlwaysCompleteAnimation) {
    if (scroll.y + rect.top < view.height) {
      startY = 0;
    }

    if (scroll.x + rect.left < view.width) {
      startX = 0;
    }

    if (endY > view.scrollHeight - view.height) {
      endY = view.scrollHeight - view.height;
    }

    if (endX > view.scrollWidth - view.width) {
      endX = view.scrollWidth - view.width;
    }
  }

  var limits = new Limits({
    startX: startX,
    startY: startY,
    endX: endX,
    endY: endY
  });
  return limits;
}

function getTranslateScalar(startTranslatePx, endTranslatePx, totalDist) {
  var slow = endTranslatePx > startTranslatePx; // calculating necessary scale to increase translations

  var totalAbsOff = (Math.abs(startTranslatePx) + Math.abs(endTranslatePx)) * (slow ? -1 : 1);
  var totalDistTrue = totalDist + totalAbsOff; // Determine multiple to scale by, only values greater than 1

  var scale = Math.max(totalDist / totalDistTrue, 1);
  return scale;
}

/**
 * Return the start and end pixel values for an elements translations
 */
function getStartEndValueInPx(translate, elementSize) {
  var start = translate.start,
      end = translate.end,
      unit = translate.unit;

  if (unit === '%') {
    var scale = elementSize / 100;
    start = start * scale;
    end = end * scale;
  }

  if (unit === 'vw') {
    var startScale = start / 100;
    var endScale = end / 100;
    start = window.innerWidth * startScale;
    end = window.innerWidth * endScale;
  }

  if (unit === 'vh') {
    var _startScale = start / 100;

    var _endScale = end / 100;

    start = window.innerHeight * _startScale;
    end = window.innerHeight * _endScale;
  }

  return {
    start: start,
    end: end
  };
}

var DEFAULT_VALUE = {
  start: 0,
  end: 0,
  unit: ''
};
function createLimitsWithTranslationsForRelativeElements(rect, view, effects, scroll, scrollAxis, shouldAlwaysCompleteAnimation) {
  // get start and end accounting for percent effects
  var translateX = effects.translateX || DEFAULT_VALUE;
  var translateY = effects.translateY || DEFAULT_VALUE;

  var _getStartEndValueInPx = getStartEndValueInPx(translateX, rect.width),
      startTranslateXPx = _getStartEndValueInPx.start,
      endTranslateXPx = _getStartEndValueInPx.end;

  var _getStartEndValueInPx2 = getStartEndValueInPx(translateY, rect.height),
      startTranslateYPx = _getStartEndValueInPx2.start,
      endTranslateYPx = _getStartEndValueInPx2.end; // default starting values


  var startY = rect.top - view.height;
  var startX = rect.left - view.width;
  var endY = rect.bottom;
  var endX = rect.right;
  var startMultiplierY = 1;
  var endMultiplierY = 1;

  if (scrollAxis === ScrollAxis.vertical) {
    startMultiplierY = getTranslateScalar(startTranslateYPx, endTranslateYPx, view.height + rect.height);
    endMultiplierY = startMultiplierY;
  }

  var startMultiplierX = 1;
  var endMultiplierX = 1;

  if (scrollAxis === ScrollAxis.horizontal) {
    startMultiplierX = getTranslateScalar(startTranslateXPx, endTranslateXPx, view.width + rect.width);
    endMultiplierX = startMultiplierX;
  } // Apply the scale to initial values


  if (startTranslateYPx < 0) {
    startY = startY + startTranslateYPx * startMultiplierY;
  }

  if (endTranslateYPx > 0) {
    endY = endY + endTranslateYPx * endMultiplierY;
  }

  if (startTranslateXPx < 0) {
    startX = startX + startTranslateXPx * startMultiplierX;
  }

  if (endTranslateXPx > 0) {
    endX = endX + endTranslateXPx * endMultiplierX;
  } // add scroll


  startX += scroll.x;
  endX += scroll.x;
  startY += scroll.y;
  endY += scroll.y; // NOTE: please refactor and isolate this :(

  if (shouldAlwaysCompleteAnimation) {
    var topBeginsInView = scroll.y + rect.top < view.height;
    var leftBeginsInView = scroll.x + rect.left < view.width;
    var bottomEndsInView = scroll.y + rect.bottom > view.scrollHeight - view.height;
    var rightEndsInView = scroll.x + rect.right > view.scrollWidth - view.height;

    if (topBeginsInView && bottomEndsInView) {
      startMultiplierY = 1;
      endMultiplierY = 1;
      startY = 0;
      endY = view.scrollHeight - view.height;
    }

    if (leftBeginsInView && rightEndsInView) {
      startMultiplierX = 1;
      endMultiplierX = 1;
      startX = 0;
      endX = view.scrollWidth - view.width;
    }

    if (!topBeginsInView && bottomEndsInView) {
      startY = rect.top - view.height + scroll.y;
      endY = view.scrollHeight - view.height;
      var totalDist = endY - startY;
      startMultiplierY = getTranslateScalar(startTranslateYPx, endTranslateYPx, totalDist);
      endMultiplierY = 1;

      if (startTranslateYPx < 0) {
        startY = startY + startTranslateYPx * startMultiplierY;
      }
    }

    if (!leftBeginsInView && rightEndsInView) {
      startX = rect.left - view.width + scroll.x;
      endX = view.scrollWidth - view.width;

      var _totalDist = endX - startX;

      startMultiplierX = getTranslateScalar(startTranslateXPx, endTranslateXPx, _totalDist);
      endMultiplierX = 1;

      if (startTranslateXPx < 0) {
        startX = startX + startTranslateXPx * startMultiplierX;
      }
    }

    if (topBeginsInView && !bottomEndsInView) {
      startY = 0;
      endY = rect.bottom + scroll.y;

      var _totalDist2 = endY - startY;

      startMultiplierY = 1;
      endMultiplierY = getTranslateScalar(startTranslateYPx, endTranslateYPx, _totalDist2);

      if (endTranslateYPx > 0) {
        endY = endY + endTranslateYPx * endMultiplierY;
      }
    }

    if (leftBeginsInView && !rightEndsInView) {
      startX = 0;
      endX = rect.right + scroll.x;

      var _totalDist3 = endX - startX;

      startMultiplierX = 1;
      endMultiplierX = getTranslateScalar(startTranslateXPx, endTranslateXPx, _totalDist3);

      if (endTranslateXPx > 0) {
        endX = endX + endTranslateXPx * endMultiplierX;
      }
    }
  }

  var limits = new Limits({
    startX: startX,
    startY: startY,
    endX: endX,
    endY: endY,
    startMultiplierX: startMultiplierX,
    endMultiplierX: endMultiplierX,
    startMultiplierY: startMultiplierY,
    endMultiplierY: endMultiplierY
  });
  return limits;
}

function scaleTranslateEffectsForSlowerScroll(effects, limits) {
  var effectsCopy = _extends$1({}, effects);

  if (effectsCopy.translateX) {
    effectsCopy.translateX = _extends$1({}, effects.translateX, {
      start: effectsCopy.translateX.start * limits.startMultiplierX,
      end: effectsCopy.translateX.end * limits.endMultiplierX
    });
  }

  if (effectsCopy.translateY) {
    effectsCopy.translateY = _extends$1({}, effects.translateY, {
      start: effectsCopy.translateY.start * limits.startMultiplierY,
      end: effectsCopy.translateY.end * limits.endMultiplierY
    });
  }

  return effectsCopy;
}

function getShouldScaleTranslateEffects(props, effects, scrollAxis) {
  if (props.rootMargin || props.targetElement || props.shouldDisableScalingTranslations) {
    return false;
  }

  if (!!effects.translateX && scrollAxis === ScrollAxis.horizontal || !!effects.translateY && scrollAxis === ScrollAxis.vertical) {
    return true;
  }

  return false;
}

var clamp = function clamp(num, min, max) {
  return Math.min(Math.max(num, min), max);
};

var Element$1 = /*#__PURE__*/function () {
  function Element(options) {
    this.el = options.el;
    this.props = options.props;
    this.scrollAxis = options.scrollAxis;
    this.id = createId();
    this.effects = parseElementTransitionEffects(this.props, this.scrollAxis);
    this.isInView = null;
    this.progress = 0;

    this._setElementEasing(options.props.easing);

    setWillChangeStyles(options.el, this.effects);
  }

  var _proto = Element.prototype;

  _proto.updateProps = function updateProps(nextProps) {
    this.props = _extends$1({}, this.props, nextProps);
    this.effects = parseElementTransitionEffects(nextProps, this.scrollAxis);

    this._setElementEasing(nextProps.easing);

    return this;
  };

  _proto.setCachedAttributes = function setCachedAttributes(view, scroll) {
    // NOTE: Must reset styles before getting the rect, as it might impact the natural position
    resetStyles(this);
    this.rect = new Rect({
      el: this.props.targetElement || this.el,
      rootMargin: this.props.rootMargin,
      view: view
    });
    var shouldScaleTranslateEffects = getShouldScaleTranslateEffects(this.props, this.effects, this.scrollAxis);

    if (typeof this.props.startScroll === 'number' && typeof this.props.endScroll === 'number') {
      this.limits = new Limits({
        startX: this.props.startScroll,
        startY: this.props.startScroll,
        endX: this.props.endScroll,
        endY: this.props.endScroll
      }); // Undo the reset -- place it back at current position with styles

      this._setElementStyles();

      return this;
    }

    if (shouldScaleTranslateEffects) {
      this.limits = createLimitsWithTranslationsForRelativeElements(this.rect, view, this.effects, scroll, this.scrollAxis, this.props.shouldAlwaysCompleteAnimation);
      this.scaledEffects = scaleTranslateEffectsForSlowerScroll(this.effects, this.limits);
    } else {
      this.limits = createLimitsForRelativeElements(this.rect, view, scroll, this.props.shouldAlwaysCompleteAnimation);
    } // Undo the reset -- place it back at current position with styles


    this._setElementStyles();

    return this;
  };

  _proto._updateElementIsInView = function _updateElementIsInView(nextIsInView) {
    // NOTE: Check if this is the first change to make sure onExit isn't called
    var isFirstChange = this.isInView === null;

    if (nextIsInView !== this.isInView) {
      if (nextIsInView) {
        this.props.onEnter && this.props.onEnter(this);
      } else if (!isFirstChange) {
        this._setFinalProgress();

        this._setElementStyles();

        this.props.onExit && this.props.onExit(this);
      }
    }

    this.isInView = nextIsInView;
  };

  _proto._setFinalProgress = function _setFinalProgress() {
    var finalProgress = clamp(Math.round(this.progress), 0, 1);

    this._updateElementProgress(finalProgress);
  };

  _proto._setElementStyles = function _setElementStyles() {
    if (this.props.disabled) return;
    var effects = this.scaledEffects || this.effects;
    setElementStyles(effects, this.progress, this.el);
  };

  _proto._updateElementProgress = function _updateElementProgress(nextProgress) {
    this.progress = nextProgress;
    this.props.onProgressChange && this.props.onProgressChange(this.progress);
    this.props.onChange && this.props.onChange(this);
  };

  _proto._setElementEasing = function _setElementEasing(easing) {
    this.easing = createEasingFunction(easing);
  };

  _proto.updatePosition = function updatePosition(scroll) {
    if (!this.limits) return this;
    var isVertical = this.scrollAxis === ScrollAxis.vertical;
    var isFirstChange = this.isInView === null; // based on scroll axis

    var start = isVertical ? this.limits.startY : this.limits.startX;
    var end = isVertical ? this.limits.endY : this.limits.endX;
    var total = isVertical ? this.limits.totalY : this.limits.totalX;
    var s = isVertical ? scroll.y : scroll.x; // check if in view

    var nextIsInView = isElementInView(start, end, s);

    this._updateElementIsInView(nextIsInView); // set the progress if in view or this is the first change


    if (nextIsInView) {
      var nextProgress = getProgressAmount(start, total, s, this.easing);

      this._updateElementProgress(nextProgress);

      this._setElementStyles();
    } else if (isFirstChange) {
      // NOTE: this._updateElementProgress -- dont use this because it will trigger onChange
      this.progress = clamp(Math.round(getProgressAmount(start, total, s, this.easing)), 0, 1);

      this._setElementStyles();
    }

    return this;
  };

  return Element;
}();

var View = /*#__PURE__*/function () {
  function View(config) {
    this.scrollContainer = config.scrollContainer;
    this.width = config.width;
    this.height = config.height;
    this.scrollHeight = config.scrollHeight;
    this.scrollWidth = config.scrollWidth;
  }

  var _proto = View.prototype;

  _proto.hasChanged = function hasChanged(params) {
    if (params.width !== this.width || params.height !== this.height || params.scrollWidth !== this.scrollWidth || params.scrollHeight !== this.scrollHeight) {
      return true;
    }

    return false;
  };

  _proto.setSize = function setSize(params) {
    this.width = params.width;
    this.height = params.height;
    this.scrollHeight = params.scrollHeight;
    this.scrollWidth = params.scrollWidth;
    return this;
  };

  return View;
}();

var Scroll = /*#__PURE__*/function () {
  function Scroll(x, y) {
    this.x = x;
    this.y = y;
    this.dx = 0;
    this.dy = 0;
  }

  var _proto = Scroll.prototype;

  _proto.setScroll = function setScroll(x, y) {
    this.dx = x - this.x;
    this.dy = y - this.y;
    this.x = x;
    this.y = y;
    return this;
  };

  return Scroll;
}();

function testForPassiveScroll() {
  var supportsPassiveOption = false;

  try {
    var opts = Object.defineProperty({}, 'passive', {
      get: function get() {
        supportsPassiveOption = true;
        return true;
      }
    }); // @ts-expect-error

    window.addEventListener('test', null, opts); // @ts-expect-error

    window.removeEventListener('test', null, opts);
  } catch (e) {}

  return supportsPassiveOption;
}

/**
 * -------------------------------------------------------
 * Parallax Controller
 * -------------------------------------------------------
 *
 * The global controller for setting up and managing a scroll view of elements.
 *
 */

var ParallaxController = /*#__PURE__*/function () {
  function ParallaxController(_ref) {
    var _ref$scrollAxis = _ref.scrollAxis,
        scrollAxis = _ref$scrollAxis === void 0 ? ScrollAxis.vertical : _ref$scrollAxis,
        scrollContainer = _ref.scrollContainer;
    this.scrollAxis = scrollAxis; // All parallax elements to be updated

    this.elements = [];
    this._hasScrollContainer = !!scrollContainer;
    this.viewEl = scrollContainer != null ? scrollContainer : window; // Scroll and View

    var _this$_getScrollPosit = this._getScrollPosition(),
        x = _this$_getScrollPosit[0],
        y = _this$_getScrollPosit[1];

    this.scroll = new Scroll(x, y);
    this.view = new View({
      width: 0,
      height: 0,
      scrollWidth: 0,
      scrollHeight: 0,
      scrollContainer: this._hasScrollContainer ? scrollContainer : undefined
    }); // Ticking

    this._ticking = false; // Passive support

    this._supportsPassive = testForPassiveScroll(); // Bind methods to class

    this._bindAllMethods();

    this._addListeners(this.viewEl);

    this._addResizeObserver();

    this._setViewSize();
  }
  /**
   * Static method to instantiate the ParallaxController.
   * @returns {Class} ParallaxController
   */


  ParallaxController.init = function init(options) {
    var hasWindow = typeof window !== 'undefined';

    if (!hasWindow) {
      throw new Error('Looks like ParallaxController.init() was called on the server. This method must be called on the client.');
    }

    return new ParallaxController(options);
  };

  var _proto = ParallaxController.prototype;

  _proto._bindAllMethods = function _bindAllMethods() {
    var _this = this;

    ['_addListeners', '_removeListeners', '_getScrollPosition', '_handleScroll', '_handleUpdateCache', '_updateAllElements', '_updateElementPosition', '_setViewSize', '_addResizeObserver', '_checkIfViewHasChanged', '_getViewParams', 'getElements', 'createElement', 'removeElementById', 'resetElementStyles', 'updateElementPropsById', 'update', 'updateScrollContainer', 'destroy'].forEach(function (method) {
      // @ts-expect-error
      _this[method] = _this[method].bind(_this);
    });
  };

  _proto._addListeners = function _addListeners(el) {
    el.addEventListener('scroll', this._handleScroll, this._supportsPassive ? {
      passive: true
    } : false);
    window.addEventListener('resize', this._handleUpdateCache, false);
    window.addEventListener('blur', this._handleUpdateCache, false);
    window.addEventListener('focus', this._handleUpdateCache, false);
    window.addEventListener('load', this._handleUpdateCache, false);
  };

  _proto._removeListeners = function _removeListeners(el) {
    var _this$_resizeObserver;

    el.removeEventListener('scroll', this._handleScroll, false);
    window.removeEventListener('resize', this._handleUpdateCache, false);
    window.removeEventListener('blur', this._handleUpdateCache, false);
    window.removeEventListener('focus', this._handleUpdateCache, false);
    window.removeEventListener('load', this._handleUpdateCache, false);
    (_this$_resizeObserver = this._resizeObserver) == null ? void 0 : _this$_resizeObserver.disconnect();
  };

  _proto._addResizeObserver = function _addResizeObserver() {
    var _this2 = this;

    try {
      var observedEl = this._hasScrollContainer ? this.viewEl : document.documentElement;
      this._resizeObserver = new ResizeObserver(function () {
        return _this2.update();
      });

      this._resizeObserver.observe(observedEl);
    } catch (e) {
      console.warn('Failed to create the resize observer in the ParallaxContoller');
    }
  };

  _proto._getScrollPosition = function _getScrollPosition() {
    // Save current scroll
    // Supports IE 9 and up.
    var nx = this._hasScrollContainer ? // @ts-expect-error
    this.viewEl.scrollLeft : window.pageXOffset;
    var ny = this._hasScrollContainer ? // @ts-expect-error
    this.viewEl.scrollTop : window.pageYOffset;
    return [nx, ny];
  }
  /**
   * Window scroll handler sets scroll position
   * and then calls '_updateAllElements()'.
   */
  ;

  _proto._handleScroll = function _handleScroll() {
    var _this$_getScrollPosit2 = this._getScrollPosition(),
        nx = _this$_getScrollPosit2[0],
        ny = _this$_getScrollPosit2[1];

    this.scroll.setScroll(nx, ny); // Only called if the last animation request has been
    // completed and there are parallax elements to update

    if (!this._ticking && this.elements.length > 0) {
      this._ticking = true; // @ts-ignore

      window.requestAnimationFrame(this._updateAllElements);
    }
  }
  /**
   * Window resize handler. Sets the new window inner height
   * then updates parallax element attributes and positions.
   */
  ;

  _proto._handleUpdateCache = function _handleUpdateCache() {
    this._setViewSize();

    this._updateAllElements({
      updateCache: true
    });
  }
  /**
   * Update element positions.
   * Determines if the element is in view based on the cached
   * attributes, if so set the elements parallax styles.
   */
  ;

  _proto._updateAllElements = function _updateAllElements(_temp) {
    var _this3 = this;

    var _ref2 = _temp === void 0 ? {} : _temp,
        updateCache = _ref2.updateCache;

    if (this.elements) {
      this.elements.forEach(function (element) {
        if (updateCache) {
          element.setCachedAttributes(_this3.view, _this3.scroll);
        }

        _this3._updateElementPosition(element);
      });
    } // reset ticking so more animations can be called


    this._ticking = false;
  }
  /**
   * Update element positions.
   * Determines if the element is in view based on the cached
   * attributes, if so set the elements parallax styles.
   */
  ;

  _proto._updateElementPosition = function _updateElementPosition(element) {
    if (element.props.disabled) return;
    element.updatePosition(this.scroll);
  }
  /**
   * Gets the params to set in the View from the scroll container or the window
   */
  ;

  _proto._getViewParams = function _getViewParams() {
    if (this._hasScrollContainer) {
      // @ts-expect-error
      var _width = this.viewEl.offsetWidth; // @ts-expect-error

      var _height = this.viewEl.offsetHeight; // @ts-expect-error

      var _scrollHeight = this.viewEl.scrollHeight; // @ts-expect-error

      var _scrollWidth = this.viewEl.scrollWidth;
      return this.view.setSize({
        width: _width,
        height: _height,
        scrollHeight: _scrollHeight,
        scrollWidth: _scrollWidth
      });
    }

    var html = document.documentElement;
    var width = window.innerWidth || html.clientWidth;
    var height = window.innerHeight || html.clientHeight;
    var scrollHeight = html.scrollHeight;
    var scrollWidth = html.scrollWidth;
    return {
      width: width,
      height: height,
      scrollHeight: scrollHeight,
      scrollWidth: scrollWidth
    };
  }
  /**
   * Cache the view attributes
   */
  ;

  _proto._setViewSize = function _setViewSize() {
    return this.view.setSize(this._getViewParams());
  }
  /**
   * Checks if any of the cached attributes of the view have changed.
   * @returns boolean
   */
  ;

  _proto._checkIfViewHasChanged = function _checkIfViewHasChanged() {
    return this.view.hasChanged(this._getViewParams());
  }
  /**
   * -------------------------------------------------------
   * Public methods
   * -------------------------------------------------------
   */

  /**
   * Returns all the parallax elements in the controller
   */
  ;

  _proto.getElements = function getElements() {
    return this.elements;
  }
  /**
   * Creates and returns new parallax element with provided options to be managed by the controller.
   */
  ;

  _proto.createElement = function createElement(options) {
    var newElement = new Element$1(_extends$1({}, options, {
      scrollAxis: this.scrollAxis
    }));
    newElement.setCachedAttributes(this.view, this.scroll);
    this.elements = this.elements ? [].concat(this.elements, [newElement]) : [newElement];

    this._updateElementPosition(newElement); // NOTE: This checks if the view has changed then update the controller and all elements if it has
    // This shouldn't always be necessary with a resize observer watching the view element
    // but there seems to be cases where the resize observer does not catch and update.


    if (this._checkIfViewHasChanged()) {
      this.update();
    }

    return newElement;
  }
  /**
   * Remove an element by id
   */
  ;

  _proto.removeElementById = function removeElementById(id) {
    if (!this.elements) return;
    this.elements = this.elements.filter(function (el) {
      return el.id !== id;
    });
  }
  /**
   * Updates an existing parallax element object with new options.
   */
  ;

  _proto.updateElementPropsById = function updateElementPropsById(id, props) {
    if (this.elements) {
      this.elements = this.elements.map(function (el) {
        if (el.id === id) {
          return el.updateProps(props);
        }

        return el;
      });
    }

    this.update();
  }
  /**
   * Remove a target elements parallax styles
   */
  ;

  _proto.resetElementStyles = function resetElementStyles(element) {
    resetStyles(element);
  }
  /**
   * Updates all cached attributes on parallax elements.
   */
  ;

  _proto.update = function update() {
    // Save the latest scroll position because window.scroll
    // may be called and the handle scroll event may not be called.
    var _this$_getScrollPosit3 = this._getScrollPosition(),
        nx = _this$_getScrollPosit3[0],
        ny = _this$_getScrollPosit3[1];

    this.scroll.setScroll(nx, ny);

    this._setViewSize();

    this._updateAllElements({
      updateCache: true
    });
  }
  /**
   * Updates the scroll container of the parallax controller
   */
  ;

  _proto.updateScrollContainer = function updateScrollContainer(el) {
    // remove existing listeners with current el first
    this._removeListeners(this.viewEl);

    this.viewEl = el;
    this._hasScrollContainer = !!el;
    this.view = new View({
      width: 0,
      height: 0,
      scrollWidth: 0,
      scrollHeight: 0,
      scrollContainer: el
    });

    this._setViewSize();

    this._addListeners(this.viewEl);

    this._updateAllElements({
      updateCache: true
    });
  }
  /**
   * Disable all parallax elements
   */
  ;

  _proto.disableAllElements = function disableAllElements() {
    if (this.elements) {
      this.elements = this.elements.map(function (el) {
        return el.updateProps({
          disabled: true
        });
      });
    }

    this.update();
  }
  /**
   * Enable all parallax elements
   */
  ;

  _proto.enableAllElements = function enableAllElements() {
    if (this.elements) {
      this.elements = this.elements.map(function (el) {
        return el.updateProps({
          disabled: false
        });
      });
    }

    this.update();
  }
  /**
   * Removes all listeners and resets all styles on managed elements.
   */
  ;

  _proto.destroy = function destroy() {
    this._removeListeners(this.viewEl);

    if (this.elements) {
      this.elements.forEach(function (element) {
        return resetStyles(element);
      });
    } // @ts-expect-error


    this.elements = undefined;
  };

  return ParallaxController;
}();

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function removeUndefinedObjectKeys(obj) {
  Object.keys(obj).forEach(function (key) {
    return obj[key] === undefined ? delete obj[key] : {};
  });
  return obj;
}

var _excluded = ["disabled", "easing", "endScroll", "onChange", "onEnter", "onExit", "onProgressChange", "opacity", "rootMargin", "rotate", "rotateX", "rotateY", "rotateZ", "scale", "scaleX", "scaleY", "scaleZ", "shouldAlwaysCompleteAnimation", "shouldDisableScalingTranslations", "speed", "startScroll", "targetElement", "translateX", "translateY"];
function getIsolatedParallaxProps(props) {
  var disabled = props.disabled,
      easing = props.easing,
      endScroll = props.endScroll,
      onChange = props.onChange,
      onEnter = props.onEnter,
      onExit = props.onExit,
      onProgressChange = props.onProgressChange,
      opacity = props.opacity,
      rootMargin = props.rootMargin,
      rotate = props.rotate,
      rotateX = props.rotateX,
      rotateY = props.rotateY,
      rotateZ = props.rotateZ,
      scale = props.scale,
      scaleX = props.scaleX,
      scaleY = props.scaleY,
      scaleZ = props.scaleZ,
      shouldAlwaysCompleteAnimation = props.shouldAlwaysCompleteAnimation,
      shouldDisableScalingTranslations = props.shouldDisableScalingTranslations,
      speed = props.speed,
      startScroll = props.startScroll,
      targetElement = props.targetElement,
      translateX = props.translateX,
      translateY = props.translateY,
      rest = _objectWithoutPropertiesLoose(props, _excluded);

  var parallaxProps = removeUndefinedObjectKeys({
    disabled: disabled,
    easing: easing,
    endScroll: endScroll,
    onChange: onChange,
    onEnter: onEnter,
    onExit: onExit,
    onProgressChange: onProgressChange,
    opacity: opacity,
    rootMargin: rootMargin,
    rotate: rotate,
    rotateX: rotateX,
    rotateY: rotateY,
    rotateZ: rotateZ,
    scale: scale,
    scaleX: scaleX,
    scaleY: scaleY,
    scaleZ: scaleZ,
    shouldAlwaysCompleteAnimation: shouldAlwaysCompleteAnimation,
    shouldDisableScalingTranslations: shouldDisableScalingTranslations,
    speed: speed,
    startScroll: startScroll,
    targetElement: targetElement,
    translateX: translateX,
    translateY: translateY
  });
  return {
    parallaxProps: parallaxProps,
    rest: rest
  };
}

function useVerifyController(controller) {
  React.useEffect(function () {
    var isServer = typeof window === 'undefined'; // Make sure the provided controller is an instance of the Parallax Controller

    var isInstance = controller instanceof ParallaxController; // Throw if neither context or global is available

    if (!isServer && !controller && !isInstance) {
      throw new Error("Must wrap your application's <Parallax /> components in a <ParallaxProvider />.");
    }
  }, [controller]);
}

var ParallaxContext = /*#__PURE__*/React__default["default"].createContext(null);

function useParallaxController() {
  var parallaxController = React.useContext(ParallaxContext);
  var isServer = typeof window === 'undefined';

  if (isServer) {
    return null;
  }

  if (!parallaxController) {
    throw new Error('Could not find `react-scroll-parallax` context value. Please ensure the component is wrapped in a <ParallaxProvider>');
  }

  return parallaxController;
}

function useParallax(props) {
  var controller = useParallaxController();
  var ref = React.useRef(null);

  var _getIsolatedParallaxP = getIsolatedParallaxProps(props),
      parallaxProps = _getIsolatedParallaxP.parallaxProps;

  useVerifyController(controller);

  var _useState = React.useState(),
      element = _useState[0],
      setElement = _useState[1]; // create element


  React.useEffect(function () {
    var newElement;

    if (ref.current instanceof HTMLElement) {
      var options = {
        el: ref.current,
        props: parallaxProps
      };
      newElement = controller == null ? void 0 : controller.createElement(options);
      setElement(newElement);
    } else {
      throw new Error('You must assign the ref returned by the useParallax() hook to an HTML Element.');
    }

    return function () {
      if (newElement) {
        controller == null ? void 0 : controller.removeElementById(newElement.id);
      }
    };
  }, []); // update element

  React.useEffect(function () {
    if (element) {
      if (props.disabled) {
        controller == null ? void 0 : controller.resetElementStyles(element);
        controller == null ? void 0 : controller.updateElementPropsById(element.id, parallaxProps);
      } else {
        controller == null ? void 0 : controller.updateElementPropsById(element.id, parallaxProps);
      }
    }
  }, [props.disabled, props.easing, props.endScroll, props.onChange, props.onEnter, props.onExit, props.onProgressChange, props.opacity, props.rootMargin, props.rotate, props.rotateX, props.rotateY, props.rotateZ, props.scale, props.scaleX, props.scaleY, props.scaleZ, props.shouldAlwaysCompleteAnimation, props.shouldDisableScalingTranslations, props.speed, props.startScroll, props.targetElement, props.translateX, props.translateY]);
  return {
    ref: ref,
    controller: controller,
    element: element
  };
}

var FALLBACK_RECT = {
  height: 0
};
function getExpandedStyle(layer) {
  if (Array.isArray(layer.translateY)) {
    var translateYStart = parseValueAndUnit(layer.translateY[0]);
    var translateYEnd = parseValueAndUnit(layer.translateY[1]);

    if (translateYStart.unit === 'px' && translateYEnd.unit === 'px') {
      return {
        top: Math.abs(translateYEnd.value) * -1 + "px",
        bottom: Math.abs(translateYStart.value) * -1 + "px"
      };
    }

    if (translateYStart.unit === '%' && translateYEnd.unit === '%') {
      var _layer$targetElement;

      var clientRect = ((_layer$targetElement = layer.targetElement) == null ? void 0 : _layer$targetElement.getBoundingClientRect()) || FALLBACK_RECT;
      var top = Math.abs(clientRect.height * 0.01 * translateYEnd.value) * -1;
      var bottom = Math.abs(clientRect.height * 0.01 * translateYStart.value) * -1;
      return {
        top: top + "px",
        bottom: bottom + "px"
      };
    }
  }

  if (layer.speed) {
    var speed = layer.speed || 0;
    return {
      top: Math.abs(speed) * 10 * -1 + 'px',
      bottom: Math.abs(speed) * 10 * -1 + 'px'
    };
  }

  return {};
}

function getImageStyle(layer) {
  return layer.image ? {
    backgroundImage: "url(" + layer.image + ")",
    backgroundPosition: 'center',
    backgroundSize: 'cover'
  } : {};
}

var _excluded$1 = ["children", "disabled", "style", "expanded", "image", "testId"];
var absoluteStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0
};
var ParallaxBannerLayer = function ParallaxBannerLayer(props) {
  var _getIsolatedParallaxP = getIsolatedParallaxProps(props),
      parallaxProps = _getIsolatedParallaxP.parallaxProps,
      rest = _getIsolatedParallaxP.rest;

  var style = rest.style,
      _rest$expanded = rest.expanded,
      expanded = _rest$expanded === void 0 ? true : _rest$expanded,
      testId = rest.testId,
      divProps = _objectWithoutPropertiesLoose(rest, _excluded$1);

  var imageStyle = getImageStyle(props);
  var expandedStyle = expanded ? getExpandedStyle(props) : {};
  var parallax = useParallax(_extends({
    targetElement: props.targetElement,
    shouldDisableScalingTranslations: true
  }, parallaxProps));
  return React__default["default"].createElement("div", Object.assign({
    "data-testid": testId,
    ref: parallax.ref,
    style: _extends({}, imageStyle, absoluteStyle, expandedStyle, style)
  }, divProps), rest.children);
};

var _excluded$2 = ["disabled", "style", "layers"];
var containerStyle = {
  position: 'relative',
  overflow: 'hidden',
  width: '100%'
};
var ParallaxBanner = function ParallaxBanner(props) {
  var _useState = React.useState(null),
      targetElement = _useState[0],
      setTargetElement = _useState[1];

  var containerRef = React.useRef(null);
  React.useEffect(function () {
    setTargetElement(containerRef.current);
  }, []);

  var rootStyle = props.style,
      _props$layers = props.layers,
      layers = _props$layers === void 0 ? [] : _props$layers,
      rootRest = _objectWithoutPropertiesLoose(props, _excluded$2);

  function renderLayers() {
    if (targetElement) {
      var shouldUseLayers = layers && layers.length > 0;

      if (shouldUseLayers) {
        return layers.map(function (layer, i) {
          return React__default["default"].createElement(ParallaxBannerLayer, Object.assign({}, layer, {
            targetElement: targetElement,
            key: "layer-" + i,
            testId: "layer-" + i
          }));
        });
      }
    }

    return null;
  }

  function renderChildren() {
    if (targetElement) {
      return React__default["default"].Children.map(props.children, function (child) {
        var item = child; // adds the targetElement prop to any ParallaxBannerLayer components

        if ((item == null ? void 0 : item.type) === ParallaxBannerLayer) {
          var clone = React__default["default"].cloneElement(item, {
            targetElement: targetElement
          });
          return clone;
        }

        return child;
      });
    }

    return null;
  }

  return React__default["default"].createElement("div", Object.assign({
    ref: containerRef,
    style: _extends({}, containerStyle, rootStyle)
  }, rootRest), renderLayers(), renderChildren());
};

var createController = function createController(options) {
  // Don't initialize on the server
  var isServer = typeof window === 'undefined';

  if (!isServer) {
    // Must not be the server so kick it off...
    return ParallaxController.init(options);
  }

  return null;
};

var ParallaxProvider = /*#__PURE__*/function (_Component) {
  _inheritsLoose(ParallaxProvider, _Component);

  function ParallaxProvider(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.controller = createController({
      scrollAxis: props.scrollAxis,
      scrollContainer: props.scrollContainer
    });
    return _this;
  }

  var _proto = ParallaxProvider.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    if (prevProps.scrollContainer !== this.props.scrollContainer) {
      // @ts-ignore
      this.controller.updateScrollContainer(this.props.scrollContainer);
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    // @ts-ignore
    this.controller = this.controller.destroy();
  };

  _proto.render = function render() {
    var children = this.props.children;
    return (// @ts-ignore
      React__default["default"].createElement(ParallaxContext.Provider, {
        value: this.controller
      }, children)
    );
  };

  return ParallaxProvider;
}(React.Component);
ParallaxProvider.defaultProps = {
  scrollAxis: ScrollAxis.vertical
};

var css$e = ".HeroParallax_module_AppContainer__87e1fa35 {\n  max-width: 1920px;\n  margin: 0 auto;\n}\n\n.HeroParallax_module_HeroContent__87e1fa35 {\n  height: 420px;\n  width: 420px;\n  background-color: #444f6b;\n  border-radius: 16px;\n  overflow: hidden;\n  transform: rotate(45deg);\n}\n\n.HeroParallax_module_HeroParallaxContainer__87e1fa35 {\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n}\n\n.HeroParallax_module_Headline__87e1fa35 {\n  font-family: \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n  font-weight: 100;\n  font-size: 10vw;\n}\n\n.HeroParallax_module_Inset__87e1fa35 {\n  position: absolute;\n  inset: 0;\n}\n\n.HeroParallax_module_White__87e1fa35 {\n  color: white;\n}\n\n.HeroParallax_module_Gray__87e1fa35 {\n  color: #446;\n}\n\n.HeroParallax_module_Full__87e1fa35 {\n  height: 100vh;\n}\n\n.HeroParallax_module_Gradient__87e1fa35 {\n  background: linear-gradient(rgba(14, 62, 151, 0.5) 50%, white);\n}";
injectCss(css$e);
var modules_45f37e80 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","AppContainer":"HeroParallax_module_AppContainer__87e1fa35","HeroContent":"HeroParallax_module_HeroContent__87e1fa35","HeroParallaxContainer":"HeroParallax_module_HeroParallaxContainer__87e1fa35","Headline":"HeroParallax_module_Headline__87e1fa35","Inset":"HeroParallax_module_Inset__87e1fa35","White":"HeroParallax_module_White__87e1fa35","Gray":"HeroParallax_module_Gray__87e1fa35","Full":"HeroParallax_module_Full__87e1fa35","Gradient":"HeroParallax_module_Gradient__87e1fa35"};

function HeroParallax(props) {
  return /*#__PURE__*/React__default["default"].createElement("header", {
    className: modules_45f37e80.AppContainer
  }, /*#__PURE__*/React__default["default"].createElement(ParallaxProvider, null, /*#__PURE__*/React__default["default"].createElement(ParallaxBanner, {
    className: modules_45f37e80.Full,
    style: {
      aspectRatio: "2 / 1"
    }
  }, /*#__PURE__*/React__default["default"].createElement(ParallaxBannerLayer, {
    image: props.backgroundImg
    //translateY={[0, 50]}
    ,
    opacity: [1, 0.3],
    scale: [1, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true
  }), /*#__PURE__*/React__default["default"].createElement(ParallaxBannerLayer, {
    image: props.centerImg,
    translateY: [0, 30],
    scale: [1, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false
  }), /*#__PURE__*/React__default["default"].createElement(ParallaxBannerLayer, {
    image: props.centerSVG,
    translateY: [0, 30],
    scale: [1, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false
  }), /*#__PURE__*/React__default["default"].createElement(ParallaxBannerLayer, {
    image: props.foregroundImg
    //translateY={[0, 15]}
    ,
    scale: [1, 1.3, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true
  }), /*#__PURE__*/React__default["default"].createElement(ParallaxBannerLayer, {
    opacity: [0, 1, "easeOutCubic"],
    shouldAlwaysCompleteAnimation: true,
    expanded: false
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_45f37e80.Gradient, modules_45f37e80.Inset].join(" ")
  })))));
}
var HeroParallaxPropTypes = {
  backgroundImg: propTypes.exports.string,
  centerImg: propTypes.exports.string,
  centerSVG: propTypes.exports.string,
  foregroundImg: propTypes.exports.string
};
HeroParallax.propTypes = HeroParallaxPropTypes;

var css$d = ".Grid_module_mdsGrid__0baf4d23 {\n  display: grid;\n  grid-template-columns: repeat(12, 1fr);\n  gap: 24px;\n  width: 100%;\n  max-width: 1920px;\n  margin: 0 auto;\n}\n.Grid_module_mdsGrid_cols__0baf4d23 > * {\n  grid-column: span 12;\n}\n.Grid_module_mdsGrid_col__0baf4d23 {\n  grid-column: span 12;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col__0baf4d23 > * {\n  grid-column: span 12;\n}\n.Grid_module_mdsGrid_col_1__0baf4d23 {\n  grid-column: span 1;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols1__0baf4d23 > * {\n  grid-column: span 1;\n}\n.Grid_module_mdsGrid_colStart1__0baf4d23 {\n  grid-column-start: 1;\n}\n.Grid_module_mdsGrid_colEnd1__0baf4d23 {\n  grid-column-end: 2;\n}\n.Grid_module_mdsGrid_col_2__0baf4d23 {\n  grid-column: span 2;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols2__0baf4d23 > * {\n  grid-column: span 2;\n}\n.Grid_module_mdsGrid_colStart2__0baf4d23 {\n  grid-column-start: 2;\n}\n.Grid_module_mdsGrid_colEnd2__0baf4d23 {\n  grid-column-end: 3;\n}\n.Grid_module_mdsGrid_col_3__0baf4d23 {\n  grid-column: span 3;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols3__0baf4d23 > * {\n  grid-column: span 3;\n}\n.Grid_module_mdsGrid_colStart3__0baf4d23 {\n  grid-column-start: 3;\n}\n.Grid_module_mdsGrid_colEnd3__0baf4d23 {\n  grid-column-end: 4;\n}\n.Grid_module_mdsGrid_col_4__0baf4d23 {\n  grid-column: span 4;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols4__0baf4d23 > * {\n  grid-column: span 4;\n}\n.Grid_module_mdsGrid_colStart4__0baf4d23 {\n  grid-column-start: 4;\n}\n.Grid_module_mdsGrid_colEnd4__0baf4d23 {\n  grid-column-end: 5;\n}\n.Grid_module_mdsGrid_col_5__0baf4d23 {\n  grid-column: span 5;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols5__0baf4d23 > * {\n  grid-column: span 5;\n}\n.Grid_module_mdsGrid_colStart5__0baf4d23 {\n  grid-column-start: 5;\n}\n.Grid_module_mdsGrid_colEnd5__0baf4d23 {\n  grid-column-end: 6;\n}\n.Grid_module_mdsGrid_col_6__0baf4d23 {\n  grid-column: span 6;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols6__0baf4d23 > * {\n  grid-column: span 6;\n}\n.Grid_module_mdsGrid_colStart6__0baf4d23 {\n  grid-column-start: 6;\n}\n.Grid_module_mdsGrid_colEnd6__0baf4d23 {\n  grid-column-end: 7;\n}\n.Grid_module_mdsGrid_col_7__0baf4d23 {\n  grid-column: span 7;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols7__0baf4d23 > * {\n  grid-column: span 7;\n}\n.Grid_module_mdsGrid_colStart7__0baf4d23 {\n  grid-column-start: 7;\n}\n.Grid_module_mdsGrid_colEnd7__0baf4d23 {\n  grid-column-end: 8;\n}\n.Grid_module_mdsGrid_col_8__0baf4d23 {\n  grid-column: span 8;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols8__0baf4d23 > * {\n  grid-column: span 8;\n}\n.Grid_module_mdsGrid_colStart8__0baf4d23 {\n  grid-column-start: 8;\n}\n.Grid_module_mdsGrid_colEnd8__0baf4d23 {\n  grid-column-end: 9;\n}\n.Grid_module_mdsGrid_col_9__0baf4d23 {\n  grid-column: span 9;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols9__0baf4d23 > * {\n  grid-column: span 9;\n}\n.Grid_module_mdsGrid_colStart9__0baf4d23 {\n  grid-column-start: 9;\n}\n.Grid_module_mdsGrid_colEnd9__0baf4d23 {\n  grid-column-end: 10;\n}\n.Grid_module_mdsGrid_col_10__0baf4d23 {\n  grid-column: span 10;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols10__0baf4d23 > * {\n  grid-column: span 10;\n}\n.Grid_module_mdsGrid_colStart10__0baf4d23 {\n  grid-column-start: 10;\n}\n.Grid_module_mdsGrid_colEnd10__0baf4d23 {\n  grid-column-end: 11;\n}\n.Grid_module_mdsGrid_col_11__0baf4d23 {\n  grid-column: span 11;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols11__0baf4d23 > * {\n  grid-column: span 11;\n}\n.Grid_module_mdsGrid_colStart11__0baf4d23 {\n  grid-column-start: 11;\n}\n.Grid_module_mdsGrid_colEnd11__0baf4d23 {\n  grid-column-end: 12;\n}\n.Grid_module_mdsGrid_col_12__0baf4d23 {\n  grid-column: span 12;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_cols12__0baf4d23 > * {\n  grid-column: span 12;\n}\n.Grid_module_mdsGrid_colStart12__0baf4d23 {\n  grid-column-start: 12;\n}\n.Grid_module_mdsGrid_colEnd12__0baf4d23 {\n  grid-column-end: 13;\n}\n@media only screen and (min-width: 420px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_xs_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartXs1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndXs1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_xs_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartXs2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndXs2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_xs_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartXs3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndXs3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_xs_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartXs4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndXs4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_xs_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartXs5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndXs5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_xs_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartXs6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndXs6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_xs_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartXs7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndXs7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_xs_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartXs8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndXs8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_xs_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartXs9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndXs9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_xs_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartXs10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndXs10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_xs_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartXs11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndXs11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xs_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_xs_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartXs12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndXs12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_sm_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartSm1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndSm1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_sm_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartSm2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndSm2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_sm_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartSm3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndSm3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_sm_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartSm4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndSm4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_sm_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartSm5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndSm5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_sm_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartSm6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndSm6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_sm_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartSm7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndSm7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_sm_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartSm8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndSm8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_sm_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartSm9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndSm9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_sm_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartSm10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndSm10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_sm_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartSm11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndSm11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_sm_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_sm_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartSm12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndSm12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_md_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartMd1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndMd1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_md_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartMd2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndMd2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_md_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartMd3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndMd3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_md_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartMd4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndMd4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_md_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartMd5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndMd5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_md_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartMd6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndMd6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_md_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartMd7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndMd7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_md_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartMd8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndMd8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_md_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartMd9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndMd9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_md_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartMd10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndMd10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_md_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartMd11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndMd11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_md_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_md_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartMd12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndMd12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_lg_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartLg1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndLg1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_lg_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartLg2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndLg2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_lg_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartLg3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndLg3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_lg_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartLg4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndLg4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_lg_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartLg5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndLg5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_lg_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartLg6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndLg6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_lg_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartLg7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndLg7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_lg_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartLg8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndLg8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_lg_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartLg9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndLg9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_lg_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartLg10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndLg10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_lg_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartLg11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndLg11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_lg_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_lg_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartLg12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndLg12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n@media only screen and (min-width: 1440px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_xl_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartXl1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndXl1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_xl_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartXl2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndXl2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_xl_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartXl3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndXl3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_xl_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartXl4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndXl4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_xl_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartXl5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndXl5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_xl_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartXl6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndXl6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_xl_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartXl7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndXl7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_xl_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartXl8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndXl8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_xl_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartXl9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndXl9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_xl_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartXl10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndXl10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_xl_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartXl11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndXl11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xl_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_xl_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartXl12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndXl12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_1__0baf4d23 > * {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_col_xxl_1__0baf4d23 {\n    grid-column: span 1;\n  }\n  .Grid_module_mdsGrid_colStartXxl1__0baf4d23 {\n    grid-column-start: 1;\n  }\n  .Grid_module_mdsGrid_colEndXxl1__0baf4d23 {\n    grid-column-end: 2;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_2__0baf4d23 > * {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_col_xxl_2__0baf4d23 {\n    grid-column: span 2;\n  }\n  .Grid_module_mdsGrid_colStartXxl2__0baf4d23 {\n    grid-column-start: 2;\n  }\n  .Grid_module_mdsGrid_colEndXxl2__0baf4d23 {\n    grid-column-end: 3;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_3__0baf4d23 > * {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_col_xxl_3__0baf4d23 {\n    grid-column: span 3;\n  }\n  .Grid_module_mdsGrid_colStartXxl3__0baf4d23 {\n    grid-column-start: 3;\n  }\n  .Grid_module_mdsGrid_colEndXxl3__0baf4d23 {\n    grid-column-end: 4;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_4__0baf4d23 > * {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_col_xxl_4__0baf4d23 {\n    grid-column: span 4;\n  }\n  .Grid_module_mdsGrid_colStartXxl4__0baf4d23 {\n    grid-column-start: 4;\n  }\n  .Grid_module_mdsGrid_colEndXxl4__0baf4d23 {\n    grid-column-end: 5;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_5__0baf4d23 > * {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_col_xxl_5__0baf4d23 {\n    grid-column: span 5;\n  }\n  .Grid_module_mdsGrid_colStartXxl5__0baf4d23 {\n    grid-column-start: 5;\n  }\n  .Grid_module_mdsGrid_colEndXxl5__0baf4d23 {\n    grid-column-end: 6;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_6__0baf4d23 > * {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_col_xxl_6__0baf4d23 {\n    grid-column: span 6;\n  }\n  .Grid_module_mdsGrid_colStartXxl6__0baf4d23 {\n    grid-column-start: 6;\n  }\n  .Grid_module_mdsGrid_colEndXxl6__0baf4d23 {\n    grid-column-end: 7;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_7__0baf4d23 > * {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_col_xxl_7__0baf4d23 {\n    grid-column: span 7;\n  }\n  .Grid_module_mdsGrid_colStartXxl7__0baf4d23 {\n    grid-column-start: 7;\n  }\n  .Grid_module_mdsGrid_colEndXxl7__0baf4d23 {\n    grid-column-end: 8;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_8__0baf4d23 > * {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_col_xxl_8__0baf4d23 {\n    grid-column: span 8;\n  }\n  .Grid_module_mdsGrid_colStartXxl8__0baf4d23 {\n    grid-column-start: 8;\n  }\n  .Grid_module_mdsGrid_colEndXxl8__0baf4d23 {\n    grid-column-end: 9;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_9__0baf4d23 > * {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_col_xxl_9__0baf4d23 {\n    grid-column: span 9;\n  }\n  .Grid_module_mdsGrid_colStartXxl9__0baf4d23 {\n    grid-column-start: 9;\n  }\n  .Grid_module_mdsGrid_colEndXxl9__0baf4d23 {\n    grid-column-end: 10;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_10__0baf4d23 > * {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_col_xxl_10__0baf4d23 {\n    grid-column: span 10;\n  }\n  .Grid_module_mdsGrid_colStartXxl10__0baf4d23 {\n    grid-column-start: 10;\n  }\n  .Grid_module_mdsGrid_colEndXxl10__0baf4d23 {\n    grid-column-end: 11;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_11__0baf4d23 > * {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_col_xxl_11__0baf4d23 {\n    grid-column: span 11;\n  }\n  .Grid_module_mdsGrid_colStartXxl11__0baf4d23 {\n    grid-column-start: 11;\n  }\n  .Grid_module_mdsGrid_colEndXxl11__0baf4d23 {\n    grid-column-end: 12;\n  }\n  .Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_col_xxl_12__0baf4d23 > * {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_col_xxl_12__0baf4d23 {\n    grid-column: span 12;\n  }\n  .Grid_module_mdsGrid_colStartXxl12__0baf4d23 {\n    grid-column-start: 12;\n  }\n  .Grid_module_mdsGrid_colEndXxl12__0baf4d23 {\n    grid-column-end: 13;\n  }\n}\n.Grid_module_mdsGrid_NoGap__0baf4d23 {\n  gap: 0;\n}\n.Grid_module_mdsGrid_NoRowGap__0baf4d23 {\n  row-gap: 0;\n}\n.Grid_module_mdsGrid_NoColumnGap__0baf4d23 {\n  column-gap: 0;\n}\n.Grid_module_mdsGrid_SmallGap__0baf4d23 {\n  gap: 14px;\n  margin-bottom: 14px;\n}\n@media only screen and (min-width: 768px) {\n  .Grid_module_mdsGrid_LargeGap__0baf4d23 {\n    gap: 32px;\n    margin-bottom: 32px;\n  }\n  .Grid_module_mdsGrid_XLargeGap__0baf4d23 {\n    gap: 36px;\n    margin-bottom: 32px;\n  }\n  .Grid_module_mdsGrid_XXLargeGap__0baf4d23 {\n    gap: 54px;\n    margin-bottom: 32px;\n  }\n}\n.Grid_module_mdsGrid_colFirst__0baf4d23 {\n  order: -1;\n}\n.Grid_module_mdsGrid_colLast__0baf4d23 {\n  order: 12;\n}\n@media only screen and (min-width: 420px) {\n  .Grid_module_mdsGrid_colXsFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colXsLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colXs_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n@media only screen and (min-width: 768px) {\n  .Grid_module_mdsGrid_colSmFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colSmLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colSm_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n@media only screen and (min-width: 1024px) {\n  .Grid_module_mdsGrid_colMdFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colMdLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colMd_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .Grid_module_mdsGrid_colLgFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colLgLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colLg_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n@media only screen and (min-width: 1440px) {\n  .Grid_module_mdsGrid_colXlFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colXlLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colXl_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n@media only screen and (min-width: 1920px) {\n  .Grid_module_mdsGrid_colXxlFirst__0baf4d23 {\n    order: -1;\n  }\n  .Grid_module_mdsGrid_colXxlLast__0baf4d23 {\n    order: 12;\n  }\n  .Grid_module_mdsGrid_colXxl_OrderReset__0baf4d23 {\n    order: initial !important;\n  }\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_normal__0baf4d23 {\n  justify-self: normal;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_normal__0baf4d23 {\n  justify-items: normal;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_stretch__0baf4d23 {\n  justify-self: stretch;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_stretch__0baf4d23 {\n  justify-items: stretch;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_center__0baf4d23 {\n  justify-self: center;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_center__0baf4d23 {\n  justify-items: center;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_start__0baf4d23 {\n  justify-self: start;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_start__0baf4d23 {\n  justify-items: start;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_end__0baf4d23 {\n  justify-self: end;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_end__0baf4d23 {\n  justify-items: end;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_selfStart__0baf4d23 {\n  justify-self: self-start;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_selfStart__0baf4d23 {\n  justify-items: self-start;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_selfEnd__0baf4d23 {\n  justify-self: self-end;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_selfEnd__0baf4d23 {\n  justify-items: self-end;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_left__0baf4d23 {\n  justify-self: left;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_left__0baf4d23 {\n  justify-items: left;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_right__0baf4d23 {\n  justify-self: right;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_right__0baf4d23 {\n  justify-items: right;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_baseline__0baf4d23 {\n  justify-self: baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_baseline__0baf4d23 {\n  justify-items: baseline;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_first__0baf4d23 baseline {\n  justify-self: first baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_first__0baf4d23 baseline {\n  justify-items: first baseline;\n}\n.Grid_module_mdsGrid_col__0baf4d23.Grid_module_mdsGrid_h_align_last__0baf4d23 baseline {\n  justify-self: last baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_h_align_last__0baf4d23 baseline {\n  justify-items: last baseline;\n}\n.Grid_module_mdsGrid_col_v_align_auto__0baf4d23 {\n  align-self: auto;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_auto__0baf4d23 {\n  align-items: auto;\n}\n.Grid_module_mdsGrid_col_v_align_normal__0baf4d23 {\n  align-self: normal;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_normal__0baf4d23 {\n  align-items: normal;\n}\n.Grid_module_mdsGrid_col_v_align_stretch__0baf4d23 {\n  align-self: stretch;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_stretch__0baf4d23 {\n  align-items: stretch;\n}\n.Grid_module_mdsGrid_col_v_align_center__0baf4d23 {\n  align-self: center;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_center__0baf4d23 {\n  align-items: center;\n}\n.Grid_module_mdsGrid_col_v_align_start__0baf4d23 {\n  align-self: start;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_start__0baf4d23 {\n  align-items: start;\n}\n.Grid_module_mdsGrid_col_v_align_end__0baf4d23 {\n  align-self: end;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_end__0baf4d23 {\n  align-items: end;\n}\n.Grid_module_mdsGrid_col_v_align_selfStart__0baf4d23 {\n  align-self: self-start;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_selfStart__0baf4d23 {\n  align-items: self-start;\n}\n.Grid_module_mdsGrid_col_v_align_selfEnd__0baf4d23 {\n  align-self: self-end;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_selfEnd__0baf4d23 {\n  align-items: self-end;\n}\n.Grid_module_mdsGrid_col_v_align_baseline__0baf4d23 {\n  align-self: baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_baseline__0baf4d23 {\n  align-items: baseline;\n}\n.Grid_module_mdsGrid_col_v_align_firstBaseline__0baf4d23 {\n  align-self: first-baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_firstBaseline__0baf4d23 {\n  align-items: first-baseline;\n}\n.Grid_module_mdsGrid_col_v_align_lastBaseline__0baf4d23 {\n  align-self: last-baseline;\n}\n.Grid_module_mdsGrid__0baf4d23.Grid_module_mdsGrid_v_align_lastBaseline__0baf4d23 {\n  align-items: last-baseline;\n}\n.Grid_module_mdsGrid__0baf4d23 ul li {\n  width: 100%;\n  display: list-item;\n  margin: 0;\n}\n\n.Grid_module_Widescreen__0baf4d23 {\n  max-width: 1920px;\n  margin: 0 auto;\n}\n\n.Grid_module_Large__0baf4d23 {\n  max-width: 1440px;\n  margin: 0 auto;\n}\n\n.Grid_module_Standard__0baf4d23 {\n  max-width: 1366px;\n  margin: 0 auto;\n}\n\n.Grid_module_Medium__0baf4d23 {\n  max-width: 980px;\n  margin: 0 auto;\n}\n\n.Grid_module_Small__0baf4d23 {\n  max-width: 768px;\n  margin: 0 auto;\n}";
injectCss(css$d);
var modules_39fbd8cc = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","mdsGrid":"Grid_module_mdsGrid__0baf4d23","mdsGrid_cols":"Grid_module_mdsGrid_cols__0baf4d23","mdsGrid_col":"Grid_module_mdsGrid_col__0baf4d23","mdsGrid_col_1":"Grid_module_mdsGrid_col_1__0baf4d23","mdsGrid_cols1":"Grid_module_mdsGrid_cols1__0baf4d23","mdsGrid_col-start-1":"Grid_module_mdsGrid_colStart1__0baf4d23","mdsGrid_col-end-1":"Grid_module_mdsGrid_colEnd1__0baf4d23","mdsGrid_col_2":"Grid_module_mdsGrid_col_2__0baf4d23","mdsGrid_cols2":"Grid_module_mdsGrid_cols2__0baf4d23","mdsGrid_col-start-2":"Grid_module_mdsGrid_colStart2__0baf4d23","mdsGrid_col-end-2":"Grid_module_mdsGrid_colEnd2__0baf4d23","mdsGrid_col_3":"Grid_module_mdsGrid_col_3__0baf4d23","mdsGrid_cols3":"Grid_module_mdsGrid_cols3__0baf4d23","mdsGrid_col-start-3":"Grid_module_mdsGrid_colStart3__0baf4d23","mdsGrid_col-end-3":"Grid_module_mdsGrid_colEnd3__0baf4d23","mdsGrid_col_4":"Grid_module_mdsGrid_col_4__0baf4d23","mdsGrid_cols4":"Grid_module_mdsGrid_cols4__0baf4d23","mdsGrid_col-start-4":"Grid_module_mdsGrid_colStart4__0baf4d23","mdsGrid_col-end-4":"Grid_module_mdsGrid_colEnd4__0baf4d23","mdsGrid_col_5":"Grid_module_mdsGrid_col_5__0baf4d23","mdsGrid_cols5":"Grid_module_mdsGrid_cols5__0baf4d23","mdsGrid_col-start-5":"Grid_module_mdsGrid_colStart5__0baf4d23","mdsGrid_col-end-5":"Grid_module_mdsGrid_colEnd5__0baf4d23","mdsGrid_col_6":"Grid_module_mdsGrid_col_6__0baf4d23","mdsGrid_cols6":"Grid_module_mdsGrid_cols6__0baf4d23","mdsGrid_col-start-6":"Grid_module_mdsGrid_colStart6__0baf4d23","mdsGrid_col-end-6":"Grid_module_mdsGrid_colEnd6__0baf4d23","mdsGrid_col_7":"Grid_module_mdsGrid_col_7__0baf4d23","mdsGrid_cols7":"Grid_module_mdsGrid_cols7__0baf4d23","mdsGrid_col-start-7":"Grid_module_mdsGrid_colStart7__0baf4d23","mdsGrid_col-end-7":"Grid_module_mdsGrid_colEnd7__0baf4d23","mdsGrid_col_8":"Grid_module_mdsGrid_col_8__0baf4d23","mdsGrid_cols8":"Grid_module_mdsGrid_cols8__0baf4d23","mdsGrid_col-start-8":"Grid_module_mdsGrid_colStart8__0baf4d23","mdsGrid_col-end-8":"Grid_module_mdsGrid_colEnd8__0baf4d23","mdsGrid_col_9":"Grid_module_mdsGrid_col_9__0baf4d23","mdsGrid_cols9":"Grid_module_mdsGrid_cols9__0baf4d23","mdsGrid_col-start-9":"Grid_module_mdsGrid_colStart9__0baf4d23","mdsGrid_col-end-9":"Grid_module_mdsGrid_colEnd9__0baf4d23","mdsGrid_col_10":"Grid_module_mdsGrid_col_10__0baf4d23","mdsGrid_cols10":"Grid_module_mdsGrid_cols10__0baf4d23","mdsGrid_col-start-10":"Grid_module_mdsGrid_colStart10__0baf4d23","mdsGrid_col-end-10":"Grid_module_mdsGrid_colEnd10__0baf4d23","mdsGrid_col_11":"Grid_module_mdsGrid_col_11__0baf4d23","mdsGrid_cols11":"Grid_module_mdsGrid_cols11__0baf4d23","mdsGrid_col-start-11":"Grid_module_mdsGrid_colStart11__0baf4d23","mdsGrid_col-end-11":"Grid_module_mdsGrid_colEnd11__0baf4d23","mdsGrid_col_12":"Grid_module_mdsGrid_col_12__0baf4d23","mdsGrid_cols12":"Grid_module_mdsGrid_cols12__0baf4d23","mdsGrid_col-start-12":"Grid_module_mdsGrid_colStart12__0baf4d23","mdsGrid_col-end-12":"Grid_module_mdsGrid_colEnd12__0baf4d23","mdsGrid_col_xs_1":"Grid_module_mdsGrid_col_xs_1__0baf4d23","mdsGrid_col-start-xs-1":"Grid_module_mdsGrid_colStartXs1__0baf4d23","mdsGrid_col-end-xs-1":"Grid_module_mdsGrid_colEndXs1__0baf4d23","mdsGrid_col_xs_2":"Grid_module_mdsGrid_col_xs_2__0baf4d23","mdsGrid_col-start-xs-2":"Grid_module_mdsGrid_colStartXs2__0baf4d23","mdsGrid_col-end-xs-2":"Grid_module_mdsGrid_colEndXs2__0baf4d23","mdsGrid_col_xs_3":"Grid_module_mdsGrid_col_xs_3__0baf4d23","mdsGrid_col-start-xs-3":"Grid_module_mdsGrid_colStartXs3__0baf4d23","mdsGrid_col-end-xs-3":"Grid_module_mdsGrid_colEndXs3__0baf4d23","mdsGrid_col_xs_4":"Grid_module_mdsGrid_col_xs_4__0baf4d23","mdsGrid_col-start-xs-4":"Grid_module_mdsGrid_colStartXs4__0baf4d23","mdsGrid_col-end-xs-4":"Grid_module_mdsGrid_colEndXs4__0baf4d23","mdsGrid_col_xs_5":"Grid_module_mdsGrid_col_xs_5__0baf4d23","mdsGrid_col-start-xs-5":"Grid_module_mdsGrid_colStartXs5__0baf4d23","mdsGrid_col-end-xs-5":"Grid_module_mdsGrid_colEndXs5__0baf4d23","mdsGrid_col_xs_6":"Grid_module_mdsGrid_col_xs_6__0baf4d23","mdsGrid_col-start-xs-6":"Grid_module_mdsGrid_colStartXs6__0baf4d23","mdsGrid_col-end-xs-6":"Grid_module_mdsGrid_colEndXs6__0baf4d23","mdsGrid_col_xs_7":"Grid_module_mdsGrid_col_xs_7__0baf4d23","mdsGrid_col-start-xs-7":"Grid_module_mdsGrid_colStartXs7__0baf4d23","mdsGrid_col-end-xs-7":"Grid_module_mdsGrid_colEndXs7__0baf4d23","mdsGrid_col_xs_8":"Grid_module_mdsGrid_col_xs_8__0baf4d23","mdsGrid_col-start-xs-8":"Grid_module_mdsGrid_colStartXs8__0baf4d23","mdsGrid_col-end-xs-8":"Grid_module_mdsGrid_colEndXs8__0baf4d23","mdsGrid_col_xs_9":"Grid_module_mdsGrid_col_xs_9__0baf4d23","mdsGrid_col-start-xs-9":"Grid_module_mdsGrid_colStartXs9__0baf4d23","mdsGrid_col-end-xs-9":"Grid_module_mdsGrid_colEndXs9__0baf4d23","mdsGrid_col_xs_10":"Grid_module_mdsGrid_col_xs_10__0baf4d23","mdsGrid_col-start-xs-10":"Grid_module_mdsGrid_colStartXs10__0baf4d23","mdsGrid_col-end-xs-10":"Grid_module_mdsGrid_colEndXs10__0baf4d23","mdsGrid_col_xs_11":"Grid_module_mdsGrid_col_xs_11__0baf4d23","mdsGrid_col-start-xs-11":"Grid_module_mdsGrid_colStartXs11__0baf4d23","mdsGrid_col-end-xs-11":"Grid_module_mdsGrid_colEndXs11__0baf4d23","mdsGrid_col_xs_12":"Grid_module_mdsGrid_col_xs_12__0baf4d23","mdsGrid_col-start-xs-12":"Grid_module_mdsGrid_colStartXs12__0baf4d23","mdsGrid_col-end-xs-12":"Grid_module_mdsGrid_colEndXs12__0baf4d23","mdsGrid_col_sm_1":"Grid_module_mdsGrid_col_sm_1__0baf4d23","mdsGrid_col-start-sm-1":"Grid_module_mdsGrid_colStartSm1__0baf4d23","mdsGrid_col-end-sm-1":"Grid_module_mdsGrid_colEndSm1__0baf4d23","mdsGrid_col_sm_2":"Grid_module_mdsGrid_col_sm_2__0baf4d23","mdsGrid_col-start-sm-2":"Grid_module_mdsGrid_colStartSm2__0baf4d23","mdsGrid_col-end-sm-2":"Grid_module_mdsGrid_colEndSm2__0baf4d23","mdsGrid_col_sm_3":"Grid_module_mdsGrid_col_sm_3__0baf4d23","mdsGrid_col-start-sm-3":"Grid_module_mdsGrid_colStartSm3__0baf4d23","mdsGrid_col-end-sm-3":"Grid_module_mdsGrid_colEndSm3__0baf4d23","mdsGrid_col_sm_4":"Grid_module_mdsGrid_col_sm_4__0baf4d23","mdsGrid_col-start-sm-4":"Grid_module_mdsGrid_colStartSm4__0baf4d23","mdsGrid_col-end-sm-4":"Grid_module_mdsGrid_colEndSm4__0baf4d23","mdsGrid_col_sm_5":"Grid_module_mdsGrid_col_sm_5__0baf4d23","mdsGrid_col-start-sm-5":"Grid_module_mdsGrid_colStartSm5__0baf4d23","mdsGrid_col-end-sm-5":"Grid_module_mdsGrid_colEndSm5__0baf4d23","mdsGrid_col_sm_6":"Grid_module_mdsGrid_col_sm_6__0baf4d23","mdsGrid_col-start-sm-6":"Grid_module_mdsGrid_colStartSm6__0baf4d23","mdsGrid_col-end-sm-6":"Grid_module_mdsGrid_colEndSm6__0baf4d23","mdsGrid_col_sm_7":"Grid_module_mdsGrid_col_sm_7__0baf4d23","mdsGrid_col-start-sm-7":"Grid_module_mdsGrid_colStartSm7__0baf4d23","mdsGrid_col-end-sm-7":"Grid_module_mdsGrid_colEndSm7__0baf4d23","mdsGrid_col_sm_8":"Grid_module_mdsGrid_col_sm_8__0baf4d23","mdsGrid_col-start-sm-8":"Grid_module_mdsGrid_colStartSm8__0baf4d23","mdsGrid_col-end-sm-8":"Grid_module_mdsGrid_colEndSm8__0baf4d23","mdsGrid_col_sm_9":"Grid_module_mdsGrid_col_sm_9__0baf4d23","mdsGrid_col-start-sm-9":"Grid_module_mdsGrid_colStartSm9__0baf4d23","mdsGrid_col-end-sm-9":"Grid_module_mdsGrid_colEndSm9__0baf4d23","mdsGrid_col_sm_10":"Grid_module_mdsGrid_col_sm_10__0baf4d23","mdsGrid_col-start-sm-10":"Grid_module_mdsGrid_colStartSm10__0baf4d23","mdsGrid_col-end-sm-10":"Grid_module_mdsGrid_colEndSm10__0baf4d23","mdsGrid_col_sm_11":"Grid_module_mdsGrid_col_sm_11__0baf4d23","mdsGrid_col-start-sm-11":"Grid_module_mdsGrid_colStartSm11__0baf4d23","mdsGrid_col-end-sm-11":"Grid_module_mdsGrid_colEndSm11__0baf4d23","mdsGrid_col_sm_12":"Grid_module_mdsGrid_col_sm_12__0baf4d23","mdsGrid_col-start-sm-12":"Grid_module_mdsGrid_colStartSm12__0baf4d23","mdsGrid_col-end-sm-12":"Grid_module_mdsGrid_colEndSm12__0baf4d23","mdsGrid_col_md_1":"Grid_module_mdsGrid_col_md_1__0baf4d23","mdsGrid_col-start-md-1":"Grid_module_mdsGrid_colStartMd1__0baf4d23","mdsGrid_col-end-md-1":"Grid_module_mdsGrid_colEndMd1__0baf4d23","mdsGrid_col_md_2":"Grid_module_mdsGrid_col_md_2__0baf4d23","mdsGrid_col-start-md-2":"Grid_module_mdsGrid_colStartMd2__0baf4d23","mdsGrid_col-end-md-2":"Grid_module_mdsGrid_colEndMd2__0baf4d23","mdsGrid_col_md_3":"Grid_module_mdsGrid_col_md_3__0baf4d23","mdsGrid_col-start-md-3":"Grid_module_mdsGrid_colStartMd3__0baf4d23","mdsGrid_col-end-md-3":"Grid_module_mdsGrid_colEndMd3__0baf4d23","mdsGrid_col_md_4":"Grid_module_mdsGrid_col_md_4__0baf4d23","mdsGrid_col-start-md-4":"Grid_module_mdsGrid_colStartMd4__0baf4d23","mdsGrid_col-end-md-4":"Grid_module_mdsGrid_colEndMd4__0baf4d23","mdsGrid_col_md_5":"Grid_module_mdsGrid_col_md_5__0baf4d23","mdsGrid_col-start-md-5":"Grid_module_mdsGrid_colStartMd5__0baf4d23","mdsGrid_col-end-md-5":"Grid_module_mdsGrid_colEndMd5__0baf4d23","mdsGrid_col_md_6":"Grid_module_mdsGrid_col_md_6__0baf4d23","mdsGrid_col-start-md-6":"Grid_module_mdsGrid_colStartMd6__0baf4d23","mdsGrid_col-end-md-6":"Grid_module_mdsGrid_colEndMd6__0baf4d23","mdsGrid_col_md_7":"Grid_module_mdsGrid_col_md_7__0baf4d23","mdsGrid_col-start-md-7":"Grid_module_mdsGrid_colStartMd7__0baf4d23","mdsGrid_col-end-md-7":"Grid_module_mdsGrid_colEndMd7__0baf4d23","mdsGrid_col_md_8":"Grid_module_mdsGrid_col_md_8__0baf4d23","mdsGrid_col-start-md-8":"Grid_module_mdsGrid_colStartMd8__0baf4d23","mdsGrid_col-end-md-8":"Grid_module_mdsGrid_colEndMd8__0baf4d23","mdsGrid_col_md_9":"Grid_module_mdsGrid_col_md_9__0baf4d23","mdsGrid_col-start-md-9":"Grid_module_mdsGrid_colStartMd9__0baf4d23","mdsGrid_col-end-md-9":"Grid_module_mdsGrid_colEndMd9__0baf4d23","mdsGrid_col_md_10":"Grid_module_mdsGrid_col_md_10__0baf4d23","mdsGrid_col-start-md-10":"Grid_module_mdsGrid_colStartMd10__0baf4d23","mdsGrid_col-end-md-10":"Grid_module_mdsGrid_colEndMd10__0baf4d23","mdsGrid_col_md_11":"Grid_module_mdsGrid_col_md_11__0baf4d23","mdsGrid_col-start-md-11":"Grid_module_mdsGrid_colStartMd11__0baf4d23","mdsGrid_col-end-md-11":"Grid_module_mdsGrid_colEndMd11__0baf4d23","mdsGrid_col_md_12":"Grid_module_mdsGrid_col_md_12__0baf4d23","mdsGrid_col-start-md-12":"Grid_module_mdsGrid_colStartMd12__0baf4d23","mdsGrid_col-end-md-12":"Grid_module_mdsGrid_colEndMd12__0baf4d23","mdsGrid_col_lg_1":"Grid_module_mdsGrid_col_lg_1__0baf4d23","mdsGrid_col-start-lg-1":"Grid_module_mdsGrid_colStartLg1__0baf4d23","mdsGrid_col-end-lg-1":"Grid_module_mdsGrid_colEndLg1__0baf4d23","mdsGrid_col_lg_2":"Grid_module_mdsGrid_col_lg_2__0baf4d23","mdsGrid_col-start-lg-2":"Grid_module_mdsGrid_colStartLg2__0baf4d23","mdsGrid_col-end-lg-2":"Grid_module_mdsGrid_colEndLg2__0baf4d23","mdsGrid_col_lg_3":"Grid_module_mdsGrid_col_lg_3__0baf4d23","mdsGrid_col-start-lg-3":"Grid_module_mdsGrid_colStartLg3__0baf4d23","mdsGrid_col-end-lg-3":"Grid_module_mdsGrid_colEndLg3__0baf4d23","mdsGrid_col_lg_4":"Grid_module_mdsGrid_col_lg_4__0baf4d23","mdsGrid_col-start-lg-4":"Grid_module_mdsGrid_colStartLg4__0baf4d23","mdsGrid_col-end-lg-4":"Grid_module_mdsGrid_colEndLg4__0baf4d23","mdsGrid_col_lg_5":"Grid_module_mdsGrid_col_lg_5__0baf4d23","mdsGrid_col-start-lg-5":"Grid_module_mdsGrid_colStartLg5__0baf4d23","mdsGrid_col-end-lg-5":"Grid_module_mdsGrid_colEndLg5__0baf4d23","mdsGrid_col_lg_6":"Grid_module_mdsGrid_col_lg_6__0baf4d23","mdsGrid_col-start-lg-6":"Grid_module_mdsGrid_colStartLg6__0baf4d23","mdsGrid_col-end-lg-6":"Grid_module_mdsGrid_colEndLg6__0baf4d23","mdsGrid_col_lg_7":"Grid_module_mdsGrid_col_lg_7__0baf4d23","mdsGrid_col-start-lg-7":"Grid_module_mdsGrid_colStartLg7__0baf4d23","mdsGrid_col-end-lg-7":"Grid_module_mdsGrid_colEndLg7__0baf4d23","mdsGrid_col_lg_8":"Grid_module_mdsGrid_col_lg_8__0baf4d23","mdsGrid_col-start-lg-8":"Grid_module_mdsGrid_colStartLg8__0baf4d23","mdsGrid_col-end-lg-8":"Grid_module_mdsGrid_colEndLg8__0baf4d23","mdsGrid_col_lg_9":"Grid_module_mdsGrid_col_lg_9__0baf4d23","mdsGrid_col-start-lg-9":"Grid_module_mdsGrid_colStartLg9__0baf4d23","mdsGrid_col-end-lg-9":"Grid_module_mdsGrid_colEndLg9__0baf4d23","mdsGrid_col_lg_10":"Grid_module_mdsGrid_col_lg_10__0baf4d23","mdsGrid_col-start-lg-10":"Grid_module_mdsGrid_colStartLg10__0baf4d23","mdsGrid_col-end-lg-10":"Grid_module_mdsGrid_colEndLg10__0baf4d23","mdsGrid_col_lg_11":"Grid_module_mdsGrid_col_lg_11__0baf4d23","mdsGrid_col-start-lg-11":"Grid_module_mdsGrid_colStartLg11__0baf4d23","mdsGrid_col-end-lg-11":"Grid_module_mdsGrid_colEndLg11__0baf4d23","mdsGrid_col_lg_12":"Grid_module_mdsGrid_col_lg_12__0baf4d23","mdsGrid_col-start-lg-12":"Grid_module_mdsGrid_colStartLg12__0baf4d23","mdsGrid_col-end-lg-12":"Grid_module_mdsGrid_colEndLg12__0baf4d23","mdsGrid_col_xl_1":"Grid_module_mdsGrid_col_xl_1__0baf4d23","mdsGrid_col-start-xl-1":"Grid_module_mdsGrid_colStartXl1__0baf4d23","mdsGrid_col-end-xl-1":"Grid_module_mdsGrid_colEndXl1__0baf4d23","mdsGrid_col_xl_2":"Grid_module_mdsGrid_col_xl_2__0baf4d23","mdsGrid_col-start-xl-2":"Grid_module_mdsGrid_colStartXl2__0baf4d23","mdsGrid_col-end-xl-2":"Grid_module_mdsGrid_colEndXl2__0baf4d23","mdsGrid_col_xl_3":"Grid_module_mdsGrid_col_xl_3__0baf4d23","mdsGrid_col-start-xl-3":"Grid_module_mdsGrid_colStartXl3__0baf4d23","mdsGrid_col-end-xl-3":"Grid_module_mdsGrid_colEndXl3__0baf4d23","mdsGrid_col_xl_4":"Grid_module_mdsGrid_col_xl_4__0baf4d23","mdsGrid_col-start-xl-4":"Grid_module_mdsGrid_colStartXl4__0baf4d23","mdsGrid_col-end-xl-4":"Grid_module_mdsGrid_colEndXl4__0baf4d23","mdsGrid_col_xl_5":"Grid_module_mdsGrid_col_xl_5__0baf4d23","mdsGrid_col-start-xl-5":"Grid_module_mdsGrid_colStartXl5__0baf4d23","mdsGrid_col-end-xl-5":"Grid_module_mdsGrid_colEndXl5__0baf4d23","mdsGrid_col_xl_6":"Grid_module_mdsGrid_col_xl_6__0baf4d23","mdsGrid_col-start-xl-6":"Grid_module_mdsGrid_colStartXl6__0baf4d23","mdsGrid_col-end-xl-6":"Grid_module_mdsGrid_colEndXl6__0baf4d23","mdsGrid_col_xl_7":"Grid_module_mdsGrid_col_xl_7__0baf4d23","mdsGrid_col-start-xl-7":"Grid_module_mdsGrid_colStartXl7__0baf4d23","mdsGrid_col-end-xl-7":"Grid_module_mdsGrid_colEndXl7__0baf4d23","mdsGrid_col_xl_8":"Grid_module_mdsGrid_col_xl_8__0baf4d23","mdsGrid_col-start-xl-8":"Grid_module_mdsGrid_colStartXl8__0baf4d23","mdsGrid_col-end-xl-8":"Grid_module_mdsGrid_colEndXl8__0baf4d23","mdsGrid_col_xl_9":"Grid_module_mdsGrid_col_xl_9__0baf4d23","mdsGrid_col-start-xl-9":"Grid_module_mdsGrid_colStartXl9__0baf4d23","mdsGrid_col-end-xl-9":"Grid_module_mdsGrid_colEndXl9__0baf4d23","mdsGrid_col_xl_10":"Grid_module_mdsGrid_col_xl_10__0baf4d23","mdsGrid_col-start-xl-10":"Grid_module_mdsGrid_colStartXl10__0baf4d23","mdsGrid_col-end-xl-10":"Grid_module_mdsGrid_colEndXl10__0baf4d23","mdsGrid_col_xl_11":"Grid_module_mdsGrid_col_xl_11__0baf4d23","mdsGrid_col-start-xl-11":"Grid_module_mdsGrid_colStartXl11__0baf4d23","mdsGrid_col-end-xl-11":"Grid_module_mdsGrid_colEndXl11__0baf4d23","mdsGrid_col_xl_12":"Grid_module_mdsGrid_col_xl_12__0baf4d23","mdsGrid_col-start-xl-12":"Grid_module_mdsGrid_colStartXl12__0baf4d23","mdsGrid_col-end-xl-12":"Grid_module_mdsGrid_colEndXl12__0baf4d23","mdsGrid_col_xxl_1":"Grid_module_mdsGrid_col_xxl_1__0baf4d23","mdsGrid_col-start-xxl-1":"Grid_module_mdsGrid_colStartXxl1__0baf4d23","mdsGrid_col-end-xxl-1":"Grid_module_mdsGrid_colEndXxl1__0baf4d23","mdsGrid_col_xxl_2":"Grid_module_mdsGrid_col_xxl_2__0baf4d23","mdsGrid_col-start-xxl-2":"Grid_module_mdsGrid_colStartXxl2__0baf4d23","mdsGrid_col-end-xxl-2":"Grid_module_mdsGrid_colEndXxl2__0baf4d23","mdsGrid_col_xxl_3":"Grid_module_mdsGrid_col_xxl_3__0baf4d23","mdsGrid_col-start-xxl-3":"Grid_module_mdsGrid_colStartXxl3__0baf4d23","mdsGrid_col-end-xxl-3":"Grid_module_mdsGrid_colEndXxl3__0baf4d23","mdsGrid_col_xxl_4":"Grid_module_mdsGrid_col_xxl_4__0baf4d23","mdsGrid_col-start-xxl-4":"Grid_module_mdsGrid_colStartXxl4__0baf4d23","mdsGrid_col-end-xxl-4":"Grid_module_mdsGrid_colEndXxl4__0baf4d23","mdsGrid_col_xxl_5":"Grid_module_mdsGrid_col_xxl_5__0baf4d23","mdsGrid_col-start-xxl-5":"Grid_module_mdsGrid_colStartXxl5__0baf4d23","mdsGrid_col-end-xxl-5":"Grid_module_mdsGrid_colEndXxl5__0baf4d23","mdsGrid_col_xxl_6":"Grid_module_mdsGrid_col_xxl_6__0baf4d23","mdsGrid_col-start-xxl-6":"Grid_module_mdsGrid_colStartXxl6__0baf4d23","mdsGrid_col-end-xxl-6":"Grid_module_mdsGrid_colEndXxl6__0baf4d23","mdsGrid_col_xxl_7":"Grid_module_mdsGrid_col_xxl_7__0baf4d23","mdsGrid_col-start-xxl-7":"Grid_module_mdsGrid_colStartXxl7__0baf4d23","mdsGrid_col-end-xxl-7":"Grid_module_mdsGrid_colEndXxl7__0baf4d23","mdsGrid_col_xxl_8":"Grid_module_mdsGrid_col_xxl_8__0baf4d23","mdsGrid_col-start-xxl-8":"Grid_module_mdsGrid_colStartXxl8__0baf4d23","mdsGrid_col-end-xxl-8":"Grid_module_mdsGrid_colEndXxl8__0baf4d23","mdsGrid_col_xxl_9":"Grid_module_mdsGrid_col_xxl_9__0baf4d23","mdsGrid_col-start-xxl-9":"Grid_module_mdsGrid_colStartXxl9__0baf4d23","mdsGrid_col-end-xxl-9":"Grid_module_mdsGrid_colEndXxl9__0baf4d23","mdsGrid_col_xxl_10":"Grid_module_mdsGrid_col_xxl_10__0baf4d23","mdsGrid_col-start-xxl-10":"Grid_module_mdsGrid_colStartXxl10__0baf4d23","mdsGrid_col-end-xxl-10":"Grid_module_mdsGrid_colEndXxl10__0baf4d23","mdsGrid_col_xxl_11":"Grid_module_mdsGrid_col_xxl_11__0baf4d23","mdsGrid_col-start-xxl-11":"Grid_module_mdsGrid_colStartXxl11__0baf4d23","mdsGrid_col-end-xxl-11":"Grid_module_mdsGrid_colEndXxl11__0baf4d23","mdsGrid_col_xxl_12":"Grid_module_mdsGrid_col_xxl_12__0baf4d23","mdsGrid_col-start-xxl-12":"Grid_module_mdsGrid_colStartXxl12__0baf4d23","mdsGrid_col-end-xxl-12":"Grid_module_mdsGrid_colEndXxl12__0baf4d23","mdsGrid_NoGap":"Grid_module_mdsGrid_NoGap__0baf4d23","mdsGrid_NoRowGap":"Grid_module_mdsGrid_NoRowGap__0baf4d23","mdsGrid_NoColumnGap":"Grid_module_mdsGrid_NoColumnGap__0baf4d23","mdsGrid_SmallGap":"Grid_module_mdsGrid_SmallGap__0baf4d23","mdsGrid_LargeGap":"Grid_module_mdsGrid_LargeGap__0baf4d23","mdsGrid_XLargeGap":"Grid_module_mdsGrid_XLargeGap__0baf4d23","mdsGrid_XXLargeGap":"Grid_module_mdsGrid_XXLargeGap__0baf4d23","mdsGrid_col-first":"Grid_module_mdsGrid_colFirst__0baf4d23","mdsGrid_col-last":"Grid_module_mdsGrid_colLast__0baf4d23","mdsGrid_col-xs-first":"Grid_module_mdsGrid_colXsFirst__0baf4d23","mdsGrid_col-xs-last":"Grid_module_mdsGrid_colXsLast__0baf4d23","mdsGrid_col-xs--order-reset":"Grid_module_mdsGrid_colXs_OrderReset__0baf4d23","mdsGrid_col-sm-first":"Grid_module_mdsGrid_colSmFirst__0baf4d23","mdsGrid_col-sm-last":"Grid_module_mdsGrid_colSmLast__0baf4d23","mdsGrid_col-sm--order-reset":"Grid_module_mdsGrid_colSm_OrderReset__0baf4d23","mdsGrid_col-md-first":"Grid_module_mdsGrid_colMdFirst__0baf4d23","mdsGrid_col-md-last":"Grid_module_mdsGrid_colMdLast__0baf4d23","mdsGrid_col-md--order-reset":"Grid_module_mdsGrid_colMd_OrderReset__0baf4d23","mdsGrid_col-lg-first":"Grid_module_mdsGrid_colLgFirst__0baf4d23","mdsGrid_col-lg-last":"Grid_module_mdsGrid_colLgLast__0baf4d23","mdsGrid_col-lg--order-reset":"Grid_module_mdsGrid_colLg_OrderReset__0baf4d23","mdsGrid_col-xl-first":"Grid_module_mdsGrid_colXlFirst__0baf4d23","mdsGrid_col-xl-last":"Grid_module_mdsGrid_colXlLast__0baf4d23","mdsGrid_col-xl--order-reset":"Grid_module_mdsGrid_colXl_OrderReset__0baf4d23","mdsGrid_col-xxl-first":"Grid_module_mdsGrid_colXxlFirst__0baf4d23","mdsGrid_col-xxl-last":"Grid_module_mdsGrid_colXxlLast__0baf4d23","mdsGrid_col-xxl--order-reset":"Grid_module_mdsGrid_colXxl_OrderReset__0baf4d23","mdsGrid_h_align_normal":"Grid_module_mdsGrid_h_align_normal__0baf4d23","mdsGrid_h_align_stretch":"Grid_module_mdsGrid_h_align_stretch__0baf4d23","mdsGrid_h_align_center":"Grid_module_mdsGrid_h_align_center__0baf4d23","mdsGrid_h_align_start":"Grid_module_mdsGrid_h_align_start__0baf4d23","mdsGrid_h_align_end":"Grid_module_mdsGrid_h_align_end__0baf4d23","mdsGrid_h_align_self-start":"Grid_module_mdsGrid_h_align_selfStart__0baf4d23","mdsGrid_h_align_self-end":"Grid_module_mdsGrid_h_align_selfEnd__0baf4d23","mdsGrid_h_align_left":"Grid_module_mdsGrid_h_align_left__0baf4d23","mdsGrid_h_align_right":"Grid_module_mdsGrid_h_align_right__0baf4d23","mdsGrid_h_align_baseline":"Grid_module_mdsGrid_h_align_baseline__0baf4d23","mdsGrid_h_align_first":"Grid_module_mdsGrid_h_align_first__0baf4d23","mdsGrid_h_align_last":"Grid_module_mdsGrid_h_align_last__0baf4d23","mdsGrid_col_v_align_auto":"Grid_module_mdsGrid_col_v_align_auto__0baf4d23","mdsGrid_v_align_auto":"Grid_module_mdsGrid_v_align_auto__0baf4d23","mdsGrid_col_v_align_normal":"Grid_module_mdsGrid_col_v_align_normal__0baf4d23","mdsGrid_v_align_normal":"Grid_module_mdsGrid_v_align_normal__0baf4d23","mdsGrid_col_v_align_stretch":"Grid_module_mdsGrid_col_v_align_stretch__0baf4d23","mdsGrid_v_align_stretch":"Grid_module_mdsGrid_v_align_stretch__0baf4d23","mdsGrid_col_v_align_center":"Grid_module_mdsGrid_col_v_align_center__0baf4d23","mdsGrid_v_align_center":"Grid_module_mdsGrid_v_align_center__0baf4d23","mdsGrid_col_v_align_start":"Grid_module_mdsGrid_col_v_align_start__0baf4d23","mdsGrid_v_align_start":"Grid_module_mdsGrid_v_align_start__0baf4d23","mdsGrid_col_v_align_end":"Grid_module_mdsGrid_col_v_align_end__0baf4d23","mdsGrid_v_align_end":"Grid_module_mdsGrid_v_align_end__0baf4d23","mdsGrid_col_v_align_self-start":"Grid_module_mdsGrid_col_v_align_selfStart__0baf4d23","mdsGrid_v_align_self-start":"Grid_module_mdsGrid_v_align_selfStart__0baf4d23","mdsGrid_col_v_align_self-end":"Grid_module_mdsGrid_col_v_align_selfEnd__0baf4d23","mdsGrid_v_align_self-end":"Grid_module_mdsGrid_v_align_selfEnd__0baf4d23","mdsGrid_col_v_align_baseline":"Grid_module_mdsGrid_col_v_align_baseline__0baf4d23","mdsGrid_v_align_baseline":"Grid_module_mdsGrid_v_align_baseline__0baf4d23","mdsGrid_col_v_align_first-baseline":"Grid_module_mdsGrid_col_v_align_firstBaseline__0baf4d23","mdsGrid_v_align_first-baseline":"Grid_module_mdsGrid_v_align_firstBaseline__0baf4d23","mdsGrid_col_v_align_last-baseline":"Grid_module_mdsGrid_col_v_align_lastBaseline__0baf4d23","mdsGrid_v_align_last-baseline":"Grid_module_mdsGrid_v_align_lastBaseline__0baf4d23","Widescreen":"Grid_module_Widescreen__0baf4d23","Large":"Grid_module_Large__0baf4d23","Standard":"Grid_module_Standard__0baf4d23","Medium":"Grid_module_Medium__0baf4d23","Small":"Grid_module_Small__0baf4d23"};

var _ALIGN;
//COLUMN SIZE

var COLUMN = {
  BASE1: modules_39fbd8cc.mdsGrid_col_1,
  BASE2: modules_39fbd8cc.mdsGrid_col_2,
  BASE3: modules_39fbd8cc.mdsGrid_col_3,
  BASE4: modules_39fbd8cc.mdsGrid_col_4,
  BASE5: modules_39fbd8cc.mdsGrid_col_5,
  BASE6: modules_39fbd8cc.mdsGrid_col_6,
  BASE7: modules_39fbd8cc.mdsGrid_col_7,
  BASE8: modules_39fbd8cc.mdsGrid_col_8,
  BASE9: modules_39fbd8cc.mdsGrid_col_9,
  BASE10: modules_39fbd8cc.mdsGrid_col_10,
  BASE11: modules_39fbd8cc.mdsGrid_col_11,
  BASE12: modules_39fbd8cc.mdsGrid_col_12,
  XS1: modules_39fbd8cc.mdsGrid_col_xs_1,
  XS2: modules_39fbd8cc.mdsGrid_col_xs_2,
  XS3: modules_39fbd8cc.mdsGrid_col_xs_3,
  XS4: modules_39fbd8cc.mdsGrid_col_xs_4,
  XS5: modules_39fbd8cc.mdsGrid_col_xs_5,
  XS6: modules_39fbd8cc.mdsGrid_col_xs_6,
  XS7: modules_39fbd8cc.mdsGrid_col_xs_7,
  XS8: modules_39fbd8cc.mdsGrid_col_xs_8,
  XS9: modules_39fbd8cc.mdsGrid_col_xs_9,
  XS10: modules_39fbd8cc.mdsGrid_col_xs_10,
  XS11: modules_39fbd8cc.mdsGrid_col_xs_11,
  XS12: modules_39fbd8cc.mdsGrid_col_xs_12,
  S1: modules_39fbd8cc.mdsGrid_col_sm_1,
  S2: modules_39fbd8cc.mdsGrid_col_sm_2,
  S3: modules_39fbd8cc.mdsGrid_col_sm_3,
  S4: modules_39fbd8cc.mdsGrid_col_sm_4,
  S5: modules_39fbd8cc.mdsGrid_col_sm_5,
  S6: modules_39fbd8cc.mdsGrid_col_sm_6,
  S7: modules_39fbd8cc.mdsGrid_col_sm_7,
  S8: modules_39fbd8cc.mdsGrid_col_sm_8,
  S9: modules_39fbd8cc.mdsGrid_col_sm_9,
  S10: modules_39fbd8cc.mdsGrid_col_sm_10,
  S11: modules_39fbd8cc.mdsGrid_col_sm_11,
  S12: modules_39fbd8cc.mdsGrid_col_sm_12,
  M1: modules_39fbd8cc.mdsGrid_col_md_1,
  M2: modules_39fbd8cc.mdsGrid_col_md_2,
  M3: modules_39fbd8cc.mdsGrid_col_md_3,
  M4: modules_39fbd8cc.mdsGrid_col_md_4,
  M5: modules_39fbd8cc.mdsGrid_col_md_5,
  M6: modules_39fbd8cc.mdsGrid_col_md_6,
  M7: modules_39fbd8cc.mdsGrid_col_md_7,
  M8: modules_39fbd8cc.mdsGrid_col_md_8,
  M9: modules_39fbd8cc.mdsGrid_col_md_9,
  M10: modules_39fbd8cc.mdsGrid_col_md_10,
  M11: modules_39fbd8cc.mdsGrid_col_md_11,
  M12: modules_39fbd8cc.mdsGrid_col_md_12,
  L1: modules_39fbd8cc.mdsGrid_col_lg_1,
  L2: modules_39fbd8cc.mdsGrid_col_lg_2,
  L3: modules_39fbd8cc.mdsGrid_col_lg_3,
  L4: modules_39fbd8cc.mdsGrid_col_lg_4,
  L5: modules_39fbd8cc.mdsGrid_col_lg_5,
  L6: modules_39fbd8cc.mdsGrid_col_lg_6,
  L7: modules_39fbd8cc.mdsGrid_col_lg_7,
  L8: modules_39fbd8cc.mdsGrid_col_lg_8,
  L9: modules_39fbd8cc.mdsGrid_col_lg_9,
  L10: modules_39fbd8cc.mdsGrid_col_lg_10,
  L11: modules_39fbd8cc.mdsGrid_col_lg_11,
  L12: modules_39fbd8cc.mdsGrid_col_lg_12,
  XL1: modules_39fbd8cc.mdsGrid_col_xl_1,
  XL2: modules_39fbd8cc.mdsGrid_col_xl_2,
  XL3: modules_39fbd8cc.mdsGrid_col_xl_3,
  XL4: modules_39fbd8cc.mdsGrid_col_xl_4,
  XL5: modules_39fbd8cc.mdsGrid_col_xl_5,
  XL6: modules_39fbd8cc.mdsGrid_col_xl_6,
  XL7: modules_39fbd8cc.mdsGrid_col_xl_7,
  XL8: modules_39fbd8cc.mdsGrid_col_xl_8,
  XL9: modules_39fbd8cc.mdsGrid_col_xl_9,
  XL10: modules_39fbd8cc.mdsGrid_col_xl_10,
  XL11: modules_39fbd8cc.mdsGrid_col_xl_11,
  XL12: modules_39fbd8cc.mdsGrid_col_xl_12,
  XXL1: modules_39fbd8cc.mdsGrid_col_xxl_1,
  XXL2: modules_39fbd8cc.mdsGrid_col_xxl_2,
  XXL3: modules_39fbd8cc.mdsGrid_col_xxl_3,
  XXL4: modules_39fbd8cc.mdsGrid_col_xxl_4,
  XXL5: modules_39fbd8cc.mdsGrid_col_xxl_5,
  XXL6: modules_39fbd8cc.mdsGrid_col_xxl_6,
  XXL7: modules_39fbd8cc.mdsGrid_col_xxl_7,
  XXL8: modules_39fbd8cc.mdsGrid_col_xxl_8,
  XXL9: modules_39fbd8cc.mdsGrid_col_xxl_9,
  XXL10: modules_39fbd8cc.mdsGrid_col_xxl_10,
  XXL11: modules_39fbd8cc.mdsGrid_col_xxl_11,
  XXL12: modules_39fbd8cc.mdsGrid_col_xxl_12
};
var ORDER = {
  ORDER_FIRST_XS: modules_39fbd8cc.mdsGrid_col_xs_first,
  ORDER_FIRST_S: modules_39fbd8cc.mdsGrid_col_sm_first,
  ORDER_FIRST_M: modules_39fbd8cc.mdsGrid_col_md_first,
  ORDER_FIRST_L: modules_39fbd8cc.mdsGrid_col_lg_first,
  ORDER_FIRST_XL: modules_39fbd8cc.mdsGrid_col_xl_first,
  ORDER_FIRST_XXL: modules_39fbd8cc.mdsGrid_col_xxl_first,
  ORDER_LAST_XS: modules_39fbd8cc.mdsGrid_col_xs_last,
  ORDER_LAST_S: modules_39fbd8cc.mdsGrid_col_sm_last,
  ORDER_LAST_M: modules_39fbd8cc.mdsGrid_col_md_last,
  ORDER_LAST_L: modules_39fbd8cc.mdsGrid_col_lg_last,
  ORDER_LAST_XL: modules_39fbd8cc.mdsGrid_col_xl_last,
  ORDER_LAST_XXL: modules_39fbd8cc.mdsGrid_col_xxl_last
};
var ALIGN = (_ALIGN = {
  ALIGN_V_STRETCH: modules_39fbd8cc.mdsGrid_v_align_stretch,
  ALIGN_V_CENTER: modules_39fbd8cc.mdsGrid_v_align_center,
  ALIGN_V_START: modules_39fbd8cc.mdsGrid_v_align_start,
  ALIGN_V_END: modules_39fbd8cc.mdsGrid_v_align_end,
  ALIGN_V_BASELINE: modules_39fbd8cc.mdsGrid_v_align_baseline
}, _defineProperty(_ALIGN, "ALIGN_V_STRETCH", modules_39fbd8cc.mdsGrid_v_align_stretch), _defineProperty(_ALIGN, "ALIGN_V_CENTER", modules_39fbd8cc.mdsGrid_v_align_center), _defineProperty(_ALIGN, "ALIGN_V_START", modules_39fbd8cc.mdsGrid_v_align_start), _defineProperty(_ALIGN, "ALIGN_V_END", modules_39fbd8cc.mdsGrid_v_align_end), _defineProperty(_ALIGN, "ALIGN_V_BASELINE", modules_39fbd8cc.mdsGrid_v_align_baseline), _defineProperty(_ALIGN, "ALIGN_H_STRETCH", modules_39fbd8cc.mdsGrid_h_align_stretch), _defineProperty(_ALIGN, "ALIGN_H_CENTER", modules_39fbd8cc.mdsGrid_h_align_center), _defineProperty(_ALIGN, "ALIGN_H_START", modules_39fbd8cc.mdsGrid_h_align_start), _defineProperty(_ALIGN, "ALIGN_H_END", modules_39fbd8cc.mdsGrid_h_align_end), _defineProperty(_ALIGN, "ALIGN_H_LEFT", modules_39fbd8cc.mdsGrid_h_align_left), _defineProperty(_ALIGN, "ALIGN_H_RIGHT", modules_39fbd8cc.mdsGrid_h_align_right), _defineProperty(_ALIGN, "ALIGN_H_BASELINE", modules_39fbd8cc.mdsGrid_h_align_baseline), _ALIGN);
var getColumnsContainerClassNames = function getColumnsContainerClassNames(mdsGrid, props) {
  return [mdsGrid, props.columnSize || "", props.columnSizeXS || "", props.columnSizeS || "", props.columnSizeM || "", props.columnSizeL || "", props.column == "1" ? modules_39fbd8cc.mdsGrid_col_1 : props.column == "2" ? modules_39fbd8cc.mdsGrid_col_2 : props.column == "3" ? modules_39fbd8cc.mdsGrid_col_3 : props.column == "4" ? modules_39fbd8cc.mdsGrid_col_4 : props.column == "5" ? modules_39fbd8cc.mdsGrid_col_5 : props.column == "6" ? modules_39fbd8cc.mdsGrid_col_6 : props.column == "7" ? modules_39fbd8cc.mdsGrid_col_7 : props.column == "8" ? modules_39fbd8cc.mdsGrid_col_8 : props.column == "9" ? modules_39fbd8cc.mdsGrid_col_9 : props.column == "10" ? modules_39fbd8cc.mdsGrid_col_10 : props.column == "11" ? modules_39fbd8cc.mdsGrid_col_11 : props.column == "12" ? modules_39fbd8cc.mdsGrid_col_12 : "", props.columnXS == "1" ? modules_39fbd8cc.mdsGrid_col_xs_1 : props.columnXS == "2" ? modules_39fbd8cc.mdsGrid_col_xs_2 : props.columnXS == "3" ? modules_39fbd8cc.mdsGrid_col_xs_3 : props.columnXS == "4" ? modules_39fbd8cc.mdsGrid_col_xs_4 : props.columnXS == "5" ? modules_39fbd8cc.mdsGrid_col_xs_5 : props.columnXS == "6" ? modules_39fbd8cc.mdsGrid_col_xs_6 : props.columnXS == "7" ? modules_39fbd8cc.mdsGrid_col_xs_7 : props.columnXS == "8" ? modules_39fbd8cc.mdsGrid_col_xs_8 : props.columnXS == "9" ? modules_39fbd8cc.mdsGrid_col_xs_9 : props.columnXS == "10" ? modules_39fbd8cc.mdsGrid_col_xs_10 : props.columnXS == "11" ? modules_39fbd8cc.mdsGrid_col_xs_11 : props.columnXS == "12" ? modules_39fbd8cc.mdsGrid_col_xs_12 : "", props.columnS == "1" ? modules_39fbd8cc.mdsGrid_col_sm_1 : props.columnS == "2" ? modules_39fbd8cc.mdsGrid_col_sm_2 : props.columnS == "3" ? modules_39fbd8cc.mdsGrid_col_sm_3 : props.columnS == "4" ? modules_39fbd8cc.mdsGrid_col_sm_4 : props.columnS == "5" ? modules_39fbd8cc.mdsGrid_col_sm_5 : props.columnS == "6" ? modules_39fbd8cc.mdsGrid_col_sm_6 : props.columnS == "7" ? modules_39fbd8cc.mdsGrid_col_sm_7 : props.columnS == "8" ? modules_39fbd8cc.mdsGrid_col_sm_8 : props.columnS == "9" ? modules_39fbd8cc.mdsGrid_col_sm_9 : props.columnS == "10" ? modules_39fbd8cc.mdsGrid_col_sm_10 : props.columnS == "11" ? modules_39fbd8cc.mdsGrid_col_sm_11 : props.columnS == "12" ? modules_39fbd8cc.mdsGrid_col_sm_12 : "", props.columnM == "1" ? modules_39fbd8cc.mdsGrid_col_md_1 : props.columnM == "2" ? modules_39fbd8cc.mdsGrid_col_md_2 : props.columnM == "3" ? modules_39fbd8cc.mdsGrid_col_md_3 : props.columnM == "4" ? modules_39fbd8cc.mdsGrid_col_md_4 : props.columnM == "5" ? modules_39fbd8cc.mdsGrid_col_md_5 : props.columnM == "6" ? modules_39fbd8cc.mdsGrid_col_md_6 : props.columnM == "7" ? modules_39fbd8cc.mdsGrid_col_md_7 : props.columnM == "8" ? modules_39fbd8cc.mdsGrid_col_md_8 : props.columnM == "9" ? modules_39fbd8cc.mdsGrid_col_md_9 : props.columnM == "10" ? modules_39fbd8cc.mdsGrid_col_md_10 : props.columnM == "11" ? modules_39fbd8cc.mdsGrid_col_md_11 : props.columnM == "12" ? modules_39fbd8cc.mdsGrid_col_md_12 : "", props.columnL == "1" ? modules_39fbd8cc.mdsGrid_col_lg_1 : props.columnL == "2" ? modules_39fbd8cc.mdsGrid_col_lg_2 : props.columnL == "3" ? modules_39fbd8cc.mdsGrid_col_lg_3 : props.columnL == "4" ? modules_39fbd8cc.mdsGrid_col_lg_4 : props.columnL == "5" ? modules_39fbd8cc.mdsGrid_col_lg_5 : props.columnL == "6" ? modules_39fbd8cc.mdsGrid_col_lg_6 : props.columnL == "7" ? modules_39fbd8cc.mdsGrid_col_lg_7 : props.columnL == "8" ? modules_39fbd8cc.mdsGrid_col_lg_8 : props.columnL == "9" ? modules_39fbd8cc.mdsGrid_col_lg_9 : props.columnL == "10" ? modules_39fbd8cc.mdsGrid_col_lg_10 : props.columnL == "11" ? modules_39fbd8cc.mdsGrid_col_lg_11 : props.columnL == "12" ? modules_39fbd8cc.mdsGrid_col_lg_12 : "", props.columnXL == "1" ? modules_39fbd8cc.mdsGrid_col_xl_1 : props.columnXL == "2" ? modules_39fbd8cc.mdsGrid_col_xl_2 : props.columnXL == "3" ? modules_39fbd8cc.mdsGrid_col_xl_3 : props.columnXL == "4" ? modules_39fbd8cc.mdsGrid_col_xl_4 : props.columnXL == "5" ? modules_39fbd8cc.mdsGrid_col_xl_5 : props.columnXL == "6" ? modules_39fbd8cc.mdsGrid_col_xl_6 : props.columnXL == "7" ? modules_39fbd8cc.mdsGrid_col_xl_7 : props.columnXL == "8" ? modules_39fbd8cc.mdsGrid_col_xl_8 : props.columnXL == "9" ? modules_39fbd8cc.mdsGrid_col_xl_9 : props.columnXL == "10" ? modules_39fbd8cc.mdsGrid_col_xl_10 : props.columnXL == "11" ? modules_39fbd8cc.mdsGrid_col_xl_11 : props.columnXL == "12" ? modules_39fbd8cc.mdsGrid_col_xl_12 : "", props.columnXXL == "1" ? modules_39fbd8cc.mdsGrid_col_xxl_1 : props.columnXXL == "2" ? modules_39fbd8cc.mdsGrid_col_xxl_2 : props.columnXXL == "3" ? modules_39fbd8cc.mdsGrid_col_xxl_3 : props.columnXXL == "4" ? modules_39fbd8cc.mdsGrid_col_xxl_4 : props.columnXXL == "5" ? modules_39fbd8cc.mdsGrid_col_xxl_5 : props.columnXXL == "6" ? modules_39fbd8cc.mdsGrid_col_xxl_6 : props.columnXXL == "7" ? modules_39fbd8cc.mdsGrid_col_xxl_7 : props.columnXXL == "8" ? modules_39fbd8cc.mdsGrid_col_xxl_8 : props.columnXXL == "9" ? modules_39fbd8cc.mdsGrid_col_xxl_9 : props.columnXXL == "10" ? modules_39fbd8cc.mdsGrid_col_xxl_10 : props.columnXXL == "11" ? modules_39fbd8cc.mdsGrid_col_xxl_11 : props.columnXXL == "12" ? modules_39fbd8cc.mdsGrid_col_xxl_12 : "", props.align || "", props.alignHorizontal == "center" ? modules_39fbd8cc.mdsGrid_h_align_center : props.alignHorizontal == "left" ? modules_39fbd8cc.mdsGrid_h_align_start : props.alignHorizontal == "right" ? modules_39fbd8cc.mdsGrid_h_align_end : "", props.alignVertical == "center" ? modules_39fbd8cc.mdsGrid_v_align_center : props.alignVertical == "top" ? modules_39fbd8cc.mdsGrid_v_align_start : props.alignVertical == "bottom" ? modules_39fbd8cc.mdsGrid_v_align_end : "",
  //props.gap || '',
  props.gap == "noGap" ? modules_39fbd8cc.mdsGrid_NoGap : props.gap == "noRowGap" ? modules_39fbd8cc.mdsGrid_NoRowGap : props.gap == "noColumnGap" ? modules_39fbd8cc.mdsGrid_NoRowGap : props.gap == "smallGap" ? modules_39fbd8cc.mdsGrid_SmallGap : props.gap == "largeGap" ? modules_39fbd8cc.mdsGrid_LargeGap : props.gap == "xlargeGap" ? modules_39fbd8cc.mdsGrid_XLargeGap : props.gap == "xxlargeGap" ? modules_39fbd8cc.mdsGrid_XXLargeGap : "", props.width == "1920" ? modules_39fbd8cc.Widescreen : props.width == "1440" ? modules_39fbd8cc.Large : props.width == "1366" ? modules_39fbd8cc.Large : props.width == "980" ? modules_39fbd8cc.Medium : props.width == "768" ? modules_39fbd8cc.Small : "", props.extraClass || ""].join(" ");
};
var getColumnClassNames = function getColumnClassNames(mdsGrid_col, props) {
  return [mdsGrid_col, props.columnSize || "", props.columnSizeXS || "", props.columnSizeS || "", props.columnSizeM || "", props.columnSizeL || "", props.column == "1" ? modules_39fbd8cc.mdsGrid_col_1 : props.column == "2" ? modules_39fbd8cc.mdsGrid_col_2 : props.column == "3" ? modules_39fbd8cc.mdsGrid_col_3 : props.column == "4" ? modules_39fbd8cc.mdsGrid_col_4 : props.column == "5" ? modules_39fbd8cc.mdsGrid_col_5 : props.column == "6" ? modules_39fbd8cc.mdsGrid_col_6 : props.column == "7" ? modules_39fbd8cc.mdsGrid_col_7 : props.column == "8" ? modules_39fbd8cc.mdsGrid_col_8 : props.column == "9" ? modules_39fbd8cc.mdsGrid_col_9 : props.column == "10" ? modules_39fbd8cc.mdsGrid_col_10 : props.column == "11" ? modules_39fbd8cc.mdsGrid_col_11 : props.column == "12" ? modules_39fbd8cc.mdsGrid_col_12 : "", props.columnXS == "1" ? modules_39fbd8cc.mdsGrid_col_xs_1 : props.columnXS == "2" ? modules_39fbd8cc.mdsGrid_col_xs_2 : props.columnXS == "3" ? modules_39fbd8cc.mdsGrid_col_xs_3 : props.columnXS == "4" ? modules_39fbd8cc.mdsGrid_col_xs_4 : props.columnXS == "5" ? modules_39fbd8cc.mdsGrid_col_xs_5 : props.columnXS == "6" ? modules_39fbd8cc.mdsGrid_col_xs_6 : props.columnXS == "7" ? modules_39fbd8cc.mdsGrid_col_xs_7 : props.columnXS == "8" ? modules_39fbd8cc.mdsGrid_col_xs_8 : props.columnXS == "9" ? modules_39fbd8cc.mdsGrid_col_xs_9 : props.columnXS == "10" ? modules_39fbd8cc.mdsGrid_col_xs_10 : props.columnXS == "11" ? modules_39fbd8cc.mdsGrid_col_xs_11 : props.columnXS == "12" ? modules_39fbd8cc.mdsGrid_col_xs_12 : "", props.columnS == "1" ? modules_39fbd8cc.mdsGrid_col_sm_1 : props.columnS == "2" ? modules_39fbd8cc.mdsGrid_col_sm_2 : props.columnS == "3" ? modules_39fbd8cc.mdsGrid_col_sm_3 : props.columnS == "4" ? modules_39fbd8cc.mdsGrid_col_sm_4 : props.columnS == "5" ? modules_39fbd8cc.mdsGrid_col_sm_5 : props.columnS == "6" ? modules_39fbd8cc.mdsGrid_col_sm_6 : props.columnS == "7" ? modules_39fbd8cc.mdsGrid_col_sm_7 : props.columnS == "8" ? modules_39fbd8cc.mdsGrid_col_sm_8 : props.columnS == "9" ? modules_39fbd8cc.mdsGrid_col_sm_9 : props.columnS == "10" ? modules_39fbd8cc.mdsGrid_col_sm_10 : props.columnS == "11" ? modules_39fbd8cc.mdsGrid_col_sm_11 : props.columnS == "12" ? modules_39fbd8cc.mdsGrid_col_sm_12 : "", props.columnM == "1" ? modules_39fbd8cc.mdsGrid_col_md_1 : props.columnM == "2" ? modules_39fbd8cc.mdsGrid_col_md_2 : props.columnM == "3" ? modules_39fbd8cc.mdsGrid_col_md_3 : props.columnM == "4" ? modules_39fbd8cc.mdsGrid_col_md_4 : props.columnM == "5" ? modules_39fbd8cc.mdsGrid_col_md_5 : props.columnM == "6" ? modules_39fbd8cc.mdsGrid_col_md_6 : props.columnM == "7" ? modules_39fbd8cc.mdsGrid_col_md_7 : props.columnM == "8" ? modules_39fbd8cc.mdsGrid_col_md_8 : props.columnM == "9" ? modules_39fbd8cc.mdsGrid_col_md_9 : props.columnM == "10" ? modules_39fbd8cc.mdsGrid_col_md_10 : props.columnM == "11" ? modules_39fbd8cc.mdsGrid_col_md_11 : props.columnM == "12" ? modules_39fbd8cc.mdsGrid_col_md_12 : "", props.columnL == "1" ? modules_39fbd8cc.mdsGrid_col_lg_1 : props.columnL == "2" ? modules_39fbd8cc.mdsGrid_col_lg_2 : props.columnL == "3" ? modules_39fbd8cc.mdsGrid_col_lg_3 : props.columnL == "4" ? modules_39fbd8cc.mdsGrid_col_lg_4 : props.columnL == "5" ? modules_39fbd8cc.mdsGrid_col_lg_5 : props.columnL == "6" ? modules_39fbd8cc.mdsGrid_col_lg_6 : props.columnL == "7" ? modules_39fbd8cc.mdsGrid_col_lg_7 : props.columnL == "8" ? modules_39fbd8cc.mdsGrid_col_lg_8 : props.columnL == "9" ? modules_39fbd8cc.mdsGrid_col_lg_9 : props.columnL == "10" ? modules_39fbd8cc.mdsGrid_col_lg_10 : props.columnL == "11" ? modules_39fbd8cc.mdsGrid_col_lg_11 : props.columnL == "12" ? modules_39fbd8cc.mdsGrid_col_lg_12 : "", props.columnXL == "1" ? modules_39fbd8cc.mdsGrid_col_xl_1 : props.columnXL == "2" ? modules_39fbd8cc.mdsGrid_col_xl_2 : props.columnXL == "3" ? modules_39fbd8cc.mdsGrid_col_xl_3 : props.columnXL == "4" ? modules_39fbd8cc.mdsGrid_col_xl_4 : props.columnXL == "5" ? modules_39fbd8cc.mdsGrid_col_xl_5 : props.columnXL == "6" ? modules_39fbd8cc.mdsGrid_col_xl_6 : props.columnXL == "7" ? modules_39fbd8cc.mdsGrid_col_xl_7 : props.columnXL == "8" ? modules_39fbd8cc.mdsGrid_col_xl_8 : props.columnXL == "9" ? modules_39fbd8cc.mdsGrid_col_xl_9 : props.columnXL == "10" ? modules_39fbd8cc.mdsGrid_col_xl_10 : props.columnXL == "11" ? modules_39fbd8cc.mdsGrid_col_xl_11 : props.columnXL == "12" ? modules_39fbd8cc.mdsGrid_col_xl_12 : "", props.columnXXL == "1" ? modules_39fbd8cc.mdsGrid_col_xxl_1 : props.columnXXL == "2" ? modules_39fbd8cc.mdsGrid_col_xxl_2 : props.columnXXL == "3" ? modules_39fbd8cc.mdsGrid_col_xxl_3 : props.columnXXL == "4" ? modules_39fbd8cc.mdsGrid_col_xxl_4 : props.columnXXL == "5" ? modules_39fbd8cc.mdsGrid_col_xxl_5 : props.columnXXL == "6" ? modules_39fbd8cc.mdsGrid_col_xxl_6 : props.columnXXL == "7" ? modules_39fbd8cc.mdsGrid_col_xxl_7 : props.columnXXL == "8" ? modules_39fbd8cc.mdsGrid_col_xxl_8 : props.columnXXL == "9" ? modules_39fbd8cc.mdsGrid_col_xxl_9 : props.columnXXL == "10" ? modules_39fbd8cc.mdsGrid_col_xxl_10 : props.columnXXL == "11" ? modules_39fbd8cc.mdsGrid_col_xxl_11 : props.columnXXL == "12" ? modules_39fbd8cc.mdsGrid_col_xxl_12 : "", props.alignHorizontal == "center" ? modules_39fbd8cc.mdsGrid_h_align_center : props.alignHorizontal == "left" ? modules_39fbd8cc.mdsGrid_h_align_start : props.alignHorizontal == "right" ? modules_39fbd8cc.mdsGrid_h_align_end : "", props.alignVertical == "center" ? modules_39fbd8cc.mdsGrid_col_v_align_center : props.alignVertical == "top" ? modules_39fbd8cc.mdsGrid_col_v_align_start : props.alignVertical == "bottom" ? modules_39fbd8cc.mdsGrid_col_v_align_end : "", props.order || "", props.extraClass || ""].join(" ");
};
var getContainerClassNames = function getContainerClassNames(mdsGrid, props) {
  return [mdsGrid,
  //props.gap || '',
  props.gap == "noGap" ? modules_39fbd8cc.mdsGrid_NoGap : props.gap == "noRowGap" ? modules_39fbd8cc.mdsGrid_NoRowGap : props.gap == "noColumnGap" ? modules_39fbd8cc.mdsGrid_NoRowGap : props.gap == "smallGap" ? modules_39fbd8cc.mdsGrid_SmallGap : props.gap == "largeGap" ? modules_39fbd8cc.mdsGrid_LargeGap : props.gap == "xlargeGap" ? modules_39fbd8cc.mdsGrid_XLargeGap : props.gap == "xxlargeGap" ? modules_39fbd8cc.mdsGrid_XXLargeGap : "", props.align || "", props.alignHorizontal == "center" ? modules_39fbd8cc.mdsGrid_h_align_center : props.alignHorizontal == "left" ? modules_39fbd8cc.mdsGrid_h_align_start : props.alignHorizontal == "right" ? modules_39fbd8cc.mdsGrid_h_align_end : "", props.alignVertical == "center" ? modules_39fbd8cc.mdsGrid_v_align_center : props.alignVertical == "top" ? modules_39fbd8cc.mdsGrid_v_align_start : props.alignVertical == "bottom" ? modules_39fbd8cc.mdsGrid_v_align_end : "", props.width == "1920" ? modules_39fbd8cc.Widescreen : props.width == "1440" ? modules_39fbd8cc.Large : props.width == "1366" ? modules_39fbd8cc.Large : props.width == "980" ? modules_39fbd8cc.Medium : props.width == "768" ? modules_39fbd8cc.Small : "", props.extraClass || ""].join(" ");
};
var GridContainer = function GridContainer(props) {
  return (
    /*#__PURE__*/
    //Container for Wrapping GridColumn for individual children Column Sizing
    React__default["default"].createElement("div", {
      className: getContainerClassNames(modules_39fbd8cc.mdsGrid, props)
    }, props.children)
  );
};
var GridColumn = function GridColumn(props) {
  return (
    /*#__PURE__*/
    //Container for individual Column
    React__default["default"].createElement("div", {
      className: getColumnClassNames(modules_39fbd8cc.mdsGrid_col, props)
    }, props.children)
  );
};
var GridColumnsContainer = function GridColumnsContainer(props) {
  return (
    /*#__PURE__*/
    //All Children Column Width will be the same
    React__default["default"].createElement("div", {
      className: [getColumnsContainerClassNames(modules_39fbd8cc.mdsGrid, props), modules_39fbd8cc.mdsGrid_col].join(" ")
    }, props.children)
  );
};
var colSizes = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"];
var gapOptions = ["noGap", "noRowGap", "noColumnGap", "smallGap", "largeGap", "xlargeGap", "xxlGap"];
var colAlignH = ["center", "left", "right"];
var colAlignV = ["center", "top", "bottom"];
var gridPropTypes = {
  extraClass: propTypes.exports.string,
  columnSize: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeXS: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeS: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeM: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeL: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  column: propTypes.exports.oneOf(colSizes),
  columnXS: propTypes.exports.oneOf(colSizes),
  columnS: propTypes.exports.oneOf(colSizes),
  columnM: propTypes.exports.oneOf(colSizes),
  columnL: propTypes.exports.oneOf(colSizes),
  columnXL: propTypes.exports.oneOf(colSizes),
  columnXXL: propTypes.exports.oneOf(colSizes),
  align: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(ALIGN))),
  gap: propTypes.exports.oneOf(gapOptions),
  alignHorizontal: propTypes.exports.oneOf(colAlignH),
  alignVertical: propTypes.exports.oneOf(colAlignV),
  width: propTypes.exports.oneOf(["1920", "1440", "1366", "980", "768"])
};
var columnPropTypes = {
  extraClass: propTypes.exports.string,
  columnSize: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeS: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeM: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  columnSizeL: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(COLUMN))),
  order: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(ORDER))),
  align: propTypes.exports.arrayOf(propTypes.exports.oneOf(Object.values(ALIGN))),
  alignHorizontal: propTypes.exports.oneOf(colAlignH),
  alignVertical: propTypes.exports.oneOf(colAlignV),
  column: propTypes.exports.oneOf(colSizes),
  columnXS: propTypes.exports.oneOf(colSizes),
  columnS: propTypes.exports.oneOf(colSizes),
  columnM: propTypes.exports.oneOf(colSizes),
  columnL: propTypes.exports.oneOf(colSizes),
  columnXL: propTypes.exports.oneOf(colSizes),
  columnXXL: propTypes.exports.oneOf(colSizes)
};

// Link.propTypes = buttonPropTypes;
GridContainer.propTypes = gridPropTypes;
GridColumnsContainer.propTypes = gridPropTypes;
GridColumn.propTypes = columnPropTypes;

var css$c = ".BaseSection_module_Section__50c604d8 {\n  max-width: 1920px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  background-color: #ffffff;\n}\n@media (max-width: 1024px) {\n  .BaseSection_module_Section__50c604d8 {\n    flex-direction: column;\n  }\n}\n\n.BaseSection_module_RightImage__50c604d8 {\n  max-width: 1920px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row-reverse;\n  align-items: center;\n  background-color: #ffffff;\n}\n@media (max-width: 1024px) {\n  .BaseSection_module_RightImage__50c604d8 {\n    flex-direction: column;\n  }\n}\n.BaseSection_module_RightImage__50c604d8 .BaseSection_module_ContentImage__50c604d8 {\n  border-bottom-right-radius: 0px;\n  border-bottom-left-radius: 880px;\n}\n\n.BaseSection_module_ContentImage__50c604d8 {\n  width: 100%;\n  border-bottom-right-radius: 880px;\n}\n\n.BaseSection_module_Content__50c604d8 {\n  width: 100%;\n  padding: 54px;\n}\n@media (max-width: 700px) {\n  .BaseSection_module_Content__50c604d8 {\n    padding: 24px;\n  }\n}\n\n.BaseSection_module_Overlay__50c604d8 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  width: 100%;\n  background: radial-gradient(circle at center, rgba(27, 32, 43, 0.98) 0%, rgba(27, 32, 43, 0.98) 100%);\n  opacity: 0.5;\n}\n\n.BaseSection_module_FullWidth__50c604d8 {\n  display: block;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  position: relative;\n}\n.BaseSection_module_FullWidth__50c604d8 .BaseSection_module_Content__50c604d8 {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n}\n.BaseSection_module_FullWidth__50c604d8 .BaseSection_module_Content__50c604d8 p {\n  color: #ffffff;\n}\n.BaseSection_module_FullWidth__50c604d8 .BaseSection_module_ContentImage__50c604d8 {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-bottom-right-radius: 0;\n  border-bottom-left-radius: 0;\n}\n\n.BaseSection_module_Parallax__50c604d8 {\n  max-width: 1920px;\n  margin: 0 auto;\n  display: block;\n}\n.BaseSection_module_Parallax__50c604d8 .BaseSection_module_ParallaxContent__50c604d8 {\n  min-height: 500px;\n  background-attachment: fixed;\n  background-position: top center;\n  background-repeat: no-repeat;\n  background-size: cover;\n}\n@media (max-width: 1200px) {\n  .BaseSection_module_Parallax__50c604d8 .BaseSection_module_ParallaxContent__50c604d8 {\n    background-attachment: initial;\n  }\n}\n\n.BaseSection_module_SwiperContent__50c604d8 {\n  width: 50%;\n}\n@media (max-width: 1024px) {\n  .BaseSection_module_SwiperContent__50c604d8 {\n    width: 100%;\n  }\n}\n\n.BaseSection_module_SwiperImage__50c604d8 {\n  width: 100%;\n  height: auto;\n  aspect-ratio: 4/3;\n  object-fit: cover;\n}\n\n.BaseSection_module_CenterAlignContent__50c604d8 {\n  text-align: center;\n}\n.BaseSection_module_CenterAlignContent__50c604d8 div, .BaseSection_module_CenterAlignContent__50c604d8 a, .BaseSection_module_CenterAlignContent__50c604d8 button {\n  justify-content: center;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.BaseSection_module_RightAlignContent__50c604d8 {\n  text-align: right;\n}\n.BaseSection_module_RightAlignContent__50c604d8 div, .BaseSection_module_RightAlignContent__50c604d8 a, .BaseSection_module_RightAlignContent__50c604d8 button {\n  justify-content: right;\n  margin-left: auto;\n  margin-right: 0;\n}";
injectCss(css$c);
var modules_2789d99a = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Section":"BaseSection_module_Section__50c604d8","RightImage":"BaseSection_module_RightImage__50c604d8","ContentImage":"BaseSection_module_ContentImage__50c604d8","Content":"BaseSection_module_Content__50c604d8","Overlay":"BaseSection_module_Overlay__50c604d8","FullWidth":"BaseSection_module_FullWidth__50c604d8","Parallax":"BaseSection_module_Parallax__50c604d8","ParallaxContent":"BaseSection_module_ParallaxContent__50c604d8","SwiperContent":"BaseSection_module_SwiperContent__50c604d8","SwiperImage":"BaseSection_module_SwiperImage__50c604d8","CenterAlignContent":"BaseSection_module_CenterAlignContent__50c604d8","RightAlignContent":"BaseSection_module_RightAlignContent__50c604d8"};

//Section options
var getClassNames$1 = function getClassNames(Section, props) {
  return [Section, props.style || "", props.image || "", props.extraClass || "", props.swiperSection, props.swiperItems ? modules_2789d99a.SwiperSection : "",
  //Alternate layouts
  props.fullWidth ? modules_2789d99a.FullWidth : props.alternate ? modules_2789d99a.RightImage : props.parallax ? modules_2789d99a.Parallax : ""].join(" ");
};
var ContentSection = function ContentSection(props) {
  return /*#__PURE__*/React__default["default"].createElement("section", {
    className: getClassNames$1(modules_2789d99a.Section, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_2789d99a.ParallaxContent, props.swiperItems ? modules_2789d99a.SwiperContent : null].join(" "),
    style: {
      height: props.height,
      backgroundImage: props.parallaxImgSrc ? "url(" + props.parallaxImgSrc + ")" : null
    }
  }, props.swiperItems ? /*#__PURE__*/React__default["default"].createElement(SwiperWrapper, {
    navigation: true,
    pagination: true
  }, props.swiperItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(Image, {
      key: index,
      id: item.id,
      src: item.imgURL,
      extraClass: modules_2789d99a.SwiperImage,
      alt: item.imgALT
    });
  })) : null, !props.swiperItems ? props.imgSrc ? /*#__PURE__*/React__default["default"].createElement(Image, {
    src: props.imgSrc,
    extraClass: modules_2789d99a.ContentImage,
    alt: props.imgAlt
  }) : null : null, props.overlay ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_2789d99a.Overlay
  }) : null), /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_2789d99a.Content, props.centerAlignContent ? modules_2789d99a.CenterAlignContent : '', props.rightAlignContent ? modules_2789d99a.RightAlignContent : ''].join(" "),
    style: {
      width: props.imgWidth || "100%"
    }
  }, props.children));
};
var contentSectionPropTypes = {
  extraClass: propTypes.exports.string,
  height: propTypes.exports.string,
  backgroundColor: propTypes.exports.string,
  parallaxImgSrc: propTypes.exports.string,
  imgSrc: propTypes.exports.string,
  imgWidth: propTypes.exports.string,
  imgAlt: propTypes.exports.string,
  overlay: propTypes.exports.bool,
  fullWidth: propTypes.exports.bool,
  alternate: propTypes.exports.bool,
  parallax: propTypes.exports.bool,
  swiperItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    id: propTypes.exports.string,
    imgURL: propTypes.exports.string,
    imgAlt: propTypes.exports.string
  })),
  centerAlignContent: propTypes.exports.bool,
  rightAlignContent: propTypes.exports.bool
};
ContentSection.propTypes = contentSectionPropTypes;

var css$b = ".TwoColumnSection_module_Section__76b5e2f5 {\n  max-width: 1920px;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  background-color: #ffffff;\n}\n@media (min-width: 1024px) {\n  .TwoColumnSection_module_Section__76b5e2f5 {\n    display: grid;\n    grid-template-columns: 50% 50%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_imgWidth50__76b5e2f5 {\n    grid-template-columns: 50% 50%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_imgWidth25__76b5e2f5 {\n    grid-template-columns: 25% 75%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_imgWidth30__76b5e2f5 {\n    grid-template-columns: 30% 70%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_imgWidth40__76b5e2f5 {\n    grid-template-columns: 40% 60%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5 .TwoColumnSection_module_superRadius__76b5e2f5 {\n    border-radius: 0px;\n    border-bottom-right-radius: 100%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5 .TwoColumnSection_module_imageContainer__76b5e2f5 {\n    order: 2;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5.TwoColumnSection_module_imgWidth25__76b5e2f5 {\n    grid-template-columns: 75% 25%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5.TwoColumnSection_module_imgWidth30__76b5e2f5 {\n    grid-template-columns: 70% 30%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5.TwoColumnSection_module_imgWidth40__76b5e2f5 {\n    grid-template-columns: 60% 40%;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5 .TwoColumnSection_module_superRadius__76b5e2f5 {\n    border-radius: 0px;\n    border-bottom-left-radius: 100%;\n  }\n}\n@media (min-width: 700px) {\n  .TwoColumnSection_module_Section__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5 .TwoColumnSection_module_Content__76b5e2f5 {\n    padding: 32px 54px 32px 100px;\n  }\n}\n.TwoColumnSection_module_Section__76b5e2f5 .TwoColumnSection_module_Content__76b5e2f5 {\n  padding: 24px;\n}\n@media (min-width: 700px) {\n  .TwoColumnSection_module_Section__76b5e2f5 .TwoColumnSection_module_Content__76b5e2f5 {\n    width: 100%;\n    padding: 32px 100px 32px 54px;\n    align-self: center;\n  }\n  .TwoColumnSection_module_Section__76b5e2f5 .TwoColumnSection_module_Content__76b5e2f5.TwoColumnSection_module_alternateImage__76b5e2f5 {\n    padding: 32px 54px 32px 100px;\n  }\n}\n.TwoColumnSection_module_Section__76b5e2f5 .TwoColumnSection_module_contentImage__76b5e2f5 {\n  width: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.TwoColumnSection_module_SwiperContent__76b5e2f5 {\n  width: 100%;\n}\n\n.TwoColumnSection_module_SwiperImage__76b5e2f5 {\n  width: 100%;\n  height: auto;\n  object-fit: cover;\n}";
injectCss(css$b);
var modules_0ec4b8ba = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Section":"TwoColumnSection_module_Section__76b5e2f5","imgWidth50":"TwoColumnSection_module_imgWidth50__76b5e2f5","imgWidth25":"TwoColumnSection_module_imgWidth25__76b5e2f5","imgWidth30":"TwoColumnSection_module_imgWidth30__76b5e2f5","imgWidth40":"TwoColumnSection_module_imgWidth40__76b5e2f5","superRadius":"TwoColumnSection_module_superRadius__76b5e2f5","alternateImage":"TwoColumnSection_module_alternateImage__76b5e2f5","imageContainer":"TwoColumnSection_module_imageContainer__76b5e2f5","Content":"TwoColumnSection_module_Content__76b5e2f5","contentImage":"TwoColumnSection_module_contentImage__76b5e2f5","SwiperContent":"TwoColumnSection_module_SwiperContent__76b5e2f5","SwiperImage":"TwoColumnSection_module_SwiperImage__76b5e2f5"};

//Section options
var getClassNames = function getClassNames(Section, props) {
  return [Section, props.extraClass || "", props.swiperSection, props.swiperItems ? modules_0ec4b8ba.SwiperSection : "",
  //Alternate layouts
  props.fullWidth ? modules_0ec4b8ba.FullWidth : props.alternate ? modules_0ec4b8ba.alternateImage : null, props.imgWidth == "25%" ? modules_0ec4b8ba.imgWidth25 : props.imgWidth == "30%" ? modules_0ec4b8ba.imgWidth30 : props.imgWidth == "40%" ? modules_0ec4b8ba.imgWidth40 : props.imgWidth == "50%" ? modules_0ec4b8ba.imgWidth50 : null].join(" ");
};
var TwoColumnSection = function TwoColumnSection(props) {
  return /*#__PURE__*/React__default["default"].createElement("section", {
    className: getClassNames(modules_0ec4b8ba.Section, props),
    style: {
      backgroundColor: props.backgroundColor
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_0ec4b8ba.imageContainer, props.swiperItems ? modules_0ec4b8ba.SwiperContent : null].join(" ")
  }, props.swiperItems ? /*#__PURE__*/React__default["default"].createElement(SwiperWrapper, {
    navigation: true,
    pagination: true
  }, props.swiperItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(Image, {
      key: index,
      id: item.id,
      src: item.imgURL,
      extraClass: modules_0ec4b8ba.SwiperImage,
      alt: item.imgALT,
      aspectRatio: props.imgAspectRatio,
      roundCornerAll: props.imgRadius == "superRadius" ? null : props.imgRadius
    });
  })) : null, !props.swiperItems ? props.imgSrc ? /*#__PURE__*/React__default["default"].createElement(Image, {
    src: props.imgSrc,
    extraClass: [modules_0ec4b8ba.contentImage, props.imgRadius == "superRadius" ? modules_0ec4b8ba.superRadius : null].join(" "),
    alt: props.imgAlt,
    aspectRatio: props.imgAspectRatio,
    roundCornerAll: props.imgRadius == "superRadius" ? null : props.imgRadius
  }) : null : null), /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_0ec4b8ba.Content, props.centerAlignContent ? modules_0ec4b8ba.CenterAlignContent : '', props.rightAlignContent ? modules_0ec4b8ba.RightAlignContent : ''].join(" ")
  }, props.children));
};
var imgWidths = ["25%", "30%", "40%", "50%" //default
];
var aspectRatioOptions = ["auto", "4 / 3", "3 / 4", "16 / 9", "9 / 16", "1 / 1"];
var radiusOptions = ["radiusXXS", "radiusXS", "radiusS", "radiusBase", "radiusM", "radiusL", "radiusXL", "radiusCircle", "superRadius"];
var twoColumnSectionPropTypes = {
  extraClass: propTypes.exports.string,
  height: propTypes.exports.string,
  backgroundColor: propTypes.exports.string,
  imgSrc: propTypes.exports.string,
  imgAlt: propTypes.exports.string,
  imgWidth: propTypes.exports.oneOf(imgWidths),
  imgAspectRatio: propTypes.exports.oneOf(aspectRatioOptions),
  imgRadius: propTypes.exports.oneOf(radiusOptions),
  alternate: propTypes.exports.bool,
  swiperItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    id: propTypes.exports.string,
    imgURL: propTypes.exports.string,
    imgAlt: propTypes.exports.string
  }))
};
TwoColumnSection.propTypes = twoColumnSectionPropTypes;

var css$a = ".Page_module_PageWrapper__0f181cbb {\n  max-width: 1920px;\n  margin: 0 auto;\n  box-shadow: 0 -8px 16px rgba(0, 0, 0, 0.1);\n}";
injectCss(css$a);
var modules_3ca4fc74 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","PageWrapper":"Page_module_PageWrapper__0f181cbb"};

function PageWrapper(props) {
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_3ca4fc74.PageWrapper
  }, props.children);
}

var css$9 = ".IntroCard_module_IntroCard__df73d80e {\n  width: 300px;\n  height: 524px;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e {\n  position: absolute;\n  bottom: 24px;\n  left: 0;\n  width: 284px;\n  border-top-left-radius: 0;\n  border-bottom-left-radius: 0;\n  overflow: visible;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e .IntroCard_module_Header2__df73d80e {\n  max-width: 240px;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e .IntroCard_module_Header2__df73d80e span {\n  display: block;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e .IntroCard_module_Header2__df73d80e .IntroCard_module_FontWeight__df73d80e {\n  font-weight: 500;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e a {\n  position: absolute;\n  top: 24px;\n  right: -16px;\n}\n.IntroCard_module_IntroCard__df73d80e .IntroCard_module_Title__df73d80e a span {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  padding: 0 24px;\n}";
injectCss(css$9);
var modules_f9379d17 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","IntroCard":"IntroCard_module_IntroCard__df73d80e","Title":"IntroCard_module_Title__df73d80e","Header2":"IntroCard_module_Header2__df73d80e","FontWeight":"IntroCard_module_FontWeight__df73d80e"};

function IntroCard(_ref) {
  var titleID = _ref.titleID,
    titleTopLine = _ref.titleTopLine,
    titleBottomLine = _ref.titleBottomLine,
    titleColor = _ref.titleColor,
    imgSrc = _ref.imgSrc,
    imgAlt = _ref.imgAlt,
    iconName = _ref.iconName,
    iconColor = _ref.iconColor,
    buttonHref = _ref.buttonHref,
    buttonAriaLabel = _ref.buttonAriaLabel,
    buttonRel = _ref.buttonRel;
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_f9379d17.IntroCard,
    style: "Shadow",
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Image, {
    src: imgSrc,
    height: "100%",
    width: "100%",
    objectFit: "cover",
    alt: imgAlt
  }), /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_f9379d17.Title,
    style: "Shadow"
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconName: iconName,
    iconHSize: 48,
    iconWSize: 48,
    iconColor: iconColor
  }), /*#__PURE__*/React__default["default"].createElement(Header2, {
    id: titleID,
    extraClass: modules_f9379d17.Header2
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    serif: true,
    fontSize: "L",
    uppercase: true,
    color: titleColor,
    extraClass: modules_f9379d17.FontWeight
  }, titleTopLine), /*#__PURE__*/React__default["default"].createElement(Span, {
    serif: true,
    fontSize: "XL",
    uppercase: true,
    color: titleColor,
    extraClass: modules_f9379d17.FontWeight
  }, titleBottomLine)), /*#__PURE__*/React__default["default"].createElement(ButtonLink, {
    color: "RED",
    label: "Show all",
    square: true,
    href: buttonHref,
    ariaLabel: buttonAriaLabel,
    rel: buttonRel
  })));
}
IntroCard.propTypes = {
  titleID: propTypes.exports.string,
  titleTopLine: propTypes.exports.string,
  titleBottomLine: propTypes.exports.string,
  titleColor: propTypes.exports.string,
  imgSrc: propTypes.exports.string,
  imgAlt: propTypes.exports.string,
  iconName: propTypes.exports.string,
  iconColor: propTypes.exports.string,
  buttonHref: propTypes.exports.string,
  buttonAriaLabel: propTypes.exports.string,
  buttonRel: propTypes.exports.string
};

function RatingStars(_ref) {
  var _ref$ratingScore = _ref.ratingScore,
    ratingScore = _ref$ratingScore === void 0 ? 4 : _ref$ratingScore,
    extraClass = _ref.extraClass;
  return /*#__PURE__*/React__default["default"].createElement("span", {
    className: extraClass
  }, Array.from(Array(ratingScore <= 5 ? ratingScore : 0)).map(function (index, i) {
    return /*#__PURE__*/React__default["default"].createElement(Icon, {
      key: i + "solidStar",
      iconColor: "#444f6b",
      iconName: "star--solid"
    });
  }), Array.from(Array(ratingScore < 5 ? ratingScore = 5 - ratingScore : ratingScore = 0)).map(function (index, i) {
    return /*#__PURE__*/React__default["default"].createElement(Icon, {
      key: i + "outlineStar",
      iconColor: "#444f6b",
      iconName: "star--outline"
    });
  }));
}
RatingStars.propTypes = {
  ratingScore: propTypes.exports.number,
  extraClass: propTypes.exports.string
};

var css$8 = ".HorizontalScale_module_HorizontalScale__3562e6a3 {\n  width: 100%;\n  max-width: 500px;\n}\n@media (max-width: 360px) {\n  .HorizontalScale_module_HorizontalScale__3562e6a3 {\n    max-width: 200px !important;\n  }\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleLabelContainer__3562e6a3 {\n  padding-bottom: 5px;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3 {\n  display: grid;\n  grid-auto-flow: column;\n  border-radius: 14px;\n  box-shadow: 1px 4px 10px rgba(25, 25, 25, 0.3);\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3 span {\n  height: 12px;\n  display: block;\n  border-radius: 0;\n  border-left-width: 1px;\n  border-left-color: #d4d4d8;\n  border-left-style: solid;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3 span:first-child {\n  border-top-left-radius: 14px;\n  border-bottom-left-radius: 14px;\n  border-left: 1px transparent solid;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3 span:last-child {\n  border-top-right-radius: 14px;\n  border-bottom-right-radius: 14px;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3.HorizontalScale_module_HorizontalScaleNumbers1__3562e6a3 span:nth-child(-n+1) {\n  background-color: #ce0c1c;\n  border-left-color: #ffffff;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3.HorizontalScale_module_HorizontalScaleNumbers2__3562e6a3 span:nth-child(-n+2) {\n  background-color: #ce0c1c;\n  border-left-color: #ffffff;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3.HorizontalScale_module_HorizontalScaleNumbers3__3562e6a3 span:nth-child(-n+3) {\n  background-color: #cc8202;\n  border-left-color: #ffffff;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3.HorizontalScale_module_HorizontalScaleNumbers4__3562e6a3 span:nth-child(-n+4) {\n  background-color: #337b1f;\n  border-left-color: #ffffff;\n}\n.HorizontalScale_module_HorizontalScale__3562e6a3 .HorizontalScale_module_HorizontalScaleNumbers__3562e6a3.HorizontalScale_module_HorizontalScaleNumbers5__3562e6a3 span:nth-child(-n+5) {\n  background-color: #337b1f;\n  border-left-color: #ffffff;\n}";
injectCss(css$8);
var modules_4d949811 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","HorizontalScale":"HorizontalScale_module_HorizontalScale__3562e6a3","HorizontalScaleLabelContainer":"HorizontalScale_module_HorizontalScaleLabelContainer__3562e6a3","HorizontalScaleNumbers":"HorizontalScale_module_HorizontalScaleNumbers__3562e6a3","HorizontalScaleNumbers1":"HorizontalScale_module_HorizontalScaleNumbers1__3562e6a3","HorizontalScaleNumbers2":"HorizontalScale_module_HorizontalScaleNumbers2__3562e6a3","HorizontalScaleNumbers3":"HorizontalScale_module_HorizontalScaleNumbers3__3562e6a3","HorizontalScaleNumbers4":"HorizontalScale_module_HorizontalScaleNumbers4__3562e6a3","HorizontalScaleNumbers5":"HorizontalScale_module_HorizontalScaleNumbers5__3562e6a3"};

function HorizontalScale(_ref) {
  var _ref$label = _ref.label,
    label = _ref$label === void 0 ? "Text Goes Here:" : _ref$label,
    _ref$labelDescription = _ref.labelDescription,
    labelDescription = _ref$labelDescription === void 0 ? "Good" : _ref$labelDescription,
    _ref$rating = _ref.rating,
    rating = _ref$rating === void 0 ? 4 : _ref$rating,
    _ref$maxWidth = _ref.maxWidth,
    maxWidth = _ref$maxWidth === void 0 ? "500px" : _ref$maxWidth;
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_4d949811.HorizontalScale,
    style: {
      maxWidth: "" + maxWidth + ""
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_4d949811.HorizontalScaleLabelContainer
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S",
    className: modules_4d949811.HorizontalScaleLabel
  }, label, " "), /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S",
    bold: true,
    className: modules_4d949811.HorizontalScaleDescription
  }, labelDescription, " ")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_4d949811.HorizontalScaleNumbers, rating == 1 ? modules_4d949811.HorizontalScaleNumbers1 : null, rating == 2 ? modules_4d949811.HorizontalScaleNumbers2 : null, rating == 3 ? modules_4d949811.HorizontalScaleNumbers3 : null, rating == 4 ? modules_4d949811.HorizontalScaleNumbers4 : null, rating == 5 ? modules_4d949811.HorizontalScaleNumbers5 : null].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null), /*#__PURE__*/React__default["default"].createElement("span", null)));
}
HorizontalScale.propTypes = {
  label: propTypes.exports.string,
  labelDescription: propTypes.exports.string,
  rating: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number]),
  maxWidth: propTypes.exports.string
};

var css$7 = ".ReviewListing_module_ReviewName__da622869 {\n  display: flex;\n  align-items: center;\n}\n\n.ReviewListing_module_ReviewHeaderContainer__da622869 {\n  display: flex;\n  align-items: center;\n}\n@media (max-width: 700px) {\n  .ReviewListing_module_ReviewHeaderContainer__da622869 {\n    flex-direction: column;\n    justify-items: start;\n    align-items: flex-start;\n  }\n}\n\n.ReviewListing_module_MemberIcon__da622869 {\n  min-width: 44px;\n}\n\n.ReviewListing_module_RatingStars__da622869 {\n  margin: 0 14px 0 8px;\n  min-width: 120px;\n}\n\n.ReviewListing_module_Review__da622869 {\n  padding-left: 24px;\n  padding-right: 24px;\n}\n@media (max-width: 700px) {\n  .ReviewListing_module_Review__da622869 {\n    padding-left: 0;\n    padding-right: 0;\n  }\n}\n\n.ReviewListing_module_Ellipsis__da622869 {\n  display: block;\n  display: -webkit-box;\n  max-width: 100%;\n  height: 52x;\n  margin: 0 auto;\n  -webkit-line-clamp: 2;\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.ReviewListing_module_NoEllipsis__da622869 {\n  height: auto;\n  overflow: auto;\n  text-overflow: inherit;\n}\n\n.ReviewListing_module_ReadMoreInline__da622869 a {\n  display: inline;\n}\n\n.ReviewListing_module_ReadMore__da622869 {\n  font-style: italic;\n}\n\n.ReviewListing_module_Scales__da622869 {\n  margin: 14px 0 24px 0;\n}";
injectCss(css$7);
var modules_cc1638ef = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","ReviewName":"ReviewListing_module_ReviewName__da622869","ReviewHeaderContainer":"ReviewListing_module_ReviewHeaderContainer__da622869","MemberIcon":"ReviewListing_module_MemberIcon__da622869","RatingStars":"ReviewListing_module_RatingStars__da622869","Review":"ReviewListing_module_Review__da622869","Ellipsis":"ReviewListing_module_Ellipsis__da622869","NoEllipsis":"ReviewListing_module_NoEllipsis__da622869","ReadMoreInline":"ReviewListing_module_ReadMoreInline__da622869","ReadMore":"ReviewListing_module_ReadMore__da622869","Scales":"ReviewListing_module_Scales__da622869"};

function ReviewListing(_ref) {
  var extraClass = _ref.extraClass,
    ratingScore = _ref.ratingScore,
    reviewComment = _ref.reviewComment,
    scaleItems = _ref.scaleItems,
    reviewDate = _ref.reviewDate,
    reviewerName = _ref.reviewerName,
    reviewerLocation = _ref.reviewerLocation;
  var _useState = React.useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: extraClass,
    style: "Shadow",
    width: "980"
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_cc1638ef.Review
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_cc1638ef.ReviewHeaderContainer
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_cc1638ef.ReviewName
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    extraClass: modules_cc1638ef.MemberIcon,
    iconColor: "#444f6b",
    iconName: "member--review",
    iconHSize: 44,
    iconWSize: 44
  }), /*#__PURE__*/React__default["default"].createElement(RatingStars, {
    extraClass: modules_cc1638ef.RatingStars,
    ratingScore: ratingScore
  })), reviewDate ? /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S"
  }, "Reviewed on ", reviewDate) : null), reviewerName ? /*#__PURE__*/React__default["default"].createElement(Paragraph, {
    bold: true
  }, reviewerName, reviewerLocation ? ", " + reviewerLocation : null) : null, scaleItems ? /*#__PURE__*/React__default["default"].createElement(GridColumnsContainer, {
    extraClass: modules_cc1638ef.Scales,
    columnM: "4",
    columnS: "6",
    alignVertical: "top",
    gap: "largeGap"
  }, scaleItems.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(HorizontalScale, {
      key: index,
      label: item.label,
      labelDescription: item.labelDescription,
      rating: item.rating,
      maxWidth: "none"
    });
  })) : null, reviewComment ? /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_cc1638ef.ReadMoreInline
  }, /*#__PURE__*/React__default["default"].createElement(Paragraph, null, isOpen ? reviewComment : reviewComment.length >= 260 ? "".concat(reviewComment.substring(0, 260), "...") : reviewComment, reviewComment.length >= 260 ? /*#__PURE__*/React__default["default"].createElement(Link, {
    action: function action() {
      return setIsOpen(!isOpen);
    },
    extraClass: modules_cc1638ef.ReadMore,
    label: isOpen ? " Read less" : " Read more"
  }) : null)) : null));
}
ReviewListing.propTypes = {
  extraClass: propTypes.exports.string,
  reviewDate: propTypes.exports.string,
  reviewerName: propTypes.exports.string,
  reviewerLocation: propTypes.exports.string,
  reviewComment: propTypes.exports.string,
  scaleItems: propTypes.exports.arrayOf(propTypes.exports.shape({
    label: propTypes.exports.string,
    labelDescription: propTypes.exports.string,
    rating: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
  })),
  ratingScore: propTypes.exports.oneOfType([propTypes.exports.string, propTypes.exports.number])
};

var css$6 = "";
injectCss(css$6);
var modules_8827c9dd = {"uiBreakMax":"1920","uiBreakDesktop":"1366","uiBreakMobilePortraitMin":"300","uiBreakTabletPortraitMin":"700","uiBreakDesktopMin":"1024","uiBreakWideScreenMin":"1920"};

var css$5 = ".TripCanvasHeader_module_TCHeader__a56b89fb {\n  position: relative;\n  color: white;\n  padding: 0;\n  min-height: var(--TCHeaderMobileHeight);\n  transition: all 0.5s;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb {\n    min-height: var(--TCHeaderTabletHeight);\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb {\n    min-height: var(--TCHeaderDesktopHeight);\n  }\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb.TripCanvasHeader_module_TCHeaderHeightDefault__a56b89fb {\n  --TCHeaderMobileHeight: 360px;\n  --TCHeaderTabletHeight: calc(300px + 3.75rem);\n  --TCHeaderDesktopHeight: calc(250px + 3.75rem);\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb.TripCanvasHeader_module_TCHeaderHeightActiveTrip__a56b89fb {\n  --TCHeaderMobileHeight: 285px;\n  --TCHeaderTabletHeight: calc(220px + 3.75rem);\n  --TCHeaderDesktopHeight: calc(150px + 3.75rem);\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb.TripCanvasHeader_module_TCHeaderHideRegion__a56b89fb {\n  --TCHeaderMobileHeight: 150px;\n  --TCHeaderTabletHeight: 150px;\n  --TCHeaderDesktopHeight: 150px;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb {\n  min-height: var(--TCHeaderMobileHeight);\n  position: fixed;\n  width: 100%;\n  max-width: 1920px;\n  top: 0;\n  display: block;\n  padding-bottom: 3.75rem;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb {\n    min-height: var(--TCHeaderTabletHeight);\n  }\n}\n@media only screen and (min-width: 1200px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb {\n    min-height: var(--TCHeaderDesktopHeight);\n  }\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb {\n    position: fixed;\n  }\n}\n@media (max-width: 1080px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb {\n    position: absolute;\n  }\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb {\n  position: relative;\n  z-index: 1;\n  padding: 12px;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb {\n    padding: 12px 24px;\n  }\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderContentLeft__a56b89fb {\n  width: auto;\n  max-width: fit-content;\n  position: relative;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderContentLeft__a56b89fb {\n    padding-left: 42px;\n  }\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderLogo__a56b89fb {\n  width: 100%;\n  height: 70px;\n  display: block;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderLogoLink__a56b89fb {\n  width: 100%;\n  max-width: 228px;\n  display: block;\n  max-height: 70px;\n  position: relative;\n  align-self: flex-start;\n  transition: all 0.3s;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderLogoLink__a56b89fb .TripCanvasHeader_module_TCHeaderLogoLinkLabel__a56b89fb {\n  clip: rect(0 0 0 0);\n  clip-path: inset(100%);\n  height: 1px;\n  overflow: hidden;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n  z-index: -100;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_betaBadge__a56b89fb {\n  position: absolute;\n  top: 0;\n  right: 0px;\n  font-weight: 700;\n  font-size: 10px;\n  background-color: #ffffff;\n  border-radius: 50px;\n  width: 40px;\n  height: 17px;\n  font-size: 10px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: help;\n  transition: all 0.3s;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_betaBadge__a56b89fb span {\n  font-size: 10px;\n  color: #ce0c1c;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_betaBadge__a56b89fb:hover {\n  transform: scale(1.2);\n  transform-origin: center top;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderCenterContent__a56b89fb {\n  width: 100%;\n  max-width: 620px;\n  margin: 0 auto;\n  text-align: center;\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderRightMenu__a56b89fb {\n  display: flex;\n  align-items: center;\n  gap: 14px;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderContent__a56b89fb .TripCanvasHeader_module_TCHeaderRightMenu__a56b89fb {\n    gap: 24px;\n  }\n}\n.TripCanvasHeader_module_TCHeader__a56b89fb .TripCanvasHeader_module_TCHeaderImage__a56b89fb {\n  bottom: 0;\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  filter: brightness(0.7);\n}\n\n.TripCanvasHeader_module_TCHeaderSearchInputContainer__a56b89fb {\n  width: 100%;\n  max-width: 420px;\n}\n\n.TripCanvasHeader_module_TCHeaderSearch__a56b89fb {\n  width: 100%;\n  height: calc(100% - 48px);\n  display: flex;\n  justify-content: center;\n  flex-direction: column;\n  align-items: center;\n  padding: 0 24px;\n  padding-top: 84px;\n  position: absolute;\n  pointer-events: none;\n}\n@media only screen and (min-width: 1024px) {\n  .TripCanvasHeader_module_TCHeaderSearch__a56b89fb {\n    padding-top: 24px;\n  }\n}\n.TripCanvasHeader_module_TCHeaderSearch__a56b89fb * {\n  pointer-events: all;\n}\n.TripCanvasHeader_module_TCHeaderSearch__a56b89fb .TripCanvasHeader_module_TCDefaultSearchField__a56b89fb {\n  width: 100%;\n  max-width: 420px;\n  display: inline-block;\n  margin-bottom: 14px;\n}\n.TripCanvasHeader_module_TCHeaderSearch__a56b89fb .TripCanvasHeader_module_TCDefaultSearchField__a56b89fb label {\n  font-family: \"Vollkorn\", serif;\n  font-size: 24px;\n  text-align: center;\n  color: white;\n}\n\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb {\n  width: 100%;\n  position: absolute;\n  bottom: 15px;\n  pointer-events: none;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb * {\n  pointer-events: all;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb {\n  width: 100%;\n  max-width: 768px;\n  margin: 0 auto;\n  z-index: 2;\n  text-align: center;\n  padding: 0 24px;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb {\n    padding: 0 72px;\n  }\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsName__a56b89fb {\n  display: flex;\n  justify-content: center;\n  gap: 14px;\n  padding-bottom: 14px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsName__a56b89fb span {\n  align-self: center;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n  padding-bottom: 14px;\n  text-align: center;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb {\n  font-size: 24px;\n  text-align: center;\n  color: white;\n  width: 100%;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb > span {\n  width: 100%;\n  max-width: calc(100vw - 48px);\n  margin: 0 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDates__a56b89fb {\n  display: inline-flex;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDatesButton__a56b89fb {\n  font-size: 16px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDatesButton__a56b89fb > span {\n  font-size: 16px;\n  height: 32px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 0;\n  text-align: center;\n  flex-wrap: wrap;\n  justify-content: center;\n  padding: 14px;\n  column-gap: 12px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsBadge__a56b89fb {\n  padding: 0;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb {\n  font-family: \"Vollkorn\", serif;\n  font-size: 24px;\n  text-align: center;\n  color: white;\n  max-width: calc(100vw - 48px - 42px - 14px);\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb {\n    max-width: 520px;\n  }\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb > span {\n  width: 100%;\n  height: 30px;\n  max-width: 520px;\n  margin: 14px auto 0 auto;\n  white-space: nowrap;\n  overflow: hidden;\n  text-align: center;\n  text-overflow: ellipsis;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDates__a56b89fb {\n  width: 100%;\n  display: inline-flex;\n  justify-content: center;\n}\n@media only screen and (min-width: 768px) {\n  .TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDates__a56b89fb *:hover {\n    text-decoration: underline;\n    color: white;\n  }\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDatesButton__a56b89fb {\n  font-size: 16px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsDatesButton__a56b89fb > span {\n  font-size: 16px;\n  height: 32px;\n}\n.TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb .TripCanvasHeader_module_TCHeaderTripControls__a56b89fb .TripCanvasHeader_module_TCHeaderTripControlsNodes__a56b89fb {\n  display: inline-block;\n  min-width: 200px;\n  border-radius: 50px;\n}";
injectCss(css$5);
var modules_0b7b46a9 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","TCHeader":"TripCanvasHeader_module_TCHeader__a56b89fb","TCHeaderHeightDefault":"TripCanvasHeader_module_TCHeaderHeightDefault__a56b89fb","TCHeaderHeightActiveTrip":"TripCanvasHeader_module_TCHeaderHeightActiveTrip__a56b89fb","TCHeaderHideRegion":"TripCanvasHeader_module_TCHeaderHideRegion__a56b89fb","TCHeaderContentWrapper":"TripCanvasHeader_module_TCHeaderContentWrapper__a56b89fb","TCHeaderContent":"TripCanvasHeader_module_TCHeaderContent__a56b89fb","TCHeaderContentLeft":"TripCanvasHeader_module_TCHeaderContentLeft__a56b89fb","TCHeaderLogo":"TripCanvasHeader_module_TCHeaderLogo__a56b89fb","TCHeaderLogoLink":"TripCanvasHeader_module_TCHeaderLogoLink__a56b89fb","TCHeaderLogoLinkLabel":"TripCanvasHeader_module_TCHeaderLogoLinkLabel__a56b89fb","betaBadge":"TripCanvasHeader_module_betaBadge__a56b89fb","TCHeaderCenterContent":"TripCanvasHeader_module_TCHeaderCenterContent__a56b89fb","TCHeaderRightMenu":"TripCanvasHeader_module_TCHeaderRightMenu__a56b89fb","TCHeaderImage":"TripCanvasHeader_module_TCHeaderImage__a56b89fb","TCHeaderSearchInputContainer":"TripCanvasHeader_module_TCHeaderSearchInputContainer__a56b89fb","TCHeaderSearch":"TripCanvasHeader_module_TCHeaderSearch__a56b89fb","TCDefaultSearchField":"TripCanvasHeader_module_TCDefaultSearchField__a56b89fb","TCHeaderTripControlsContainer":"TripCanvasHeader_module_TCHeaderTripControlsContainer__a56b89fb","TCHeaderTripControls":"TripCanvasHeader_module_TCHeaderTripControls__a56b89fb","TCHeaderTripControlsName":"TripCanvasHeader_module_TCHeaderTripControlsName__a56b89fb","TCHeaderTripControlsNameStacked":"TripCanvasHeader_module_TCHeaderTripControlsNameStacked__a56b89fb","TCHeaderTripControlsNameLabel":"TripCanvasHeader_module_TCHeaderTripControlsNameLabel__a56b89fb","TCHeaderTripControlsDates":"TripCanvasHeader_module_TCHeaderTripControlsDates__a56b89fb","TCHeaderTripControlsDatesButton":"TripCanvasHeader_module_TCHeaderTripControlsDatesButton__a56b89fb","TCHeaderTripControlsNameHorizontal":"TripCanvasHeader_module_TCHeaderTripControlsNameHorizontal__a56b89fb","TCHeaderTripControlsBadge":"TripCanvasHeader_module_TCHeaderTripControlsBadge__a56b89fb","TCHeaderTripControlsNodes":"TripCanvasHeader_module_TCHeaderTripControlsNodes__a56b89fb"};

function TripCanvasHeader(_ref) {
  var Logo = _ref.Logo,
    LogoAlt = _ref.LogoAlt,
    LogoLink = _ref.LogoLink,
    bgIMG = _ref.bgIMG,
    bgIMGMobile = _ref.bgIMGMobile,
    defaultRegion = _ref.defaultRegion,
    _ref$setActiveTrip = _ref.setActiveTrip,
    setActiveTrip = _ref$setActiveTrip === void 0 ? false : _ref$setActiveTrip,
    _ref$hideRegions = _ref.hideRegions,
    hideRegions = _ref$hideRegions === void 0 ? false : _ref$hideRegions,
    activeTripRegion = _ref.activeTripRegion,
    rightMenuElement = _ref.rightMenuElement;
    _ref.betaCopy;
  return /*#__PURE__*/React__default["default"].createElement(Header, {
    extraClass: [modules_0b7b46a9.TCHeader, setActiveTrip ? modules_0b7b46a9.TCHeaderHeightActiveTrip : modules_0b7b46a9.TCHeaderHeightDefault, hideRegions ? modules_0b7b46a9.TCHeaderHideRegion : ""].join(" ")
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_0b7b46a9.TCHeaderContentWrapper
  }, /*#__PURE__*/React__default["default"].createElement(GridContainer, {
    extraClass: modules_0b7b46a9.TCHeaderContent,
    gap: "noGap"
  }, /*#__PURE__*/React__default["default"].createElement(GridColumn, {
    column: "6",
    extraClass: modules_0b7b46a9.TCHeaderContentLeft
  }, /*#__PURE__*/React__default["default"].createElement("a", {
    href: LogoLink,
    rel: "noreferrer",
    className: modules_0b7b46a9.TCHeaderLogoLink
  }, /*#__PURE__*/React__default["default"].createElement("img", {
    alt: LogoAlt,
    src: Logo,
    className: modules_0b7b46a9.TCHeaderLogo
  }), /*#__PURE__*/React__default["default"].createElement("span", {
    className: modules_0b7b46a9.TCHeaderLogoLinkLabel
  }, "Trip Canvas Home"))), /*#__PURE__*/React__default["default"].createElement(GridColumn, {
    column: "6",
    alignHorizontal: "right",
    alignVertical: "center"
  }, /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_0b7b46a9.TCHeaderRightMenu,
    noPadding: true
  }, rightMenuElement || /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null)))), /*#__PURE__*/React__default["default"].createElement("picture", null, /*#__PURE__*/React__default["default"].createElement("source", {
    srcSet: bgIMG,
    media: "(min-width: ".concat(modules_8827c9dd.uiBreakDesktopMin, "px)")
  }), /*#__PURE__*/React__default["default"].createElement("img", {
    className: modules_0b7b46a9.TCHeaderImage,
    src: bgIMGMobile,
    alt: "",
    fetchpriority: "high"
  }))), hideRegions == false ? /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, setActiveTrip ? activeTripRegion : defaultRegion) : null);
}
TripCanvasHeader.propTypes = {
  Logo: propTypes.exports.string,
  LogoAlt: propTypes.exports.string,
  bgIMG: propTypes.exports.string,
  bgIMGMobile: propTypes.exports.string,
  defaultRegion: propTypes.exports.node,
  setActiveTrip: propTypes.exports.bool,
  activeTripRegion: propTypes.exports.node,
  rightMenuElement: propTypes.exports.node,
  hideRegions: propTypes.exports.bool
};

function TripCanvasDefaultSearch(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? "Let's go somewhere." : _ref$title,
    _ref$searchInput = _ref.searchInput,
    searchInput = _ref$searchInput === void 0 ? /*#__PURE__*/React__default["default"].createElement(Input, {
      placeholder: "Search Trip Canvas",
      iconName: "location--solid",
      showIcon: true,
      autoWidth: true,
      name: "SearchTripCanvas",
      label: "Search Trip Canvas",
      hideLabel: true,
      extraClass: modules_0b7b46a9.TCDefaultSearchField
    }) : _ref$searchInput,
    buttonAction = _ref.buttonAction,
    _ref$buttonText = _ref.buttonText,
    buttonText = _ref$buttonText === void 0 ? "How Trip Canvas works" : _ref$buttonText,
    _ref$buttonIcon = _ref.buttonIcon,
    buttonIcon = _ref$buttonIcon === void 0 ? "ui-circle-solid--play" : _ref$buttonIcon;
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_0b7b46a9.TCHeaderSearch,
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    bold: true,
    serif: true,
    centerText: true,
    color: "#ffffff",
    spacing: true,
    fontSize: "L"
  }, title), /*#__PURE__*/React__default["default"].createElement(Span, {
    extraClass: modules_0b7b46a9.TCHeaderSearchInputContainer
  }, searchInput ? searchInput : null), /*#__PURE__*/React__default["default"].createElement(Container, {
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    action: buttonAction,
    iconName: buttonIcon,
    style: "PLAIN",
    color: "WHITE"
  }, buttonText)));
}
TripCanvasDefaultSearch.propTypes = {
  title: propTypes.exports.string,
  searchInput: propTypes.exports.node.isRequired,
  ButtonAction: propTypes.exports.func,
  ButtonText: propTypes.exports.string
};

function TripCanvasActiveTrip(_ref) {
  var TripControls = _ref.TripControls,
    TripTitle = _ref.TripTitle,
    TripHeartedCount = _ref.TripHeartedCount,
    _ref$TripDates = _ref.TripDates,
    TripDates = _ref$TripDates === void 0 ? "ADD DATES +" : _ref$TripDates,
    TripDatesAction = _ref.TripDatesAction,
    TripURL = _ref.TripURL;
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_0b7b46a9.TCHeaderTripControlsContainer,
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_0b7b46a9.TCHeaderTripControls,
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: modules_0b7b46a9.TCHeaderTripControlsNameHorizontal,
    noPadding: true
  }, /*#__PURE__*/React__default["default"].createElement(ButtonLink, {
    href: TripURL,
    style: "PLAIN",
    extraClass: modules_0b7b46a9.TCHeaderTripControlsBadge
  }, /*#__PURE__*/React__default["default"].createElement(Badge, {
    icon: true,
    iconColor: "#ce0c1c",
    badgeCountColor: "#ffffff",
    iconShadow: true,
    iconName: "heart--solid",
    badgeCount: TripHeartedCount
  })), /*#__PURE__*/React__default["default"].createElement(Link, {
    href: TripURL,
    extraClass: modules_0b7b46a9.TCHeaderTripControlsNameLabel,
    label: TripTitle
  }), /*#__PURE__*/React__default["default"].createElement(Span, {
    extraClass: modules_0b7b46a9.TCHeaderTripControlsDates
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    iconName: "calendar",
    style: "PLAIN",
    color: "WHITE",
    extraClass: modules_0b7b46a9.TCHeaderTripControlsDatesButton,
    action: TripDatesAction
  }, TripDates))), TripControls));
}
TripCanvasActiveTrip.propTypes = {
  TripControls: propTypes.exports.node,
  TripTitle: propTypes.exports.string,
  TripHeartedCount: propTypes.exports.string,
  TripDates: propTypes.exports.string,
  TripDatesAction: propTypes.exports.func
};

var css$4 = ".DialIndicator_module_Dial__d91370b2 {\n  position: relative;\n  padding: 24px;\n  max-width: fit-content;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_DialSvg__d91370b2 {\n  --DialStrokeColor:#444F6B;\n  --DialTrackColor:#ffffff;\n  --DialSize: 150px;\n  --DialStrokeWidth: 10px;\n  --DialTrackStrokeWidth: 16px;\n  --DialCenter: calc(var(--DialSize) / 2);\n  --DialRadius: calc(var(--DialCenter) - var(--DialStrokeWidth));\n  --DialProgressDecimal: 0;\n  --DialBaseNumber: 5;\n  --DialBaseNumberValue: calc(100 - (100 / var(--DialBaseNumber)));\n  --DialProgress: calc((var(--DialProgressDecimal) / var(--DialBaseNumber) * var(--DialBaseNumberValue)));\n  --arcLength: calc(2 * 3.14 * var(--DialRadius));\n  --arcOffset: calc(var(--arcLength) * ((100 - var(--DialProgress))/100) );\n  transition: all 0.5s;\n  width: var(--DialSize);\n  height: var(--DialSize);\n  transform: rotate(-233.9deg); /* Fix the orientation */\n  position: relative;\n  background: 0 0;\n  box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.2), inset 0 0 0 16px #fff, inset 0px 0px 16px 16px rgba(0, 0, 0, 0.2);\n  border-radius: 150px;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_DialSvg__d91370b2 .DialIndicator_module_svgIndicator__d91370b2 {\n  stroke: var(--DialStrokeColor);\n  stroke-dasharray: var(--arcLength); /* DashArray = Track's or indicator's Circumference */\n  stroke-dashoffset: var(--arcOffset); /* DashOffset = DashArray * ((100 - progress)/100) */\n  stroke-linecap: round;\n  transition: all 0.5s;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_DialSvg__d91370b2 .DialIndicator_module_svgTrack__d91370b2,\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_DialSvg__d91370b2 .DialIndicator_module_svgIndicator__d91370b2 {\n  cx: var(--DialCenter);\n  cy: var(--DialCenter);\n  r: var(--DialRadius);\n  fill: transparent;\n  stroke-width: calc(var(--DialStrokeWidth));\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_DialSvg__d91370b2 .DialIndicator_module_svgTrack__d91370b2 {\n  stroke: var(--DialTrackColor);\n  transition: all 0.5s;\n  stroke-width: calc(var(--DialTrackStrokeWidth));\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_Steps__d91370b2 {\n  position: absolute;\n  top: 98px;\n  left: 98px;\n  z-index: 1;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_Steps__d91370b2 .DialIndicator_module_Step__d91370b2 {\n  position: absolute;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  transform-origin: top center;\n  transform-style: rotate3d(0, 0, 1, 0deg);\n  font-size: 14px;\n  color: #444F6B;\n  height: 99px;\n  width: 1px;\n  transition: transform 300ms ease;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_Steps__d91370b2 .DialIndicator_module_Step__d91370b2 .DialIndicator_module_SmallNumber__d91370b2 {\n  color: #d4d4d8;\n  font-weight: lighter;\n}\n.DialIndicator_module_Dial__d91370b2 .DialIndicator_module_Text__d91370b2 {\n  position: absolute;\n  width: 100%;\n  height: 198px;\n  top: 0;\n  left: 0;\n  display: flex;\n  flex-direction: column;\n  color: #444f6b;\n  align-items: center;\n  justify-content: center;\n}";
injectCss(css$4);
var modules_8012e5ef = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Dial":"DialIndicator_module_Dial__d91370b2","DialSvg":"DialIndicator_module_DialSvg__d91370b2","svgIndicator":"DialIndicator_module_svgIndicator__d91370b2","svgTrack":"DialIndicator_module_svgTrack__d91370b2","Steps":"DialIndicator_module_Steps__d91370b2","Step":"DialIndicator_module_Step__d91370b2","SmallNumber":"DialIndicator_module_SmallNumber__d91370b2","Text":"DialIndicator_module_Text__d91370b2"};

function DialIndicator(_ref) {
  var dialLabel = _ref.dialLabel,
    value = _ref.value;
  var _React$useState = React__default["default"].useState(null),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    dialValue = _React$useState2[0],
    setDialValue = _React$useState2[1];
  React.useEffect(function () {
    setDialValue(value);
  });
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.ServiceRating
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Dial
  }, /*#__PURE__*/React__default["default"].createElement("svg", {
    className: modules_8012e5ef.DialSvg,
    style: {
      "--DialProgressDecimal": dialValue > 5 ? 5 : dialValue
    }
  }, /*#__PURE__*/React__default["default"].createElement("circle", {
    className: modules_8012e5ef.svgTrack
  }), /*#__PURE__*/React__default["default"].createElement("circle", {
    className: modules_8012e5ef.svgIndicator
  })), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Text
  }, /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "S"
  }, dialLabel), /*#__PURE__*/React__default["default"].createElement(Span, {
    fontSize: "XL",
    bold: true
  }, value)), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Steps
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 30deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 330deg)"
    }
  }, "0")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 90deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 270deg)"
    }
  }, "1")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 150deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 210deg)"
    }
  }, "2")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 210deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 150deg)"
    }
  }, "3")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 270deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 90deg)"
    }
  }, "4")), /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_8012e5ef.Step,
    style: {
      transform: "rotate3d(0, 0, 1, 330deg)"
    }
  }, /*#__PURE__*/React__default["default"].createElement("span", {
    style: {
      transform: "rotate3d(0, 0, 1, 30deg)"
    }
  }, "5")))));
}
DialIndicator.propTypes = {
  dialLabel: propTypes.exports.string,
  value: propTypes.exports.number
};

var css$3 = ".DiamondIndicator_module_DiamondIndicator__1c24c074 {\n  cursor: pointer;\n  padding-bottom: 6px;\n}\n.DiamondIndicator_module_DiamondIndicator__1c24c074 svg {\n  display: block;\n}\n\n.DiamondIndicator_module_ToolTip__1c24c074 {\n  max-width: 300px;\n}";
injectCss(css$3);
var modules_90a9aeac = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","DiamondIndicator":"DiamondIndicator_module_DiamondIndicator__1c24c074","ToolTip":"DiamondIndicator_module_ToolTip__1c24c074"};

function DiamondIndicator(_ref) {
  var diamondStyle = _ref.diamondStyle,
    diamondType = _ref.diamondType,
    extraClass = _ref.extraClass;
  var diamondText = "";
  if (diamondType == "diamond-five") {
    diamondText = "World-class luxury, amenities and indulgence for a once-in-a-lifetime experience.";
  }
  if (diamondType == "diamond-four") {
    diamondText = "Upscale style and amenities enhanced with the right touch of service.";
  }
  if (diamondType == "diamond-three") {
    diamondText = "Comprehensive amenities, style and comfort level.";
  }
  if (diamondType == "diamond-approved") {
    diamondText = "Noteworthy by meeting the industry-leading standards of AAA inspections.";
  }
  return /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    content: /*#__PURE__*/React__default["default"].createElement(Paragraph, {
      fontSize: "S",
      bold: true,
      extraClass: modules_90a9aeac.ToolTip
    }, diamondText),
    options: {
      offset: [0, 0],
      maxWidth: "300px"
    }
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: [modules_90a9aeac.DiamondIndicator, extraClass].join(" "),
    style: {
      width: diamondStyle == "Long" ? "197px" : "107px"
    }
  }, /*#__PURE__*/React__default["default"].createElement(Icon, {
    iconHSize: 45,
    iconName: diamondStyle == "Long" ? diamondType + "-long" : diamondType,
    iconWSize: diamondStyle == "Long" ? "197" : "107"
  })));
}
DiamondIndicator.propTypes = {
  extraClass: propTypes.exports.string,
  diamondStyle: propTypes.exports.oneOf(["Long", "Short"]),
  diamondType: propTypes.exports.oneOf(["diamond-approved", "diamond-three", "diamond-four", "diamond-five"])
};

var css$2 = "@keyframes SocialSharing_module_fadeIn__d590f3b4 {\n  from {\n    opacity: 0;\n    visibility: hidden;\n  }\n  to {\n    opacity: 1;\n    visibility: visible;\n  }\n}\n@keyframes SocialSharing_module_fadeOut__d590f3b4 {\n  from {\n    opacity: 1;\n    visibility: visible;\n  }\n  to {\n    opacity: 0;\n    visibility: hidden;\n  }\n}\n\n.SocialSharing_module_Item__d590f3b4 {\n  padding: 0 0 14px 0;\n  max-width: 400px;\n}\n.SocialSharing_module_Item__d590f3b4 :hover {\n  cursor: auto;\n}\n.SocialSharing_module_Item__d590f3b4 :hover h4 {\n  text-decoration: none;\n}\n\n.SocialSharing_module_Thumbnail__d590f3b4 {\n  border-radius: 14px;\n}\n\n.SocialSharing_module_Content__d590f3b4 {\n  margin-left: 14px;\n}\n.SocialSharing_module_Content__d590f3b4 span {\n  display: block;\n}\n\n.SocialSharing_module_SocialSharing__d590f3b4 {\n  padding-top: 24px;\n  padding-bottom: 24px;\n  width: 184px;\n  margin: 0 auto;\n}\n\n.SocialSharing_module_LinkCopied__d590f3b4 {\n  position: relative;\n  width: 280px;\n  margin: 0 auto;\n  text-align: center;\n  transition: all 0.4s ease;\n}\n.SocialSharing_module_LinkCopied__d590f3b4 p {\n  margin: 14px 0;\n}\n\n.SocialSharing_module_Show__d590f3b4 {\n  animation: SocialSharing_module_fadeIn__d590f3b4 2s;\n}\n\n.SocialSharing_module_Hide__d590f3b4 {\n  animation: SocialSharing_module_fadeOut__d590f3b4 1s;\n}";
injectCss(css$2);
var modules_d946a03d = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","Item":"SocialSharing_module_Item__d590f3b4","Thumbnail":"SocialSharing_module_Thumbnail__d590f3b4","Content":"SocialSharing_module_Content__d590f3b4","SocialSharing":"SocialSharing_module_SocialSharing__d590f3b4","LinkCopied":"SocialSharing_module_LinkCopied__d590f3b4","Show":"SocialSharing_module_Show__d590f3b4","fadeIn":"SocialSharing_module_fadeIn__d590f3b4","Hide":"SocialSharing_module_Hide__d590f3b4","fadeOut":"SocialSharing_module_fadeOut__d590f3b4"};

function SocialSharing(_ref) {
  var thumbnailSRC = _ref.thumbnailSRC,
    thumbnailALT = _ref.thumbnailALT,
    category = _ref.category,
    categoryColor = _ref.categoryColor,
    title = _ref.title,
    subtitle = _ref.subtitle,
    showConfirmation = _ref.showConfirmation,
    socialButtons = _ref.socialButtons,
    socialControls = _ref.socialControls,
    diamondAward = _ref.diamondAward;
  var _useState = React.useState(showConfirmation),
    _useState2 = _slicedToArray(_useState, 2),
    isShowConfirmation = _useState2[0],
    setConfirmtion = _useState2[1];
  var _useState3 = React.useState(),
    _useState4 = _slicedToArray(_useState3, 2),
    animateHide = _useState4[0],
    setAnimateHide = _useState4[1];
  React.useEffect(function () {
    setConfirmtion(showConfirmation);
  }, [showConfirmation]);
  var closeLinkConfirmation = function closeLinkConfirmation() {
    setAnimateHide(true);
    setTimeout(function () {
      setConfirmtion(false);
    }, 900);
  };
  return /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    content: /*#__PURE__*/React__default["default"].createElement(React__default["default"].Fragment, null, /*#__PURE__*/React__default["default"].createElement(Listing, {
      extraClass: modules_d946a03d.Item,
      categoryColor: categoryColor,
      categoryTitle: category,
      imgURL: thumbnailSRC,
      imgAlt: thumbnailALT,
      title: title,
      subtitle: subtitle,
      diamondAward: diamondAward
    }), /*#__PURE__*/React__default["default"].createElement(ButtonGroup, {
      extraClass: modules_d946a03d.SocialSharing,
      tightSpacing: true
    }, socialButtons ? socialButtons.map(function (item, index) {
      return /*#__PURE__*/React__default["default"].createElement(Button, {
        key: index,
        icon: "ICON",
        iconName: item.socialIconName,
        label: item.label,
        square: true,
        style: "NEU_SECONDARY",
        action: item.action
      });
    }) : socialControls), isShowConfirmation ? /*#__PURE__*/React__default["default"].createElement("div", {
      className: [modules_d946a03d.LinkCopied, isShowConfirmation ? modules_d946a03d.Show : modules_d946a03d.Hide, animateHide ? modules_d946a03d.Hide : modules_d946a03d.Show].join(" ")
    }, /*#__PURE__*/React__default["default"].createElement(Header4, {
      serif: true,
      bold: true,
      fontSize: "M"
    }, "Link copied!"), /*#__PURE__*/React__default["default"].createElement(Paragraph, null, "A link has been copied our clipboard and is ready for sharing."), /*#__PURE__*/React__default["default"].createElement(Button, {
      label: "Done",
      style: "NEU_PRIMARY",
      color: "RED",
      action: closeLinkConfirmation
    })) : null),
    options: {
      offset: [0, 0],
      maxWidth: "540px"
    },
    interactive: true,
    clickTrigger: true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    style: {
      width: "44px"
    }
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    icon: "ICON",
    iconName: "ui-share",
    label: "Share",
    style: "NEU_SECONDARY"
  })));
}
SocialSharing.propTypes = {
  extraClass: propTypes.exports.string,
  thumbnailSRC: propTypes.exports.string,
  thumbnailALT: propTypes.exports.string,
  category: propTypes.exports.string,
  categoryColor: propTypes.exports.string,
  title: propTypes.exports.string,
  subtitle: propTypes.exports.string,
  showConfirmation: propTypes.exports.bool,
  facebookAction: propTypes.exports.func,
  twitterAction: propTypes.exports.func,
  copyAction: propTypes.exports.func,
  socialButtons: propTypes.exports.arrayOf(propTypes.exports.shape({
    socialIconName: propTypes.exports.string,
    label: propTypes.exports.string,
    action: propTypes.exports.func
  })),
  socialControls: propTypes.exports.node,
  diamondAward: propTypes.exports.string
};

var css$1 = ".TripNode_module_TipNodeWrapper__0e4edb0d {\n  box-sizing: content-box;\n  width: 32px;\n}\n\n.TripNode_module_TripNode__0e4edb0d {\n  width: 32px;\n  padding: 0;\n  background: #ffffff;\n  border: 2px solid #444f6b;\n}\n.TripNode_module_TripNode__0e4edb0d span {\n  background: #ffffff;\n  border: none;\n  color: #444f6b;\n  padding: 0 14px;\n  height: 32px;\n}\n.TripNode_module_TripNode__0e4edb0d span span {\n  font-size: 12px;\n  line-height: 22px;\n  border: none;\n  box-shadow: none;\n  background: none;\n  height: auto;\n}\n.TripNode_module_TripNode__0e4edb0d span :hover {\n  background-color: transparent;\n  color: #ffffff;\n}\n.TripNode_module_TripNode__0e4edb0d :hover {\n  background-color: #444f6b;\n}\n.TripNode_module_TripNode__0e4edb0d.TripNode_module_ActiveNode__0e4edb0d {\n  border: none;\n  padding: 2px;\n  box-shadow: inset 3px 3px 6px rgba(0, 0, 85, 0.3333333333);\n  background: #ce0c1c;\n}\n.TripNode_module_TripNode__0e4edb0d.TripNode_module_ActiveNode__0e4edb0d span {\n  background: transparent;\n  color: #fff;\n  border: none;\n}\n.TripNode_module_TripNode__0e4edb0d.TripNode_module_ActiveNode__0e4edb0d span :hover {\n  background-color: transparent;\n  color: #ffffff;\n}\n.TripNode_module_TripNode__0e4edb0d.TripNode_module_ActiveNode__0e4edb0d:hover {\n  box-shadow: none;\n  background: #444f6b;\n  border-color: #444f6b;\n}";
injectCss(css$1);
var modules_060b2617 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","TipNodeWrapper":"TripNode_module_TipNodeWrapper__0e4edb0d","TripNode":"TripNode_module_TripNode__0e4edb0d","ActiveNode":"TripNode_module_ActiveNode__0e4edb0d"};

function TripNode(_ref) {
  var active = _ref.active,
    destinationName = _ref.destinationName,
    toolTipContent = _ref.toolTipContent,
    destinationAction = _ref.destinationAction;
  return /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    content: toolTipContent,
    options: {
      offset: [0, 0],
      maxWidth: "340px"
    },
    focusIn: true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_060b2617.TipNodeWrapper
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: [modules_060b2617.TripNode, active ? modules_060b2617.ActiveNode : ""].join(" "),
    action: destinationAction,
    label: destinationName
  })));
}
TripNode.propTypes = {
  destinationName: propTypes.exports.string,
  destinationAction: propTypes.exports.func,
  active: propTypes.exports.bool,
  toolTipContent: propTypes.exports.node
};

var css = "@import \"https://cdnjs.cloudflare.com/ajax/libs/Swiper/8.3.2/swiper-bundle.min.css\";\n\n.TripControls_module_TripControls__9b23021a {\n  border-radius: 48px;\n  padding: 0;\n  height: 54px;\n  max-width: fit-content;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_SettingsWrapper__9b23021a {\n  height: 48px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_SettingsWrapper__9b23021a .TripControls_module_Settings__9b23021a {\n  padding: 0;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_AddDestinationWrapper__9b23021a {\n  height: 48px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_AddDestinationWrapper__9b23021a .TripControls_module_AddDestination__9b23021a {\n  padding: 0;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_NextDestination__9b23021a {\n  padding: 0;\n  margin-right: -8px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_NextDestination__9b23021a span {\n  height: 46px;\n  width: 34px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_PrevDestination__9b23021a {\n  padding: 0;\n  margin-left: -8px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_PrevDestination__9b23021a span {\n  height: 46px;\n  width: 34px;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_BorderBottom__9b23021a {\n  border-bottom: 1px solid #edeef2;\n}\n.TripControls_module_TripControls__9b23021a .TripControls_module_TripOptions__9b23021a {\n  min-width: 174px;\n}\n\n.tripControls .swiper-wrapper {\n  align-items: center;\n  display: flex;\n}\n.tripControls .swiperContainer {\n  padding: 2px 0px 0px 0px;\n  position: relative;\n  margin: 0 auto;\n  width: 100%;\n  margin-left: 12px;\n  padding-right: 8px;\n}\n.tripControls .tripControlsSwiperNext {\n  height: 44px;\n  width: 44px;\n  top: 0;\n  right: 0;\n  background-image: none;\n}\n.tripControls .tripControlsSwiperNext::after {\n  display: none;\n}\n.tripControls .tripControlsSwiperPrev {\n  height: 44px;\n  width: 44px;\n  top: 0;\n  left: 0;\n  background-image: none;\n}\n.tripControls .tripControlsSwiperPrev::after {\n  display: none;\n}\n.tripControls .tripControlsSwiperNext, .tripControls .tripControlsSwiperPrev {\n  opacity: 1;\n  transition: 0.5s ease-in-out;\n  visibility: visible;\n  width: auto;\n}\n.tripControls .tripControlsSwiperNext.swiper-button-disabled, .tripControls .tripControlsSwiperPrev.swiper-button-disabled {\n  visibility: visible;\n  opacity: 0.3;\n  transition: 0.5s ease-in-out;\n  width: auto;\n}\n.tripControls .swiper-button-lock {\n  visibility: hidden !important;\n  opacity: 0 !important;\n  transition: 0.5s ease-in-out;\n  width: 0 !important;\n}\n.tripControls .tripControlsSwiperPrev:disabled span, .tripControls .tripControlsSwiperNext:disabled span {\n  background: transparent;\n}\n.tripControls .swiperAuto {\n  width: auto;\n}\n@media (max-width: 700px) {\n  .tripControlsSwiperNext {\n    display: block;\n  }\n}\n@media (max-width: 700px) {\n  .tripControlsSwiperPrev {\n    display: block;\n  }\n}";
injectCss(css);
var modules_f785d0c4 = {"uiBreakMax":"strip-units(1920px)","uiBreakDesktop":"strip-units(1366px)","uiBreakMobilePortraitMin":"strip-units(300px)","uiBreakTabletPortraitMin":"strip-units(700px)","uiBreakDesktopMin":"strip-units(1024px)","uiBreakWideScreenMin":"strip-units(1920px)","TripControls":"TripControls_module_TripControls__9b23021a","SettingsWrapper":"TripControls_module_SettingsWrapper__9b23021a","Settings":"TripControls_module_Settings__9b23021a","AddDestinationWrapper":"TripControls_module_AddDestinationWrapper__9b23021a","AddDestination":"TripControls_module_AddDestination__9b23021a","NextDestination":"TripControls_module_NextDestination__9b23021a","PrevDestination":"TripControls_module_PrevDestination__9b23021a","BorderBottom":"TripControls_module_BorderBottom__9b23021a","TripOptions":"TripControls_module_TripOptions__9b23021a"};

function TripControls(_ref) {
  var tripNodes = _ref.tripNodes,
    settingsAction = _ref.settingsAction,
    addDestinationAction = _ref.addDestinationAction,
    createDestinationAction = _ref.createDestinationAction,
    newTripAction = _ref.newTripAction;
  return /*#__PURE__*/React__default["default"].createElement(Container, {
    extraClass: [modules_f785d0c4.TripControls, "tripControls"].join(" "),
    style: "Neumorphic"
  }, /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    content: /*#__PURE__*/React__default["default"].createElement(Span, {
      fontSize: "XS",
      bold: true,
      uppercase: true
    }, "Trip Settings"),
    options: {
      offset: [0, 0],
      maxWidth: "340px"
    },
    focusIn: true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_f785d0c4.SettingsWrapper
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: modules_f785d0c4.Settings,
    icon: "ICON",
    iconName: "ui-settings",
    label: "Trip Settings",
    style: "PLAIN",
    action: settingsAction
  }))), /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: ["tripControlsSwiperPrev", modules_f785d0c4.PrevDestination].join(" "),
    icon: "ICON",
    iconName: "ui-arrow-short--left",
    label: "Previous Destination",
    style: "PLAIN"
  }), /*#__PURE__*/React__default["default"].createElement(Swiper, {
    className: "swiperContainer",
    modules: [Navigation, freeMode],
    navigation: {
      nextEl: ".tripControlsSwiperNext",
      prevEl: ".tripControlsSwiperPrev"
    },
    freeMode: true,
    spaceBetween: 14,
    slidesPerView: "auto"
  }, tripNodes.map(function (item, index) {
    return /*#__PURE__*/React__default["default"].createElement(SwiperSlide, {
      key: index,
      className: "swiperAuto"
    }, /*#__PURE__*/React__default["default"].createElement(TripNode, {
      destinationName: item.destinationName,
      destinationAction: item.destinationAction,
      active: item.active,
      toolTipContent: /*#__PURE__*/React__default["default"].createElement(Span, {
        fontSize: "XS",
        bold: true,
        uppercase: true
      }, item.toolTipContent)
    }));
  })), /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: ["tripControlsSwiperNext", modules_f785d0c4.NextDestination].join(" "),
    icon: "ICON",
    iconName: "ui-arrow-short--right",
    label: "Next Destination",
    style: "PLAIN"
  }), /*#__PURE__*/React__default["default"].createElement(Tooltip, {
    content: /*#__PURE__*/React__default["default"].createElement("div", {
      className: modules_f785d0c4.TripOptions
    }, /*#__PURE__*/React__default["default"].createElement("div", {
      className: modules_f785d0c4.BorderBottom
    }, /*#__PURE__*/React__default["default"].createElement(Button, {
      iconName: "location--add",
      label: "Add Destination",
      style: "PLAIN",
      action: createDestinationAction
    })), /*#__PURE__*/React__default["default"].createElement("div", null, /*#__PURE__*/React__default["default"].createElement(Button, {
      iconName: "luggage",
      label: "New Trip",
      style: "PLAIN",
      action: newTripAction
    }))),
    options: {
      offset: [0, 0],
      maxWidth: "340px"
    },
    interactive: true
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: modules_f785d0c4.AddDestinationWrapper
  }, /*#__PURE__*/React__default["default"].createElement(Button, {
    extraClass: modules_f785d0c4.AddDestination,
    icon: "ICON",
    iconName: "ui-circle--plus",
    label: "Add Destination",
    style: "PLAIN",
    action: addDestinationAction
  }))));
}
TripControls.propTypes = {
  tripNodes: propTypes.exports.arrayOf(propTypes.exports.shape({
    destinationName: propTypes.exports.string,
    destinationAction: propTypes.exports.func,
    active: propTypes.exports.bool,
    toolTipContent: propTypes.exports.string
  })),
  settingsAction: propTypes.exports.func,
  addDestinationAction: propTypes.exports.func,
  createDestinationAction: propTypes.exports.func,
  newTripAction: propTypes.exports.func
};

exports.Accordion = Accordion;
exports.ActionIcon = ActionIcon;
exports.Autocomplete = Autocomplete;
exports.Badge = Badge;
exports.Banner = Banner;
exports.Breadcrumbs = Breadcrumbs;
exports.Button = Button;
exports.ButtonGroup = ButtonGroup;
exports.ButtonLink = ButtonLink;
exports.COLUMN = COLUMN;
exports.Card = Card;
exports.Checkbox = Checkbox;
exports.CircleIcon = CircleIcon;
exports.Container = Container;
exports.ContentSection = ContentSection;
exports.DialIndicator = DialIndicator;
exports.DiamondIndicator = DiamondIndicator;
exports.DiamondRating = DiamondRating;
exports.Fieldset = Fieldset;
exports.Footer = Footer;
exports.FooterLink = FooterLink;
exports.Form = Form;
exports.Gallery = Gallery;
exports.GridColumn = GridColumn;
exports.GridColumnsContainer = GridColumnsContainer;
exports.GridContainer = GridContainer;
exports.Header = Header;
exports.Header1 = Header1;
exports.Header2 = Header2;
exports.Header3 = Header3;
exports.Header4 = Header4;
exports.HeaderCard = HeaderCard;
exports.HeroParallax = HeroParallax;
exports.HighlightBar = HighlightBar;
exports.Icon = Icon;
exports.IconIndicator = IconIndicator;
exports.IconIndicatorGroup = IconIndicatorGroup;
exports.Image = Image;
exports.Input = Input;
exports.IntroCard = IntroCard;
exports.Lightbox = Lightbox$1;
exports.Link = Link;
exports.Listing = Listing;
exports.Loader = Loader$1;
exports.Main = Main;
exports.MainFooter = MainFooter;
exports.MainNavigation = MainNavigation;
exports.MainNavigationItem = MainNavigationItem;
exports.PageWrapper = PageWrapper;
exports.Pagination = Pagination$1;
exports.Paragraph = Paragraph;
exports.Pill = Pill;
exports.Radio = Radio;
exports.Rating = Rating;
exports.RatingStars = RatingStars;
exports.ReadMore = ReadMore;
exports.ReviewListing = ReviewListing;
exports.RichContentWrapper = RichContentWrapper;
exports.Section = Section;
exports.Select = Select;
exports.SelectOption = SelectOption;
exports.SelectOptionGroup = SelectOptionGroup;
exports.SkipToMainContent = SkipToMainContent;
exports.SocialSharing = SocialSharing;
exports.Spacing = Spacing;
exports.Span = Span;
exports.SpottingMap = SpottingMap;
exports.SubMenu = SubMenu;
exports.SwiperWrapper = SwiperWrapper;
exports.Tabs = Tabs;
exports.TextArea = TextArea;
exports.Title = Title;
exports.TitleH1 = TitleH1;
exports.TitleH2 = TitleH2;
exports.TitleH3 = TitleH3;
exports.TitleH4 = TitleH4;
exports.Tooltip = Tooltip;
exports.TripCanvasActiveTrip = TripCanvasActiveTrip;
exports.TripCanvasDefaultSearch = TripCanvasDefaultSearch;
exports.TripCanvasHeader = TripCanvasHeader;
exports.TripControls = TripControls;
exports.TwoColumnSection = TwoColumnSection;
